/*
 @license
 Shaka Player
 Copyright 2016 Google LLC
 SPDX-License-Identifier: Apache-2.0
*/
(function () {
  var innerGlobal = typeof window != 'undefined' ? window : global;
  var exportTo = {};
  (function (window, global, module) {
    /*

 Copyright The Closure Library Authors.
 SPDX-License-Identifier: Apache-2.0
*/
    var $jscomp = $jscomp || {};
    $jscomp.scope = {};
    $jscomp.arrayIteratorImpl = function (a) {
      var b = 0;
      return function () {
        return b < a.length ? { done: !1, value: a[b++] } : { done: !0 };
      };
    };
    $jscomp.arrayIterator = function (a) {
      return { next: $jscomp.arrayIteratorImpl(a) };
    };
    $jscomp.ASSUME_ES5 = !1;
    $jscomp.ASSUME_NO_NATIVE_MAP = !1;
    $jscomp.ASSUME_NO_NATIVE_SET = !1;
    $jscomp.SIMPLE_FROUND_POLYFILL = !1;
    $jscomp.ISOLATE_POLYFILLS = !1;
    $jscomp.FORCE_POLYFILL_PROMISE = !1;
    $jscomp.FORCE_POLYFILL_PROMISE_WHEN_NO_UNHANDLED_REJECTION = !1;
    $jscomp.defineProperty =
      $jscomp.ASSUME_ES5 || 'function' == typeof Object.defineProperties
        ? Object.defineProperty
        : function (a, b, c) {
            if (a == Array.prototype || a == Object.prototype) return a;
            a[b] = c.value;
            return a;
          };
    $jscomp.getGlobal = function (a) {
      a = [
        'object' == typeof globalThis && globalThis,
        a,
        'object' == typeof window && window,
        'object' == typeof self && self,
        'object' == typeof global && global,
      ];
      for (var b = 0; b < a.length; ++b) {
        var c = a[b];
        if (c && c.Math == Math) return c;
      }
      throw Error('Cannot find global object');
    };
    $jscomp.global = $jscomp.getGlobal(this);
    $jscomp.IS_SYMBOL_NATIVE = 'function' === typeof Symbol && 'symbol' === typeof Symbol('x');
    $jscomp.TRUST_ES6_POLYFILLS = !$jscomp.ISOLATE_POLYFILLS || $jscomp.IS_SYMBOL_NATIVE;
    $jscomp.polyfills = {};
    $jscomp.propertyToPolyfillSymbol = {};
    $jscomp.POLYFILL_PREFIX = '$jscp$';
    var $jscomp$lookupPolyfilledValue = function (a, b) {
      var c = $jscomp.propertyToPolyfillSymbol[b];
      if (null == c) return a[b];
      c = a[c];
      return void 0 !== c ? c : a[b];
    };
    $jscomp.polyfill = function (a, b, c, d) {
      b && ($jscomp.ISOLATE_POLYFILLS ? $jscomp.polyfillIsolated(a, b, c, d) : $jscomp.polyfillUnisolated(a, b, c, d));
    };
    $jscomp.polyfillUnisolated = function (a, b, c, d) {
      c = $jscomp.global;
      a = a.split('.');
      for (d = 0; d < a.length - 1; d++) {
        var e = a[d];
        if (!(e in c)) return;
        c = c[e];
      }
      a = a[a.length - 1];
      d = c[a];
      b = b(d);
      b != d && null != b && $jscomp.defineProperty(c, a, { configurable: !0, writable: !0, value: b });
    };
    $jscomp.polyfillIsolated = function (a, b, c, d) {
      var e = a.split('.');
      a = 1 === e.length;
      d = e[0];
      d = !a && d in $jscomp.polyfills ? $jscomp.polyfills : $jscomp.global;
      for (var f = 0; f < e.length - 1; f++) {
        var g = e[f];
        if (!(g in d)) return;
        d = d[g];
      }
      e = e[e.length - 1];
      c = $jscomp.IS_SYMBOL_NATIVE && 'es6' === c ? d[e] : null;
      b = b(c);
      null != b &&
        (a
          ? $jscomp.defineProperty($jscomp.polyfills, e, { configurable: !0, writable: !0, value: b })
          : b !== c &&
            (($jscomp.propertyToPolyfillSymbol[e] = $jscomp.IS_SYMBOL_NATIVE
              ? $jscomp.global.Symbol(e)
              : $jscomp.POLYFILL_PREFIX + e),
            (e = $jscomp.propertyToPolyfillSymbol[e]),
            $jscomp.defineProperty(d, e, { configurable: !0, writable: !0, value: b })));
    };
    $jscomp.initSymbol = function () {};
    $jscomp.polyfill(
      'Symbol',
      function (a) {
        if (a) return a;
        var b = function (e, f) {
          this.$jscomp$symbol$id_ = e;
          $jscomp.defineProperty(this, 'description', { configurable: !0, writable: !0, value: f });
        };
        b.prototype.toString = function () {
          return this.$jscomp$symbol$id_;
        };
        var c = 0,
          d = function (e) {
            if (this instanceof d) throw new TypeError('Symbol is not a constructor');
            return new b('jscomp_symbol_' + (e || '') + '_' + c++, e);
          };
        return d;
      },
      'es6',
      'es3',
    );
    $jscomp.initSymbolIterator = function () {};
    $jscomp.polyfill(
      'Symbol.iterator',
      function (a) {
        if (a) return a;
        a = Symbol('Symbol.iterator');
        for (
          var b = 'Array Int8Array Uint8Array Uint8ClampedArray Int16Array Uint16Array Int32Array Uint32Array Float32Array Float64Array'.split(
              ' ',
            ),
            c = 0;
          c < b.length;
          c++
        ) {
          var d = $jscomp.global[b[c]];
          'function' === typeof d &&
            'function' != typeof d.prototype[a] &&
            $jscomp.defineProperty(d.prototype, a, {
              configurable: !0,
              writable: !0,
              value: function () {
                return $jscomp.iteratorPrototype($jscomp.arrayIteratorImpl(this));
              },
            });
        }
        return a;
      },
      'es6',
      'es3',
    );
    $jscomp.initSymbolAsyncIterator = function () {};
    $jscomp.iteratorPrototype = function (a) {
      a = { next: a };
      a[Symbol.iterator] = function () {
        return this;
      };
      return a;
    };
    $jscomp.createTemplateTagFirstArg = function (a) {
      return (a.raw = a);
    };
    $jscomp.createTemplateTagFirstArgWithRaw = function (a, b) {
      a.raw = b;
      return a;
    };
    $jscomp.makeIterator = function (a) {
      var b = 'undefined' != typeof Symbol && Symbol.iterator && a[Symbol.iterator];
      return b ? b.call(a) : $jscomp.arrayIterator(a);
    };
    $jscomp.arrayFromIterator = function (a) {
      for (var b, c = []; !(b = a.next()).done; ) c.push(b.value);
      return c;
    };
    $jscomp.arrayFromIterable = function (a) {
      return a instanceof Array ? a : $jscomp.arrayFromIterator($jscomp.makeIterator(a));
    };
    $jscomp.objectCreate =
      $jscomp.ASSUME_ES5 || 'function' == typeof Object.create
        ? Object.create
        : function (a) {
            var b = function () {};
            b.prototype = a;
            return new b();
          };
    $jscomp.getConstructImplementation = function () {
      function a() {
        function c() {}
        new c();
        Reflect.construct(c, [], function () {});
        return new c() instanceof c;
      }
      if ($jscomp.TRUST_ES6_POLYFILLS && 'undefined' != typeof Reflect && Reflect.construct) {
        if (a()) return Reflect.construct;
        var b = Reflect.construct;
        return function (c, d, e) {
          c = b(c, d);
          e && Reflect.setPrototypeOf(c, e.prototype);
          return c;
        };
      }
      return function (c, d, e) {
        void 0 === e && (e = c);
        e = $jscomp.objectCreate(e.prototype || Object.prototype);
        return Function.prototype.apply.call(c, e, d) || e;
      };
    };
    $jscomp.construct = { valueOf: $jscomp.getConstructImplementation }.valueOf();
    $jscomp.underscoreProtoCanBeSet = function () {
      var a = { a: !0 },
        b = {};
      try {
        return (b.__proto__ = a), b.a;
      } catch (c) {}
      return !1;
    };
    $jscomp.setPrototypeOf =
      $jscomp.TRUST_ES6_POLYFILLS && 'function' == typeof Object.setPrototypeOf
        ? Object.setPrototypeOf
        : $jscomp.underscoreProtoCanBeSet()
        ? function (a, b) {
            a.__proto__ = b;
            if (a.__proto__ !== b) throw new TypeError(a + ' is not extensible');
            return a;
          }
        : null;
    $jscomp.inherits = function (a, b) {
      a.prototype = $jscomp.objectCreate(b.prototype);
      a.prototype.constructor = a;
      if ($jscomp.setPrototypeOf) {
        var c = $jscomp.setPrototypeOf;
        c(a, b);
      } else
        for (c in b)
          if ('prototype' != c)
            if (Object.defineProperties) {
              var d = Object.getOwnPropertyDescriptor(b, c);
              d && Object.defineProperty(a, c, d);
            } else a[c] = b[c];
      a.superClass_ = b.prototype;
    };
    $jscomp.generator = {};
    $jscomp.generator.ensureIteratorResultIsObject_ = function (a) {
      if (!(a instanceof Object)) throw new TypeError('Iterator result ' + a + ' is not an object');
    };
    $jscomp.generator.Context = function () {
      this.isRunning_ = !1;
      this.yieldAllIterator_ = null;
      this.yieldResult = void 0;
      this.nextAddress = 1;
      this.finallyAddress_ = this.catchAddress_ = 0;
      this.finallyContexts_ = this.abruptCompletion_ = null;
    };
    $jscomp.generator.Context.prototype.start_ = function () {
      if (this.isRunning_) throw new TypeError('Generator is already running');
      this.isRunning_ = !0;
    };
    $jscomp.generator.Context.prototype.stop_ = function () {
      this.isRunning_ = !1;
    };
    $jscomp.generator.Context.prototype.jumpToErrorHandler_ = function () {
      this.nextAddress = this.catchAddress_ || this.finallyAddress_;
    };
    $jscomp.generator.Context.prototype.next_ = function (a) {
      this.yieldResult = a;
    };
    $jscomp.generator.Context.prototype.throw_ = function (a) {
      this.abruptCompletion_ = { exception: a, isException: !0 };
      this.jumpToErrorHandler_();
    };
    $jscomp.generator.Context.prototype['return'] = function (a) {
      this.abruptCompletion_ = { return: a };
      this.nextAddress = this.finallyAddress_;
    };
    $jscomp.generator.Context.prototype.jumpThroughFinallyBlocks = function (a) {
      this.abruptCompletion_ = { jumpTo: a };
      this.nextAddress = this.finallyAddress_;
    };
    $jscomp.generator.Context.prototype.yield = function (a, b) {
      this.nextAddress = b;
      return { value: a };
    };
    $jscomp.generator.Context.prototype.yieldAll = function (a, b) {
      var c = $jscomp.makeIterator(a),
        d = c.next();
      $jscomp.generator.ensureIteratorResultIsObject_(d);
      if (d.done) (this.yieldResult = d.value), (this.nextAddress = b);
      else return (this.yieldAllIterator_ = c), this.yield(d.value, b);
    };
    $jscomp.generator.Context.prototype.jumpTo = function (a) {
      this.nextAddress = a;
    };
    $jscomp.generator.Context.prototype.jumpToEnd = function () {
      this.nextAddress = 0;
    };
    $jscomp.generator.Context.prototype.setCatchFinallyBlocks = function (a, b) {
      this.catchAddress_ = a;
      void 0 != b && (this.finallyAddress_ = b);
    };
    $jscomp.generator.Context.prototype.setFinallyBlock = function (a) {
      this.catchAddress_ = 0;
      this.finallyAddress_ = a || 0;
    };
    $jscomp.generator.Context.prototype.leaveTryBlock = function (a, b) {
      this.nextAddress = a;
      this.catchAddress_ = b || 0;
    };
    $jscomp.generator.Context.prototype.enterCatchBlock = function (a) {
      this.catchAddress_ = a || 0;
      a = this.abruptCompletion_.exception;
      this.abruptCompletion_ = null;
      return a;
    };
    $jscomp.generator.Context.prototype.enterFinallyBlock = function (a, b, c) {
      c ? (this.finallyContexts_[c] = this.abruptCompletion_) : (this.finallyContexts_ = [this.abruptCompletion_]);
      this.catchAddress_ = a || 0;
      this.finallyAddress_ = b || 0;
    };
    $jscomp.generator.Context.prototype.leaveFinallyBlock = function (a, b) {
      var c = this.finallyContexts_.splice(b || 0)[0];
      if ((c = this.abruptCompletion_ = this.abruptCompletion_ || c)) {
        if (c.isException) return this.jumpToErrorHandler_();
        void 0 != c.jumpTo && this.finallyAddress_ < c.jumpTo
          ? ((this.nextAddress = c.jumpTo), (this.abruptCompletion_ = null))
          : (this.nextAddress = this.finallyAddress_);
      } else this.nextAddress = a;
    };
    $jscomp.generator.Context.prototype.forIn = function (a) {
      return new $jscomp.generator.Context.PropertyIterator(a);
    };
    $jscomp.generator.Context.PropertyIterator = function (a) {
      this.object_ = a;
      this.properties_ = [];
      for (var b in a) this.properties_.push(b);
      this.properties_.reverse();
    };
    $jscomp.generator.Context.PropertyIterator.prototype.getNext = function () {
      for (; 0 < this.properties_.length; ) {
        var a = this.properties_.pop();
        if (a in this.object_) return a;
      }
      return null;
    };
    $jscomp.generator.Engine_ = function (a) {
      this.context_ = new $jscomp.generator.Context();
      this.program_ = a;
    };
    $jscomp.generator.Engine_.prototype.next_ = function (a) {
      this.context_.start_();
      if (this.context_.yieldAllIterator_)
        return this.yieldAllStep_(this.context_.yieldAllIterator_.next, a, this.context_.next_);
      this.context_.next_(a);
      return this.nextStep_();
    };
    $jscomp.generator.Engine_.prototype.return_ = function (a) {
      this.context_.start_();
      var b = this.context_.yieldAllIterator_;
      if (b)
        return this.yieldAllStep_(
          'return' in b
            ? b['return']
            : function (c) {
                return { value: c, done: !0 };
              },
          a,
          this.context_['return'],
        );
      this.context_['return'](a);
      return this.nextStep_();
    };
    $jscomp.generator.Engine_.prototype.throw_ = function (a) {
      this.context_.start_();
      if (this.context_.yieldAllIterator_)
        return this.yieldAllStep_(this.context_.yieldAllIterator_['throw'], a, this.context_.next_);
      this.context_.throw_(a);
      return this.nextStep_();
    };
    $jscomp.generator.Engine_.prototype.yieldAllStep_ = function (a, b, c) {
      try {
        var d = a.call(this.context_.yieldAllIterator_, b);
        $jscomp.generator.ensureIteratorResultIsObject_(d);
        if (!d.done) return this.context_.stop_(), d;
        var e = d.value;
      } catch (f) {
        return (this.context_.yieldAllIterator_ = null), this.context_.throw_(f), this.nextStep_();
      }
      this.context_.yieldAllIterator_ = null;
      c.call(this.context_, e);
      return this.nextStep_();
    };
    $jscomp.generator.Engine_.prototype.nextStep_ = function () {
      for (; this.context_.nextAddress; )
        try {
          var a = this.program_(this.context_);
          if (a) return this.context_.stop_(), { value: a.value, done: !1 };
        } catch (b) {
          (this.context_.yieldResult = void 0), this.context_.throw_(b);
        }
      this.context_.stop_();
      if (this.context_.abruptCompletion_) {
        a = this.context_.abruptCompletion_;
        this.context_.abruptCompletion_ = null;
        if (a.isException) throw a.exception;
        return { value: a['return'], done: !0 };
      }
      return { value: void 0, done: !0 };
    };
    $jscomp.generator.Generator_ = function (a) {
      this.next = function (b) {
        return a.next_(b);
      };
      this['throw'] = function (b) {
        return a.throw_(b);
      };
      this['return'] = function (b) {
        return a.return_(b);
      };
      this[Symbol.iterator] = function () {
        return this;
      };
    };
    $jscomp.generator.createGenerator = function (a, b) {
      var c = new $jscomp.generator.Generator_(new $jscomp.generator.Engine_(b));
      $jscomp.setPrototypeOf && a.prototype && $jscomp.setPrototypeOf(c, a.prototype);
      return c;
    };
    $jscomp.asyncExecutePromiseGenerator = function (a) {
      function b(d) {
        return a.next(d);
      }
      function c(d) {
        return a['throw'](d);
      }
      return new Promise(function (d, e) {
        function f(g) {
          g.done ? d(g.value) : Promise.resolve(g.value).then(b, c).then(f, e);
        }
        f(a.next());
      });
    };
    $jscomp.asyncExecutePromiseGeneratorFunction = function (a) {
      return $jscomp.asyncExecutePromiseGenerator(a());
    };
    $jscomp.asyncExecutePromiseGeneratorProgram = function (a) {
      return $jscomp.asyncExecutePromiseGenerator(new $jscomp.generator.Generator_(new $jscomp.generator.Engine_(a)));
    };
    $jscomp.polyfill(
      'Reflect',
      function (a) {
        return a ? a : {};
      },
      'es6',
      'es3',
    );
    $jscomp.polyfill(
      'Reflect.construct',
      function (a) {
        return $jscomp.construct;
      },
      'es6',
      'es3',
    );
    $jscomp.polyfill(
      'Reflect.setPrototypeOf',
      function (a) {
        if (a) return a;
        if ($jscomp.setPrototypeOf) {
          var b = $jscomp.setPrototypeOf;
          return function (c, d) {
            try {
              return b(c, d), !0;
            } catch (e) {
              return !1;
            }
          };
        }
        return null;
      },
      'es6',
      'es5',
    );
    $jscomp.polyfill(
      'Promise',
      function (a) {
        function b() {
          this.batch_ = null;
        }
        function c(g) {
          return g instanceof e
            ? g
            : new e(function (h, k) {
                h(g);
              });
        }
        if (
          a &&
          !(
            $jscomp.FORCE_POLYFILL_PROMISE ||
            ($jscomp.FORCE_POLYFILL_PROMISE_WHEN_NO_UNHANDLED_REJECTION &&
              'undefined' === typeof $jscomp.global.PromiseRejectionEvent)
          )
        )
          return a;
        b.prototype.asyncExecute = function (g) {
          if (null == this.batch_) {
            this.batch_ = [];
            var h = this;
            this.asyncExecuteFunction(function () {
              h.executeBatch_();
            });
          }
          this.batch_.push(g);
        };
        var d = $jscomp.global.setTimeout;
        b.prototype.asyncExecuteFunction = function (g) {
          d(g, 0);
        };
        b.prototype.executeBatch_ = function () {
          for (; this.batch_ && this.batch_.length; ) {
            var g = this.batch_;
            this.batch_ = [];
            for (var h = 0; h < g.length; ++h) {
              var k = g[h];
              g[h] = null;
              try {
                k();
              } catch (l) {
                this.asyncThrow_(l);
              }
            }
          }
          this.batch_ = null;
        };
        b.prototype.asyncThrow_ = function (g) {
          this.asyncExecuteFunction(function () {
            throw g;
          });
        };
        var e = function (g) {
          this.state_ = 0;
          this.result_ = void 0;
          this.onSettledCallbacks_ = [];
          this.isRejectionHandled_ = !1;
          var h = this.createResolveAndReject_();
          try {
            g(h.resolve, h.reject);
          } catch (k) {
            h.reject(k);
          }
        };
        e.prototype.createResolveAndReject_ = function () {
          function g(l) {
            return function (m) {
              k || ((k = !0), l.call(h, m));
            };
          }
          var h = this,
            k = !1;
          return { resolve: g(this.resolveTo_), reject: g(this.reject_) };
        };
        e.prototype.resolveTo_ = function (g) {
          if (g === this) this.reject_(new TypeError('A Promise cannot resolve to itself'));
          else if (g instanceof e) this.settleSameAsPromise_(g);
          else {
            a: switch (typeof g) {
              case 'object':
                var h = null != g;
                break a;
              case 'function':
                h = !0;
                break a;
              default:
                h = !1;
            }
            h ? this.resolveToNonPromiseObj_(g) : this.fulfill_(g);
          }
        };
        e.prototype.resolveToNonPromiseObj_ = function (g) {
          var h = void 0;
          try {
            h = g.then;
          } catch (k) {
            this.reject_(k);
            return;
          }
          'function' == typeof h ? this.settleSameAsThenable_(h, g) : this.fulfill_(g);
        };
        e.prototype.reject_ = function (g) {
          this.settle_(2, g);
        };
        e.prototype.fulfill_ = function (g) {
          this.settle_(1, g);
        };
        e.prototype.settle_ = function (g, h) {
          if (0 != this.state_)
            throw Error('Cannot settle(' + g + ', ' + h + '): Promise already settled in state' + this.state_);
          this.state_ = g;
          this.result_ = h;
          2 === this.state_ && this.scheduleUnhandledRejectionCheck_();
          this.executeOnSettledCallbacks_();
        };
        e.prototype.scheduleUnhandledRejectionCheck_ = function () {
          var g = this;
          d(function () {
            if (g.notifyUnhandledRejection_()) {
              var h = $jscomp.global.console;
              'undefined' !== typeof h && h.error(g.result_);
            }
          }, 1);
        };
        e.prototype.notifyUnhandledRejection_ = function () {
          if (this.isRejectionHandled_) return !1;
          var g = $jscomp.global.CustomEvent,
            h = $jscomp.global.Event,
            k = $jscomp.global.dispatchEvent;
          if ('undefined' === typeof k) return !0;
          'function' === typeof g
            ? (g = new g('unhandledrejection', { cancelable: !0 }))
            : 'function' === typeof h
            ? (g = new h('unhandledrejection', { cancelable: !0 }))
            : ((g = $jscomp.global.document.createEvent('CustomEvent')),
              g.initCustomEvent('unhandledrejection', !1, !0, g));
          g.promise = this;
          g.reason = this.result_;
          return k(g);
        };
        e.prototype.executeOnSettledCallbacks_ = function () {
          if (null != this.onSettledCallbacks_) {
            for (var g = 0; g < this.onSettledCallbacks_.length; ++g) f.asyncExecute(this.onSettledCallbacks_[g]);
            this.onSettledCallbacks_ = null;
          }
        };
        var f = new b();
        e.prototype.settleSameAsPromise_ = function (g) {
          var h = this.createResolveAndReject_();
          g.callWhenSettled_(h.resolve, h.reject);
        };
        e.prototype.settleSameAsThenable_ = function (g, h) {
          var k = this.createResolveAndReject_();
          try {
            g.call(h, k.resolve, k.reject);
          } catch (l) {
            k.reject(l);
          }
        };
        e.prototype.then = function (g, h) {
          function k(p, q) {
            return 'function' == typeof p
              ? function (r) {
                  try {
                    l(p(r));
                  } catch (t) {
                    m(t);
                  }
                }
              : q;
          }
          var l,
            m,
            n = new e(function (p, q) {
              l = p;
              m = q;
            });
          this.callWhenSettled_(k(g, l), k(h, m));
          return n;
        };
        e.prototype['catch'] = function (g) {
          return this.then(void 0, g);
        };
        e.prototype.callWhenSettled_ = function (g, h) {
          function k() {
            switch (l.state_) {
              case 1:
                g(l.result_);
                break;
              case 2:
                h(l.result_);
                break;
              default:
                throw Error('Unexpected state: ' + l.state_);
            }
          }
          var l = this;
          null == this.onSettledCallbacks_ ? f.asyncExecute(k) : this.onSettledCallbacks_.push(k);
          this.isRejectionHandled_ = !0;
        };
        e.resolve = c;
        e.reject = function (g) {
          return new e(function (h, k) {
            k(g);
          });
        };
        e.race = function (g) {
          return new e(function (h, k) {
            for (var l = $jscomp.makeIterator(g), m = l.next(); !m.done; m = l.next())
              c(m.value).callWhenSettled_(h, k);
          });
        };
        e.all = function (g) {
          var h = $jscomp.makeIterator(g),
            k = h.next();
          return k.done
            ? c([])
            : new e(function (l, m) {
                function n(r) {
                  return function (t) {
                    p[r] = t;
                    q--;
                    0 == q && l(p);
                  };
                }
                var p = [],
                  q = 0;
                do p.push(void 0), q++, c(k.value).callWhenSettled_(n(p.length - 1), m), (k = h.next());
                while (!k.done);
              });
        };
        return e;
      },
      'es6',
      'es3',
    );
    $jscomp.checkEs6ConformanceViaProxy = function () {
      try {
        var a = {},
          b = Object.create(
            new $jscomp.global.Proxy(a, {
              get: function (c, d, e) {
                return c == a && 'q' == d && e == b;
              },
            }),
          );
        return !0 === b.q;
      } catch (c) {
        return !1;
      }
    };
    $jscomp.USE_PROXY_FOR_ES6_CONFORMANCE_CHECKS = !1;
    $jscomp.ES6_CONFORMANCE = $jscomp.USE_PROXY_FOR_ES6_CONFORMANCE_CHECKS && $jscomp.checkEs6ConformanceViaProxy();
    $jscomp.owns = function (a, b) {
      return Object.prototype.hasOwnProperty.call(a, b);
    };
    $jscomp.polyfill(
      'WeakMap',
      function (a) {
        function b() {
          if (!a || !Object.seal) return !1;
          try {
            var l = Object.seal({}),
              m = Object.seal({}),
              n = new a([
                [l, 2],
                [m, 3],
              ]);
            if (2 != n.get(l) || 3 != n.get(m)) return !1;
            n['delete'](l);
            n.set(m, 4);
            return !n.has(l) && 4 == n.get(m);
          } catch (p) {
            return !1;
          }
        }
        function c() {}
        function d(l) {
          var m = typeof l;
          return ('object' === m && null !== l) || 'function' === m;
        }
        function e(l) {
          if (!$jscomp.owns(l, g)) {
            var m = new c();
            $jscomp.defineProperty(l, g, { value: m });
          }
        }
        function f(l) {
          if (!$jscomp.ISOLATE_POLYFILLS) {
            var m = Object[l];
            m &&
              (Object[l] = function (n) {
                if (n instanceof c) return n;
                Object.isExtensible(n) && e(n);
                return m(n);
              });
          }
        }
        if ($jscomp.USE_PROXY_FOR_ES6_CONFORMANCE_CHECKS) {
          if (a && $jscomp.ES6_CONFORMANCE) return a;
        } else if (b()) return a;
        var g = '$jscomp_hidden_' + Math.random();
        f('freeze');
        f('preventExtensions');
        f('seal');
        var h = 0,
          k = function (l) {
            this.id_ = (h += Math.random() + 1).toString();
            if (l) {
              l = $jscomp.makeIterator(l);
              for (var m; !(m = l.next()).done; ) (m = m.value), this.set(m[0], m[1]);
            }
          };
        k.prototype.set = function (l, m) {
          if (!d(l)) throw Error('Invalid WeakMap key');
          e(l);
          if (!$jscomp.owns(l, g)) throw Error('WeakMap key fail: ' + l);
          l[g][this.id_] = m;
          return this;
        };
        k.prototype.get = function (l) {
          return d(l) && $jscomp.owns(l, g) ? l[g][this.id_] : void 0;
        };
        k.prototype.has = function (l) {
          return d(l) && $jscomp.owns(l, g) && $jscomp.owns(l[g], this.id_);
        };
        k.prototype['delete'] = function (l) {
          return d(l) && $jscomp.owns(l, g) && $jscomp.owns(l[g], this.id_) ? delete l[g][this.id_] : !1;
        };
        return k;
      },
      'es6',
      'es3',
    );
    $jscomp.MapEntry = function () {};
    $jscomp.polyfill(
      'Map',
      function (a) {
        function b() {
          if (
            $jscomp.ASSUME_NO_NATIVE_MAP ||
            !a ||
            'function' != typeof a ||
            !a.prototype.entries ||
            'function' != typeof Object.seal
          )
            return !1;
          try {
            var k = Object.seal({ x: 4 }),
              l = new a($jscomp.makeIterator([[k, 's']]));
            if ('s' != l.get(k) || 1 != l.size || l.get({ x: 4 }) || l.set({ x: 4 }, 't') != l || 2 != l.size)
              return !1;
            var m = l.entries(),
              n = m.next();
            if (n.done || n.value[0] != k || 's' != n.value[1]) return !1;
            n = m.next();
            return n.done || 4 != n.value[0].x || 't' != n.value[1] || !m.next().done ? !1 : !0;
          } catch (p) {
            return !1;
          }
        }
        if ($jscomp.USE_PROXY_FOR_ES6_CONFORMANCE_CHECKS) {
          if (a && $jscomp.ES6_CONFORMANCE) return a;
        } else if (b()) return a;
        var c = new WeakMap(),
          d = function (k) {
            this.data_ = {};
            this.head_ = g();
            this.size = 0;
            if (k) {
              k = $jscomp.makeIterator(k);
              for (var l; !(l = k.next()).done; ) (l = l.value), this.set(l[0], l[1]);
            }
          };
        d.prototype.set = function (k, l) {
          k = 0 === k ? 0 : k;
          var m = e(this, k);
          m.list || (m.list = this.data_[m.id] = []);
          m.entry
            ? (m.entry.value = l)
            : ((m.entry = { next: this.head_, previous: this.head_.previous, head: this.head_, key: k, value: l }),
              m.list.push(m.entry),
              (this.head_.previous.next = m.entry),
              (this.head_.previous = m.entry),
              this.size++);
          return this;
        };
        d.prototype['delete'] = function (k) {
          k = e(this, k);
          return k.entry && k.list
            ? (k.list.splice(k.index, 1),
              k.list.length || delete this.data_[k.id],
              (k.entry.previous.next = k.entry.next),
              (k.entry.next.previous = k.entry.previous),
              (k.entry.head = null),
              this.size--,
              !0)
            : !1;
        };
        d.prototype.clear = function () {
          this.data_ = {};
          this.head_ = this.head_.previous = g();
          this.size = 0;
        };
        d.prototype.has = function (k) {
          return !!e(this, k).entry;
        };
        d.prototype.get = function (k) {
          return (k = e(this, k).entry) && k.value;
        };
        d.prototype.entries = function () {
          return f(this, function (k) {
            return [k.key, k.value];
          });
        };
        d.prototype.keys = function () {
          return f(this, function (k) {
            return k.key;
          });
        };
        d.prototype.values = function () {
          return f(this, function (k) {
            return k.value;
          });
        };
        d.prototype.forEach = function (k, l) {
          for (var m = this.entries(), n; !(n = m.next()).done; ) (n = n.value), k.call(l, n[1], n[0], this);
        };
        d.prototype[Symbol.iterator] = d.prototype.entries;
        var e = function (k, l) {
            var m = l && typeof l;
            'object' == m || 'function' == m
              ? c.has(l)
                ? (m = c.get(l))
                : ((m = '' + ++h), c.set(l, m))
              : (m = 'p_' + l);
            var n = k.data_[m];
            if (n && $jscomp.owns(k.data_, m))
              for (var p = 0; p < n.length; p++) {
                var q = n[p];
                if ((l !== l && q.key !== q.key) || l === q.key) return { id: m, list: n, index: p, entry: q };
              }
            return { id: m, list: n, index: -1, entry: void 0 };
          },
          f = function (k, l) {
            var m = k.head_;
            return $jscomp.iteratorPrototype(function () {
              if (m) {
                for (; m.head != k.head_; ) m = m.previous;
                for (; m.next != m.head; ) return (m = m.next), { done: !1, value: l(m) };
                m = null;
              }
              return { done: !0, value: void 0 };
            });
          },
          g = function () {
            var k = {};
            return (k.previous = k.next = k.head = k);
          },
          h = 0;
        return d;
      },
      'es6',
      'es3',
    );
    $jscomp.polyfill(
      'Set',
      function (a) {
        function b() {
          if (
            $jscomp.ASSUME_NO_NATIVE_SET ||
            !a ||
            'function' != typeof a ||
            !a.prototype.entries ||
            'function' != typeof Object.seal
          )
            return !1;
          try {
            var d = Object.seal({ x: 4 }),
              e = new a($jscomp.makeIterator([d]));
            if (!e.has(d) || 1 != e.size || e.add(d) != e || 1 != e.size || e.add({ x: 4 }) != e || 2 != e.size)
              return !1;
            var f = e.entries(),
              g = f.next();
            if (g.done || g.value[0] != d || g.value[1] != d) return !1;
            g = f.next();
            return g.done || g.value[0] == d || 4 != g.value[0].x || g.value[1] != g.value[0] ? !1 : f.next().done;
          } catch (h) {
            return !1;
          }
        }
        if ($jscomp.USE_PROXY_FOR_ES6_CONFORMANCE_CHECKS) {
          if (a && $jscomp.ES6_CONFORMANCE) return a;
        } else if (b()) return a;
        var c = function (d) {
          this.map_ = new Map();
          if (d) {
            d = $jscomp.makeIterator(d);
            for (var e; !(e = d.next()).done; ) this.add(e.value);
          }
          this.size = this.map_.size;
        };
        c.prototype.add = function (d) {
          d = 0 === d ? 0 : d;
          this.map_.set(d, d);
          this.size = this.map_.size;
          return this;
        };
        c.prototype['delete'] = function (d) {
          d = this.map_['delete'](d);
          this.size = this.map_.size;
          return d;
        };
        c.prototype.clear = function () {
          this.map_.clear();
          this.size = 0;
        };
        c.prototype.has = function (d) {
          return this.map_.has(d);
        };
        c.prototype.entries = function () {
          return this.map_.entries();
        };
        c.prototype.values = function () {
          return this.map_.values();
        };
        c.prototype.keys = c.prototype.values;
        c.prototype[Symbol.iterator] = c.prototype.values;
        c.prototype.forEach = function (d, e) {
          var f = this;
          this.map_.forEach(function (g) {
            return d.call(e, g, g, f);
          });
        };
        return c;
      },
      'es6',
      'es3',
    );
    $jscomp.iteratorFromArray = function (a, b) {
      a instanceof String && (a += '');
      var c = 0,
        d = !1,
        e = {
          next: function () {
            if (!d && c < a.length) {
              var f = c++;
              return { value: b(f, a[f]), done: !1 };
            }
            d = !0;
            return { done: !0, value: void 0 };
          },
        };
      e[Symbol.iterator] = function () {
        return e;
      };
      return e;
    };
    $jscomp.polyfill(
      'Array.prototype.keys',
      function (a) {
        return a
          ? a
          : function () {
              return $jscomp.iteratorFromArray(this, function (b) {
                return b;
              });
            };
      },
      'es6',
      'es3',
    );
    $jscomp.polyfill(
      'Array.from',
      function (a) {
        return a
          ? a
          : function (b, c, d) {
              c =
                null != c
                  ? c
                  : function (h) {
                      return h;
                    };
              var e = [],
                f = 'undefined' != typeof Symbol && Symbol.iterator && b[Symbol.iterator];
              if ('function' == typeof f) {
                b = f.call(b);
                for (var g = 0; !(f = b.next()).done; ) e.push(c.call(d, f.value, g++));
              } else for (f = b.length, g = 0; g < f; g++) e.push(c.call(d, b[g], g));
              return e;
            };
      },
      'es6',
      'es3',
    );
    $jscomp.findInternal = function (a, b, c) {
      a instanceof String && (a = String(a));
      for (var d = a.length, e = 0; e < d; e++) {
        var f = a[e];
        if (b.call(c, f, e, a)) return { i: e, v: f };
      }
      return { i: -1, v: void 0 };
    };
    $jscomp.polyfill(
      'Array.prototype.findIndex',
      function (a) {
        return a
          ? a
          : function (b, c) {
              return $jscomp.findInternal(this, b, c).i;
            };
      },
      'es6',
      'es3',
    );
    $jscomp.polyfill(
      'Promise.prototype.finally',
      function (a) {
        return a
          ? a
          : function (b) {
              return this.then(
                function (c) {
                  return Promise.resolve(b()).then(function () {
                    return c;
                  });
                },
                function (c) {
                  return Promise.resolve(b()).then(function () {
                    throw c;
                  });
                },
              );
            };
      },
      'es9',
      'es3',
    );
    $jscomp.polyfill(
      'Object.is',
      function (a) {
        return a
          ? a
          : function (b, c) {
              return b === c ? 0 !== b || 1 / b === 1 / c : b !== b && c !== c;
            };
      },
      'es6',
      'es3',
    );
    $jscomp.polyfill(
      'Array.prototype.includes',
      function (a) {
        return a
          ? a
          : function (b, c) {
              var d = this;
              d instanceof String && (d = String(d));
              var e = d.length,
                f = c || 0;
              for (0 > f && (f = Math.max(f + e, 0)); f < e; f++) {
                var g = d[f];
                if (g === b || Object.is(g, b)) return !0;
              }
              return !1;
            };
      },
      'es7',
      'es3',
    );
    $jscomp.checkStringArgs = function (a, b, c) {
      if (null == a)
        throw new TypeError("The 'this' value for String.prototype." + c + ' must not be null or undefined');
      if (b instanceof RegExp)
        throw new TypeError('First argument to String.prototype.' + c + ' must not be a regular expression');
      return a + '';
    };
    $jscomp.polyfill(
      'String.prototype.includes',
      function (a) {
        return a
          ? a
          : function (b, c) {
              return -1 !== $jscomp.checkStringArgs(this, b, 'includes').indexOf(b, c || 0);
            };
      },
      'es6',
      'es3',
    );
    $jscomp.polyfill(
      'Array.prototype.values',
      function (a) {
        return a
          ? a
          : function () {
              return $jscomp.iteratorFromArray(this, function (b, c) {
                return c;
              });
            };
      },
      'es8',
      'es3',
    );
    $jscomp.polyfill(
      'Array.prototype.find',
      function (a) {
        return a
          ? a
          : function (b, c) {
              return $jscomp.findInternal(this, b, c).v;
            };
      },
      'es6',
      'es3',
    );
    $jscomp.polyfill(
      'Math.log2',
      function (a) {
        return a
          ? a
          : function (b) {
              return Math.log(b) / Math.LN2;
            };
      },
      'es6',
      'es3',
    );
    $jscomp.assign =
      $jscomp.TRUST_ES6_POLYFILLS && 'function' == typeof Object.assign
        ? Object.assign
        : function (a, b) {
            for (var c = 1; c < arguments.length; c++) {
              var d = arguments[c];
              if (d) for (var e in d) $jscomp.owns(d, e) && (a[e] = d[e]);
            }
            return a;
          };
    $jscomp.polyfill(
      'Object.assign',
      function (a) {
        return a || $jscomp.assign;
      },
      'es6',
      'es3',
    );
    $jscomp.polyfill(
      'Object.values',
      function (a) {
        return a
          ? a
          : function (b) {
              var c = [],
                d;
              for (d in b) $jscomp.owns(b, d) && c.push(b[d]);
              return c;
            };
      },
      'es8',
      'es3',
    );
    $jscomp.polyfill(
      'String.prototype.startsWith',
      function (a) {
        return a
          ? a
          : function (b, c) {
              var d = $jscomp.checkStringArgs(this, b, 'startsWith');
              b += '';
              for (var e = d.length, f = b.length, g = Math.max(0, Math.min(c | 0, d.length)), h = 0; h < f && g < e; )
                if (d[g++] != b[h++]) return !1;
              return h >= f;
            };
      },
      'es6',
      'es3',
    );
    var COMPILED = !0,
      goog = goog || {};
    goog.global = this || self;
    goog.exportPath_ = function (a, b, c, d) {
      a = a.split('.');
      d = d || goog.global;
      a[0] in d || 'undefined' == typeof d.execScript || d.execScript('var ' + a[0]);
      for (var e; a.length && (e = a.shift()); )
        if (a.length || void 0 === b) d = d[e] && d[e] !== Object.prototype[e] ? d[e] : (d[e] = {});
        else if (!c && goog.isObject(b) && goog.isObject(d[e]))
          for (var f in b) b.hasOwnProperty(f) && (d[e][f] = b[f]);
        else d[e] = b;
    };
    goog.define = function (a, b) {
      var c = b;
      if (!COMPILED) {
        var d = goog.global.CLOSURE_UNCOMPILED_DEFINES,
          e = goog.global.CLOSURE_DEFINES;
        d && void 0 === d.nodeType && Object.prototype.hasOwnProperty.call(d, a)
          ? (c = d[a])
          : e && void 0 === e.nodeType && Object.prototype.hasOwnProperty.call(e, a) && (c = e[a]);
      }
      return c;
    };
    goog.FEATURESET_YEAR = 2012;
    goog.DEBUG = !0;
    goog.LOCALE = 'en';
    goog.TRUSTED_SITE = !0;
    goog.DISALLOW_TEST_ONLY_CODE = COMPILED && !goog.DEBUG;
    goog.ENABLE_CHROME_APP_SAFE_SCRIPT_LOADING = !1;
    goog.provide = function (a) {
      if (goog.isInModuleLoader_()) throw Error('goog.provide cannot be used within a module.');
      if (!COMPILED && goog.isProvided_(a)) throw Error('Namespace "' + a + '" already declared.');
      goog.constructNamespace_(a);
    };
    goog.constructNamespace_ = function (a, b, c) {
      if (!COMPILED) {
        delete goog.implicitNamespaces_[a];
        for (var d = a; (d = d.substring(0, d.lastIndexOf('.'))) && !goog.getObjectByName(d); )
          goog.implicitNamespaces_[d] = !0;
      }
      goog.exportPath_(a, b, c);
    };
    goog.getScriptNonce = function (a) {
      if (a && a != goog.global) return goog.getScriptNonce_(a.document);
      null === goog.cspNonce_ && (goog.cspNonce_ = goog.getScriptNonce_(goog.global.document));
      return goog.cspNonce_;
    };
    goog.NONCE_PATTERN_ = /^[\w+/_-]+[=]{0,2}$/;
    goog.cspNonce_ = null;
    goog.getScriptNonce_ = function (a) {
      return (a = a.querySelector && a.querySelector('script[nonce]')) &&
        (a = a.nonce || a.getAttribute('nonce')) &&
        goog.NONCE_PATTERN_.test(a)
        ? a
        : '';
    };
    goog.VALID_MODULE_RE_ = /^[a-zA-Z_$][a-zA-Z0-9._$]*$/;
    goog.module = function (a) {
      if ('string' !== typeof a || !a || -1 == a.search(goog.VALID_MODULE_RE_))
        throw Error('Invalid module identifier');
      if (!goog.isInGoogModuleLoader_())
        throw Error(
          'Module ' +
            a +
            " has been loaded incorrectly. Note, modules cannot be loaded as normal scripts. They require some kind of pre-processing step. You're likely trying to load a module via a script tag or as a part of a concatenated bundle without rewriting the module. For more info see: https://github.com/google/closure-library/wiki/goog.module:-an-ES6-module-like-alternative-to-goog.provide.",
        );
      if (goog.moduleLoaderState_.moduleName) throw Error('goog.module may only be called once per module.');
      goog.moduleLoaderState_.moduleName = a;
      if (!COMPILED) {
        if (goog.isProvided_(a)) throw Error('Namespace "' + a + '" already declared.');
        delete goog.implicitNamespaces_[a];
      }
    };
    goog.module.get = function (a) {
      return goog.module.getInternal_(a);
    };
    goog.module.getInternal_ = function (a) {
      if (!COMPILED) {
        if (a in goog.loadedModules_) return goog.loadedModules_[a].exports;
        if (!goog.implicitNamespaces_[a]) return (a = goog.getObjectByName(a)), null != a ? a : null;
      }
      return null;
    };
    goog.ModuleType = { ES6: 'es6', GOOG: 'goog' };
    goog.moduleLoaderState_ = null;
    goog.isInModuleLoader_ = function () {
      return goog.isInGoogModuleLoader_() || goog.isInEs6ModuleLoader_();
    };
    goog.isInGoogModuleLoader_ = function () {
      return !!goog.moduleLoaderState_ && goog.moduleLoaderState_.type == goog.ModuleType.GOOG;
    };
    goog.isInEs6ModuleLoader_ = function () {
      if (goog.moduleLoaderState_ && goog.moduleLoaderState_.type == goog.ModuleType.ES6) return !0;
      var a = goog.global.$jscomp;
      return a ? ('function' != typeof a.getCurrentModulePath ? !1 : !!a.getCurrentModulePath()) : !1;
    };
    goog.module.declareLegacyNamespace = function () {
      if (!COMPILED && !goog.isInGoogModuleLoader_())
        throw Error('goog.module.declareLegacyNamespace must be called from within a goog.module');
      if (!COMPILED && !goog.moduleLoaderState_.moduleName)
        throw Error('goog.module must be called prior to goog.module.declareLegacyNamespace.');
      goog.moduleLoaderState_.declareLegacyNamespace = !0;
    };
    goog.declareModuleId = function (a) {
      if (!COMPILED) {
        if (!goog.isInEs6ModuleLoader_())
          throw Error('goog.declareModuleId may only be called from within an ES6 module');
        if (goog.moduleLoaderState_ && goog.moduleLoaderState_.moduleName)
          throw Error('goog.declareModuleId may only be called once per module.');
        if (a in goog.loadedModules_) throw Error('Module with namespace "' + a + '" already exists.');
      }
      if (goog.moduleLoaderState_) goog.moduleLoaderState_.moduleName = a;
      else {
        var b = goog.global.$jscomp;
        if (!b || 'function' != typeof b.getCurrentModulePath)
          throw Error('Module with namespace "' + a + '" has been loaded incorrectly.');
        b = b.require(b.getCurrentModulePath());
        goog.loadedModules_[a] = { exports: b, type: goog.ModuleType.ES6, moduleId: a };
      }
    };
    goog.setTestOnly = function (a) {
      if (goog.DISALLOW_TEST_ONLY_CODE)
        throw ((a = a || ''), Error('Importing test-only code into non-debug environment' + (a ? ': ' + a : '.')));
    };
    goog.forwardDeclare = function (a) {};
    COMPILED ||
      ((goog.isProvided_ = function (a) {
        return a in goog.loadedModules_ || (!goog.implicitNamespaces_[a] && null != goog.getObjectByName(a));
      }),
      (goog.implicitNamespaces_ = { 'goog.module': !0 }));
    goog.getObjectByName = function (a, b) {
      for (var c = a.split('.'), d = b || goog.global, e = 0; e < c.length; e++)
        if (((d = d[c[e]]), null == d)) return null;
      return d;
    };
    goog.addDependency = function (a, b, c, d) {
      !COMPILED && goog.DEPENDENCIES_ENABLED && goog.debugLoader_.addDependency(a, b, c, d);
    };
    goog.ENABLE_DEBUG_LOADER = !1;
    goog.logToConsole_ = function (a) {
      goog.global.console && goog.global.console.error(a);
    };
    goog.require = function (a) {
      if (!COMPILED) {
        goog.ENABLE_DEBUG_LOADER && goog.debugLoader_.requested(a);
        if (goog.isProvided_(a)) {
          if (goog.isInModuleLoader_()) return goog.module.getInternal_(a);
        } else if (goog.ENABLE_DEBUG_LOADER) {
          var b = goog.moduleLoaderState_;
          goog.moduleLoaderState_ = null;
          try {
            goog.debugLoader_.load_(a);
          } finally {
            goog.moduleLoaderState_ = b;
          }
        }
        return null;
      }
    };
    goog.requireType = function (a) {
      return {};
    };
    goog.basePath = '';
    goog.nullFunction = function () {};
    goog.abstractMethod = function () {
      throw Error('unimplemented abstract method');
    };
    goog.addSingletonGetter = function (a) {
      a.instance_ = void 0;
      a.getInstance = function () {
        if (a.instance_) return a.instance_;
        goog.DEBUG && (goog.instantiatedSingletons_[goog.instantiatedSingletons_.length] = a);
        return (a.instance_ = new a());
      };
    };
    goog.instantiatedSingletons_ = [];
    goog.LOAD_MODULE_USING_EVAL = !0;
    goog.SEAL_MODULE_EXPORTS = goog.DEBUG;
    goog.loadedModules_ = {};
    goog.DEPENDENCIES_ENABLED = !COMPILED && goog.ENABLE_DEBUG_LOADER;
    goog.TRANSPILE = 'detect';
    goog.ASSUME_ES_MODULES_TRANSPILED = !1;
    goog.TRANSPILE_TO_LANGUAGE = '';
    goog.TRANSPILER = 'transpile.js';
    goog.hasBadLetScoping = null;
    goog.useSafari10Workaround = function () {
      if (null == goog.hasBadLetScoping) {
        try {
          var a = !eval('"use strict";let x = 1; function f() { return typeof x; };f() == "number";');
        } catch (b) {
          a = !1;
        }
        goog.hasBadLetScoping = a;
      }
      return goog.hasBadLetScoping;
    };
    goog.workaroundSafari10EvalBug = function (a) {
      return '(function(){' + a + '\n;})();\n';
    };
    goog.loadModule = function (a) {
      var b = goog.moduleLoaderState_;
      try {
        goog.moduleLoaderState_ = { moduleName: '', declareLegacyNamespace: !1, type: goog.ModuleType.GOOG };
        var c = {},
          d = c;
        if (goog.isFunction(a)) d = a.call(void 0, d);
        else if ('string' === typeof a)
          goog.useSafari10Workaround() && (a = goog.workaroundSafari10EvalBug(a)),
            (d = goog.loadModuleFromSource_.call(void 0, d, a));
        else throw Error('Invalid module definition');
        var e = goog.moduleLoaderState_.moduleName;
        if ('string' === typeof e && e)
          goog.moduleLoaderState_.declareLegacyNamespace
            ? goog.constructNamespace_(e, d, c !== d)
            : goog.SEAL_MODULE_EXPORTS && Object.seal && 'object' == typeof d && null != d && Object.seal(d),
            (goog.loadedModules_[e] = {
              exports: d,
              type: goog.ModuleType.GOOG,
              moduleId: goog.moduleLoaderState_.moduleName,
            });
        else throw Error('Invalid module name "' + e + '"');
      } finally {
        goog.moduleLoaderState_ = b;
      }
    };
    goog.loadModuleFromSource_ = function (a, b) {
      eval(b);
      return a;
    };
    goog.normalizePath_ = function (a) {
      a = a.split('/');
      for (var b = 0; b < a.length; )
        '.' == a[b] ? a.splice(b, 1) : b && '..' == a[b] && a[b - 1] && '..' != a[b - 1] ? a.splice(--b, 2) : b++;
      return a.join('/');
    };
    goog.loadFileSync_ = function (a) {
      if (goog.global.CLOSURE_LOAD_FILE_SYNC) return goog.global.CLOSURE_LOAD_FILE_SYNC(a);
      try {
        var b = new goog.global.XMLHttpRequest();
        b.open('get', a, !1);
        b.send();
        return 0 == b.status || 200 == b.status ? b.responseText : null;
      } catch (c) {
        return null;
      }
    };
    goog.transpile_ = function (a, b, c) {
      var d = goog.global.$jscomp;
      d || (goog.global.$jscomp = d = {});
      var e = d.transpile;
      if (!e) {
        var f = goog.basePath + goog.TRANSPILER,
          g = goog.loadFileSync_(f);
        if (g) {
          (function () {
            (0, eval)(g + '\n//# sourceURL=' + f);
          }.call(goog.global));
          if (goog.global.$gwtExport && goog.global.$gwtExport.$jscomp && !goog.global.$gwtExport.$jscomp.transpile)
            throw Error(
              'The transpiler did not properly export the "transpile" method. $gwtExport: ' +
                JSON.stringify(goog.global.$gwtExport),
            );
          goog.global.$jscomp.transpile = goog.global.$gwtExport.$jscomp.transpile;
          d = goog.global.$jscomp;
          e = d.transpile;
        }
      }
      e ||
        (e = d.transpile = function (h, k) {
          goog.logToConsole_(k + ' requires transpilation but no transpiler was found.');
          return h;
        });
      return e(a, b, c);
    };
    goog.typeOf = function (a) {
      var b = typeof a;
      return 'object' != b ? b : a ? (Array.isArray(a) ? 'array' : b) : 'null';
    };
    goog.isArrayLike = function (a) {
      var b = goog.typeOf(a);
      return 'array' == b || ('object' == b && 'number' == typeof a.length);
    };
    goog.isDateLike = function (a) {
      return goog.isObject(a) && 'function' == typeof a.getFullYear;
    };
    goog.isFunction = function (a) {
      return 'function' == goog.typeOf(a);
    };
    goog.isObject = function (a) {
      var b = typeof a;
      return ('object' == b && null != a) || 'function' == b;
    };
    goog.getUid = function (a) {
      return (
        (Object.prototype.hasOwnProperty.call(a, goog.UID_PROPERTY_) && a[goog.UID_PROPERTY_]) ||
        (a[goog.UID_PROPERTY_] = ++goog.uidCounter_)
      );
    };
    goog.hasUid = function (a) {
      return !!a[goog.UID_PROPERTY_];
    };
    goog.removeUid = function (a) {
      null !== a && 'removeAttribute' in a && a.removeAttribute(goog.UID_PROPERTY_);
      try {
        delete a[goog.UID_PROPERTY_];
      } catch (b) {}
    };
    goog.UID_PROPERTY_ = 'closure_uid_' + ((1e9 * Math.random()) >>> 0);
    goog.uidCounter_ = 0;
    goog.cloneObject = function (a) {
      var b = goog.typeOf(a);
      if ('object' == b || 'array' == b) {
        if ('function' === typeof a.clone) return a.clone();
        b = 'array' == b ? [] : {};
        for (var c in a) b[c] = goog.cloneObject(a[c]);
        return b;
      }
      return a;
    };
    goog.bindNative_ = function (a, b, c) {
      return a.call.apply(a.bind, arguments);
    };
    goog.bindJs_ = function (a, b, c) {
      if (!a) throw Error();
      if (2 < arguments.length) {
        var d = Array.prototype.slice.call(arguments, 2);
        return function () {
          var e = Array.prototype.slice.call(arguments);
          Array.prototype.unshift.apply(e, d);
          return a.apply(b, e);
        };
      }
      return function () {
        return a.apply(b, arguments);
      };
    };
    goog.bind = function (a, b, c) {
      Function.prototype.bind && -1 != Function.prototype.bind.toString().indexOf('native code')
        ? (goog.bind = goog.bindNative_)
        : (goog.bind = goog.bindJs_);
      return goog.bind.apply(null, arguments);
    };
    goog.partial = function (a, b) {
      var c = Array.prototype.slice.call(arguments, 1);
      return function () {
        var d = c.slice();
        d.push.apply(d, arguments);
        return a.apply(this, d);
      };
    };
    goog.mixin = function (a, b) {
      for (var c in b) a[c] = b[c];
    };
    goog.now = Date.now;
    goog.globalEval = function (a) {
      (0, eval)(a);
    };
    goog.getCssName = function (a, b) {
      if ('.' == String(a).charAt(0))
        throw Error('className passed in goog.getCssName must not start with ".". You passed: ' + a);
      var c = function (e) {
          return goog.cssNameMapping_[e] || e;
        },
        d = function (e) {
          e = e.split('-');
          for (var f = [], g = 0; g < e.length; g++) f.push(c(e[g]));
          return f.join('-');
        };
      d = goog.cssNameMapping_
        ? 'BY_WHOLE' == goog.cssNameMappingStyle_
          ? c
          : d
        : function (e) {
            return e;
          };
      d = b ? a + '-' + d(b) : d(a);
      return goog.global.CLOSURE_CSS_NAME_MAP_FN ? goog.global.CLOSURE_CSS_NAME_MAP_FN(d) : d;
    };
    goog.setCssNameMapping = function (a, b) {
      goog.cssNameMapping_ = a;
      goog.cssNameMappingStyle_ = b;
    };
    !COMPILED && goog.global.CLOSURE_CSS_NAME_MAPPING && (goog.cssNameMapping_ = goog.global.CLOSURE_CSS_NAME_MAPPING);
    goog.getMsg = function (a, b, c) {
      c && c.html && (a = a.replace(/</g, '&lt;'));
      b &&
        (a = a.replace(/\{\$([^}]+)}/g, function (d, e) {
          return null != b && e in b ? b[e] : d;
        }));
      return a;
    };
    goog.getMsgWithFallback = function (a, b) {
      return a;
    };
    goog.exportSymbol = function (a, b, c) {
      goog.exportPath_(a, b, !0, c);
    };
    goog.exportProperty = function (a, b, c) {
      a[b] = c;
    };
    goog.inherits = function (a, b) {
      function c() {}
      c.prototype = b.prototype;
      a.superClass_ = b.prototype;
      a.prototype = new c();
      a.prototype.constructor = a;
      a.base = function (d, e, f) {
        for (var g = Array(arguments.length - 2), h = 2; h < arguments.length; h++) g[h - 2] = arguments[h];
        return b.prototype[e].apply(d, g);
      };
    };
    goog.scope = function (a) {
      if (goog.isInModuleLoader_()) throw Error('goog.scope is not supported within a module.');
      a.call(goog.global);
    };
    COMPILED || (goog.global.COMPILED = COMPILED);
    goog.defineClass = function (a, b) {
      var c = b.constructor,
        d = b.statics;
      (c && c != Object.prototype.constructor) ||
        (c = function () {
          throw Error('cannot instantiate an interface (no constructor defined).');
        });
      c = goog.defineClass.createSealingConstructor_(c, a);
      a && goog.inherits(c, a);
      delete b.constructor;
      delete b.statics;
      goog.defineClass.applyProperties_(c.prototype, b);
      null != d && (d instanceof Function ? d(c) : goog.defineClass.applyProperties_(c, d));
      return c;
    };
    goog.defineClass.SEAL_CLASS_INSTANCES = goog.DEBUG;
    goog.defineClass.createSealingConstructor_ = function (a, b) {
      return goog.defineClass.SEAL_CLASS_INSTANCES
        ? function () {
            var c = a.apply(this, arguments) || this;
            c[goog.UID_PROPERTY_] = c[goog.UID_PROPERTY_];
            return c;
          }
        : a;
    };
    goog.defineClass.OBJECT_PROTOTYPE_FIELDS_ = 'constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf'.split(
      ' ',
    );
    goog.defineClass.applyProperties_ = function (a, b) {
      for (var c in b) Object.prototype.hasOwnProperty.call(b, c) && (a[c] = b[c]);
      for (var d = 0; d < goog.defineClass.OBJECT_PROTOTYPE_FIELDS_.length; d++)
        (c = goog.defineClass.OBJECT_PROTOTYPE_FIELDS_[d]), Object.prototype.hasOwnProperty.call(b, c) && (a[c] = b[c]);
    };
    !COMPILED &&
      goog.DEPENDENCIES_ENABLED &&
      ((goog.getLastScript_ = function () {
        for (var a = document.documentElement; 'SCRIPT' != a.nodeName && a.lastChild; ) a = a.lastChild;
        return a;
      }),
      (goog.inHtmlDocument_ = function () {
        var a = goog.global.document;
        return null != a && 'write' in a;
      }),
      (goog.isDocumentLoading_ = function () {
        var a = goog.global.document;
        return a.attachEvent ? 'complete' != a.readyState : 'loading' == a.readyState;
      }),
      (goog.findBasePath_ = function () {
        if (void 0 != goog.global.CLOSURE_BASE_PATH && 'string' === typeof goog.global.CLOSURE_BASE_PATH)
          goog.basePath = goog.global.CLOSURE_BASE_PATH;
        else if (goog.inHtmlDocument_()) {
          var a = goog.global.document,
            b = a.currentScript;
          a = b ? [b] : a.getElementsByTagName('SCRIPT');
          for (b = a.length - 1; 0 <= b; --b) {
            var c = a[b].src,
              d = c.lastIndexOf('?');
            d = -1 == d ? c.length : d;
            if ('base.js' == c.substr(d - 7, 7)) {
              goog.basePath = c.substr(0, d - 7);
              break;
            }
          }
        }
      }),
      goog.findBasePath_(),
      (goog.Transpiler = function () {
        this.requiresTranspilation_ = null;
        this.transpilationTarget_ = goog.TRANSPILE_TO_LANGUAGE;
      }),
      (goog.Transpiler.prototype.createRequiresTranspilation_ = function () {
        function a(g, h) {
          e ? (d[g] = !0) : h() ? ((c = g), (d[g] = !1)) : (e = d[g] = !0);
        }
        function b(g) {
          try {
            return !!eval(g);
          } catch (h) {
            return !1;
          }
        }
        var c = 'es3',
          d = { es3: !1 },
          e = !1,
          f = goog.global.navigator && goog.global.navigator.userAgent ? goog.global.navigator.userAgent : '';
        a('es5', function () {
          return b('[1,].length==1');
        });
        a('es6', function () {
          return f.match(/Edge\/(\d+)(\.\d)*/i)
            ? !1
            : b(
                '(()=>{"use strict";class X{constructor(){if(new.target!=String)throw 1;this.x=42}}let q=Reflect.construct(X,[],String);if(q.x!=42||!(q instanceof String))throw 1;for(const a of[2,3]){if(a==2)continue;function f(z={a}){let a=0;return z.a}{function f(){return 0;}}return f()==3}})()',
              );
        });
        a('es7', function () {
          return b('2 ** 2 == 4');
        });
        a('es8', function () {
          return b('async () => 1, true');
        });
        a('es9', function () {
          return b('({...rest} = {}), true');
        });
        a('es_next', function () {
          return !1;
        });
        return { target: c, map: d };
      }),
      (goog.Transpiler.prototype.needsTranspile = function (a, b) {
        if ('always' == goog.TRANSPILE) return !0;
        if ('never' == goog.TRANSPILE) return !1;
        if (!this.requiresTranspilation_) {
          var c = this.createRequiresTranspilation_();
          this.requiresTranspilation_ = c.map;
          this.transpilationTarget_ = this.transpilationTarget_ || c.target;
        }
        if (a in this.requiresTranspilation_)
          return this.requiresTranspilation_[a]
            ? !0
            : !goog.inHtmlDocument_() || 'es6' != b || 'noModule' in goog.global.document.createElement('script')
            ? !1
            : !0;
        throw Error('Unknown language mode: ' + a);
      }),
      (goog.Transpiler.prototype.transpile = function (a, b) {
        return goog.transpile_(a, b, this.transpilationTarget_);
      }),
      (goog.transpiler_ = new goog.Transpiler()),
      (goog.protectScriptTag_ = function (a) {
        return a.replace(/<\/(SCRIPT)/gi, '\\x3c/$1');
      }),
      (goog.DebugLoader_ = function () {
        this.dependencies_ = {};
        this.idToPath_ = {};
        this.written_ = {};
        this.loadingDeps_ = [];
        this.depsToLoad_ = [];
        this.paused_ = !1;
        this.factory_ = new goog.DependencyFactory(goog.transpiler_);
        this.deferredCallbacks_ = {};
        this.deferredQueue_ = [];
      }),
      (goog.DebugLoader_.prototype.bootstrap = function (a, b) {
        function c() {
          d && (goog.global.setTimeout(d, 0), (d = null));
        }
        var d = b;
        if (a.length) {
          for (var e = [], f = 0; f < a.length; f++) {
            var g = this.getPathFromDeps_(a[f]);
            if (!g) throw Error('Unregonized namespace: ' + a[f]);
            e.push(this.dependencies_[g]);
          }
          g = goog.require;
          var h = 0;
          for (f = 0; f < a.length; f++)
            g(a[f]),
              e[f].onLoad(function () {
                ++h == a.length && c();
              });
        } else c();
      }),
      (goog.DebugLoader_.prototype.loadClosureDeps = function () {
        this.depsToLoad_.push(
          this.factory_.createDependency(goog.normalizePath_(goog.basePath + 'deps.js'), 'deps.js', [], [], {}, !1),
        );
        this.loadDeps_();
      }),
      (goog.DebugLoader_.prototype.requested = function (a, b) {
        var c = this.getPathFromDeps_(a);
        if (c && (b || this.areDepsLoaded_(this.dependencies_[c].requires))) {
          var d = this.deferredCallbacks_[c];
          d && (delete this.deferredCallbacks_[c], d());
        }
      }),
      (goog.DebugLoader_.prototype.setDependencyFactory = function (a) {
        this.factory_ = a;
      }),
      (goog.DebugLoader_.prototype.load_ = function (a) {
        if (this.getPathFromDeps_(a)) {
          var b = this,
            c = [],
            d = function (e) {
              var f = b.getPathFromDeps_(e);
              if (!f) throw Error('Bad dependency path or symbol: ' + e);
              if (!b.written_[f]) {
                b.written_[f] = !0;
                e = b.dependencies_[f];
                for (f = 0; f < e.requires.length; f++) goog.isProvided_(e.requires[f]) || d(e.requires[f]);
                c.push(e);
              }
            };
          d(a);
          a = !!this.depsToLoad_.length;
          this.depsToLoad_ = this.depsToLoad_.concat(c);
          this.paused_ || a || this.loadDeps_();
        } else throw ((a = 'goog.require could not find: ' + a), goog.logToConsole_(a), Error(a));
      }),
      (goog.DebugLoader_.prototype.loadDeps_ = function () {
        for (var a = this, b = this.paused_; this.depsToLoad_.length && !b; )
          (function () {
            var c = !1,
              d = a.depsToLoad_.shift(),
              e = !1;
            a.loading_(d);
            var f = {
              pause: function () {
                if (c) throw Error('Cannot call pause after the call to load.');
                b = !0;
              },
              resume: function () {
                c ? a.resume_() : (b = !1);
              },
              loaded: function () {
                if (e) throw Error('Double call to loaded.');
                e = !0;
                a.loaded_(d);
              },
              pending: function () {
                for (var g = [], h = 0; h < a.loadingDeps_.length; h++) g.push(a.loadingDeps_[h]);
                return g;
              },
              setModuleState: function (g) {
                goog.moduleLoaderState_ = { type: g, moduleName: '', declareLegacyNamespace: !1 };
              },
              registerEs6ModuleExports: function (g, h, k) {
                k && (goog.loadedModules_[k] = { exports: h, type: goog.ModuleType.ES6, moduleId: k || '' });
              },
              registerGoogModuleExports: function (g, h) {
                goog.loadedModules_[g] = { exports: h, type: goog.ModuleType.GOOG, moduleId: g };
              },
              clearModuleState: function () {
                goog.moduleLoaderState_ = null;
              },
              defer: function (g) {
                if (c) throw Error('Cannot register with defer after the call to load.');
                a.defer_(d, g);
              },
              areDepsLoaded: function () {
                return a.areDepsLoaded_(d.requires);
              },
            };
            try {
              d.load(f);
            } finally {
              c = !0;
            }
          })();
        b && this.pause_();
      }),
      (goog.DebugLoader_.prototype.pause_ = function () {
        this.paused_ = !0;
      }),
      (goog.DebugLoader_.prototype.resume_ = function () {
        this.paused_ && ((this.paused_ = !1), this.loadDeps_());
      }),
      (goog.DebugLoader_.prototype.loading_ = function (a) {
        this.loadingDeps_.push(a);
      }),
      (goog.DebugLoader_.prototype.loaded_ = function (a) {
        for (var b = 0; b < this.loadingDeps_.length; b++)
          if (this.loadingDeps_[b] == a) {
            this.loadingDeps_.splice(b, 1);
            break;
          }
        for (b = 0; b < this.deferredQueue_.length; b++)
          if (this.deferredQueue_[b] == a.path) {
            this.deferredQueue_.splice(b, 1);
            break;
          }
        if (this.loadingDeps_.length == this.deferredQueue_.length && !this.depsToLoad_.length)
          for (; this.deferredQueue_.length; ) this.requested(this.deferredQueue_.shift(), !0);
        a.loaded();
      }),
      (goog.DebugLoader_.prototype.areDepsLoaded_ = function (a) {
        for (var b = 0; b < a.length; b++) {
          var c = this.getPathFromDeps_(a[b]);
          if (!c || !(c in this.deferredCallbacks_ || goog.isProvided_(a[b]))) return !1;
        }
        return !0;
      }),
      (goog.DebugLoader_.prototype.getPathFromDeps_ = function (a) {
        return a in this.idToPath_ ? this.idToPath_[a] : a in this.dependencies_ ? a : null;
      }),
      (goog.DebugLoader_.prototype.defer_ = function (a, b) {
        this.deferredCallbacks_[a.path] = b;
        this.deferredQueue_.push(a.path);
      }),
      (goog.LoadController = function () {}),
      (goog.LoadController.prototype.pause = function () {}),
      (goog.LoadController.prototype.resume = function () {}),
      (goog.LoadController.prototype.loaded = function () {}),
      (goog.LoadController.prototype.pending = function () {}),
      (goog.LoadController.prototype.registerEs6ModuleExports = function (a, b, c) {}),
      (goog.LoadController.prototype.setModuleState = function (a) {}),
      (goog.LoadController.prototype.clearModuleState = function () {}),
      (goog.LoadController.prototype.defer = function (a) {}),
      (goog.LoadController.prototype.areDepsLoaded = function () {}),
      (goog.Dependency = function (a, b, c, d, e) {
        this.path = a;
        this.relativePath = b;
        this.provides = c;
        this.requires = d;
        this.loadFlags = e;
        this.loaded_ = !1;
        this.loadCallbacks_ = [];
      }),
      (goog.Dependency.prototype.getPathName = function () {
        var a = this.path,
          b = a.indexOf('://');
        0 <= b && ((a = a.substring(b + 3)), (b = a.indexOf('/')), 0 <= b && (a = a.substring(b + 1)));
        return a;
      }),
      (goog.Dependency.prototype.onLoad = function (a) {
        this.loaded_ ? a() : this.loadCallbacks_.push(a);
      }),
      (goog.Dependency.prototype.loaded = function () {
        this.loaded_ = !0;
        var a = this.loadCallbacks_;
        this.loadCallbacks_ = [];
        for (var b = 0; b < a.length; b++) a[b]();
      }),
      (goog.Dependency.defer_ = !1),
      (goog.Dependency.callbackMap_ = {}),
      (goog.Dependency.registerCallback_ = function (a) {
        var b = Math.random().toString(32);
        goog.Dependency.callbackMap_[b] = a;
        return b;
      }),
      (goog.Dependency.unregisterCallback_ = function (a) {
        delete goog.Dependency.callbackMap_[a];
      }),
      (goog.Dependency.callback_ = function (a, b) {
        if (a in goog.Dependency.callbackMap_) {
          for (var c = goog.Dependency.callbackMap_[a], d = [], e = 1; e < arguments.length; e++) d.push(arguments[e]);
          c.apply(void 0, d);
        } else throw Error('Callback key ' + a + ' does not exist (was base.js loaded more than once?).');
      }),
      (goog.Dependency.prototype.load = function (a) {
        if (goog.global.CLOSURE_IMPORT_SCRIPT) goog.global.CLOSURE_IMPORT_SCRIPT(this.path) ? a.loaded() : a.pause();
        else if (goog.inHtmlDocument_()) {
          var b = goog.global.document;
          if ('complete' == b.readyState && !goog.ENABLE_CHROME_APP_SAFE_SCRIPT_LOADING) {
            if (/\bdeps.js$/.test(this.path)) {
              a.loaded();
              return;
            }
            throw Error('Cannot write "' + this.path + '" after document load');
          }
          var c = goog.getScriptNonce();
          if (!goog.ENABLE_CHROME_APP_SAFE_SCRIPT_LOADING && goog.isDocumentLoading_()) {
            var d = !c,
              e = goog.Dependency.registerCallback_(function (k) {
                (goog.DebugLoader_.IS_OLD_IE_ && 'complete' != k.readyState) ||
                  (goog.Dependency.unregisterCallback_(e), a.loaded());
              }),
              f = goog.DebugLoader_.IS_OLD_IE_ ? 'onreadystatechange' : 'onload',
              g = '';
            d && (g = ' ' + f + '="goog.Dependency.callback_(\'' + e + '\', this)"');
            c =
              '<script src="' +
              this.path +
              '"' +
              (c ? ' nonce="' + c + '"' : '') +
              g +
              (goog.Dependency.defer_ ? ' defer' : '') +
              '>\x3c/script>';
            b.write(goog.TRUSTED_TYPES_POLICY_ ? goog.TRUSTED_TYPES_POLICY_.createHTML(c) : c);
            d ||
              (goog.getLastScript_().onload = function () {
                goog.Dependency.callback_(e, this);
              });
          } else {
            var h = b.createElement('script');
            h.defer = goog.Dependency.defer_;
            h.async = !1;
            h.type = 'text/javascript';
            c && h.setAttribute('nonce', c);
            goog.DebugLoader_.IS_OLD_IE_
              ? (a.pause(),
                (h.onreadystatechange = function () {
                  if ('loaded' == h.readyState || 'complete' == h.readyState) a.loaded(), a.resume();
                }))
              : (h.onload = function () {
                  h.onload = null;
                  a.loaded();
                });
            h.src = goog.TRUSTED_TYPES_POLICY_ ? goog.TRUSTED_TYPES_POLICY_.createScriptURL(this.path) : this.path;
            b.head.appendChild(h);
          }
        } else
          goog.logToConsole_('Cannot use default debug loader outside of HTML documents.'),
            'deps.js' == this.relativePath
              ? (goog.logToConsole_(
                  'Consider setting CLOSURE_IMPORT_SCRIPT before loading base.js, or setting CLOSURE_NO_DEPS to true.',
                ),
                a.loaded())
              : a.pause();
      }),
      (goog.Es6ModuleDependency = function (a, b, c, d, e) {
        goog.Dependency.call(this, a, b, c, d, e);
      }),
      goog.inherits(goog.Es6ModuleDependency, goog.Dependency),
      (goog.Es6ModuleDependency.prototype.load = function (a) {
        function b(l, m) {
          var n = m
            ? '<script type="module" crossorigin>' + m + '\x3c/script>'
            : '<script type="module" crossorigin src="' + l + '">\x3c/script>';
          d.write(goog.TRUSTED_TYPES_POLICY_ ? goog.TRUSTED_TYPES_POLICY_.createHTML(n) : n);
        }
        function c(l, m) {
          var n = d.createElement('script');
          n.defer = !0;
          n.async = !1;
          n.type = 'module';
          n.setAttribute('crossorigin', !0);
          var p = goog.getScriptNonce();
          p && n.setAttribute('nonce', p);
          m
            ? (n.textContent = goog.TRUSTED_TYPES_POLICY_ ? goog.TRUSTED_TYPES_POLICY_.createScript(m) : m)
            : (n.src = goog.TRUSTED_TYPES_POLICY_ ? goog.TRUSTED_TYPES_POLICY_.createScriptURL(l) : l);
          d.head.appendChild(n);
        }
        if (goog.global.CLOSURE_IMPORT_SCRIPT) goog.global.CLOSURE_IMPORT_SCRIPT(this.path) ? a.loaded() : a.pause();
        else if (goog.inHtmlDocument_()) {
          var d = goog.global.document,
            e = this;
          if (goog.isDocumentLoading_()) {
            var f = b;
            goog.Dependency.defer_ = !0;
          } else f = c;
          var g = goog.Dependency.registerCallback_(function () {
            goog.Dependency.unregisterCallback_(g);
            a.setModuleState(goog.ModuleType.ES6);
          });
          f(void 0, 'goog.Dependency.callback_("' + g + '")');
          f(this.path, void 0);
          var h = goog.Dependency.registerCallback_(function (l) {
            goog.Dependency.unregisterCallback_(h);
            a.registerEs6ModuleExports(e.path, l, goog.moduleLoaderState_.moduleName);
          });
          f(void 0, 'import * as m from "' + this.path + '"; goog.Dependency.callback_("' + h + '", m)');
          var k = goog.Dependency.registerCallback_(function () {
            goog.Dependency.unregisterCallback_(k);
            a.clearModuleState();
            a.loaded();
          });
          f(void 0, 'goog.Dependency.callback_("' + k + '")');
        } else goog.logToConsole_('Cannot use default debug loader outside of HTML documents.'), a.pause();
      }),
      (goog.TransformedDependency = function (a, b, c, d, e) {
        goog.Dependency.call(this, a, b, c, d, e);
        this.contents_ = null;
        this.lazyFetch_ = !goog.inHtmlDocument_() || !('noModule' in goog.global.document.createElement('script'));
      }),
      goog.inherits(goog.TransformedDependency, goog.Dependency),
      (goog.TransformedDependency.prototype.load = function (a) {
        function b() {
          e.contents_ = goog.loadFileSync_(e.path);
          e.contents_ &&
            ((e.contents_ = e.transform(e.contents_)), e.contents_ && (e.contents_ += '\n//# sourceURL=' + e.path));
        }
        function c() {
          e.lazyFetch_ && b();
          if (e.contents_) {
            f && a.setModuleState(goog.ModuleType.ES6);
            try {
              var m = e.contents_;
              e.contents_ = null;
              goog.globalEval(m);
              if (f) var n = goog.moduleLoaderState_.moduleName;
            } finally {
              f && a.clearModuleState();
            }
            f &&
              goog.global.$jscomp.require.ensure([e.getPathName()], function () {
                a.registerEs6ModuleExports(e.path, goog.global.$jscomp.require(e.getPathName()), n);
              });
            a.loaded();
          }
        }
        function d() {
          var m = goog.global.document,
            n = goog.Dependency.registerCallback_(function () {
              goog.Dependency.unregisterCallback_(n);
              c();
            }),
            p = goog.getScriptNonce();
          p =
            '<script' +
            (p ? ' nonce="' + p + '"' : '') +
            '>' +
            goog.protectScriptTag_('goog.Dependency.callback_("' + n + '");') +
            '\x3c/script>';
          m.write(goog.TRUSTED_TYPES_POLICY_ ? goog.TRUSTED_TYPES_POLICY_.createHTML(p) : p);
        }
        var e = this;
        if (goog.global.CLOSURE_IMPORT_SCRIPT)
          b(),
            this.contents_ && goog.global.CLOSURE_IMPORT_SCRIPT('', this.contents_)
              ? ((this.contents_ = null), a.loaded())
              : a.pause();
        else {
          var f = this.loadFlags.module == goog.ModuleType.ES6;
          this.lazyFetch_ || b();
          var g = 1 < a.pending().length,
            h = g && goog.DebugLoader_.IS_OLD_IE_;
          g = goog.Dependency.defer_ && (g || goog.isDocumentLoading_());
          if (h || g)
            a.defer(function () {
              c();
            });
          else {
            var k = goog.global.document;
            h = goog.inHtmlDocument_() && 'ActiveXObject' in goog.global;
            if (f && goog.inHtmlDocument_() && goog.isDocumentLoading_() && !h) {
              goog.Dependency.defer_ = !0;
              a.pause();
              var l = k.onreadystatechange;
              k.onreadystatechange = function () {
                'interactive' == k.readyState && ((k.onreadystatechange = l), c(), a.resume());
                goog.isFunction(l) && l.apply(void 0, arguments);
              };
            } else !goog.DebugLoader_.IS_OLD_IE_ && goog.inHtmlDocument_() && goog.isDocumentLoading_() ? d() : c();
          }
        }
      }),
      (goog.TransformedDependency.prototype.transform = function (a) {}),
      (goog.TranspiledDependency = function (a, b, c, d, e, f) {
        goog.TransformedDependency.call(this, a, b, c, d, e);
        this.transpiler = f;
      }),
      goog.inherits(goog.TranspiledDependency, goog.TransformedDependency),
      (goog.TranspiledDependency.prototype.transform = function (a) {
        return this.transpiler.transpile(a, this.getPathName());
      }),
      (goog.PreTranspiledEs6ModuleDependency = function (a, b, c, d, e) {
        goog.TransformedDependency.call(this, a, b, c, d, e);
      }),
      goog.inherits(goog.PreTranspiledEs6ModuleDependency, goog.TransformedDependency),
      (goog.PreTranspiledEs6ModuleDependency.prototype.transform = function (a) {
        return a;
      }),
      (goog.GoogModuleDependency = function (a, b, c, d, e, f, g) {
        goog.TransformedDependency.call(this, a, b, c, d, e);
        this.needsTranspile_ = f;
        this.transpiler_ = g;
      }),
      goog.inherits(goog.GoogModuleDependency, goog.TransformedDependency),
      (goog.GoogModuleDependency.prototype.transform = function (a) {
        this.needsTranspile_ && (a = this.transpiler_.transpile(a, this.getPathName()));
        return goog.LOAD_MODULE_USING_EVAL && void 0 !== goog.global.JSON
          ? 'goog.loadModule(' + goog.global.JSON.stringify(a + '\n//# sourceURL=' + this.path + '\n') + ');'
          : 'goog.loadModule(function(exports) {"use strict";' +
              a +
              '\n;return exports});\n//# sourceURL=' +
              this.path +
              '\n';
      }),
      (goog.DebugLoader_.IS_OLD_IE_ = !(goog.global.atob || !goog.global.document || !goog.global.document.all)),
      (goog.DebugLoader_.prototype.addDependency = function (a, b, c, d) {
        b = b || [];
        a = a.replace(/\\/g, '/');
        var e = goog.normalizePath_(goog.basePath + a);
        (d && 'boolean' !== typeof d) || (d = d ? { module: goog.ModuleType.GOOG } : {});
        c = this.factory_.createDependency(e, a, b, c, d, goog.transpiler_.needsTranspile(d.lang || 'es3', d.module));
        this.dependencies_[e] = c;
        for (c = 0; c < b.length; c++) this.idToPath_[b[c]] = e;
        this.idToPath_[a] = e;
      }),
      (goog.DependencyFactory = function (a) {
        this.transpiler = a;
      }),
      (goog.DependencyFactory.prototype.createDependency = function (a, b, c, d, e, f) {
        return e.module == goog.ModuleType.GOOG
          ? new goog.GoogModuleDependency(a, b, c, d, e, f, this.transpiler)
          : f
          ? new goog.TranspiledDependency(a, b, c, d, e, this.transpiler)
          : e.module == goog.ModuleType.ES6
          ? 'never' == goog.TRANSPILE && goog.ASSUME_ES_MODULES_TRANSPILED
            ? new goog.PreTranspiledEs6ModuleDependency(a, b, c, d, e)
            : new goog.Es6ModuleDependency(a, b, c, d, e)
          : new goog.Dependency(a, b, c, d, e);
      }),
      (goog.debugLoader_ = new goog.DebugLoader_()),
      (goog.loadClosureDeps = function () {
        goog.debugLoader_.loadClosureDeps();
      }),
      (goog.setDependencyFactory = function (a) {
        goog.debugLoader_.setDependencyFactory(a);
      }),
      (goog.TRUSTED_TYPES_POLICY_ = goog.TRUSTED_TYPES_POLICY_NAME
        ? goog.createTrustedTypesPolicy(goog.TRUSTED_TYPES_POLICY_NAME + '#base')
        : null),
      goog.global.CLOSURE_NO_DEPS || goog.debugLoader_.loadClosureDeps(),
      (goog.bootstrap = function (a, b) {
        goog.debugLoader_.bootstrap(a, b);
      }));
    goog.TRUSTED_TYPES_POLICY_NAME = 'goog';
    goog.identity_ = function (a) {
      return a;
    };
    goog.createTrustedTypesPolicy = function (a) {
      var b = null,
        c = goog.global.trustedTypes;
      if (!c || !c.createPolicy) return b;
      try {
        b = c.createPolicy(a, {
          createHTML: goog.identity_,
          createScript: goog.identity_,
          createScriptURL: goog.identity_,
        });
      } catch (d) {
        goog.logToConsole_(d.message);
      }
      return b;
    }; /*
 @license
 Shaka Player
 Copyright 2016 Google LLC
 SPDX-License-Identifier: Apache-2.0
*/
    var shaka = { util: {} };
    shaka.util.FakeEvent = function (a, b) {
      b = void 0 === b ? {} : b;
      for (var c in b) Object.defineProperty(this, c, { value: b[c], writable: !0, enumerable: !0 });
      this.defaultPrevented = this.cancelable = this.bubbles = !1;
      this.timeStamp = window.performance && window.performance.now ? window.performance.now() : Date.now();
      this.type = a;
      this.isTrusted = !1;
      this.target = this.currentTarget = null;
      this.stopped = !1;
    };
    shaka.util.FakeEvent.prototype.preventDefault = function () {
      this.cancelable && (this.defaultPrevented = !0);
    };
    shaka.util.FakeEvent.prototype.stopImmediatePropagation = function () {
      this.stopped = !0;
    };
    shaka.util.FakeEvent.prototype.stopPropagation = function () {};
    goog.exportSymbol('shaka.util.FakeEvent', shaka.util.FakeEvent);
    goog.asserts = function () {};
    goog.asserts.assert = function (a, b) {};
    goog.asserts.ENABLE_ASSERTS = !0;
    goog.asserts.ENABLE_ASSERTS &&
      console.assert &&
      console.assert.bind &&
      (goog.asserts.assert = console.assert.bind(console));
    shaka.log = function () {};
    shaka.log.alwaysError = function (a) {};
    shaka.log.alwaysWarn = function (a) {};
    shaka.log.warnOnce = function (a, b) {
      for (var c = [], d = 1; d < arguments.length; ++d) c[d - 1] = arguments[d];
      shaka.log.oneTimeWarningIssued_.has(a) ||
        (shaka.log.oneTimeWarningIssued_.add(a), shaka.log.alwaysWarn.apply(shaka.log, $jscomp.arrayFromIterable(c)));
    };
    shaka.log.error = function (a) {};
    shaka.log.warning = function (a) {};
    shaka.log.info = function (a) {};
    shaka.log.debug = function (a) {};
    shaka.log.v1 = function (a) {};
    shaka.log.v2 = function (a) {};
    shaka.log.Level = { NONE: 0, ERROR: 1, WARNING: 2, INFO: 3, DEBUG: 4, V1: 5, V2: 6 };
    shaka.log.MAX_LOG_LEVEL = 4;
    shaka.log.oneTimeWarningIssued_ = new Set();
    if (window.console && window.console.log.bind) {
      var $jscomp$compprop0 = {};
      shaka.log.logMap_ =
        (($jscomp$compprop0[shaka.log.Level.ERROR] = console.error.bind(console)),
        ($jscomp$compprop0[shaka.log.Level.WARNING] = console.warn.bind(console)),
        ($jscomp$compprop0[shaka.log.Level.INFO] = console.info.bind(console)),
        ($jscomp$compprop0[shaka.log.Level.DEBUG] = console.log.bind(console)),
        ($jscomp$compprop0[shaka.log.Level.V1] = console.debug.bind(console)),
        ($jscomp$compprop0[shaka.log.Level.V2] = console.debug.bind(console)),
        $jscomp$compprop0);
      shaka.log.alwaysWarn = shaka.log.logMap_[shaka.log.Level.WARNING];
      shaka.log.alwaysError = shaka.log.logMap_[shaka.log.Level.ERROR];
      goog.DEBUG
        ? (goog.exportSymbol('shaka.log', shaka.log),
          (shaka.log.setLevel = function (a) {
            var b = function (c) {
              return c <= a
                ? (goog.asserts.assert(shaka.log.logMap_[c], 'Unexpected log level'), shaka.log.logMap_[c])
                : function () {};
            };
            shaka.log.currentLevel = a;
            shaka.log.error = b(shaka.log.Level.ERROR);
            shaka.log.warning = b(shaka.log.Level.WARNING);
            shaka.log.info = b(shaka.log.Level.INFO);
            shaka.log.debug = b(shaka.log.Level.DEBUG);
            shaka.log.v1 = b(shaka.log.Level.V1);
            shaka.log.v2 = b(shaka.log.Level.V2);
          }),
          shaka.log.setLevel(shaka.log.MAX_LOG_LEVEL))
        : (shaka.log.MAX_LOG_LEVEL >= shaka.log.Level.ERROR &&
            (shaka.log.error = shaka.log.logMap_[shaka.log.Level.ERROR]),
          shaka.log.MAX_LOG_LEVEL >= shaka.log.Level.WARNING &&
            (shaka.log.warning = shaka.log.logMap_[shaka.log.Level.WARNING]),
          shaka.log.MAX_LOG_LEVEL >= shaka.log.Level.INFO && (shaka.log.info = shaka.log.logMap_[shaka.log.Level.INFO]),
          shaka.log.MAX_LOG_LEVEL >= shaka.log.Level.DEBUG &&
            (shaka.log.debug = shaka.log.logMap_[shaka.log.Level.DEBUG]),
          shaka.log.MAX_LOG_LEVEL >= shaka.log.Level.V1 && (shaka.log.v1 = shaka.log.logMap_[shaka.log.Level.V1]),
          shaka.log.MAX_LOG_LEVEL >= shaka.log.Level.V2 && (shaka.log.v2 = shaka.log.logMap_[shaka.log.Level.V2]));
    }
    shaka.util.MultiMap = function () {
      this.map_ = {};
    };
    shaka.util.MultiMap.prototype.push = function (a, b) {
      this.map_.hasOwnProperty(a) ? this.map_[a].push(b) : (this.map_[a] = [b]);
    };
    shaka.util.MultiMap.prototype.get = function (a) {
      return (a = this.map_[a]) ? a.slice() : null;
    };
    shaka.util.MultiMap.prototype.getAll = function () {
      var a = [],
        b;
      for (b in this.map_) a.push.apply(a, $jscomp.arrayFromIterable(this.map_[b]));
      return a;
    };
    shaka.util.MultiMap.prototype.remove = function (a, b) {
      a in this.map_ &&
        (this.map_[a] = this.map_[a].filter(function (c) {
          return c != b;
        }));
    };
    shaka.util.MultiMap.prototype.clear = function () {
      this.map_ = {};
    };
    shaka.util.MultiMap.prototype.forEach = function (a) {
      for (var b in this.map_) a(b, this.map_[b]);
    };
    shaka.util.FakeEventTarget = function () {
      this.listeners_ = new shaka.util.MultiMap();
      this.dispatchTarget = this;
    };
    shaka.util.FakeEventTarget.prototype.addEventListener = function (a, b, c) {
      this.listeners_.push(a, b);
    };
    shaka.util.FakeEventTarget.prototype.removeEventListener = function (a, b, c) {
      this.listeners_.remove(a, b);
    };
    shaka.util.FakeEventTarget.prototype.dispatchEvent = function (a) {
      goog.asserts.assert(a instanceof shaka.util.FakeEvent, 'FakeEventTarget can only dispatch FakeEvents!');
      var b = this.listeners_.get(a.type) || [];
      b = $jscomp.makeIterator(b);
      for (var c = b.next(); !c.done; c = b.next()) {
        c = c.value;
        a.target = this.dispatchTarget;
        a.currentTarget = this.dispatchTarget;
        try {
          c.handleEvent ? c.handleEvent(a) : c.call(this, a);
        } catch (d) {
          shaka.log.error('Uncaught exception in event handler', d, d ? d.message : null, d ? d.stack : null);
        }
        if (a.stopped) break;
      }
      return a.defaultPrevented;
    };
    shaka.util.Iterables = function () {};
    shaka.util.Iterables.map = function (a, b) {
      for (var c = [], d = $jscomp.makeIterator(a), e = d.next(); !e.done; e = d.next()) c.push(b(e.value));
      return c;
    };
    shaka.util.Iterables.every = function (a, b) {
      for (var c = $jscomp.makeIterator(a), d = c.next(); !d.done; d = c.next()) if (!b(d.value)) return !1;
      return !0;
    };
    shaka.util.Iterables.some = function (a, b) {
      for (var c = $jscomp.makeIterator(a), d = c.next(); !d.done; d = c.next()) if (b(d.value)) return !0;
      return !1;
    };
    shaka.util.Iterables.filter = function (a, b) {
      for (var c = [], d = $jscomp.makeIterator(a), e = d.next(); !e.done; e = d.next())
        (e = e.value), b(e) && c.push(e);
      return c;
    };
    shaka.util.Iterables.range = function $jscomp$generator$function(a) {
      var c;
      return $jscomp.generator.createGenerator($jscomp$generator$function, function (d) {
        1 == d.nextAddress && (c = 0);
        if (3 != d.nextAddress) return c < a ? d.yield(c, 3) : d.jumpTo(0);
        c++;
        return d.jumpTo(2);
      });
    };
    shaka.util.Iterables.enumerate = function $jscomp$generator$function(a) {
      var c, d, e, f, g, h;
      return $jscomp.generator.createGenerator($jscomp$generator$function, function (k) {
        1 == k.nextAddress && ((c = -1), (e = d = void 0), (f = $jscomp.makeIterator(a)), (g = f.next()));
        if (5 != k.nextAddress) {
          if (g.done) return -1 == c ? k.jumpTo(0) : k.yield({ i: c, prev: d, item: e, next: void 0 }, 0);
          h = g.value;
          return 0 <= c ? k.yield({ i: c, item: e, prev: d, next: h }, 5) : k.jumpTo(5);
        }
        c++;
        d = e;
        e = h;
        g = f.next();
        return k.jumpTo(2);
      });
    }; /*
 @license
 Copyright 2008 The Closure Library Authors
 SPDX-License-Identifier: Apache-2.0
*/
    goog.uri = {};
    goog.uri.utils = {};
    goog.uri.utils.splitRe_ = /^(?:([^:/?#.]+):)?(?:\/\/(?:([^/?#]*)@)?([^/#?]*?)(?::([0-9]+))?(?=[/#?]|$))?([^?#]+)?(?:\?([^#]*))?(?:#(.*))?$/;
    goog.uri.utils.ComponentIndex = {
      SCHEME: 1,
      USER_INFO: 2,
      DOMAIN: 3,
      PORT: 4,
      PATH: 5,
      QUERY_DATA: 6,
      FRAGMENT: 7,
    };
    goog.uri.utils.split = function (a) {
      return a.match(goog.uri.utils.splitRe_);
    }; /*
 @license
 Copyright 2006 The Closure Library Authors
 SPDX-License-Identifier: Apache-2.0
*/
    goog.Uri = function (a) {
      var b;
      a instanceof goog.Uri
        ? (this.setScheme(a.getScheme()),
          this.setUserInfo(a.getUserInfo()),
          this.setDomain(a.getDomain()),
          this.setPort(a.getPort()),
          this.setPath(a.getPath()),
          this.setQueryData(a.getQueryData().clone()),
          this.setFragment(a.getFragment()))
        : a && (b = goog.uri.utils.split(String(a)))
        ? (this.setScheme(b[goog.uri.utils.ComponentIndex.SCHEME] || '', !0),
          this.setUserInfo(b[goog.uri.utils.ComponentIndex.USER_INFO] || '', !0),
          this.setDomain(b[goog.uri.utils.ComponentIndex.DOMAIN] || '', !0),
          this.setPort(b[goog.uri.utils.ComponentIndex.PORT]),
          this.setPath(b[goog.uri.utils.ComponentIndex.PATH] || '', !0),
          this.setQueryData(b[goog.uri.utils.ComponentIndex.QUERY_DATA] || '', !0),
          this.setFragment(b[goog.uri.utils.ComponentIndex.FRAGMENT] || '', !0))
        : (this.queryData_ = new goog.Uri.QueryData(null, null));
    };
    goog.Uri.prototype.scheme_ = '';
    goog.Uri.prototype.userInfo_ = '';
    goog.Uri.prototype.domain_ = '';
    goog.Uri.prototype.port_ = null;
    goog.Uri.prototype.path_ = '';
    goog.Uri.prototype.fragment_ = '';
    goog.Uri.prototype.toString = function () {
      var a = [],
        b = this.getScheme();
      b && a.push(goog.Uri.encodeSpecialChars_(b, goog.Uri.reDisallowedInSchemeOrUserInfo_, !0), ':');
      if ((b = this.getDomain())) {
        a.push('//');
        var c = this.getUserInfo();
        c && a.push(goog.Uri.encodeSpecialChars_(c, goog.Uri.reDisallowedInSchemeOrUserInfo_, !0), '@');
        a.push(goog.Uri.removeDoubleEncoding_(encodeURIComponent(b)));
        b = this.getPort();
        null != b && a.push(':', String(b));
      }
      if ((b = this.getPath()))
        this.hasDomain() && '/' != b.charAt(0) && a.push('/'),
          a.push(
            goog.Uri.encodeSpecialChars_(
              b,
              '/' == b.charAt(0) ? goog.Uri.reDisallowedInAbsolutePath_ : goog.Uri.reDisallowedInRelativePath_,
              !0,
            ),
          );
      (b = this.getEncodedQuery()) && a.push('?', b);
      (b = this.getFragment()) && a.push('#', goog.Uri.encodeSpecialChars_(b, goog.Uri.reDisallowedInFragment_));
      return a.join('');
    };
    goog.Uri.prototype.resolve = function (a) {
      var b = this.clone();
      'data' === b.scheme_ && (b = new goog.Uri());
      var c = a.hasScheme();
      c ? b.setScheme(a.getScheme()) : (c = a.hasUserInfo());
      c ? b.setUserInfo(a.getUserInfo()) : (c = a.hasDomain());
      c ? b.setDomain(a.getDomain()) : (c = a.hasPort());
      var d = a.getPath();
      if (c) b.setPort(a.getPort());
      else if ((c = a.hasPath())) {
        if ('/' != d.charAt(0))
          if (this.hasDomain() && !this.hasPath()) d = '/' + d;
          else {
            var e = b.getPath().lastIndexOf('/');
            -1 != e && (d = b.getPath().substr(0, e + 1) + d);
          }
        d = goog.Uri.removeDotSegments(d);
      }
      c ? b.setPath(d) : (c = a.hasQuery());
      c ? b.setQueryData(a.getQueryData().clone()) : (c = a.hasFragment());
      c && b.setFragment(a.getFragment());
      return b;
    };
    goog.Uri.prototype.clone = function () {
      return new goog.Uri(this);
    };
    goog.Uri.prototype.getScheme = function () {
      return this.scheme_;
    };
    goog.Uri.prototype.setScheme = function (a, b) {
      if ((this.scheme_ = b ? goog.Uri.decodeOrEmpty_(a, !0) : a)) this.scheme_ = this.scheme_.replace(/:$/, '');
      return this;
    };
    goog.Uri.prototype.hasScheme = function () {
      return !!this.scheme_;
    };
    goog.Uri.prototype.getUserInfo = function () {
      return this.userInfo_;
    };
    goog.Uri.prototype.setUserInfo = function (a, b) {
      this.userInfo_ = b ? goog.Uri.decodeOrEmpty_(a) : a;
      return this;
    };
    goog.Uri.prototype.hasUserInfo = function () {
      return !!this.userInfo_;
    };
    goog.Uri.prototype.getDomain = function () {
      return this.domain_;
    };
    goog.Uri.prototype.setDomain = function (a, b) {
      this.domain_ = b ? goog.Uri.decodeOrEmpty_(a, !0) : a;
      return this;
    };
    goog.Uri.prototype.hasDomain = function () {
      return !!this.domain_;
    };
    goog.Uri.prototype.getPort = function () {
      return this.port_;
    };
    goog.Uri.prototype.setPort = function (a) {
      if (a) {
        a = Number(a);
        if (isNaN(a) || 0 > a) throw Error('Bad port number ' + a);
        this.port_ = a;
      } else this.port_ = null;
      return this;
    };
    goog.Uri.prototype.hasPort = function () {
      return null != this.port_;
    };
    goog.Uri.prototype.getPath = function () {
      return this.path_;
    };
    goog.Uri.prototype.setPath = function (a, b) {
      this.path_ = b ? goog.Uri.decodeOrEmpty_(a, !0) : a;
      return this;
    };
    goog.Uri.prototype.hasPath = function () {
      return !!this.path_;
    };
    goog.Uri.prototype.hasQuery = function () {
      return '' !== this.queryData_.toString();
    };
    goog.Uri.prototype.setQueryData = function (a, b) {
      a instanceof goog.Uri.QueryData
        ? (this.queryData_ = a)
        : (b || (a = goog.Uri.encodeSpecialChars_(a, goog.Uri.reDisallowedInQuery_)),
          (this.queryData_ = new goog.Uri.QueryData(a, null)));
      return this;
    };
    goog.Uri.prototype.getEncodedQuery = function () {
      return this.queryData_.toString();
    };
    goog.Uri.prototype.getDecodedQuery = function () {
      return this.queryData_.toDecodedString();
    };
    goog.Uri.prototype.getQueryData = function () {
      return this.queryData_;
    };
    goog.Uri.prototype.getFragment = function () {
      return this.fragment_;
    };
    goog.Uri.prototype.setFragment = function (a, b) {
      this.fragment_ = b ? goog.Uri.decodeOrEmpty_(a) : a;
      return this;
    };
    goog.Uri.prototype.hasFragment = function () {
      return !!this.fragment_;
    };
    goog.Uri.removeDotSegments = function (a) {
      if ('..' == a || '.' == a) return '';
      if (-1 == a.indexOf('./') && -1 == a.indexOf('/.')) return a;
      var b = 0 == a.lastIndexOf('/', 0);
      a = a.split('/');
      for (var c = [], d = 0; d < a.length; ) {
        var e = a[d++];
        '.' == e
          ? b && d == a.length && c.push('')
          : '..' == e
          ? ((1 < c.length || (1 == c.length && '' != c[0])) && c.pop(), b && d == a.length && c.push(''))
          : (c.push(e), (b = !0));
      }
      return c.join('/');
    };
    goog.Uri.decodeOrEmpty_ = function (a, b) {
      return a ? (b ? decodeURI(a) : decodeURIComponent(a)) : '';
    };
    goog.Uri.encodeSpecialChars_ = function (a, b, c) {
      return null != a
        ? ((a = encodeURI(a).replace(b, goog.Uri.encodeChar_)), c && (a = goog.Uri.removeDoubleEncoding_(a)), a)
        : null;
    };
    goog.Uri.encodeChar_ = function (a) {
      a = a.charCodeAt(0);
      return '%' + ((a >> 4) & 15).toString(16) + (a & 15).toString(16);
    };
    goog.Uri.removeDoubleEncoding_ = function (a) {
      return a.replace(/%25([0-9a-fA-F]{2})/g, '%$1');
    };
    goog.Uri.reDisallowedInSchemeOrUserInfo_ = /[#\/\?@]/g;
    goog.Uri.reDisallowedInRelativePath_ = /[#\?:]/g;
    goog.Uri.reDisallowedInAbsolutePath_ = /[#\?]/g;
    goog.Uri.reDisallowedInQuery_ = /[#\?@]/g;
    goog.Uri.reDisallowedInFragment_ = /#/g;
    goog.Uri.QueryData = function (a, b) {
      this.encodedQuery_ = a || null;
    };
    goog.Uri.QueryData.prototype.ensureKeyMapInitialized_ = function () {
      if (!this.keyMap_ && ((this.keyMap_ = {}), (this.count_ = 0), this.encodedQuery_))
        for (var a = this.encodedQuery_.split('&'), b = 0; b < a.length; b++) {
          var c = a[b].indexOf('='),
            d = null;
          if (0 <= c) {
            var e = a[b].substring(0, c);
            d = a[b].substring(c + 1);
          } else e = a[b];
          e = decodeURIComponent(e.replace(/\+/g, ' '));
          d = d || '';
          this.add(e, decodeURIComponent(d.replace(/\+/g, ' ')));
        }
    };
    goog.Uri.QueryData.prototype.keyMap_ = null;
    goog.Uri.QueryData.prototype.count_ = null;
    goog.Uri.QueryData.prototype.getCount = function () {
      this.ensureKeyMapInitialized_();
      return this.count_;
    };
    goog.Uri.QueryData.prototype.add = function (a, b) {
      this.ensureKeyMapInitialized_();
      this.encodedQuery_ = null;
      var c = this.keyMap_.hasOwnProperty(a) && this.keyMap_[a];
      c || (this.keyMap_[a] = c = []);
      c.push(b);
      goog.asserts.assert(null != this.count_, 'Should not be null.');
      this.count_++;
      return this;
    };
    goog.Uri.QueryData.prototype.toString = function () {
      if (this.encodedQuery_) return this.encodedQuery_;
      if (!this.keyMap_) return '';
      var a = [],
        b;
      for (b in this.keyMap_)
        for (var c = encodeURIComponent(b), d = this.keyMap_[b], e = 0; e < d.length; e++) {
          var f = c;
          '' !== d[e] && (f += '=' + encodeURIComponent(d[e]));
          a.push(f);
        }
      return (this.encodedQuery_ = a.join('&'));
    };
    goog.Uri.QueryData.prototype.toDecodedString = function () {
      return goog.Uri.decodeOrEmpty_(this.toString());
    };
    goog.Uri.QueryData.prototype.clone = function () {
      var a = new goog.Uri.QueryData();
      a.encodedQuery_ = this.encodedQuery_;
      if (this.keyMap_) {
        var b = {},
          c;
        for (c in this.keyMap_) b[c] = this.keyMap_[c].concat();
        a.keyMap_ = b;
        a.count_ = this.count_;
      }
      return a;
    };
    shaka.deprecate = {};
    shaka.deprecate.Version = function (a, b) {
      this.major_ = a;
      this.minor_ = b;
    };
    shaka.deprecate.Version.prototype.major = function () {
      return this.major_;
    };
    shaka.deprecate.Version.prototype.minor = function () {
      return this.minor_;
    };
    shaka.deprecate.Version.prototype.compareTo = function (a) {
      var b = this.minor_ - a.minor_;
      return this.major_ - a.major_ || b;
    };
    shaka.deprecate.Version.prototype.toString = function () {
      return 'v' + this.major_ + '.' + this.minor_;
    };
    shaka.deprecate.Version.parse = function (a) {
      a = a.substring(1).split('.', 2);
      return new shaka.deprecate.Version(Number(a[0]), Number(a[1]));
    };
    shaka.deprecate.Enforcer = function (a, b, c) {
      this.libraryVersion_ = a;
      this.onPending_ = b;
      this.onExpired_ = c;
    };
    shaka.deprecate.Enforcer.prototype.enforce = function (a, b, c) {
      (0 < a.compareTo(this.libraryVersion_) ? this.onPending_ : this.onExpired_)(this.libraryVersion_, a, b, c);
    };
    shaka.Deprecate = function () {};
    shaka.Deprecate.init = function (a) {
      goog.asserts.assert(null == shaka.Deprecate.enforcer_, 'Deprecate.init should only be called once.');
      shaka.Deprecate.enforcer_ = new shaka.deprecate.Enforcer(
        shaka.deprecate.Version.parse(a),
        shaka.Deprecate.onPending_,
        shaka.Deprecate.onExpired_,
      );
    };
    shaka.Deprecate.deprecateFeature = function (a, b, c) {
      var d = shaka.Deprecate.enforcer_;
      goog.asserts.assert(d, 'Missing deprecation enforcer. Was |init| called?');
      a = new shaka.deprecate.Version(a, 0);
      d.enforce(a, b, c);
    };
    shaka.Deprecate.onPending_ = function (a, b, c, d) {
      shaka.log.alwaysWarn(
        [
          c,
          'has been deprecated and will be removed in',
          b,
          '. We are currently at version',
          a,
          '. Additional information:',
          d,
        ].join(' '),
      );
    };
    shaka.Deprecate.onExpired_ = function (a, b, c, d) {
      a = [
        c,
        'has been deprecated and has been removed in',
        b,
        '. We are now at version',
        a,
        '. Additional information:',
        d,
      ].join('');
      shaka.log.alwaysError(a);
      goog.asserts.assert(!1, a);
    };
    shaka.Deprecate.enforcer_ = null;
    shaka.util.Functional = function () {};
    shaka.util.Functional.createFallbackPromiseChain = function (a, b) {
      return a.reduce(function (c, d) {
        return c['catch'](function () {
          return b(d);
        });
      }, Promise.reject());
    };
    shaka.util.Functional.collapseArrays = function (a, b) {
      return a.concat(b);
    };
    shaka.util.Functional.ignored = function (a) {};
    shaka.util.Functional.noop = function () {};
    shaka.util.Functional.isNotNull = function (a) {
      return null != a;
    };
    shaka.util.Functional.callFactory = function (a) {
      var b = Object.create(a.prototype || Object.prototype);
      try {
        var c = a.call(b);
        c ||
          (shaka.Deprecate.deprecateFeature(4, 'Factories requiring new', 'Factories should be plain functions'),
          (c = b));
      } catch (d) {
        shaka.Deprecate.deprecateFeature(4, 'Factories requiring new', 'Factories should be plain functions'),
          (c = new a());
      }
      return c;
    };
    shaka.util.ManifestParserUtils = function () {};
    shaka.util.ManifestParserUtils.resolveUris = function (a, b) {
      var c = shaka.util.Functional;
      if (0 == b.length) return a;
      var d = b.map(function (e) {
        return new goog.Uri(e);
      });
      return a
        .map(function (e) {
          return new goog.Uri(e);
        })
        .map(function (e) {
          return d.map(function (f) {
            return e.resolve(f);
          });
        })
        .reduce(c.collapseArrays, [])
        .map(function (e) {
          return e.toString();
        });
    };
    shaka.util.ManifestParserUtils.createDrmInfo = function (a, b) {
      return {
        keySystem: a,
        licenseServerUri: '',
        distinctiveIdentifierRequired: !1,
        persistentStateRequired: !1,
        audioRobustness: '',
        videoRobustness: '',
        serverCertificate: null,
        initData: b || [],
        keyIds: new Set(),
      };
    };
    shaka.util.ManifestParserUtils.ContentType = {
      VIDEO: 'video',
      AUDIO: 'audio',
      TEXT: 'text',
      IMAGE: 'image',
      APPLICATION: 'application',
    };
    shaka.util.ManifestParserUtils.TextStreamKind = { SUBTITLE: 'subtitle', CLOSED_CAPTION: 'caption' };
    shaka.util.ManifestParserUtils.GAP_OVERLAP_TOLERANCE_SECONDS = 1 / 15;
    shaka.util.LanguageUtils = function () {};
    shaka.util.LanguageUtils.areLocaleCompatible = function (a, b) {
      var c = shaka.util.LanguageUtils;
      a = c.normalize(a);
      b = c.normalize(b);
      return a == b;
    };
    shaka.util.LanguageUtils.areLanguageCompatible = function (a, b) {
      var c = shaka.util.LanguageUtils;
      a = c.normalize(a);
      b = c.normalize(b);
      var d = c.disassembleLocale_(a);
      c = c.disassembleLocale_(b);
      return d[0] == c[0];
    };
    shaka.util.LanguageUtils.isParentOf = function (a, b) {
      var c = shaka.util.LanguageUtils;
      a = c.normalize(a);
      b = c.normalize(b);
      var d = c.disassembleLocale_(a);
      c = c.disassembleLocale_(b);
      return d[0] == c[0] && 1 == d.length && 2 == c.length;
    };
    shaka.util.LanguageUtils.isSiblingOf = function (a, b) {
      var c = shaka.util.LanguageUtils;
      a = c.normalize(a);
      b = c.normalize(b);
      var d = c.disassembleLocale_(a);
      c = c.disassembleLocale_(b);
      return 2 == d.length && 2 == c.length && d[0] == c[0];
    };
    shaka.util.LanguageUtils.normalize = function (a) {
      var b = shaka.util.LanguageUtils,
        c = a.split('-');
      a = c[0] || '';
      c = c[1] || '';
      a = a.toLowerCase();
      a = b.isoMap_.get(a) || a;
      return (c = c.toUpperCase()) ? a + '-' + c : a;
    };
    shaka.util.LanguageUtils.areSiblings = function (a, b) {
      var c = shaka.util.LanguageUtils,
        d = c.getBase(a);
      c = c.getBase(b);
      return a != d && b != c && d == c;
    };
    shaka.util.LanguageUtils.relatedness = function (a, b) {
      var c = shaka.util.LanguageUtils;
      a = c.normalize(a);
      b = c.normalize(b);
      return b == a ? 4 : c.isParentOf(b, a) ? 3 : c.isSiblingOf(b, a) ? 2 : c.isParentOf(a, b) ? 1 : 0;
    };
    shaka.util.LanguageUtils.getBase = function (a) {
      var b = shaka.util.LanguageUtils,
        c = a.indexOf('-');
      a = 0 <= c ? a.substring(0, c) : a;
      a = a.toLowerCase();
      return (a = b.isoMap_.get(a) || a);
    };
    shaka.util.LanguageUtils.getLocaleForText = function (a) {
      var b = shaka.util.LanguageUtils;
      goog.asserts.assert(
        a.type == shaka.util.ManifestParserUtils.ContentType.TEXT,
        'Can only get language from text streams',
      );
      return b.normalize(a.language || 'und');
    };
    shaka.util.LanguageUtils.getLocaleForVariant = function (a) {
      var b = shaka.util.LanguageUtils;
      return a.language
        ? b.normalize(a.language)
        : a.audio && a.audio.language
        ? b.normalize(a.audio.language)
        : a.video && a.video.language
        ? b.normalize(a.video.language)
        : 'und';
    };
    shaka.util.LanguageUtils.findClosestLocale = function (a, b) {
      for (
        var c = shaka.util.LanguageUtils, d = c.normalize(a), e = new Set(), f = $jscomp.makeIterator(b), g = f.next();
        !g.done;
        g = f.next()
      )
        e.add(c.normalize(g.value));
      f = $jscomp.makeIterator(e);
      for (g = f.next(); !g.done; g = f.next()) if (((g = g.value), g == d)) return g;
      f = $jscomp.makeIterator(e);
      for (g = f.next(); !g.done; g = f.next()) if (((g = g.value), c.isParentOf(g, d))) return g;
      f = $jscomp.makeIterator(e);
      for (g = f.next(); !g.done; g = f.next()) if (((g = g.value), c.isSiblingOf(g, d))) return g;
      e = $jscomp.makeIterator(e);
      for (g = e.next(); !g.done; g = e.next()) if (((g = g.value), c.isParentOf(d, g))) return g;
      return null;
    };
    shaka.util.LanguageUtils.disassembleLocale_ = function (a) {
      var b = a.split('-');
      goog.asserts.assert(
        2 >= b.length,
        ['Locales should not have more than 2 components. ', a, ' has too many components.'].join(),
      );
      return b;
    };
    shaka.util.LanguageUtils.isoMap_ = new Map([
      ['aar', 'aa'],
      ['abk', 'ab'],
      ['afr', 'af'],
      ['aka', 'ak'],
      ['alb', 'sq'],
      ['amh', 'am'],
      ['ara', 'ar'],
      ['arg', 'an'],
      ['arm', 'hy'],
      ['asm', 'as'],
      ['ava', 'av'],
      ['ave', 'ae'],
      ['aym', 'ay'],
      ['aze', 'az'],
      ['bak', 'ba'],
      ['bam', 'bm'],
      ['baq', 'eu'],
      ['bel', 'be'],
      ['ben', 'bn'],
      ['bih', 'bh'],
      ['bis', 'bi'],
      ['bod', 'bo'],
      ['bos', 'bs'],
      ['bre', 'br'],
      ['bul', 'bg'],
      ['bur', 'my'],
      ['cat', 'ca'],
      ['ces', 'cs'],
      ['cha', 'ch'],
      ['che', 'ce'],
      ['chi', 'zh'],
      ['chu', 'cu'],
      ['chv', 'cv'],
      ['cor', 'kw'],
      ['cos', 'co'],
      ['cre', 'cr'],
      ['cym', 'cy'],
      ['cze', 'cs'],
      ['dan', 'da'],
      ['deu', 'de'],
      ['div', 'dv'],
      ['dut', 'nl'],
      ['dzo', 'dz'],
      ['ell', 'el'],
      ['eng', 'en'],
      ['epo', 'eo'],
      ['est', 'et'],
      ['eus', 'eu'],
      ['ewe', 'ee'],
      ['fao', 'fo'],
      ['fas', 'fa'],
      ['fij', 'fj'],
      ['fin', 'fi'],
      ['fra', 'fr'],
      ['fre', 'fr'],
      ['fry', 'fy'],
      ['ful', 'ff'],
      ['geo', 'ka'],
      ['ger', 'de'],
      ['gla', 'gd'],
      ['gle', 'ga'],
      ['glg', 'gl'],
      ['glv', 'gv'],
      ['gre', 'el'],
      ['grn', 'gn'],
      ['guj', 'gu'],
      ['hat', 'ht'],
      ['hau', 'ha'],
      ['heb', 'he'],
      ['her', 'hz'],
      ['hin', 'hi'],
      ['hmo', 'ho'],
      ['hrv', 'hr'],
      ['hun', 'hu'],
      ['hye', 'hy'],
      ['ibo', 'ig'],
      ['ice', 'is'],
      ['ido', 'io'],
      ['iii', 'ii'],
      ['iku', 'iu'],
      ['ile', 'ie'],
      ['ina', 'ia'],
      ['ind', 'id'],
      ['ipk', 'ik'],
      ['isl', 'is'],
      ['ita', 'it'],
      ['jav', 'jv'],
      ['jpn', 'ja'],
      ['kal', 'kl'],
      ['kan', 'kn'],
      ['kas', 'ks'],
      ['kat', 'ka'],
      ['kau', 'kr'],
      ['kaz', 'kk'],
      ['khm', 'km'],
      ['kik', 'ki'],
      ['kin', 'rw'],
      ['kir', 'ky'],
      ['kom', 'kv'],
      ['kon', 'kg'],
      ['kor', 'ko'],
      ['kua', 'kj'],
      ['kur', 'ku'],
      ['lao', 'lo'],
      ['lat', 'la'],
      ['lav', 'lv'],
      ['lim', 'li'],
      ['lin', 'ln'],
      ['lit', 'lt'],
      ['ltz', 'lb'],
      ['lub', 'lu'],
      ['lug', 'lg'],
      ['mac', 'mk'],
      ['mah', 'mh'],
      ['mal', 'ml'],
      ['mao', 'mi'],
      ['mar', 'mr'],
      ['may', 'ms'],
      ['mkd', 'mk'],
      ['mlg', 'mg'],
      ['mlt', 'mt'],
      ['mon', 'mn'],
      ['mri', 'mi'],
      ['msa', 'ms'],
      ['mya', 'my'],
      ['nau', 'na'],
      ['nav', 'nv'],
      ['nbl', 'nr'],
      ['nde', 'nd'],
      ['ndo', 'ng'],
      ['nep', 'ne'],
      ['nld', 'nl'],
      ['nno', 'nn'],
      ['nob', 'nb'],
      ['nor', 'no'],
      ['nya', 'ny'],
      ['oci', 'oc'],
      ['oji', 'oj'],
      ['ori', 'or'],
      ['orm', 'om'],
      ['oss', 'os'],
      ['pan', 'pa'],
      ['per', 'fa'],
      ['pli', 'pi'],
      ['pol', 'pl'],
      ['por', 'pt'],
      ['pus', 'ps'],
      ['que', 'qu'],
      ['roh', 'rm'],
      ['ron', 'ro'],
      ['rum', 'ro'],
      ['run', 'rn'],
      ['rus', 'ru'],
      ['sag', 'sg'],
      ['san', 'sa'],
      ['sin', 'si'],
      ['slk', 'sk'],
      ['slo', 'sk'],
      ['slv', 'sl'],
      ['sme', 'se'],
      ['smo', 'sm'],
      ['sna', 'sn'],
      ['snd', 'sd'],
      ['som', 'so'],
      ['sot', 'st'],
      ['spa', 'es'],
      ['sqi', 'sq'],
      ['srd', 'sc'],
      ['srp', 'sr'],
      ['ssw', 'ss'],
      ['sun', 'su'],
      ['swa', 'sw'],
      ['swe', 'sv'],
      ['tah', 'ty'],
      ['tam', 'ta'],
      ['tat', 'tt'],
      ['tel', 'te'],
      ['tgk', 'tg'],
      ['tgl', 'tl'],
      ['tha', 'th'],
      ['tib', 'bo'],
      ['tir', 'ti'],
      ['ton', 'to'],
      ['tsn', 'tn'],
      ['tso', 'ts'],
      ['tuk', 'tk'],
      ['tur', 'tr'],
      ['twi', 'tw'],
      ['uig', 'ug'],
      ['ukr', 'uk'],
      ['urd', 'ur'],
      ['uzb', 'uz'],
      ['ven', 've'],
      ['vie', 'vi'],
      ['vol', 'vo'],
      ['wel', 'cy'],
      ['wln', 'wa'],
      ['wol', 'wo'],
      ['xho', 'xh'],
      ['yid', 'yi'],
      ['yor', 'yo'],
      ['zha', 'za'],
      ['zho', 'zh'],
      ['zul', 'zu'],
    ]);
    shaka.ui = {};
    shaka.ui.Localization = function (a) {
      this.fallbackLocale_ = shaka.util.LanguageUtils.normalize(a);
      this.currentMap_ = new Map();
      this.currentLocales_ = new Set();
      this.localizations_ = new Map();
      this.events_ = new shaka.util.FakeEventTarget();
    };
    shaka.ui.Localization.prototype.addEventListener = function (a, b, c) {
      this.events_.addEventListener(a, b, c);
    };
    shaka.ui.Localization.prototype.removeEventListener = function (a, b, c) {
      this.events_.removeEventListener(a, b, c || void 0);
    };
    shaka.ui.Localization.prototype.dispatchEvent = function (a) {
      return this.events_.dispatchEvent(a);
    };
    shaka.ui.Localization.prototype.changeLocale = function (a) {
      var b = this,
        c = shaka.ui.Localization;
      this.currentLocales_.clear();
      a = $jscomp.makeIterator(a);
      for (var d = a.next(); !d.done; d = a.next())
        this.currentLocales_.add(shaka.util.LanguageUtils.normalize(d.value));
      this.updateCurrentMap_();
      a = shaka.util.Iterables.filter(this.currentLocales_, function (e) {
        return !b.localizations_.has(e);
      });
      a.length && this.events_.dispatchEvent(new shaka.util.FakeEvent(c.UNKNOWN_LOCALES, { locales: a }));
      a = shaka.util.Iterables.filter(this.currentLocales_, function (e) {
        return b.localizations_.has(e);
      });
      this.events_.dispatchEvent(
        new shaka.util.FakeEvent(c.LOCALE_CHANGED, { locales: a.length ? a : [this.fallbackLocale_] }),
      );
    };
    shaka.ui.Localization.prototype.insert = function (a, b, c) {
      var d = shaka.ui.Localization,
        e = shaka.ui.Localization.ConflictResolution,
        f = shaka.util.FakeEvent;
      a = shaka.util.LanguageUtils.normalize(a);
      void 0 === c && (c = e.USE_NEW);
      var g = this.localizations_.get(a) || new Map();
      b.forEach(function (h, k) {
        (g.has(k) && c != e.USE_NEW) || g.set(k, h);
      });
      this.localizations_.set(a, g);
      this.updateCurrentMap_();
      this.events_.dispatchEvent(new f(d.LOCALE_UPDATED));
      return this;
    };
    shaka.ui.Localization.prototype.resolveDictionary = function (a) {
      for (var b = $jscomp.makeIterator(a.keys()), c = b.next(); !c.done; c = b.next())
        (c = c.value), a.set(c, this.resolve(c));
    };
    shaka.ui.Localization.prototype.resolve = function (a) {
      var b = shaka.ui.Localization,
        c = shaka.util.FakeEvent,
        d = this.currentMap_.get(a);
      if (d) return d;
      a = { locales: Array.from(this.currentLocales_), missing: a };
      this.events_.dispatchEvent(new c(b.UNKNOWN_LOCALIZATION, a));
      return '';
    };
    shaka.ui.Localization.prototype.updateCurrentMap_ = function () {
      for (
        var a = this,
          b = shaka.util.LanguageUtils,
          c = this.localizations_,
          d = this.fallbackLocale_,
          e = this.currentLocales_,
          f = new Set(),
          g = {},
          h = $jscomp.makeIterator(e),
          k = h.next();
        !k.done;
        g = { $jscomp$loop$prop$locale$511: g.$jscomp$loop$prop$locale$511 }, k = h.next()
      ) {
        g.$jscomp$loop$prop$locale$511 = k.value;
        f.add(g.$jscomp$loop$prop$locale$511);
        f.add(b.getBase(g.$jscomp$loop$prop$locale$511));
        k = shaka.util.Iterables.filter(
          c.keys(),
          (function (m) {
            return function (n) {
              return b.areSiblings(n, m.$jscomp$loop$prop$locale$511);
            };
          })(g),
        );
        k.sort();
        var l = $jscomp.makeIterator(k);
        for (k = l.next(); !k.done; k = l.next()) f.add(k.value);
        k = shaka.util.Iterables.filter(
          c.keys(),
          (function (m) {
            return function (n) {
              return b.getBase(n) == m.$jscomp$loop$prop$locale$511;
            };
          })(g),
        );
        k.sort();
        l = $jscomp.makeIterator(k);
        for (k = l.next(); !k.done; k = l.next()) f.add(k.value);
      }
      f.add(d);
      d = [];
      f = $jscomp.makeIterator(f);
      for (k = f.next(); !k.done; k = f.next()) (k = c.get(k.value)) && d.push(k);
      d.reverse();
      this.currentMap_.clear();
      c = $jscomp.makeIterator(d);
      for (k = c.next(); !k.done; k = c.next())
        k.value.forEach(function (m, n) {
          a.currentMap_.set(n, m);
        });
      c = this.currentMap_.keys();
      f = new Set();
      d = $jscomp.makeIterator(this.currentLocales_);
      for (k = d.next(); !k.done; k = d.next())
        (k = this.localizations_.get(k.value) || new Map()), shaka.ui.Localization.findMissingKeys_(k, c, f);
      0 < f.size &&
        ((e = { locales: Array.from(e), missing: Array.from(f) }),
        this.events_.dispatchEvent(new shaka.util.FakeEvent(shaka.ui.Localization.MISSING_LOCALIZATIONS, e)));
    };
    shaka.ui.Localization.findMissingKeys_ = function (a, b, c) {
      b = $jscomp.makeIterator(b);
      for (var d = b.next(); !d.done; d = b.next()) (d = d.value), a.get(d) || c.add(d);
    };
    goog.exportSymbol('shaka.ui.Localization', shaka.ui.Localization);
    goog.exportProperty(shaka.ui.Localization.prototype, 'resolve', shaka.ui.Localization.prototype.resolve);
    goog.exportProperty(
      shaka.ui.Localization.prototype,
      'resolveDictionary',
      shaka.ui.Localization.prototype.resolveDictionary,
    );
    goog.exportProperty(shaka.ui.Localization.prototype, 'insert', shaka.ui.Localization.prototype.insert);
    goog.exportProperty(shaka.ui.Localization.prototype, 'changeLocale', shaka.ui.Localization.prototype.changeLocale);
    goog.exportProperty(
      shaka.ui.Localization.prototype,
      'dispatchEvent',
      shaka.ui.Localization.prototype.dispatchEvent,
    );
    goog.exportProperty(
      shaka.ui.Localization.prototype,
      'removeEventListener',
      shaka.ui.Localization.prototype.removeEventListener,
    );
    goog.exportProperty(
      shaka.ui.Localization.prototype,
      'addEventListener',
      shaka.ui.Localization.prototype.addEventListener,
    );
    shaka.ui.Localization.ConflictResolution = { USE_OLD: 0, USE_NEW: 1 };
    goog.exportProperty(shaka.ui.Localization, 'ConflictResolution', shaka.ui.Localization.ConflictResolution);
    shaka.ui.Localization.UNKNOWN_LOCALES = 'unknown-locales';
    goog.exportProperty(shaka.ui.Localization, 'UNKNOWN_LOCALES', shaka.ui.Localization.UNKNOWN_LOCALES);
    shaka.ui.Localization.UNKNOWN_LOCALIZATION = 'unknown-localization';
    goog.exportProperty(shaka.ui.Localization, 'UNKNOWN_LOCALIZATION', shaka.ui.Localization.UNKNOWN_LOCALIZATION);
    shaka.ui.Localization.MISSING_LOCALIZATIONS = 'missing-localizations';
    goog.exportProperty(shaka.ui.Localization, 'MISSING_LOCALIZATIONS', shaka.ui.Localization.MISSING_LOCALIZATIONS);
    shaka.ui.Localization.LOCALE_CHANGED = 'locale-changed';
    goog.exportProperty(shaka.ui.Localization, 'LOCALE_CHANGED', shaka.ui.Localization.LOCALE_CHANGED);
    shaka.ui.Localization.LOCALE_UPDATED = 'locale-updated';
    goog.exportProperty(shaka.ui.Localization, 'LOCALE_UPDATED', shaka.ui.Localization.LOCALE_UPDATED);
    shaka.ui.Locales = {};
    shaka.ui.Locales.addTo = function (a) {
      a.insert(
        'ar',
        new Map([
          ['AD_DURATION', '\u0645\u062f\u0629 \u0627\u0644\u0625\u0639\u0644\u0627\u0646'],
          ['AD_PROGRESS', '\u0627\u0644\u0625\u0639\u0644\u0627\u0646 [AD_ON] \u0645\u0646 [NUM_ADS]'],
          ['AD_TIME', '\u0627\u0644\u0625\u0639\u0644\u0627\u0646: [AD_TIME]'],
          ['AUTO_QUALITY', '\u062a\u0644\u0642\u0627\u0626\u064a'],
          ['BACK', '\u0631\u062c\u0648\u0639'],
          ['CAPTIONS', '\u0627\u0644\u062a\u0631\u062c\u0645\u0629 \u0648\u0627\u0644\u0634\u0631\u062d'],
          ['CAST', '\u0625\u0631\u0633\u0627\u0644...'],
          [
            'ENTER_LOOP_MODE',
            '\u062a\u0643\u0631\u0627\u0631 \u0627\u0644\u0641\u064a\u062f\u064a\u0648 \u0627\u0644\u062d\u0627\u0644\u064a',
          ],
          [
            'ENTER_PICTURE_IN_PICTURE',
            '\u0627\u0644\u062f\u062e\u0648\u0644 \u0641\u064a \u0648\u0636\u0639 "\u0646\u0627\u0641\u0630\u0629 \u0636\u0645\u0646 \u0646\u0627\u0641\u0630\u0629"',
          ],
          [
            'EXIT_FULL_SCREEN',
            '\u0625\u0646\u0647\u0627\u0621 \u0648\u0636\u0639 \u0645\u0644\u0621 \u0627\u0644\u0634\u0627\u0634\u0629',
          ],
          [
            'EXIT_LOOP_MODE',
            '\u0625\u064a\u0642\u0627\u0641 \u062a\u0643\u0631\u0627\u0631 \u0627\u0644\u0641\u064a\u062f\u064a\u0648 \u0627\u0644\u062d\u0627\u0644\u064a',
          ],
          [
            'EXIT_PICTURE_IN_PICTURE',
            '\u0627\u0644\u062e\u0631\u0648\u062c \u0645\u0646 \u0648\u0636\u0639 "\u0646\u0627\u0641\u0630\u0629 \u0636\u0645\u0646 \u0646\u0627\u0641\u0630\u0629"',
          ],
          ['FAST_FORWARD', '\u062a\u0642\u062f\u064a\u0645 \u0633\u0631\u064a\u0639'],
          ['FULL_SCREEN', '\u0645\u0644\u0621 \u0627\u0644\u0634\u0627\u0634\u0629'],
          ['LANGUAGE', '\u0627\u0644\u0644\u063a\u0629'],
          ['LIVE', '\u0645\u0628\u0627\u0634\u0631'],
          ['LOOP', '\u062a\u0643\u0631\u0627\u0631'],
          [
            'MORE_SETTINGS',
            '\u0645\u0632\u064a\u062f \u0645\u0646 \u0627\u0644\u0625\u0639\u062f\u0627\u062f\u0627\u062a',
          ],
          ['MULTIPLE_LANGUAGES', '\u0644\u063a\u0627\u062a \u0645\u062a\u0639\u062f\u062f\u0629'],
          ['MUTE', '\u0643\u062a\u0645 \u0627\u0644\u0635\u0648\u062a'],
          ['NOT_APPLICABLE', '\u063a\u064a\u0631 \u0633\u0627\u0631\u064d'],
          ['OFF', '\u0625\u064a\u0642\u0627\u0641'],
          ['ON', '\u062a\u0634\u063a\u064a\u0644'],
          ['PAUSE', '\u0625\u064a\u0642\u0627\u0641 \u0645\u0624\u0642\u062a'],
          [
            'PICTURE_IN_PICTURE',
            '\u0646\u0627\u0641\u0630\u0629 \u0636\u0645\u0646 \u0627\u0644\u0646\u0627\u0641\u0630\u0629',
          ],
          ['PLAY', '\u0627\u0644\u062a\u0634\u063a\u064a\u0644'],
          ['PLAYBACK_RATE', '\u0633\u0631\u0639\u0629 \u0627\u0644\u062a\u0634\u063a\u064a\u0644'],
          ['RESOLUTION', '\u062f\u0631\u062c\u0629 \u0627\u0644\u062f\u0642\u0629'],
          ['REWIND', '\u062a\u0631\u062c\u064a\u0639'],
          ['SEEK', '\u0627\u0644\u0628\u062d\u062b \u0628\u0627\u0644\u062a\u0645\u0631\u064a\u0631'],
          ['SKIP_AD', '\u062a\u062e\u0637\u0651\u064a \u0627\u0644\u0625\u0639\u0644\u0627\u0646'],
          [
            'SKIP_TO_LIVE',
            '\u0627\u0644\u0627\u0646\u062a\u0642\u0627\u0644 \u0625\u0644\u0649 \u0628\u062b \u0645\u0628\u0627\u0634\u0631',
          ],
          ['UNDETERMINED_LANGUAGE', '\u063a\u064a\u0631 \u0645\u062d\u062f\u062f'],
          ['UNMUTE', '\u0625\u0639\u0627\u062f\u0629 \u0627\u0644\u0635\u0648\u062a'],
          ['UNRECOGNIZED_LANGUAGE', '\u063a\u064a\u0631 \u0645\u0639\u0631\u0648\u0641'],
          ['VOLUME', '\u0645\u0633\u062a\u0648\u0649 \u0627\u0644\u0635\u0648\u062a'],
        ]),
      );
      a.insert(
        'de',
        new Map([
          ['AD_DURATION', 'Dauer der Werbeanzeige'],
          ['AD_PROGRESS', 'Werbung\u00a0[AD_ON] von\u00a0[NUM_ADS]'],
          ['AD_TIME', 'Werbeanzeige: [AD_TIME]'],
          ['AUTO_QUALITY', 'Automatisch'],
          ['BACK', 'Zur\u00fcck'],
          ['CAPTIONS', 'Untertitel'],
          ['CAST', 'Streamen...'],
          ['ENTER_LOOP_MODE', 'In Endlosschleife spielen'],
          ['ENTER_PICTURE_IN_PICTURE', 'Bild-im-Bild-Modus aktivieren'],
          ['EXIT_FULL_SCREEN', 'Vollbildmodus beenden'],
          ['EXIT_LOOP_MODE', 'Endlosschleife stoppen'],
          ['EXIT_PICTURE_IN_PICTURE', 'Bild-im-Bild-Modus beenden'],
          ['FAST_FORWARD', 'Vorspulen'],
          ['FULL_SCREEN', 'Vollbildmodus'],
          ['LANGUAGE', 'Sprache'],
          ['LIVE', 'Live'],
          ['LOOP', 'Schleife'],
          ['MORE_SETTINGS', 'Weitere Einstellungen'],
          ['MULTIPLE_LANGUAGES', 'Mehrere Sprachen'],
          ['MUTE', 'Stummschalten'],
          ['NOT_APPLICABLE', 'Nicht zutreffend'],
          ['OFF', 'Aus'],
          ['ON', 'Ein'],
          ['PAUSE', 'Pause'],
          ['PICTURE_IN_PICTURE', 'Bild im Bild'],
          ['PLAY', 'Wiedergabe'],
          ['PLAYBACK_RATE', 'Geschwindigkeit'],
          ['RESOLUTION', 'Aufl\u00f6sung'],
          ['REWIND', 'Zur\u00fcckspulen'],
          ['SEEK', 'Suche'],
          ['SKIP_AD', '\u00dcberspringen'],
          ['SKIP_TO_LIVE', 'Zum Live-Videostream wechseln'],
          ['UNDETERMINED_LANGUAGE', 'Unbestimmt'],
          ['UNMUTE', 'Stummschaltung aufheben'],
          ['UNRECOGNIZED_LANGUAGE', 'Unbekannt'],
          ['VOLUME', 'Lautst\u00e4rke'],
        ]),
      );
      a.insert(
        'en',
        new Map([
          ['AD_DURATION', 'Ad duration'],
          ['AD_PROGRESS', 'Ad [AD_ON] of [NUM_ADS]'],
          ['AD_TIME', 'Ad: [AD_TIME]'],
          ['AUTO_QUALITY', 'Auto'],
          ['BACK', 'Back'],
          ['CAPTIONS', 'Captions'],
          ['CAST', 'Cast...'],
          ['ENTER_LOOP_MODE', 'Loop the current video'],
          ['ENTER_PICTURE_IN_PICTURE', 'Enter Picture-in-Picture'],
          ['EXIT_FULL_SCREEN', 'Exit full screen'],
          ['EXIT_LOOP_MODE', 'Stop looping the current video'],
          ['EXIT_PICTURE_IN_PICTURE', 'Exit Picture-in-Picture'],
          ['FAST_FORWARD', 'Fast-forward'],
          ['FULL_SCREEN', 'Full screen'],
          ['LANGUAGE', 'Language'],
          ['LIVE', 'Live'],
          ['LOOP', 'Loop'],
          ['MORE_SETTINGS', 'More settings'],
          ['MULTIPLE_LANGUAGES', 'Multiple languages'],
          ['MUTE', 'Mute'],
          ['NOT_APPLICABLE', 'Not applicable'],
          ['OFF', 'Off'],
          ['ON', 'On'],
          ['PAUSE', 'Pause'],
          ['PICTURE_IN_PICTURE', 'Picture-in-Picture'],
          ['PLAY', 'Play'],
          ['PLAYBACK_RATE', 'Playback speed'],
          ['RESOLUTION', 'Resolution'],
          ['REWIND', 'Rewind'],
          ['SEEK', 'Seek'],
          ['SKIP_AD', 'Skip Ad'],
          ['SKIP_TO_LIVE', 'Skip ahead to live'],
          ['UNDETERMINED_LANGUAGE', 'Undetermined'],
          ['UNMUTE', 'Unmute'],
          ['UNRECOGNIZED_LANGUAGE', 'Unrecognized'],
          ['VOLUME', 'Volume'],
        ]),
      );
      a.insert(
        'en-GB',
        new Map([
          ['AD_DURATION', 'Ad duration'],
          ['AD_PROGRESS', 'Ad [AD_ON] of [NUM_ADS]'],
          ['AD_TIME', 'Ad: [AD_TIME]'],
          ['AUTO_QUALITY', 'Auto'],
          ['BACK', 'Back'],
          ['CAPTIONS', 'Captions'],
          ['CAST', 'Cast...'],
          ['ENTER_LOOP_MODE', 'Loop the current video'],
          ['ENTER_PICTURE_IN_PICTURE', 'Enter picture-in-picture'],
          ['EXIT_FULL_SCREEN', 'Exit full screen'],
          ['EXIT_LOOP_MODE', 'Stop looping the current video'],
          ['EXIT_PICTURE_IN_PICTURE', 'Exit picture-in-picture'],
          ['FAST_FORWARD', 'Fast-forward'],
          ['FULL_SCREEN', 'Full screen'],
          ['LANGUAGE', 'Language'],
          ['LIVE', 'Live'],
          ['LOOP', 'Loop'],
          ['MORE_SETTINGS', 'More settings'],
          ['MULTIPLE_LANGUAGES', 'Multiple languages'],
          ['MUTE', 'Mute'],
          ['NOT_APPLICABLE', 'Not applicable'],
          ['OFF', 'Off'],
          ['ON', 'On'],
          ['PAUSE', 'Pause'],
          ['PICTURE_IN_PICTURE', 'Picture-in-picture'],
          ['PLAY', 'Play'],
          ['PLAYBACK_RATE', 'Playback speed'],
          ['RESOLUTION', 'Resolution'],
          ['REWIND', 'Rewind'],
          ['SEEK', 'Seek'],
          ['SKIP_AD', 'Skip ad'],
          ['SKIP_TO_LIVE', 'Skip ahead to live'],
          ['UNDETERMINED_LANGUAGE', 'Undetermined'],
          ['UNMUTE', 'Unmute'],
          ['UNRECOGNIZED_LANGUAGE', 'Unrecognised'],
          ['VOLUME', 'volume'],
        ]),
      );
      a.insert(
        'es',
        new Map([
          ['AD_DURATION', 'Duraci\u00f3n del anuncio'],
          ['AD_PROGRESS', 'Anuncio [AD_ON] de [NUM_ADS]'],
          ['AD_TIME', 'Anuncio: [AD_TIME]'],
          ['AUTO_QUALITY', 'Autom\u00e1tico'],
          ['BACK', 'Atr\u00e1s'],
          ['CAPTIONS', 'Subt\u00edtulos'],
          ['CAST', 'Enviar...'],
          ['ENTER_LOOP_MODE', 'Reproducir en bucle el v\u00eddeo actual'],
          ['ENTER_PICTURE_IN_PICTURE', 'Activar el modo imagen en imagen'],
          ['EXIT_FULL_SCREEN', 'Salir del modo de pantalla completa'],
          ['EXIT_LOOP_MODE', 'Dejar de reproducir en bucle el v\u00eddeo actual'],
          ['EXIT_PICTURE_IN_PICTURE', 'Salir del modo imagen en imagen'],
          ['FAST_FORWARD', 'Avanzar r\u00e1pidamente'],
          ['FULL_SCREEN', 'Pantalla completa'],
          ['LANGUAGE', 'Idioma'],
          ['LIVE', 'En directo'],
          ['LOOP', 'Reproducir en bucle'],
          ['MORE_SETTINGS', 'M\u00e1s ajustes'],
          ['MULTIPLE_LANGUAGES', 'Varios idiomas'],
          ['MUTE', 'Silenciar'],
          ['NOT_APPLICABLE', 'No aplicable'],
          ['OFF', 'Desactivado'],
          ['ON', 'Activado'],
          ['PAUSE', 'Pausar'],
          ['PICTURE_IN_PICTURE', 'Imagen en imagen'],
          ['PLAY', 'Reproducir'],
          ['PLAYBACK_RATE', 'Velocidad de reproducci\u00f3n'],
          ['RESOLUTION', 'Resoluci\u00f3n'],
          ['REWIND', 'Rebobinar'],
          ['SEEK', 'Buscar'],
          ['SKIP_AD', 'Saltar anuncio'],
          ['SKIP_TO_LIVE', 'Ir al v\u00eddeo en directo'],
          ['UNDETERMINED_LANGUAGE', 'Sin especificar'],
          ['UNMUTE', 'Activar sonido'],
          ['UNRECOGNIZED_LANGUAGE', 'No reconocida'],
          ['VOLUME', 'Volumen'],
        ]),
      );
      a.insert(
        'es-419',
        new Map([
          ['AD_DURATION', 'Duraci\u00f3n del anuncio'],
          ['AD_PROGRESS', 'Anuncio [AD_ON] de [NUM_ADS]'],
          ['AD_TIME', 'Anuncio: [AD_TIME]'],
          ['AUTO_QUALITY', 'Autom\u00e1tico'],
          ['BACK', 'Atr\u00e1s'],
          ['CAPTIONS', 'Subt\u00edtulos'],
          ['CAST', 'Transmitir...'],
          ['ENTER_LOOP_MODE', 'Repetir indefinidamente el video actual'],
          ['ENTER_PICTURE_IN_PICTURE', 'Ingresar al modo de pantalla en pantalla'],
          ['EXIT_FULL_SCREEN', 'Salir de pantalla completa'],
          ['EXIT_LOOP_MODE', 'Detener la repetici\u00f3n indefinida del video actual'],
          ['EXIT_PICTURE_IN_PICTURE', 'Salir del modo de pantalla en pantalla'],
          ['FAST_FORWARD', 'Avanzar'],
          ['FULL_SCREEN', 'Pantalla completa'],
          ['LANGUAGE', 'Idioma'],
          ['LIVE', 'En directo'],
          ['LOOP', 'Repetir indefinidamente'],
          ['MORE_SETTINGS', 'M\u00e1s opciones de configuraci\u00f3n'],
          ['MULTIPLE_LANGUAGES', 'Varios idiomas'],
          ['MUTE', 'Silenciar'],
          ['NOT_APPLICABLE', 'No aplicable'],
          ['OFF', 'Desactivado'],
          ['ON', 'Activado'],
          ['PAUSE', 'Detener'],
          ['PICTURE_IN_PICTURE', 'Pantalla en pantalla'],
          ['PLAY', 'Reproducir'],
          ['PLAYBACK_RATE', 'Velocidad de reproducci\u00f3n'],
          ['RESOLUTION', 'Resoluci\u00f3n'],
          ['REWIND', 'Retroceder'],
          ['SEEK', 'Buscar'],
          ['SKIP_AD', 'Omitir anuncio'],
          ['SKIP_TO_LIVE', 'Adelantar hasta la transmisi\u00f3n en vivo'],
          ['UNDETERMINED_LANGUAGE', 'Sin especificar'],
          ['UNMUTE', 'Dejar de silenciar'],
          ['UNRECOGNIZED_LANGUAGE', 'No reconocida'],
          ['VOLUME', 'Volumen'],
        ]),
      );
      a.insert(
        'fr',
        new Map([
          ['AD_DURATION', "Dur\u00e9e de l'annonce"],
          ['AD_PROGRESS', 'Annonce\u00a0[AD_ON] sur\u00a0[NUM_ADS]'],
          ['AD_TIME', 'Annonce\u00a0: [AD_TIME]'],
          ['AUTO_QUALITY', 'Automatique'],
          ['BACK', 'Retour'],
          ['CAPTIONS', 'Sous-titres'],
          ['CAST', 'Caster\u2026'],
          ['ENTER_LOOP_MODE', 'Lire en boucle la vid\u00e9o en cours'],
          ['ENTER_PICTURE_IN_PICTURE', 'Utiliser le mode Picture-in-Picture'],
          ['EXIT_FULL_SCREEN', 'Quitter le mode plein \u00e9cran'],
          ['EXIT_LOOP_MODE', 'Arr\u00eater la lecture en boucle de la vid\u00e9o en cours'],
          ['EXIT_PICTURE_IN_PICTURE', 'Quitter le mode\u00a0PIP (Picture-in-picture)'],
          ['FAST_FORWARD', 'Avance rapide'],
          ['FULL_SCREEN', 'Plein \u00e9cran'],
          ['LANGUAGE', 'Langue'],
          ['LIVE', 'En direct'],
          ['LOOP', 'R\u00e9p\u00e9ter'],
          ['MORE_SETTINGS', 'Plus de param\u00e8tres'],
          ['MULTIPLE_LANGUAGES', 'Plusieurs langues'],
          ['MUTE', 'Couper le son'],
          ['NOT_APPLICABLE', 'Non applicable'],
          ['OFF', 'D\u00e9sactiv\u00e9e'],
          ['ON', 'Activ\u00e9e'],
          ['PAUSE', 'Pause'],
          ['PICTURE_IN_PICTURE', 'Picture-in-Picture'],
          ['PLAY', 'Visionner'],
          ['PLAYBACK_RATE', 'Vitesse de lecture'],
          ['RESOLUTION', 'R\u00e9solution'],
          ['REWIND', 'Retour arri\u00e8re'],
          ['SEEK', 'Chercher'],
          ['SKIP_AD', "Passer l'annonce"],
          ['SKIP_TO_LIVE', 'Acc\u00e9der \u00e0 la partie la plus r\u00e9cente du direct'],
          ['UNDETERMINED_LANGUAGE', 'Langue ind\u00e9termin\u00e9e'],
          ['UNMUTE', 'R\u00e9activer le son'],
          ['UNRECOGNIZED_LANGUAGE', 'Non reconnu'],
          ['VOLUME', 'Volume'],
        ]),
      );
      a.insert(
        'it',
        new Map([
          ['AD_DURATION', "Durata dell'annuncio"],
          ['AD_PROGRESS', 'Annuncio [AD_ON] di [NUM_ADS]'],
          ['AD_TIME', 'Annuncio: [AD_TIME]'],
          ['AUTO_QUALITY', 'Automatica'],
          ['BACK', 'Indietro'],
          ['CAPTIONS', 'Sottotitoli'],
          ['CAST', 'Trasmetti...'],
          ['ENTER_LOOP_MODE', 'Riproduci in loop il video corrente'],
          ['ENTER_PICTURE_IN_PICTURE', 'Attiva Picture in picture'],
          ['EXIT_FULL_SCREEN', 'Esci da schermo intero'],
          ['EXIT_LOOP_MODE', 'Interrompi riproduzione in loop del video corrente'],
          ['EXIT_PICTURE_IN_PICTURE', 'Esci da Picture in picture'],
          ['FAST_FORWARD', 'Avanti veloce'],
          ['FULL_SCREEN', 'Schermo intero'],
          ['LANGUAGE', 'Lingua'],
          ['LIVE', 'Dal vivo'],
          ['LOOP', 'Riproduci in loop'],
          ['MORE_SETTINGS', 'Altre impostazioni'],
          ['MULTIPLE_LANGUAGES', 'Pi\u00f9 lingue'],
          ['MUTE', 'Disattiva audio'],
          ['NOT_APPLICABLE', 'Non applicabile'],
          ['OFF', 'Disattivo'],
          ['ON', 'Attivo'],
          ['PAUSE', 'Metti in pausa'],
          ['PICTURE_IN_PICTURE', 'Picture in picture'],
          ['PLAY', 'Riproduci'],
          ['PLAYBACK_RATE', 'Velocit\u00e0 di riproduzione'],
          ['RESOLUTION', 'Risoluzione'],
          ['REWIND', 'Riavvolgi'],
          ['SEEK', 'Cerca'],
          ['SKIP_AD', 'Salta annuncio'],
          ['SKIP_TO_LIVE', 'Passa alla trasmissione dal vivo'],
          ['UNDETERMINED_LANGUAGE', 'Indeterminata'],
          ['UNMUTE', 'Riattiva audio'],
          ['UNRECOGNIZED_LANGUAGE', 'Non riconosciuto'],
          ['VOLUME', 'Volume'],
        ]),
      );
      a.insert(
        'ja',
        new Map([
          ['AD_DURATION', '\u5e83\u544a\u518d\u751f\u6642\u9593'],
          ['AD_PROGRESS', '[AD_ON] \u756a\u76ee\u306e\u5e83\u544a\uff08\u5168 [NUM_ADS] \u500b\uff09'],
          ['AD_TIME', '\u5e83\u544a: [AD_TIME]'],
          ['AUTO_QUALITY', '\u81ea\u52d5'],
          ['BACK', '\u623b\u308b'],
          ['CAPTIONS', '\u5b57\u5e55'],
          ['CAST', '\u30ad\u30e3\u30b9\u30c8...'],
          ['ENTER_LOOP_MODE', '\u73fe\u5728\u306e\u52d5\u753b\u3092\u30eb\u30fc\u30d7\u518d\u751f'],
          [
            'ENTER_PICTURE_IN_PICTURE',
            '\u30d4\u30af\u30c1\u30e3\u30fc \u30a4\u30f3 \u30d4\u30af\u30c1\u30e3\u30fc\u3092\u958b\u59cb',
          ],
          ['EXIT_FULL_SCREEN', '\u5168\u753b\u9762\u8868\u793a\u3092\u7d42\u4e86'],
          ['EXIT_LOOP_MODE', '\u73fe\u5728\u306e\u52d5\u753b\u306e\u30eb\u30fc\u30d7\u518d\u751f\u3092\u505c\u6b62'],
          [
            'EXIT_PICTURE_IN_PICTURE',
            '\u30d4\u30af\u30c1\u30e3\u30fc \u30a4\u30f3 \u30d4\u30af\u30c1\u30e3\u30fc\u3092\u7d42\u4e86',
          ],
          ['FAST_FORWARD', '\u65e9\u9001\u308a'],
          ['FULL_SCREEN', '\u5168\u753b\u9762\u8868\u793a'],
          ['LANGUAGE', '\u8a00\u8a9e'],
          ['LIVE', '\u30e9\u30a4\u30d6'],
          ['LOOP', '\u30eb\u30fc\u30d7'],
          ['MORE_SETTINGS', '\u8a73\u7d30\u8a2d\u5b9a'],
          ['MULTIPLE_LANGUAGES', '\u591a\u8a00\u8a9e'],
          ['MUTE', '\u30df\u30e5\u30fc\u30c8'],
          ['NOT_APPLICABLE', '\u8a72\u5f53\u306a\u3057'],
          ['OFF', '\u30aa\u30d5'],
          ['ON', '\u30aa\u30f3'],
          ['PAUSE', '\u4e00\u6642\u505c\u6b62'],
          ['PICTURE_IN_PICTURE', '\u30d4\u30af\u30c1\u30e3\u30fc \u30a4\u30f3 \u30d4\u30af\u30c1\u30e3\u30fc'],
          ['PLAY', '\u518d\u751f'],
          ['PLAYBACK_RATE', '\u518d\u751f\u901f\u5ea6'],
          ['RESOLUTION', '\u89e3\u50cf\u5ea6'],
          ['REWIND', '\u5dfb\u304d\u623b\u3057'],
          ['SEEK', '\u30b7\u30fc\u30af\u518d\u751f'],
          ['SKIP_AD', '\u5e83\u544a\u3092\u30b9\u30ad\u30c3\u30d7'],
          ['SKIP_TO_LIVE', '\u30e9\u30a4\u30d6\u914d\u4fe1\u307e\u3067\u30b9\u30ad\u30c3\u30d7'],
          ['UNDETERMINED_LANGUAGE', '\u4e0d\u660e'],
          ['UNMUTE', '\u30df\u30e5\u30fc\u30c8\u3092\u89e3\u9664'],
          ['UNRECOGNIZED_LANGUAGE', '\u4e0d\u660e'],
          ['VOLUME', '\u97f3\u91cf'],
        ]),
      );
      a.insert(
        'ko',
        new Map([
          ['AD_DURATION', '\uad11\uace0 \uae30\uac04'],
          ['AD_PROGRESS', '\uad11\uace0 [AD_ON]/[NUM_ADS]'],
          ['AD_TIME', '\uad11\uace0: [AD_TIME]'],
          ['AUTO_QUALITY', '\uc790\ub3d9'],
          ['BACK', '\ub4a4\ub85c'],
          ['CAPTIONS', '\uc790\ub9c9'],
          ['CAST', '\uc804\uc1a1...'],
          ['ENTER_LOOP_MODE', '\ud604\uc7ac \ub3d9\uc601\uc0c1 \ubc18\ubcf5 \uc7ac\uc0dd'],
          ['ENTER_PICTURE_IN_PICTURE', 'PIP \ubaa8\ub4dc \uc2dc\uc791'],
          ['EXIT_FULL_SCREEN', '\uc804\uccb4\ud654\uba74 \ub2eb\uae30'],
          ['EXIT_LOOP_MODE', '\ud604\uc7ac \ub3d9\uc601\uc0c1 \ubc18\ubcf5 \uc7ac\uc0dd \uc911\uc9c0'],
          ['EXIT_PICTURE_IN_PICTURE', 'PIP \ubaa8\ub4dc \uc885\ub8cc'],
          ['FAST_FORWARD', '\ube68\ub9ac \uac10\uae30'],
          ['FULL_SCREEN', '\uc804\uccb4\ud654\uba74'],
          ['LANGUAGE', '\uc5b8\uc5b4'],
          ['LIVE', '\uc2e4\uc2dc\uac04'],
          ['LOOP', '\ubc18\ubcf5 \uc7ac\uc0dd'],
          ['MORE_SETTINGS', '\uc124\uc815 \ub354\ubcf4\uae30'],
          ['MULTIPLE_LANGUAGES', '\uc5ec\ub7ec \uc5b8\uc5b4'],
          ['MUTE', '\uc74c\uc18c\uac70'],
          ['NOT_APPLICABLE', '\ud574\ub2f9 \uc0ac\ud56d \uc5c6\uc74c'],
          ['OFF', '\uc0ac\uc6a9 \uc548\ud568'],
          ['ON', '\uc0ac\uc6a9'],
          ['PAUSE', '\uc77c\uc2dc\uc911\uc9c0'],
          ['PICTURE_IN_PICTURE', 'PIP \ubaa8\ub4dc'],
          ['PLAY', '\uc7ac\uc0dd'],
          ['PLAYBACK_RATE', '\uc7ac\uc0dd \uc18d\ub3c4'],
          ['RESOLUTION', '\ud574\uc0c1\ub3c4'],
          ['REWIND', '\ub418\uac10\uae30'],
          ['SEEK', '\ucc3e\uae30'],
          ['SKIP_AD', '\uad11\uace0 \uac74\ub108\ub6f0\uae30'],
          ['SKIP_TO_LIVE', '\ub77c\uc774\ube0c \ub3d9\uc601\uc0c1\uc73c\ub85c \uac74\ub108\ub6f0\uae30'],
          ['UNDETERMINED_LANGUAGE', '\ubbf8\uc815'],
          ['UNMUTE', '\uc74c\uc18c\uac70 \ud574\uc81c'],
          ['UNRECOGNIZED_LANGUAGE', '\uc54c \uc218 \uc5c6\uc74c'],
          ['VOLUME', '\ubcfc\ub968'],
        ]),
      );
      a.insert(
        'nl',
        new Map([
          ['AD_DURATION', 'Advertentieduur'],
          ['AD_PROGRESS', 'Advertentie [AD_ON] van [NUM_ADS]'],
          ['AD_TIME', 'Advertentie: [AD_TIME]'],
          ['AUTO_QUALITY', 'Automatisch'],
          ['BACK', 'Terug'],
          ['CAPTIONS', 'Ondertiteling'],
          ['CAST', 'Casten...'],
          ['ENTER_LOOP_MODE', 'De huidige video lussen'],
          ['ENTER_PICTURE_IN_PICTURE', 'Scherm-in-scherm openen'],
          ['EXIT_FULL_SCREEN', 'Volledig scherm sluiten'],
          ['EXIT_LOOP_MODE', 'De huidige video niet meer lussen'],
          ['EXIT_PICTURE_IN_PICTURE', 'Scherm-in-scherm afsluiten'],
          ['FAST_FORWARD', 'Vooruitspoelen'],
          ['FULL_SCREEN', 'Volledig scherm'],
          ['LANGUAGE', 'Taal'],
          ['LIVE', 'Live'],
          ['LOOP', 'Lussen'],
          ['MORE_SETTINGS', 'Meer instellingen'],
          ['MULTIPLE_LANGUAGES', 'Meerdere talen'],
          ['MUTE', 'Dempen'],
          ['NOT_APPLICABLE', 'Niet van toepassing'],
          ['OFF', 'Uit'],
          ['ON', 'Aan'],
          ['PAUSE', 'Onderbreken'],
          ['PICTURE_IN_PICTURE', 'Scherm-in-scherm'],
          ['PLAY', 'Afspelen'],
          ['PLAYBACK_RATE', 'Afspeelsnelheid'],
          ['RESOLUTION', 'Resolutie'],
          ['REWIND', 'Terugspoelen'],
          ['SEEK', 'Zoeken'],
          ['SKIP_AD', 'Advertentie overslaan'],
          ['SKIP_TO_LIVE', 'Doorgaan naar live'],
          ['UNDETERMINED_LANGUAGE', 'Onbepaald'],
          ['UNMUTE', 'Dempen opheffen'],
          ['UNRECOGNIZED_LANGUAGE', 'Onbekend'],
          ['VOLUME', 'Volume'],
        ]),
      );
      a.insert(
        'pl',
        new Map([
          ['AD_DURATION', 'Czas trwania reklamy'],
          ['AD_PROGRESS', 'Reklama\u00a0[AD_ON] z\u00a0[NUM_ADS]'],
          ['AD_TIME', 'Reklama: [AD_TIME]'],
          ['AUTO_QUALITY', 'Automatycznie'],
          ['BACK', 'Wstecz'],
          ['CAPTIONS', 'Napisy'],
          ['CAST', 'Przesy\u0142aj...'],
          ['ENTER_LOOP_MODE', 'Odtwarzaj bie\u017c\u0105cy film w\u00a0p\u0119tli'],
          ['ENTER_PICTURE_IN_PICTURE', 'W\u0142\u0105cz tryb obrazu w\u00a0obrazie'],
          ['EXIT_FULL_SCREEN', 'Zamknij pe\u0142ny ekran'],
          ['EXIT_LOOP_MODE', 'Wy\u0142\u0105cz odtwarzanie bie\u017c\u0105cego filmu w\u00a0p\u0119tli'],
          ['EXIT_PICTURE_IN_PICTURE', 'Wy\u0142\u0105cz tryb obrazu w\u00a0obrazie'],
          ['FAST_FORWARD', 'Przewi\u0144 do przodu'],
          ['FULL_SCREEN', 'Pe\u0142ny ekran'],
          ['LANGUAGE', 'J\u0119zyk'],
          ['LIVE', 'Na \u017cywo'],
          ['LOOP', 'Odtwarzaj w\u00a0p\u0119tli'],
          ['MORE_SETTINGS', 'Wi\u0119cej ustawie\u0144'],
          ['MULTIPLE_LANGUAGES', 'Wiele j\u0119zyk\u00f3w'],
          ['MUTE', 'Wycisz'],
          ['NOT_APPLICABLE', 'Nie dotyczy'],
          ['OFF', 'Wy\u0142\u0105czone'],
          ['ON', 'W\u0142\u0105czone'],
          ['PAUSE', 'Wstrzymaj'],
          ['PICTURE_IN_PICTURE', 'Obraz w\u00a0obrazie'],
          ['PLAY', 'Odtw\u00f3rz'],
          ['PLAYBACK_RATE', 'Szybko\u015b\u0107 odtwarzania'],
          ['RESOLUTION', 'Rozdzielczo\u015b\u0107'],
          ['REWIND', 'Przewi\u0144 do ty\u0142u'],
          ['SEEK', 'Szukaj'],
          ['SKIP_AD', 'Pomi\u0144 reklam\u0119'],
          ['SKIP_TO_LIVE', 'Przejd\u017a do transmisji na \u017cywo'],
          ['UNDETERMINED_LANGUAGE', 'Nie okre\u015blono'],
          ['UNMUTE', 'Wy\u0142\u0105cz wyciszenie'],
          ['UNRECOGNIZED_LANGUAGE', 'Nierozpoznany'],
          ['VOLUME', 'G\u0142o\u015bno\u015b\u0107'],
        ]),
      );
      a.insert(
        'pt-BR',
        new Map([
          ['AD_DURATION', 'Dura\u00e7\u00e3o do an\u00fancio'],
          ['AD_PROGRESS', 'An\u00fancio [AD_ON] de [NUM_ADS]'],
          ['AD_TIME', 'An\u00fancio: [AD_TIME]'],
          ['AUTO_QUALITY', 'Autom\u00e1tica'],
          ['BACK', 'Voltar'],
          ['CAPTIONS', 'Legendas'],
          ['CAST', 'Transmitir...'],
          ['ENTER_LOOP_MODE', 'Repetir o v\u00eddeo atual'],
          ['ENTER_PICTURE_IN_PICTURE', 'Entrar no modo picture-in-picture'],
          ['EXIT_FULL_SCREEN', 'Sair do modo tela cheia'],
          ['EXIT_LOOP_MODE', 'Parar repeti\u00e7\u00e3o do v\u00eddeo atual'],
          ['EXIT_PICTURE_IN_PICTURE', 'Sair de picture-in-picture'],
          ['FAST_FORWARD', 'Avan\u00e7ar'],
          ['FULL_SCREEN', 'Tela cheia'],
          ['LANGUAGE', 'Idioma'],
          ['LIVE', 'Ao vivo'],
          ['LOOP', 'Repetir'],
          ['MORE_SETTINGS', 'Mais defini\u00e7\u00f5es'],
          ['MULTIPLE_LANGUAGES', 'V\u00e1rios idiomas'],
          ['MUTE', 'Desativar som'],
          ['NOT_APPLICABLE', 'N\u00e3o relevante'],
          ['OFF', 'Desativado'],
          ['ON', 'Ativado'],
          ['PAUSE', 'Pausar'],
          ['PICTURE_IN_PICTURE', 'Picture-in-picture'],
          ['PLAY', 'Reproduzir'],
          ['PLAYBACK_RATE', 'Velocidade da reprodu\u00e7\u00e3o'],
          ['RESOLUTION', 'Resolu\u00e7\u00e3o'],
          ['REWIND', 'Retroceder'],
          ['SEEK', 'Procurar'],
          ['SKIP_AD', 'Pular an\u00fancio'],
          ['SKIP_TO_LIVE', 'Pular para transmiss\u00e3o ao vivo'],
          ['UNDETERMINED_LANGUAGE', 'Indeterminado'],
          ['UNMUTE', 'Ativar som'],
          ['UNRECOGNIZED_LANGUAGE', 'N\u00e3o reconhecido'],
          ['VOLUME', 'Volume'],
        ]),
      );
      a.insert(
        'ru',
        new Map([
          [
            'AD_DURATION',
            '\u041f\u0440\u043e\u0434\u043e\u043b\u0436\u0438\u0442\u0435\u043b\u044c\u043d\u043e\u0441\u0442\u044c \u043e\u0431\u044a\u044f\u0432\u043b\u0435\u043d\u0438\u044f',
          ],
          [
            'AD_PROGRESS',
            '\u041e\u0431\u044a\u044f\u0432\u043b\u0435\u043d\u0438\u0435 [AD_ON] \u0438\u0437 [NUM_ADS]',
          ],
          ['AD_TIME', '\u041e\u0431\u044a\u044f\u0432\u043b\u0435\u043d\u0438\u0435: [AD_TIME]'],
          ['AUTO_QUALITY', '\u0410\u0432\u0442\u043e'],
          ['BACK', '\u041d\u0430\u0437\u0430\u0434'],
          ['CAPTIONS', '\u0422\u0438\u0442\u0440\u044b'],
          ['CAST', '\u0422\u0440\u0430\u043d\u0441\u043b\u0438\u0440\u043e\u0432\u0430\u0442\u044c...'],
          [
            'ENTER_LOOP_MODE',
            '\u0417\u0430\u0446\u0438\u043a\u043b\u0438\u0442\u044c \u0442\u0435\u043a\u0443\u0449\u0435\u0435 \u0432\u0438\u0434\u0435\u043e',
          ],
          [
            'ENTER_PICTURE_IN_PICTURE',
            '\u041f\u0435\u0440\u0435\u0439\u0442\u0438 \u0432 \u0440\u0435\u0436\u0438\u043c "\u041a\u0430\u0440\u0442\u0438\u043d\u043a\u0430 \u0432 \u043a\u0430\u0440\u0442\u0438\u043d\u043a\u0435"',
          ],
          ['EXIT_FULL_SCREEN', '\u041e\u0431\u044b\u0447\u043d\u044b\u0439 \u0440\u0435\u0436\u0438\u043c'],
          [
            'EXIT_LOOP_MODE',
            '\u041e\u0442\u043c\u0435\u043d\u0438\u0442\u044c \u0437\u0430\u0446\u0438\u043a\u043b\u0438\u0432\u0430\u043d\u0438\u0435 \u0442\u0435\u043a\u0443\u0449\u0435\u0433\u043e \u0432\u0438\u0434\u0435\u043e',
          ],
          [
            'EXIT_PICTURE_IN_PICTURE',
            '\u0412\u044b\u0439\u0442\u0438 \u0438\u0437 \u0440\u0435\u0436\u0438\u043c\u0430 "\u041a\u0430\u0440\u0442\u0438\u043d\u043a\u0430 \u0432 \u043a\u0430\u0440\u0442\u0438\u043d\u043a\u0435"',
          ],
          [
            'FAST_FORWARD',
            '\u041f\u0435\u0440\u0435\u043c\u043e\u0442\u043a\u0430 \u0432\u043f\u0435\u0440\u0435\u0434',
          ],
          [
            'FULL_SCREEN',
            '\u041f\u043e\u043b\u043d\u043e\u044d\u043a\u0440\u0430\u043d\u043d\u044b\u0439 \u0440\u0435\u0436\u0438\u043c',
          ],
          ['LANGUAGE', '\u042f\u0437\u044b\u043a'],
          ['LIVE', '\u041f\u0440\u044f\u043c\u043e\u0439 \u044d\u0444\u0438\u0440'],
          ['LOOP', '\u0417\u0430\u0446\u0438\u043a\u043b\u0438\u0442\u044c'],
          [
            'MORE_SETTINGS',
            '\u0414\u043e\u043f\u043e\u043b\u043d\u0438\u0442\u0435\u043b\u044c\u043d\u044b\u0435 \u043d\u0430\u0441\u0442\u0440\u043e\u0439\u043a\u0438',
          ],
          [
            'MULTIPLE_LANGUAGES',
            '\u041d\u0435\u0441\u043a\u043e\u043b\u044c\u043a\u043e \u044f\u0437\u044b\u043a\u043e\u0432',
          ],
          ['MUTE', '\u041e\u0442\u043a\u043b\u044e\u0447\u0438\u0442\u044c \u0437\u0432\u0443\u043a'],
          ['NOT_APPLICABLE', '\u041d\u0435\u043f\u0440\u0438\u043c\u0435\u043d\u0438\u043c\u043e'],
          ['OFF', '\u0412\u043a\u043b\u044e\u0447\u0438\u0442\u044c'],
          ['ON', '\u041e\u0442\u043a\u043b\u044e\u0447\u0438\u0442\u044c'],
          ['PAUSE', '\u041f\u0430\u0443\u0437\u0430'],
          [
            'PICTURE_IN_PICTURE',
            '\u041a\u0430\u0440\u0442\u0438\u043d\u043a\u0430 \u0432 \u043a\u0430\u0440\u0442\u0438\u043d\u043a\u0435',
          ],
          ['PLAY', '\u0412\u043e\u0441\u043f\u0440\u043e\u0438\u0437\u0432\u0435\u0441\u0442\u0438'],
          [
            'PLAYBACK_RATE',
            '\u0421\u043a\u043e\u0440\u043e\u0441\u0442\u044c \u0432\u043e\u0441\u043f\u0440\u043e\u0438\u0437\u0432\u0435\u0434\u0435\u043d\u0438\u044f',
          ],
          ['RESOLUTION', '\u0420\u0430\u0437\u0440\u0435\u0448\u0435\u043d\u0438\u0435'],
          ['REWIND', '\u041f\u0435\u0440\u0435\u043c\u043e\u0442\u0430\u0442\u044c \u043d\u0430\u0437\u0430\u0434'],
          ['SEEK', '\u041f\u0435\u0440\u0435\u043c\u043e\u0442\u043a\u0430'],
          ['SKIP_AD', '\u041f\u0440\u043e\u043f\u0443\u0441\u0442\u0438\u0442\u044c'],
          [
            'SKIP_TO_LIVE',
            '\u041f\u0440\u043e\u043f\u0443\u0441\u0442\u0438\u0442\u044c \u0438 \u043f\u0435\u0440\u0435\u0439\u0442\u0438 \u043a \u043f\u0440\u044f\u043c\u043e\u0439 \u0442\u0440\u0430\u043d\u0441\u043b\u044f\u0446\u0438\u0438',
          ],
          ['UNDETERMINED_LANGUAGE', '\u041d\u0435 \u0443\u043a\u0430\u0437\u0430\u043d\u043e'],
          ['UNMUTE', '\u0412\u043a\u043b\u044e\u0447\u0438\u0442\u044c \u0437\u0432\u0443\u043a'],
          ['UNRECOGNIZED_LANGUAGE', '\u041d\u0435 \u0440\u0430\u0441\u043f\u043e\u0437\u043d\u0430\u043d\u043e'],
          ['VOLUME', '\u0413\u0440\u043e\u043c\u043a\u043e\u0441\u0442\u044c'],
        ]),
      );
      a.insert(
        'th',
        new Map([
          ['AD_DURATION', '\u0e23\u0e30\u0e22\u0e30\u0e40\u0e27\u0e25\u0e32\u0e42\u0e06\u0e29\u0e13\u0e32'],
          [
            'AD_PROGRESS',
            '\u0e42\u0e06\u0e29\u0e13\u0e32 [AD_ON] \u0e08\u0e32\u0e01 [NUM_ADS] \u0e23\u0e32\u0e22\u0e01\u0e32\u0e23',
          ],
          ['AD_TIME', '\u0e42\u0e06\u0e29\u0e13\u0e32: [AD_TIME]'],
          ['AUTO_QUALITY', '\u0e2d\u0e31\u0e15\u0e42\u0e19\u0e21\u0e31\u0e15\u0e34'],
          ['BACK', '\u0e01\u0e25\u0e31\u0e1a'],
          ['CAPTIONS', '\u0e04\u0e33\u0e1a\u0e23\u0e23\u0e22\u0e32\u0e22'],
          ['CAST', '\u0e41\u0e04\u0e2a\u0e15\u0e4c...'],
          [
            'ENTER_LOOP_MODE',
            '\u0e27\u0e19\u0e0b\u0e49\u0e33\u0e27\u0e34\u0e14\u0e35\u0e42\u0e2d\u0e1b\u0e31\u0e08\u0e08\u0e38\u0e1a\u0e31\u0e19',
          ],
          [
            'ENTER_PICTURE_IN_PICTURE',
            '\u0e40\u0e02\u0e49\u0e32\u0e2a\u0e39\u0e48\u0e01\u0e32\u0e23\u0e41\u0e2a\u0e14\u0e07\u0e20\u0e32\u0e1e\u0e0b\u0e49\u0e2d\u0e19\u0e20\u0e32\u0e1e',
          ],
          [
            'EXIT_FULL_SCREEN',
            '\u0e2d\u0e2d\u0e01\u0e08\u0e32\u0e01\u0e01\u0e32\u0e23\u0e41\u0e2a\u0e14\u0e07\u0e41\u0e1a\u0e1a\u0e40\u0e15\u0e47\u0e21\u0e2b\u0e19\u0e49\u0e32\u0e08\u0e2d',
          ],
          [
            'EXIT_LOOP_MODE',
            '\u0e2b\u0e22\u0e38\u0e14\u0e27\u0e19\u0e0b\u0e49\u0e33\u0e27\u0e34\u0e14\u0e35\u0e42\u0e2d\u0e1b\u0e31\u0e08\u0e08\u0e38\u0e1a\u0e31\u0e19',
          ],
          [
            'EXIT_PICTURE_IN_PICTURE',
            '\u0e2d\u0e2d\u0e01\u0e08\u0e32\u0e01\u0e01\u0e32\u0e23\u0e41\u0e2a\u0e14\u0e07\u0e20\u0e32\u0e1e\u0e0b\u0e49\u0e2d\u0e19\u0e20\u0e32\u0e1e',
          ],
          ['FAST_FORWARD', '\u0e01\u0e23\u0e2d\u0e44\u0e1b\u0e02\u0e49\u0e32\u0e07\u0e2b\u0e19\u0e49\u0e32'],
          ['FULL_SCREEN', '\u0e40\u0e15\u0e47\u0e21\u0e2b\u0e19\u0e49\u0e32\u0e08\u0e2d'],
          ['LANGUAGE', '\u0e20\u0e32\u0e29\u0e32'],
          ['LIVE', '\u0e2a\u0e14'],
          ['LOOP', '\u0e25\u0e39\u0e1b'],
          [
            'MORE_SETTINGS',
            '\u0e01\u0e32\u0e23\u0e15\u0e31\u0e49\u0e07\u0e04\u0e48\u0e32\u0e40\u0e1e\u0e34\u0e48\u0e21\u0e40\u0e15\u0e34\u0e21',
          ],
          ['MULTIPLE_LANGUAGES', '\u0e2b\u0e25\u0e32\u0e22\u0e20\u0e32\u0e29\u0e32'],
          ['MUTE', '\u0e1b\u0e34\u0e14\u0e40\u0e2a\u0e35\u0e22\u0e07'],
          ['NOT_APPLICABLE', '\u0e44\u0e21\u0e48\u0e40\u0e01\u0e35\u0e48\u0e22\u0e27\u0e02\u0e49\u0e2d\u0e07'],
          ['OFF', '\u0e1b\u0e34\u0e14'],
          ['ON', '\u0e40\u0e1b\u0e34\u0e14'],
          ['PAUSE', '\u0e2b\u0e22\u0e38\u0e14\u0e0a\u0e31\u0e48\u0e27\u0e04\u0e23\u0e32\u0e27'],
          [
            'PICTURE_IN_PICTURE',
            '\u0e01\u0e32\u0e23\u0e41\u0e2a\u0e14\u0e07\u0e20\u0e32\u0e1e\u0e0b\u0e49\u0e2d\u0e19\u0e20\u0e32\u0e1e',
          ],
          ['PLAY', '\u0e40\u0e25\u0e48\u0e19'],
          [
            'PLAYBACK_RATE',
            '\u0e04\u0e27\u0e32\u0e21\u0e40\u0e23\u0e47\u0e27\u0e43\u0e19\u0e01\u0e32\u0e23\u0e40\u0e25\u0e48\u0e19',
          ],
          ['RESOLUTION', '\u0e04\u0e27\u0e32\u0e21\u0e25\u0e30\u0e40\u0e2d\u0e35\u0e22\u0e14'],
          ['REWIND', '\u0e01\u0e23\u0e2d\u0e01\u0e25\u0e31\u0e1a'],
          ['SEEK', '\u0e04\u0e49\u0e19\u0e2b\u0e32'],
          ['SKIP_AD', '\u0e02\u0e49\u0e32\u0e21\u0e42\u0e06\u0e29\u0e13\u0e32'],
          [
            'SKIP_TO_LIVE',
            '\u0e02\u0e49\u0e32\u0e21\u0e44\u0e1b\u0e17\u0e35\u0e48\u0e01\u0e32\u0e23\u0e16\u0e48\u0e32\u0e22\u0e17\u0e2d\u0e14\u0e2a\u0e14',
          ],
          ['UNDETERMINED_LANGUAGE', '\u0e44\u0e21\u0e48\u0e01\u0e33\u0e2b\u0e19\u0e14'],
          ['UNMUTE', '\u0e40\u0e1b\u0e34\u0e14\u0e40\u0e2a\u0e35\u0e22\u0e07'],
          ['UNRECOGNIZED_LANGUAGE', '\u0e17\u0e35\u0e48\u0e44\u0e21\u0e48\u0e23\u0e39\u0e49\u0e08\u0e31\u0e01'],
          ['VOLUME', '\u0e23\u0e30\u0e14\u0e31\u0e1a\u0e40\u0e2a\u0e35\u0e22\u0e07'],
        ]),
      );
      a.insert(
        'tr',
        new Map([
          ['AD_DURATION', 'Reklam s\u00fcresi'],
          ['AD_PROGRESS', '[AD_ON]/[NUM_ADS] reklam'],
          ['AD_TIME', 'Reklam: [AD_TIME]'],
          ['AUTO_QUALITY', 'Otomatik'],
          ['BACK', 'Geri'],
          ['CAPTIONS', 'Altyaz\u0131lar'],
          ['CAST', 'Yay\u0131nla...'],
          ['ENTER_LOOP_MODE', 'Mevcut videoyu d\u00f6ng\u00fcye al'],
          ['ENTER_PICTURE_IN_PICTURE', 'Pencere i\u00e7inde Pencere moduna gir'],
          ['EXIT_FULL_SCREEN', 'Tam ekrandan \u00e7\u0131k'],
          ['EXIT_LOOP_MODE', 'Mevcut videonun d\u00f6ng\u00fcs\u00fcn\u00fc durdur'],
          ['EXIT_PICTURE_IN_PICTURE', 'Pencere \u0130\u00e7inde Pencereden \u00c7\u0131k'],
          ['FAST_FORWARD', '\u0130leri sar'],
          ['FULL_SCREEN', 'Tam ekran'],
          ['LANGUAGE', 'Dil'],
          ['LIVE', 'Canl\u0131'],
          ['LOOP', 'D\u00f6ng\u00fc'],
          ['MORE_SETTINGS', 'Daha fazla ayar'],
          ['MULTIPLE_LANGUAGES', 'Birden \u00e7ok dil'],
          ['MUTE', 'Sesi kapat'],
          ['NOT_APPLICABLE', 'Ge\u00e7erli de\u011fil'],
          ['OFF', 'Kapal\u0131'],
          ['ON', 'A\u00e7\u0131k'],
          ['PAUSE', 'Duraklat'],
          ['PICTURE_IN_PICTURE', 'Pencere \u0130\u00e7inde Pencere'],
          ['PLAY', 'Oynat'],
          ['PLAYBACK_RATE', '\u00c7alma h\u0131z\u0131'],
          ['RESOLUTION', '\u00c7\u00f6z\u00fcn\u00fcrl\u00fck'],
          ['REWIND', 'Geri sar'],
          ['SEEK', 'Ara'],
          ['SKIP_AD', 'Reklam\u0131 Atla'],
          ['SKIP_TO_LIVE', 'Canl\u0131 yay\u0131na atla'],
          ['UNDETERMINED_LANGUAGE', 'Belirsiz'],
          ['UNMUTE', 'Sesi a\u00e7'],
          ['UNRECOGNIZED_LANGUAGE', 'Tan\u0131nmayan'],
          ['VOLUME', 'Ses'],
        ]),
      );
      a.insert(
        'zh',
        new Map([
          ['AD_DURATION', '\u5e7f\u544a\u6301\u7eed\u65f6\u95f4'],
          ['AD_PROGRESS', '\u5e7f\u544a [AD_ON]/[NUM_ADS]'],
          ['AD_TIME', '\u5e7f\u544a\uff1a[AD_TIME]'],
          ['AUTO_QUALITY', '\u81ea\u52a8'],
          ['BACK', '\u8fd4\u56de'],
          ['CAPTIONS', '\u5b57\u5e55'],
          ['CAST', '\u6295\u5c04\u2026'],
          ['ENTER_LOOP_MODE', '\u5faa\u73af\u64ad\u653e\u5f53\u524d\u89c6\u9891'],
          ['ENTER_PICTURE_IN_PICTURE', '\u8fdb\u5165\u201c\u753b\u4e2d\u753b\u201d\u6a21\u5f0f'],
          ['EXIT_FULL_SCREEN', '\u9000\u51fa\u5168\u5c4f\u6a21\u5f0f'],
          ['EXIT_LOOP_MODE', '\u505c\u6b62\u5faa\u73af\u64ad\u653e\u5f53\u524d\u89c6\u9891'],
          ['EXIT_PICTURE_IN_PICTURE', '\u9000\u51fa\u201c\u753b\u4e2d\u753b\u201d\u6a21\u5f0f'],
          ['FAST_FORWARD', '\u5feb\u8fdb'],
          ['FULL_SCREEN', '\u5168\u5c4f'],
          ['LANGUAGE', '\u8bed\u8a00'],
          ['LIVE', '\u76f4\u64ad'],
          ['LOOP', '\u5faa\u73af\u64ad\u653e'],
          ['MORE_SETTINGS', '\u66f4\u591a\u8bbe\u7f6e'],
          ['MULTIPLE_LANGUAGES', '\u591a\u79cd\u8bed\u8a00'],
          ['MUTE', '\u9759\u97f3'],
          ['NOT_APPLICABLE', '\u4e0d\u9002\u7528'],
          ['OFF', '\u5173\u95ed'],
          ['ON', '\u5f00\u542f'],
          ['PAUSE', '\u6682\u505c'],
          ['PICTURE_IN_PICTURE', '\u753b\u4e2d\u753b'],
          ['PLAY', '\u64ad\u653e'],
          ['PLAYBACK_RATE', '\u64ad\u653e\u901f\u5ea6'],
          ['RESOLUTION', '\u5206\u8fa8\u7387'],
          ['REWIND', '\u5feb\u9000'],
          ['SEEK', '\u8fdb\u5ea6'],
          ['SKIP_AD', '\u8df3\u8fc7\u5e7f\u544a'],
          ['SKIP_TO_LIVE', '\u8df3\u81f3\u5f53\u524d\u76f4\u64ad'],
          ['UNDETERMINED_LANGUAGE', '\u672a\u786e\u5b9a'],
          ['UNMUTE', '\u53d6\u6d88\u9759\u97f3'],
          ['UNRECOGNIZED_LANGUAGE', '\u65e0\u6cd5\u8bc6\u522b'],
          ['VOLUME', '\u97f3\u91cf'],
        ]),
      );
      a.insert(
        'zh-TW',
        new Map([
          ['AD_DURATION', '\u5ee3\u544a\u9577\u5ea6'],
          ['AD_PROGRESS', '\u5ee3\u544a [AD_ON]/[NUM_ADS]'],
          ['AD_TIME', '\u5ee3\u544a\uff1a[AD_TIME]'],
          ['AUTO_QUALITY', '\u81ea\u52d5'],
          ['BACK', '\u8fd4\u56de'],
          ['CAPTIONS', '\u5b57\u5e55'],
          ['CAST', '\u6295\u653e...'],
          ['ENTER_LOOP_MODE', '\u5faa\u74b0\u64ad\u653e\u76ee\u524d\u7684\u5f71\u7247'],
          ['ENTER_PICTURE_IN_PICTURE', '\u9032\u5165\u5b50\u6bcd\u756b\u9762'],
          ['EXIT_FULL_SCREEN', '\u9000\u51fa\u5168\u87a2\u5e55\u6a21\u5f0f'],
          ['EXIT_LOOP_MODE', '\u505c\u6b62\u5faa\u74b0\u64ad\u653e\u76ee\u524d\u7684\u5f71\u7247'],
          ['EXIT_PICTURE_IN_PICTURE', '\u96e2\u958b\u5b50\u6bcd\u756b\u9762'],
          ['FAST_FORWARD', '\u5feb\u8f49'],
          ['FULL_SCREEN', '\u5168\u87a2\u5e55'],
          ['LANGUAGE', '\u8a9e\u8a00'],
          ['LIVE', '\u76f4\u64ad'],
          ['LOOP', '\u5faa\u74b0\u64ad\u653e'],
          ['MORE_SETTINGS', '\u986f\u793a\u66f4\u591a\u8a2d\u5b9a'],
          ['MULTIPLE_LANGUAGES', '\u591a\u7a2e\u8a9e\u8a00'],
          ['MUTE', '\u975c\u97f3'],
          ['NOT_APPLICABLE', '\u4e0d\u9069\u7528'],
          ['OFF', '\u95dc\u9589'],
          ['ON', '\u958b\u555f'],
          ['PAUSE', '\u66ab\u505c'],
          ['PICTURE_IN_PICTURE', '\u5b50\u6bcd\u756b\u9762'],
          ['PLAY', '\u64ad\u653e'],
          ['PLAYBACK_RATE', '\u64ad\u653e\u901f\u5ea6'],
          ['RESOLUTION', '\u89e3\u6790\u5ea6'],
          ['REWIND', '\u5012\u8f49'],
          ['SEEK', '\u641c\u5c0b'],
          ['SKIP_AD', '\u7565\u904e\u5ee3\u544a'],
          ['SKIP_TO_LIVE', '\u8df3\u81f3\u5f53\u524d\u76f4\u64ad'],
          ['UNDETERMINED_LANGUAGE', '\u4e0d\u660e'],
          ['UNMUTE', '\u53d6\u6d88\u975c\u97f3'],
          ['UNRECOGNIZED_LANGUAGE', '\u7121\u6cd5\u8fa8\u8b58'],
          ['VOLUME', '\u97f3\u91cf'],
        ]),
      );
    };
    shaka.ui.Locales.Ids = {
      AD_PROGRESS: 'AD_PROGRESS',
      ENTER_PICTURE_IN_PICTURE: 'ENTER_PICTURE_IN_PICTURE',
      MULTIPLE_LANGUAGES: 'MULTIPLE_LANGUAGES',
      BACK: 'BACK',
      VOLUME: 'VOLUME',
      PAUSE: 'PAUSE',
      EXIT_FULL_SCREEN: 'EXIT_FULL_SCREEN',
      NOT_APPLICABLE: 'NOT_APPLICABLE',
      SEEK: 'SEEK',
      AD_DURATION: 'AD_DURATION',
      LANGUAGE: 'LANGUAGE',
      SKIP_TO_LIVE: 'SKIP_TO_LIVE',
      FULL_SCREEN: 'FULL_SCREEN',
      CAST: 'CAST',
      LIVE: 'LIVE',
      UNRECOGNIZED_LANGUAGE: 'UNRECOGNIZED_LANGUAGE',
      RESOLUTION: 'RESOLUTION',
      PICTURE_IN_PICTURE: 'PICTURE_IN_PICTURE',
      PLAY: 'PLAY',
      EXIT_LOOP_MODE: 'EXIT_LOOP_MODE',
      OFF: 'OFF',
      MUTE: 'MUTE',
      UNDETERMINED_LANGUAGE: 'UNDETERMINED_LANGUAGE',
      CAPTIONS: 'CAPTIONS',
      AD_TIME: 'AD_TIME',
      AUTO_QUALITY: 'AUTO_QUALITY',
      ON: 'ON',
      PLAYBACK_RATE: 'PLAYBACK_RATE',
      MORE_SETTINGS: 'MORE_SETTINGS',
      EXIT_PICTURE_IN_PICTURE: 'EXIT_PICTURE_IN_PICTURE',
      ENTER_LOOP_MODE: 'ENTER_LOOP_MODE',
      UNMUTE: 'UNMUTE',
      FAST_FORWARD: 'FAST_FORWARD',
      REWIND: 'REWIND',
      SKIP_AD: 'SKIP_AD',
      LOOP: 'LOOP',
    };
    shaka.abr = {};
    shaka.abr.Ewma = function (a) {
      goog.asserts.assert(0 < a, 'expected halfLife to be positive');
      this.alpha_ = Math.exp(Math.log(0.5) / a);
      this.totalWeight_ = this.estimate_ = 0;
    };
    shaka.abr.Ewma.prototype.sample = function (a, b) {
      var c = Math.pow(this.alpha_, a);
      c = b * (1 - c) + c * this.estimate_;
      isNaN(c) || ((this.estimate_ = c), (this.totalWeight_ += a));
    };
    shaka.abr.Ewma.prototype.getEstimate = function () {
      return this.estimate_ / (1 - Math.pow(this.alpha_, this.totalWeight_));
    };
    shaka.abr.EwmaBandwidthEstimator = function () {
      this.fast_ = new shaka.abr.Ewma(2);
      this.slow_ = new shaka.abr.Ewma(5);
      this.bytesSampled_ = 0;
      this.minTotalBytes_ = 128e3;
      this.minBytes_ = 16e3;
    };
    shaka.abr.EwmaBandwidthEstimator.prototype.sample = function (a, b) {
      if (!(b < this.minBytes_)) {
        var c = (8e3 * b) / a,
          d = a / 1e3;
        this.bytesSampled_ += b;
        this.fast_.sample(d, c);
        this.slow_.sample(d, c);
      }
    };
    shaka.abr.EwmaBandwidthEstimator.prototype.getBandwidthEstimate = function (a) {
      return this.bytesSampled_ < this.minTotalBytes_
        ? a
        : Math.min(this.fast_.getEstimate(), this.slow_.getEstimate());
    };
    shaka.abr.EwmaBandwidthEstimator.prototype.hasGoodEstimate = function () {
      return this.bytesSampled_ >= this.minTotalBytes_;
    };
    shaka.util.Error = function (a, b, c, d) {
      for (var e = [], f = 3; f < arguments.length; ++f) e[f - 3] = arguments[f];
      this.severity = a;
      this.category = b;
      this.code = c;
      this.data = e;
      this.handled = !1;
      if (goog.DEBUG) {
        f = e = 'UNKNOWN';
        for (var g in shaka.util.Error.Category) shaka.util.Error.Category[g] == this.category && (e = g);
        for (var h in shaka.util.Error.Code) shaka.util.Error.Code[h] == this.code && (f = h);
        this.message = 'Shaka Error ' + e + '.' + f + ' (' + this.data.toString() + ')';
        if (shaka.util.Error.createStack)
          try {
            throw Error(this.message);
          } catch (k) {
            this.stack = k.stack;
          }
      }
    };
    shaka.util.Error.prototype.toString = function () {
      return 'shaka.util.Error ' + JSON.stringify(this, null, '  ');
    };
    goog.exportSymbol('shaka.util.Error', shaka.util.Error);
    goog.DEBUG && (shaka.util.Error.createStack = !0);
    shaka.util.Error.Severity = { RECOVERABLE: 1, CRITICAL: 2 };
    goog.exportProperty(shaka.util.Error, 'Severity', shaka.util.Error.Severity);
    shaka.util.Error.Category = {
      NETWORK: 1,
      TEXT: 2,
      MEDIA: 3,
      MANIFEST: 4,
      STREAMING: 5,
      DRM: 6,
      PLAYER: 7,
      CAST: 8,
      STORAGE: 9,
      ADS: 10,
    };
    goog.exportProperty(shaka.util.Error, 'Category', shaka.util.Error.Category);
    shaka.util.Error.Code = {
      UNSUPPORTED_SCHEME: 1e3,
      BAD_HTTP_STATUS: 1001,
      HTTP_ERROR: 1002,
      TIMEOUT: 1003,
      MALFORMED_DATA_URI: 1004,
      REQUEST_FILTER_ERROR: 1006,
      RESPONSE_FILTER_ERROR: 1007,
      MALFORMED_TEST_URI: 1008,
      UNEXPECTED_TEST_REQUEST: 1009,
      ATTEMPTS_EXHAUSTED: 1010,
      INVALID_TEXT_HEADER: 2e3,
      INVALID_TEXT_CUE: 2001,
      UNABLE_TO_DETECT_ENCODING: 2003,
      BAD_ENCODING: 2004,
      INVALID_XML: 2005,
      INVALID_MP4_TTML: 2007,
      INVALID_MP4_VTT: 2008,
      UNABLE_TO_EXTRACT_CUE_START_TIME: 2009,
      BUFFER_READ_OUT_OF_BOUNDS: 3e3,
      JS_INTEGER_OVERFLOW: 3001,
      EBML_OVERFLOW: 3002,
      EBML_BAD_FLOATING_POINT_SIZE: 3003,
      MP4_SIDX_WRONG_BOX_TYPE: 3004,
      MP4_SIDX_INVALID_TIMESCALE: 3005,
      MP4_SIDX_TYPE_NOT_SUPPORTED: 3006,
      WEBM_CUES_ELEMENT_MISSING: 3007,
      WEBM_EBML_HEADER_ELEMENT_MISSING: 3008,
      WEBM_SEGMENT_ELEMENT_MISSING: 3009,
      WEBM_INFO_ELEMENT_MISSING: 3010,
      WEBM_DURATION_ELEMENT_MISSING: 3011,
      WEBM_CUE_TRACK_POSITIONS_ELEMENT_MISSING: 3012,
      WEBM_CUE_TIME_ELEMENT_MISSING: 3013,
      MEDIA_SOURCE_OPERATION_FAILED: 3014,
      MEDIA_SOURCE_OPERATION_THREW: 3015,
      VIDEO_ERROR: 3016,
      QUOTA_EXCEEDED_ERROR: 3017,
      TRANSMUXING_FAILED: 3018,
      UNABLE_TO_GUESS_MANIFEST_TYPE: 4e3,
      DASH_INVALID_XML: 4001,
      DASH_NO_SEGMENT_INFO: 4002,
      DASH_EMPTY_ADAPTATION_SET: 4003,
      DASH_EMPTY_PERIOD: 4004,
      DASH_WEBM_MISSING_INIT: 4005,
      DASH_UNSUPPORTED_CONTAINER: 4006,
      DASH_PSSH_BAD_ENCODING: 4007,
      DASH_NO_COMMON_KEY_SYSTEM: 4008,
      DASH_MULTIPLE_KEY_IDS_NOT_SUPPORTED: 4009,
      DASH_CONFLICTING_KEY_IDS: 4010,
      RESTRICTIONS_CANNOT_BE_MET: 4012,
      HLS_PLAYLIST_HEADER_MISSING: 4015,
      INVALID_HLS_TAG: 4016,
      HLS_INVALID_PLAYLIST_HIERARCHY: 4017,
      DASH_DUPLICATE_REPRESENTATION_ID: 4018,
      HLS_MULTIPLE_MEDIA_INIT_SECTIONS_FOUND: 4020,
      HLS_COULD_NOT_GUESS_MIME_TYPE: 4021,
      HLS_MASTER_PLAYLIST_NOT_PROVIDED: 4022,
      HLS_REQUIRED_ATTRIBUTE_MISSING: 4023,
      HLS_REQUIRED_TAG_MISSING: 4024,
      HLS_COULD_NOT_GUESS_CODECS: 4025,
      HLS_KEYFORMATS_NOT_SUPPORTED: 4026,
      DASH_UNSUPPORTED_XLINK_ACTUATE: 4027,
      DASH_XLINK_DEPTH_LIMIT: 4028,
      HLS_COULD_NOT_PARSE_SEGMENT_START_TIME: 4030,
      CONTENT_UNSUPPORTED_BY_BROWSER: 4032,
      CANNOT_ADD_EXTERNAL_TEXT_TO_LIVE_STREAM: 4033,
      HLS_AES_128_ENCRYPTION_NOT_SUPPORTED: 4034,
      HLS_INTERNAL_SKIP_STREAM: 4035,
      NO_VARIANTS: 4036,
      PERIOD_FLATTENING_FAILED: 4037,
      INCONSISTENT_DRM_ACROSS_PERIODS: 4038,
      HLS_VARIABLE_NOT_FOUND: 4039,
      STREAMING_ENGINE_STARTUP_INVALID_STATE: 5006,
      NO_RECOGNIZED_KEY_SYSTEMS: 6e3,
      REQUESTED_KEY_SYSTEM_CONFIG_UNAVAILABLE: 6001,
      FAILED_TO_CREATE_CDM: 6002,
      FAILED_TO_ATTACH_TO_VIDEO: 6003,
      INVALID_SERVER_CERTIFICATE: 6004,
      FAILED_TO_CREATE_SESSION: 6005,
      FAILED_TO_GENERATE_LICENSE_REQUEST: 6006,
      LICENSE_REQUEST_FAILED: 6007,
      LICENSE_RESPONSE_REJECTED: 6008,
      ENCRYPTED_CONTENT_WITHOUT_DRM_INFO: 6010,
      NO_LICENSE_SERVER_GIVEN: 6012,
      OFFLINE_SESSION_REMOVED: 6013,
      EXPIRED: 6014,
      SERVER_CERTIFICATE_REQUIRED: 6015,
      INIT_DATA_TRANSFORM_ERROR: 6016,
      LOAD_INTERRUPTED: 7e3,
      OPERATION_ABORTED: 7001,
      NO_VIDEO_ELEMENT: 7002,
      OBJECT_DESTROYED: 7003,
      CAST_API_UNAVAILABLE: 8e3,
      NO_CAST_RECEIVERS: 8001,
      ALREADY_CASTING: 8002,
      UNEXPECTED_CAST_ERROR: 8003,
      CAST_CANCELED_BY_USER: 8004,
      CAST_CONNECTION_TIMED_OUT: 8005,
      CAST_RECEIVER_APP_UNAVAILABLE: 8006,
      STORAGE_NOT_SUPPORTED: 9e3,
      INDEXED_DB_ERROR: 9001,
      DEPRECATED_OPERATION_ABORTED: 9002,
      REQUESTED_ITEM_NOT_FOUND: 9003,
      MALFORMED_OFFLINE_URI: 9004,
      CANNOT_STORE_LIVE_OFFLINE: 9005,
      NO_INIT_DATA_FOR_OFFLINE: 9007,
      LOCAL_PLAYER_INSTANCE_REQUIRED: 9008,
      NEW_KEY_OPERATION_NOT_SUPPORTED: 9011,
      KEY_NOT_FOUND: 9012,
      MISSING_STORAGE_CELL: 9013,
      CS_IMA_SDK_MISSING: 1e4,
      CS_AD_MANAGER_NOT_INITIALIZED: 10001,
      SS_IMA_SDK_MISSING: 10002,
      SS_AD_MANAGER_NOT_INITIALIZED: 10003,
      CURRENT_DAI_REQUEST_NOT_FINISHED: 10004,
    };
    goog.exportProperty(shaka.util.Error, 'Code', shaka.util.Error.Code);
    shaka.util.DelayedTick = function (a) {
      this.onTick_ = a;
      this.cancelPending_ = null;
    };
    shaka.util.DelayedTick.prototype.tickAfter = function (a) {
      var b = this;
      this.stop();
      var c = !0,
        d = null;
      this.cancelPending_ = function () {
        window.clearTimeout(d);
        c = !1;
      };
      d = window.setTimeout(function () {
        if (c) b.onTick_();
      }, 1e3 * a);
      return this;
    };
    shaka.util.DelayedTick.prototype.stop = function () {
      this.cancelPending_ && (this.cancelPending_(), (this.cancelPending_ = null));
    };
    shaka.util.Timer = function (a) {
      this.onTick_ = a;
      this.ticker_ = null;
    };
    shaka.util.Timer.prototype.tickNow = function () {
      this.stop();
      this.onTick_();
      return this;
    };
    shaka.util.Timer.prototype.tickAfter = function (a) {
      var b = this;
      this.stop();
      this.ticker_ = new shaka.util.DelayedTick(function () {
        b.onTick_();
      }).tickAfter(a);
      return this;
    };
    shaka.util.Timer.prototype.tickEvery = function (a) {
      var b = this;
      this.stop();
      this.ticker_ = new shaka.util.DelayedTick(function () {
        b.ticker_.tickAfter(a);
        b.onTick_();
      }).tickAfter(a);
      return this;
    };
    shaka.util.Timer.prototype.stop = function () {
      this.ticker_ && (this.ticker_.stop(), (this.ticker_ = null));
    };
    goog.exportSymbol('shaka.util.Timer', shaka.util.Timer);
    goog.exportProperty(shaka.util.Timer.prototype, 'stop', shaka.util.Timer.prototype.stop);
    goog.exportProperty(shaka.util.Timer.prototype, 'tickEvery', shaka.util.Timer.prototype.tickEvery);
    goog.exportProperty(shaka.util.Timer.prototype, 'tickAfter', shaka.util.Timer.prototype.tickAfter);
    goog.exportProperty(shaka.util.Timer.prototype, 'tickNow', shaka.util.Timer.prototype.tickNow);
    shaka.net = {};
    shaka.net.Backoff = function (a, b) {
      b = void 0 === b ? !1 : b;
      var c = shaka.net.Backoff.defaultRetryParameters();
      this.maxAttempts_ = null == a.maxAttempts ? c.maxAttempts : a.maxAttempts;
      goog.asserts.assert(1 <= this.maxAttempts_, 'maxAttempts should be >= 1');
      this.baseDelay_ = null == a.baseDelay ? c.baseDelay : a.baseDelay;
      goog.asserts.assert(0 <= this.baseDelay_, 'baseDelay should be >= 0');
      this.fuzzFactor_ = null == a.fuzzFactor ? c.fuzzFactor : a.fuzzFactor;
      goog.asserts.assert(0 <= this.fuzzFactor_, 'fuzzFactor should be >= 0');
      this.backoffFactor_ = null == a.backoffFactor ? c.backoffFactor : a.backoffFactor;
      goog.asserts.assert(0 <= this.backoffFactor_, 'backoffFactor should be >= 0');
      this.numAttempts_ = 0;
      this.nextUnfuzzedDelay_ = this.baseDelay_;
      if ((this.autoReset_ = b))
        goog.asserts.assert(2 <= this.maxAttempts_, 'maxAttempts must be >= 2 for autoReset == true'),
          (this.numAttempts_ = 1);
    };
    shaka.net.Backoff.prototype.attempt = function () {
      var a = this,
        b,
        c;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (d) {
        if (1 == d.nextAddress) {
          if (a.numAttempts_ >= a.maxAttempts_)
            if (a.autoReset_) a.reset_();
            else
              throw new shaka.util.Error(
                shaka.util.Error.Severity.CRITICAL,
                shaka.util.Error.Category.PLAYER,
                shaka.util.Error.Code.ATTEMPTS_EXHAUSTED,
              );
          b = a.numAttempts_;
          a.numAttempts_++;
          if (0 == b) return goog.asserts.assert(!a.autoReset_, 'Failed to delay with auto-reset!'), d['return']();
          c = shaka.net.Backoff.fuzz_(a.nextUnfuzzedDelay_, a.fuzzFactor_);
          return d.yield(
            new Promise(function (e) {
              shaka.net.Backoff.defer(c, e);
            }),
            2,
          );
        }
        a.nextUnfuzzedDelay_ *= a.backoffFactor_;
        d.jumpToEnd();
      });
    };
    shaka.net.Backoff.defaultRetryParameters = function () {
      return { maxAttempts: 2, baseDelay: 1e3, backoffFactor: 2, fuzzFactor: 0.5, timeout: 0 };
    };
    shaka.net.Backoff.fuzz_ = function (a, b) {
      return a * (1 + (2 * Math.random() - 1) * b);
    };
    shaka.net.Backoff.prototype.reset_ = function () {
      goog.asserts.assert(this.autoReset_, 'Should only be used for auto-reset!');
      this.numAttempts_ = 1;
      this.nextUnfuzzedDelay_ = this.baseDelay_;
    };
    shaka.net.Backoff.defer = function (a, b) {
      new shaka.util.Timer(b).tickAfter(a / 1e3);
    };
    shaka.util.PublicPromise = function () {
      var a,
        b,
        c = new Promise(function (d, e) {
          a = d;
          b = e;
        });
      c.resolve = a;
      c.reject = b;
      return c;
    };
    shaka.util.PublicPromise.prototype.resolve = function (a) {};
    shaka.util.PublicPromise.prototype.reject = function (a) {};
    shaka.util.AbortableOperation = function (a, b) {
      this.promise = a;
      this.onAbort_ = b;
      this.aborted_ = !1;
    };
    shaka.util.AbortableOperation.failed = function (a) {
      return new shaka.util.AbortableOperation(Promise.reject(a), function () {
        return Promise.resolve();
      });
    };
    shaka.util.AbortableOperation.aborted = function () {
      var a = Promise.reject(shaka.util.AbortableOperation.abortError());
      a['catch'](function () {});
      return new shaka.util.AbortableOperation(a, function () {
        return Promise.resolve();
      });
    };
    shaka.util.AbortableOperation.abortError = function () {
      return new shaka.util.Error(
        shaka.util.Error.Severity.CRITICAL,
        shaka.util.Error.Category.PLAYER,
        shaka.util.Error.Code.OPERATION_ABORTED,
      );
    };
    shaka.util.AbortableOperation.completed = function (a) {
      return new shaka.util.AbortableOperation(Promise.resolve(a), function () {
        return Promise.resolve();
      });
    };
    shaka.util.AbortableOperation.notAbortable = function (a) {
      return new shaka.util.AbortableOperation(a, function () {
        return a['catch'](function () {});
      });
    };
    shaka.util.AbortableOperation.prototype.abort = function () {
      this.aborted_ = !0;
      return this.onAbort_();
    };
    shaka.util.AbortableOperation.all = function (a) {
      return new shaka.util.AbortableOperation(
        Promise.all(
          a.map(function (b) {
            return b.promise;
          }),
        ),
        function () {
          return Promise.all(
            a.map(function (b) {
              return b.abort();
            }),
          );
        },
      );
    };
    shaka.util.AbortableOperation.prototype['finally'] = function (a) {
      this.promise.then(
        function (b) {
          return a(!0);
        },
        function (b) {
          return a(!1);
        },
      );
      return this;
    };
    shaka.util.AbortableOperation.prototype.chain = function (a, b) {
      var c = this,
        d = new shaka.util.PublicPromise(),
        e = shaka.util.AbortableOperation.abortError(),
        f = function () {
          d.reject(e);
          return c.abort();
        },
        g = function (h) {
          return function (k) {
            if (c.aborted_ && h) d.reject(e);
            else {
              var l = h ? a : b;
              l ? (f = shaka.util.AbortableOperation.wrapChainCallback_(l, k, d)) : (h ? d.resolve : d.reject)(k);
            }
          };
        };
      this.promise.then(g(!0), g(!1));
      return new shaka.util.AbortableOperation(d, function () {
        return f();
      });
    };
    shaka.util.AbortableOperation.wrapChainCallback_ = function (a, b, c) {
      try {
        var d = a(b);
        if (d && d.promise && d.abort)
          return (
            c.resolve(d.promise),
            function () {
              return d.abort();
            }
          );
        c.resolve(d);
        return function () {
          return Promise.resolve(d).then(
            function () {},
            function () {},
          );
        };
      } catch (e) {
        return (
          c.reject(e),
          function () {
            return Promise.resolve();
          }
        );
      }
    };
    goog.exportSymbol('shaka.util.AbortableOperation', shaka.util.AbortableOperation);
    goog.exportProperty(
      shaka.util.AbortableOperation.prototype,
      'chain',
      shaka.util.AbortableOperation.prototype.chain,
    );
    goog.exportProperty(
      shaka.util.AbortableOperation.prototype,
      'finally',
      shaka.util.AbortableOperation.prototype['finally'],
    );
    goog.exportProperty(shaka.util.AbortableOperation, 'all', shaka.util.AbortableOperation.all);
    goog.exportProperty(
      shaka.util.AbortableOperation.prototype,
      'abort',
      shaka.util.AbortableOperation.prototype.abort,
    );
    goog.exportProperty(shaka.util.AbortableOperation, 'notAbortable', shaka.util.AbortableOperation.notAbortable);
    goog.exportProperty(shaka.util.AbortableOperation, 'completed', shaka.util.AbortableOperation.completed);
    goog.exportProperty(shaka.util.AbortableOperation, 'aborted', shaka.util.AbortableOperation.aborted);
    goog.exportProperty(shaka.util.AbortableOperation, 'failed', shaka.util.AbortableOperation.failed);
    shaka.util.BufferUtils = function () {};
    shaka.util.BufferUtils.equal = function (a, b) {
      var c = shaka.util.BufferUtils;
      if (!a && !b) return !0;
      if (!a || !b || a.byteLength != b.byteLength) return !1;
      if (c.unsafeGetArrayBuffer_(a) == c.unsafeGetArrayBuffer_(b) && (a.byteOffset || 0) == (b.byteOffset || 0))
        return !0;
      c = shaka.util.BufferUtils.toUint8(a);
      for (
        var d = shaka.util.BufferUtils.toUint8(b),
          e = $jscomp.makeIterator(shaka.util.Iterables.range(a.byteLength)),
          f = e.next();
        !f.done;
        f = e.next()
      )
        if (((f = f.value), c[f] != d[f])) return !1;
      return !0;
    };
    shaka.util.BufferUtils.unsafeGetArrayBuffer_ = function (a) {
      return a instanceof ArrayBuffer ? a : a.buffer;
    };
    shaka.util.BufferUtils.toArrayBuffer = function (a) {
      return a instanceof ArrayBuffer
        ? a
        : 0 == a.byteOffset && a.byteLength == a.buffer.byteLength
        ? a.buffer
        : new Uint8Array(a).buffer;
    };
    shaka.util.BufferUtils.toUint8 = function (a, b, c) {
      c = void 0 === c ? Infinity : c;
      return shaka.util.BufferUtils.view_(a, void 0 === b ? 0 : b, c, Uint8Array);
    };
    shaka.util.BufferUtils.toDataView = function (a, b, c) {
      c = void 0 === c ? Infinity : c;
      return shaka.util.BufferUtils.view_(a, void 0 === b ? 0 : b, c, DataView);
    };
    shaka.util.BufferUtils.view_ = function (a, b, c, d) {
      var e = shaka.util.BufferUtils.unsafeGetArrayBuffer_(a),
        f = (a.byteOffset || 0) + a.byteLength;
      a = Math.max(0, Math.min((a.byteOffset || 0) + b, f));
      return new d(e, a, Math.min(a + Math.max(c, 0), f) - a);
    };
    goog.exportSymbol('shaka.util.BufferUtils', shaka.util.BufferUtils);
    goog.exportProperty(shaka.util.BufferUtils, 'toDataView', shaka.util.BufferUtils.toDataView);
    goog.exportProperty(shaka.util.BufferUtils, 'toUint8', shaka.util.BufferUtils.toUint8);
    goog.exportProperty(shaka.util.BufferUtils, 'toArrayBuffer', shaka.util.BufferUtils.toArrayBuffer);
    goog.exportProperty(shaka.util.BufferUtils, 'equal', shaka.util.BufferUtils.equal);
    shaka.util.IDestroyable = function () {};
    shaka.util.IDestroyable.prototype.destroy = function () {};
    shaka.util.ObjectUtils = function () {};
    shaka.util.ObjectUtils.cloneObject = function (a) {
      var b = new Set(),
        c = function (d) {
          switch (typeof d) {
            case 'undefined':
            case 'boolean':
            case 'number':
            case 'string':
            case 'symbol':
            case 'function':
              return d;
            default:
              if (!d || (d.buffer && d.buffer.constructor == ArrayBuffer)) return d;
              if (b.has(d)) return null;
              var e = d.constructor == Array;
              if (d.constructor != Object && !e) return null;
              b.add(d);
              var f = e ? [] : {},
                g;
              for (g in d) f[g] = c(d[g]);
              e && (f.length = d.length);
              return f;
          }
        };
      return c(a);
    };
    shaka.util.ObjectUtils.shallowCloneObject = function (a) {
      var b = {},
        c;
      for (c in a) b[c] = a[c];
      return b;
    };
    shaka.util.ArrayUtils = function () {};
    shaka.util.ArrayUtils.defaultEquals = function (a, b) {
      return 'number' === typeof a && 'number' === typeof b && isNaN(a) && isNaN(b) ? !0 : a === b;
    };
    shaka.util.ArrayUtils.remove = function (a, b) {
      var c = a.indexOf(b);
      -1 < c && a.splice(c, 1);
    };
    shaka.util.ArrayUtils.count = function (a, b) {
      for (var c = 0, d = $jscomp.makeIterator(a), e = d.next(); !e.done; e = d.next()) c += b(e.value) ? 1 : 0;
      return c;
    };
    shaka.util.ArrayUtils.hasSameElements = function (a, b, c) {
      c || (c = shaka.util.ArrayUtils.defaultEquals);
      if (a.length != b.length) return !1;
      b = b.slice();
      var d = {};
      a = $jscomp.makeIterator(a);
      for (var e = a.next(); !e.done; d = { $jscomp$loop$prop$item$513: d.$jscomp$loop$prop$item$513 }, e = a.next()) {
        d.$jscomp$loop$prop$item$513 = e.value;
        e = b.findIndex(
          (function (f) {
            return function (g) {
              return c(f.$jscomp$loop$prop$item$513, g);
            };
          })(d),
        );
        if (-1 == e) return !1;
        b[e] = b[b.length - 1];
        b.pop();
      }
      return 0 == b.length;
    };
    shaka.util.ArrayUtils.equal = function (a, b, c) {
      c || (c = shaka.util.ArrayUtils.defaultEquals);
      if (a.length != b.length) return !1;
      for (var d = 0; d < a.length; d++) if (!c(a[d], b[d])) return !1;
      return !0;
    };
    shaka.util.OperationManager = function () {
      this.operations_ = [];
    };
    shaka.util.OperationManager.prototype.manage = function (a) {
      var b = this;
      this.operations_.push(
        a['finally'](function () {
          shaka.util.ArrayUtils.remove(b.operations_, a);
        }),
      );
    };
    shaka.util.OperationManager.prototype.destroy = function () {
      for (var a = [], b = $jscomp.makeIterator(this.operations_), c = b.next(); !c.done; c = b.next())
        (c = c.value), c.promise['catch'](function () {}), a.push(c.abort());
      this.operations_ = [];
      return Promise.all(a);
    };
    shaka.net.NetworkingEngine = function (a) {
      shaka.util.FakeEventTarget.call(this);
      this.destroyed_ = !1;
      this.operationManager_ = new shaka.util.OperationManager();
      this.requestFilters_ = new Set();
      this.responseFilters_ = new Set();
      this.onProgressUpdated_ = a || null;
    };
    $jscomp.inherits(shaka.net.NetworkingEngine, shaka.util.FakeEventTarget);
    shaka.net.NetworkingEngine.registerScheme = function (a, b, c) {
      goog.asserts.assert(void 0 == c || 0 < c, 'explicit priority must be > 0');
      c = c || shaka.net.NetworkingEngine.PluginPriority.APPLICATION;
      var d = shaka.net.NetworkingEngine.schemes_[a];
      if (!d || c >= d.priority) shaka.net.NetworkingEngine.schemes_[a] = { priority: c, plugin: b };
    };
    shaka.net.NetworkingEngine.unregisterScheme = function (a) {
      delete shaka.net.NetworkingEngine.schemes_[a];
    };
    shaka.net.NetworkingEngine.prototype.registerRequestFilter = function (a) {
      this.requestFilters_.add(a);
    };
    shaka.net.NetworkingEngine.prototype.unregisterRequestFilter = function (a) {
      this.requestFilters_['delete'](a);
    };
    shaka.net.NetworkingEngine.prototype.clearAllRequestFilters = function () {
      this.requestFilters_.clear();
    };
    shaka.net.NetworkingEngine.prototype.registerResponseFilter = function (a) {
      this.responseFilters_.add(a);
    };
    shaka.net.NetworkingEngine.prototype.unregisterResponseFilter = function (a) {
      this.responseFilters_['delete'](a);
    };
    shaka.net.NetworkingEngine.prototype.clearAllResponseFilters = function () {
      this.responseFilters_.clear();
    };
    shaka.net.NetworkingEngine.defaultRetryParameters = function () {
      return shaka.net.Backoff.defaultRetryParameters();
    };
    shaka.net.NetworkingEngine.makeRequest = function (a, b) {
      return {
        uris: a,
        method: 'GET',
        body: null,
        headers: {},
        allowCrossSiteCredentials: !1,
        retryParameters: b,
        licenseRequestType: null,
        sessionId: null,
      };
    };
    shaka.net.NetworkingEngine.prototype.destroy = function () {
      this.destroyed_ = !0;
      this.requestFilters_.clear();
      this.responseFilters_.clear();
      return this.operationManager_.destroy();
    };
    shaka.net.NetworkingEngine.prototype.request = function (a, b) {
      var c = this,
        d = shaka.util.ObjectUtils,
        e = new shaka.net.NetworkingEngine.NumBytesRemainingClass();
      if (this.destroyed_)
        return (
          (d = Promise.reject(
            new shaka.util.Error(
              shaka.util.Error.Severity.CRITICAL,
              shaka.util.Error.Category.PLAYER,
              shaka.util.Error.Code.OPERATION_ABORTED,
            ),
          )),
          d['catch'](function () {}),
          new shaka.net.NetworkingEngine.PendingRequest(
            d,
            function () {
              return Promise.resolve();
            },
            e,
          )
        );
      goog.asserts.assert(b.uris && b.uris.length, 'Request without URIs!');
      b.method = b.method || 'GET';
      b.headers = b.headers || {};
      b.retryParameters = b.retryParameters
        ? d.cloneObject(b.retryParameters)
        : shaka.net.NetworkingEngine.defaultRetryParameters();
      b.uris = d.cloneObject(b.uris);
      d = this.filterRequest_(a, b);
      var f = d.chain(function () {
          return c.makeRequestWithRetry_(a, b, e);
        }),
        g = f.chain(function (n) {
          return c.filterResponse_(a, n);
        }),
        h = Date.now(),
        k = 0;
      d.promise.then(
        function () {
          k = Date.now() - h;
        },
        function () {},
      );
      var l = 0;
      f.promise.then(
        function () {
          l = Date.now();
        },
        function () {},
      );
      var m = g.chain(
        function (n) {
          var p = Date.now() - l,
            q = n.response;
          q.timeMs += k;
          q.timeMs += p;
          if (
            !n.gotProgress &&
            c.onProgressUpdated_ &&
            !q.fromCache &&
            a == shaka.net.NetworkingEngine.RequestType.SEGMENT
          )
            c.onProgressUpdated_(q.timeMs, q.data.byteLength);
          return q;
        },
        function (n) {
          n &&
            (goog.asserts.assert(n instanceof shaka.util.Error, 'Wrong error type'),
            (n.severity = shaka.util.Error.Severity.CRITICAL));
          throw n;
        },
      );
      d = new shaka.net.NetworkingEngine.PendingRequest(
        m.promise,
        function () {
          return m.abort();
        },
        e,
      );
      this.operationManager_.manage(d);
      return d;
    };
    shaka.net.NetworkingEngine.prototype.filterRequest_ = function (a, b) {
      for (
        var c = shaka.util.AbortableOperation.completed(void 0),
          d = {},
          e = $jscomp.makeIterator(this.requestFilters_),
          f = e.next();
        !f.done;
        d = { $jscomp$loop$prop$requestFilter$515: d.$jscomp$loop$prop$requestFilter$515 }, f = e.next()
      )
        (d.$jscomp$loop$prop$requestFilter$515 = f.value),
          (c = c.chain(
            (function (g) {
              return function () {
                b.body && (b.body = shaka.util.BufferUtils.toArrayBuffer(b.body));
                return g.$jscomp$loop$prop$requestFilter$515(a, b);
              };
            })(d),
          ));
      return c.chain(void 0, function (g) {
        if (g instanceof shaka.util.Error && g.code == shaka.util.Error.Code.OPERATION_ABORTED) throw g;
        throw new shaka.util.Error(
          shaka.util.Error.Severity.CRITICAL,
          shaka.util.Error.Category.NETWORK,
          shaka.util.Error.Code.REQUEST_FILTER_ERROR,
          g,
        );
      });
    };
    shaka.net.NetworkingEngine.prototype.makeRequestWithRetry_ = function (a, b, c) {
      var d = new shaka.net.Backoff(b.retryParameters, !1);
      return this.send_(a, b, d, 0, null, c);
    };
    shaka.net.NetworkingEngine.prototype.send_ = function (a, b, c, d, e, f) {
      var g = this,
        h = new goog.Uri(b.uris[d]),
        k = h.getScheme(),
        l = !1;
      k ||
        ((k = shaka.net.NetworkingEngine.getLocationProtocol_()),
        goog.asserts.assert(':' == k[k.length - 1], 'location.protocol expected to end with a colon!'),
        (k = k.slice(0, -1)),
        h.setScheme(k),
        (b.uris[d] = h.toString()));
      k = k.toLowerCase();
      var m = (k = shaka.net.NetworkingEngine.schemes_[k]) ? k.plugin : null;
      if (!m)
        return shaka.util.AbortableOperation.failed(
          new shaka.util.Error(
            shaka.util.Error.Severity.CRITICAL,
            shaka.util.Error.Category.NETWORK,
            shaka.util.Error.Code.UNSUPPORTED_SCHEME,
            h,
          ),
        );
      var n;
      return shaka.util.AbortableOperation.notAbortable(c.attempt())
        .chain(function () {
          if (g.destroyed_) return shaka.util.AbortableOperation.aborted();
          n = Date.now();
          var p = shaka.net.NetworkingEngine.RequestType.SEGMENT;
          return m(b.uris[d], b, a, function (q, r, t) {
            g.onProgressUpdated_ && a == p && (g.onProgressUpdated_(q, r), (l = !0), f.setBytes(t));
          });
        })
        .chain(
          function (p) {
            void 0 == p.timeMs && (p.timeMs = Date.now() - n);
            return { response: p, gotProgress: l };
          },
          function (p) {
            if (g.destroyed_) return shaka.util.AbortableOperation.aborted();
            if (p instanceof shaka.util.Error) {
              if (p.code == shaka.util.Error.Code.OPERATION_ABORTED) throw p;
              if (p.code == shaka.util.Error.Code.ATTEMPTS_EXHAUSTED)
                throw (goog.asserts.assert(e, 'Should have last error'), e);
              if (p.severity == shaka.util.Error.Severity.RECOVERABLE) {
                var q = new shaka.util.FakeEvent('retry', { error: p });
                g.dispatchEvent(q);
                d = (d + 1) % b.uris.length;
                return g.send_(a, b, c, d, p, f);
              }
            }
            throw p;
          },
        );
    };
    shaka.net.NetworkingEngine.prototype.filterResponse_ = function (a, b) {
      for (
        var c = shaka.util.AbortableOperation.completed(void 0),
          d = {},
          e = $jscomp.makeIterator(this.responseFilters_),
          f = e.next();
        !f.done;
        d = { $jscomp$loop$prop$responseFilter$517: d.$jscomp$loop$prop$responseFilter$517 }, f = e.next()
      )
        (d.$jscomp$loop$prop$responseFilter$517 = f.value),
          (c = c.chain(
            (function (g) {
              return function () {
                var h = b.response;
                h.data && (h.data = shaka.util.BufferUtils.toArrayBuffer(h.data));
                return g.$jscomp$loop$prop$responseFilter$517(a, h);
              };
            })(d),
          ));
      return c.chain(
        function () {
          return b;
        },
        function (g) {
          var h = shaka.util.Error.Severity.CRITICAL;
          if (g instanceof shaka.util.Error) {
            if (g.code == shaka.util.Error.Code.OPERATION_ABORTED) throw g;
            h = g.severity;
          }
          throw new shaka.util.Error(
            h,
            shaka.util.Error.Category.NETWORK,
            shaka.util.Error.Code.RESPONSE_FILTER_ERROR,
            g,
          );
        },
      );
    };
    shaka.net.NetworkingEngine.getLocationProtocol_ = function () {
      return location.protocol;
    };
    goog.exportSymbol('shaka.net.NetworkingEngine', shaka.net.NetworkingEngine);
    goog.exportProperty(shaka.net.NetworkingEngine.prototype, 'request', shaka.net.NetworkingEngine.prototype.request);
    goog.exportProperty(shaka.net.NetworkingEngine.prototype, 'destroy', shaka.net.NetworkingEngine.prototype.destroy);
    goog.exportProperty(shaka.net.NetworkingEngine, 'makeRequest', shaka.net.NetworkingEngine.makeRequest);
    goog.exportProperty(
      shaka.net.NetworkingEngine,
      'defaultRetryParameters',
      shaka.net.NetworkingEngine.defaultRetryParameters,
    );
    goog.exportProperty(
      shaka.net.NetworkingEngine.prototype,
      'clearAllResponseFilters',
      shaka.net.NetworkingEngine.prototype.clearAllResponseFilters,
    );
    goog.exportProperty(
      shaka.net.NetworkingEngine.prototype,
      'unregisterResponseFilter',
      shaka.net.NetworkingEngine.prototype.unregisterResponseFilter,
    );
    goog.exportProperty(
      shaka.net.NetworkingEngine.prototype,
      'registerResponseFilter',
      shaka.net.NetworkingEngine.prototype.registerResponseFilter,
    );
    goog.exportProperty(
      shaka.net.NetworkingEngine.prototype,
      'clearAllRequestFilters',
      shaka.net.NetworkingEngine.prototype.clearAllRequestFilters,
    );
    goog.exportProperty(
      shaka.net.NetworkingEngine.prototype,
      'unregisterRequestFilter',
      shaka.net.NetworkingEngine.prototype.unregisterRequestFilter,
    );
    goog.exportProperty(
      shaka.net.NetworkingEngine.prototype,
      'registerRequestFilter',
      shaka.net.NetworkingEngine.prototype.registerRequestFilter,
    );
    goog.exportProperty(shaka.net.NetworkingEngine, 'unregisterScheme', shaka.net.NetworkingEngine.unregisterScheme);
    goog.exportProperty(shaka.net.NetworkingEngine, 'registerScheme', shaka.net.NetworkingEngine.registerScheme);
    shaka.net.NetworkingEngine.NumBytesRemainingClass = function () {
      this.bytesToLoad_ = 0;
    };
    shaka.net.NetworkingEngine.NumBytesRemainingClass.prototype.setBytes = function (a) {
      this.bytesToLoad_ = a;
    };
    shaka.net.NetworkingEngine.NumBytesRemainingClass.prototype.getBytes = function () {
      return this.bytesToLoad_;
    };
    goog.exportProperty(
      shaka.net.NetworkingEngine,
      'NumBytesRemainingClass',
      shaka.net.NetworkingEngine.NumBytesRemainingClass,
    );
    shaka.net.NetworkingEngine.PendingRequest = function (a, b, c) {
      shaka.util.AbortableOperation.call(this, a, b);
      this.bytesRemaining_ = c;
    };
    $jscomp.inherits(shaka.net.NetworkingEngine.PendingRequest, shaka.util.AbortableOperation);
    shaka.net.NetworkingEngine.PendingRequest.prototype.getBytesRemaining = function () {
      return this.bytesRemaining_.getBytes();
    };
    goog.exportProperty(shaka.net.NetworkingEngine, 'PendingRequest', shaka.net.NetworkingEngine.PendingRequest);
    shaka.net.NetworkingEngine.RequestType = { MANIFEST: 0, SEGMENT: 1, LICENSE: 2, APP: 3, TIMING: 4 };
    goog.exportProperty(shaka.net.NetworkingEngine, 'RequestType', shaka.net.NetworkingEngine.RequestType);
    shaka.net.NetworkingEngine.PluginPriority = { FALLBACK: 1, PREFERRED: 2, APPLICATION: 3 };
    goog.exportProperty(shaka.net.NetworkingEngine, 'PluginPriority', shaka.net.NetworkingEngine.PluginPriority);
    shaka.net.NetworkingEngine.schemes_ = {};
    shaka.util.Destroyer = function (a) {
      this.destroyed_ = !1;
      this.waitOnDestroy_ = new shaka.util.PublicPromise();
      this.onDestroy_ = a;
    };
    shaka.util.Destroyer.prototype.destroyed = function () {
      return this.destroyed_;
    };
    shaka.util.Destroyer.prototype.destroy = function () {
      var a = this;
      if (this.destroyed_) return this.waitOnDestroy_;
      this.destroyed_ = !0;
      return this.onDestroy_().then(
        function () {
          a.waitOnDestroy_.resolve();
        },
        function () {
          a.waitOnDestroy_.resolve();
        },
      );
    };
    shaka.util.Destroyer.prototype.ensureNotDestroyed = function (a) {
      if (this.destroyed_) {
        if (a instanceof shaka.util.Error && a.code == shaka.util.Error.Code.OBJECT_DESTROYED) throw a;
        throw shaka.util.Destroyer.destroyedError(a);
      }
    };
    shaka.util.Destroyer.destroyedError = function (a) {
      return new shaka.util.Error(
        shaka.util.Error.Severity.CRITICAL,
        shaka.util.Error.Category.PLAYER,
        shaka.util.Error.Code.OBJECT_DESTROYED,
        a,
      );
    };
    shaka.util.IReleasable = function () {};
    shaka.util.IReleasable.prototype.release = function () {};
    shaka.util.EventManager = function () {
      this.bindingMap_ = new shaka.util.MultiMap();
    };
    shaka.util.EventManager.prototype.release = function () {
      this.removeAll();
      this.bindingMap_ = null;
    };
    shaka.util.EventManager.prototype.listen = function (a, b, c, d) {
      this.bindingMap_ && ((a = new shaka.util.EventManager.Binding_(a, b, c, d)), this.bindingMap_.push(b, a));
    };
    shaka.util.EventManager.prototype.listenOnce = function (a, b, c, d) {
      var e = this,
        f = function (g) {
          e.unlisten(a, b, f);
          c(g);
        };
      this.listen(a, b, f, d);
    };
    shaka.util.EventManager.prototype.unlisten = function (a, b, c) {
      if (this.bindingMap_) {
        var d = this.bindingMap_.get(b) || [];
        d = $jscomp.makeIterator(d);
        for (var e = d.next(); !e.done; e = d.next())
          (e = e.value), e.target != a || (c != e.listener && c) || (e.unlisten(), this.bindingMap_.remove(b, e));
      }
    };
    shaka.util.EventManager.prototype.removeAll = function () {
      if (this.bindingMap_) {
        var a = this.bindingMap_.getAll();
        a = $jscomp.makeIterator(a);
        for (var b = a.next(); !b.done; b = a.next()) b.value.unlisten();
        this.bindingMap_.clear();
      }
    };
    goog.exportSymbol('shaka.util.EventManager', shaka.util.EventManager);
    goog.exportProperty(shaka.util.EventManager.prototype, 'removeAll', shaka.util.EventManager.prototype.removeAll);
    goog.exportProperty(shaka.util.EventManager.prototype, 'unlisten', shaka.util.EventManager.prototype.unlisten);
    goog.exportProperty(shaka.util.EventManager.prototype, 'listenOnce', shaka.util.EventManager.prototype.listenOnce);
    goog.exportProperty(shaka.util.EventManager.prototype, 'listen', shaka.util.EventManager.prototype.listen);
    goog.exportProperty(shaka.util.EventManager.prototype, 'release', shaka.util.EventManager.prototype.release);
    shaka.util.EventManager.Binding_ = function (a, b, c, d) {
      this.target = a;
      this.type = b;
      this.listener = c;
      this.options = shaka.util.EventManager.Binding_.convertOptions_(a, d);
      this.target.addEventListener(b, c, this.options);
    };
    shaka.util.EventManager.Binding_.prototype.unlisten = function () {
      goog.asserts.assert(this.target, 'Missing target');
      this.target.removeEventListener(this.type, this.listener, this.options);
      this.listener = this.target = null;
      this.options = !1;
    };
    shaka.util.EventManager.Binding_.convertOptions_ = function (a, b) {
      if (void 0 == b) return !1;
      if ('boolean' == typeof b) return b;
      var c = new Set(['passive', 'capture']),
        d = Object.keys(b).filter(function (e) {
          return !c.has(e);
        });
      goog.asserts.assert(0 == d.length, 'Unsupported flag(s) to addEventListener: ' + d.join(','));
      return shaka.util.EventManager.Binding_.doesSupportObject_(a) ? b : b.capture || !1;
    };
    shaka.util.EventManager.Binding_.doesSupportObject_ = function (a) {
      var b = shaka.util.EventManager.Binding_.supportsObject_;
      if (void 0 == b) {
        b = !1;
        try {
          var c = {},
            d = {
              get: function () {
                b = !0;
                return !1;
              },
            };
          Object.defineProperty(c, 'passive', d);
          Object.defineProperty(c, 'capture', d);
          d = function () {};
          a.addEventListener('test', d, c);
          a.removeEventListener('test', d, c);
        } catch (e) {
          b = !1;
        }
        shaka.util.EventManager.Binding_.supportsObject_ = b;
      }
      return b || !1;
    };
    shaka.util.EventManager.Binding_.supportsObject_ = void 0;
    shaka.util.Lazy = function (a) {
      this.gen_ = a;
      this.value_ = void 0;
    };
    shaka.util.Lazy.prototype.value = function () {
      void 0 == this.value_ &&
        ((this.value_ = this.gen_()), goog.asserts.assert(void 0 != this.value_, 'Unable to create lazy value'));
      return this.value_;
    };
    shaka.util.Lazy.prototype.reset = function () {
      this.value_ = void 0;
    };
    shaka.util.StringUtils = function () {};
    shaka.util.StringUtils.fromUTF8 = function (a) {
      if (!a) return '';
      a = shaka.util.BufferUtils.toUint8(a);
      239 == a[0] && 187 == a[1] && 191 == a[2] && (a = a.subarray(3));
      a = shaka.util.StringUtils.fromCharCode(a);
      a = escape(a);
      try {
        return decodeURIComponent(a);
      } catch (b) {
        throw new shaka.util.Error(
          shaka.util.Error.Severity.CRITICAL,
          shaka.util.Error.Category.TEXT,
          shaka.util.Error.Code.BAD_ENCODING,
        );
      }
    };
    shaka.util.StringUtils.fromUTF16 = function (a, b, c) {
      if (!a) return '';
      if (!c && 0 != a.byteLength % 2)
        throw (
          (shaka.log.error('Data has an incorrect length, must be even.'),
          new shaka.util.Error(
            shaka.util.Error.Severity.CRITICAL,
            shaka.util.Error.Category.TEXT,
            shaka.util.Error.Code.BAD_ENCODING,
          ))
        );
      var d = Math.floor(a.byteLength / 2);
      c = new Uint16Array(d);
      a = shaka.util.BufferUtils.toDataView(a);
      d = $jscomp.makeIterator(shaka.util.Iterables.range(d));
      for (var e = d.next(); !e.done; e = d.next()) (e = e.value), (c[e] = a.getUint16(2 * e, b));
      return shaka.util.StringUtils.fromCharCode(c);
    };
    shaka.util.StringUtils.fromBytesAutoDetect = function (a) {
      var b = shaka.util.StringUtils;
      if (!a) return '';
      var c = shaka.util.BufferUtils.toUint8(a);
      if (239 == c[0] && 187 == c[1] && 191 == c[2]) return b.fromUTF8(c);
      if (254 == c[0] && 255 == c[1]) return b.fromUTF16(c.subarray(2), !1);
      if (255 == c[0] && 254 == c[1]) return b.fromUTF16(c.subarray(2), !0);
      var d = function (e) {
        return c.byteLength <= e || (32 <= c[e] && 126 >= c[e]);
      };
      shaka.log.debug('Unable to find byte-order-mark, making an educated guess.');
      if (0 == c[0] && 0 == c[2]) return b.fromUTF16(a, !1);
      if (0 == c[1] && 0 == c[3]) return b.fromUTF16(a, !0);
      if (d(0) && d(1) && d(2) && d(3)) return b.fromUTF8(a);
      throw new shaka.util.Error(
        shaka.util.Error.Severity.CRITICAL,
        shaka.util.Error.Category.TEXT,
        shaka.util.Error.Code.UNABLE_TO_DETECT_ENCODING,
      );
    };
    shaka.util.StringUtils.toUTF8 = function (a) {
      a = encodeURIComponent(a);
      var b = unescape(a);
      a = new Uint8Array(b.length);
      b = $jscomp.makeIterator(shaka.util.Iterables.enumerate(b));
      for (var c = b.next(); !c.done; c = b.next()) (c = c.value), (a[c.i] = c.item.charCodeAt(0));
      return shaka.util.BufferUtils.toArrayBuffer(a);
    };
    shaka.util.StringUtils.toUTF16 = function (a, b) {
      for (
        var c = new ArrayBuffer(2 * a.length),
          d = new DataView(c),
          e = $jscomp.makeIterator(shaka.util.Iterables.enumerate(a)),
          f = e.next();
        !f.done;
        f = e.next()
      ) {
        var g = f.value;
        f = g.i;
        g = g.item.charCodeAt(0);
        d.setUint16(2 * f, g, b);
      }
      return c;
    };
    shaka.util.StringUtils.fromCharCode = function (a) {
      return shaka.util.StringUtils.fromCharCodeImpl_.value()(a);
    };
    shaka.util.StringUtils.resetFromCharCode = function () {
      shaka.util.StringUtils.fromCharCodeImpl_.reset();
    };
    goog.exportSymbol('shaka.util.StringUtils', shaka.util.StringUtils);
    goog.exportProperty(shaka.util.StringUtils, 'resetFromCharCode', shaka.util.StringUtils.resetFromCharCode);
    goog.exportProperty(shaka.util.StringUtils, 'toUTF16', shaka.util.StringUtils.toUTF16);
    goog.exportProperty(shaka.util.StringUtils, 'toUTF8', shaka.util.StringUtils.toUTF8);
    goog.exportProperty(shaka.util.StringUtils, 'fromBytesAutoDetect', shaka.util.StringUtils.fromBytesAutoDetect);
    goog.exportProperty(shaka.util.StringUtils, 'fromUTF16', shaka.util.StringUtils.fromUTF16);
    goog.exportProperty(shaka.util.StringUtils, 'fromUTF8', shaka.util.StringUtils.fromUTF8);
    shaka.util.StringUtils.fromCharCodeImpl_ = new shaka.util.Lazy(function () {
      for (
        var a = function (c) {
            try {
              var d = new Uint8Array(c),
                e = String.fromCharCode.apply(null, d);
              goog.asserts.assert(e, 'Should get value');
              return 0 < e.length;
            } catch (f) {
              return !1;
            }
          },
          b = { $jscomp$loop$prop$size$519: 65536 };
        0 < b.$jscomp$loop$prop$size$519;
        b = { $jscomp$loop$prop$size$519: b.$jscomp$loop$prop$size$519 }, b.$jscomp$loop$prop$size$519 /= 2
      )
        if (a(b.$jscomp$loop$prop$size$519))
          return (function (c) {
            return function (d) {
              for (var e = '', f = 0; f < d.length; f += c.$jscomp$loop$prop$size$519) {
                var g = d.subarray(f, f + c.$jscomp$loop$prop$size$519);
                e += String.fromCharCode.apply(null, g);
              }
              return e;
            };
          })(b);
      goog.asserts.assert(!1, 'Unable to create a fromCharCode method');
      return null;
    });
    shaka.util.FairPlayUtils = function () {};
    shaka.util.FairPlayUtils.defaultGetContentId = function (a) {
      a = shaka.util.StringUtils.fromBytesAutoDetect(a);
      return new goog.Uri(a).getDomain();
    };
    shaka.util.FairPlayUtils.initDataTransform = function (a, b, c) {
      if (!c || !c.byteLength)
        throw new shaka.util.Error(
          shaka.util.Error.Severity.CRITICAL,
          shaka.util.Error.Category.DRM,
          shaka.util.Error.Code.SERVER_CERTIFICATE_REQUIRED,
        );
      b = 'string' == typeof b ? shaka.util.StringUtils.toUTF16(b, !0) : b;
      a = shaka.util.StringUtils.fromBytesAutoDetect(a);
      a = shaka.util.StringUtils.toUTF16(a, !0);
      var d = new Uint8Array(12 + a.byteLength + b.byteLength + c.byteLength),
        e = 0,
        f = function (g) {
          shaka.util.BufferUtils.toDataView(d).setUint32(e, g.byteLength, !0);
          e += 4;
          d.set(shaka.util.BufferUtils.toUint8(g), e);
          e += g.byteLength;
        };
      f(a);
      f(b);
      f(c);
      goog.asserts.assert(e == d.length, 'Inconsistent init data length');
      return d;
    };
    goog.exportSymbol('shaka.util.FairPlayUtils', shaka.util.FairPlayUtils);
    goog.exportProperty(shaka.util.FairPlayUtils, 'initDataTransform', shaka.util.FairPlayUtils.initDataTransform);
    goog.exportProperty(shaka.util.FairPlayUtils, 'defaultGetContentId', shaka.util.FairPlayUtils.defaultGetContentId);
    shaka.util.MapUtils = function () {};
    shaka.util.MapUtils.asMap = function (a) {
      for (var b = new Map(), c = $jscomp.makeIterator(Object.keys(a)), d = c.next(); !d.done; d = c.next())
        (d = d.value), b.set(d, a[d]);
      return b;
    };
    shaka.util.MapUtils.asObject = function (a) {
      var b = {};
      a.forEach(function (c, d) {
        b[d] = c;
      });
      return b;
    };
    shaka.util.MapUtils.hasSameElements = function (a, b) {
      if (a || b) {
        if ((a && !b) || (b && !a)) return !1;
      } else return !0;
      if (a.size != b.size) return !1;
      for (var c = $jscomp.makeIterator(a), d = c.next(); !d.done; d = c.next()) {
        var e = $jscomp.makeIterator(d.value);
        d = e.next().value;
        e = e.next().value;
        if (!b.has(d)) return !1;
        d = b.get(d);
        if (d != e || void 0 == d) return !1;
      }
      return !0;
    };
    shaka.util.MimeUtils = function () {};
    shaka.util.MimeUtils.getFullType = function (a, b) {
      var c = a;
      b && (c += '; codecs="' + b + '"');
      return c;
    };
    shaka.util.MimeUtils.getExtendedType = function (a) {
      var b = [a.mimeType];
      shaka.util.MimeUtils.EXTENDED_MIME_PARAMETERS_.forEach(function (c, d) {
        var e = a[d];
        e && b.push(c + '="' + e + '"');
      });
      return b.join(';');
    };
    shaka.util.MimeUtils.splitCodecs = function (a) {
      return a.split(',');
    };
    shaka.util.MimeUtils.getCodecBase = function (a) {
      return shaka.util.MimeUtils.getCodecParts_(a)[0];
    };
    shaka.util.MimeUtils.getCodecParts_ = function (a) {
      var b = a.split('.');
      a = b[0];
      b.pop();
      b = b.join('.');
      return [a, b];
    };
    shaka.util.MimeUtils.EXTENDED_MIME_PARAMETERS_ = new Map()
      .set('codecs', 'codecs')
      .set('frameRate', 'framerate')
      .set('bandwidth', 'bitrate')
      .set('width', 'width')
      .set('height', 'height')
      .set('channelsCount', 'channels');
    shaka.util.MimeUtils.CLOSED_CAPTION_MIMETYPE = 'application/cea-608';
    shaka.util.Platform = function () {};
    shaka.util.Platform.supportsMediaSource = function () {
      return window.MediaSource && MediaSource.isTypeSupported ? !0 : !1;
    };
    shaka.util.Platform.supportsMediaType = function (a) {
      return '' != shaka.util.Platform.anyMediaElement().canPlayType(a);
    };
    shaka.util.Platform.isEdge = function () {
      return navigator.userAgent.match(/Edge?\//) ? !0 : !1;
    };
    shaka.util.Platform.isIE = function () {
      return shaka.util.Platform.userAgentContains_('Trident/');
    };
    shaka.util.Platform.isTizen = function () {
      return shaka.util.Platform.userAgentContains_('Tizen');
    };
    shaka.util.Platform.isTizen4 = function () {
      return shaka.util.Platform.userAgentContains_('Tizen 4');
    };
    shaka.util.Platform.isTizen3 = function () {
      return shaka.util.Platform.userAgentContains_('Tizen 3');
    };
    shaka.util.Platform.isTizen2 = function () {
      return shaka.util.Platform.userAgentContains_('Tizen 2');
    };
    shaka.util.Platform.isWebOS = function () {
      return shaka.util.Platform.userAgentContains_('Web0S');
    };
    shaka.util.Platform.isChromecast = function () {
      return shaka.util.Platform.userAgentContains_('CrKey');
    };
    shaka.util.Platform.isChrome = function () {
      return shaka.util.Platform.userAgentContains_('Chrome') && !shaka.util.Platform.isEdge();
    };
    shaka.util.Platform.isApple = function () {
      return !!navigator.vendor && navigator.vendor.includes('Apple') && !shaka.util.Platform.isTizen();
    };
    shaka.util.Platform.safariVersion = function () {
      if (!shaka.util.Platform.isApple()) return null;
      var a = navigator.userAgent.match(/Version\/(\d+)/);
      return a ? parseInt(a[1], 10) : (a = navigator.userAgent.match(/OS (\d+)(?:_\d+)?/)) ? parseInt(a[1], 10) : null;
    };
    shaka.util.Platform.isMobile = function () {
      return /(?:iPhone|iPad|iPod|Android)/.test(navigator.userAgent)
        ? !0
        : shaka.util.Platform.isApple() && 1 < navigator.maxTouchPoints;
    };
    shaka.util.Platform.userAgentContains_ = function (a) {
      return (navigator.userAgent || '').includes(a);
    };
    shaka.util.Platform.anyMediaElement = function () {
      var a = shaka.util.Platform;
      if (a.cachedMediaElement_) return a.cachedMediaElement_;
      a.cacheExpirationTimer_ ||
        (a.cacheExpirationTimer_ = new shaka.util.Timer(function () {
          a.cachedMediaElement_ = null;
        }));
      a.cachedMediaElement_ = document.getElementsByTagName('video')[0] || document.getElementsByTagName('audio')[0];
      a.cachedMediaElement_ || (a.cachedMediaElement_ = document.createElement('video'));
      a.cacheExpirationTimer_.tickAfter(1);
      return a.cachedMediaElement_;
    };
    shaka.util.Platform.cacheExpirationTimer_ = null;
    shaka.util.Platform.cachedMediaElement_ = null;
    shaka.util.Uint8ArrayUtils = function () {};
    shaka.util.Uint8ArrayUtils.equal = function (a, b) {
      shaka.Deprecate.deprecateFeature(
        4,
        'shaka.util.Uint8ArrayUtils.equal',
        'Please use shaka.util.BufferUtils.equal instead.',
      );
      return shaka.util.BufferUtils.equal(a, b);
    };
    shaka.util.Uint8ArrayUtils.toStandardBase64 = function (a) {
      a = shaka.util.StringUtils.fromCharCode(shaka.util.BufferUtils.toUint8(a));
      return btoa(a);
    };
    shaka.util.Uint8ArrayUtils.toBase64 = function (a, b) {
      b = void 0 == b ? !0 : b;
      var c = shaka.util.Uint8ArrayUtils.toStandardBase64(a).replace(/\+/g, '-').replace(/\//g, '_');
      return b ? c : c.replace(/[=]*$/, '');
    };
    shaka.util.Uint8ArrayUtils.fromBase64 = function (a) {
      var b = window.atob(a.replace(/-/g, '+').replace(/_/g, '/'));
      a = new Uint8Array(b.length);
      b = $jscomp.makeIterator(shaka.util.Iterables.enumerate(b));
      for (var c = b.next(); !c.done; c = b.next()) (c = c.value), (a[c.i] = c.item.charCodeAt(0));
      return a;
    };
    shaka.util.Uint8ArrayUtils.fromHex = function (a) {
      var b = a.length / 2,
        c = new Uint8Array(b);
      b = $jscomp.makeIterator(shaka.util.Iterables.range(b));
      for (var d = b.next(); !d.done; d = b.next()) (d = d.value), (c[d] = window.parseInt(a.substr(2 * d, 2), 16));
      return c;
    };
    shaka.util.Uint8ArrayUtils.toHex = function (a) {
      var b = shaka.util.BufferUtils.toUint8(a);
      a = '';
      b = $jscomp.makeIterator(b);
      for (var c = b.next(); !c.done; c = b.next())
        (c = c.value), (c = c.toString(16)), 1 == c.length && (c = '0' + c), (a += c);
      return a;
    };
    shaka.util.Uint8ArrayUtils.concat = function (a) {
      for (var b = [], c = 0; c < arguments.length; ++c) b[c - 0] = arguments[c];
      var d = 0,
        e = $jscomp.makeIterator(b);
      for (c = e.next(); !c.done; c = e.next()) d += c.value.byteLength;
      d = new Uint8Array(d);
      e = 0;
      b = $jscomp.makeIterator(b);
      for (c = b.next(); !c.done; c = b.next())
        (c = c.value), d.set(shaka.util.BufferUtils.toUint8(c), e), (e += c.byteLength);
      return d;
    };
    goog.exportSymbol('shaka.util.Uint8ArrayUtils', shaka.util.Uint8ArrayUtils);
    goog.exportProperty(shaka.util.Uint8ArrayUtils, 'concat', shaka.util.Uint8ArrayUtils.concat);
    goog.exportProperty(shaka.util.Uint8ArrayUtils, 'toHex', shaka.util.Uint8ArrayUtils.toHex);
    goog.exportProperty(shaka.util.Uint8ArrayUtils, 'fromHex', shaka.util.Uint8ArrayUtils.fromHex);
    goog.exportProperty(shaka.util.Uint8ArrayUtils, 'fromBase64', shaka.util.Uint8ArrayUtils.fromBase64);
    goog.exportProperty(shaka.util.Uint8ArrayUtils, 'toBase64', shaka.util.Uint8ArrayUtils.toBase64);
    goog.exportProperty(shaka.util.Uint8ArrayUtils, 'toStandardBase64', shaka.util.Uint8ArrayUtils.toStandardBase64);
    goog.exportProperty(shaka.util.Uint8ArrayUtils, 'equal', shaka.util.Uint8ArrayUtils.equal);
    shaka.media = {};
    shaka.media.DrmEngine = function (a, b) {
      var c = this;
      b = void 0 === b ? 1 : b;
      this.playerInterface_ = a;
      this.supportedTypes_ = new Set();
      this.video_ = this.mediaKeys_ = null;
      this.initialized_ = !1;
      this.licenseTimeSeconds_ = 0;
      this.currentDrmInfo_ = null;
      this.eventManager_ = new shaka.util.EventManager();
      this.activeSessions_ = new Map();
      this.offlineSessionIds_ = [];
      this.allSessionsLoaded_ = new shaka.util.PublicPromise();
      this.config_ = null;
      this.onError_ = function (d) {
        c.allSessionsLoaded_.reject(d);
        a.onError(d);
      };
      this.keyStatusByKeyId_ = new Map();
      this.announcedKeyStatusByKeyId_ = new Map();
      this.keyStatusTimer_ = new shaka.util.Timer(function () {
        return c.processKeyStatusChanges_();
      });
      this.usePersistentLicenses_ = !1;
      this.mediaKeyMessageEvents_ = [];
      this.initialRequestsSent_ = !1;
      this.expirationTimer_ = new shaka.util.Timer(function () {
        c.pollExpiration_();
      }).tickEvery(b);
      this.allSessionsLoaded_['catch'](function () {});
      this.destroyer_ = new shaka.util.Destroyer(function () {
        return c.destroyNow_();
      });
    };
    shaka.media.DrmEngine.prototype.destroy = function () {
      return this.destroyer_.destroy();
    };
    shaka.media.DrmEngine.prototype.destroyNow_ = function () {
      var a = this;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (b) {
        switch (b.nextAddress) {
          case 1:
            return (
              a.eventManager_.release(),
              (a.eventManager_ = null),
              a.allSessionsLoaded_.reject(),
              a.expirationTimer_.stop(),
              (a.expirationTimer_ = null),
              a.keyStatusTimer_.stop(),
              (a.keyStatusTimer_ = null),
              b.yield(a.closeOpenSessions_(), 2)
            );
          case 2:
            if (!a.video_) {
              b.jumpTo(3);
              break;
            }
            goog.asserts.assert(!a.video_.src, 'video src must be removed first!');
            b.setCatchFinallyBlocks(4);
            return b.yield(a.video_.setMediaKeys(null), 6);
          case 6:
            b.leaveTryBlock(5);
            break;
          case 4:
            b.enterCatchBlock();
          case 5:
            a.video_ = null;
          case 3:
            (a.currentDrmInfo_ = null),
              a.supportedTypes_.clear(),
              (a.mediaKeys_ = null),
              (a.offlineSessionIds_ = []),
              (a.config_ = null),
              (a.onError_ = function () {}),
              (a.playerInterface_ = null),
              b.jumpToEnd();
        }
      });
    };
    shaka.media.DrmEngine.prototype.configure = function (a) {
      this.config_ = a;
    };
    shaka.media.DrmEngine.prototype.initForStorage = function (a, b) {
      this.offlineSessionIds_ = [];
      this.usePersistentLicenses_ = b;
      return this.init_(a);
    };
    shaka.media.DrmEngine.prototype.initForPlayback = function (a, b) {
      this.offlineSessionIds_ = b;
      this.usePersistentLicenses_ = 0 < b.length;
      return this.init_(a);
    };
    shaka.media.DrmEngine.prototype.initForRemoval = function (a, b, c, d, e) {
      var f = new Map();
      d = {
        audioCapabilities: d,
        videoCapabilities: e,
        distinctiveIdentifier: 'optional',
        persistentState: 'required',
        sessionTypes: ['persistent-license'],
        label: a,
      };
      d.drmInfos = [
        {
          keySystem: a,
          licenseServerUri: b,
          distinctiveIdentifierRequired: !1,
          persistentStateRequired: !0,
          audioRobustness: '',
          videoRobustness: '',
          serverCertificate: c,
          initData: null,
          keyIds: null,
        },
      ];
      f.set(a, d);
      return this.queryMediaKeys_(f);
    };
    shaka.media.DrmEngine.prototype.init_ = function (a) {
      goog.asserts.assert(this.config_, 'DrmEngine configure() must be called before init()!');
      var b = this.configureClearKey_();
      if (b)
        for (var c = $jscomp.makeIterator(a), d = c.next(); !d.done; d = c.next())
          (d = d.value), d.video && (d.video.drmInfos = [b]), d.audio && (d.audio.drmInfos = [b]);
      b = a.some(function (f) {
        return (f.video && f.video.drmInfos.length) || (f.audio && f.audio.drmInfos.length) ? !0 : !1;
      });
      b || ((c = shaka.util.MapUtils.asMap(this.config_.servers)), shaka.media.DrmEngine.replaceDrmInfo_(a, c));
      c = $jscomp.makeIterator(a);
      for (d = c.next(); !d.done; d = c.next()) {
        d = d.value;
        d = (d.video ? d.video.drmInfos : []).concat(d.audio ? d.audio.drmInfos : []);
        d = $jscomp.makeIterator(d);
        for (var e = d.next(); !e.done; e = d.next())
          shaka.media.DrmEngine.fillInDrmInfoDefaults_(
            e.value,
            shaka.util.MapUtils.asMap(this.config_.servers),
            shaka.util.MapUtils.asMap(this.config_.advanced || {}),
          );
      }
      a = this.prepareMediaKeyConfigsForVariants_(a);
      if (!a.size) return (this.initialized_ = !0), Promise.resolve();
      a = this.queryMediaKeys_(a);
      return b ? a : a['catch'](function () {});
    };
    shaka.media.DrmEngine.prototype.attach = function (a) {
      var b = this,
        c,
        d;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (e) {
        if (1 == e.nextAddress) {
          if (!b.mediaKeys_)
            return (
              b.eventManager_.listenOnce(a, 'encrypted', function (f) {
                b.onError_(
                  new shaka.util.Error(
                    shaka.util.Error.Severity.CRITICAL,
                    shaka.util.Error.Category.DRM,
                    shaka.util.Error.Code.ENCRYPTED_CONTENT_WITHOUT_DRM_INFO,
                  ),
                );
              }),
              e['return']()
            );
          b.video_ = a;
          b.eventManager_.listenOnce(b.video_, 'play', function () {
            return b.onPlay_();
          });
          'webkitCurrentPlaybackTargetIsWireless' in b.video_ &&
            b.eventManager_.listen(b.video_, 'webkitcurrentplaybacktargetiswirelesschanged', function () {
              return b.closeOpenSessions_();
            });
          c = b.video_.setMediaKeys(b.mediaKeys_);
          c = c['catch'](function (f) {
            goog.asserts.assert(f instanceof Error, 'Wrong error type!');
            return Promise.reject(
              new shaka.util.Error(
                shaka.util.Error.Severity.CRITICAL,
                shaka.util.Error.Category.DRM,
                shaka.util.Error.Code.FAILED_TO_ATTACH_TO_VIDEO,
                f.message,
              ),
            );
          });
          return e.yield(c, 2);
        }
        b.destroyer_.ensureNotDestroyed();
        b.createOrLoad();
        b.currentDrmInfo_.initData.length ||
          b.offlineSessionIds_.length ||
          ((d = function (f) {
            return b.newInitData(f.initDataType, shaka.util.BufferUtils.toUint8(f.initData));
          }),
          b.eventManager_.listen(b.video_, 'encrypted', d));
        e.jumpToEnd();
      });
    };
    shaka.media.DrmEngine.prototype.setServerCertificate = function () {
      var a = this,
        b,
        c;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (d) {
        if (1 == d.nextAddress) {
          goog.asserts.assert(a.initialized_, 'Must call init() before setServerCertificate');
          if (
            !(
              a.mediaKeys_ &&
              a.currentDrmInfo_ &&
              a.currentDrmInfo_.serverCertificate &&
              a.currentDrmInfo_.serverCertificate.length
            )
          )
            return d.jumpTo(0);
          d.setCatchFinallyBlocks(3);
          return d.yield(a.mediaKeys_.setServerCertificate(a.currentDrmInfo_.serverCertificate), 5);
        }
        if (3 != d.nextAddress)
          return (
            (b = d.yieldResult) ||
              shaka.log.warning(
                'Server certificates are not supported by the key system.  The server certificate has been ignored.',
              ),
            d.leaveTryBlock(0)
          );
        c = d.enterCatchBlock();
        throw new shaka.util.Error(
          shaka.util.Error.Severity.CRITICAL,
          shaka.util.Error.Category.DRM,
          shaka.util.Error.Code.INVALID_SERVER_CERTIFICATE,
          c.message,
        );
      });
    };
    shaka.media.DrmEngine.prototype.removeSession = function (a) {
      var b = this,
        c,
        d,
        e;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (f) {
        if (1 == f.nextAddress)
          return (
            goog.asserts.assert(b.mediaKeys_, 'Must call init() before removeSession'),
            f.yield(b.loadOfflineSession_(a), 2)
          );
        c = f.yieldResult;
        if (!c) return shaka.log.v2('Ignoring attempt to remove missing session', a), f['return']();
        d = [];
        if ((e = b.activeSessions_.get(c))) (e.updatePromise = new shaka.util.PublicPromise()), d.push(e.updatePromise);
        shaka.log.v2('Attempting to remove session', a);
        d.push(c.remove());
        return f.yield(Promise.all(d), 0);
      });
    };
    shaka.media.DrmEngine.prototype.createOrLoad = function () {
      for (
        var a = (this.currentDrmInfo_ ? this.currentDrmInfo_.initData : []) || [],
          b = $jscomp.makeIterator(a),
          c = b.next();
        !c.done;
        c = b.next()
      )
        (c = c.value), this.newInitData(c.initDataType, c.initData);
      b = $jscomp.makeIterator(this.offlineSessionIds_);
      for (c = b.next(); !c.done; c = b.next()) this.loadOfflineSession_(c.value);
      a.length || this.offlineSessionIds_.length || this.allSessionsLoaded_.resolve();
      return this.allSessionsLoaded_;
    };
    shaka.media.DrmEngine.prototype.newInitData = function (a, b) {
      var c = this.activeSessions_.values();
      c = $jscomp.makeIterator(c);
      if (!shaka.util.Platform.isApple()) {
        // TODO don't perform data init check on Apple devices, new media key will never get downloaded again
        for (var d = c.next(); !d.done; d = c.next())
          if (shaka.util.BufferUtils.equal(b, d.value.initData) && !shaka.util.Platform.isTizen2()) {
            shaka.log.debug('Ignoring duplicate init data.');
            return;
          }
      }
      this.createTemporarySession_(a, b);
    };
    shaka.media.DrmEngine.prototype.initialized = function () {
      return this.initialized_;
    };
    shaka.media.DrmEngine.keySystem = function (a) {
      return a ? a.keySystem : '';
    };
    shaka.media.DrmEngine.prototype.willSupport = function (a) {
      return shaka.util.Platform.isEdge() ? !0 : this.supportedTypes_.has(a.toLowerCase());
    };
    shaka.media.DrmEngine.prototype.getSessionIds = function () {
      var a = this.activeSessions_.keys();
      a = shaka.util.Iterables.map(a, function (b) {
        return b.sessionId;
      });
      return Array.from(a);
    };
    shaka.media.DrmEngine.prototype.getExpiration = function () {
      var a = Infinity,
        b = this.activeSessions_.keys();
      b = $jscomp.makeIterator(b);
      for (var c = b.next(); !c.done; c = b.next())
        (c = c.value), isNaN(c.expiration) || (a = Math.min(a, c.expiration));
      return a;
    };
    shaka.media.DrmEngine.prototype.getLicenseTime = function () {
      return this.licenseTimeSeconds_ ? this.licenseTimeSeconds_ : NaN;
    };
    shaka.media.DrmEngine.prototype.getDrmInfo = function () {
      return this.currentDrmInfo_;
    };
    shaka.media.DrmEngine.prototype.getKeyStatuses = function () {
      return shaka.util.MapUtils.asObject(this.announcedKeyStatusByKeyId_);
    };
    shaka.media.DrmEngine.prototype.prepareMediaKeyConfigsForVariants_ = function (a) {
      for (
        var b = shaka.util.ManifestParserUtils.ContentType, c = new Set(), d = $jscomp.makeIterator(a), e = d.next();
        !e.done;
        e = d.next()
      ) {
        e = e.value;
        e = (e.video ? e.video.drmInfos : []).concat(e.audio ? e.audio.drmInfos : []);
        var f = $jscomp.makeIterator(e);
        for (e = f.next(); !e.done; e = f.next()) c.add(e.value);
      }
      d = $jscomp.makeIterator(c);
      for (e = d.next(); !e.done; e = d.next())
        shaka.media.DrmEngine.fillInDrmInfoDefaults_(
          e.value,
          shaka.util.MapUtils.asMap(this.config_.servers),
          shaka.util.MapUtils.asMap(this.config_.advanced || {}),
        );
      f = this.usePersistentLicenses_ ? 'required' : 'optional';
      var g = this.usePersistentLicenses_ ? ['persistent-license'] : ['temporary'];
      d = new Map();
      c = $jscomp.makeIterator(c);
      for (e = c.next(); !e.done; e = c.next())
        (e = e.value),
          d.set(e.keySystem, {
            audioCapabilities: [],
            videoCapabilities: [],
            distinctiveIdentifier: 'optional',
            persistentState: f,
            sessionTypes: g,
            label: e.keySystem,
            drmInfos: [],
          });
      a = $jscomp.makeIterator(a);
      for (e = a.next(); !e.done; e = a.next())
        for (e = e.value, c = $jscomp.makeIterator([e.audio, e.video]), e = c.next(); !e.done; e = c.next())
          if ((f = e.value)) {
            g = shaka.util.MimeUtils.getFullType(f.mimeType, f.codecs);
            var h = $jscomp.makeIterator(f.drmInfos);
            for (e = h.next(); !e.done; e = h.next()) {
              var k = e.value;
              e = d.get(k.keySystem);
              goog.asserts.assert(e, 'Any missing configs should have be filled in before.');
              e.drmInfos.push(k);
              k.distinctiveIdentifierRequired && (e.distinctiveIdentifier = 'required');
              k.persistentStateRequired && (e.persistentState = 'required');
              k = { robustness: (f.type == b.AUDIO ? k.audioRobustness : k.videoRobustness) || '', contentType: g };
              f.type == b.AUDIO ? e.audioCapabilities.push(k) : e.videoCapabilities.push(k);
            }
          }
      return d;
    };
    shaka.media.DrmEngine.prototype.queryMediaKeys_ = function (a) {
      var b = this,
        c,
        d,
        e,
        f,
        g,
        h,
        k,
        l,
        m,
        n,
        p,
        q,
        r,
        t,
        w,
        u,
        v,
        x,
        B,
        z,
        A,
        D;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (y) {
        switch (y.nextAddress) {
          case 1:
            if (1 == a.size && a.has(''))
              throw new shaka.util.Error(
                shaka.util.Error.Severity.CRITICAL,
                shaka.util.Error.Category.DRM,
                shaka.util.Error.Code.NO_RECOGNIZED_KEY_SYSTEMS,
              );
            c = $jscomp.makeIterator(a.values());
            for (d = c.next(); !d.done; d = c.next())
              (e = d.value),
                0 == e.audioCapabilities.length && delete e.audioCapabilities,
                0 == e.videoCapabilities.length && delete e.videoCapabilities;
            g = $jscomp.makeIterator([!0, !1]);
            h = g.next();
          case 2:
            if (h.done) {
              y.jumpTo(4);
              break;
            }
            k = h.value;
            l = $jscomp.makeIterator(a.keys());
            m = l.next();
          case 5:
            if (m.done) {
              y.jumpTo(7);
              break;
            }
            n = m.value;
            p = a.get(n);
            q = p.drmInfos.some(function (C) {
              return !!C.licenseServerUri;
            });
            if (q != k) {
              y.jumpTo(6);
              break;
            }
            y.setCatchFinallyBlocks(8);
            return y.yield(navigator.requestMediaKeySystemAccess(n, [p]), 10);
          case 10:
            f = y.yieldResult;
            y.jumpTo(7);
            break;
          case 8:
            y.enterCatchBlock();
          case 9:
            b.destroyer_.ensureNotDestroyed();
          case 6:
            m = l.next();
            y.jumpTo(5);
            break;
          case 7:
            if (f) {
              y.jumpTo(4);
              break;
            }
            h = g.next();
            y.jumpTo(2);
            break;
          case 4:
            if (!f)
              throw new shaka.util.Error(
                shaka.util.Error.Severity.CRITICAL,
                shaka.util.Error.Category.DRM,
                shaka.util.Error.Code.REQUESTED_KEY_SYSTEM_CONFIG_UNAVAILABLE,
              );
            b.destroyer_.ensureNotDestroyed();
            y.setCatchFinallyBlocks(11);
            b.supportedTypes_.clear();
            r = f.getConfiguration();
            t = r.audioCapabilities || [];
            w = r.videoCapabilities || [];
            u = $jscomp.makeIterator(t);
            for (v = u.next(); !v.done; v = u.next()) (x = v.value), b.supportedTypes_.add(x.contentType.toLowerCase());
            B = $jscomp.makeIterator(w);
            for (v = B.next(); !v.done; v = B.next()) (z = v.value), b.supportedTypes_.add(z.contentType.toLowerCase());
            goog.asserts.assert(b.supportedTypes_.size, 'We should get at least one supported MIME type');
            b.currentDrmInfo_ = shaka.media.DrmEngine.createDrmInfoFor_(f.keySystem, a.get(f.keySystem));
            if (!b.currentDrmInfo_.licenseServerUri)
              throw new shaka.util.Error(
                shaka.util.Error.Severity.CRITICAL,
                shaka.util.Error.Category.DRM,
                shaka.util.Error.Code.NO_LICENSE_SERVER_GIVEN,
                b.currentDrmInfo_.keySystem,
              );
            return y.yield(f.createMediaKeys(), 13);
          case 13:
            return (
              (A = y.yieldResult),
              b.destroyer_.ensureNotDestroyed(),
              shaka.log.info('Created MediaKeys object for key system', b.currentDrmInfo_.keySystem),
              (b.mediaKeys_ = A),
              (b.initialized_ = !0),
              y.yield(b.setServerCertificate(), 14)
            );
          case 14:
            b.destroyer_.ensureNotDestroyed();
            y.leaveTryBlock(0);
            break;
          case 11:
            D = y.enterCatchBlock();
            b.destroyer_.ensureNotDestroyed(D);
            b.currentDrmInfo_ = null;
            b.supportedTypes_.clear();
            if (D instanceof shaka.util.Error) throw D;
            throw new shaka.util.Error(
              shaka.util.Error.Severity.CRITICAL,
              shaka.util.Error.Category.DRM,
              shaka.util.Error.Code.FAILED_TO_CREATE_CDM,
              D.message,
            );
        }
      });
    };
    shaka.media.DrmEngine.prototype.configureClearKey_ = function () {
      var a = shaka.util.MapUtils.asMap(this.config_.clearKeys);
      if (0 == a.size) return null;
      var b = shaka.util.StringUtils,
        c = shaka.util.Uint8ArrayUtils,
        d = [],
        e = [];
      a.forEach(function (g, h) {
        var k = c.fromHex(h),
          l = c.fromHex(g);
        k = { kty: 'oct', kid: c.toBase64(k, !1), k: c.toBase64(l, !1) };
        d.push(k);
        e.push(k.kid);
      });
      a = JSON.stringify({ keys: d });
      var f = JSON.stringify({ kids: e });
      b = [{ initData: shaka.util.BufferUtils.toUint8(b.toUTF8(f)), initDataType: 'keyids' }];
      return {
        keySystem: 'org.w3.clearkey',
        licenseServerUri: 'data:application/json;base64,' + window.btoa(a),
        distinctiveIdentifierRequired: !1,
        persistentStateRequired: !1,
        audioRobustness: '',
        videoRobustness: '',
        serverCertificate: null,
        initData: b,
        keyIds: new Set(e),
      };
    };
    shaka.media.DrmEngine.prototype.loadOfflineSession_ = function (a) {
      var b = this,
        c,
        d,
        e,
        f,
        g;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (h) {
        switch (h.nextAddress) {
          case 1:
            try {
              shaka.log.v1('Attempting to load an offline session', a),
                (c = b.mediaKeys_.createSession('persistent-license'));
            } catch (k) {
              return (
                (d = new shaka.util.Error(
                  shaka.util.Error.Severity.CRITICAL,
                  shaka.util.Error.Category.DRM,
                  shaka.util.Error.Code.FAILED_TO_CREATE_SESSION,
                  k.message,
                )),
                b.onError_(d),
                h['return'](Promise.reject(d))
              );
            }
            b.eventManager_.listen(c, 'message', function (k) {
              return b.onSessionMessage_(k);
            });
            b.eventManager_.listen(c, 'keystatuseschange', function (k) {
              return b.onKeyStatusesChange_(k);
            });
            e = { initData: null, loaded: !1, oldExpiration: Infinity, updatePromise: null };
            b.activeSessions_.set(c, e);
            h.setCatchFinallyBlocks(2);
            return h.yield(c.load(a), 4);
          case 4:
            f = h.yieldResult;
            b.destroyer_.ensureNotDestroyed();
            shaka.log.v2('Loaded offline session', a, f);
            if (!f)
              return (
                b.activeSessions_['delete'](c),
                b.onError_(
                  new shaka.util.Error(
                    shaka.util.Error.Severity.CRITICAL,
                    shaka.util.Error.Category.DRM,
                    shaka.util.Error.Code.OFFLINE_SESSION_REMOVED,
                  ),
                ),
                h['return'](Promise.resolve())
              );
            e.loaded = !0;
            b.areAllSessionsLoaded_() && b.allSessionsLoaded_.resolve();
            return h['return'](c);
          case 2:
            (g = h.enterCatchBlock()),
              b.destroyer_.ensureNotDestroyed(g),
              b.activeSessions_['delete'](c),
              b.onError_(
                new shaka.util.Error(
                  shaka.util.Error.Severity.CRITICAL,
                  shaka.util.Error.Category.DRM,
                  shaka.util.Error.Code.FAILED_TO_CREATE_SESSION,
                  g.message,
                ),
              );
          case 3:
            return h['return'](Promise.resolve());
        }
      });
    };
    shaka.media.DrmEngine.prototype.createTemporarySession_ = function (a, b) {
      var c = this;
      try {
        if (this.usePersistentLicenses_) {
          shaka.log.v1('Creating new persistent session');
          var d = this.mediaKeys_.createSession('persistent-license');
        } else shaka.log.v1('Creating new temporary session'), (d = this.mediaKeys_.createSession());
      } catch (f) {
        this.onError_(
          new shaka.util.Error(
            shaka.util.Error.Severity.CRITICAL,
            shaka.util.Error.Category.DRM,
            shaka.util.Error.Code.FAILED_TO_CREATE_SESSION,
            f.message,
          ),
        );
        return;
      }
      this.eventManager_.listen(d, 'message', function (f) {
        return c.onSessionMessage_(f);
      });
      this.eventManager_.listen(d, 'keystatuseschange', function (f) {
        return c.onKeyStatusesChange_(f);
      });
      this.activeSessions_.set(d, { initData: b, loaded: !1, oldExpiration: Infinity, updatePromise: null });
      try {
        b = this.config_.initDataTransform(b, a, this.currentDrmInfo_);
      } catch (f) {
        var e = f;
        f instanceof shaka.util.Error ||
          (e = new shaka.util.Error(
            shaka.util.Error.Severity.CRITICAL,
            shaka.util.Error.Category.DRM,
            shaka.util.Error.Code.INIT_DATA_TRANSFORM_ERROR,
            f,
          ));
        this.onError_(e);
        return;
      }
      this.config_.logLicenseExchange &&
        ((e = shaka.util.Uint8ArrayUtils.toBase64(b)), shaka.log.info('EME init data: type=', a, 'data=', e));
      d.generateRequest(a, b)['catch'](function (f) {
        if (!c.destroyer_.destroyed()) {
          goog.asserts.assert(f instanceof Error, 'Wrong error type!');
          c.activeSessions_['delete'](d);
          var g = f.errorCode;
          if (g && g.systemCode) {
            var h = g.systemCode;
            0 > h && (h += Math.pow(2, 32));
            h = '0x' + h.toString(16);
          }
          c.onError_(
            new shaka.util.Error(
              shaka.util.Error.Severity.CRITICAL,
              shaka.util.Error.Category.DRM,
              shaka.util.Error.Code.FAILED_TO_GENERATE_LICENSE_REQUEST,
              f.message,
              f,
              h,
            ),
          );
        }
      });
    };
    shaka.media.DrmEngine.defaultInitDataTransform = function (a, b, c) {
      'skd' == b &&
        ((b = c.serverCertificate),
        (c = shaka.util.FairPlayUtils.defaultGetContentId(a)),
        (a = shaka.util.FairPlayUtils.initDataTransform(a, c, b)));
      return a;
    };
    shaka.media.DrmEngine.prototype.onSessionMessage_ = function (a) {
      this.delayLicenseRequest_() ? this.mediaKeyMessageEvents_.push(a) : this.sendLicenseRequest_(a);
    };
    shaka.media.DrmEngine.prototype.delayLicenseRequest_ = function () {
      return this.video_
        ? this.config_.delayLicenseRequestUntilPlayed && this.video_.paused && !this.initialRequestsSent_
        : !1;
    };
    shaka.media.DrmEngine.prototype.sendLicenseRequest_ = function (a) {
      var b = this,
        c,
        d,
        e,
        f,
        g,
        h,
        k,
        l,
        m,
        n,
        p,
        q,
        r,
        t,
        w,
        u,
        v;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (x) {
        switch (x.nextAddress) {
          case 1:
            return (
              (c = a.target),
              shaka.log.v1('Sending license request for session', c.sessionId, 'of type', a.messageType),
              b.config_.logLicenseExchange &&
                ((d = shaka.util.Uint8ArrayUtils.toBase64(a.message)), shaka.log.info('EME license request', d)),
              (e = b.activeSessions_.get(c)),
              (f = b.currentDrmInfo_.licenseServerUri),
              (g = b.config_.advanced[b.currentDrmInfo_.keySystem]),
              'individualization-request' == a.messageType &&
                g &&
                g.individualizationServer &&
                (f = g.individualizationServer),
              (h = shaka.net.NetworkingEngine.RequestType.LICENSE),
              (k = shaka.net.NetworkingEngine.makeRequest([f], b.config_.retryParameters)),
              (k.body = a.message),
              (k.method = 'POST'),
              (k.licenseRequestType = a.messageType),
              (k.sessionId = c.sessionId),
              ('com.microsoft.playready' != b.currentDrmInfo_.keySystem &&
                'com.chromecast.playready' != b.currentDrmInfo_.keySystem) ||
                b.unpackPlayReadyRequest_(k),
              (l = Date.now()),
              x.setCatchFinallyBlocks(2),
              (n = b.playerInterface_.netEngine.request(h, k)),
              x.yield(n.promise, 4)
            );
          case 4:
            m = x.yieldResult;
            x.leaveTryBlock(3);
            break;
          case 2:
            return (
              (p = x.enterCatchBlock()),
              goog.asserts.assert(p instanceof shaka.util.Error, 'Wrong NetworkingEngine error type!'),
              (q = new shaka.util.Error(
                shaka.util.Error.Severity.CRITICAL,
                shaka.util.Error.Category.DRM,
                shaka.util.Error.Code.LICENSE_REQUEST_FAILED,
                p,
              )),
              b.onError_(q),
              e && e.updatePromise && e.updatePromise.reject(q),
              x['return']()
            );
          case 3:
            if (b.destroyer_.destroyed()) return x['return']();
            b.licenseTimeSeconds_ += (Date.now() - l) / 1e3;
            b.config_.logLicenseExchange &&
              ((r = shaka.util.Uint8ArrayUtils.toBase64(m.data)), shaka.log.info('EME license response', r));
            x.setCatchFinallyBlocks(5);
            shaka.log.v1('Updating session', c.sessionId);
            return x.yield(c.update(m.data), 7);
          case 7:
            x.leaveTryBlock(6);
            break;
          case 5:
            return (
              (t = x.enterCatchBlock()),
              (w = new shaka.util.Error(
                shaka.util.Error.Severity.CRITICAL,
                shaka.util.Error.Category.DRM,
                shaka.util.Error.Code.LICENSE_RESPONSE_REJECTED,
                t.message,
              )),
              b.onError_(w),
              e && e.updatePromise && e.updatePromise.reject(w),
              x['return']()
            );
          case 6:
            (u = new shaka.util.FakeEvent('drmsessionupdate')),
              b.playerInterface_.onEvent(u),
              e &&
                (e.updatePromise && e.updatePromise.resolve(),
                (v = new shaka.util.Timer(function () {
                  e.loaded = !0;
                  b.areAllSessionsLoaded_() && b.allSessionsLoaded_.resolve();
                })),
                v.tickAfter(shaka.media.DrmEngine.SESSION_LOAD_TIMEOUT_)),
              x.jumpToEnd();
        }
      });
    };
    shaka.media.DrmEngine.prototype.unpackPlayReadyRequest_ = function (a) {
      var b = shaka.util.StringUtils.fromUTF16(a.body, !0, !0);
      if (b.includes('PlayReadyKeyMessage')) {
        shaka.log.debug('Unwrapping PlayReady request.');
        b = new DOMParser().parseFromString(b, 'application/xml');
        var c = b.getElementsByTagName('HttpHeader');
        c = $jscomp.makeIterator(c);
        for (var d = c.next(); !d.done; d = c.next()) {
          var e = d.value;
          d = e.getElementsByTagName('name')[0];
          e = e.getElementsByTagName('value')[0];
          goog.asserts.assert(d && e, 'Malformed PlayReady headers!');
          a.headers[d.textContent] = e.textContent;
        }
        b = b.getElementsByTagName('Challenge')[0];
        goog.asserts.assert(b, 'Malformed PlayReady challenge!');
        goog.asserts.assert('base64encoded' == b.getAttribute('encoding'), 'Unexpected PlayReady challenge encoding!');
        a.body = shaka.util.Uint8ArrayUtils.fromBase64(b.textContent);
      } else
        shaka.log.debug('PlayReady request is already unwrapped.'),
          (a.headers['Content-Type'] = 'text/xml; charset=utf-8');
    };
    shaka.media.DrmEngine.prototype.onKeyStatusesChange_ = function (a) {
      var b = this;
      a = a.target;
      shaka.log.v2('Key status changed for session', a.sessionId);
      var c = this.activeSessions_.get(a),
        d = !1;
      a.keyStatuses.forEach(function (f, g) {
        if ('string' == typeof g) {
          var h = g;
          g = f;
          f = h;
        }
        if (
          'com.microsoft.playready' == b.currentDrmInfo_.keySystem &&
          16 == g.byteLength &&
          (shaka.util.Platform.isIE() || shaka.util.Platform.isEdge())
        ) {
          h = shaka.util.BufferUtils.toDataView(g);
          var k = h.getUint32(0, !0),
            l = h.getUint16(4, !0),
            m = h.getUint16(6, !0);
          h.setUint32(0, k, !1);
          h.setUint16(4, l, !1);
          h.setUint16(6, m, !1);
        }
        'com.microsoft.playready' == b.currentDrmInfo_.keySystem && 'status-pending' == f && (f = 'usable');
        'status-pending' != f && (c.loaded = !0);
        c || goog.asserts.assert('usable' != f, 'Usable keys found in closed session');
        'expired' == f && (d = !0);
        h = shaka.util.Uint8ArrayUtils.toHex(g);
        b.keyStatusByKeyId_.set(h, f);
      });
      var e = a.expiration - Date.now();
      (0 > e || (d && 1e3 > e)) &&
        c &&
        !c.updatePromise &&
        (shaka.log.debug('Session has expired', a.sessionId),
        this.activeSessions_['delete'](a),
        a.close()['catch'](function () {}));
      this.areAllSessionsLoaded_() &&
        (this.allSessionsLoaded_.resolve(),
        this.keyStatusTimer_.tickAfter(shaka.media.DrmEngine.KEY_STATUS_BATCH_TIME));
    };
    shaka.media.DrmEngine.prototype.processKeyStatusChanges_ = function () {
      var a = this.keyStatusByKeyId_,
        b = this.announcedKeyStatusByKeyId_;
      b.clear();
      a.forEach(function (c, d) {
        return b.set(d, c);
      });
      a = Array.from(b.values());
      if (
        a.length &&
        a.every(function (c) {
          return 'expired' == c;
        })
      )
        this.onError_(
          new shaka.util.Error(
            shaka.util.Error.Severity.CRITICAL,
            shaka.util.Error.Category.DRM,
            shaka.util.Error.Code.EXPIRED,
          ),
        );
      this.playerInterface_.onKeyStatus(shaka.util.MapUtils.asObject(b));
    };
    shaka.media.DrmEngine.isBrowserSupported = function () {
      return (
        !!window.MediaKeys &&
        !!window.navigator &&
        !!window.navigator.requestMediaKeySystemAccess &&
        !!window.MediaKeySystemAccess &&
        !!window.MediaKeySystemAccess.prototype.getConfiguration
      );
    };
    shaka.media.DrmEngine.probeSupport = function () {
      var a, b, c, d, e, f, g, h;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (k) {
        return 1 == k.nextAddress
          ? (goog.asserts.assert(shaka.media.DrmEngine.isBrowserSupported(), 'Must have basic EME support'),
            (a = 'org.w3.clearkey com.widevine.alpha com.microsoft.playready com.apple.fps.3_0 com.apple.fps.2_0 com.apple.fps.1_0 com.apple.fps com.adobe.primetime'.split(
              ' ',
            )),
            (b = [{ contentType: 'video/mp4; codecs="avc1.42E01E"' }, { contentType: 'video/webm; codecs="vp8"' }]),
            (c = { videoCapabilities: b }),
            (d = { videoCapabilities: b, persistentState: 'required', sessionTypes: ['persistent-license'] }),
            (e = [d, c]),
            (f = new Map()),
            (g = function (l) {
              var m, n, p;
              return $jscomp.asyncExecutePromiseGeneratorProgram(function (q) {
                switch (q.nextAddress) {
                  case 1:
                    return q.setCatchFinallyBlocks(2), q.yield(navigator.requestMediaKeySystemAccess(l, e), 4);
                  case 4:
                    return (
                      (m = q.yieldResult),
                      (p = (n = m.getConfiguration().sessionTypes) ? n.includes('persistent-license') : !1),
                      shaka.util.Platform.isTizen3() && (p = !1),
                      f.set(l, { persistentState: p }),
                      q.yield(m.createMediaKeys(), 5)
                    );
                  case 5:
                    q.leaveTryBlock(0);
                    break;
                  case 2:
                    q.enterCatchBlock(), f.set(l, null), q.jumpToEnd();
                }
              });
            }),
            (h = a.map(function (l) {
              return g(l);
            })),
            k.yield(Promise.all(h), 2))
          : k['return'](shaka.util.MapUtils.asObject(f));
      });
    };
    shaka.media.DrmEngine.prototype.onPlay_ = function () {
      for (var a = $jscomp.makeIterator(this.mediaKeyMessageEvents_), b = a.next(); !b.done; b = a.next())
        this.sendLicenseRequest_(b.value);
      this.initialRequestsSent_ = !0;
      this.mediaKeyMessageEvents_ = [];
    };
    shaka.media.DrmEngine.prototype.closeSession_ = function (a) {
      var b, c;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (d) {
        if (1 == d.nextAddress)
          return (
            (b = shaka.media.DrmEngine),
            (c = new Promise(function (e, f) {
              new shaka.util.Timer(f).tickAfter(b.CLOSE_TIMEOUT_);
            })),
            d.setCatchFinallyBlocks(2),
            d.yield(Promise.race([Promise.all([a.close(), a.closed]), c]), 4)
          );
        if (2 != d.nextAddress) return d.leaveTryBlock(0);
        d.enterCatchBlock();
        shaka.log.warning('Timeout waiting for session close');
        d.jumpToEnd();
      });
    };
    shaka.media.DrmEngine.prototype.closeOpenSessions_ = function () {
      var a = this,
        b;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (c) {
        b = Array.from(a.activeSessions_.keys());
        a.activeSessions_.clear();
        return c.yield(
          Promise.all(
            b.map(function (d) {
              return $jscomp.asyncExecutePromiseGeneratorProgram(function (e) {
                if (1 == e.nextAddress)
                  return (
                    shaka.log.v1('Closing session', d.sessionId),
                    e.setCatchFinallyBlocks(2),
                    e.yield(a.closeSession_(d), 4)
                  );
                if (2 != e.nextAddress) return e.leaveTryBlock(0);
                e.enterCatchBlock();
                e.jumpToEnd();
              });
            }),
          ),
          0,
        );
      });
    };
    shaka.media.DrmEngine.prototype.supportsVariant = function (a) {
      var b = a.audio;
      a = a.video;
      if (b && b.encrypted) {
        var c = shaka.util.MimeUtils.getFullType(b.mimeType, b.codecs);
        if (!this.willSupport(c)) return !1;
      }
      if (a && a.encrypted && ((c = shaka.util.MimeUtils.getFullType(a.mimeType, a.codecs)), !this.willSupport(c)))
        return !1;
      var d = shaka.media.DrmEngine.keySystem(this.currentDrmInfo_);
      b = (a ? a.drmInfos : []).concat(b ? b.drmInfos : []);
      return (
        0 == b.length ||
        b.some(function (e) {
          return e.keySystem == d;
        })
      );
    };
    shaka.media.DrmEngine.areDrmCompatible = function (a, b) {
      return a.length && b.length ? 0 < shaka.media.DrmEngine.getCommonDrmInfos(a, b).length : !0;
    };
    shaka.media.DrmEngine.getCommonDrmInfos = function (a, b) {
      if (!a.length) return b;
      if (!b.length) return a;
      for (var c = [], d = $jscomp.makeIterator(a), e = d.next(); !e.done; e = d.next()) {
        e = e.value;
        for (var f = $jscomp.makeIterator(b), g = f.next(); !g.done; g = f.next())
          if (((g = g.value), e.keySystem == g.keySystem)) {
            f = [];
            f = f.concat(e.initData || []);
            f = f.concat(g.initData || []);
            var h =
              e.keyIds && g.keyIds
                ? new Set([].concat($jscomp.arrayFromIterable(e.keyIds), $jscomp.arrayFromIterable(g.keyIds)))
                : e.keyIds || g.keyIds;
            c.push({
              keySystem: e.keySystem,
              licenseServerUri: e.licenseServerUri || g.licenseServerUri,
              distinctiveIdentifierRequired: e.distinctiveIdentifierRequired || g.distinctiveIdentifierRequired,
              persistentStateRequired: e.persistentStateRequired || g.persistentStateRequired,
              videoRobustness: e.videoRobustness || g.videoRobustness,
              audioRobustness: e.audioRobustness || g.audioRobustness,
              serverCertificate: e.serverCertificate || g.serverCertificate,
              initData: f,
              keyIds: h,
            });
            break;
          }
      }
      return c;
    };
    shaka.media.DrmEngine.prototype.pollExpiration_ = function () {
      var a = this;
      this.activeSessions_.forEach(function (b, c) {
        var d = b.oldExpiration,
          e = c.expiration;
        isNaN(e) && (e = Infinity);
        e != d && (a.playerInterface_.onExpirationUpdated(c.sessionId, e), (b.oldExpiration = e));
      });
    };
    shaka.media.DrmEngine.prototype.areAllSessionsLoaded_ = function () {
      var a = this.activeSessions_.values();
      return shaka.util.Iterables.every(a, function (b) {
        return b.loaded;
      });
    };
    shaka.media.DrmEngine.replaceDrmInfo_ = function (a, b) {
      var c = [];
      b.forEach(function (f, g) {
        c.push({
          keySystem: g,
          licenseServerUri: f,
          distinctiveIdentifierRequired: !1,
          persistentStateRequired: !1,
          audioRobustness: '',
          videoRobustness: '',
          serverCertificate: null,
          initData: [],
          keyIds: new Set(),
        });
      });
      for (var d = $jscomp.makeIterator(a), e = d.next(); !e.done; e = d.next())
        (e = e.value), e.video && (e.video.drmInfos = c), e.audio && (e.audio.drmInfos = c);
    };
    shaka.media.DrmEngine.createDrmInfoFor_ = function (a, b) {
      var c = [],
        d = [],
        e = [],
        f = new Set();
      shaka.media.DrmEngine.processDrmInfos_(b.drmInfos, c, d, e, f);
      1 < d.length && shaka.log.warning('Multiple unique server certificates found! Only the first will be used.');
      1 < c.length && shaka.log.warning('Multiple unique license server URIs found! Only the first will be used.');
      return {
        keySystem: a,
        licenseServerUri: c[0],
        distinctiveIdentifierRequired: 'required' == b.distinctiveIdentifier,
        persistentStateRequired: 'required' == b.persistentState,
        audioRobustness: (b.audioCapabilities ? b.audioCapabilities[0].robustness : '') || '',
        videoRobustness: (b.videoCapabilities ? b.videoCapabilities[0].robustness : '') || '',
        serverCertificate: d[0],
        initData: e,
        keyIds: f,
      };
    };
    shaka.media.DrmEngine.processDrmInfos_ = function (a, b, c, d, e) {
      var f = {};
      a = $jscomp.makeIterator(a);
      for (
        var g = a.next();
        !g.done;
        f = { $jscomp$loop$prop$drmInfo$521: f.$jscomp$loop$prop$drmInfo$521 }, g = a.next()
      ) {
        f.$jscomp$loop$prop$drmInfo$521 = g.value;
        b.includes(f.$jscomp$loop$prop$drmInfo$521.licenseServerUri) ||
          b.push(f.$jscomp$loop$prop$drmInfo$521.licenseServerUri);
        f.$jscomp$loop$prop$drmInfo$521.serverCertificate &&
          (c.some(
            (function (l) {
              return function (m) {
                return shaka.util.BufferUtils.equal(m, l.$jscomp$loop$prop$drmInfo$521.serverCertificate);
              };
            })(f),
          ) ||
            c.push(f.$jscomp$loop$prop$drmInfo$521.serverCertificate));
        if (f.$jscomp$loop$prop$drmInfo$521.initData) {
          g = {};
          for (
            var h = $jscomp.makeIterator(f.$jscomp$loop$prop$drmInfo$521.initData), k = h.next();
            !k.done;
            g = { $jscomp$loop$prop$initDataOverride$523: g.$jscomp$loop$prop$initDataOverride$523 }, k = h.next()
          )
            (g.$jscomp$loop$prop$initDataOverride$523 = k.value),
              d.some(
                (function (l) {
                  return function (m) {
                    var n = l.$jscomp$loop$prop$initDataOverride$523;
                    m =
                      m.keyId && m.keyId == n.keyId
                        ? !0
                        : m.initDataType == n.initDataType && shaka.util.BufferUtils.equal(m.initData, n.initData);
                    return m;
                  };
                })(g),
              ) || d.push(g.$jscomp$loop$prop$initDataOverride$523);
        }
        if (f.$jscomp$loop$prop$drmInfo$521.keyIds)
          for (g = $jscomp.makeIterator(f.$jscomp$loop$prop$drmInfo$521.keyIds), h = g.next(); !h.done; h = g.next())
            e.add(h.value);
      }
    };
    shaka.media.DrmEngine.fillInDrmInfoDefaults_ = function (a, b, c) {
      if (a.keySystem && ('org.w3.clearkey' != a.keySystem || !a.licenseServerUri)) {
        b.size && ((b = b.get(a.keySystem) || ''), (a.licenseServerUri = b));
        a.keyIds || (a.keyIds = new Set());
        if ((c = c.get(a.keySystem)))
          a.distinctiveIdentifierRequired || (a.distinctiveIdentifierRequired = c.distinctiveIdentifierRequired),
            a.persistentStateRequired || (a.persistentStateRequired = c.persistentStateRequired),
            a.videoRobustness || (a.videoRobustness = c.videoRobustness),
            a.audioRobustness || (a.audioRobustness = c.audioRobustness),
            a.serverCertificate || (a.serverCertificate = c.serverCertificate);
        window.cast &&
          window.cast.__platform__ &&
          'com.microsoft.playready' == a.keySystem &&
          (a.keySystem = 'com.chromecast.playready');
      }
    };
    shaka.media.DrmEngine.CLOSE_TIMEOUT_ = 1;
    shaka.media.DrmEngine.SESSION_LOAD_TIMEOUT_ = 5;
    shaka.media.DrmEngine.KEY_STATUS_BATCH_TIME = 0.5;
    shaka.media.DrmEngine.DUMMY_KEY_ID = new shaka.util.Lazy(function () {
      return shaka.util.BufferUtils.toArrayBuffer(new Uint8Array([0]));
    });
    shaka.media.IClosedCaptionParser = function () {};
    shaka.media.IClosedCaptionParser.prototype.init = function (a) {};
    shaka.media.IClosedCaptionParser.prototype.parseFrom = function (a, b) {};
    shaka.media.IClosedCaptionParser.prototype.reset = function () {};
    shaka.media.MuxJSClosedCaptionParser = function () {
      this.muxCaptionParser_ = new muxjs.mp4.CaptionParser();
      this.videoTrackIds_ = [];
      this.timescales_ = {};
    };
    shaka.media.MuxJSClosedCaptionParser.prototype.init = function (a) {
      var b = muxjs.mp4.probe;
      a = shaka.util.BufferUtils.toUint8(a);
      this.videoTrackIds_ = b.videoTrackIds(a);
      this.timescales_ = b.timescale(a);
      this.muxCaptionParser_.init();
    };
    shaka.media.MuxJSClosedCaptionParser.prototype.parseFrom = function (a, b) {
      var c = shaka.util.BufferUtils.toUint8(a);
      (c = this.muxCaptionParser_.parse(c, this.videoTrackIds_, this.timescales_)) && c.captions && b(c.captions);
      this.muxCaptionParser_.clearParsedCaptions();
    };
    shaka.media.MuxJSClosedCaptionParser.prototype.reset = function () {
      this.muxCaptionParser_.resetCaptionStream();
    };
    shaka.media.MuxJSClosedCaptionParser.isSupported = function () {
      return !!window.muxjs;
    };
    shaka.media.NoopCaptionParser = function () {};
    shaka.media.NoopCaptionParser.prototype.init = function (a) {};
    shaka.media.NoopCaptionParser.prototype.parseFrom = function (a, b) {};
    shaka.media.NoopCaptionParser.prototype.reset = function () {};
    shaka.media.TimeRangesUtils = function () {};
    shaka.media.TimeRangesUtils.bufferStart = function (a) {
      return !a || (1 == a.length && 1e-6 > a.end(0) - a.start(0))
        ? null
        : 1 == a.length && 0 > a.start(0)
        ? 0
        : a.length
        ? a.start(0)
        : null;
    };
    shaka.media.TimeRangesUtils.bufferEnd = function (a) {
      return !a || (1 == a.length && 1e-6 > a.end(0) - a.start(0)) ? null : a.length ? a.end(a.length - 1) : null;
    };
    shaka.media.TimeRangesUtils.isBuffered = function (a, b, c) {
      c = void 0 === c ? 0 : c;
      return !a || !a.length || (1 == a.length && 1e-6 > a.end(0) - a.start(0)) || b > a.end(a.length - 1)
        ? !1
        : b + c >= a.start(0);
    };
    shaka.media.TimeRangesUtils.bufferedAheadOf = function (a, b) {
      if (!a || !a.length || (1 == a.length && 1e-6 > a.end(0) - a.start(0))) return 0;
      for (
        var c = 0, d = $jscomp.makeIterator(shaka.media.TimeRangesUtils.getBufferedInfo(a)), e = d.next();
        !e.done;
        e = d.next()
      ) {
        var f = e.value;
        e = f.start;
        f = f.end;
        f > b && (c += f - Math.max(e, b));
      }
      return c;
    };
    shaka.media.TimeRangesUtils.getGapIndex = function (a, b) {
      var c = shaka.util.Platform,
        d = shaka.media.TimeRangesUtils;
      if (!a || !a.length || (1 == a.length && 1e-6 > a.end(0) - a.start(0))) return null;
      var e = c.isEdge() || c.isIE() || c.isTizen() || c.isChromecast() ? 0.5 : 0.1;
      c = d.getBufferedInfo(a).findIndex(function (f, g, h) {
        return f.start > b && (0 == g || h[g - 1].end - b <= e);
      });
      return 0 <= c ? c : null;
    };
    shaka.media.TimeRangesUtils.getBufferedInfo = function (a) {
      if (!a) return [];
      for (
        var b = [], c = $jscomp.makeIterator(shaka.util.Iterables.range(a.length)), d = c.next();
        !d.done;
        d = c.next()
      )
        (d = d.value), b.push({ start: a.start(d), end: a.end(d) });
      return b;
    };
    shaka.media.Transmuxer = function () {
      var a = this;
      this.muxTransmuxer_ = new muxjs.mp4.Transmuxer({ keepOriginalTimestamps: !0 });
      this.transmuxPromise_ = null;
      this.transmuxedData_ = [];
      this.captions_ = [];
      this.metadata_ = [];
      this.isTransmuxing_ = !1;
      this.muxTransmuxer_.on('data', function (b) {
        return a.onTransmuxed_(b);
      });
      this.muxTransmuxer_.on('done', function () {
        return a.onTransmuxDone_();
      });
    };
    shaka.media.Transmuxer.prototype.destroy = function () {
      this.muxTransmuxer_.dispose();
      this.muxTransmuxer_ = null;
      return Promise.resolve();
    };
    shaka.media.Transmuxer.isSupported = function (a, b) {
      var c = shaka.media.Transmuxer;
      if (!window.muxjs || !c.isTsContainer(a)) return !1;
      if (b) return MediaSource.isTypeSupported(c.convertTsCodecs(b, a));
      var d = shaka.util.ManifestParserUtils.ContentType,
        e = c.convertTsCodecs(d.AUDIO, a);
      c = c.convertTsCodecs(d.VIDEO, a);
      return MediaSource.isTypeSupported(e) || MediaSource.isTypeSupported(c);
    };
    shaka.media.Transmuxer.isTsContainer = function (a) {
      return 'mp2t' == a.toLowerCase().split(';')[0].split('/')[1];
    };
    shaka.media.Transmuxer.convertTsCodecs = function (a, b) {
      var c = shaka.util.ManifestParserUtils.ContentType,
        d = b.replace(/mp2t/i, 'mp4');
      a == c.AUDIO && (d = d.replace('video', 'audio'));
      if ((c = /avc1\.(66|77|100)\.(\d+)/.exec(d))) {
        var e = 'avc1.',
          f = c[1];
        '66' == f
          ? (e += '4200')
          : '77' == f
          ? (e += '4d00')
          : (goog.asserts.assert('100' == f, 'Legacy avc1 parsing code out of sync with regex!'), (e += '6400'));
        f = Number(c[2]);
        goog.asserts.assert(256 > f, 'Invalid legacy avc1 level number!');
        e += (f >> 4).toString(16);
        e += (f & 15).toString(16);
        d = d.replace(c[0], e);
      }
      return d;
    };
    shaka.media.Transmuxer.prototype.transmux = function (a) {
      goog.asserts.assert(!this.isTransmuxing_, 'No transmuxing should be in progress.');
      this.isTransmuxing_ = !0;
      this.transmuxPromise_ = new shaka.util.PublicPromise();
      this.transmuxedData_ = [];
      this.captions_ = [];
      this.metadata_ = [];
      a = shaka.util.BufferUtils.toUint8(a);
      this.muxTransmuxer_.push(a);
      this.muxTransmuxer_.flush();
      this.isTransmuxing_ &&
        this.transmuxPromise_.reject(
          new shaka.util.Error(
            shaka.util.Error.Severity.CRITICAL,
            shaka.util.Error.Category.MEDIA,
            shaka.util.Error.Code.TRANSMUXING_FAILED,
          ),
        );
      return this.transmuxPromise_;
    };
    shaka.media.Transmuxer.prototype.onTransmuxed_ = function (a) {
      this.captions_ = a.captions;
      this.metadata_ = a.metadata;
      this.transmuxedData_.push(shaka.util.Uint8ArrayUtils.concat(a.initSegment, a.data));
    };
    shaka.media.Transmuxer.prototype.onTransmuxDone_ = function () {
      var a = {
        data: shaka.util.Uint8ArrayUtils.concat.apply(
          shaka.util.Uint8ArrayUtils,
          $jscomp.arrayFromIterable(this.transmuxedData_),
        ),
        captions: this.captions_,
        metadata: this.metadata_,
      };
      this.transmuxPromise_.resolve(a);
      this.isTransmuxing_ = !1;
    };
    shaka.text = {};
    shaka.text.Cue = function (a, b, c) {
      var d = shaka.text.Cue;
      this.startTime = a;
      this.direction = d.direction.HORIZONTAL_LEFT_TO_RIGHT;
      this.endTime = b;
      this.payload = c;
      this.region = new shaka.text.CueRegion();
      this.position = null;
      this.positionAlign = d.positionAlign.AUTO;
      this.size = 0;
      this.textAlign = d.textAlign.CENTER;
      this.writingMode = d.writingMode.HORIZONTAL_TOP_TO_BOTTOM;
      this.lineInterpretation = d.lineInterpretation.LINE_NUMBER;
      this.line = null;
      this.lineHeight = '';
      this.lineAlign = d.lineAlign.START;
      this.displayAlign = d.displayAlign.AFTER;
      this.fontSize = this.border = this.backgroundImage = this.backgroundColor = this.color = '';
      this.fontWeight = d.fontWeight.NORMAL;
      this.fontStyle = d.fontStyle.NORMAL;
      this.linePadding = this.letterSpacing = this.fontFamily = '';
      this.opacity = 1;
      this.textDecoration = [];
      this.wrapLine = !0;
      this.id = '';
      this.nestedCues = [];
      this.spacer = !1;
      this.cellResolution = { columns: 32, rows: 15 };
    };
    shaka.text.Cue.prototype.clone = function () {
      var a = new shaka.text.Cue(0, 0, ''),
        b;
      for (b in this) (a[b] = this[b]), a[b] && a[b].constructor == Array && (a[b] = a[b].slice());
      return a;
    };
    shaka.text.Cue.equal = function (a, b) {
      for (var c in a)
        if ('nestedCues' == c) {
          if (!shaka.util.ArrayUtils.equal(a.nestedCues, b.nestedCues, shaka.text.Cue.equal)) return !1;
        } else if ('region' == c || 'cellResolution' == c)
          for (var d in a[c]) {
            if (a[c][d] != b[c][d]) return !1;
          }
        else if (Array.isArray(a[c])) {
          if (!shaka.util.ArrayUtils.equal(a[c], b[c])) return !1;
        } else if (a[c] != b[c]) return !1;
      return !0;
    };
    goog.exportSymbol('shaka.text.Cue', shaka.text.Cue);
    shaka.text.Cue.positionAlign = { LEFT: 'line-left', RIGHT: 'line-right', CENTER: 'center', AUTO: 'auto' };
    goog.exportProperty(shaka.text.Cue, 'positionAlign', shaka.text.Cue.positionAlign);
    shaka.text.Cue.textAlign = { LEFT: 'left', RIGHT: 'right', CENTER: 'center', START: 'start', END: 'end' };
    goog.exportProperty(shaka.text.Cue, 'textAlign', shaka.text.Cue.textAlign);
    shaka.text.Cue.displayAlign = { BEFORE: 'before', CENTER: 'center', AFTER: 'after' };
    goog.exportProperty(shaka.text.Cue, 'displayAlign', shaka.text.Cue.displayAlign);
    shaka.text.Cue.direction = { HORIZONTAL_LEFT_TO_RIGHT: 'ltr', HORIZONTAL_RIGHT_TO_LEFT: 'rtl' };
    goog.exportProperty(shaka.text.Cue, 'direction', shaka.text.Cue.direction);
    shaka.text.Cue.writingMode = {
      HORIZONTAL_TOP_TO_BOTTOM: 'horizontal-tb',
      VERTICAL_LEFT_TO_RIGHT: 'vertical-lr',
      VERTICAL_RIGHT_TO_LEFT: 'vertical-rl',
    };
    goog.exportProperty(shaka.text.Cue, 'writingMode', shaka.text.Cue.writingMode);
    shaka.text.Cue.lineInterpretation = { LINE_NUMBER: 0, PERCENTAGE: 1 };
    goog.exportProperty(shaka.text.Cue, 'lineInterpretation', shaka.text.Cue.lineInterpretation);
    shaka.text.Cue.lineAlign = { CENTER: 'center', START: 'start', END: 'end' };
    goog.exportProperty(shaka.text.Cue, 'lineAlign', shaka.text.Cue.lineAlign);
    shaka.text.Cue.fontWeight = { NORMAL: 400, BOLD: 700 };
    goog.exportProperty(shaka.text.Cue, 'fontWeight', shaka.text.Cue.fontWeight);
    shaka.text.Cue.fontStyle = { NORMAL: 'normal', ITALIC: 'italic', OBLIQUE: 'oblique' };
    goog.exportProperty(shaka.text.Cue, 'fontStyle', shaka.text.Cue.fontStyle);
    shaka.text.Cue.textDecoration = { UNDERLINE: 'underline', LINE_THROUGH: 'lineThrough', OVERLINE: 'overline' };
    goog.exportProperty(shaka.text.Cue, 'textDecoration', shaka.text.Cue.textDecoration);
    shaka.text.CueRegion = function () {
      var a = shaka.text.CueRegion;
      this.id = '';
      this.regionAnchorY = this.regionAnchorX = this.viewportAnchorY = this.viewportAnchorX = 0;
      this.height = this.width = 100;
      this.viewportAnchorUnits = this.widthUnits = this.heightUnits = a.units.PERCENTAGE;
      this.scroll = a.scrollMode.NONE;
    };
    goog.exportSymbol('shaka.text.CueRegion', shaka.text.CueRegion);
    shaka.text.CueRegion.units = { PX: 0, PERCENTAGE: 1, LINES: 2 };
    goog.exportProperty(shaka.text.CueRegion, 'units', shaka.text.CueRegion.units);
    shaka.text.CueRegion.scrollMode = { NONE: '', UP: 'up' };
    goog.exportProperty(shaka.text.CueRegion, 'scrollMode', shaka.text.CueRegion.scrollMode);
    shaka.text.TextEngine = function (a) {
      this.parser_ = null;
      this.displayer_ = a;
      this.appendWindowStart_ = this.timestampOffset_ = 0;
      this.appendWindowEnd_ = Infinity;
      this.bufferEnd_ = this.bufferStart_ = null;
      this.selectedClosedCaptionId_ = '';
      this.closedCaptionsMap_ = new Map();
    };
    shaka.text.TextEngine.registerParser = function (a, b) {
      shaka.text.TextEngine.parserMap_[a] = b;
    };
    shaka.text.TextEngine.unregisterParser = function (a) {
      delete shaka.text.TextEngine.parserMap_[a];
    };
    shaka.text.TextEngine.isTypeSupported = function (a) {
      return shaka.text.TextEngine.parserMap_[a] || (window.muxjs && a == shaka.util.MimeUtils.CLOSED_CAPTION_MIMETYPE)
        ? !0
        : !1;
    };
    shaka.text.TextEngine.prototype.destroy = function () {
      this.displayer_ = this.parser_ = null;
      this.closedCaptionsMap_.clear();
      return Promise.resolve();
    };
    shaka.text.TextEngine.prototype.setDisplayer = function (a) {
      this.displayer_ = a;
    };
    shaka.text.TextEngine.prototype.initParser = function (a) {
      a != shaka.util.MimeUtils.CLOSED_CAPTION_MIMETYPE &&
        ((a = shaka.text.TextEngine.parserMap_[a]),
        goog.asserts.assert(a, 'Text type negotiation should have happened already'),
        (this.parser_ = shaka.util.Functional.callFactory(a)));
    };
    shaka.text.TextEngine.prototype.appendBuffer = function (a, b, c) {
      var d = this,
        e,
        f,
        g;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (h) {
        if (1 == h.nextAddress)
          return (
            goog.asserts.assert(d.parser_, 'The parser should already be initialized'), h.yield(Promise.resolve(), 2)
          );
        if (!d.parser_ || !d.displayer_) return h['return']();
        if (null == b || null == c) return d.parser_.parseInit(shaka.util.BufferUtils.toUint8(a)), h['return']();
        e = { periodStart: d.timestampOffset_, segmentStart: b, segmentEnd: c };
        f = d.parser_.parseMedia(shaka.util.BufferUtils.toUint8(a), e);
        g = f.filter(function (k) {
          return k.startTime >= d.appendWindowStart_ && k.startTime < d.appendWindowEnd_;
        });
        d.displayer_.append(g);
        null == d.bufferStart_
          ? (d.bufferStart_ = Math.max(b, d.appendWindowStart_))
          : (goog.asserts.assert(null != d.bufferEnd_, 'There should already be a buffered range end.'),
            goog.asserts.assert(1 >= b - d.bufferEnd_, 'There should not be a gap in text references >1s'));
        d.bufferEnd_ = Math.min(c, d.appendWindowEnd_);
        h.jumpToEnd();
      });
    };
    shaka.text.TextEngine.prototype.remove = function (a, b) {
      var c = this;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (d) {
        if (1 == d.nextAddress) return d.yield(Promise.resolve(), 2);
        c.displayer_ &&
          c.displayer_.remove(a, b) &&
          (null == c.bufferStart_
            ? goog.asserts.assert(null == c.bufferEnd_, 'end must be null if startTime is null')
            : (goog.asserts.assert(null != c.bufferEnd_, 'end must be non-null if startTime is non-null'),
              b <= c.bufferStart_ ||
                a >= c.bufferEnd_ ||
                (a <= c.bufferStart_ && b >= c.bufferEnd_
                  ? (c.bufferStart_ = c.bufferEnd_ = null)
                  : a <= c.bufferStart_ && b < c.bufferEnd_
                  ? (c.bufferStart_ = b)
                  : a > c.bufferStart_ && b >= c.bufferEnd_
                  ? (c.bufferEnd_ = a)
                  : goog.asserts.assert(!1, 'removal from the middle is not supported by TextEngine'))));
        d.jumpToEnd();
      });
    };
    shaka.text.TextEngine.prototype.setTimestampOffset = function (a) {
      this.timestampOffset_ = a;
    };
    shaka.text.TextEngine.prototype.setAppendWindow = function (a, b) {
      this.appendWindowStart_ = a;
      this.appendWindowEnd_ = b;
    };
    shaka.text.TextEngine.prototype.bufferStart = function () {
      return this.bufferStart_;
    };
    shaka.text.TextEngine.prototype.bufferEnd = function () {
      return this.bufferEnd_;
    };
    shaka.text.TextEngine.prototype.isBuffered = function (a) {
      return null == this.bufferStart_ || null == this.bufferEnd_ ? !1 : a >= this.bufferStart_ && a < this.bufferEnd_;
    };
    shaka.text.TextEngine.prototype.bufferedAheadOf = function (a) {
      if (null == this.bufferEnd_ || this.bufferEnd_ < a) return 0;
      goog.asserts.assert(null != this.bufferStart_, 'start should not be null if end is not null');
      return this.bufferEnd_ - Math.max(a, this.bufferStart_);
    };
    shaka.text.TextEngine.prototype.setSelectedClosedCaptionId = function (a, b) {
      this.selectedClosedCaptionId_ = a;
      var c = this.closedCaptionsMap_.get(a);
      if (c)
        for (var d = $jscomp.makeIterator(c.keys()), e = d.next(); !e.done; e = d.next())
          (e = c.get(e.value).filter(function (f) {
            return f.endTime <= b;
          })) && this.displayer_.append(e);
    };
    shaka.text.TextEngine.prototype.storeAndAppendClosedCaptions = function (a, b, c, d) {
      var e = b + ' ' + c,
        f = new Map();
      a = $jscomp.makeIterator(a);
      for (var g = a.next(); !g.done; g = a.next()) {
        var h = g.value;
        g = h.stream;
        f.has(g) || f.set(g, new Map());
        f.get(g).has(e) || f.get(g).set(e, []);
        h.startTime += d;
        h.endTime += d;
        h.startTime >= this.appendWindowStart_ &&
          h.startTime < this.appendWindowEnd_ &&
          ((h = new shaka.text.Cue(h.startTime, h.endTime, h.text)),
          f.get(g).get(e).push(h),
          g == this.selectedClosedCaptionId_ && this.displayer_.append([h]));
      }
      d = $jscomp.makeIterator(f.keys());
      for (e = d.next(); !e.done; e = d.next())
        for (
          e = e.value,
            this.closedCaptionsMap_.has(e) || this.closedCaptionsMap_.set(e, new Map()),
            a = $jscomp.makeIterator(f.get(e).keys()),
            g = a.next();
          !g.done;
          g = a.next()
        )
          (g = g.value), (h = f.get(e).get(g)), this.closedCaptionsMap_.get(e).set(g, h);
      this.bufferStart_ =
        null == this.bufferStart_
          ? Math.max(b, this.appendWindowStart_)
          : Math.min(this.bufferStart_, Math.max(b, this.appendWindowStart_));
      this.bufferEnd_ = Math.max(this.bufferEnd_, Math.min(c, this.appendWindowEnd_));
    };
    shaka.text.TextEngine.prototype.getNumberOfClosedCaptionChannels = function () {
      return this.closedCaptionsMap_.size;
    };
    shaka.text.TextEngine.prototype.getNumberOfClosedCaptionsInChannel = function (a) {
      return (a = this.closedCaptionsMap_.get(a)) ? a.size : 0;
    };
    goog.exportSymbol('shaka.text.TextEngine', shaka.text.TextEngine);
    goog.exportProperty(shaka.text.TextEngine.prototype, 'destroy', shaka.text.TextEngine.prototype.destroy);
    goog.exportProperty(shaka.text.TextEngine, 'unregisterParser', shaka.text.TextEngine.unregisterParser);
    goog.exportProperty(shaka.text.TextEngine, 'registerParser', shaka.text.TextEngine.registerParser);
    shaka.text.TextEngine.parserMap_ = {};
    shaka.media.MediaSourceEngine = function (a, b, c, d) {
      var e = this;
      this.video_ = a;
      this.textDisplayer_ = c;
      this.sourceBuffers_ = {};
      this.textEngine_ = null;
      a = function (f, g, h) {};
      this.onMetadata_ = d || a;
      this.queues_ = {};
      this.eventManager_ = new shaka.util.EventManager();
      this.transmuxers_ = {};
      this.captionParser_ = b;
      this.mediaSourceOpen_ = new shaka.util.PublicPromise();
      this.mediaSource_ = this.createMediaSource(this.mediaSourceOpen_);
      this.destroyer_ = new shaka.util.Destroyer(function () {
        return e.doDestroy_();
      });
    };
    shaka.media.MediaSourceEngine.prototype.createMediaSource = function (a) {
      var b = new MediaSource();
      this.eventManager_.listenOnce(b, 'sourceopen', a.resolve);
      this.video_.src = shaka.media.MediaSourceEngine.createObjectURL(b);
      return b;
    };
    shaka.media.MediaSourceEngine.isStreamSupported = function (a) {
      var b = shaka.util.MimeUtils.getFullType(a.mimeType, a.codecs),
        c = shaka.util.MimeUtils.getExtendedType(a);
      return (
        shaka.text.TextEngine.isTypeSupported(b) ||
        MediaSource.isTypeSupported(c) ||
        shaka.media.Transmuxer.isSupported(b, a.type)
      );
    };
    shaka.media.MediaSourceEngine.probeSupport = function () {
      for (
        var a = {},
          b = $jscomp.makeIterator(
            'video/mp4; codecs="avc1.42E01E",video/mp4; codecs="avc3.42E01E",video/mp4; codecs="hev1.1.6.L93.90",video/mp4; codecs="hvc1.1.6.L93.90",video/mp4; codecs="hev1.2.4.L153.B0"; eotf="smpte2084",video/mp4; codecs="hvc1.2.4.L153.B0"; eotf="smpte2084",video/mp4; codecs="vp9",video/mp4; codecs="vp09.00.10.08",video/mp4; codecs="av01.0.01M.08",audio/mp4; codecs="mp4a.40.2",audio/mp4; codecs="ac-3",audio/mp4; codecs="ec-3",audio/mp4; codecs="opus",audio/mp4; codecs="flac",video/webm; codecs="vp8",video/webm; codecs="vp9",video/webm; codecs="vp09.00.10.08",audio/webm; codecs="vorbis",audio/webm; codecs="opus",video/mp2t; codecs="avc1.42E01E",video/mp2t; codecs="avc3.42E01E",video/mp2t; codecs="hvc1.1.6.L93.90",video/mp2t; codecs="mp4a.40.2",video/mp2t; codecs="ac-3",video/mp2t; codecs="ec-3",text/vtt,application/mp4; codecs="wvtt",application/ttml+xml,application/mp4; codecs="stpp"'.split(
              ',',
            ),
          ),
          c = b.next();
        !c.done;
        c = b.next()
      ) {
        c = c.value;
        shaka.util.Platform.supportsMediaSource()
          ? shaka.text.TextEngine.isTypeSupported(c)
            ? (a[c] = !0)
            : (a[c] = MediaSource.isTypeSupported(c) || shaka.media.Transmuxer.isSupported(c))
          : (a[c] = shaka.util.Platform.supportsMediaType(c));
        var d = c.split(';')[0];
        a[d] = a[d] || a[c];
      }
      return a;
    };
    shaka.media.MediaSourceEngine.prototype.destroy = function () {
      return this.destroyer_.destroy();
    };
    shaka.media.MediaSourceEngine.prototype.doDestroy_ = function () {
      var a = this,
        b,
        c,
        d,
        e,
        f,
        g,
        h,
        k,
        l,
        m;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (n) {
        if (1 == n.nextAddress) {
          b = shaka.util.Functional;
          c = [];
          for (d in a.queues_)
            for (
              e = a.queues_[d],
                f = e[0],
                a.queues_[d] = e.slice(0, 1),
                f && c.push(f.p['catch'](b.noop)),
                g = $jscomp.makeIterator(e.slice(1)),
                h = g.next();
              !h.done;
              h = g.next()
            )
              (k = h.value), k.p.reject(shaka.util.Destroyer.destroyedError());
          a.textEngine_ && c.push(a.textEngine_.destroy());
          a.textDisplayer_ && c.push(a.textDisplayer_.destroy());
          for (l in a.transmuxers_) c.push(a.transmuxers_[l].destroy());
          return n.yield(Promise.all(c), 2);
        }
        a.eventManager_ && (a.eventManager_.release(), (a.eventManager_ = null));
        a.video_ && (a.video_.removeAttribute('src'), a.video_.load(), (a.video_ = null));
        a.mediaSource_ = null;
        a.textEngine_ = null;
        a.textDisplayer_ = null;
        a.sourceBuffers_ = {};
        a.transmuxers_ = {};
        a.captionParser_ = null;
        if (goog.DEBUG)
          for (m in a.queues_)
            goog.asserts.assert(0 == a.queues_[m].length, m + ' queue should be empty after destroy!');
        a.queues_ = {};
        n.jumpToEnd();
      });
    };
    shaka.media.MediaSourceEngine.prototype.open = function () {
      return this.mediaSourceOpen_;
    };
    shaka.media.MediaSourceEngine.prototype.init = function (a, b) {
      var c = this,
        d,
        e,
        f,
        g,
        h,
        k,
        l;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (m) {
        if (1 == m.nextAddress) return (d = shaka.util.ManifestParserUtils.ContentType), m.yield(c.mediaSourceOpen_, 2);
        e = {};
        f = $jscomp.makeIterator(a.keys());
        for (
          g = f.next();
          !g.done;
          e = { $jscomp$loop$prop$contentType$526: e.$jscomp$loop$prop$contentType$526 }, g = f.next()
        )
          (e.$jscomp$loop$prop$contentType$526 = g.value),
            (h = a.get(e.$jscomp$loop$prop$contentType$526)),
            goog.asserts.assert(
              shaka.media.MediaSourceEngine.isStreamSupported(h),
              'Type negotiation should happen before MediaSourceEngine.init!',
            ),
            (k = shaka.util.MimeUtils.getFullType(h.mimeType, h.codecs)),
            e.$jscomp$loop$prop$contentType$526 == d.TEXT
              ? c.reinitText(k)
              : ((!b && MediaSource.isTypeSupported(k)) ||
                  !shaka.media.Transmuxer.isSupported(k, e.$jscomp$loop$prop$contentType$526) ||
                  ((c.transmuxers_[e.$jscomp$loop$prop$contentType$526] = new shaka.media.Transmuxer()),
                  (k = shaka.media.Transmuxer.convertTsCodecs(e.$jscomp$loop$prop$contentType$526, k))),
                (l = c.mediaSource_.addSourceBuffer(k)),
                c.eventManager_.listen(
                  l,
                  'error',
                  (function (n) {
                    return function () {
                      return c.onError_(n.$jscomp$loop$prop$contentType$526);
                    };
                  })(e),
                ),
                c.eventManager_.listen(
                  l,
                  'updateend',
                  (function (n) {
                    return function () {
                      return c.onUpdateEnd_(n.$jscomp$loop$prop$contentType$526);
                    };
                  })(e),
                ),
                (c.sourceBuffers_[e.$jscomp$loop$prop$contentType$526] = l),
                (c.queues_[e.$jscomp$loop$prop$contentType$526] = []));
        m.jumpToEnd();
      });
    };
    shaka.media.MediaSourceEngine.prototype.reinitText = function (a) {
      this.textEngine_ || (this.textEngine_ = new shaka.text.TextEngine(this.textDisplayer_));
      this.textEngine_.initParser(a);
    };
    shaka.media.MediaSourceEngine.prototype.ended = function () {
      return this.mediaSource_ ? 'ended' == this.mediaSource_.readyState : !0;
    };
    shaka.media.MediaSourceEngine.prototype.bufferStart = function (a) {
      return a == shaka.util.ManifestParserUtils.ContentType.TEXT
        ? this.textEngine_.bufferStart()
        : shaka.media.TimeRangesUtils.bufferStart(this.getBuffered_(a));
    };
    shaka.media.MediaSourceEngine.prototype.bufferEnd = function (a) {
      return a == shaka.util.ManifestParserUtils.ContentType.TEXT
        ? this.textEngine_.bufferEnd()
        : shaka.media.TimeRangesUtils.bufferEnd(this.getBuffered_(a));
    };
    shaka.media.MediaSourceEngine.prototype.isBuffered = function (a, b, c) {
      if (a == shaka.util.ManifestParserUtils.ContentType.TEXT) return this.textEngine_.isBuffered(b);
      a = this.getBuffered_(a);
      return shaka.media.TimeRangesUtils.isBuffered(a, b, c);
    };
    shaka.media.MediaSourceEngine.prototype.bufferedAheadOf = function (a, b) {
      if (a == shaka.util.ManifestParserUtils.ContentType.TEXT) return this.textEngine_.bufferedAheadOf(b);
      var c = this.getBuffered_(a);
      return shaka.media.TimeRangesUtils.bufferedAheadOf(c, b);
    };
    shaka.media.MediaSourceEngine.prototype.getBufferedInfo = function () {
      var a = shaka.util.ManifestParserUtils.ContentType,
        b = shaka.media.TimeRangesUtils;
      a = {
        total: b.getBufferedInfo(this.video_.buffered),
        audio: b.getBufferedInfo(this.getBuffered_(a.AUDIO)),
        video: b.getBufferedInfo(this.getBuffered_(a.VIDEO)),
        text: [],
      };
      if (this.textEngine_) {
        b = this.textEngine_.bufferStart();
        var c = this.textEngine_.bufferEnd();
        null != b && null != c && a.text.push({ start: b, end: c });
      }
      return a;
    };
    shaka.media.MediaSourceEngine.prototype.getBuffered_ = function (a) {
      try {
        return this.sourceBuffers_[a].buffered;
      } catch (b) {
        return a in this.sourceBuffers_ && shaka.log.error('failed to get buffered range for ' + a, b), null;
      }
    };
    shaka.media.MediaSourceEngine.prototype.appendBuffer = function (a, b, c, d, e) {
      var f = this,
        g,
        h,
        k,
        l;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (m) {
        if (1 == m.nextAddress) {
          g = shaka.util.ManifestParserUtils.ContentType;
          if (a == g.TEXT) return m.yield(f.textEngine_.appendBuffer(b, c, d), 0);
          if (f.transmuxers_[a]) return m.yield(f.transmuxers_[a].transmux(b), 10);
          e &&
            window.muxjs &&
            (f.textEngine_ || f.reinitText('text/vtt'),
            null == c && null == d
              ? f.captionParser_.init(b)
              : f.captionParser_.parseFrom(b, function (n) {
                  n.length &&
                    f.textEngine_.storeAndAppendClosedCaptions(n, c, d, f.sourceBuffers_[g.VIDEO].timestampOffset);
                }));
          return m.yield(
            f.enqueueOperation_(a, function () {
              return f.append_(a, b);
            }),
            0,
          );
        }
        h = m.yieldResult;
        f.textEngine_ || f.reinitText('text/vtt');
        h.metadata && ((k = f.sourceBuffers_[a].timestampOffset), f.onMetadata_(h.metadata, k, d));
        h.captions &&
          h.captions.length &&
          ((l = f.sourceBuffers_[g.VIDEO].timestampOffset),
          f.textEngine_.storeAndAppendClosedCaptions(h.captions, c, d, l));
        return m.yield(
          f.enqueueOperation_(a, function () {
            return f.append_(a, h.data);
          }),
          0,
        );
      });
    };
    shaka.media.MediaSourceEngine.prototype.setSelectedClosedCaptionId = function (a) {
      var b = this.bufferEnd(shaka.util.ManifestParserUtils.ContentType.VIDEO) || 0;
      this.textEngine_.setSelectedClosedCaptionId(a, b);
    };
    shaka.media.MediaSourceEngine.prototype.remove = function (a, b, c) {
      var d = this,
        e;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (f) {
        goog.asserts.assert(c < Number.MAX_VALUE, 'remove() with MAX_VALUE or Infinity is not IE-compatible!');
        e = shaka.util.ManifestParserUtils.ContentType;
        return a == e.TEXT
          ? f.yield(d.textEngine_.remove(b, c), 0)
          : f.yield(
              d.enqueueOperation_(a, function () {
                return d.remove_(a, b, c);
              }),
              0,
            );
      });
    };
    shaka.media.MediaSourceEngine.prototype.clear = function (a) {
      var b = this,
        c;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (d) {
        c = shaka.util.ManifestParserUtils.ContentType;
        return a == c.TEXT
          ? b.textEngine_
            ? d.yield(b.textEngine_.remove(0, Infinity), 0)
            : d['return']()
          : d.yield(
              b.enqueueOperation_(a, function () {
                return b.remove_(a, 0, b.mediaSource_.duration);
              }),
              0,
            );
      });
    };
    shaka.media.MediaSourceEngine.prototype.resetCaptionParser = function () {
      this.captionParser_.reset();
    };
    shaka.media.MediaSourceEngine.prototype.flush = function (a) {
      var b = this,
        c;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (d) {
        c = shaka.util.ManifestParserUtils.ContentType;
        return a == c.TEXT
          ? d['return']()
          : d.yield(
              b.enqueueOperation_(a, function () {
                return b.flush_(a);
              }),
              0,
            );
      });
    };
    shaka.media.MediaSourceEngine.prototype.setStreamProperties = function (a, b, c, d) {
      var e = this,
        f;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (g) {
        f = shaka.util.ManifestParserUtils.ContentType;
        return a == f.TEXT
          ? (e.textEngine_.setTimestampOffset(b), e.textEngine_.setAppendWindow(c, d), g['return']())
          : g.yield(
              Promise.all([
                e.enqueueOperation_(a, function () {
                  return e.abort_(a);
                }),
                e.enqueueOperation_(a, function () {
                  return e.setTimestampOffset_(a, b);
                }),
                e.enqueueOperation_(a, function () {
                  return e.setAppendWindow_(a, c, d);
                }),
              ]),
              0,
            );
      });
    };
    shaka.media.MediaSourceEngine.prototype.endOfStream = function (a) {
      var b = this;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (c) {
        return c.yield(
          b.enqueueBlockingOperation_(function () {
            b.ended() || (a ? b.mediaSource_.endOfStream(a) : b.mediaSource_.endOfStream());
          }),
          0,
        );
      });
    };
    shaka.media.MediaSourceEngine.prototype.setDuration = function (a) {
      var b = this;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (c) {
        goog.asserts.assert(
          isNaN(b.mediaSource_.duration) || b.mediaSource_.duration <= a,
          'duration cannot decrease: ' + b.mediaSource_.duration + ' -> ' + a,
        );
        return c.yield(
          b.enqueueBlockingOperation_(function () {
            b.mediaSource_.duration = a;
          }),
          0,
        );
      });
    };
    shaka.media.MediaSourceEngine.prototype.getDuration = function () {
      return this.mediaSource_.duration;
    };
    shaka.media.MediaSourceEngine.prototype.append_ = function (a, b) {
      this.sourceBuffers_[a].appendBuffer(b);
    };
    shaka.media.MediaSourceEngine.prototype.remove_ = function (a, b, c) {
      if (c <= b) this.onUpdateEnd_(a);
      else this.sourceBuffers_[a].remove(b, c);
    };
    shaka.media.MediaSourceEngine.prototype.abort_ = function (a) {
      var b = this.sourceBuffers_[a].appendWindowStart,
        c = this.sourceBuffers_[a].appendWindowEnd;
      this.sourceBuffers_[a].abort();
      this.sourceBuffers_[a].appendWindowStart = b;
      this.sourceBuffers_[a].appendWindowEnd = c;
      this.onUpdateEnd_(a);
    };
    shaka.media.MediaSourceEngine.prototype.flush_ = function (a) {
      goog.asserts.assert(
        0 == this.video_.buffered.length,
        'MediaSourceEngine.flush_ should only be used after clearing all data!',
      );
      this.video_.currentTime -= 0.001;
      this.onUpdateEnd_(a);
    };
    shaka.media.MediaSourceEngine.prototype.setTimestampOffset_ = function (a, b) {
      0 > b && (b += 0.001);
      this.sourceBuffers_[a].timestampOffset = b;
      this.onUpdateEnd_(a);
    };
    shaka.media.MediaSourceEngine.prototype.setAppendWindow_ = function (a, b, c) {
      this.sourceBuffers_[a].appendWindowStart = 0;
      this.sourceBuffers_[a].appendWindowEnd = c;
      this.sourceBuffers_[a].appendWindowStart = b;
      this.onUpdateEnd_(a);
    };
    shaka.media.MediaSourceEngine.prototype.onError_ = function (a) {
      var b = this.queues_[a][0];
      goog.asserts.assert(b, 'Spurious error event!');
      goog.asserts.assert(!this.sourceBuffers_[a].updating, 'SourceBuffer should not be updating on error!');
      b.p.reject(
        new shaka.util.Error(
          shaka.util.Error.Severity.CRITICAL,
          shaka.util.Error.Category.MEDIA,
          shaka.util.Error.Code.MEDIA_SOURCE_OPERATION_FAILED,
          this.video_.error ? this.video_.error.code : 0,
        ),
      );
    };
    shaka.media.MediaSourceEngine.prototype.onUpdateEnd_ = function (a) {
      var b = this.queues_[a][0];
      goog.asserts.assert(b, 'Spurious updateend event!');
      b &&
        (goog.asserts.assert(!this.sourceBuffers_[a].updating, 'SourceBuffer should not be updating on updateend!'),
        b.p.resolve(),
        this.popFromQueue_(a));
    };
    shaka.media.MediaSourceEngine.prototype.enqueueOperation_ = function (a, b) {
      this.destroyer_.ensureNotDestroyed();
      var c = { start: b, p: new shaka.util.PublicPromise() };
      this.queues_[a].push(c);
      1 == this.queues_[a].length && this.startOperation_(a);
      return c.p;
    };
    shaka.media.MediaSourceEngine.prototype.enqueueBlockingOperation_ = function (a) {
      var b = this,
        c,
        d,
        e,
        f,
        g,
        h,
        k,
        l;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (m) {
        switch (m.nextAddress) {
          case 1:
            b.destroyer_.ensureNotDestroyed();
            c = [];
            d = {};
            for (e in b.sourceBuffers_)
              (d.$jscomp$loop$prop$ready$528 = new shaka.util.PublicPromise()),
                (f = {
                  start: (function (n) {
                    return function () {
                      return n.$jscomp$loop$prop$ready$528.resolve();
                    };
                  })(d),
                  p: d.$jscomp$loop$prop$ready$528,
                }),
                b.queues_[e].push(f),
                c.push(d.$jscomp$loop$prop$ready$528),
                1 == b.queues_[e].length && f.start(),
                (d = { $jscomp$loop$prop$ready$528: d.$jscomp$loop$prop$ready$528 });
            m.setCatchFinallyBlocks(2);
            return m.yield(Promise.all(c), 4);
          case 4:
            m.leaveTryBlock(3);
            break;
          case 2:
            g = m.enterCatchBlock();
            goog.asserts.assert(b.destroyer_.destroyed(), 'Should be destroyed by now');
            if (goog.DEBUG)
              for (h in b.sourceBuffers_)
                b.queues_[h].length &&
                  (goog.asserts.assert(1 == b.queues_[h].length, 'Should be at most one item in queue!'),
                  goog.asserts.assert(c.includes(b.queues_[h][0].p), 'The item in queue should be one of our waiters!'),
                  b.queues_[h].shift());
            throw g;
          case 3:
            if (goog.DEBUG)
              for (k in b.sourceBuffers_)
                goog.asserts.assert(
                  0 == b.sourceBuffers_[k].updating,
                  'SourceBuffers should not be updating after a blocking op!',
                );
            try {
              a();
            } catch (n) {
              throw new shaka.util.Error(
                shaka.util.Error.Severity.CRITICAL,
                shaka.util.Error.Category.MEDIA,
                shaka.util.Error.Code.MEDIA_SOURCE_OPERATION_THREW,
                n,
              );
            } finally {
              for (l in b.sourceBuffers_) b.popFromQueue_(l);
            }
            m.jumpToEnd();
        }
      });
    };
    shaka.media.MediaSourceEngine.prototype.popFromQueue_ = function (a) {
      this.queues_[a].shift();
      this.startOperation_(a);
    };
    shaka.media.MediaSourceEngine.prototype.startOperation_ = function (a) {
      var b = this.queues_[a][0];
      if (b)
        try {
          b.start();
        } catch (c) {
          'QuotaExceededError' == c.name
            ? b.p.reject(
                new shaka.util.Error(
                  shaka.util.Error.Severity.CRITICAL,
                  shaka.util.Error.Category.MEDIA,
                  shaka.util.Error.Code.QUOTA_EXCEEDED_ERROR,
                  a,
                ),
              )
            : b.p.reject(
                new shaka.util.Error(
                  shaka.util.Error.Severity.CRITICAL,
                  shaka.util.Error.Category.MEDIA,
                  shaka.util.Error.Code.MEDIA_SOURCE_OPERATION_THREW,
                  c,
                ),
              ),
            this.popFromQueue_(a);
        }
    };
    shaka.media.MediaSourceEngine.prototype.getTextDisplayer = function () {
      goog.asserts.assert(this.textDisplayer_, 'TextDisplayer should only be null when this is destroyed');
      return this.textDisplayer_;
    };
    shaka.media.MediaSourceEngine.prototype.setTextDisplayer = function (a) {
      var b = this.textDisplayer_;
      this.textDisplayer_ = a;
      b && (a.setTextVisibility(b.isTextVisible()), b.destroy());
      this.textEngine_ && this.textEngine_.setDisplayer(a);
    };
    shaka.media.MediaSourceEngine.createObjectURL = window.URL.createObjectURL;
    shaka.util.StreamUtils = function () {};
    shaka.util.StreamUtils.chooseCodecsAndFilterManifest = function (a, b) {
      function c(m) {
        var n = '';
        m.video && (n = d.getCodecBase(m.video.codecs));
        var p = '';
        m.audio && (p = d.getCodecBase(m.audio.codecs));
        return n + '-' + p;
      }
      var d = shaka.util.MimeUtils,
        e = shaka.util.StreamUtils.filterVariantsByAudioChannelCount(a.variants, b),
        f = new shaka.util.MultiMap();
      e = $jscomp.makeIterator(e);
      for (var g = e.next(); !g.done; g = e.next()) {
        g = g.value;
        var h = c(g);
        f.push(h, g);
      }
      var k = null,
        l = Infinity;
      f.forEach(function (m, n) {
        for (var p = 0, q = 0, r = $jscomp.makeIterator(n), t = r.next(); !t.done; t = r.next())
          (p += t.value.bandwidth || 0), ++q;
        p /= q;
        shaka.log.debug('codecs', m, 'avg bandwidth', p);
        p < l && ((k = m), (l = p));
      });
      goog.asserts.assert(null != k, 'Should have chosen codecs!');
      goog.asserts.assert(!isNaN(l), 'Bandwidth should be a number!');
      a.variants = a.variants.filter(function (m) {
        if (c(m) == k) return !0;
        shaka.log.debug('Dropping Variant (better codec available)', m);
        return !1;
      });
    };
    shaka.util.StreamUtils.meetsRestrictions = function (a, b, c) {
      var d = function (f, g, h) {
          return f >= g && f <= h;
        },
        e = a.video;
      return (e &&
        e.width &&
        e.height &&
        (!d(e.width, b.minWidth, Math.min(b.maxWidth, c.width)) ||
          !d(e.height, b.minHeight, Math.min(b.maxHeight, c.height)) ||
          !d(e.width * e.height, b.minPixels, b.maxPixels))) ||
        (a && a.video && a.video.frameRate && !d(a.video.frameRate, b.minFrameRate, b.maxFrameRate)) ||
        !d(a.bandwidth, b.minBandwidth, b.maxBandwidth)
        ? !1
        : !0;
    };
    shaka.util.StreamUtils.applyRestrictions = function (a, b, c) {
      var d = !1;
      a = $jscomp.makeIterator(a);
      for (var e = a.next(); !e.done; e = a.next()) {
        e = e.value;
        var f = e.allowedByApplication;
        e.allowedByApplication = shaka.util.StreamUtils.meetsRestrictions(e, b, c);
        f != e.allowedByApplication && (d = !0);
      }
      return d;
    };
    shaka.util.StreamUtils.filterManifest = function (a, b, c) {
      var d = shaka.util.StreamUtils;
      c.variants = c.variants.filter(function (e) {
        if (a && a.initialized() && !a.supportsVariant(e))
          return shaka.log.debug('Dropping variant - not compatible with key system', e), !1;
        var f = e.audio;
        e = e.video;
        return f && !shaka.media.MediaSourceEngine.isStreamSupported(f)
          ? (shaka.log.debug('Dropping variant - audio not compatible with platform', d.getStreamSummaryString_(f)), !1)
          : e && !shaka.media.MediaSourceEngine.isStreamSupported(e)
          ? (shaka.log.debug('Dropping variant - video not compatible with platform', d.getStreamSummaryString_(e)), !1)
          : f && b && b.audio && !d.areStreamsCompatible_(f, b.audio)
          ? (shaka.log.debug(
              'Droping variant - not compatible with active audio',
              'active audio',
              d.getStreamSummaryString_(b.audio),
              'variant.audio',
              d.getStreamSummaryString_(f),
            ),
            !1)
          : e && b && b.video && !d.areStreamsCompatible_(e, b.video)
          ? (shaka.log.debug(
              'Droping variant - not compatible with active video',
              'active video',
              d.getStreamSummaryString_(b.video),
              'variant.video',
              d.getStreamSummaryString_(e),
            ),
            !1)
          : !0;
      });
      c.textStreams = c.textStreams.filter(function (e) {
        var f = shaka.util.MimeUtils.getFullType(e.mimeType, e.codecs);
        (f = shaka.text.TextEngine.isTypeSupported(f)) ||
          shaka.log.debug('Dropping text stream. Is not supported by the platform.', e);
        return f;
      });
    };
    shaka.util.StreamUtils.areStreamsCompatible_ = function (a, b) {
      return a.mimeType != b.mimeType || a.codecs.split('.')[0] != b.codecs.split('.')[0] ? !1 : !0;
    };
    shaka.util.StreamUtils.variantToTrack = function (a) {
      var b = a.audio,
        c = a.video,
        d = b ? b.codecs : null,
        e = c ? c.codecs : null,
        f = [];
      e && f.push(e);
      d && f.push(d);
      var g = [];
      c && g.push(c.mimeType);
      b && g.push(b.mimeType);
      g = g[0] || null;
      var h = [];
      b && h.push(b.kind);
      c && h.push(c.kind);
      h = h[0] || null;
      var k = new Set();
      if (b) for (var l = $jscomp.makeIterator(b.roles), m = l.next(); !m.done; m = l.next()) k.add(m.value);
      if (c) for (l = $jscomp.makeIterator(c.roles), m = l.next(); !m.done; m = l.next()) k.add(m.value);
      a = {
        id: a.id,
        active: !1,
        type: 'variant',
        bandwidth: a.bandwidth,
        language: a.language,
        label: null,
        kind: h,
        width: null,
        height: null,
        frameRate: null,
        pixelAspectRatio: null,
        mimeType: g,
        codecs: f.join(', '),
        audioCodec: d,
        videoCodec: e,
        primary: a.primary,
        roles: Array.from(k),
        audioRoles: null,
        videoId: null,
        audioId: null,
        channelsCount: null,
        audioSamplingRate: null,
        audioBandwidth: null,
        videoBandwidth: null,
        originalVideoId: null,
        originalAudioId: null,
        originalTextId: null,
      };
      c &&
        ((a.videoId = c.id),
        (a.originalVideoId = c.originalId),
        (a.width = c.width || null),
        (a.height = c.height || null),
        (a.frameRate = c.frameRate || null),
        (a.pixelAspectRatio = c.pixelAspectRatio || null),
        (a.videoBandwidth = c.bandwidth || null));
      b &&
        ((a.audioId = b.id),
        (a.originalAudioId = b.originalId),
        (a.channelsCount = b.channelsCount),
        (a.audioSamplingRate = b.audioSamplingRate),
        (a.audioBandwidth = b.bandwidth || null),
        (a.label = b.label),
        (a.audioRoles = b.roles));
      return a;
    };
    shaka.util.StreamUtils.textStreamToTrack = function (a) {
      return {
        id: a.id,
        active: !1,
        type: shaka.util.ManifestParserUtils.ContentType.TEXT,
        bandwidth: 0,
        language: a.language,
        label: a.label,
        kind: a.kind || null,
        width: null,
        height: null,
        frameRate: null,
        pixelAspectRatio: null,
        mimeType: a.mimeType,
        codecs: a.codecs || null,
        audioCodec: null,
        videoCodec: null,
        primary: a.primary,
        roles: a.roles,
        audioRoles: null,
        videoId: null,
        audioId: null,
        channelsCount: null,
        audioSamplingRate: null,
        audioBandwidth: null,
        videoBandwidth: null,
        originalVideoId: null,
        originalAudioId: null,
        originalTextId: a.originalId,
      };
    };
    shaka.util.StreamUtils.html5TrackId = function (a) {
      a.__shaka_id || (a.__shaka_id = shaka.util.StreamUtils.nextTrackId_++);
      return a.__shaka_id;
    };
    shaka.util.StreamUtils.html5TextTrackToTrack = function (a) {
      var b = shaka.util.MimeUtils.CLOSED_CAPTION_MIMETYPE,
        c = shaka.util.StreamUtils.html5TrackToGenericShakaTrack_(a);
      c.active = 'disabled' != a.mode;
      c.type = 'text';
      c.originalTextId = a.id;
      'captions' == a.kind && (c.mimeType = b);
      a.kind && (c.roles = [a.kind]);
      return c;
    };
    shaka.util.StreamUtils.html5AudioTrackToTrack = function (a) {
      var b = shaka.util.StreamUtils.html5TrackToGenericShakaTrack_(a);
      b.active = a.enabled;
      b.type = 'variant';
      b.originalAudioId = a.id;
      'main' == a.kind && (b.primary = !0);
      a.kind && ((b.roles = [a.kind]), (b.audioRoles = [a.kind]));
      return b;
    };
    shaka.util.StreamUtils.html5TrackToGenericShakaTrack_ = function (a) {
      return {
        id: shaka.util.StreamUtils.html5TrackId(a),
        active: !1,
        type: '',
        bandwidth: 0,
        language: shaka.util.LanguageUtils.normalize(a.language),
        label: a.label,
        kind: a.kind,
        width: null,
        height: null,
        frameRate: null,
        pixelAspectRatio: null,
        mimeType: null,
        codecs: null,
        audioCodec: null,
        videoCodec: null,
        primary: !1,
        roles: [],
        audioRoles: null,
        videoId: null,
        audioId: null,
        channelsCount: null,
        audioSamplingRate: null,
        audioBandwidth: null,
        videoBandwidth: null,
        originalVideoId: null,
        originalAudioId: null,
        originalTextId: null,
      };
    };
    shaka.util.StreamUtils.isPlayable = function (a) {
      return a.allowedByApplication && a.allowedByKeySystem;
    };
    shaka.util.StreamUtils.getPlayableVariants = function (a) {
      return a.filter(function (b) {
        return shaka.util.StreamUtils.isPlayable(b);
      });
    };
    shaka.util.StreamUtils.filterVariantsByAudioChannelCount = function (a, b) {
      var c = a.filter(function (g) {
          return g.audio && g.audio.channelsCount;
        }),
        d = new Map();
      c = $jscomp.makeIterator(c);
      for (var e = c.next(); !e.done; e = c.next()) {
        e = e.value;
        var f = e.audio.channelsCount;
        goog.asserts.assert(null != f, 'Must have count after filtering!');
        d.has(f) || d.set(f, []);
        d.get(f).push(e);
      }
      c = Array.from(d.keys());
      if (0 == c.length) return a;
      e = c.filter(function (g) {
        return g <= b;
      });
      return e.length
        ? d.get(Math.max.apply(Math, $jscomp.arrayFromIterable(e)))
        : d.get(Math.min.apply(Math, $jscomp.arrayFromIterable(c)));
    };
    shaka.util.StreamUtils.filterStreamsByLanguageAndRole = function (a, b, c) {
      var d = shaka.util.LanguageUtils,
        e = a,
        f = a.filter(function (k) {
          return k.primary;
        });
      f.length && (e = f);
      var g = e.length ? e[0].language : '';
      e = e.filter(function (k) {
        return k.language == g;
      });
      if (b) {
        var h = d.findClosestLocale(
          d.normalize(b),
          a.map(function (k) {
            return k.language;
          }),
        );
        h &&
          (e = a.filter(function (k) {
            return d.normalize(k.language) == h;
          }));
      }
      if (c) {
        a = shaka.util.StreamUtils.filterTextStreamsByRole_(e, c);
        if (a.length) return a;
        shaka.log.warning('No exact match for the text role could be found.');
      } else if (
        ((a = e.filter(function (k) {
          return 0 == k.roles.length;
        })),
        a.length)
      )
        return a;
      a = e
        .map(function (k) {
          return k.roles;
        })
        .reduce(shaka.util.Functional.collapseArrays, []);
      return a.length ? shaka.util.StreamUtils.filterTextStreamsByRole_(e, a[0]) : e;
    };
    shaka.util.StreamUtils.filterTextStreamsByRole_ = function (a, b) {
      return a.filter(function (c) {
        return c.roles.includes(b);
      });
    };
    shaka.util.StreamUtils.isAudio = function (a) {
      return a.type == shaka.util.ManifestParserUtils.ContentType.AUDIO;
    };
    shaka.util.StreamUtils.isVideo = function (a) {
      return a.type == shaka.util.ManifestParserUtils.ContentType.VIDEO;
    };
    shaka.util.StreamUtils.getVariantStreams = function (a) {
      var b = [];
      a.audio && b.push(a.audio);
      a.video && b.push(a.video);
      return b;
    };
    shaka.util.StreamUtils.getStreamSummaryString_ = function (a) {
      return shaka.util.StreamUtils.isAudio(a)
        ? 'type=audio codecs=' +
            a.codecs +
            ' bandwidth=' +
            a.bandwidth +
            ' channelsCount=' +
            a.channelsCount +
            ' audioSamplingRate=' +
            a.audioSamplingRate
        : shaka.util.StreamUtils.isVideo(a)
        ? 'type=video codecs=' +
          a.codecs +
          ' bandwidth=' +
          a.bandwidth +
          ' frameRate=' +
          a.frameRate +
          ' width=' +
          a.width +
          ' height=' +
          a.height
        : 'unexpected stream type';
    };
    shaka.util.StreamUtils.nextTrackId_ = 0;
    shaka.abr.SimpleAbrManager = function () {
      this.switch_ = null;
      this.enabled_ = !1;
      this.bandwidthEstimator_ = new shaka.abr.EwmaBandwidthEstimator();
      this.variants_ = [];
      this.playbackRate_ = 1;
      this.startupComplete_ = !1;
      this.config_ = this.lastTimeChosenMs_ = null;
    };
    shaka.abr.SimpleAbrManager.prototype.stop = function () {
      this.switch_ = null;
      this.enabled_ = !1;
      this.variants_ = [];
      this.playbackRate_ = 1;
      this.lastTimeChosenMs_ = null;
    };
    shaka.abr.SimpleAbrManager.prototype.init = function (a) {
      this.switch_ = a;
    };
    shaka.abr.SimpleAbrManager.prototype.chooseVariant = function () {
      var a = shaka.abr.SimpleAbrManager,
        b = a.filterAndSortVariants_(this.config_.restrictions, this.variants_),
        c = this.bandwidthEstimator_.getBandwidthEstimate(this.config_.defaultBandwidthEstimate);
      this.variants_.length &&
        !b.length &&
        (shaka.log.warning('No variants met the ABR restrictions. Choosing a variant by lowest bandwidth.'),
        (b = a.filterAndSortVariants_(null, this.variants_)),
        (b = [b[0]]));
      a = b[0] || null;
      b = $jscomp.makeIterator(shaka.util.Iterables.enumerate(b));
      for (var d = b.next(); !d.done; d = b.next()) {
        var e = d.value;
        d = e.item;
        var f = e.next,
          g = isNaN(this.playbackRate_) ? 1 : Math.abs(this.playbackRate_);
        e = g * d.bandwidth;
        var h = e / this.config_.bandwidthDowngradeTarget;
        f = (g * (f || { bandwidth: Infinity }).bandwidth) / this.config_.bandwidthUpgradeTarget;
        shaka.log.v2('Bandwidth ranges:', (e / 1e6).toFixed(3), (h / 1e6).toFixed(3), (f / 1e6).toFixed(3));
        c >= h && c <= f && (a = d);
      }
      this.lastTimeChosenMs_ = Date.now();
      return a;
    };
    shaka.abr.SimpleAbrManager.prototype.enable = function () {
      this.enabled_ = !0;
    };
    shaka.abr.SimpleAbrManager.prototype.disable = function () {
      this.enabled_ = !1;
    };
    shaka.abr.SimpleAbrManager.prototype.segmentDownloaded = function (a, b) {
      shaka.log.v2(
        'Segment downloaded:',
        'deltaTimeMs=' + a,
        'numBytes=' + b,
        'lastTimeChosenMs=' + this.lastTimeChosenMs_,
        'enabled=' + this.enabled_,
      );
      goog.asserts.assert(0 <= a, 'expected a non-negative duration');
      this.bandwidthEstimator_.sample(a, b);
      null != this.lastTimeChosenMs_ && this.enabled_ && this.suggestStreams_();
    };
    shaka.abr.SimpleAbrManager.prototype.getBandwidthEstimate = function () {
      return this.bandwidthEstimator_.getBandwidthEstimate(this.config_.defaultBandwidthEstimate);
    };
    shaka.abr.SimpleAbrManager.prototype.setVariants = function (a) {
      this.variants_ = a;
    };
    shaka.abr.SimpleAbrManager.prototype.playbackRateChanged = function (a) {
      this.playbackRate_ = a;
    };
    shaka.abr.SimpleAbrManager.prototype.configure = function (a) {
      this.config_ = a;
    };
    shaka.abr.SimpleAbrManager.prototype.suggestStreams_ = function () {
      shaka.log.v2('Suggesting Streams...');
      goog.asserts.assert(null != this.lastTimeChosenMs_, 'lastTimeChosenMs_ should not be null');
      if (!this.startupComplete_) {
        if (!this.bandwidthEstimator_.hasGoodEstimate()) {
          shaka.log.v2('Still waiting for a good estimate...');
          return;
        }
        this.startupComplete_ = !0;
      } else if (Date.now() - this.lastTimeChosenMs_ < 1e3 * this.config_.switchInterval) {
        shaka.log.v2('Still within switch interval...');
        return;
      }
      var a = this.chooseVariant(),
        b = this.bandwidthEstimator_.getBandwidthEstimate(this.config_.defaultBandwidthEstimate);
      b = Math.round(b / 1e3);
      a && (shaka.log.debug('Calling switch_(), bandwidth=' + b + ' kbps'), this.switch_(a));
    };
    shaka.abr.SimpleAbrManager.filterAndSortVariants_ = function (a, b) {
      a &&
        (b = b.filter(function (c) {
          goog.asserts.assert(a, 'Restrictions should exist!');
          return shaka.util.StreamUtils.meetsRestrictions(c, a, { width: Infinity, height: Infinity });
        }));
      return b.sort(function (c, d) {
        return c.bandwidth - d.bandwidth;
      });
    };
    goog.exportSymbol('shaka.abr.SimpleAbrManager', shaka.abr.SimpleAbrManager);
    goog.exportProperty(
      shaka.abr.SimpleAbrManager.prototype,
      'configure',
      shaka.abr.SimpleAbrManager.prototype.configure,
    );
    goog.exportProperty(
      shaka.abr.SimpleAbrManager.prototype,
      'playbackRateChanged',
      shaka.abr.SimpleAbrManager.prototype.playbackRateChanged,
    );
    goog.exportProperty(
      shaka.abr.SimpleAbrManager.prototype,
      'setVariants',
      shaka.abr.SimpleAbrManager.prototype.setVariants,
    );
    goog.exportProperty(
      shaka.abr.SimpleAbrManager.prototype,
      'getBandwidthEstimate',
      shaka.abr.SimpleAbrManager.prototype.getBandwidthEstimate,
    );
    goog.exportProperty(
      shaka.abr.SimpleAbrManager.prototype,
      'segmentDownloaded',
      shaka.abr.SimpleAbrManager.prototype.segmentDownloaded,
    );
    goog.exportProperty(shaka.abr.SimpleAbrManager.prototype, 'disable', shaka.abr.SimpleAbrManager.prototype.disable);
    goog.exportProperty(shaka.abr.SimpleAbrManager.prototype, 'enable', shaka.abr.SimpleAbrManager.prototype.enable);
    goog.exportProperty(
      shaka.abr.SimpleAbrManager.prototype,
      'chooseVariant',
      shaka.abr.SimpleAbrManager.prototype.chooseVariant,
    );
    goog.exportProperty(shaka.abr.SimpleAbrManager.prototype, 'init', shaka.abr.SimpleAbrManager.prototype.init);
    goog.exportProperty(shaka.abr.SimpleAbrManager.prototype, 'stop', shaka.abr.SimpleAbrManager.prototype.stop);
    shaka.media.AdaptationSet = function (a, b) {
      this.root_ = a;
      this.variants_ = new Set([a]);
      b = b || [];
      for (var c = $jscomp.makeIterator(b), d = c.next(); !d.done; d = c.next()) this.add(d.value);
    };
    shaka.media.AdaptationSet.prototype.add = function (a) {
      if (this.canInclude(a)) return this.variants_.add(a), !0;
      shaka.log.warning('Rejecting variant - not compatible with root.');
      return !1;
    };
    shaka.media.AdaptationSet.prototype.canInclude = function (a) {
      return shaka.media.AdaptationSet.areAdaptable(this.root_, a);
    };
    shaka.media.AdaptationSet.areAdaptable = function (a, b) {
      var c = shaka.media.AdaptationSet;
      if (!!a.audio != !!b.audio || !!a.video != !!b.video || a.language != b.language) return !1;
      goog.asserts.assert(!!a.audio == !!b.audio, 'Both should either have audio or not have audio.');
      if (a.audio && b.audio && !c.areAudiosCompatible_(a.audio, b.audio)) return !1;
      goog.asserts.assert(!!a.video == !!b.video, 'Both should either have video or not have video.');
      return a.video && b.video && !c.areVideosCompatible_(a.video, b.video) ? !1 : !0;
    };
    shaka.media.AdaptationSet.prototype.values = function () {
      return this.variants_.values();
    };
    shaka.media.AdaptationSet.areAudiosCompatible_ = function (a, b) {
      var c = shaka.media.AdaptationSet;
      return a.channelsCount == b.channelsCount && c.canTransitionBetween_(a, b) && c.areRolesEqual_(a.roles, b.roles)
        ? !0
        : !1;
    };
    shaka.media.AdaptationSet.areVideosCompatible_ = function (a, b) {
      var c = shaka.media.AdaptationSet;
      return c.canTransitionBetween_(a, b) && c.areRolesEqual_(a.roles, b.roles) ? !0 : !1;
    };
    shaka.media.AdaptationSet.canTransitionBetween_ = function (a, b) {
      if (a.mimeType != b.mimeType) return !1;
      var c = shaka.util.MimeUtils.splitCodecs(a.codecs).map(function (g) {
          return shaka.util.MimeUtils.getCodecBase(g);
        }),
        d = shaka.util.MimeUtils.splitCodecs(b.codecs).map(function (g) {
          return shaka.util.MimeUtils.getCodecBase(g);
        });
      if (c.length != d.length) return !1;
      c.sort();
      d.sort();
      for (var e = $jscomp.makeIterator(shaka.util.Iterables.range(c.length)), f = e.next(); !f.done; f = e.next())
        if (((f = f.value), c[f] != d[f])) return !1;
      return !0;
    };
    shaka.media.AdaptationSet.areRolesEqual_ = function (a, b) {
      var c = new Set(a),
        d = new Set(b);
      c['delete']('main');
      d['delete']('main');
      if (c.size != d.size) return !1;
      c = $jscomp.makeIterator(c);
      for (var e = c.next(); !e.done; e = c.next()) if (!d.has(e.value)) return !1;
      return !0;
    };
    shaka.media.AdaptationSetCriteria = function () {};
    shaka.media.AdaptationSetCriteria.prototype.create = function (a) {};
    shaka.media.ExampleBasedCriteria = function (a) {
      this.example_ = a;
      this.fallback_ = new shaka.media.PreferenceBasedCriteria(
        a.language,
        '',
        a.audio && a.audio.channelsCount ? a.audio.channelsCount : 0,
        '',
      );
    };
    shaka.media.ExampleBasedCriteria.prototype.create = function (a) {
      var b = this,
        c = a.filter(function (d) {
          return shaka.media.AdaptationSet.areAdaptable(b.example_, d);
        });
      return c.length ? new shaka.media.AdaptationSet(c[0], c) : this.fallback_.create(a);
    };
    shaka.media.PreferenceBasedCriteria = function (a, b, c, d) {
      this.language_ = a;
      this.role_ = b;
      this.channelCount_ = c;
      this.label_ = void 0 === d ? '' : d;
    };
    shaka.media.PreferenceBasedCriteria.prototype.create = function (a) {
      var b = shaka.media.PreferenceBasedCriteria,
        c = shaka.util.StreamUtils,
        d = [];
      d = b.filterByLanguage_(a, this.language_);
      var e = a.filter(function (f) {
        return f.primary;
      });
      d = d.length ? d : e.length ? e : a;
      a = b.filterVariantsByRole_(d, this.role_);
      a.length ? (d = a) : shaka.log.warning('No exact match for variant role could be found.');
      this.channelCount_ &&
        ((c = c.filterVariantsByAudioChannelCount(d, this.channelCount_)),
        c.length ? (d = c) : shaka.log.warning('No exact match for the channel count could be found.'));
      this.label_ &&
        ((b = b.filterVariantsByLabel_(d, this.label_)),
        b.length ? (d = b) : shaka.log.warning('No exact match for variant label could be found.'));
      b = new shaka.media.AdaptationSet(d[0]);
      d = $jscomp.makeIterator(d);
      for (c = d.next(); !c.done; c = d.next()) (c = c.value), b.canInclude(c) && b.add(c);
      return b;
    };
    shaka.media.PreferenceBasedCriteria.filterByLanguage_ = function (a, b) {
      var c = shaka.util.LanguageUtils,
        d = c.normalize(b),
        e = c.findClosestLocale(
          d,
          a.map(function (f) {
            return c.getLocaleForVariant(f);
          }),
        );
      return e
        ? a.filter(function (f) {
            return e == c.getLocaleForVariant(f);
          })
        : [];
    };
    shaka.media.PreferenceBasedCriteria.filterVariantsByRole_ = function (a, b) {
      return a.filter(function (c) {
        return c.audio ? (b ? c.audio.roles.includes(b) : 0 == c.audio.roles.length) : !1;
      });
    };
    shaka.media.PreferenceBasedCriteria.filterVariantsByLabel_ = function (a, b) {
      return a.filter(function (c) {
        if (!c.audio) return !1;
        c = c.audio.label.toLowerCase();
        var d = b.toLowerCase();
        return c == d;
      });
    };
    shaka.media.BufferingObserver = function (a, b) {
      var c = shaka.media.BufferingObserver.State;
      this.previousState_ = c.SATISFIED;
      this.thresholds_ = new Map().set(c.SATISFIED, b).set(c.STARVING, a);
    };
    shaka.media.BufferingObserver.prototype.setThresholds = function (a, b) {
      var c = shaka.media.BufferingObserver.State;
      this.thresholds_.set(c.SATISFIED, b).set(c.STARVING, a);
    };
    shaka.media.BufferingObserver.prototype.update = function (a, b) {
      var c = shaka.media.BufferingObserver.State,
        d = this.thresholds_.get(this.previousState_),
        e = this.previousState_;
      this.previousState_ = c = b || a >= d ? c.SATISFIED : c.STARVING;
      return e != c;
    };
    shaka.media.BufferingObserver.prototype.setState = function (a) {
      this.previousState_ = a;
    };
    shaka.media.BufferingObserver.prototype.getState = function () {
      return this.previousState_;
    };
    shaka.media.BufferingObserver.State = { STARVING: 0, SATISFIED: 1 };
    shaka.media.ManifestParser = function () {};
    shaka.media.ManifestParser.registerParserByExtension = function (a, b) {
      shaka.media.ManifestParser.parsersByExtension[a] = b;
    };
    shaka.media.ManifestParser.registerParserByMime = function (a, b) {
      shaka.media.ManifestParser.parsersByMime[a] = b;
    };
    shaka.media.ManifestParser.unregisterParserByMime = function (a) {
      delete shaka.media.ManifestParser.parsersByMime[a];
    };
    shaka.media.ManifestParser.probeSupport = function () {
      var a = shaka.media.ManifestParser,
        b = {};
      if (shaka.util.Platform.supportsMediaSource()) {
        for (var c in a.parsersByMime) b[c] = !0;
        for (var d in a.parsersByExtension) b[d] = !0;
      }
      c = { mpd: 'application/dash+xml', m3u8: 'application/x-mpegurl', ism: 'application/vnd.ms-sstr+xml' };
      d = $jscomp.makeIterator([
        'application/dash+xml',
        'application/x-mpegurl',
        'application/vnd.apple.mpegurl',
        'application/vnd.ms-sstr+xml',
      ]);
      for (var e = d.next(); !e.done; e = d.next())
        (e = e.value),
          shaka.util.Platform.supportsMediaSource()
            ? (b[e] = !!a.parsersByMime[e])
            : (b[e] = shaka.util.Platform.supportsMediaType(e));
      for (var f in c)
        shaka.util.Platform.supportsMediaSource()
          ? (b[f] = !!a.parsersByExtension[f])
          : (b[f] = shaka.util.Platform.supportsMediaType(c[f]));
      return b;
    };
    shaka.media.ManifestParser.getFactory = function (a, b, c, d) {
      var e, f, g, h, k;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (l) {
        if (1 == l.nextAddress) {
          e = shaka.media.ManifestParser;
          if (d) {
            if ((f = e.parsersByMime[d.toLowerCase()])) return l['return'](f);
            shaka.log.warning('Could not determine manifest type using MIME type ', d);
          }
          if ((g = e.getExtension(a))) {
            if ((h = e.parsersByExtension[g])) return l['return'](h);
            shaka.log.warning('Could not determine manifest type for extension ', g);
          } else shaka.log.warning('Could not find extension for ', a);
          return d ? l.jumpTo(2) : l.yield(e.getMimeType(a, b, c), 3);
        }
        if (2 != l.nextAddress && (d = l.yieldResult)) {
          if ((k = shaka.media.ManifestParser.parsersByMime[d])) return l['return'](k);
          shaka.log.warning('Could not determine manifest type using MIME type', d);
        }
        throw new shaka.util.Error(
          shaka.util.Error.Severity.CRITICAL,
          shaka.util.Error.Category.MANIFEST,
          shaka.util.Error.Code.UNABLE_TO_GUESS_MANIFEST_TYPE,
          a,
        );
      });
    };
    shaka.media.ManifestParser.getMimeType = function (a, b, c) {
      var d, e, f, g;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (h) {
        if (1 == h.nextAddress)
          return (
            (d = shaka.net.NetworkingEngine.RequestType.MANIFEST),
            (e = shaka.net.NetworkingEngine.makeRequest([a], c)),
            (e.method = 'HEAD'),
            h.yield(b.request(d, e).promise, 2)
          );
        f = h.yieldResult;
        g = f.headers['content-type'];
        return h['return'](g ? g.toLowerCase().split(';').shift() : '');
      });
    };
    shaka.media.ManifestParser.getExtension = function (a) {
      a = new goog.Uri(a).getPath().split('/').pop().split('.');
      return 1 == a.length ? '' : a.pop().toLowerCase();
    };
    shaka.media.ManifestParser.isSupported = function (a, b) {
      return shaka.util.Platform.supportsMediaSource()
        ? b in shaka.media.ManifestParser.parsersByMime ||
          shaka.media.ManifestParser.getExtension(a) in shaka.media.ManifestParser.parsersByExtension
          ? !0
          : !1
        : !1;
    };
    goog.exportSymbol('shaka.media.ManifestParser', shaka.media.ManifestParser);
    goog.exportProperty(
      shaka.media.ManifestParser,
      'unregisterParserByMime',
      shaka.media.ManifestParser.unregisterParserByMime,
    );
    goog.exportProperty(
      shaka.media.ManifestParser,
      'registerParserByMime',
      shaka.media.ManifestParser.registerParserByMime,
    );
    goog.exportProperty(
      shaka.media.ManifestParser,
      'registerParserByExtension',
      shaka.media.ManifestParser.registerParserByExtension,
    );
    shaka.media.ManifestParser.parsersByMime = {};
    shaka.media.ManifestParser.parsersByExtension = {};
    shaka.media.InitSegmentReference = function (a, b, c) {
      this.getUris = a;
      this.startByte = b;
      this.endByte = c;
    };
    shaka.media.InitSegmentReference.prototype.getStartByte = function () {
      return this.startByte;
    };
    shaka.media.InitSegmentReference.prototype.getEndByte = function () {
      return this.endByte;
    };
    shaka.media.InitSegmentReference.prototype.getSize = function () {
      return this.endByte ? this.endByte - this.startByte : null;
    };
    shaka.media.InitSegmentReference.equal = function (a, b) {
      var c = shaka.util.ArrayUtils;
      return a && b
        ? a.getStartByte() == b.getStartByte() && a.getEndByte() == b.getEndByte() && c.equal(a.getUris(), b.getUris())
        : a == b;
    };
    goog.exportSymbol('shaka.media.InitSegmentReference', shaka.media.InitSegmentReference);
    goog.exportProperty(
      shaka.media.InitSegmentReference.prototype,
      'getEndByte',
      shaka.media.InitSegmentReference.prototype.getEndByte,
    );
    goog.exportProperty(
      shaka.media.InitSegmentReference.prototype,
      'getStartByte',
      shaka.media.InitSegmentReference.prototype.getStartByte,
    );
    shaka.media.SegmentReference = function (a, b, c, d, e, f, g, h, k) {
      goog.asserts.assert(a < b, 'startTime must be less than endTime');
      goog.asserts.assert(null == e || d < e, 'startByte must be < endByte');
      this.startTime = a;
      this.endTime = b;
      this.getUris = c;
      this.startByte = d;
      this.endByte = e;
      this.initSegmentReference = f;
      this.timestampOffset = g;
      this.appendWindowStart = h;
      this.appendWindowEnd = k;
    };
    shaka.media.SegmentReference.prototype.getStartTime = function () {
      return this.startTime;
    };
    shaka.media.SegmentReference.prototype.getEndTime = function () {
      return this.endTime;
    };
    shaka.media.SegmentReference.prototype.getStartByte = function () {
      return this.startByte;
    };
    shaka.media.SegmentReference.prototype.getEndByte = function () {
      return this.endByte;
    };
    shaka.media.SegmentReference.prototype.getSize = function () {
      return this.endByte ? this.endByte - this.startByte : null;
    };
    goog.exportSymbol('shaka.media.SegmentReference', shaka.media.SegmentReference);
    goog.exportProperty(
      shaka.media.SegmentReference.prototype,
      'getEndByte',
      shaka.media.SegmentReference.prototype.getEndByte,
    );
    goog.exportProperty(
      shaka.media.SegmentReference.prototype,
      'getStartByte',
      shaka.media.SegmentReference.prototype.getStartByte,
    );
    goog.exportProperty(
      shaka.media.SegmentReference.prototype,
      'getEndTime',
      shaka.media.SegmentReference.prototype.getEndTime,
    );
    goog.exportProperty(
      shaka.media.SegmentReference.prototype,
      'getStartTime',
      shaka.media.SegmentReference.prototype.getStartTime,
    );
    shaka.media.PresentationTimeline = function (a, b, c) {
      this.presentationStartTime_ = a;
      this.presentationDelay_ = b;
      this.segmentAvailabilityDuration_ = this.duration_ = Infinity;
      this.maxSegmentDuration_ = 1;
      this.maxSegmentEndTime_ = this.minSegmentStartTime_ = null;
      this.clockOffset_ = 0;
      this.static_ = !0;
      this.userSeekStart_ = 0;
      this.autoCorrectDrift_ = void 0 === c ? !0 : c;
    };
    shaka.media.PresentationTimeline.prototype.getDuration = function () {
      return this.duration_;
    };
    shaka.media.PresentationTimeline.prototype.getMaxSegmentDuration = function () {
      return this.maxSegmentDuration_;
    };
    shaka.media.PresentationTimeline.prototype.setDuration = function (a) {
      goog.asserts.assert(0 < a, 'duration must be > 0');
      this.duration_ = a;
    };
    shaka.media.PresentationTimeline.prototype.getPresentationStartTime = function () {
      return this.presentationStartTime_;
    };
    shaka.media.PresentationTimeline.prototype.setClockOffset = function (a) {
      this.clockOffset_ = a;
    };
    shaka.media.PresentationTimeline.prototype.setStatic = function (a) {
      this.static_ = a;
    };
    shaka.media.PresentationTimeline.prototype.setSegmentAvailabilityDuration = function (a) {
      goog.asserts.assert(0 <= a, 'segmentAvailabilityDuration must be >= 0');
      this.segmentAvailabilityDuration_ = a;
    };
    shaka.media.PresentationTimeline.prototype.setDelay = function (a) {
      goog.asserts.assert(0 <= a, 'delay must be >= 0');
      this.presentationDelay_ = a;
    };
    shaka.media.PresentationTimeline.prototype.getDelay = function () {
      return this.presentationDelay_;
    };
    shaka.media.PresentationTimeline.prototype.notifySegments = function (a) {
      if (0 != a.length) {
        var b = a[a.length - 1].endTime;
        this.notifyMinSegmentStartTime(a[0].startTime);
        this.maxSegmentDuration_ = a.reduce(function (c, d) {
          return Math.max(c, d.endTime - d.startTime);
        }, this.maxSegmentDuration_);
        this.maxSegmentEndTime_ = Math.max(this.maxSegmentEndTime_, b);
        null != this.presentationStartTime_ &&
          this.autoCorrectDrift_ &&
          (this.presentationStartTime_ =
            (Date.now() + this.clockOffset_) / 1e3 - this.maxSegmentEndTime_ - this.maxSegmentDuration_);
        shaka.log.v1('notifySegments:', 'maxSegmentDuration=' + this.maxSegmentDuration_);
      }
    };
    shaka.media.PresentationTimeline.prototype.notifyMinSegmentStartTime = function (a) {
      this.minSegmentStartTime_ = null == this.minSegmentStartTime_ ? a : Math.min(this.minSegmentStartTime_, a);
    };
    shaka.media.PresentationTimeline.prototype.notifyMaxSegmentDuration = function (a) {
      this.maxSegmentDuration_ = Math.max(this.maxSegmentDuration_, a);
      shaka.log.v1('notifyNewSegmentDuration:', 'maxSegmentDuration=' + this.maxSegmentDuration_);
    };
    shaka.media.PresentationTimeline.prototype.offset = function (a) {
      null != this.minSegmentStartTime_ && (this.minSegmentStartTime_ += a);
      null != this.maxSegmentEndTime_ && (this.maxSegmentEndTime_ += a);
    };
    shaka.media.PresentationTimeline.prototype.isLive = function () {
      return Infinity == this.duration_ && !this.static_;
    };
    shaka.media.PresentationTimeline.prototype.isInProgress = function () {
      return Infinity != this.duration_ && !this.static_;
    };
    shaka.media.PresentationTimeline.prototype.getSegmentAvailabilityStart = function () {
      goog.asserts.assert(0 <= this.segmentAvailabilityDuration_, 'The availability duration should be positive');
      var a = this.getSegmentAvailabilityEnd() - this.segmentAvailabilityDuration_;
      return Math.max(this.userSeekStart_, a);
    };
    shaka.media.PresentationTimeline.prototype.setUserSeekStart = function (a) {
      this.userSeekStart_ = a;
    };
    shaka.media.PresentationTimeline.prototype.getSegmentAvailabilityEnd = function () {
      return this.isLive() || this.isInProgress() ? Math.min(this.getLiveEdge_(), this.duration_) : this.duration_;
    };
    shaka.media.PresentationTimeline.prototype.getSafeSeekRangeStart = function (a) {
      var b = Math.max(this.minSegmentStartTime_, this.userSeekStart_);
      if (Infinity == this.segmentAvailabilityDuration_) return b;
      var c = this.getSegmentAvailabilityEnd() - this.segmentAvailabilityDuration_;
      a = Math.min(c + a, this.getSeekRangeEnd());
      return Math.max(b, a);
    };
    shaka.media.PresentationTimeline.prototype.getSeekRangeStart = function () {
      return this.getSafeSeekRangeStart(0);
    };
    shaka.media.PresentationTimeline.prototype.getSeekRangeEnd = function () {
      var a = this.isLive() || this.isInProgress() ? this.presentationDelay_ : 0;
      return Math.max(0, this.getSegmentAvailabilityEnd() - a);
    };
    shaka.media.PresentationTimeline.prototype.usingPresentationStartTime = function () {
      return null == this.presentationStartTime_ || (null != this.maxSegmentEndTime_ && this.autoCorrectDrift_)
        ? !1
        : !0;
    };
    shaka.media.PresentationTimeline.prototype.getLiveEdge_ = function () {
      goog.asserts.assert(null != this.presentationStartTime_, 'Cannot compute timeline live edge without start time');
      var a = (Date.now() + this.clockOffset_) / 1e3;
      return Math.max(0, a - this.maxSegmentDuration_ - this.presentationStartTime_);
    };
    shaka.media.PresentationTimeline.prototype.assertIsValid = function () {
      goog.DEBUG &&
        (this.isLive()
          ? goog.asserts.assert(
              null != this.presentationStartTime_,
              'Detected as live stream, but does not match our model of live!',
            )
          : this.isInProgress()
          ? goog.asserts.assert(
              null != this.presentationStartTime_ && Infinity == this.segmentAvailabilityDuration_,
              'Detected as IPR stream, but does not match our model of IPR!',
            )
          : goog.asserts.assert(
              Infinity == this.segmentAvailabilityDuration_ && Infinity != this.duration_ && this.static_,
              'Detected as VOD stream, but does not match our model of VOD!',
            ));
    };
    goog.exportSymbol('shaka.media.PresentationTimeline', shaka.media.PresentationTimeline);
    goog.exportProperty(
      shaka.media.PresentationTimeline.prototype,
      'usingPresentationStartTime',
      shaka.media.PresentationTimeline.prototype.usingPresentationStartTime,
    );
    goog.exportProperty(
      shaka.media.PresentationTimeline.prototype,
      'getSeekRangeEnd',
      shaka.media.PresentationTimeline.prototype.getSeekRangeEnd,
    );
    goog.exportProperty(
      shaka.media.PresentationTimeline.prototype,
      'getSeekRangeStart',
      shaka.media.PresentationTimeline.prototype.getSeekRangeStart,
    );
    goog.exportProperty(
      shaka.media.PresentationTimeline.prototype,
      'getSafeSeekRangeStart',
      shaka.media.PresentationTimeline.prototype.getSafeSeekRangeStart,
    );
    goog.exportProperty(
      shaka.media.PresentationTimeline.prototype,
      'getSegmentAvailabilityEnd',
      shaka.media.PresentationTimeline.prototype.getSegmentAvailabilityEnd,
    );
    goog.exportProperty(
      shaka.media.PresentationTimeline.prototype,
      'setUserSeekStart',
      shaka.media.PresentationTimeline.prototype.setUserSeekStart,
    );
    goog.exportProperty(
      shaka.media.PresentationTimeline.prototype,
      'getSegmentAvailabilityStart',
      shaka.media.PresentationTimeline.prototype.getSegmentAvailabilityStart,
    );
    goog.exportProperty(
      shaka.media.PresentationTimeline.prototype,
      'isInProgress',
      shaka.media.PresentationTimeline.prototype.isInProgress,
    );
    goog.exportProperty(
      shaka.media.PresentationTimeline.prototype,
      'isLive',
      shaka.media.PresentationTimeline.prototype.isLive,
    );
    goog.exportProperty(
      shaka.media.PresentationTimeline.prototype,
      'offset',
      shaka.media.PresentationTimeline.prototype.offset,
    );
    goog.exportProperty(
      shaka.media.PresentationTimeline.prototype,
      'notifyMaxSegmentDuration',
      shaka.media.PresentationTimeline.prototype.notifyMaxSegmentDuration,
    );
    goog.exportProperty(
      shaka.media.PresentationTimeline.prototype,
      'notifyMinSegmentStartTime',
      shaka.media.PresentationTimeline.prototype.notifyMinSegmentStartTime,
    );
    goog.exportProperty(
      shaka.media.PresentationTimeline.prototype,
      'notifySegments',
      shaka.media.PresentationTimeline.prototype.notifySegments,
    );
    goog.exportProperty(
      shaka.media.PresentationTimeline.prototype,
      'getDelay',
      shaka.media.PresentationTimeline.prototype.getDelay,
    );
    goog.exportProperty(
      shaka.media.PresentationTimeline.prototype,
      'setDelay',
      shaka.media.PresentationTimeline.prototype.setDelay,
    );
    goog.exportProperty(
      shaka.media.PresentationTimeline.prototype,
      'setSegmentAvailabilityDuration',
      shaka.media.PresentationTimeline.prototype.setSegmentAvailabilityDuration,
    );
    goog.exportProperty(
      shaka.media.PresentationTimeline.prototype,
      'setStatic',
      shaka.media.PresentationTimeline.prototype.setStatic,
    );
    goog.exportProperty(
      shaka.media.PresentationTimeline.prototype,
      'setClockOffset',
      shaka.media.PresentationTimeline.prototype.setClockOffset,
    );
    goog.exportProperty(
      shaka.media.PresentationTimeline.prototype,
      'getPresentationStartTime',
      shaka.media.PresentationTimeline.prototype.getPresentationStartTime,
    );
    goog.exportProperty(
      shaka.media.PresentationTimeline.prototype,
      'setDuration',
      shaka.media.PresentationTimeline.prototype.setDuration,
    );
    goog.exportProperty(
      shaka.media.PresentationTimeline.prototype,
      'getMaxSegmentDuration',
      shaka.media.PresentationTimeline.prototype.getMaxSegmentDuration,
    );
    goog.exportProperty(
      shaka.media.PresentationTimeline.prototype,
      'getDuration',
      shaka.media.PresentationTimeline.prototype.getDuration,
    );
    shaka.media.StallDetector = function (a, b) {
      this.implementation_ = a;
      this.wasMakingProgress_ = a.shouldBeMakingProgress();
      this.value_ = a.getPresentationSeconds();
      this.lastUpdateSeconds_ = a.getWallSeconds();
      this.didJump_ = !1;
      this.stallThresholdSeconds_ = b;
      this.onStall_ = function () {};
    };
    shaka.media.StallDetector.prototype.release = function () {
      this.implementation_ = null;
      this.onStall_ = function () {};
    };
    shaka.media.StallDetector.prototype.onStall = function (a) {
      this.onStall_ = a;
    };
    shaka.media.StallDetector.prototype.poll = function () {
      var a = this.implementation_,
        b = a.shouldBeMakingProgress(),
        c = a.getPresentationSeconds(),
        d = a.getWallSeconds();
      if (this.value_ != c || this.wasMakingProgress_ != b)
        (this.lastUpdateSeconds_ = d), (this.value_ = c), (this.wasMakingProgress_ = b), (this.didJump_ = !1);
      c = d - this.lastUpdateSeconds_;
      if ((b = c >= this.stallThresholdSeconds_ && b && !this.didJump_))
        this.onStall_(this.value_, c), (this.didJump_ = !0), (this.value_ = a.getPresentationSeconds());
      return b;
    };
    shaka.media.StallDetector.Implementation = function () {};
    shaka.media.StallDetector.Implementation.prototype.shouldBeMakingProgress = function () {};
    shaka.media.StallDetector.Implementation.prototype.getPresentationSeconds = function () {};
    shaka.media.StallDetector.Implementation.prototype.getWallSeconds = function () {};
    shaka.media.StallDetector.MediaElementImplementation = function (a) {
      this.mediaElement_ = a;
    };
    shaka.media.StallDetector.MediaElementImplementation.prototype.shouldBeMakingProgress = function () {
      return this.mediaElement_.paused ||
        0 == this.mediaElement_.playbackRate ||
        0 == this.mediaElement_.buffered.length
        ? !1
        : shaka.media.StallDetector.MediaElementImplementation.hasContentFor_(
            this.mediaElement_.buffered,
            this.mediaElement_.currentTime,
          );
    };
    shaka.media.StallDetector.MediaElementImplementation.prototype.getPresentationSeconds = function () {
      return this.mediaElement_.currentTime;
    };
    shaka.media.StallDetector.MediaElementImplementation.prototype.getWallSeconds = function () {
      return Date.now() / 1e3;
    };
    shaka.media.StallDetector.MediaElementImplementation.hasContentFor_ = function (a, b) {
      for (
        var c = $jscomp.makeIterator(shaka.media.TimeRangesUtils.getBufferedInfo(a)), d = c.next();
        !d.done;
        d = c.next()
      )
        if (((d = d.value), !(b < d.start - 0.1 || b > d.end - 0.5))) return !0;
      return !1;
    };
    shaka.media.GapJumpingController = function (a, b, c, d, e) {
      var f = this;
      this.video_ = a;
      this.timeline_ = b;
      this.config_ = c;
      this.onEvent_ = e;
      this.eventManager_ = new shaka.util.EventManager();
      this.seekingEventReceived_ = !1;
      this.prevReadyState_ = a.readyState;
      this.didFireLargeGap_ = !1;
      this.stallDetector_ = d;
      this.hadSegmentAppended_ = !1;
      this.eventManager_.listen(a, 'waiting', function () {
        return f.onPollGapJump_();
      });
      this.gapJumpTimer_ = new shaka.util.Timer(function () {
        f.onPollGapJump_();
      }).tickEvery(0.25);
    };
    shaka.media.GapJumpingController.prototype.release = function () {
      this.eventManager_ && (this.eventManager_.release(), (this.eventManager_ = null));
      null != this.gapJumpTimer_ && (this.gapJumpTimer_.stop(), (this.gapJumpTimer_ = null));
      this.stallDetector_ && (this.stallDetector_.release(), (this.stallDetector_ = null));
      this.video_ = this.timeline_ = this.onEvent_ = null;
    };
    shaka.media.GapJumpingController.prototype.onSegmentAppended = function () {
      this.hadSegmentAppended_ = !0;
      this.onPollGapJump_();
    };
    shaka.media.GapJumpingController.prototype.onSeeking = function () {
      this.seekingEventReceived_ = !0;
      this.didFireLargeGap_ = this.hadSegmentAppended_ = !1;
    };
    shaka.media.GapJumpingController.prototype.onPollGapJump_ = function () {
      if (0 != this.video_.readyState) {
        if (this.video_.seeking) {
          if (!this.seekingEventReceived_) return;
        } else this.seekingEventReceived_ = !1;
        if (
          !this.video_.paused &&
          (this.video_.readyState != this.prevReadyState_ &&
            ((this.didFireLargeGap_ = !1), (this.prevReadyState_ = this.video_.readyState)),
          !this.stallDetector_ || !this.stallDetector_.poll())
        ) {
          var a = this.config_.smallGapLimit,
            b = this.video_.currentTime,
            c = this.video_.buffered,
            d = shaka.media.TimeRangesUtils.getGapIndex(c, b);
          if (null != d && (0 != d || this.hadSegmentAppended_)) {
            var e = c.start(d),
              f = this.timeline_.getSeekRangeEnd();
            if (!(e >= f)) {
              f = e - b;
              a = f <= a;
              var g = !1;
              if (!(f < shaka.media.GapJumpingController.BROWSER_GAP_TOLERANCE)) {
                if (!a && !this.didFireLargeGap_) {
                  this.didFireLargeGap_ = !0;
                  var h = new shaka.util.FakeEvent('largegap', { currentTime: b, gapSize: f });
                  h.cancelable = !0;
                  this.onEvent_(h);
                  this.config_.jumpLargeGaps && !h.defaultPrevented
                    ? (g = !0)
                    : shaka.log.info('Ignoring large gap at', b, 'size', f);
                }
                if (a || g)
                  0 == d
                    ? shaka.log.info('Jumping forward', f, 'seconds because of gap before start time of', e)
                    : shaka.log.info(
                        'Jumping forward',
                        f,
                        'seconds because of gap starting at',
                        c.end(d - 1),
                        'and ending at',
                        e,
                      ),
                    (this.video_.currentTime = e);
              }
            }
          }
        }
      }
    };
    shaka.media.GapJumpingController.BROWSER_GAP_TOLERANCE = 0.001;
    shaka.util.MediaReadyState = function () {};
    shaka.util.MediaReadyState.waitForReadyState = function (a, b, c, d) {
      b == HTMLMediaElement.HAVE_NOTHING || a.readyState >= b
        ? d()
        : ((b = shaka.util.MediaReadyState.READY_STATES_TO_EVENT_NAMES_.get(b)), c.listenOnce(a, b, d));
    };
    shaka.util.MediaReadyState.READY_STATES_TO_EVENT_NAMES_ = new Map([
      [HTMLMediaElement.HAVE_METADATA, 'loadedmetadata'],
      [HTMLMediaElement.HAVE_CURRENT_DATA, 'loadeddata'],
      [HTMLMediaElement.HAVE_FUTURE_DATA, 'canplay'],
      [HTMLMediaElement.HAVE_ENOUGH_DATA, 'canplaythrough'],
    ]);
    shaka.media.VideoWrapper = function (a, b, c) {
      var d = this;
      this.video_ = a;
      this.onSeek_ = b;
      this.startTime_ = c;
      this.started_ = !1;
      this.eventManager_ = new shaka.util.EventManager();
      this.mover_ = new shaka.media.VideoWrapper.PlayheadMover(a, 10);
      shaka.util.MediaReadyState.waitForReadyState(
        this.video_,
        HTMLMediaElement.HAVE_METADATA,
        this.eventManager_,
        function () {
          d.setStartTime_(d.startTime_);
        },
      );
    };
    shaka.media.VideoWrapper.prototype.release = function () {
      this.eventManager_ && (this.eventManager_.release(), (this.eventManager_ = null));
      null != this.mover_ && (this.mover_.release(), (this.mover_ = null));
      this.onSeek_ = function () {};
      this.video_ = null;
    };
    shaka.media.VideoWrapper.prototype.getTime = function () {
      return this.started_ ? this.video_.currentTime : this.startTime_;
    };
    shaka.media.VideoWrapper.prototype.setTime = function (a) {
      var b = this;
      0 < this.video_.readyState
        ? this.mover_.moveTo(a)
        : shaka.util.MediaReadyState.waitForReadyState(
            this.video_,
            HTMLMediaElement.HAVE_METADATA,
            this.eventManager_,
            function () {
              b.setStartTime_(b.startTime_);
            },
          );
    };
    shaka.media.VideoWrapper.prototype.setStartTime_ = function (a) {
      var b = this;
      0.001 > Math.abs(this.video_.currentTime - a)
        ? this.startListeningToSeeks_()
        : (this.eventManager_.listenOnce(this.video_, 'seeking', function () {
            b.startListeningToSeeks_();
          }),
          this.mover_.moveTo(0 == this.video_.currentTime ? a : this.video_.currentTime));
    };
    shaka.media.VideoWrapper.prototype.startListeningToSeeks_ = function () {
      var a = this;
      goog.asserts.assert(
        0 < this.video_.readyState,
        'The media element should be ready before we listen for seeking.',
      );
      this.started_ = !0;
      this.eventManager_.listen(this.video_, 'seeking', function () {
        return a.onSeek_();
      });
    };
    shaka.media.VideoWrapper.PlayheadMover = function (a, b) {
      var c = this;
      this.mediaElement_ = a;
      this.maxAttempts_ = b;
      this.targetTime_ = this.originTime_ = this.remainingAttempts_ = 0;
      this.timer_ = new shaka.util.Timer(function () {
        return c.onTick_();
      });
    };
    shaka.media.VideoWrapper.PlayheadMover.prototype.release = function () {
      this.timer_ && (this.timer_.stop(), (this.timer_ = null));
      this.mediaElement_ = null;
    };
    shaka.media.VideoWrapper.PlayheadMover.prototype.moveTo = function (a) {
      this.originTime_ = this.mediaElement_.currentTime;
      this.targetTime_ = a;
      this.remainingAttempts_ = this.maxAttempts_;
      this.mediaElement_.currentTime = a;
      this.timer_.tickEvery(0.1);
    };
    shaka.media.VideoWrapper.PlayheadMover.prototype.onTick_ = function () {
      0 >= this.remainingAttempts_
        ? (shaka.log.warning(['Failed to move playhead from', this.originTime_, 'to', this.targetTime_].join(' ')),
          this.timer_.stop())
        : this.mediaElement_.currentTime != this.originTime_
        ? this.timer_.stop()
        : ((this.mediaElement_.currentTime = this.targetTime_), this.remainingAttempts_--);
    };
    shaka.media.Playhead = function () {};
    shaka.media.Playhead.prototype.setStartTime = function (a) {};
    shaka.media.Playhead.prototype.getTime = function () {};
    shaka.media.Playhead.prototype.notifyOfBufferingChange = function () {};
    shaka.media.SrcEqualsPlayhead = function (a) {
      var b = this;
      this.mediaElement_ = a;
      this.started_ = !1;
      this.startTime_ = null;
      this.eventManager_ = new shaka.util.EventManager();
      var c = function () {
        null == b.startTime_
          ? (b.started_ = !0)
          : (b.eventManager_.listenOnce(b.mediaElement_, 'seeking', function () {
              b.started_ = !0;
            }),
            (b.mediaElement_.currentTime = Math.max(0, b.mediaElement_.currentTime + b.startTime_)));
      };
      shaka.util.MediaReadyState.waitForReadyState(
        this.mediaElement_,
        HTMLMediaElement.HAVE_CURRENT_DATA,
        this.eventManager_,
        function () {
          c();
        },
      );
    };
    shaka.media.SrcEqualsPlayhead.prototype.release = function () {
      this.eventManager_ && (this.eventManager_.release(), (this.eventManager_ = null));
      this.mediaElement_ = null;
    };
    shaka.media.SrcEqualsPlayhead.prototype.setStartTime = function (a) {
      this.startTime_ = this.started_ ? this.startTime_ : a;
    };
    shaka.media.SrcEqualsPlayhead.prototype.getTime = function () {
      return (this.started_ ? this.mediaElement_.currentTime : this.startTime_) || 0;
    };
    shaka.media.SrcEqualsPlayhead.prototype.notifyOfBufferingChange = function () {};
    shaka.media.MediaSourcePlayhead = function (a, b, c, d, e, f) {
      var g = this;
      this.minSeekRange_ = 3;
      this.mediaElement_ = a;
      this.timeline_ = b.presentationTimeline;
      this.minBufferTime_ = b.minBufferTime || 0;
      this.config_ = c;
      this.onSeek_ = e;
      this.lastCorrectiveSeek_ = null;
      this.gapController_ = new shaka.media.GapJumpingController(
        a,
        b.presentationTimeline,
        c,
        this.createStallDetector_(a, c),
        f,
      );
      this.videoWrapper_ = new shaka.media.VideoWrapper(
        a,
        function () {
          return g.onSeeking_();
        },
        this.getStartTime_(d),
      );
      this.checkWindowTimer_ = new shaka.util.Timer(function () {
        g.onPollWindow_();
      }).tickEvery(0.25);
    };
    shaka.media.MediaSourcePlayhead.prototype.release = function () {
      this.videoWrapper_ && (this.videoWrapper_.release(), (this.videoWrapper_ = null));
      this.gapController_ && (this.gapController_.release(), (this.gapController_ = null));
      this.checkWindowTimer_ && (this.checkWindowTimer_.stop(), (this.checkWindowTimer_ = null));
      this.mediaElement_ = this.videoWrapper_ = this.timeline_ = this.config_ = null;
      this.onSeek_ = function () {};
    };
    shaka.media.MediaSourcePlayhead.prototype.setStartTime = function (a) {
      this.videoWrapper_.setTime(a);
    };
    shaka.media.MediaSourcePlayhead.prototype.getTime = function () {
      var a = this.videoWrapper_.getTime();
      return 0 < this.mediaElement_.readyState && !this.mediaElement_.paused ? this.clampTime_(a) : a;
    };
    shaka.media.MediaSourcePlayhead.prototype.getStartTime_ = function (a) {
      null == a
        ? (a =
            Infinity > this.timeline_.getDuration()
              ? this.timeline_.getSeekRangeStart()
              : this.timeline_.getSeekRangeEnd())
        : 0 > a && (a = this.timeline_.getSeekRangeEnd() + a);
      return this.clampSeekToDuration_(this.clampTime_(a));
    };
    shaka.media.MediaSourcePlayhead.prototype.notifyOfBufferingChange = function () {
      this.gapController_.onSegmentAppended();
    };
    shaka.media.MediaSourcePlayhead.prototype.onPollWindow_ = function () {
      if (0 != this.mediaElement_.readyState && !this.mediaElement_.paused) {
        var a = this.videoWrapper_.getTime(),
          b = this.timeline_.getSeekRangeStart(),
          c = this.timeline_.getSeekRangeEnd();
        c - b < this.minSeekRange_ && (b = c - this.minSeekRange_);
        a < b &&
          ((b = this.reposition_(a)),
          shaka.log.info('Jumping forward ' + (b - a) + ' seconds to catch up with the seek range.'),
          (this.mediaElement_.currentTime = b));
      }
    };
    shaka.media.MediaSourcePlayhead.prototype.onSeeking_ = function () {
      this.gapController_.onSeeking();
      var a = this.videoWrapper_.getTime(),
        b = this.reposition_(a);
      if (Math.abs(b - a) > shaka.media.GapJumpingController.BROWSER_GAP_TOLERANCE) {
        var c = Date.now() / 1e3;
        if (!this.lastCorrectiveSeek_ || this.lastCorrectiveSeek_ < c - 1) {
          this.lastCorrectiveSeek_ = c;
          this.videoWrapper_.setTime(b);
          return;
        }
      }
      shaka.log.v1('Seek to ' + a);
      this.onSeek_();
    };
    shaka.media.MediaSourcePlayhead.prototype.clampSeekToDuration_ = function (a) {
      var b = this.timeline_.getDuration();
      return a >= b
        ? (goog.asserts.assert(0 <= this.config_.durationBackoff, 'Duration backoff must be non-negative!'),
          b - this.config_.durationBackoff)
        : a;
    };
    shaka.media.MediaSourcePlayhead.prototype.reposition_ = function (a) {
      goog.asserts.assert(this.config_, 'Cannot reposition playhead when it has beeen destroyed');
      var b = Math.max(this.minBufferTime_, this.config_.rebufferingGoal),
        c = this.config_.safeSeekOffset,
        d = this.timeline_.getSeekRangeStart(),
        e = this.timeline_.getSeekRangeEnd(),
        f = this.timeline_.getDuration();
      e - d < this.minSeekRange_ && (d = e - this.minSeekRange_);
      var g = this.timeline_.getSafeSeekRangeStart(b),
        h = this.timeline_.getSafeSeekRangeStart(c);
      b = this.timeline_.getSafeSeekRangeStart(b + c);
      if (a >= f) return shaka.log.v1('Playhead past duration.'), this.clampSeekToDuration_(a);
      if (a > e) return shaka.log.v1('Playhead past end.'), e;
      if (a < d) {
        if (shaka.media.TimeRangesUtils.isBuffered(this.mediaElement_.buffered, h))
          return shaka.log.v1('Playhead before start & start is buffered'), h;
        shaka.log.v1('Playhead before start & start is unbuffered');
        return b;
      }
      if (a >= g || shaka.media.TimeRangesUtils.isBuffered(this.mediaElement_.buffered, a))
        return shaka.log.v1('Playhead in safe region or in buffered region.'), a;
      shaka.log.v1('Playhead outside safe region & in unbuffered region.');
      return b;
    };
    shaka.media.MediaSourcePlayhead.prototype.clampTime_ = function (a) {
      var b = this.timeline_.getSeekRangeStart();
      if (a < b) return b;
      b = this.timeline_.getSeekRangeEnd();
      return a > b ? b : a;
    };
    shaka.media.MediaSourcePlayhead.prototype.createStallDetector_ = function (a, b) {
      if (!b.stallEnabled) return null;
      var c = b.stallThreshold,
        d = b.stallSkip;
      c = new shaka.media.StallDetector(new shaka.media.StallDetector.MediaElementImplementation(a), c);
      c.onStall(function (e, f) {
        shaka.log.debug('Stall detected at ' + e + ' for ' + f + ' seconds.');
        d
          ? (shaka.log.debug('Seeking forward ' + d + ' seconds to break stall.'), (a.currentTime += d))
          : (shaka.log.debug('Pausing and unpausing to break stall.'), a.pause(), a.play());
      });
      return c;
    };
    shaka.media.SegmentIndex = function (a) {
      goog.DEBUG && shaka.media.SegmentIndex.assertCorrectReferences_(a);
      this.references = a;
      this.timer_ = null;
      this.numEvicted = 0;
    };
    shaka.media.SegmentIndex.prototype.destroy = function () {
      shaka.Deprecate.deprecateFeature(4, 'shaka.media.SegmentIndex', 'Please use release() instead of destroy().');
      this.release();
      return Promise.resolve();
    };
    shaka.media.SegmentIndex.prototype.release = function () {
      this.references = [];
      this.timer_ && this.timer_.stop();
      this.timer_ = null;
    };
    shaka.media.SegmentIndex.prototype.find = function (a) {
      for (var b = this.references.length - 1; 0 <= b; --b) {
        var c = this.references[b];
        if (a >= c.startTime && a < c.endTime) return b + this.numEvicted;
      }
      return this.references.length && a < this.references[0].startTime ? this.numEvicted : null;
    };
    shaka.media.SegmentIndex.prototype.get = function (a) {
      if (0 == this.references.length) return null;
      a -= this.numEvicted;
      return 0 > a || a >= this.references.length ? null : this.references[a];
    };
    shaka.media.SegmentIndex.prototype.offset = function (a) {
      for (var b = $jscomp.makeIterator(this.references), c = b.next(); !c.done; c = b.next())
        (c = c.value), (c.startTime += a), (c.endTime += a), (c.timestampOffset += a);
    };
    shaka.media.SegmentIndex.prototype.merge = function (a) {
      goog.DEBUG && shaka.media.SegmentIndex.assertCorrectReferences_(a);
      var b = this.references[this.references.length - 1],
        c = [];
      c = this.references.length
        ? a.filter(function (d) {
            return d.startTime >= b.startTime;
          })
        : a;
      b && c.length && c[0].startTime == b.startTime && this.references.pop();
      this.references.push.apply(this.references, $jscomp.arrayFromIterable(c));
      goog.DEBUG && shaka.media.SegmentIndex.assertCorrectReferences_(this.references);
    };
    shaka.media.SegmentIndex.prototype.evict = function (a) {
      var b = this.references.length;
      this.references = this.references.filter(function (c) {
        return c.endTime > a;
      });
      this.numEvicted += b - this.references.length;
    };
    shaka.media.SegmentIndex.prototype.fit = function (a, b) {
      goog.asserts.assert(null != b, 'Content duration must be known for static content!');
      for (
        goog.asserts.assert(Infinity != b, 'Content duration must be finite for static content!');
        this.references.length;

      )
        if (this.references[this.references.length - 1].startTime >= b) this.references.pop();
        else break;
      for (; this.references.length; )
        if (this.references[0].endTime <= a) this.references.shift(), this.numEvicted++;
        else break;
      if (0 != this.references.length) {
        var c = this.references[this.references.length - 1];
        this.references[this.references.length - 1] = new shaka.media.SegmentReference(
          c.startTime,
          b,
          c.getUris,
          c.startByte,
          c.endByte,
          c.initSegmentReference,
          c.timestampOffset,
          c.appendWindowStart,
          c.appendWindowEnd,
        );
      }
    };
    shaka.media.SegmentIndex.prototype.updateEvery = function (a, b) {
      var c = this;
      goog.asserts.assert(!this.timer_, 'SegmentIndex timer already started!');
      this.timer_ && this.timer_.stop();
      this.timer_ = new shaka.util.Timer(function () {
        var d = b();
        c.references.push.apply(c.references, $jscomp.arrayFromIterable(d));
        0 == c.references.length && (c.timer_.stop(), (c.timer_ = null));
      });
      this.timer_.tickEvery(a);
    };
    shaka.media.SegmentIndex.prototype[Symbol.iterator] = function () {
      return new shaka.media.SegmentIterator(this);
    };
    shaka.media.SegmentIndex.forSingleSegment = function (a, b, c) {
      a = new shaka.media.SegmentReference(
        a,
        a + b,
        function () {
          return c;
        },
        0,
        null,
        null,
        a,
        a,
        a + b,
      );
      return new shaka.media.SegmentIndex([a]);
    };
    goog.exportSymbol('shaka.media.SegmentIndex', shaka.media.SegmentIndex);
    goog.exportProperty(shaka.media.SegmentIndex, 'forSingleSegment', shaka.media.SegmentIndex.forSingleSegment);
    goog.exportProperty(
      shaka.media.SegmentIndex.prototype,
      'updateEvery',
      shaka.media.SegmentIndex.prototype.updateEvery,
    );
    goog.exportProperty(shaka.media.SegmentIndex.prototype, 'fit', shaka.media.SegmentIndex.prototype.fit);
    goog.exportProperty(shaka.media.SegmentIndex.prototype, 'evict', shaka.media.SegmentIndex.prototype.evict);
    goog.exportProperty(shaka.media.SegmentIndex.prototype, 'merge', shaka.media.SegmentIndex.prototype.merge);
    goog.exportProperty(shaka.media.SegmentIndex.prototype, 'offset', shaka.media.SegmentIndex.prototype.offset);
    goog.exportProperty(shaka.media.SegmentIndex.prototype, 'get', shaka.media.SegmentIndex.prototype.get);
    goog.exportProperty(shaka.media.SegmentIndex.prototype, 'find', shaka.media.SegmentIndex.prototype.find);
    goog.exportProperty(shaka.media.SegmentIndex.prototype, 'release', shaka.media.SegmentIndex.prototype.release);
    goog.exportProperty(shaka.media.SegmentIndex.prototype, 'destroy', shaka.media.SegmentIndex.prototype.destroy);
    goog.DEBUG &&
      (shaka.media.SegmentIndex.assertCorrectReferences_ = function (a) {
        goog.asserts.assert(
          a.every(function (b, c) {
            if (0 == c) return !0;
            var d = a[c - 1];
            return d.startTime < b.startTime ? !0 : d.startTime > b.startTime ? !1 : d.endTime <= b.endTime ? !0 : !1;
          }),
          'SegmentReferences are incorrect',
        );
      });
    shaka.media.SegmentIterator = function (a) {
      this.segmentIndex_ = a;
      this.nextPosition_ = this.segmentIndex_.find(0) || 0;
    };
    shaka.media.SegmentIterator.prototype.seek = function (a) {
      a = this.segmentIndex_.find(a);
      if (null == a) return (this.nextPosition_ = Math.pow(2, 31)), null;
      this.nextPosition_ = a;
      return this.segmentIndex_.get(this.nextPosition_++);
    };
    shaka.media.SegmentIterator.prototype.current = function () {
      return this.segmentIndex_.get(this.nextPosition_ - 1);
    };
    shaka.media.SegmentIterator.prototype.next = function () {
      var a = this.segmentIndex_.get(this.nextPosition_++);
      return { value: a, done: !a };
    };
    goog.exportSymbol('shaka.media.SegmentIterator', shaka.media.SegmentIterator);
    goog.exportProperty(shaka.media.SegmentIterator.prototype, 'next', shaka.media.SegmentIterator.prototype.next);
    goog.exportProperty(
      shaka.media.SegmentIterator.prototype,
      'current',
      shaka.media.SegmentIterator.prototype.current,
    );
    goog.exportProperty(shaka.media.SegmentIterator.prototype, 'seek', shaka.media.SegmentIterator.prototype.seek);
    shaka.media.MetaSegmentIndex = function () {
      shaka.media.SegmentIndex.call(this, []);
      this.indexes_ = [];
    };
    $jscomp.inherits(shaka.media.MetaSegmentIndex, shaka.media.SegmentIndex);
    shaka.media.MetaSegmentIndex.prototype.appendSegmentIndex = function (a) {
      this.indexes_.push(a);
    };
    shaka.media.MetaSegmentIndex.prototype.clone = function () {
      var a = new shaka.media.MetaSegmentIndex();
      a.indexes_ = this.indexes_.slice();
      return a;
    };
    shaka.media.MetaSegmentIndex.prototype.release = function () {
      for (var a = $jscomp.makeIterator(this.indexes_), b = a.next(); !b.done; b = a.next()) b.value.release();
      this.indexes_ = [];
    };
    shaka.media.MetaSegmentIndex.prototype.find = function (a) {
      for (var b = 0, c = $jscomp.makeIterator(this.indexes_), d = c.next(); !d.done; d = c.next()) {
        d = d.value;
        var e = d.find(a);
        if (null != e) return e + b;
        b += d.numEvicted + d.references.length;
      }
      return null;
    };
    shaka.media.MetaSegmentIndex.prototype.get = function (a) {
      for (var b = 0, c = $jscomp.makeIterator(this.indexes_), d = c.next(); !d.done; d = c.next()) {
        d = d.value;
        var e = d.get(a - b);
        if (e) return e;
        b += d.numEvicted + d.references.length;
      }
      return null;
    };
    shaka.media.MetaSegmentIndex.prototype.offset = function (a) {
      goog.asserts.assert(!1, 'offset() should not be used in MetaSegmentIndex!');
    };
    shaka.media.MetaSegmentIndex.prototype.merge = function (a) {
      goog.asserts.assert(!1, 'merge() should not be used in MetaSegmentIndex!');
    };
    shaka.media.MetaSegmentIndex.prototype.evict = function (a) {
      goog.asserts.assert(!1, 'evict() should not be used in MetaSegmentIndex!');
    };
    shaka.media.MetaSegmentIndex.prototype.fit = function (a, b) {
      goog.asserts.assert(!1, 'fit() should not be used in MetaSegmentIndex!');
    };
    shaka.media.MetaSegmentIndex.prototype.updateEvery = function (a, b) {
      goog.asserts.assert(!1, 'updateEvery() should not be used in MetaSegmentIndex!');
    };
    goog.exportSymbol('shaka.media.MetaSegmentIndex', shaka.media.MetaSegmentIndex);
    goog.exportProperty(
      shaka.media.MetaSegmentIndex.prototype,
      'updateEvery',
      shaka.media.MetaSegmentIndex.prototype.updateEvery,
    );
    goog.exportProperty(shaka.media.MetaSegmentIndex.prototype, 'fit', shaka.media.MetaSegmentIndex.prototype.fit);
    goog.exportProperty(shaka.media.MetaSegmentIndex.prototype, 'evict', shaka.media.MetaSegmentIndex.prototype.evict);
    goog.exportProperty(shaka.media.MetaSegmentIndex.prototype, 'merge', shaka.media.MetaSegmentIndex.prototype.merge);
    goog.exportProperty(
      shaka.media.MetaSegmentIndex.prototype,
      'offset',
      shaka.media.MetaSegmentIndex.prototype.offset,
    );
    goog.exportProperty(shaka.media.MetaSegmentIndex.prototype, 'get', shaka.media.MetaSegmentIndex.prototype.get);
    goog.exportProperty(shaka.media.MetaSegmentIndex.prototype, 'find', shaka.media.MetaSegmentIndex.prototype.find);
    goog.exportProperty(
      shaka.media.MetaSegmentIndex.prototype,
      'release',
      shaka.media.MetaSegmentIndex.prototype.release,
    );
    shaka.media.PlayRateController = function (a) {
      var b = this;
      this.harness_ = a;
      this.isBuffering_ = !1;
      this.rate_ = this.harness_.getRate();
      this.pollRate_ = 0.25;
      this.timer_ = new shaka.util.Timer(function () {
        b.harness_.movePlayhead(b.rate_ * b.pollRate_);
      });
    };
    shaka.media.PlayRateController.prototype.release = function () {
      this.timer_ && (this.timer_.stop(), (this.timer_ = null));
      this.harness_ = null;
    };
    shaka.media.PlayRateController.prototype.setBuffering = function (a) {
      this.isBuffering_ = a;
      this.apply_();
    };
    shaka.media.PlayRateController.prototype.set = function (a) {
      goog.asserts.assert(0 != a, 'Should never set rate of 0 explicitly!');
      this.rate_ = a;
      this.apply_();
    };
    shaka.media.PlayRateController.prototype.getRealRate = function () {
      return this.rate_;
    };
    shaka.media.PlayRateController.prototype.apply_ = function () {
      this.timer_.stop();
      var a = this.calculateCurrentRate_();
      shaka.log.v1('Changing effective playback rate to', a);
      if (0 <= a)
        try {
          this.applyRate_(a);
          return;
        } catch (b) {}
      this.timer_.tickEvery(this.pollRate_);
      this.applyRate_(0);
    };
    shaka.media.PlayRateController.prototype.calculateCurrentRate_ = function () {
      return this.isBuffering_ ? 0 : this.rate_;
    };
    shaka.media.PlayRateController.prototype.applyRate_ = function (a) {
      var b = this.harness_.getRate();
      b != a && this.harness_.setRate(a);
      return b != a;
    };
    shaka.media.IPlayheadObserver = function () {};
    shaka.media.IPlayheadObserver.prototype.poll = function (a, b) {};
    shaka.media.PlayheadObserverManager = function (a) {
      var b = this;
      this.mediaElement_ = a;
      this.observers_ = new Set();
      this.pollingLoop_ = new shaka.util.Timer(function () {
        b.pollAllObservers_(!1);
      }).tickEvery(0.25);
    };
    shaka.media.PlayheadObserverManager.prototype.release = function () {
      this.pollingLoop_.stop();
      for (var a = $jscomp.makeIterator(this.observers_), b = a.next(); !b.done; b = a.next()) b.value.release();
      this.observers_.clear();
    };
    shaka.media.PlayheadObserverManager.prototype.manage = function (a) {
      this.observers_.add(a);
    };
    shaka.media.PlayheadObserverManager.prototype.notifyOfSeek = function () {
      this.pollAllObservers_(!0);
    };
    shaka.media.PlayheadObserverManager.prototype.pollAllObservers_ = function (a) {
      for (var b = $jscomp.makeIterator(this.observers_), c = b.next(); !c.done; c = b.next())
        c.value.poll(this.mediaElement_.currentTime, a);
    };
    shaka.media.RegionTimeline = function (a) {
      var b = this;
      this.onAddRegion_ = function (c) {};
      this.regions_ = new Set();
      this.getSeekRange_ = a;
      this.filterTimer_ = new shaka.util.Timer(function () {
        b.filterBySeekRange_();
      }).tickEvery(shaka.media.RegionTimeline.REGION_FILTER_INTERVAL);
    };
    shaka.media.RegionTimeline.prototype.release = function () {
      this.onAddRegion_ = function (a) {};
      this.regions_.clear();
      this.filterTimer_.stop();
    };
    shaka.media.RegionTimeline.prototype.setListeners = function (a) {
      this.onAddRegion_ = a;
    };
    shaka.media.RegionTimeline.prototype.addRegion = function (a) {
      null == this.findSimilarRegion_(a) && (this.regions_.add(a), this.onAddRegion_(a));
    };
    shaka.media.RegionTimeline.prototype.filterBySeekRange_ = function () {
      for (var a = this.getSeekRange_(), b = $jscomp.makeIterator(this.regions_), c = b.next(); !c.done; c = b.next())
        (c = c.value), c.endTime < a.start && this.regions_['delete'](c);
    };
    shaka.media.RegionTimeline.prototype.findSimilarRegion_ = function (a) {
      for (var b = $jscomp.makeIterator(this.regions_), c = b.next(); !c.done; c = b.next())
        if (
          ((c = c.value),
          c.schemeIdUri == a.schemeIdUri && c.id == a.id && c.startTime == a.startTime && c.endTime == a.endTime)
        )
          return c;
      return null;
    };
    shaka.media.RegionTimeline.prototype.regions = function () {
      return this.regions_;
    };
    shaka.media.RegionTimeline.REGION_FILTER_INTERVAL = 2;
    shaka.media.RegionObserver = function (a) {
      var b = this;
      this.timeline_ = a;
      this.oldPosition_ = new Map();
      this.onEnter_ = function (e, f) {};
      this.onExit_ = function (e, f) {};
      this.onSkip_ = function (e, f) {};
      var c = shaka.media.RegionObserver.RelativePosition_;
      a = c.BEFORE_THE_REGION;
      var d = c.IN_THE_REGION;
      c = c.AFTER_THE_REGION;
      this.rules_ = [
        {
          weWere: null,
          weAre: d,
          invoke: function (e, f) {
            return b.onEnter_(e, f);
          },
        },
        {
          weWere: a,
          weAre: d,
          invoke: function (e, f) {
            return b.onEnter_(e, f);
          },
        },
        {
          weWere: c,
          weAre: d,
          invoke: function (e, f) {
            return b.onEnter_(e, f);
          },
        },
        {
          weWere: d,
          weAre: a,
          invoke: function (e, f) {
            return b.onExit_(e, f);
          },
        },
        {
          weWere: d,
          weAre: c,
          invoke: function (e, f) {
            return b.onExit_(e, f);
          },
        },
        {
          weWere: a,
          weAre: c,
          invoke: function (e, f) {
            return b.onSkip_(e, f);
          },
        },
        {
          weWere: c,
          weAre: a,
          invoke: function (e, f) {
            return b.onSkip_(e, f);
          },
        },
      ];
    };
    shaka.media.RegionObserver.prototype.release = function () {
      this.timeline_ = null;
      this.oldPosition_.clear();
      this.onEnter_ = function (a, b) {};
      this.onExit_ = function (a, b) {};
      this.onSkip_ = function (a, b) {};
    };
    shaka.media.RegionObserver.prototype.poll = function (a, b) {
      for (
        var c = shaka.media.RegionObserver, d = $jscomp.makeIterator(this.timeline_.regions()), e = d.next();
        !e.done;
        e = d.next()
      ) {
        e = e.value;
        var f = this.oldPosition_.get(e),
          g = c.determinePositionRelativeTo_(e, a);
        this.oldPosition_.set(e, g);
        for (var h = $jscomp.makeIterator(this.rules_), k = h.next(); !k.done; k = h.next())
          (k = k.value), k.weWere == f && k.weAre == g && k.invoke(e, b);
      }
    };
    shaka.media.RegionObserver.prototype.setListeners = function (a, b, c) {
      this.onEnter_ = a;
      this.onExit_ = b;
      this.onSkip_ = c;
    };
    shaka.media.RegionObserver.determinePositionRelativeTo_ = function (a, b) {
      var c = shaka.media.RegionObserver.RelativePosition_;
      return b < a.startTime ? c.BEFORE_THE_REGION : b > a.endTime ? c.AFTER_THE_REGION : c.IN_THE_REGION;
    };
    shaka.media.RegionObserver.RelativePosition_ = { BEFORE_THE_REGION: 1, IN_THE_REGION: 2, AFTER_THE_REGION: 3 };
    shaka.util.DataViewReader = function (a, b) {
      this.dataView_ = shaka.util.BufferUtils.toDataView(a);
      this.littleEndian_ = b == shaka.util.DataViewReader.Endianness.LITTLE_ENDIAN;
      this.position_ = 0;
    };
    shaka.util.DataViewReader.prototype.getDataView = function () {
      return this.dataView_;
    };
    shaka.util.DataViewReader.prototype.hasMoreData = function () {
      return this.position_ < this.dataView_.byteLength;
    };
    shaka.util.DataViewReader.prototype.getPosition = function () {
      return this.position_;
    };
    shaka.util.DataViewReader.prototype.getLength = function () {
      return this.dataView_.byteLength;
    };
    shaka.util.DataViewReader.prototype.readUint8 = function () {
      try {
        var a = this.dataView_.getUint8(this.position_);
        this.position_ += 1;
        return a;
      } catch (b) {
        throw this.outOfBounds_();
      }
    };
    shaka.util.DataViewReader.prototype.readUint16 = function () {
      try {
        var a = this.dataView_.getUint16(this.position_, this.littleEndian_);
        this.position_ += 2;
        return a;
      } catch (b) {
        throw this.outOfBounds_();
      }
    };
    shaka.util.DataViewReader.prototype.readUint32 = function () {
      try {
        var a = this.dataView_.getUint32(this.position_, this.littleEndian_);
        this.position_ += 4;
        return a;
      } catch (b) {
        throw this.outOfBounds_();
      }
    };
    shaka.util.DataViewReader.prototype.readInt32 = function () {
      try {
        var a = this.dataView_.getInt32(this.position_, this.littleEndian_);
        this.position_ += 4;
        return a;
      } catch (b) {
        throw this.outOfBounds_();
      }
    };
    shaka.util.DataViewReader.prototype.readUint64 = function () {
      try {
        if (this.littleEndian_) {
          var a = this.dataView_.getUint32(this.position_, !0);
          var b = this.dataView_.getUint32(this.position_ + 4, !0);
        } else
          (b = this.dataView_.getUint32(this.position_, !1)), (a = this.dataView_.getUint32(this.position_ + 4, !1));
      } catch (c) {
        throw this.outOfBounds_();
      }
      if (2097151 < b)
        throw new shaka.util.Error(
          shaka.util.Error.Severity.CRITICAL,
          shaka.util.Error.Category.MEDIA,
          shaka.util.Error.Code.JS_INTEGER_OVERFLOW,
        );
      this.position_ += 8;
      return b * Math.pow(2, 32) + a;
    };
    shaka.util.DataViewReader.prototype.readBytes = function (a) {
      goog.asserts.assert(0 <= a, 'Bad call to DataViewReader.readBytes');
      if (this.position_ + a > this.dataView_.byteLength) throw this.outOfBounds_();
      var b = shaka.util.BufferUtils.toUint8(this.dataView_, this.position_, a);
      this.position_ += a;
      return b;
    };
    shaka.util.DataViewReader.prototype.skip = function (a) {
      goog.asserts.assert(0 <= a, 'Bad call to DataViewReader.skip');
      if (this.position_ + a > this.dataView_.byteLength) throw this.outOfBounds_();
      this.position_ += a;
    };
    shaka.util.DataViewReader.prototype.rewind = function (a) {
      goog.asserts.assert(0 <= a, 'Bad call to DataViewReader.rewind');
      if (this.position_ < a) throw this.outOfBounds_();
      this.position_ -= a;
    };
    shaka.util.DataViewReader.prototype.seek = function (a) {
      goog.asserts.assert(0 <= a, 'Bad call to DataViewReader.seek');
      if (0 > a || a > this.dataView_.byteLength) throw this.outOfBounds_();
      this.position_ = a;
    };
    shaka.util.DataViewReader.prototype.readTerminatedString = function () {
      for (var a = this.position_; this.hasMoreData() && 0 != this.dataView_.getUint8(this.position_); )
        this.position_ += 1;
      a = shaka.util.BufferUtils.toUint8(this.dataView_, a, this.position_ - a);
      this.position_ += 1;
      return shaka.util.StringUtils.fromUTF8(a);
    };
    shaka.util.DataViewReader.prototype.outOfBounds_ = function () {
      return new shaka.util.Error(
        shaka.util.Error.Severity.CRITICAL,
        shaka.util.Error.Category.MEDIA,
        shaka.util.Error.Code.BUFFER_READ_OUT_OF_BOUNDS,
      );
    };
    goog.exportSymbol('shaka.util.DataViewReader', shaka.util.DataViewReader);
    goog.exportProperty(
      shaka.util.DataViewReader.prototype,
      'readTerminatedString',
      shaka.util.DataViewReader.prototype.readTerminatedString,
    );
    goog.exportProperty(shaka.util.DataViewReader.prototype, 'seek', shaka.util.DataViewReader.prototype.seek);
    goog.exportProperty(shaka.util.DataViewReader.prototype, 'rewind', shaka.util.DataViewReader.prototype.rewind);
    goog.exportProperty(shaka.util.DataViewReader.prototype, 'skip', shaka.util.DataViewReader.prototype.skip);
    goog.exportProperty(
      shaka.util.DataViewReader.prototype,
      'readBytes',
      shaka.util.DataViewReader.prototype.readBytes,
    );
    goog.exportProperty(
      shaka.util.DataViewReader.prototype,
      'readUint64',
      shaka.util.DataViewReader.prototype.readUint64,
    );
    goog.exportProperty(
      shaka.util.DataViewReader.prototype,
      'readInt32',
      shaka.util.DataViewReader.prototype.readInt32,
    );
    goog.exportProperty(
      shaka.util.DataViewReader.prototype,
      'readUint32',
      shaka.util.DataViewReader.prototype.readUint32,
    );
    goog.exportProperty(
      shaka.util.DataViewReader.prototype,
      'readUint16',
      shaka.util.DataViewReader.prototype.readUint16,
    );
    goog.exportProperty(
      shaka.util.DataViewReader.prototype,
      'readUint8',
      shaka.util.DataViewReader.prototype.readUint8,
    );
    goog.exportProperty(
      shaka.util.DataViewReader.prototype,
      'getLength',
      shaka.util.DataViewReader.prototype.getLength,
    );
    goog.exportProperty(
      shaka.util.DataViewReader.prototype,
      'getPosition',
      shaka.util.DataViewReader.prototype.getPosition,
    );
    goog.exportProperty(
      shaka.util.DataViewReader.prototype,
      'hasMoreData',
      shaka.util.DataViewReader.prototype.hasMoreData,
    );
    shaka.util.DataViewReader.Endianness = { BIG_ENDIAN: 0, LITTLE_ENDIAN: 1 };
    goog.exportProperty(shaka.util.DataViewReader, 'Endianness', shaka.util.DataViewReader.Endianness);
    shaka.util.Mp4Parser = function () {
      this.headers_ = [];
      this.boxDefinitions_ = [];
      this.done_ = !1;
    };
    shaka.util.Mp4Parser.prototype.box = function (a, b) {
      var c = shaka.util.Mp4Parser.typeFromString_(a);
      this.headers_[c] = shaka.util.Mp4Parser.BoxType_.BASIC_BOX;
      this.boxDefinitions_[c] = b;
      return this;
    };
    shaka.util.Mp4Parser.prototype.fullBox = function (a, b) {
      var c = shaka.util.Mp4Parser.typeFromString_(a);
      this.headers_[c] = shaka.util.Mp4Parser.BoxType_.FULL_BOX;
      this.boxDefinitions_[c] = b;
      return this;
    };
    shaka.util.Mp4Parser.prototype.stop = function () {
      this.done_ = !0;
    };
    shaka.util.Mp4Parser.prototype.parse = function (a, b) {
      var c = new shaka.util.DataViewReader(a, shaka.util.DataViewReader.Endianness.BIG_ENDIAN);
      for (this.done_ = !1; c.hasMoreData() && !this.done_; ) this.parseNext(0, c, b);
    };
    shaka.util.Mp4Parser.prototype.parseNext = function (a, b, c) {
      var d = b.getPosition(),
        e = b.readUint32(),
        f = b.readUint32(),
        g = shaka.util.Mp4Parser.typeToString(f);
      shaka.log.v2('Parsing MP4 box', g);
      switch (e) {
        case 0:
          e = b.getLength() - d;
          break;
        case 1:
          e = b.readUint64();
      }
      if ((g = this.boxDefinitions_[f])) {
        var h = null,
          k = null;
        this.headers_[f] == shaka.util.Mp4Parser.BoxType_.FULL_BOX &&
          ((k = b.readUint32()), (h = k >>> 24), (k &= 16777215));
        f = d + e;
        c && f > b.getLength() && (f = b.getLength());
        f -= b.getPosition();
        b = 0 < f ? b.readBytes(f) : new Uint8Array(0);
        b = new shaka.util.DataViewReader(b, shaka.util.DataViewReader.Endianness.BIG_ENDIAN);
        g({ parser: this, partialOkay: c || !1, version: h, flags: k, reader: b, size: e, start: d + a });
      } else (a = Math.min(d + e - b.getPosition(), b.getLength() - b.getPosition())), b.skip(a);
    };
    shaka.util.Mp4Parser.children = function (a) {
      for (var b = null != a.flags ? 12 : 8; a.reader.hasMoreData() && !a.parser.done_; )
        a.parser.parseNext(a.start + b, a.reader, a.partialOkay);
    };
    shaka.util.Mp4Parser.sampleDescription = function (a) {
      var b = null != a.flags ? 12 : 8,
        c = a.reader.readUint32();
      c = $jscomp.makeIterator(shaka.util.Iterables.range(c));
      for (
        var d = c.next();
        !d.done &&
        (shaka.util.Functional.ignored(d.value),
        a.parser.parseNext(a.start + b, a.reader, a.partialOkay),
        !a.parser.done_);
        d = c.next()
      );
    };
    shaka.util.Mp4Parser.allData = function (a) {
      return function (b) {
        var c = b.reader.getLength() - b.reader.getPosition();
        a(b.reader.readBytes(c));
      };
    };
    shaka.util.Mp4Parser.typeFromString_ = function (a) {
      goog.asserts.assert(4 == a.length, 'Mp4 box names must be 4 characters long');
      var b = 0;
      a = $jscomp.makeIterator(a);
      for (var c = a.next(); !c.done; c = a.next()) b = (b << 8) | c.value.charCodeAt(0);
      return b;
    };
    shaka.util.Mp4Parser.typeToString = function (a) {
      return String.fromCharCode((a >> 24) & 255, (a >> 16) & 255, (a >> 8) & 255, a & 255);
    };
    goog.exportSymbol('shaka.util.Mp4Parser', shaka.util.Mp4Parser);
    goog.exportProperty(shaka.util.Mp4Parser, 'typeToString', shaka.util.Mp4Parser.typeToString);
    goog.exportProperty(shaka.util.Mp4Parser, 'allData', shaka.util.Mp4Parser.allData);
    goog.exportProperty(shaka.util.Mp4Parser, 'sampleDescription', shaka.util.Mp4Parser.sampleDescription);
    goog.exportProperty(shaka.util.Mp4Parser, 'children', shaka.util.Mp4Parser.children);
    goog.exportProperty(shaka.util.Mp4Parser.prototype, 'parseNext', shaka.util.Mp4Parser.prototype.parseNext);
    goog.exportProperty(shaka.util.Mp4Parser.prototype, 'parse', shaka.util.Mp4Parser.prototype.parse);
    goog.exportProperty(shaka.util.Mp4Parser.prototype, 'stop', shaka.util.Mp4Parser.prototype.stop);
    goog.exportProperty(shaka.util.Mp4Parser.prototype, 'fullBox', shaka.util.Mp4Parser.prototype.fullBox);
    goog.exportProperty(shaka.util.Mp4Parser.prototype, 'box', shaka.util.Mp4Parser.prototype.box);
    shaka.util.Mp4Parser.BoxType_ = { BASIC_BOX: 0, FULL_BOX: 1 };
    shaka.util.Networking = function () {};
    shaka.util.Networking.createSegmentRequest = function (a, b, c, d) {
      a = shaka.net.NetworkingEngine.makeRequest(a, d);
      if (0 != b || null != c) a.headers.Range = c ? 'bytes=' + b + '-' + c : 'bytes=' + b + '-';
      return a;
    };
    shaka.media.StreamingEngine = function (a, b) {
      var c = this;
      this.playerInterface_ = b;
      this.manifest_ = a;
      this.config_ = null;
      this.bufferingGoalScale_ = 1;
      this.currentTextStream_ = this.currentVariant_ = null;
      this.mediaStates_ = new Map();
      this.startupComplete_ = !1;
      this.failureCallbackBackoff_ = null;
      this.fatalError_ = !1;
      this.destroyer_ = new shaka.util.Destroyer(function () {
        return c.doDestroy_();
      });
    };
    shaka.media.StreamingEngine.prototype.destroy = function () {
      return this.destroyer_.destroy();
    };
    shaka.media.StreamingEngine.prototype.doDestroy_ = function () {
      var a = this,
        b,
        c,
        d,
        e;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (f) {
        if (1 == f.nextAddress) {
          b = [];
          c = $jscomp.makeIterator(a.mediaStates_.values());
          for (d = c.next(); !d.done; d = c.next()) (e = d.value), a.cancelUpdate_(e), b.push(a.abortOperations_(e));
          return f.yield(Promise.all(b), 2);
        }
        a.mediaStates_.clear();
        a.playerInterface_ = null;
        a.manifest_ = null;
        a.config_ = null;
        f.jumpToEnd();
      });
    };
    shaka.media.StreamingEngine.prototype.configure = function (a) {
      this.config_ = a;
      this.failureCallbackBackoff_ = new shaka.net.Backoff(
        {
          maxAttempts: Math.max(a.retryParameters.maxAttempts, 2),
          baseDelay: a.retryParameters.baseDelay,
          backoffFactor: a.retryParameters.backoffFactor,
          fuzzFactor: a.retryParameters.fuzzFactor,
          timeout: 0,
        },
        !0,
      );
    };
    shaka.media.StreamingEngine.prototype.start = function () {
      var a = this;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (b) {
        if (1 == b.nextAddress)
          return (
            goog.asserts.assert(a.config_, 'StreamingEngine configure() must be called before init()!'),
            b.yield(a.initStreams_(), 2)
          );
        a.destroyer_.ensureNotDestroyed();
        shaka.log.debug('init: completed initial Stream setup');
        a.startupComplete_ = !0;
        b.jumpToEnd();
      });
    };
    shaka.media.StreamingEngine.prototype.getCurrentVariant = function () {
      return this.currentVariant_;
    };
    shaka.media.StreamingEngine.prototype.getCurrentTextStream = function () {
      return this.currentTextStream_;
    };
    shaka.media.StreamingEngine.prototype.loadNewTextStream_ = function (a) {
      var b = this,
        c,
        d,
        e,
        f,
        g,
        h;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (k) {
        switch (k.nextAddress) {
          case 1:
            return (
              (c = shaka.util.ManifestParserUtils.ContentType),
              goog.asserts.assert(
                !b.mediaStates_.has(c.TEXT),
                'Should not call loadNewTextStream_ while streaming text!',
              ),
              k.setCatchFinallyBlocks(2),
              k.yield(b.playerInterface_.mediaSourceEngine.clear(c.TEXT), 4)
            );
          case 4:
            k.leaveTryBlock(3);
            break;
          case 2:
            if (((d = k.enterCatchBlock()), b.playerInterface_)) b.playerInterface_.onError(d);
          case 3:
            e = shaka.util.MimeUtils.getFullType(a.mimeType, a.codecs);
            b.playerInterface_.mediaSourceEngine.reinitText(e);
            f = b.playerInterface_.mediaSourceEngine.getTextDisplayer();
            if ((g = f.isTextVisible() || b.config_.alwaysStreamText))
              (h = b.createMediaState_(a)), b.mediaStates_.set(c.TEXT, h), b.scheduleUpdate_(h, 0);
            k.jumpToEnd();
        }
      });
    };
    shaka.media.StreamingEngine.prototype.unloadTextStream = function () {
      var a = shaka.util.ManifestParserUtils.ContentType,
        b = this.mediaStates_.get(a.TEXT);
      b &&
        (this.cancelUpdate_(b), this.abortOperations_(b)['catch'](function () {}), this.mediaStates_['delete'](a.TEXT));
      this.currentTextStream_ = null;
    };
    shaka.media.StreamingEngine.prototype.setTrickPlay = function (a) {
      var b = this.mediaStates_.get(shaka.util.ManifestParserUtils.ContentType.VIDEO);
      if (b) {
        var c = b.stream;
        if (c)
          if ((shaka.log.debug('setTrickPlay', a), a))
            (a = c.trickModeVideo) &&
              !b.restoreStreamAfterTrickPlay &&
              (shaka.log.debug('Engaging trick mode stream', a),
              this.switchInternal_(a, !1, 0, !1),
              (b.restoreStreamAfterTrickPlay = c));
          else if ((c = b.restoreStreamAfterTrickPlay))
            shaka.log.debug('Restoring non-trick-mode stream', c),
              (b.restoreStreamAfterTrickPlay = null),
              this.switchInternal_(c, !0, 0, !1);
      }
    };
    shaka.media.StreamingEngine.prototype.switchVariant = function (a, b, c) {
      b = void 0 === b ? !1 : b;
      c = void 0 === c ? 0 : c;
      this.currentVariant_ = a;
      this.startupComplete_ &&
        (a.video && this.switchInternal_(a.video, b, c, !1), a.audio && this.switchInternal_(a.audio, b, c, !1));
    };
    shaka.media.StreamingEngine.prototype.switchTextStream = function (a) {
      this.currentTextStream_ = a;
      if (this.startupComplete_) {
        var b = shaka.util.ManifestParserUtils.ContentType;
        goog.asserts.assert(a && a.type == b.TEXT, 'Wrong stream type passed to switchTextStream!');
        this.switchInternal_(a, !0, 0, !1);
      }
    };
    shaka.media.StreamingEngine.prototype.reloadTextStream = function () {
      var a = this.mediaStates_.get(shaka.util.ManifestParserUtils.ContentType.TEXT);
      a && this.switchInternal_(a.stream, !0, 0, !0);
    };
    shaka.media.StreamingEngine.prototype.switchInternal_ = function (a, b, c, d) {
      var e = this,
        f = shaka.util.ManifestParserUtils.ContentType,
        g = this.mediaStates_.get(a.type);
      g || a.type != f.TEXT
        ? (goog.asserts.assert(g, 'switch: expected mediaState to exist'),
          g &&
            (g.restoreStreamAfterTrickPlay &&
              (shaka.log.debug('switch during trick play mode', a),
              a.trickModeVideo
                ? ((g.restoreStreamAfterTrickPlay = a),
                  (a = a.trickModeVideo),
                  shaka.log.debug('switch found trick play stream', a))
                : ((g.restoreStreamAfterTrickPlay = null),
                  shaka.log.debug('switch found no special trick play stream'))),
            g.stream != a || d
              ? (a.type == f.TEXT &&
                  ((d = shaka.util.MimeUtils.getFullType(a.mimeType, a.codecs)),
                  this.playerInterface_.mediaSourceEngine.reinitText(d)),
                (g.stream = a),
                (g.segmentIterator = null),
                (a = shaka.media.StreamingEngine.logPrefix_(g)),
                shaka.log.debug('switch: switching to Stream ' + a),
                b &&
                  (g.clearingBuffer
                    ? (g.waitingToFlushBuffer = !0)
                    : g.performingUpdate
                    ? ((g.waitingToClearBuffer = !0), (g.clearBufferSafeMargin = c), (g.waitingToFlushBuffer = !0))
                    : (this.cancelUpdate_(g),
                      this.clearBuffer_(g, !0, c)['catch'](function (h) {
                        e.playerInterface_ &&
                          (goog.asserts.assert(h instanceof shaka.util.Error, 'Wrong error type!'),
                          e.playerInterface_.onError(h));
                      }))),
                this.makeAbortDecision_(g)['catch'](function (h) {
                  e.playerInterface_ &&
                    (goog.asserts.assert(h instanceof shaka.util.Error, 'Wrong error type!'),
                    e.playerInterface_.onError(h));
                }))
              : ((b = shaka.media.StreamingEngine.logPrefix_(g)),
                shaka.log.debug('switch: Stream ' + b + ' already active'))))
        : this.loadNewTextStream_(a);
    };
    shaka.media.StreamingEngine.prototype.makeAbortDecision_ = function (a) {
      var b = this,
        c,
        d;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (e) {
        if (1 == e.nextAddress) {
          if (!a.operation) return e['return']();
          c = a.stream;
          d = a.operation;
          return c.segmentIndex ? e.jumpTo(2) : e.yield(c.createSegmentIndex(), 2);
        }
        if (a.operation != d || a.stream != c) return e['return']();
        goog.asserts.assert(a.stream.segmentIndex, 'Segment index should exist by now!');
        goog.asserts.assert(!a.segmentIterator, 'Segment iterator should have been reset by now!');
        a.segmentIterator = a.stream.segmentIndex[Symbol.iterator]();
        b.shouldAbortCurrentRequest_(a) && (shaka.log.info('Aborting current segment request.'), a.operation.abort());
        e.jumpToEnd();
      });
    };
    shaka.media.StreamingEngine.prototype.shouldAbortCurrentRequest_ = function (a) {
      goog.asserts.assert(a.operation, 'Abort logic requires an ongoing operation!');
      var b = this.playerInterface_.getPresentationTime(),
        c = this.playerInterface_.mediaSourceEngine.bufferEnd(a.type),
        d = this.getSegmentReferenceNeeded_(a, b, c),
        e = d ? d.getSize() : null;
      d && !e && (e = ((d.getEndTime() - d.getStartTime()) * (a.stream.bandwidth || 0)) / 8);
      if (!e) return !1;
      (d = d.initSegmentReference) && (e += d.getSize() || 0);
      d = this.playerInterface_.getBandwidthEstimate();
      return (8 * e) / d < (c || 0) - b - Math.max(this.manifest_.minBufferTime || 0, this.config_.rebufferingGoal) ||
        a.operation.getBytesRemaining() > e
        ? !0
        : !1;
    };
    shaka.media.StreamingEngine.prototype.seeked = function () {
      for (
        var a = this.playerInterface_.getPresentationTime(),
          b = this.config_.smallGapLimit,
          c = shaka.util.ManifestParserUtils.ContentType,
          d = !1,
          e = $jscomp.makeIterator(this.mediaStates_.keys()),
          f = e.next();
        !f.done;
        f = e.next()
      ) {
        f = f.value;
        var g = this.mediaStates_.get(f),
          h = shaka.media.StreamingEngine.logPrefix_(g);
        this.playerInterface_.mediaSourceEngine.isBuffered(f, a, b) ||
          (null != this.playerInterface_.mediaSourceEngine.bufferEnd(f) && (this.forceClearBuffer_(g), (d = !0)),
          g.operation &&
            (g.operation.abort(), shaka.log.debug(h, 'Aborting operation due to seek'), (g.operation = null)),
          f === c.TEXT && this.playerInterface_.mediaSourceEngine.resetCaptionParser());
      }
      d || shaka.log.debug('(all): seeked: buffered seek: presentationTime=' + a);
    };
    shaka.media.StreamingEngine.prototype.forceClearBuffer_ = function (a) {
      var b = this,
        c = shaka.media.StreamingEngine.logPrefix_(a);
      a.clearingBuffer
        ? shaka.log.debug(c, 'clear: already clearing the buffer')
        : a.waitingToClearBuffer
        ? shaka.log.debug(c, 'clear: already waiting')
        : a.performingUpdate
        ? (shaka.log.debug(c, 'clear: currently updating'),
          (a.waitingToClearBuffer = !0),
          (a.clearBufferSafeMargin = 0))
        : null == this.playerInterface_.mediaSourceEngine.bufferStart(a.type)
        ? (shaka.log.debug(c, 'clear: nothing buffered'), null == a.updateTimer && this.scheduleUpdate_(a, 0))
        : (shaka.log.debug(c, 'clear: handling right now'),
          this.cancelUpdate_(a),
          this.clearBuffer_(a, !1, 0)['catch'](function (d) {
            b.playerInterface_ &&
              (goog.asserts.assert(d instanceof shaka.util.Error, 'Wrong error type!'), b.playerInterface_.onError(d));
          }));
    };
    shaka.media.StreamingEngine.prototype.initStreams_ = function () {
      var a = this,
        b,
        c,
        d,
        e,
        f,
        g,
        h,
        k,
        l,
        m;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (n) {
        if (1 == n.nextAddress) {
          b = shaka.util.ManifestParserUtils.ContentType;
          goog.asserts.assert(a.config_, 'StreamingEngine configure() must be called before init()!');
          if (!a.currentVariant_)
            throw (
              (shaka.log.error('init: no Streams chosen'),
              new shaka.util.Error(
                shaka.util.Error.Severity.CRITICAL,
                shaka.util.Error.Category.STREAMING,
                shaka.util.Error.Code.STREAMING_ENGINE_STARTUP_INVALID_STATE,
              ))
            );
          c = new Map();
          d = new Set();
          a.currentVariant_.audio && (c.set(b.AUDIO, a.currentVariant_.audio), d.add(a.currentVariant_.audio));
          a.currentVariant_.video && (c.set(b.VIDEO, a.currentVariant_.video), d.add(a.currentVariant_.video));
          a.currentTextStream_ && (c.set(b.TEXT, a.currentTextStream_), d.add(a.currentTextStream_));
          e = a.playerInterface_.mediaSourceEngine;
          f = a.config_.forceTransmuxTS;
          return n.yield(e.init(c, f), 2);
        }
        a.destroyer_.ensureNotDestroyed();
        a.setDuration_();
        g = $jscomp.makeIterator(c.keys());
        for (h = g.next(); !h.done; h = g.next())
          (k = h.value),
            (l = c.get(k)),
            a.mediaStates_.has(k) || ((m = a.createMediaState_(l)), a.mediaStates_.set(k, m), a.scheduleUpdate_(m, 0));
        n.jumpToEnd();
      });
    };
    shaka.media.StreamingEngine.prototype.createMediaState_ = function (a) {
      var b = a.segmentIndex ? a.segmentIndex[Symbol.iterator]() : null;
      return {
        stream: a,
        type: a.type,
        lastStream: null,
        segmentIterator: b,
        lastSegmentReference: null,
        lastInitSegmentReference: null,
        lastTimestampOffset: null,
        lastAppendWindowStart: null,
        lastAppendWindowEnd: null,
        restoreStreamAfterTrickPlay: null,
        endOfStream: !1,
        performingUpdate: !1,
        updateTimer: null,
        waitingToClearBuffer: !1,
        clearBufferSafeMargin: 0,
        waitingToFlushBuffer: !1,
        clearingBuffer: !1,
        recovering: !1,
        hasError: !1,
        operation: null,
      };
    };
    shaka.media.StreamingEngine.prototype.setDuration_ = function () {
      var a = this.manifest_.presentationTimeline.getDuration();
      Infinity > a
        ? this.playerInterface_.mediaSourceEngine.setDuration(a)
        : this.playerInterface_.mediaSourceEngine.setDuration(Math.pow(2, 32));
    };
    shaka.media.StreamingEngine.prototype.onUpdate_ = function (a) {
      var b = this,
        c,
        d,
        e,
        f,
        g;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (h) {
        switch (h.nextAddress) {
          case 1:
            b.destroyer_.ensureNotDestroyed();
            c = shaka.media.StreamingEngine.logPrefix_(a);
            goog.asserts.assert(!a.performingUpdate && null != a.updateTimer, c + ' unexpected call to onUpdate_()');
            if (a.performingUpdate || null == a.updateTimer) return h['return']();
            goog.asserts.assert(!a.clearingBuffer, c + ' onUpdate_() should not be called when clearing the buffer');
            if (a.clearingBuffer) return h['return']();
            a.updateTimer = null;
            if (!a.waitingToClearBuffer) {
              h.jumpTo(2);
              break;
            }
            shaka.log.debug(c, 'skipping update and clearing the buffer');
            return h.yield(b.clearBuffer_(a, a.waitingToFlushBuffer, a.clearBufferSafeMargin), 3);
          case 3:
            return h['return']();
          case 2:
            if (a.stream.segmentIndex) {
              h.jumpTo(4);
              break;
            }
            d = a.stream;
            return h.yield(a.stream.createSegmentIndex(), 5);
          case 5:
            if (d != a.stream) return null == a.updateTimer && b.scheduleUpdate_(a, 0), h['return']();
          case 4:
            goog.asserts.assert(a.stream.segmentIndex, 'Segment index should exist by now!');
            a.segmentIterator || (a.segmentIterator = a.stream.segmentIndex[Symbol.iterator]());
            try {
              (e = b.update_(a)), null != e && (b.scheduleUpdate_(a, e), (a.hasError = !1));
            } catch (k) {
              return b.handleStreamingError_(k), h['return']();
            }
            f = Array.from(b.mediaStates_.values());
            if (
              !b.startupComplete_ ||
              !f.every(function (k) {
                return k.endOfStream;
              })
            ) {
              h.jumpTo(0);
              break;
            }
            shaka.log.v1(c, 'calling endOfStream()...');
            return h.yield(b.playerInterface_.mediaSourceEngine.endOfStream(), 7);
          case 7:
            b.destroyer_.ensureNotDestroyed(),
              (g = b.playerInterface_.mediaSourceEngine.getDuration()),
              0 != g &&
                g < b.manifest_.presentationTimeline.getDuration() &&
                b.manifest_.presentationTimeline.setDuration(g),
              h.jumpToEnd();
        }
      });
    };
    shaka.media.StreamingEngine.prototype.update_ = function (a) {
      goog.asserts.assert(this.manifest_, 'manifest_ should not be null');
      goog.asserts.assert(this.config_, 'config_ should not be null');
      var b = shaka.util.ManifestParserUtils.ContentType;
      if (shaka.media.StreamingEngine.isEmbeddedText_(a))
        return this.playerInterface_.mediaSourceEngine.setSelectedClosedCaptionId(a.stream.originalId || ''), null;
      var c = shaka.media.StreamingEngine.logPrefix_(a),
        d = this.playerInterface_.getPresentationTime(),
        e = this.getTimeNeeded_(a, d);
      shaka.log.v2(c, 'timeNeeded=' + e);
      var f = this.playerInterface_.mediaSourceEngine.bufferedAheadOf(a.type, d);
      shaka.log.v2(c, 'update_:', 'presentationTime=' + d, 'bufferedAhead=' + f);
      var g =
        Math.max(this.manifest_.minBufferTime || 0, this.config_.rebufferingGoal, this.config_.bufferingGoal) *
        this.bufferingGoalScale_;
      if (e >= this.manifest_.presentationTimeline.getDuration())
        return (
          shaka.log.debug(c, 'buffered to end of presentation'),
          (a.endOfStream = !0),
          a.type == b.VIDEO &&
            (a = this.mediaStates_.get(b.TEXT)) &&
            shaka.media.StreamingEngine.isEmbeddedText_(a) &&
            (a.endOfStream = !0),
          null
        );
      a.endOfStream = !1;
      if (f >= g) return shaka.log.v2(c, 'buffering goal met'), 0.5;
      b = this.playerInterface_.mediaSourceEngine.bufferEnd(a.type);
      b = this.getSegmentReferenceNeeded_(a, d, b);
      if (!b || !this.isSegmentReferenceAvailable_(a, b)) return 1;
      c = Infinity;
      f = Array.from(this.mediaStates_.values());
      f = $jscomp.makeIterator(f);
      for (g = f.next(); !g.done; g = f.next())
        (g = g.value),
          shaka.media.StreamingEngine.isEmbeddedText_(g) || ((g = this.getTimeNeeded_(g, d)), (c = Math.min(c, g)));
      f =
        this.manifest_.presentationTimeline.getMaxSegmentDuration() *
        shaka.media.StreamingEngine.MAX_RUN_AHEAD_SEGMENTS_;
      if (e >= c + f) return 1;
      this.fetchAndAppend_(a, d, b)['catch'](function () {});
      return null;
    };
    shaka.media.StreamingEngine.prototype.getTimeNeeded_ = function (a, b) {
      return a.lastStream && a.lastSegmentReference ? a.lastSegmentReference.endTime : b;
    };
    shaka.media.StreamingEngine.prototype.getSegmentReferenceNeeded_ = function (a, b, c) {
      var d = shaka.media.StreamingEngine.logPrefix_(a);
      goog.asserts.assert(a.segmentIterator, 'Segment iterator should exist!');
      if (a.stream == a.lastStream) return a.segmentIterator.current();
      if (a.lastSegmentReference)
        return (
          goog.asserts.assert(a.lastStream, 'lastStream should not be null'),
          shaka.log.v1(d, 'looking up segment from new stream', 'endTime:', a.lastSegmentReference.endTime),
          (b = a.segmentIterator.seek(a.lastSegmentReference.endTime)),
          null == b && shaka.log.warning(d, 'cannot find segment', 'endTime:', a.lastSegmentReference.endTime),
          b
        );
      if (c)
        return (
          goog.asserts.assert(!a.lastStream, 'lastStream should be null'),
          shaka.log.v1(d, 'looking up segment', 'bufferEnd:', c),
          (a = a.segmentIterator.seek(c)),
          null == a && shaka.log.warning(d, 'cannot find segment', 'bufferEnd:', c),
          a
        );
      goog.asserts.assert(!a.lastStream, 'lastStream should be null');
      c = Math.max(b - this.config_.inaccurateManifestTolerance, 0);
      shaka.log.v1(d, 'looking up segment', 'lookupTime:', c, 'presentationTime:', b);
      var e = a.segmentIterator.seek(c);
      (e && this.isSegmentReferenceAvailable_(a, e)) || (e = a.segmentIterator.seek(b));
      null == e && shaka.log.warning(d, 'cannot find segment', 'lookupTime:', c, 'presentationTime:', b);
      return e;
    };
    shaka.media.StreamingEngine.prototype.isSegmentReferenceAvailable_ = function (a, b) {
      var c = shaka.media.StreamingEngine.logPrefix_(a),
        d = this.manifest_.presentationTimeline,
        e = d.getSegmentAvailabilityStart();
      d = d.getSegmentAvailabilityEnd();
      return b.endTime < e || b.startTime > d
        ? (shaka.log.v2(
            c,
            'segment is not available:',
            'reference.startTime=' + b.startTime,
            'reference.endTime=' + b.endTime,
            'availabilityStart=' + e,
            'availabilityEnd=' + d,
          ),
          !1)
        : !0;
    };
    shaka.media.StreamingEngine.prototype.fetchAndAppend_ = function (a, b, c) {
      var d = this,
        e,
        f,
        g,
        h,
        k,
        l,
        m,
        n,
        p,
        q;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (r) {
        switch (r.nextAddress) {
          case 1:
            return (
              (e = shaka.util.ManifestParserUtils.ContentType),
              (f = shaka.media.StreamingEngine),
              (g = f.logPrefix_(a)),
              shaka.log.v1(
                g,
                'fetchAndAppend_:',
                'presentationTime=' + b,
                'reference.startTime=' + c.startTime,
                'reference.endTime=' + c.endTime,
              ),
              (h = a.stream),
              (a.performingUpdate = !0),
              (k = d.initSourceBuffer_(a, c)),
              shaka.log.v2(g, 'fetching segment'),
              (l = d.fetch_(a, c)),
              r.setCatchFinallyBlocks(2),
              r.yield(Promise.all([k, l]), 4)
            );
          case 4:
            return (
              (m = r.yieldResult),
              d.destroyer_.ensureNotDestroyed(),
              d.fatalError_ ? r['return']() : r.yield(d.append_(a, b, h, c, m[1]), 5)
            );
          case 5:
            d.destroyer_.ensureNotDestroyed();
            if (d.fatalError_) return r['return']();
            a.performingUpdate = !1;
            a.recovering = !1;
            n = d.playerInterface_.mediaSourceEngine.getBufferedInfo();
            p = n[a.type];
            shaka.log.v1(g, 'finished fetch and append', JSON.stringify(p));
            if (!a.waitingToClearBuffer) d.playerInterface_.onSegmentAppended();
            d.scheduleUpdate_(a, 0);
            r.leaveTryBlock(0);
            break;
          case 2:
            q = r.enterCatchBlock();
            d.destroyer_.ensureNotDestroyed(q);
            if (d.fatalError_) return r['return']();
            goog.asserts.assert(q instanceof shaka.util.Error, 'Should only receive a Shaka error');
            a.performingUpdate = !1;
            a.type == e.TEXT && d.config_.ignoreTextStreamFailures
              ? (q.code == shaka.util.Error.Code.BAD_HTTP_STATUS
                  ? shaka.log.warning(g, 'Text stream failed to download. Proceeding without it.')
                  : shaka.log.warning(g, 'Text stream failed to parse. Proceeding without it.'),
                d.mediaStates_['delete'](e.TEXT))
              : q.code == shaka.util.Error.Code.OPERATION_ABORTED
              ? ((a.performingUpdate = !1), (a.updateTimer = null), d.scheduleUpdate_(a, 0))
              : q.code == shaka.util.Error.Code.QUOTA_EXCEEDED_ERROR
              ? d.handleQuotaExceeded_(a, q)
              : (shaka.log.error(g, 'failed fetch and append: code=' + q.code),
                (a.hasError = !0),
                (q.severity = shaka.util.Error.Severity.CRITICAL),
                d.handleStreamingError_(q));
            r.jumpToEnd();
        }
      });
    };
    shaka.media.StreamingEngine.prototype.retry = function () {
      if (this.destroyer_.destroyed())
        return shaka.log.error('Unable to retry after StreamingEngine is destroyed!'), !1;
      if (this.fatalError_)
        return shaka.log.error('Unable to retry after StreamingEngine encountered a fatal error!'), !1;
      for (var a = $jscomp.makeIterator(this.mediaStates_.values()), b = a.next(); !b.done; b = a.next()) {
        b = b.value;
        var c = shaka.media.StreamingEngine.logPrefix_(b);
        b.hasError && (shaka.log.info(c, 'Retrying after failure...'), (b.hasError = !1), this.scheduleUpdate_(b, 0.1));
      }
      return !0;
    };
    shaka.media.StreamingEngine.prototype.handleQuotaExceeded_ = function (a, b) {
      var c = shaka.media.StreamingEngine.logPrefix_(a);
      if (
        Array.from(this.mediaStates_.values()).some(function (e) {
          return e != a && e.recovering;
        })
      )
        shaka.log.debug(c, 'MediaSource threw QuotaExceededError:', 'waiting for another stream to recover...');
      else {
        var d = Math.round(100 * this.bufferingGoalScale_);
        if (20 < d) this.bufferingGoalScale_ -= 0.2;
        else if (4 < d) this.bufferingGoalScale_ -= 0.04;
        else {
          shaka.log.error(c, 'MediaSource threw QuotaExceededError too many times');
          this.fatalError_ = a.hasError = !0;
          this.playerInterface_.onError(b);
          return;
        }
        shaka.log.warning(
          c,
          'MediaSource threw QuotaExceededError:',
          'reducing buffering goals by ' + (100 - Math.round(100 * this.bufferingGoalScale_)) + '%',
        );
        a.recovering = !0;
      }
      this.scheduleUpdate_(a, 4);
    };
    shaka.media.StreamingEngine.prototype.initSourceBuffer_ = function (a, b) {
      var c = this,
        d,
        e,
        f,
        g,
        h,
        k,
        l,
        m,
        n;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (p) {
        d = shaka.media.StreamingEngine;
        e = d.logPrefix_(a);
        f = [];
        g = Math.max(0, b.appendWindowStart - d.APPEND_WINDOW_START_FUDGE_);
        h = b.appendWindowEnd + d.APPEND_WINDOW_END_FUDGE_;
        goog.asserts.assert(b.startTime <= h, e + ' segment should start before append window end');
        k = b.timestampOffset;
        if (k != a.lastTimestampOffset || g != a.lastAppendWindowStart || h != a.lastAppendWindowEnd)
          shaka.log.v1(e, 'setting timestamp offset to ' + k),
            shaka.log.v1(e, 'setting append window start to ' + g),
            shaka.log.v1(e, 'setting append window end to ' + h),
            (l = function () {
              var q;
              return $jscomp.asyncExecutePromiseGeneratorProgram(function (r) {
                if (1 == r.nextAddress)
                  return (
                    r.setCatchFinallyBlocks(2),
                    (a.lastAppendWindowStart = g),
                    (a.lastAppendWindowEnd = h),
                    (a.lastTimestampOffset = k),
                    r.yield(c.playerInterface_.mediaSourceEngine.setStreamProperties(a.type, k, g, h), 4)
                  );
                if (2 != r.nextAddress) return r.leaveTryBlock(0);
                q = r.enterCatchBlock();
                a.lastAppendWindowStart = null;
                a.lastAppendWindowEnd = null;
                a.lastTimestampOffset = null;
                throw q;
              });
            }),
            f.push(l());
        !shaka.media.InitSegmentReference.equal(b.initSegmentReference, a.lastInitSegmentReference) &&
          (a.lastInitSegmentReference = b.initSegmentReference) &&
          (shaka.log.v1(e, 'fetching init segment'),
          (m = c.fetch_(a, b.initSegmentReference)),
          (n = function () {
            var q, r, t;
            return $jscomp.asyncExecutePromiseGeneratorProgram(function (w) {
              switch (w.nextAddress) {
                case 1:
                  return w.setCatchFinallyBlocks(2), w.yield(m, 4);
                case 4:
                  return (
                    (q = w.yieldResult),
                    c.destroyer_.ensureNotDestroyed(),
                    shaka.log.v1(e, 'appending init segment'),
                    (r = a.stream.closedCaptions && 0 < a.stream.closedCaptions.size),
                    w.yield(c.playerInterface_.mediaSourceEngine.appendBuffer(a.type, q, null, null, r), 5)
                  );
                case 5:
                  w.leaveTryBlock(0);
                  break;
                case 2:
                  throw ((t = w.enterCatchBlock()), (a.lastInitSegmentReference = null), t);
              }
            });
          }),
          f.push(n()));
        return p.yield(Promise.all(f), 0);
      });
    };
    shaka.media.StreamingEngine.prototype.append_ = function (a, b, c, d, e) {
      var f = this,
        g,
        h,
        k;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (l) {
        if (1 == l.nextAddress)
          return (
            (g = shaka.media.StreamingEngine.logPrefix_(a)),
            (h = c.closedCaptions && 0 < c.closedCaptions.size),
            null != c.emsgSchemeIdUris &&
              0 < c.emsgSchemeIdUris.length &&
              new shaka.util.Mp4Parser()
                .fullBox('emsg', function (m) {
                  return f.parseEMSG_(d, c.emsgSchemeIdUris, m);
                })
                .parse(e),
            l.yield(f.evict_(a, b), 2)
          );
        if (3 != l.nextAddress)
          return (
            f.destroyer_.ensureNotDestroyed(),
            shaka.log.v1(g, 'appending media segment'),
            l.yield(f.playerInterface_.mediaSourceEngine.appendBuffer(a.type, e, d.startTime, d.endTime, h), 3)
          );
        f.destroyer_.ensureNotDestroyed();
        shaka.log.v2(g, 'appended media segment');
        a.lastStream = c;
        a.lastSegmentReference = d;
        a.stream == c && ((k = a.segmentIterator.next().value), shaka.log.v2(g, 'advancing to next segment', k));
        l.jumpToEnd();
      });
    };
    shaka.media.StreamingEngine.prototype.parseEMSG_ = function (a, b, c) {
      var d = c.reader.readTerminatedString(),
        e = c.reader.readTerminatedString(),
        f = c.reader.readUint32(),
        g = c.reader.readUint32(),
        h = c.reader.readUint32(),
        k = c.reader.readUint32();
      c = c.reader.readBytes(c.reader.getLength() - c.reader.getPosition());
      a = a.startTime + g / f;
      if (b.includes(d))
        if ('urn:mpeg:dash:event:2012' == d) this.playerInterface_.onManifestUpdate();
        else
          (b = new shaka.util.FakeEvent(shaka.Player.EventName.Emsg, {
            detail: {
              startTime: a,
              endTime: a + h / f,
              schemeIdUri: d,
              value: e,
              timescale: f,
              presentationTimeDelta: g,
              eventDuration: h,
              id: k,
              messageData: c,
            },
          })),
            this.playerInterface_.onEvent(b);
    };
    shaka.media.StreamingEngine.prototype.evict_ = function (a, b) {
      var c = this,
        d,
        e,
        f,
        g,
        h;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (k) {
        if (1 == k.nextAddress) {
          d = shaka.media.StreamingEngine.logPrefix_(a);
          shaka.log.v2(d, 'checking buffer length');
          e = Math.max(c.config_.bufferBehind, c.manifest_.presentationTimeline.getMaxSegmentDuration());
          f = c.playerInterface_.mediaSourceEngine.bufferStart(a.type);
          if (null == f)
            return (
              shaka.log.v2(
                d,
                'buffer behind okay because nothing buffered:',
                'presentationTime=' + b,
                'bufferBehind=' + e,
              ),
              k['return']()
            );
          g = b - f;
          h = g - e;
          if (0 >= h)
            return (
              shaka.log.v2(
                d,
                'buffer behind okay:',
                'presentationTime=' + b,
                'bufferedBehind=' + g,
                'bufferBehind=' + e,
                'underflow=' + -h,
              ),
              k['return']()
            );
          shaka.log.v1(
            d,
            'buffer behind too large:',
            'presentationTime=' + b,
            'bufferedBehind=' + g,
            'bufferBehind=' + e,
            'overflow=' + h,
          );
          return k.yield(c.playerInterface_.mediaSourceEngine.remove(a.type, f, f + h), 2);
        }
        c.destroyer_.ensureNotDestroyed();
        shaka.log.v1(d, 'evicted ' + h + ' seconds');
        k.jumpToEnd();
      });
    };
    shaka.media.StreamingEngine.isEmbeddedText_ = function (a) {
      var b = shaka.util.MimeUtils;
      return (
        a && a.type == shaka.util.ManifestParserUtils.ContentType.TEXT && a.stream.mimeType == b.CLOSED_CAPTION_MIMETYPE
      );
    };
    shaka.media.StreamingEngine.prototype.fetch_ = function (a, b) {
      var c = this,
        d,
        e,
        f,
        g;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (h) {
        if (1 == h.nextAddress)
          return (
            (d = shaka.net.NetworkingEngine.RequestType.SEGMENT),
            (e = shaka.util.Networking.createSegmentRequest(
              b.getUris(),
              b.startByte,
              b.endByte,
              c.config_.retryParameters,
            )),
            shaka.log.v2('fetching: reference=', b),
            (f = c.playerInterface_.netEngine.request(d, e)),
            (a.operation = f),
            h.yield(f.promise, 2)
          );
        g = h.yieldResult;
        a.operation = null;
        return h['return'](g.data);
      });
    };
    shaka.media.StreamingEngine.prototype.clearBuffer_ = function (a, b, c) {
      var d = this,
        e,
        f,
        g;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (h) {
        if (1 == h.nextAddress)
          return (
            (e = shaka.media.StreamingEngine.logPrefix_(a)),
            goog.asserts.assert(!a.performingUpdate && null == a.updateTimer, e + ' unexpected call to clearBuffer_()'),
            (a.waitingToClearBuffer = !1),
            (a.waitingToFlushBuffer = !1),
            (a.clearBufferSafeMargin = 0),
            (a.clearingBuffer = !0),
            (a.lastStream = null),
            (a.lastSegmentReference = null),
            shaka.log.debug(e, 'clearing buffer'),
            c
              ? ((f = d.playerInterface_.getPresentationTime()),
                (g = d.playerInterface_.mediaSourceEngine.getDuration()),
                h.yield(d.playerInterface_.mediaSourceEngine.remove(a.type, f + c, g), 3))
              : h.yield(d.playerInterface_.mediaSourceEngine.clear(a.type), 4)
          );
        if (3 != h.nextAddress)
          return (
            d.destroyer_.ensureNotDestroyed(),
            b ? h.yield(d.playerInterface_.mediaSourceEngine.flush(a.type), 3) : h.jumpTo(3)
          );
        d.destroyer_.ensureNotDestroyed();
        shaka.log.debug(e, 'cleared buffer');
        a.clearingBuffer = !1;
        a.endOfStream = !1;
        d.scheduleUpdate_(a, 0);
        h.jumpToEnd();
      });
    };
    shaka.media.StreamingEngine.prototype.scheduleUpdate_ = function (a, b) {
      var c = this,
        d = shaka.media.StreamingEngine.logPrefix_(a);
      shaka.log.v2(d, 'updating in ' + b + ' seconds');
      goog.asserts.assert(null == a.updateTimer, d + ' did not expect update to be scheduled');
      a.updateTimer = new shaka.util.DelayedTick(function () {
        var e;
        return $jscomp.asyncExecutePromiseGeneratorProgram(function (f) {
          if (1 == f.nextAddress) return f.setCatchFinallyBlocks(2), f.yield(c.onUpdate_(a), 4);
          if (2 != f.nextAddress) return f.leaveTryBlock(0);
          e = f.enterCatchBlock();
          if (c.playerInterface_) c.playerInterface_.onError(e);
          f.jumpToEnd();
        });
      }).tickAfter(b);
    };
    shaka.media.StreamingEngine.prototype.cancelUpdate_ = function (a) {
      null != a.updateTimer && (a.updateTimer.stop(), (a.updateTimer = null));
    };
    shaka.media.StreamingEngine.prototype.abortOperations_ = function (a) {
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (b) {
        return a.operation ? b.yield(a.operation.abort(), 0) : b.jumpTo(0);
      });
    };
    shaka.media.StreamingEngine.prototype.handleStreamingError_ = function (a) {
      var b = this;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (c) {
        if (1 == c.nextAddress) return c.yield(b.failureCallbackBackoff_.attempt(), 2);
        b.destroyer_.ensureNotDestroyed();
        b.playerInterface_.onError(a);
        a.handled || b.config_.failureCallback(a);
        c.jumpToEnd();
      });
    };
    shaka.media.StreamingEngine.logPrefix_ = function (a) {
      return '(' + a.type + ':' + a.stream.id + ')';
    };
    shaka.media.StreamingEngine.APPEND_WINDOW_START_FUDGE_ = 0.1;
    shaka.media.StreamingEngine.APPEND_WINDOW_END_FUDGE_ = 0.01;
    shaka.media.StreamingEngine.MAX_RUN_AHEAD_SEGMENTS_ = 1;
    shaka.routing = {};
    shaka.routing.Walker = function (a, b, c) {
      var d = this;
      this.implementation_ = c;
      this.currentlyAt_ = a;
      this.currentlyWith_ = b;
      this.waitForWork_ = null;
      this.requests_ = [];
      this.currentStep_ = this.currentRoute_ = null;
      this.mainLoopPromise_ = Promise.resolve().then(function () {
        return d.mainLoop_();
      });
      this.destroyer_ = new shaka.util.Destroyer(function () {
        return d.doDestroy_();
      });
    };
    shaka.routing.Walker.prototype.getCurrentPayload = function () {
      return this.currentlyWith_;
    };
    shaka.routing.Walker.prototype.destroy = function () {
      return this.destroyer_.destroy();
    };
    shaka.routing.Walker.prototype.doDestroy_ = function () {
      var a = this,
        b,
        c,
        d;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (e) {
        if (1 == e.nextAddress)
          return a.currentStep_ && a.currentStep_.abort(), a.unblockMainLoop_(), e.yield(a.mainLoopPromise_, 2);
        if (a.currentRoute_) a.currentRoute_.listeners.onCancel();
        b = $jscomp.makeIterator(a.requests_);
        for (c = b.next(); !c.done; c = b.next()) (d = c.value), d.listeners.onCancel();
        a.currentRoute_ = null;
        a.requests_ = [];
        a.implementation_ = null;
        e.jumpToEnd();
      });
    };
    shaka.routing.Walker.prototype.startNewRoute = function (a) {
      var b = {
        onStart: function () {},
        onEnd: function () {},
        onCancel: function () {},
        onError: function (c) {},
        onSkip: function () {},
        onEnter: function () {},
      };
      this.requests_.push({ create: a, listeners: b });
      this.currentStep_ && this.currentStep_.abort();
      this.unblockMainLoop_();
      return b;
    };
    shaka.routing.Walker.prototype.mainLoop_ = function () {
      var a = this;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (b) {
        return a.destroyer_.destroyed() ? b.jumpTo(0) : b.yield(a.doOneThing_(), 1);
      });
    };
    shaka.routing.Walker.prototype.doOneThing_ = function () {
      if (this.tryNewRoute_()) return Promise.resolve();
      if (this.currentRoute_) return this.takeNextStep_();
      goog.asserts.assert(null == this.waitForWork_, 'We should not have a promise yet.');
      this.implementation_.onIdle(this.currentlyAt_);
      return (this.waitForWork_ = new shaka.util.PublicPromise());
    };
    shaka.routing.Walker.prototype.tryNewRoute_ = function () {
      goog.asserts.assert(null == this.currentStep_, 'We should never have a current step between taking steps.');
      if (0 == this.requests_.length || (this.currentRoute_ && !this.currentRoute_.interruptible)) return !1;
      this.currentRoute_ && (this.currentRoute_.listeners.onCancel(), (this.currentRoute_ = null));
      var a = this.requests_.shift(),
        b = a.create(this.currentlyWith_);
      if (b)
        a.listeners.onStart(),
          (this.currentRoute_ = {
            node: b.node,
            payload: b.payload,
            interruptible: b.interruptible,
            listeners: a.listeners,
          });
      else a.listeners.onSkip();
      return !0;
    };
    shaka.routing.Walker.prototype.takeNextStep_ = function () {
      var a = this,
        b,
        c;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (d) {
        switch (d.nextAddress) {
          case 1:
            return (
              goog.asserts.assert(a.currentRoute_, 'We need a current route to take the next step.'),
              (a.currentlyAt_ = a.implementation_.getNext(
                a.currentlyAt_,
                a.currentlyWith_,
                a.currentRoute_.node,
                a.currentRoute_.payload,
              )),
              a.currentRoute_.listeners.onEnter(a.currentlyAt_),
              d.setCatchFinallyBlocks(2),
              (a.currentStep_ = a.implementation_.enterNode(a.currentlyAt_, a.currentlyWith_, a.currentRoute_.payload)),
              d.yield(a.currentStep_.promise, 4)
            );
          case 4:
            a.currentStep_ = null;
            a.currentlyAt_ == a.currentRoute_.node && (a.currentRoute_.listeners.onEnd(), (a.currentRoute_ = null));
            d.leaveTryBlock(0);
            break;
          case 2:
            b = d.enterCatchBlock();
            if (b.code == shaka.util.Error.Code.OPERATION_ABORTED)
              goog.asserts.assert(
                a.currentRoute_.interruptible,
                'Do not put abortable steps in non-interruptible routes!',
              ),
                a.currentRoute_.listeners.onCancel();
            else a.currentRoute_.listeners.onError(b);
            a.currentRoute_ = null;
            a.currentStep_ = null;
            c = a;
            return d.yield(a.implementation_.handleError(a.currentlyWith_, b), 5);
          case 5:
            (c.currentlyAt_ = d.yieldResult), d.jumpToEnd();
        }
      });
    };
    shaka.routing.Walker.prototype.unblockMainLoop_ = function () {
      this.waitForWork_ && (this.waitForWork_.resolve(), (this.waitForWork_ = null));
    };
    shaka.text.SimpleTextDisplayer = function (a) {
      this.textTrack_ = null;
      for (var b = $jscomp.makeIterator(Array.from(a.textTracks)), c = b.next(); !c.done; c = b.next())
        (c = c.value), (c.mode = 'disabled'), c.label == shaka.Player.TextTrackLabel && (this.textTrack_ = c);
      this.textTrack_ || (this.textTrack_ = a.addTextTrack('subtitles', shaka.Player.TextTrackLabel));
      this.textTrack_.mode = 'hidden';
    };
    shaka.text.SimpleTextDisplayer.prototype.remove = function (a, b) {
      if (!this.textTrack_) return !1;
      shaka.text.SimpleTextDisplayer.removeWhere_(this.textTrack_, function (c) {
        return c.startTime < b && c.endTime > a;
      });
      return !0;
    };
    shaka.text.SimpleTextDisplayer.prototype.append = function (a) {
      var b = a.map(function (f) {
          if (f.nestedCues.length) {
            var g = f.nestedCues
              .map(function (h) {
                return h.spacer ? '\n' : h.payload + ' ';
              })
              .join('')
              .replace(/ $/m, '');
            f = f.clone();
            f.nestedCues = [];
            f.payload = g;
            return f;
          }
          return f;
        }),
        c = [];
      a = this.textTrack_.cues ? Array.from(this.textTrack_.cues) : [];
      var d = {};
      b = $jscomp.makeIterator(b);
      for (var e = b.next(); !e.done; d = { $jscomp$loop$prop$inCue$530: d.$jscomp$loop$prop$inCue$530 }, e = b.next())
        (d.$jscomp$loop$prop$inCue$530 = e.value),
          a.some(
            (function (f) {
              return function (g) {
                return g.startTime == f.$jscomp$loop$prop$inCue$530.startTime &&
                  g.endTime == f.$jscomp$loop$prop$inCue$530.endTime &&
                  g.text == f.$jscomp$loop$prop$inCue$530.payload
                  ? !0
                  : !1;
              };
            })(d),
          ) ||
            ((e = shaka.text.SimpleTextDisplayer.convertToTextTrackCue_(d.$jscomp$loop$prop$inCue$530)) && c.push(e));
      a = c.slice().sort(function (f, g) {
        return f.startTime != g.startTime
          ? f.startTime - g.startTime
          : f.endTime != g.endTime
          ? f.endTime - g.startTime
          : 'line' in VTTCue.prototype
          ? c.indexOf(g) - c.indexOf(f)
          : c.indexOf(f) - c.indexOf(g);
      });
      a = $jscomp.makeIterator(a);
      for (d = a.next(); !d.done; d = a.next()) this.textTrack_.addCue(d.value);
    };
    shaka.text.SimpleTextDisplayer.prototype.destroy = function () {
      this.textTrack_ &&
        (shaka.text.SimpleTextDisplayer.removeWhere_(this.textTrack_, function (a) {
          return !0;
        }),
        (this.textTrack_.mode = 'disabled'));
      this.textTrack_ = null;
      return Promise.resolve();
    };
    shaka.text.SimpleTextDisplayer.prototype.isTextVisible = function () {
      return 'showing' == this.textTrack_.mode;
    };
    shaka.text.SimpleTextDisplayer.prototype.setTextVisibility = function (a) {
      this.textTrack_.mode = a ? 'showing' : 'hidden';
    };
    shaka.text.SimpleTextDisplayer.convertToTextTrackCue_ = function (a) {
      if (a.startTime >= a.endTime)
        return shaka.log.warning('Invalid cue times: ' + a.startTime + ' - ' + a.endTime), null;
      var b = shaka.text.Cue,
        c = new VTTCue(a.startTime, a.endTime, a.payload);
      c.lineAlign = a.lineAlign;
      c.positionAlign = a.positionAlign;
      a.size && (c.size = a.size);
      try {
        c.align = a.textAlign;
      } catch (d) {}
      'center' == a.textAlign && 'center' != c.align && (c.align = 'middle');
      a.writingMode == b.writingMode.VERTICAL_LEFT_TO_RIGHT
        ? (c.vertical = 'lr')
        : a.writingMode == b.writingMode.VERTICAL_RIGHT_TO_LEFT && (c.vertical = 'rl');
      a.lineInterpretation == b.lineInterpretation.PERCENTAGE && (c.snapToLines = !1);
      null != a.line && (c.line = a.line);
      null != a.position && (c.position = a.position);
      return c;
    };
    shaka.text.SimpleTextDisplayer.removeWhere_ = function (a, b) {
      var c = a.mode,
        d = 'showing' == c ? 'showing' : 'hidden';
      a.mode = d;
      goog.asserts.assert(a.cues, 'Cues should be accessible when mode is set to "' + d + '".');
      d = $jscomp.makeIterator(Array.from(a.cues));
      for (var e = d.next(); !e.done; e = d.next()) (e = e.value) && b(e) && a.removeCue(e);
      a.mode = c;
    };
    goog.exportSymbol('shaka.text.SimpleTextDisplayer', shaka.text.SimpleTextDisplayer);
    goog.exportProperty(
      shaka.text.SimpleTextDisplayer.prototype,
      'setTextVisibility',
      shaka.text.SimpleTextDisplayer.prototype.setTextVisibility,
    );
    goog.exportProperty(
      shaka.text.SimpleTextDisplayer.prototype,
      'isTextVisible',
      shaka.text.SimpleTextDisplayer.prototype.isTextVisible,
    );
    goog.exportProperty(
      shaka.text.SimpleTextDisplayer.prototype,
      'destroy',
      shaka.text.SimpleTextDisplayer.prototype.destroy,
    );
    goog.exportProperty(
      shaka.text.SimpleTextDisplayer.prototype,
      'append',
      shaka.text.SimpleTextDisplayer.prototype.append,
    );
    goog.exportProperty(
      shaka.text.SimpleTextDisplayer.prototype,
      'remove',
      shaka.text.SimpleTextDisplayer.prototype.remove,
    );
    shaka.util.Dom = function () {};
    shaka.util.Dom.createHTMLElement = function (a) {
      return document.createElement(a);
    };
    shaka.util.Dom.createButton = function () {
      return document.createElement('button');
    };
    shaka.util.Dom.asHTMLElement = function (a) {
      return a;
    };
    shaka.util.Dom.asHTMLMediaElement = function (a) {
      return a;
    };
    shaka.util.Dom.getElementByClassName = function (a, b) {
      var c = b.getElementsByClassName(a);
      goog.asserts.assert(1 == c.length, 'Should only be one element with class name ' + a);
      return shaka.util.Dom.asHTMLElement(c[0]);
    };
    shaka.util.Dom.removeAllChildren = function (a) {
      for (; a.firstChild; ) a.removeChild(a.firstChild);
    };
    goog.exportSymbol('shaka.util.Dom', shaka.util.Dom);
    goog.exportProperty(shaka.util.Dom, 'removeAllChildren', shaka.util.Dom.removeAllChildren);
    shaka.text.UITextDisplayer = function (a, b) {
      var c = this;
      goog.asserts.assert(b, 'videoContainer should be valid.');
      this.isTextVisible_ = !1;
      this.cues_ = [];
      this.video_ = a;
      this.videoContainer_ = b;
      this.textContainer_ = shaka.util.Dom.createHTMLElement('div');
      this.textContainer_.classList.add('shaka-text-container');
      this.textContainer_.style.textAlign = 'center';
      this.textContainer_.style.display = 'flex';
      this.textContainer_.style.flexDirection = 'column';
      this.textContainer_.style.alignItems = 'center';
      this.textContainer_.style.justifyContent = 'flex-end';
      this.videoContainer_.appendChild(this.textContainer_);
      this.captionsTimer_ = new shaka.util.Timer(function () {
        c.updateCaptions_();
      }).tickEvery(0.25);
      this.currentCuesMap_ = new Map();
    };
    shaka.text.UITextDisplayer.prototype.append = function (a) {
      var b = {};
      a = $jscomp.makeIterator(a);
      for (var c = a.next(); !c.done; b = { $jscomp$loop$prop$cue$532: b.$jscomp$loop$prop$cue$532 }, c = a.next())
        (b.$jscomp$loop$prop$cue$532 = c.value),
          this.cues_.some(
            (function (d) {
              return function (e) {
                return shaka.text.Cue.equal(e, d.$jscomp$loop$prop$cue$532);
              };
            })(b),
          ) || this.cues_.push(b.$jscomp$loop$prop$cue$532);
      this.updateCaptions_();
    };
    shaka.text.UITextDisplayer.prototype.destroy = function () {
      this.videoContainer_.removeChild(this.textContainer_);
      this.textContainer_ = null;
      this.isTextVisible_ = !1;
      this.cues_ = [];
      this.captionsTimer_ && this.captionsTimer_.stop();
      this.currentCuesMap_.clear();
    };
    shaka.text.UITextDisplayer.prototype.remove = function (a, b) {
      if (!this.textContainer_) return !1;
      this.cues_ = this.cues_.filter(function (c) {
        return c.startTime < a || c.endTime >= b;
      });
      this.updateCaptions_();
      return !0;
    };
    shaka.text.UITextDisplayer.prototype.isTextVisible = function () {
      return this.isTextVisible_;
    };
    shaka.text.UITextDisplayer.prototype.setTextVisibility = function (a) {
      this.isTextVisible_ = a;
    };
    shaka.text.UITextDisplayer.prototype.updateCaptions_ = function () {
      for (
        var a = this,
          b = this.video_.currentTime,
          c = function (g) {
            return a.cues_.includes(g) && a.isTextVisible_ && g.startTime <= b && g.endTime >= b;
          },
          d = $jscomp.makeIterator(this.currentCuesMap_.keys()),
          e = d.next();
        !e.done;
        e = d.next()
      )
        if (((e = e.value), !c(e))) {
          var f = this.currentCuesMap_.get(e);
          this.textContainer_.removeChild(f);
          this.currentCuesMap_['delete'](e);
        }
      d = new Set(this.currentCuesMap_.values());
      e = $jscomp.makeIterator(Array.from(this.textContainer_.childNodes));
      for (f = e.next(); !f.done; f = e.next()) (f = f.value), d.has(f) || this.textContainer_.removeChild(f);
      d = this.cues_
        .filter(function (g) {
          return c(g) && !a.currentCuesMap_.has(g);
        })
        .sort(function (g, h) {
          return g.startTime != h.startTime ? g.startTime - h.startTime : g.endTime - h.endTime;
        });
      d = $jscomp.makeIterator(d);
      for (e = d.next(); !e.done; e = d.next()) this.displayCue_(this.textContainer_, e.value);
    };
    shaka.text.UITextDisplayer.prototype.displayLeafCue_ = function (a, b, c) {
      var d = shaka.util.Dom.createHTMLElement('span');
      c && d.classList.add('shaka-nested-cue');
      b.spacer ? (d.style.display = 'block') : this.setCaptionStyles_(d, b, !0);
      a.appendChild(d);
      return d;
    };
    shaka.text.UITextDisplayer.prototype.displayCue_ = function (a, b) {
      if (b.nestedCues.length) {
        var c = shaka.util.Dom.createHTMLElement('p');
        c.style.width = '100%';
        this.setCaptionStyles_(c, b, !1);
        for (var d = 0; d < b.nestedCues.length; d++) this.displayLeafCue_(c, b.nestedCues[d], !0);
        a.appendChild(c);
        this.currentCuesMap_.set(b, c);
      } else this.currentCuesMap_.set(b, this.displayLeafCue_(a, b, !1));
    };
    shaka.text.UITextDisplayer.prototype.setCaptionStyles_ = function (a, b, c) {
      var d = shaka.text.Cue,
        e = a.style;
      e.whiteSpace = 'pre-line';
      a.innerHTML = b.payload; // TODO use .innerHTML instead of .textContent since we want to preserve the HTML tags
      c && (e.backgroundColor = b.backgroundColor);
      e.border = b.border;
      e.color = b.color;
      e.direction = b.direction;
      e.opacity = b.opacity;
      e.paddingLeft = shaka.text.UITextDisplayer.convertLengthValue_(b.linePadding, b, this.videoContainer_);
      e.paddingRight = shaka.text.UITextDisplayer.convertLengthValue_(b.linePadding, b, this.videoContainer_);
      b.backgroundImage &&
        ((e.backgroundImage = "url('" + b.backgroundImage + "')"),
        (e.backgroundRepeat = 'no-repeat'),
        (e.backgroundSize = 'contain'),
        (e.backgroundPosition = 'center'),
        '' == b.backgroundColor && (e.backgroundColor = 'transparent'));
      if (b.backgroundImage && b.region) {
        a = shaka.text.CueRegion.units.PERCENTAGE;
        var f = b.region.widthUnits == a ? '%' : 'px';
        e.height = b.region.height + (b.region.heightUnits == a ? '%' : 'px');
        e.width = b.region.width + f;
      }
      e.justifyContent =
        b.displayAlign == d.displayAlign.BEFORE
          ? 'flex-start'
          : b.displayAlign == d.displayAlign.CENTER
          ? 'center'
          : 'flex-end';
      b.nestedCues.length &&
        ((e.display = 'flex'),
        (e.flexDirection = 'row'),
        (e.margin = '0'),
        (e.alignItems = e.justifyContent),
        (e.justifyContent = 'center'));
      c && (e.maxWidth = '100%');
      e.fontFamily = b.fontFamily;
      e.fontWeight = b.fontWeight.toString();
      e.fontStyle = b.fontStyle;
      e.letterSpacing = b.letterSpacing;
      e.fontSize = shaka.text.UITextDisplayer.convertLengthValue_(b.fontSize, b, this.videoContainer_);
      b.line
        ? b.lineInterpretation == d.lineInterpretation.PERCENTAGE &&
          ((e.position = 'absolute'),
          b.writingMode == d.writingMode.HORIZONTAL_TOP_TO_BOTTOM
            ? b.lineAlign == d.lineAlign.START
              ? (e.top = b.line + '%')
              : b.lineAlign == d.lineAlign.END && (e.bottom = b.line + '%')
            : b.writingMode == d.writingMode.VERTICAL_LEFT_TO_RIGHT
            ? b.lineAlign == d.lineAlign.START
              ? (e.left = b.line + '%')
              : b.lineAlign == d.lineAlign.END && (e.right = b.line + '%')
            : b.lineAlign == d.lineAlign.START
            ? (e.right = b.line + '%')
            : b.lineAlign == d.lineAlign.END && (e.left = b.line + '%'))
        : b.region &&
          b.region.id &&
          !c &&
          ((c = shaka.text.CueRegion.units.PERCENTAGE),
          (a = b.region.widthUnits == c ? '%' : 'px'),
          (f = b.region.viewportAnchorUnits == c ? '%' : 'px'),
          (e.height = b.region.height + (b.region.heightUnits == c ? '%' : 'px')),
          (e.width = b.region.width + a),
          (e.position = 'absolute'),
          (e.top = b.region.viewportAnchorY + f),
          (e.left = b.region.viewportAnchorX + f));
      e.lineHeight = b.lineHeight;
      b.position &&
        (b.writingMode == d.writingMode.HORIZONTAL_TOP_TO_BOTTOM
          ? (e.paddingLeft = b.position)
          : (e.paddingTop = b.position));
      b.positionAlign == d.positionAlign.LEFT
        ? (e.cssFloat = 'left')
        : b.positionAlign == d.positionAlign.RIGHT && (e.cssFloat = 'right');
      e.textAlign = b.textAlign;
      e.textDecoration = b.textDecoration.join(' ');
      e.writingMode = b.writingMode;
      b.size &&
        (b.writingMode == d.writingMode.HORIZONTAL_TOP_TO_BOTTOM
          ? (e.width = b.size + '%')
          : (e.height = b.size + '%'));
    };
    shaka.text.UITextDisplayer.getLengthValueInfo_ = function (a) {
      return (a = new RegExp(/(\d*\.?\d+)([a-z]+|%+)/).exec(a)) ? { value: Number(a[1]), unit: a[2] } : null;
    };
    shaka.text.UITextDisplayer.convertLengthValue_ = function (a, b, c) {
      var d = shaka.text.UITextDisplayer.getLengthValueInfo_(a);
      if (!d) return a;
      var e = d.value;
      switch (d.unit) {
        case '%':
          return shaka.text.UITextDisplayer.getAbsoluteLengthInPixels_(e / 100, b, c);
        case 'c':
          return shaka.text.UITextDisplayer.getAbsoluteLengthInPixels_(e, b, c);
        default:
          return a;
      }
    };
    shaka.text.UITextDisplayer.getAbsoluteLengthInPixels_ = function (a, b, c) {
      return (c.clientHeight * a) / b.cellResolution.rows + 'px';
    };
    goog.exportSymbol('shaka.text.UITextDisplayer', shaka.text.UITextDisplayer);
    goog.exportProperty(
      shaka.text.UITextDisplayer.prototype,
      'setTextVisibility',
      shaka.text.UITextDisplayer.prototype.setTextVisibility,
    );
    goog.exportProperty(
      shaka.text.UITextDisplayer.prototype,
      'isTextVisible',
      shaka.text.UITextDisplayer.prototype.isTextVisible,
    );
    goog.exportProperty(shaka.text.UITextDisplayer.prototype, 'remove', shaka.text.UITextDisplayer.prototype.remove);
    goog.exportProperty(shaka.text.UITextDisplayer.prototype, 'destroy', shaka.text.UITextDisplayer.prototype.destroy);
    goog.exportProperty(shaka.text.UITextDisplayer.prototype, 'append', shaka.text.UITextDisplayer.prototype.append);
    shaka.util.ConfigUtils = function () {};
    shaka.util.ConfigUtils.mergeConfigObjects = function (a, b, c, d, e) {
      goog.asserts.assert(a, 'Destination config must not be null!');
      var f = e in d,
        g = !0,
        h;
      for (h in b) {
        var k = e + '.' + h,
          l = f ? d[e] : c[h];
        f || h in c
          ? void 0 === b[h]
            ? void 0 === l || f
              ? delete a[h]
              : (a[h] = shaka.util.ObjectUtils.cloneObject(l))
            : l.constructor == Object && b[h] && b[h].constructor == Object
            ? (a[h] || (a[h] = shaka.util.ObjectUtils.cloneObject(l)),
              (k = shaka.util.ConfigUtils.mergeConfigObjects(a[h], b[h], l, d, k)),
              (g = g && k))
            : typeof b[h] != typeof l ||
              null == b[h] ||
              ('function' != typeof b[h] && b[h].constructor != l.constructor)
            ? (shaka.log.alwaysError('Invalid config, wrong type for ' + k), (g = !1))
            : ('function' == typeof c[h] &&
                c[h].length != b[h].length &&
                shaka.log.alwaysWarn('Unexpected number of arguments for ' + k),
              (a[h] = b[h]))
          : (shaka.log.alwaysError('Invalid config, unrecognized key ' + k), (g = !1));
      }
      return g;
    };
    shaka.util.ConfigUtils.convertToConfigObject = function (a, b) {
      for (var c = {}, d = c, e = 0, f = 0; ; ) {
        e = a.indexOf('.', e);
        if (0 > e) break;
        if (0 == e || '\\' != a[e - 1])
          (f = a.substring(f, e).replace(/\\\./g, '.')), (d[f] = {}), (d = d[f]), (f = e + 1);
        e += 1;
      }
      d[a.substring(f).replace(/\\\./g, '.')] = b;
      return c;
    };
    goog.exportSymbol('shaka.util.ConfigUtils', shaka.util.ConfigUtils);
    goog.exportProperty(shaka.util.ConfigUtils, 'convertToConfigObject', shaka.util.ConfigUtils.convertToConfigObject);
    goog.exportProperty(shaka.util.ConfigUtils, 'mergeConfigObjects', shaka.util.ConfigUtils.mergeConfigObjects);
    shaka.util.PlayerConfiguration = function () {};
    shaka.util.PlayerConfiguration.createDefault = function () {
      var a = 1e6,
        b = Infinity;
      navigator.connection &&
        (navigator.connection.downlink && (a = 1e6 * navigator.connection.downlink),
        navigator.connection.saveData && (b = 360));
      var c = {
          retryParameters: shaka.net.NetworkingEngine.defaultRetryParameters(),
          servers: {},
          clearKeys: {},
          advanced: {},
          delayLicenseRequestUntilPlayed: !1,
          initDataTransform: shaka.media.DrmEngine.defaultInitDataTransform,
          logLicenseExchange: !1,
          updateExpirationTime: 1,
        },
        d = {
          retryParameters: shaka.net.NetworkingEngine.defaultRetryParameters(),
          availabilityWindowOverride: NaN,
          disableAudio: !1,
          disableVideo: !1,
          disableText: !1,
          defaultPresentationDelay: 0,
          dash: {
            clockSyncUri: '',
            ignoreDrmInfo: !1,
            xlinkFailGracefully: !1,
            ignoreMinBufferTime: !1,
            autoCorrectDrift: !0,
            initialSegmentLimit: 1e3,
            ignoreSuggestedPresentationDelay: !1,
            ignoreEmptyAdaptationSet: !1,
          },
          hls: { ignoreTextStreamFailures: !1, useFullSegmentsForStartTime: !1 },
        },
        e = {
          retryParameters: shaka.net.NetworkingEngine.defaultRetryParameters(),
          failureCallback: function (h) {
            shaka.log.error('Unhandled streaming error', h);
            return [h];
          },
          rebufferingGoal: 2,
          bufferingGoal: 10,
          bufferBehind: 30,
          ignoreTextStreamFailures: !1,
          alwaysStreamText: !1,
          startAtSegmentBoundary: !1,
          smallGapLimit: 0.5,
          jumpLargeGaps: !1,
          durationBackoff: 1,
          forceTransmuxTS: !1,
          safeSeekOffset: 5,
          stallEnabled: !0,
          stallThreshold: 1,
          stallSkip: 0.1,
          useNativeHlsOnSafari: !0,
          inaccurateManifestTolerance: 2,
        };
      if (shaka.util.Platform.isWebOS() || shaka.util.Platform.isTizen() || shaka.util.Platform.isChromecast())
        e.stallSkip = 0;
      var f = {
          trackSelectionCallback: function (h) {
            return $jscomp.asyncExecutePromiseGeneratorProgram(function (k) {
              return k['return'](h);
            });
          },
          progressCallback: function (h, k) {
            return [h, k];
          },
          usePersistentLicense: !0,
        },
        g = {
          drm: c,
          manifest: d,
          streaming: e,
          offline: f,
          abrFactory: function () {
            return new shaka.abr.SimpleAbrManager();
          },
          abr: {
            enabled: !0,
            defaultBandwidthEstimate: a,
            switchInterval: 8,
            bandwidthUpgradeTarget: 0.85,
            bandwidthDowngradeTarget: 0.95,
            restrictions: {
              minWidth: 0,
              maxWidth: Infinity,
              minHeight: 0,
              maxHeight: b,
              minPixels: 0,
              maxPixels: Infinity,
              minFrameRate: 0,
              maxFrameRate: Infinity,
              minBandwidth: 0,
              maxBandwidth: Infinity,
            },
          },
          preferredAudioLanguage: '',
          preferredTextLanguage: '',
          preferredVariantRole: '',
          preferredTextRole: '',
          preferredAudioChannelCount: 2,
          restrictions: {
            minWidth: 0,
            maxWidth: Infinity,
            minHeight: 0,
            maxHeight: Infinity,
            minPixels: 0,
            maxPixels: Infinity,
            minFrameRate: 0,
            maxFrameRate: Infinity,
            minBandwidth: 0,
            maxBandwidth: Infinity,
          },
          playRangeStart: 0,
          playRangeEnd: Infinity,
          textDisplayFactory: function () {
            return null;
          },
        };
      f.trackSelectionCallback = function (h) {
        return $jscomp.asyncExecutePromiseGeneratorProgram(function (k) {
          return k['return'](shaka.util.PlayerConfiguration.defaultTrackSelect(h, g.preferredAudioLanguage));
        });
      };
      return g;
    };
    shaka.util.PlayerConfiguration.mergeConfigObjects = function (a, b, c) {
      var d = {
        '.drm.servers': '',
        '.drm.clearKeys': '',
        '.drm.advanced': {
          distinctiveIdentifierRequired: !1,
          persistentStateRequired: !1,
          videoRobustness: '',
          audioRobustness: '',
          serverCertificate: new Uint8Array(0),
          individualizationServer: '',
        },
      };
      return shaka.util.ConfigUtils.mergeConfigObjects(
        a,
        b,
        c || shaka.util.PlayerConfiguration.createDefault(),
        d,
        '',
      );
    };
    shaka.util.PlayerConfiguration.defaultTrackSelect = function (a, b) {
      var c = shaka.util.ManifestParserUtils.ContentType,
        d = shaka.util.LanguageUtils,
        e = a.filter(function (l) {
          return 'variant' == l.type;
        }),
        f = [],
        g = d.findClosestLocale(
          b,
          e.map(function (l) {
            return l.language;
          }),
        );
      g &&
        (f = e.filter(function (l) {
          return d.normalize(l.language) == g;
        }));
      0 == f.length &&
        (f = e.filter(function (l) {
          return l.primary;
        }));
      0 == f.length &&
        (1 <
          new Set(
            e.map(function (l) {
              return l.language;
            }),
          ).size &&
          shaka.log.warning(
            'Could not choose a good audio track based on language preferences or primary tracks.  An arbitrary language will be stored!',
          ),
        (f = e));
      var h = f.filter(function (l) {
        return l.height && 480 >= l.height;
      });
      h.length &&
        (h.sort(function (l, m) {
          goog.asserts.assert(null != l.height, 'Null height');
          goog.asserts.assert(null != m.height, 'Null height');
          return m.height - l.height;
        }),
        (f = h.filter(function (l) {
          return l.height == h[0].height;
        })));
      e = [];
      if (f.length) {
        var k = Math.floor(f.length / 2);
        f.sort(function (l, m) {
          return l.bandwidth - m.bandwidth;
        });
        e.push(f[k]);
      }
      f = $jscomp.makeIterator(a);
      for (k = f.next(); !k.done; k = f.next()) (k = k.value), k.type == c.TEXT && e.push(k);
      return e;
    };
    goog.exportSymbol('shaka.util.PlayerConfiguration', shaka.util.PlayerConfiguration);
    goog.exportProperty(
      shaka.util.PlayerConfiguration,
      'mergeConfigObjects',
      shaka.util.PlayerConfiguration.mergeConfigObjects,
    );
    shaka.util.StateHistory = function () {
      this.open_ = null;
      this.closed_ = [];
    };
    shaka.util.StateHistory.prototype.update = function (a) {
      null == this.open_ ? this.start_(a) : this.update_(a);
    };
    shaka.util.StateHistory.prototype.getTimeSpentIn = function (a) {
      var b = 0;
      this.open_ && this.open_.state == a && (b += this.open_.duration);
      for (var c = $jscomp.makeIterator(this.closed_), d = c.next(); !d.done; d = c.next())
        (d = d.value), (b += d.state == a ? d.duration : 0);
      return b;
    };
    shaka.util.StateHistory.prototype.getCopy = function () {
      for (
        var a = function (e) {
            return { timestamp: e.timestamp, state: e.state, duration: e.duration };
          },
          b = [],
          c = $jscomp.makeIterator(this.closed_),
          d = c.next();
        !d.done;
        d = c.next()
      )
        b.push(a(d.value));
      this.open_ && b.push(a(this.open_));
      return b;
    };
    shaka.util.StateHistory.prototype.start_ = function (a) {
      goog.asserts.assert(null == this.open_, 'There must be no open entry in order when we start');
      shaka.log.v1('Changing Player state to', a);
      this.open_ = { timestamp: this.getNowInSeconds_(), state: a, duration: 0 };
    };
    shaka.util.StateHistory.prototype.update_ = function (a) {
      goog.asserts.assert(this.open_, 'There must be an open entry in order to update it');
      var b = this.getNowInSeconds_();
      this.open_.duration = b - this.open_.timestamp;
      this.open_.state != a &&
        (shaka.log.v1('Changing Player state to', a),
        this.closed_.push(this.open_),
        (this.open_ = { timestamp: b, state: a, duration: 0 }));
    };
    shaka.util.StateHistory.prototype.getNowInSeconds_ = function () {
      return Date.now() / 1e3;
    };
    shaka.util.SwitchHistory = function () {
      this.currentText_ = this.currentVariant_ = null;
      this.history_ = [];
    };
    shaka.util.SwitchHistory.prototype.updateCurrentVariant = function (a, b) {
      this.currentVariant_ != a &&
        ((this.currentVariant_ = a),
        this.history_.push({
          timestamp: this.getNowInSeconds_(),
          id: a.id,
          type: 'variant',
          fromAdaptation: b,
          bandwidth: a.bandwidth,
        }));
    };
    shaka.util.SwitchHistory.prototype.updateCurrentText = function (a, b) {
      this.currentText_ != a &&
        ((this.currentText_ = a),
        this.history_.push({
          timestamp: this.getNowInSeconds_(),
          id: a.id,
          type: 'text',
          fromAdaptation: b,
          bandwidth: null,
        }));
    };
    shaka.util.SwitchHistory.prototype.getCopy = function () {
      for (var a = [], b = $jscomp.makeIterator(this.history_), c = b.next(); !c.done; c = b.next())
        a.push(this.clone_(c.value));
      return a;
    };
    shaka.util.SwitchHistory.prototype.getNowInSeconds_ = function () {
      return Date.now() / 1e3;
    };
    shaka.util.SwitchHistory.prototype.clone_ = function (a) {
      return {
        timestamp: a.timestamp,
        id: a.id,
        type: a.type,
        fromAdaptation: a.fromAdaptation,
        bandwidth: a.bandwidth,
      };
    };
    shaka.util.Stats = function () {
      this.bandwidthEstimate_ = this.currentStreamBandwidth_ = this.maxSegmentDurationSeconds_ = this.liveLatencySeconds_ = this.licenseTimeSeconds_ = this.drmTimeSeconds_ = this.manifestTimeSeconds_ = this.loadLatencySeconds_ = this.totalCorruptedFrames_ = this.totalDecodedFrames_ = this.totalDroppedFrames_ = this.height_ = this.width_ = NaN;
      this.stateHistory_ = new shaka.util.StateHistory();
      this.switchHistory_ = new shaka.util.SwitchHistory();
    };
    shaka.util.Stats.prototype.setDroppedFrames = function (a, b) {
      this.totalDroppedFrames_ = a;
      this.totalDecodedFrames_ = b;
    };
    shaka.util.Stats.prototype.setCorruptedFrames = function (a) {
      this.totalCorruptedFrames_ = a;
    };
    shaka.util.Stats.prototype.setResolution = function (a, b) {
      this.width_ = a;
      this.height_ = b;
    };
    shaka.util.Stats.prototype.setLoadLatency = function (a) {
      this.loadLatencySeconds_ = a;
    };
    shaka.util.Stats.prototype.setManifestTime = function (a) {
      this.manifestTimeSeconds_ = a;
    };
    shaka.util.Stats.prototype.setDrmTime = function (a) {
      this.drmTimeSeconds_ = a;
    };
    shaka.util.Stats.prototype.setLicenseTime = function (a) {
      this.licenseTimeSeconds_ = a;
    };
    shaka.util.Stats.prototype.setLiveLatency = function (a) {
      this.liveLatencySeconds_ = a;
    };
    shaka.util.Stats.prototype.setMaxSegmentDuration = function (a) {
      this.maxSegmentDurationSeconds_ = a;
    };
    shaka.util.Stats.prototype.setCurrentStreamBandwidth = function (a) {
      this.currentStreamBandwidth_ = a;
    };
    shaka.util.Stats.prototype.setBandwidthEstimate = function (a) {
      this.bandwidthEstimate_ = a;
    };
    shaka.util.Stats.prototype.getStateHistory = function () {
      return this.stateHistory_;
    };
    shaka.util.Stats.prototype.getSwitchHistory = function () {
      return this.switchHistory_;
    };
    shaka.util.Stats.prototype.getBlob = function () {
      return {
        width: this.width_,
        height: this.height_,
        streamBandwidth: this.currentStreamBandwidth_,
        decodedFrames: this.totalDecodedFrames_,
        droppedFrames: this.totalDroppedFrames_,
        corruptedFrames: this.totalCorruptedFrames_,
        estimatedBandwidth: this.bandwidthEstimate_,
        loadLatency: this.loadLatencySeconds_,
        manifestTimeSeconds: this.manifestTimeSeconds_,
        drmTimeSeconds: this.drmTimeSeconds_,
        playTime: this.stateHistory_.getTimeSpentIn('playing'),
        pauseTime: this.stateHistory_.getTimeSpentIn('paused'),
        bufferingTime: this.stateHistory_.getTimeSpentIn('buffering'),
        licenseTime: this.licenseTimeSeconds_,
        liveLatency: this.liveLatencySeconds_,
        maxSegmentDuration: this.maxSegmentDurationSeconds_,
        stateHistory: this.stateHistory_.getCopy(),
        switchHistory: this.switchHistory_.getCopy(),
      };
    };
    shaka.util.Stats.getEmptyBlob = function () {
      return {
        width: NaN,
        height: NaN,
        streamBandwidth: NaN,
        decodedFrames: NaN,
        droppedFrames: NaN,
        corruptedFrames: NaN,
        estimatedBandwidth: NaN,
        loadLatency: NaN,
        manifestTimeSeconds: NaN,
        drmTimeSeconds: NaN,
        playTime: NaN,
        pauseTime: NaN,
        bufferingTime: NaN,
        licenseTime: NaN,
        liveLatency: NaN,
        maxSegmentDuration: NaN,
        switchHistory: [],
        stateHistory: [],
      };
    };
    shaka.Player = function (a, b) {
      shaka.util.FakeEventTarget.call(this);
      var c = this;
      this.loadMode_ = shaka.Player.LoadMode.NOT_LOADED;
      this.videoContainer_ = this.video_ = null;
      this.isTextVisible_ = !1;
      this.eventManager_ = new shaka.util.EventManager();
      this.abrManagerFactory_ = this.abrManager_ = this.assetUri_ = this.manifest_ = this.parserFactory_ = this.parser_ = this.streamingEngine_ = this.regionTimeline_ = this.bufferObserver_ = this.bufferPoller_ = this.playRateController_ = this.playheadObservers_ = this.playhead_ = this.mediaSourceEngine_ = this.drmEngine_ = this.networkingEngine_ = null;
      this.nextExternalStreamId_ = 1e9;
      this.config_ = this.defaultConfig_();
      this.maxHwRes_ = { width: Infinity, height: Infinity };
      this.stats_ = null;
      this.currentAdaptationSetCriteria_ = new shaka.media.PreferenceBasedCriteria(
        this.config_.preferredAudioLanguage,
        this.config_.preferredVariantRole,
        this.config_.preferredAudioChannelCount,
      );
      this.currentTextLanguage_ = this.config_.preferredTextLanguage;
      this.currentTextRole_ = this.config_.preferredTextRole;
      this.cleanupOnUnload_ = [];
      b && b(this);
      this.networkingEngine_ = this.createNetworkingEngine();
      this.adManager_ = null;
      shaka.Player.adManagerFactory_ &&
        (this.adManager_ = shaka.util.Functional.callFactory(shaka.Player.adManagerFactory_));
      this.eventManager_.listen(window, 'online', function () {
        c.retryStreaming();
      });
      this.detachNode_ = { name: 'detach' };
      this.attachNode_ = { name: 'attach' };
      this.unloadNode_ = { name: 'unload' };
      this.parserNode_ = { name: 'manifest-parser' };
      this.manifestNode_ = { name: 'manifest' };
      this.mediaSourceNode_ = { name: 'media-source' };
      this.drmNode_ = { name: 'drm-engine' };
      this.loadNode_ = { name: 'load' };
      this.srcEqualsDrmNode_ = { name: 'src-equals-drm-engine' };
      this.srcEqualsNode_ = { name: 'src-equals' };
      var d = shaka.util.AbortableOperation,
        e = new Map();
      e.set(this.attachNode_, function (f, g) {
        return d.notAbortable(c.onAttach_(f, g));
      });
      e.set(this.detachNode_, function (f, g) {
        return d.notAbortable(c.onDetach_(f, g));
      });
      e.set(this.unloadNode_, function (f, g) {
        return d.notAbortable(c.onUnload_(f, g));
      });
      e.set(this.mediaSourceNode_, function (f, g) {
        var h = c.onInitializeMediaSourceEngine_(f, g);
        return d.notAbortable(h);
      });
      e.set(this.parserNode_, function (f, g) {
        var h = c.onInitializeParser_(f, g);
        return d.notAbortable(h);
      });
      e.set(this.manifestNode_, function (f, g) {
        return c.onParseManifest_(f, g);
      });
      e.set(this.drmNode_, function (f, g) {
        var h = c.onInitializeDrm_(f, g);
        return d.notAbortable(h);
      });
      e.set(this.loadNode_, function (f, g) {
        return d.notAbortable(c.onLoad_(f, g));
      });
      e.set(this.srcEqualsDrmNode_, function (f, g) {
        var h = c.onInitializeSrcEqualsDrm_(f, g);
        return d.notAbortable(h);
      });
      e.set(this.srcEqualsNode_, function (f, g) {
        return c.onSrcEquals_(f, g);
      });
      this.walker_ = new shaka.routing.Walker(this.detachNode_, shaka.Player.createEmptyPayload_(), {
        getNext: function (f, g, h, k) {
          return c.getNextStep_(f, g, h, k);
        },
        enterNode: function (f, g, h) {
          c.dispatchEvent(c.makeEvent_(shaka.Player.EventName.OnStateChange, { state: f.name }));
          return e.get(f)(g, h);
        },
        handleError: function (f, g) {
          return $jscomp.asyncExecutePromiseGeneratorProgram(function (h) {
            return 1 == h.nextAddress
              ? (shaka.log.warning('The walker saw an error:'),
                g instanceof shaka.util.Error
                  ? shaka.log.warning('Error Code:', g.code)
                  : (shaka.log.warning('Error Message:', g.message), shaka.log.warning('Error Stack:', g.stack)),
                h.yield(c.onUnload_(f, shaka.Player.createEmptyPayload_()), 2))
              : h['return'](f.mediaElement ? c.attachNode_ : c.detachNode_);
          });
        },
        onIdle: function (f) {
          c.dispatchEvent(c.makeEvent_(shaka.Player.EventName.OnStateIdle, { state: f.name }));
        },
      });
      a && this.attach(a, !0);
    };
    $jscomp.inherits(shaka.Player, shaka.util.FakeEventTarget);
    shaka.Player.prototype.makeEvent_ = function (a, b) {
      return new shaka.util.FakeEvent(a, b);
    };
    shaka.Player.prototype.destroy = function () {
      var a = this,
        b;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (c) {
        switch (c.nextAddress) {
          case 1:
            if (a.loadMode_ == shaka.Player.LoadMode.DESTROYED) return c['return']();
            a.loadMode_ = shaka.Player.LoadMode.DESTROYED;
            b = a.walker_.startNewRoute(function (d) {
              return { node: a.detachNode_, payload: shaka.Player.createEmptyPayload_(), interruptible: !1 };
            });
            return c.yield(
              new Promise(function (d) {
                b.onStart = function () {
                  shaka.log.info('Preparing to destroy walker...');
                };
                b.onEnd = function () {
                  d();
                };
                b.onCancel = function () {
                  goog.asserts.assert(!1, 'Our final detach call should never be cancelled.');
                  d();
                };
                b.onError = function () {
                  goog.asserts.assert(!1, 'Our final detach call should never see an error');
                  d();
                };
                b.onSkip = function () {
                  goog.asserts.assert(!1, 'Our final detach call should never be skipped');
                  d();
                };
              }),
              2,
            );
          case 2:
            return c.yield(a.walker_.destroy(), 3);
          case 3:
            a.eventManager_ && (a.eventManager_.release(), (a.eventManager_ = null));
            a.abrManagerFactory_ = null;
            a.abrManager_ = null;
            a.config_ = null;
            a.stats_ = null;
            a.videoContainer_ = null;
            if (!a.networkingEngine_) {
              c.jumpTo(0);
              break;
            }
            return c.yield(a.networkingEngine_.destroy(), 5);
          case 5:
            (a.networkingEngine_ = null), c.jumpToEnd();
        }
      });
    };
    shaka.Player.registerSupportPlugin = function (a, b) {
      shaka.Player.supportPlugins_[a] = b;
    };
    shaka.Player.setAdManagerFactory = function (a) {
      shaka.Player.adManagerFactory_ = a;
    };
    shaka.Player.isBrowserSupported = function () {
      if (!(window.Promise && window.Uint8Array && Array.prototype.forEach)) return !1;
      var a = shaka.util.Platform.safariVersion();
      return (a && 12 > a) || !shaka.media.DrmEngine.isBrowserSupported()
        ? !1
        : shaka.util.Platform.supportsMediaSource()
        ? !0
        : shaka.util.Platform.supportsMediaType('application/x-mpegurl');
    };
    shaka.Player.probeSupport = function () {
      var a, b, c, d, e, f;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (g) {
        if (1 == g.nextAddress)
          return (
            goog.asserts.assert(shaka.Player.isBrowserSupported(), 'Must have basic support'),
            g.yield(shaka.media.DrmEngine.probeSupport(), 2)
          );
        a = g.yieldResult;
        b = shaka.media.ManifestParser.probeSupport();
        c = shaka.media.MediaSourceEngine.probeSupport();
        d = { manifest: b, media: c, drm: a };
        e = shaka.Player.supportPlugins_;
        for (f in e) d[f] = e[f]();
        return g['return'](d);
      });
    };
    shaka.Player.prototype.attach = function (a, b) {
      b = void 0 === b ? !0 : b;
      if (this.loadMode_ == shaka.Player.LoadMode.DESTROYED) return Promise.reject(this.createAbortLoadError_());
      var c = shaka.Player.createEmptyPayload_();
      c.mediaElement = a;
      shaka.util.Platform.supportsMediaSource() || (b = !1);
      var d = b ? this.mediaSourceNode_ : this.attachNode_,
        e = this.walker_.startNewRoute(function (f) {
          return { node: d, payload: c, interruptible: !1 };
        });
      e.onStart = function () {
        return shaka.log.info('Starting attach...');
      };
      return this.wrapWalkerListenersWithPromise_(e);
    };
    shaka.Player.prototype.detach = function () {
      var a = this;
      if (this.loadMode_ == shaka.Player.LoadMode.DESTROYED) return Promise.reject(this.createAbortLoadError_());
      var b = this.walker_.startNewRoute(function (c) {
        return { node: a.detachNode_, payload: shaka.Player.createEmptyPayload_(), interruptible: !1 };
      });
      b.onStart = function () {
        return shaka.log.info('Starting detach...');
      };
      return this.wrapWalkerListenersWithPromise_(b);
    };
    shaka.Player.prototype.unload = function (a) {
      var b = this;
      a = void 0 === a ? !0 : a;
      if (this.loadMode_ == shaka.Player.LoadMode.DESTROYED) return Promise.reject(this.createAbortLoadError_());
      shaka.util.Platform.supportsMediaSource() || (a = !1);
      var c = shaka.Player.createEmptyPayload_(),
        d = this.walker_.startNewRoute(function (e) {
          var f = e.mediaElement && a ? b.mediaSourceNode_ : e.mediaElement ? b.attachNode_ : b.detachNode_;
          goog.asserts.assert(f, 'We should have picked a destination.');
          c.mediaElement = e.mediaElement;
          return { node: f, payload: c, interruptible: !1 };
        });
      d.onStart = function () {
        return shaka.log.info('Starting unload...');
      };
      return this.wrapWalkerListenersWithPromise_(d);
    };
    shaka.Player.prototype.load = function (a, b, c) {
      var d = this;
      if (this.loadMode_ == shaka.Player.LoadMode.DESTROYED) return Promise.reject(this.createAbortLoadError_());
      this.dispatchEvent(this.makeEvent_(shaka.Player.EventName.Loading));
      var e = shaka.Player.createEmptyPayload_();
      e.uri = a;
      e.startTimeOfLoad = Date.now() / 1e3;
      c && (e.mimeType = c);
      void 0 !== b && (e.startTime = b);
      var f = this.shouldUseSrcEquals_(e) ? this.srcEqualsNode_ : this.loadNode_,
        g = this.walker_.startNewRoute(function (h) {
          if (null == h.mediaElement) return null;
          e.mediaElement = h.mediaElement;
          return { node: f, payload: e, interruptible: !0 };
        });
      this.stats_ = new shaka.util.Stats();
      g.onStart = function () {
        return shaka.log.info('Starting load of ' + a + '...');
      };
      return new Promise(function (h, k) {
        g.onSkip = function () {
          return k(
            new shaka.util.Error(
              shaka.util.Error.Severity.CRITICAL,
              shaka.util.Error.Category.PLAYER,
              shaka.util.Error.Code.NO_VIDEO_ELEMENT,
            ),
          );
        };
        g.onEnd = function () {
          h();
          d.dispatchEvent(d.makeEvent_(shaka.Player.EventName.Loaded));
        };
        g.onCancel = function () {
          return k(d.createAbortLoadError_());
        };
        g.onError = function (l) {
          return k(l);
        };
      });
    };
    shaka.Player.prototype.shouldUseSrcEquals_ = function (a) {
      var b = shaka.util.Platform;
      if (!b.supportsMediaSource()) return !0;
      var c = a.mimeType,
        d = a.uri || '';
      c ||
        (c = {
          mp4: 'video/mp4',
          m4v: 'video/mp4',
          m4a: 'audio/mp4',
          webm: 'video/webm',
          weba: 'audio/webm',
          mkv: 'video/webm',
          ts: 'video/mp2t',
          ogv: 'video/ogg',
          ogg: 'audio/ogg',
          mpg: 'video/mpeg',
          mpeg: 'video/mpeg',
          m3u8: 'application/x-mpegurl',
          mp3: 'audio/mpeg',
          aac: 'audio/aac',
          flac: 'audio/flac',
          wav: 'audio/wav',
        }[shaka.media.ManifestParser.getExtension(d)]);
      if (c) {
        a = '' != (a.mediaElement || b.anyMediaElement()).canPlayType(c);
        if (!a) return !1;
        c = shaka.media.ManifestParser.isSupported(d, c);
        if (!c) return !0;
        goog.asserts.assert(a && c, 'Both native and MSE playback should be possible!');
        return b.isApple() && this.config_.streaming.useNativeHlsOnSafari;
      }
      return !1;
    };
    shaka.Player.prototype.onAttach_ = function (a, b) {
      var c = this;
      goog.asserts.assert(
        null == a.mediaElement || a.mediaElement == b.mediaElement,
        'The routing logic failed. MediaElement requirement failed.',
      );
      null == a.mediaElement &&
        ((a.mediaElement = b.mediaElement),
        this.eventManager_.listen(a.mediaElement, 'error', function (d) {
          return c.onVideoError_(d);
        }));
      this.video_ = a.mediaElement;
      return Promise.resolve();
    };
    shaka.Player.prototype.onDetach_ = function (a, b) {
      a.mediaElement && (this.eventManager_.unlisten(a.mediaElement, 'error'), (a.mediaElement = null));
      this.video_ = null;
      return Promise.resolve();
    };
    shaka.Player.prototype.onUnload_ = function (a, b) {
      var c = this,
        d,
        e,
        f,
        g,
        h,
        k,
        l,
        m,
        n;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (p) {
        switch (p.nextAddress) {
          case 1:
            return (
              c.loadMode_ != shaka.Player.LoadMode.DESTROYED && (c.loadMode_ = shaka.Player.LoadMode.NOT_LOADED),
              (d = c.cleanupOnUnload_.map(function (q) {
                return q();
              })),
              (c.cleanupOnUnload_ = []),
              p.yield(Promise.all(d), 2)
            );
          case 2:
            c.dispatchEvent(c.makeEvent_(shaka.Player.EventName.Unloading));
            a.mimeType = null;
            a.startTime = null;
            a.uri = null;
            a.mediaElement &&
              (c.eventManager_.unlisten(a.mediaElement, 'loadedmetadata'),
              c.eventManager_.unlisten(a.mediaElement, 'playing'),
              c.eventManager_.unlisten(a.mediaElement, 'pause'),
              c.eventManager_.unlisten(a.mediaElement, 'ended'),
              c.eventManager_.unlisten(a.mediaElement, 'ratechange'));
            c.playheadObservers_ && (c.playheadObservers_.release(), (c.playheadObservers_ = null));
            c.bufferPoller_ && (c.bufferPoller_.stop(), (c.bufferPoller_ = null));
            if (!c.parser_) {
              p.jumpTo(3);
              break;
            }
            return p.yield(c.parser_.stop(), 4);
          case 4:
            (c.parser_ = null), (c.parserFactory_ = null);
          case 3:
            if (!c.abrManager_) {
              p.jumpTo(5);
              break;
            }
            return p.yield(c.abrManager_.stop(), 5);
          case 5:
            if (!c.streamingEngine_) {
              p.jumpTo(7);
              break;
            }
            return p.yield(c.streamingEngine_.destroy(), 8);
          case 8:
            c.streamingEngine_ = null;
          case 7:
            c.playRateController_ && (c.playRateController_.release(), (c.playRateController_ = null));
            c.playhead_ && (c.playhead_.release(), (c.playhead_ = null));
            if (!c.mediaSourceEngine_) {
              p.jumpTo(9);
              break;
            }
            return p.yield(c.mediaSourceEngine_.destroy(), 10);
          case 10:
            c.mediaSourceEngine_ = null;
          case 9:
            if (c.adManager_) c.adManager_.onAssetUnload();
            if (!a.mediaElement || !a.mediaElement.src) {
              p.jumpTo(11);
              break;
            }
            return p.yield(
              new Promise(function (q) {
                return new shaka.util.Timer(q).tickAfter(0.1);
              }),
              12,
            );
          case 12:
            a.mediaElement.removeAttribute('src'), a.mediaElement.load();
          case 11:
            if (!c.drmEngine_) {
              p.jumpTo(13);
              break;
            }
            return p.yield(c.drmEngine_.destroy(), 14);
          case 14:
            c.drmEngine_ = null;
          case 13:
            c.assetUri_ = null;
            c.bufferObserver_ = null;
            if (c.manifest_) {
              e = $jscomp.makeIterator(c.manifest_.variants);
              for (f = e.next(); !f.done; f = e.next())
                for (g = f.value, h = $jscomp.makeIterator([g.audio, g.video]), k = h.next(); !k.done; k = h.next())
                  (l = k.value) && l.segmentIndex && l.segmentIndex.release();
              m = $jscomp.makeIterator(c.manifest_.textStreams);
              for (k = m.next(); !k.done; k = m.next()) (n = k.value), n.segmentIndex && n.segmentIndex.release();
            }
            c.manifest_ = null;
            c.stats_ = new shaka.util.Stats();
            c.lastTextFactory_ = null;
            c.updateBufferState_();
            p.jumpToEnd();
        }
      });
    };
    shaka.Player.prototype.onInitializeMediaSourceEngine_ = function (a, b) {
      var c = this,
        d,
        e,
        f,
        g;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (h) {
        if (1 == h.nextAddress)
          return (
            goog.asserts.assert(
              shaka.util.Platform.supportsMediaSource(),
              'We should not be initializing media source on a platform that does not support media source.',
            ),
            goog.asserts.assert(a.mediaElement, 'We should have a media element when initializing media source.'),
            goog.asserts.assert(
              a.mediaElement == b.mediaElement,
              '|has| and |wants| should have the same media element when initializing media source.',
            ),
            goog.asserts.assert(null == c.mediaSourceEngine_, 'We should not have a media source engine yet.'),
            (d = shaka.media.MuxJSClosedCaptionParser.isSupported()
              ? new shaka.media.MuxJSClosedCaptionParser()
              : new shaka.media.NoopCaptionParser()),
            (e = c.config_.textDisplayFactory),
            (f = shaka.util.Functional.callFactory(e)),
            (c.lastTextFactory_ = e),
            (g = c.createMediaSourceEngine(a.mediaElement, d, f, function (k, l, m) {
              c.processTimedMetadataMediaSrc_(k, l, m);
            })),
            h.yield(g.open(), 2)
          );
        c.mediaSourceEngine_ = g;
        h.jumpToEnd();
      });
    };
    shaka.Player.prototype.onInitializeParser_ = function (a, b) {
      var c = this,
        d,
        e,
        f,
        g;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (h) {
        if (1 == h.nextAddress)
          return (
            goog.asserts.assert(a.mediaElement, 'We should have a media element when initializing the parser.'),
            goog.asserts.assert(
              a.mediaElement == b.mediaElement,
              '|has| and |wants| should have the same media element when initializing the parser.',
            ),
            goog.asserts.assert(c.networkingEngine_, 'Need networking engine when initializing the parser.'),
            goog.asserts.assert(c.config_, 'Need player config when initializing the parser.'),
            (a.mimeType = b.mimeType),
            (a.uri = b.uri),
            goog.asserts.assert(a.uri, 'We should have an asset uri when initializing the parsing.'),
            (d = a.uri),
            (e = c.networkingEngine_),
            (c.assetUri_ = d),
            (f = c),
            h.yield(shaka.media.ManifestParser.getFactory(d, e, c.config_.manifest.retryParameters, a.mimeType), 2)
          );
        f.parserFactory_ = h.yieldResult;
        goog.asserts.assert(c.parserFactory_, 'Must have manifest parser');
        c.parser_ = shaka.util.Functional.callFactory(c.parserFactory_);
        g = shaka.util.ObjectUtils.cloneObject(c.config_.manifest);
        b.mediaElement && 'AUDIO' === b.mediaElement.nodeName && (g.disableVideo = !0);
        c.parser_.configure(g);
        h.jumpToEnd();
      });
    };
    shaka.Player.prototype.onParseManifest_ = function (a, b) {
      var c = this;
      goog.asserts.assert(a.mimeType == b.mimeType, '|has| and |wants| should have the same mime type when parsing.');
      goog.asserts.assert(a.uri == b.uri, '|has| and |wants| should have the same uri when parsing.');
      goog.asserts.assert(a.uri, '|has| should have a valid uri when parsing.');
      goog.asserts.assert(a.uri == this.assetUri_, '|has.uri| should match the cached asset uri.');
      goog.asserts.assert(this.networkingEngine_, 'Need networking engine to parse manifest.');
      goog.asserts.assert(this.config_, 'Need player config to parse manifest.');
      goog.asserts.assert(this.parser_, '|this.parser_| should have been set in an earlier step.');
      var d = a.uri,
        e = this.networkingEngine_;
      this.regionTimeline_ = new shaka.media.RegionTimeline(function () {
        return c.seekRange();
      });
      this.regionTimeline_.setListeners(function (h) {
        c.onRegionEvent_(shaka.Player.EventName.TimelineRegionAdded, h);
        if (c.adManager_) c.adManager_.onDashTimedMetadata(h);
      });
      var f = {
          networkingEngine: e,
          filter: function (h) {
            return $jscomp.asyncExecutePromiseGeneratorProgram(function (k) {
              return k['return'](c.filterManifest_(h));
            });
          },
          makeTextStreamsForClosedCaptions: function (h) {
            return c.makeTextStreamsForClosedCaptions_(h);
          },
          onTimelineRegionAdded: function (h) {
            return c.regionTimeline_.addRegion(h);
          },
          onEvent: function (h) {
            return c.dispatchEvent(h);
          },
          onError: function (h) {
            return c.onError_(h);
          },
        },
        g = Date.now() / 1e3;
      return new shaka.util.AbortableOperation(
        (function () {
          var h, k, l, m;
          return $jscomp.asyncExecutePromiseGeneratorProgram(function (n) {
            if (1 == n.nextAddress) return (h = c), n.yield(c.parser_.start(d, f), 2);
            h.manifest_ = n.yieldResult;
            k = c.makeEvent_(shaka.Player.EventName.ManifestParsed);
            c.dispatchEvent(k);
            if (0 == c.manifest_.variants.length)
              throw new shaka.util.Error(
                shaka.util.Error.Severity.CRITICAL,
                shaka.util.Error.Category.MANIFEST,
                shaka.util.Error.Code.NO_VARIANTS,
              );
            shaka.Player.filterForAVVariants_(c.manifest_);
            l = Date.now() / 1e3;
            m = l - g;
            c.stats_.setManifestTime(m);
            n.jumpToEnd();
          });
        })(),
        function () {
          shaka.log.info('Aborting parser step...');
          return c.parser_.stop();
        },
      );
    };
    shaka.Player.prototype.onInitializeDrm_ = function (a, b) {
      var c = this,
        d,
        e;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (f) {
        if (1 == f.nextAddress)
          return (
            goog.asserts.assert(a.mimeType == b.mimeType, 'The load graph should have ensured the mime types matched.'),
            goog.asserts.assert(a.uri == b.uri, 'The load graph should have ensured the uris matched'),
            goog.asserts.assert(c.networkingEngine_, '|onInitializeDrm_| should never be called after |destroy|'),
            goog.asserts.assert(c.config_, '|onInitializeDrm_| should never be called after |destroy|'),
            goog.asserts.assert(c.manifest_, '|this.manifest_| should have been set in an earlier step.'),
            (d = Date.now() / 1e3),
            (e = !0),
            (c.drmEngine_ = c.createDrmEngine({
              netEngine: c.networkingEngine_,
              onError: function (g) {
                c.onError_(g);
              },
              onKeyStatus: function (g) {
                c.onKeyStatus_(g);
              },
              onExpirationUpdated: function (g, h) {
                c.onExpirationUpdated_(g, h);
              },
              onEvent: function (g) {
                c.dispatchEvent(g);
                g.type == shaka.Player.EventName.DrmSessionUpdate &&
                  e &&
                  ((e = !1), (g = Date.now() / 1e3 - d), c.stats_.setDrmTime(g));
              },
            })),
            c.drmEngine_.configure(c.config_.drm),
            f.yield(c.drmEngine_.initForPlayback(c.manifest_.variants, c.manifest_.offlineSessionIds), 2)
          );
        c.filterManifest_(c.manifest_);
        f.jumpToEnd();
      });
    };
    shaka.Player.prototype.onLoad_ = function (a, b) {
      var c = this,
        d,
        e,
        f,
        g,
        h,
        k,
        l,
        m,
        n,
        p,
        q;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (r) {
        switch (r.nextAddress) {
          case 1:
            return (
              goog.asserts.assert(
                a.mimeType == b.mimeType,
                '|has| and |wants| should have the same mime type when loading.',
              ),
              goog.asserts.assert(a.uri == b.uri, '|has| and |wants| should have the same uri when loading.'),
              goog.asserts.assert(a.mediaElement, 'We should have a media element when loading.'),
              goog.asserts.assert(
                !isNaN(b.startTimeOfLoad),
                '|wants| should tell us when the load was originally requested',
              ),
              (a.startTime = b.startTime),
              (d = a.mediaElement),
              (e = a.uri),
              (c.assetUri_ = e),
              (c.playRateController_ = new shaka.media.PlayRateController({
                getRate: function () {
                  return a.mediaElement.playbackRate;
                },
                setRate: function (t) {
                  a.mediaElement.playbackRate = t;
                },
                movePlayhead: function (t) {
                  a.mediaElement.currentTime += t;
                },
              })),
              (f = function () {
                return c.updateStateHistory_();
              }),
              (g = function () {
                return c.onRateChange_();
              }),
              c.eventManager_.listen(d, 'playing', f),
              c.eventManager_.listen(d, 'pause', f),
              c.eventManager_.listen(d, 'ended', f),
              c.eventManager_.listen(d, 'ratechange', g),
              (h = c.config_.abrFactory),
              (c.abrManager_ && c.abrManagerFactory_ == h) ||
                ((c.abrManagerFactory_ = h),
                (c.abrManager_ = shaka.util.Functional.callFactory(h)),
                'function' != typeof c.abrManager_.playbackRateChanged &&
                  (shaka.Deprecate.deprecateFeature(
                    4,
                    'AbrManager',
                    'Please use an AbrManager with playbackRateChanged function.',
                  ),
                  (c.abrManager_.playbackRateChanged = function (t) {})),
                c.abrManager_.configure(c.config_.abr)),
              (c.currentAdaptationSetCriteria_ = new shaka.media.PreferenceBasedCriteria(
                c.config_.preferredAudioLanguage,
                c.config_.preferredVariantRole,
                c.config_.preferredAudioChannelCount,
              )),
              (c.currentTextLanguage_ = c.config_.preferredTextLanguage),
              shaka.Player.applyPlayRange_(
                c.manifest_.presentationTimeline,
                c.config_.playRangeStart,
                c.config_.playRangeEnd,
              ),
              r.yield(c.drmEngine_.attach(d), 2)
            );
          case 2:
            c.abrManager_.init(function (t, w, u) {
              return c.switch_(t, w, u);
            });
            c.playhead_ = c.createPlayhead(a.startTime);
            c.playheadObservers_ = c.createPlayheadObserversForMSE_();
            k = Math.max(c.manifest_.minBufferTime, c.config_.streaming.rebufferingGoal);
            c.startBufferManagement_(k);
            shaka.util.StreamUtils.chooseCodecsAndFilterManifest(c.manifest_, c.config_.preferredAudioChannelCount);
            c.streamingEngine_ = c.createStreamingEngine();
            c.streamingEngine_.configure(c.config_.streaming);
            c.loadMode_ = shaka.Player.LoadMode.MEDIA_SOURCE;
            c.dispatchEvent(c.makeEvent_(shaka.Player.EventName.Streaming));
            l = c.chooseVariant_();
            goog.asserts.assert(l, 'Must choose an initial variant!');
            c.addVariantToSwitchHistory_(l, !0);
            c.streamingEngine_.switchVariant(l, !1, 0);
            (m = c.chooseTextStream_()) && c.addTextStreamToSwitchHistory_(m, !0);
            c.setInitialTextState_(l, m);
            m && c.shouldStreamText_() && c.streamingEngine_.switchTextStream(m);
            if (!c.config_.streaming.startAtSegmentBoundary) {
              r.jumpTo(3);
              break;
            }
            n = c.playhead_.getTime();
            return r.yield(c.adjustStartTime_(l, n), 4);
          case 4:
            (p = r.yieldResult), c.playhead_.setStartTime(p);
          case 3:
            return r.yield(c.streamingEngine_.start(), 5);
          case 5:
            c.config_.abr.enabled && (c.abrManager_.enable(), c.onAbrStatusChanged_()),
              c.filterManifest_(c.manifest_),
              c.onTracksChanged_(),
              c.onAdaptation_(),
              c.updateAbrManagerVariants_(),
              (q = c.manifest_.variants.some(function (t) {
                return t.primary;
              })),
              c.config_.preferredAudioLanguage ||
                q ||
                shaka.log.warning('No preferred audio language set.  We have chosen an arbitrary language initially'),
              c.eventManager_.listenOnce(d, 'loadedmetadata', function () {
                var t = Date.now() / 1e3 - b.startTimeOfLoad;
                c.stats_.setLoadLatency(t);
              }),
              r.jumpToEnd();
        }
      });
    };
    shaka.Player.prototype.onInitializeSrcEqualsDrm_ = function (a, b) {
      var c = this,
        d,
        e,
        f,
        g;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (h) {
        return 1 == h.nextAddress
          ? ((d = shaka.util.ManifestParserUtils.ContentType),
            goog.asserts.assert(
              c.networkingEngine_,
              '|onInitializeSrcEqualsDrm_| should never be called after |destroy|',
            ),
            goog.asserts.assert(c.config_, '|onInitializeSrcEqualsDrm_| should never be called after |destroy|'),
            (e = Date.now() / 1e3),
            (f = !0),
            (c.drmEngine_ = c.createDrmEngine({
              netEngine: c.networkingEngine_,
              onError: function (k) {
                c.onError_(k);
              },
              onKeyStatus: function (k) {
                c.onKeyStatus_(k);
              },
              onExpirationUpdated: function (k, l) {
                c.onExpirationUpdated_(k, l);
              },
              onEvent: function (k) {
                c.dispatchEvent(k);
                k.type == shaka.Player.EventName.DrmSessionUpdate &&
                  f &&
                  ((f = !1), (k = Date.now() / 1e3 - e), c.stats_.setDrmTime(k));
              },
            })),
            c.drmEngine_.configure(c.config_.drm),
            (g = {
              id: 0,
              language: 'und',
              primary: !1,
              audio: null,
              video: {
                id: 0,
                originalId: null,
                createSegmentIndex: function () {
                  return Promise.resolve();
                },
                segmentIndex: null,
                mimeType: 'video/mp4',
                codecs: '',
                encrypted: !0,
                drmInfos: [],
                keyIds: new Set(),
                language: 'und',
                label: null,
                type: d.VIDEO,
                primary: !1,
                trickModeVideo: null,
                emsgSchemeIdUris: null,
                roles: [],
                channelsCount: null,
                audioSamplingRate: null,
                closedCaptions: null,
              },
              bandwidth: 100,
              allowedByApplication: !0,
              allowedByKeySystem: !0,
            }),
            h.yield(c.drmEngine_.initForPlayback([g], []), 2))
          : h.yield(c.drmEngine_.attach(a.mediaElement), 0);
      });
    };
    shaka.Player.prototype.onSrcEquals_ = function (a, b) {
      var c = this;
      goog.asserts.assert(a.mediaElement, 'We should have a media element when loading.');
      goog.asserts.assert(b.uri, '|has| should have a valid uri when loading.');
      goog.asserts.assert(!isNaN(b.startTimeOfLoad), '|wants| should tell us when the load was originally requested');
      goog.asserts.assert(this.video_ == a.mediaElement, 'The video element should match our media element');
      a.uri = b.uri;
      a.startTime = b.startTime;
      this.assetUri_ = a.uri;
      this.playhead_ = new shaka.media.SrcEqualsPlayhead(a.mediaElement);
      null != a.startTime && this.playhead_.setStartTime(a.startTime);
      this.playRateController_ = new shaka.media.PlayRateController({
        getRate: function () {
          return a.mediaElement.playbackRate;
        },
        setRate: function (g) {
          a.mediaElement.playbackRate = g;
        },
        movePlayhead: function (g) {
          a.mediaElement.currentTime += g;
        },
      });
      this.startBufferManagement_(this.config_.streaming.rebufferingGoal);
      var d = function () {
        return c.updateStateHistory_();
      };
      this.eventManager_.listen(a.mediaElement, 'playing', d);
      this.eventManager_.listen(a.mediaElement, 'pause', d);
      this.eventManager_.listen(a.mediaElement, 'ended', d);
      this.eventManager_.listen(a.mediaElement, 'ratechange', function () {
        return c.onRateChange_();
      });
      'none' != this.video_.preload &&
        this.eventManager_.listenOnce(this.video_, 'loadedmetadata', function () {
          var g = Date.now() / 1e3 - b.startTimeOfLoad;
          c.stats_.setLoadLatency(g);
        });
      this.video_.audioTracks &&
        (this.eventManager_.listen(this.video_.audioTracks, 'addtrack', function () {
          return c.onTracksChanged_();
        }),
        this.eventManager_.listen(this.video_.audioTracks, 'removetrack', function () {
          return c.onTracksChanged_();
        }),
        this.eventManager_.listen(this.video_.audioTracks, 'change', function () {
          return c.onTracksChanged_();
        }));
      this.video_.textTracks &&
        (this.eventManager_.listen(this.video_.textTracks, 'addtrack', function (g) {
          c.onTracksChanged_();
          c.processTimedMetadataSrcEqls_(g);
        }),
        this.eventManager_.listen(this.video_.textTracks, 'removetrack', function () {
          return c.onTracksChanged_();
        }),
        this.eventManager_.listen(this.video_.textTracks, 'change', function () {
          return c.onTracksChanged_();
        }));
      a.mediaElement.src = a.uri;
      (shaka.util.Platform.isTizen() || shaka.util.Platform.isWebOS()) && a.mediaElement.load();
      this.loadMode_ = shaka.Player.LoadMode.SRC_EQUALS;
      this.dispatchEvent(this.makeEvent_(shaka.Player.EventName.Streaming));
      var e = new shaka.util.PublicPromise();
      shaka.util.MediaReadyState.waitForReadyState(
        this.video_,
        HTMLMediaElement.HAVE_METADATA,
        this.eventManager_,
        function () {
          e.resolve();
        },
      );
      var f = !1;
      this.cleanupOnUnload_.push(function () {
        f = !0;
      });
      shaka.util.MediaReadyState.waitForReadyState(
        this.video_,
        HTMLMediaElement.HAVE_CURRENT_DATA,
        this.eventManager_,
        function () {
          var g;
          return $jscomp.asyncExecutePromiseGeneratorProgram(function (h) {
            if (1 == h.nextAddress) {
              if (f) return h['return']();
              c.setupPreferredAudioOnSrc_();
              g = c.getFilteredTextTracks_();
              return g.find(function (k) {
                return 'disabled' != k.mode;
              })
                ? h.jumpTo(2)
                : h.yield(
                    new Promise(function (k) {
                      c.eventManager_.listenOnce(c.video_.textTracks, 'change', k);
                      new shaka.util.Timer(k).tickAfter(1);
                    }),
                    2,
                  );
            }
            if (f) return h['return']();
            c.setupPreferredTextOnSrc_();
            h.jumpToEnd();
          });
        },
      );
      this.video_.error
        ? e.reject(this.videoErrorToShakaError_())
        : 'none' == this.video_.preload &&
          (shaka.log.alwaysWarn(
            'With <video preload="none">, the browser will not load anything until play() is called. We are unable to measure load latency in a meaningful way, and we cannot provide track info yet. Please do not use preload="none" with Shaka Player.',
          ),
          e.resolve());
      this.eventManager_.listenOnce(this.video_, 'error', function () {
        e.reject(c.videoErrorToShakaError_());
      });
      return new shaka.util.AbortableOperation(e, function () {
        var g = new shaka.util.Error(
          shaka.util.Error.Severity.CRITICAL,
          shaka.util.Error.Category.PLAYER,
          shaka.util.Error.Code.OPERATION_ABORTED,
        );
        e.reject(g);
        return Promise.resolve();
      });
    };
    shaka.Player.prototype.setupPreferredAudioOnSrc_ = function () {
      var a = this.config_.preferredAudioLanguage;
      if ('' != a) {
        this.selectAudioLanguage(a);
        var b = this.config_.preferredVariantRole;
        '' != b && this.selectAudioLanguage(a, b);
      }
    };
    shaka.Player.prototype.setupPreferredTextOnSrc_ = function () {
      var a = this.config_.preferredTextLanguage;
      if ('' != a) {
        this.selectTextLanguage(a);
        var b = this.config_.preferredTextRole;
        '' != b && this.selectTextLanguage(a, b);
      }
    };
    shaka.Player.prototype.processTimedMetadataSrcEqls_ = function (a) {
      var b = this,
        c = a.track;
      goog.asserts.assert(c instanceof TextTrack, 'Wrong track type!');
      'metadata' == c.kind &&
        ((c.mode = 'hidden'),
        this.eventManager_.listen(c, 'cuechange', function () {
          if (c.activeCues)
            for (var d = $jscomp.makeIterator(c.activeCues), e = d.next(); !e.done; e = d.next())
              if (((e = e.value), b.dispatchMetadataEvent_(e.startTime, e.endTime, e.type, e.value), b.adManager_))
                b.adManager_.onCueMetadataChange(e.value);
        }),
        new shaka.util.Timer(function () {
          var d = b.getMetadataTracks_();
          d = $jscomp.makeIterator(d);
          for (var e = d.next(); !e.done; e = d.next()) e.value.mode = 'hidden';
        })
          .tickNow()
          .tickAfter(0.5));
    };
    shaka.Player.prototype.processTimedMetadataMediaSrc_ = function (a, b, c) {
      a = $jscomp.makeIterator(a);
      for (var d = a.next(); !d.done; d = a.next())
        if (((d = d.value), d.data && d.cueTime && d.frames)) {
          for (var e = d.cueTime + b, f = c, g = $jscomp.makeIterator(d.frames), h = g.next(); !h.done; h = g.next())
            this.dispatchMetadataEvent_(e, f, 'ID3', h.value);
          if (this.adManager_) this.adManager_.onHlsTimedMetadata(d, e);
        }
    };
    shaka.Player.prototype.dispatchMetadataEvent_ = function (a, b, c, d) {
      goog.asserts.assert(!b || a <= b, 'Metadata start time should be less or equal to the end time!');
      this.dispatchEvent(
        this.makeEvent_(shaka.Player.EventName.Metadata, { startTime: a, endTime: b, metadataType: c, payload: d }),
      );
    };
    shaka.Player.filterForAVVariants_ = function (a) {
      var b = function (c) {
        return (c.video && c.audio) || (c.video && c.video.codecs.includes(','));
      };
      a.variants.some(b) &&
        (shaka.log.debug('Found variant with audio and video content, so filtering out audio-only content.'),
        (a.variants = a.variants.filter(b)));
    };
    shaka.Player.prototype.createDrmEngine = function (a) {
      return new shaka.media.DrmEngine(a, this.config_.drm.updateExpirationTime);
    };
    shaka.Player.prototype.createNetworkingEngine = function () {
      var a = this;
      return new shaka.net.NetworkingEngine(function (b, c) {
        a.abrManager_ && a.abrManager_.segmentDownloaded(b, c);
      });
    };
    shaka.Player.prototype.createPlayhead = function (a) {
      var b = this;
      goog.asserts.assert(this.manifest_, 'Must have manifest');
      goog.asserts.assert(this.video_, 'Must have video');
      return new shaka.media.MediaSourcePlayhead(
        this.video_,
        this.manifest_,
        this.config_.streaming,
        a,
        function () {
          return b.onSeek_();
        },
        function (c) {
          return b.dispatchEvent(c);
        },
      );
    };
    shaka.Player.prototype.createPlayheadObserversForMSE_ = function () {
      var a = this;
      goog.asserts.assert(this.manifest_, 'Must have manifest');
      goog.asserts.assert(this.regionTimeline_, 'Must have region timeline');
      goog.asserts.assert(this.video_, 'Must have video element');
      var b = new shaka.media.RegionObserver(this.regionTimeline_);
      b.setListeners(
        function (d, e) {
          a.onRegionEvent_(shaka.Player.EventName.TimelineRegionEnter, d);
        },
        function (d, e) {
          a.onRegionEvent_(shaka.Player.EventName.TimelineRegionExit, d);
        },
        function (d, e) {
          e ||
            (a.onRegionEvent_(shaka.Player.EventName.TimelineRegionEnter, d),
            a.onRegionEvent_(shaka.Player.EventName.TimelineRegionExit, d));
        },
      );
      var c = new shaka.media.PlayheadObserverManager(this.video_);
      c.manage(b);
      return c;
    };
    shaka.Player.prototype.startBufferManagement_ = function (a) {
      var b = this;
      goog.asserts.assert(!this.bufferObserver_, 'No buffering observer should exist before initialization.');
      goog.asserts.assert(!this.bufferPoller_, 'No buffer timer should exist before initialization.');
      this.bufferObserver_ = new shaka.media.BufferingObserver(1, 2);
      this.bufferObserver_.setState(shaka.media.BufferingObserver.State.STARVING);
      this.updateBufferingSettings_(a);
      this.updateBufferState_();
      this.bufferPoller_ = new shaka.util.Timer(function () {
        b.pollBufferState_();
      }).tickEvery(0.25);
    };
    shaka.Player.prototype.updateBufferingSettings_ = function (a) {
      this.bufferObserver_.setThresholds(a, Math.min(shaka.Player.TYPICAL_BUFFERING_THRESHOLD_, a / 2));
    };
    shaka.Player.prototype.pollBufferState_ = function () {
      goog.asserts.assert(this.video_, 'Need a media element to update the buffering observer');
      goog.asserts.assert(this.bufferObserver_, 'Need a buffering observer to update');
      switch (this.loadMode_) {
        case shaka.Player.LoadMode.SRC_EQUALS:
          var a = this.isBufferedToEndSrc_();
          break;
        case shaka.Player.LoadMode.MEDIA_SOURCE:
          a = this.isBufferedToEndMS_();
          break;
        default:
          a = !1;
      }
      var b = shaka.media.TimeRangesUtils.bufferedAheadOf(this.video_.buffered, this.video_.currentTime);
      this.bufferObserver_.update(b, a) && this.updateBufferState_();
    };
    shaka.Player.prototype.createMediaSourceEngine = function (a, b, c, d) {
      return new shaka.media.MediaSourceEngine(a, b, c, d);
    };
    shaka.Player.prototype.createStreamingEngine = function () {
      var a = this;
      goog.asserts.assert(
        this.playhead_ && this.abrManager_ && this.mediaSourceEngine_ && this.manifest_,
        'Must not be destroyed',
      );
      return new shaka.media.StreamingEngine(this.manifest_, {
        getPresentationTime: function () {
          return a.playhead_.getTime();
        },
        getBandwidthEstimate: function () {
          return a.abrManager_.getBandwidthEstimate();
        },
        mediaSourceEngine: this.mediaSourceEngine_,
        netEngine: this.networkingEngine_,
        onError: function (b) {
          return a.onError_(b);
        },
        onEvent: function (b) {
          return a.dispatchEvent(b);
        },
        onManifestUpdate: function () {
          return a.onManifestUpdate_();
        },
        onSegmentAppended: function () {
          return a.onSegmentAppended_();
        },
      });
    };
    shaka.Player.prototype.configure = function (a, b) {
      goog.asserts.assert(this.config_, 'Config must not be null!');
      goog.asserts.assert('object' == typeof a || 2 == arguments.length, 'String configs should have values!');
      2 == arguments.length && 'string' == typeof a && (a = shaka.util.ConfigUtils.convertToConfigObject(a, b));
      goog.asserts.assert('object' == typeof a, 'Should be an object!');
      a.manifest &&
        a.manifest.dash &&
        'defaultPresentationDelay' in a.manifest.dash &&
        (shaka.Deprecate.deprecateFeature(
          4,
          'manifest.dash.defaultPresentationDelay configuration',
          'Please Use manifest.defaultPresentationDelay instead.',
        ),
        (a.manifest.defaultPresentationDelay = a.manifest.dash.defaultPresentationDelay),
        delete a.manifest.dash.defaultPresentationDelay);
      var c = shaka.util.PlayerConfiguration.mergeConfigObjects(this.config_, a, this.defaultConfig_());
      this.applyConfig_();
      return c;
    };
    shaka.Player.prototype.applyConfig_ = function () {
      if (this.parser_) {
        var a = shaka.util.ObjectUtils.cloneObject(this.config_.manifest);
        this.video_ && 'AUDIO' === this.video_.nodeName && (a.disableVideo = !0);
        this.parser_.configure(a);
      }
      this.drmEngine_ && this.drmEngine_.configure(this.config_.drm);
      if (this.streamingEngine_) {
        this.streamingEngine_.configure(this.config_.streaming);
        try {
          this.filterManifest_(this.manifest_);
        } catch (c) {
          this.onError_(c);
        }
        this.abrManager_ && this.updateAbrManagerVariants_();
        !(a = this.streamingEngine_.getCurrentVariant()) ||
          (a.allowedByApplication && a.allowedByKeySystem) ||
          (shaka.log.debug('Choosing new variant after changing configuration'), this.chooseVariantAndSwitch_());
      }
      if (this.mediaSourceEngine_ && ((a = this.config_.textDisplayFactory), this.lastTextFactory_ != a)) {
        var b = shaka.util.Functional.callFactory(a);
        this.mediaSourceEngine_.setTextDisplayer(b);
        this.lastTextFactory_ = a;
        this.streamingEngine_ && this.streamingEngine_.reloadTextStream();
      }
      this.abrManager_ &&
        (this.abrManager_.configure(this.config_.abr),
        this.config_.abr.enabled ? this.abrManager_.enable() : this.abrManager_.disable(),
        this.onAbrStatusChanged_());
      this.bufferObserver_ &&
        ((a = this.config_.streaming.rebufferingGoal),
        this.manifest_ && (a = Math.max(a, this.manifest_.minBufferTime)),
        this.updateBufferingSettings_(a));
    };
    shaka.Player.prototype.getConfiguration = function () {
      goog.asserts.assert(this.config_, 'Config must not be null!');
      var a = this.defaultConfig_();
      shaka.util.PlayerConfiguration.mergeConfigObjects(a, this.config_, this.defaultConfig_());
      return a;
    };
    shaka.Player.prototype.getSharedConfiguration = function () {
      goog.asserts.assert(this.config_, 'Cannot call getSharedConfiguration after call destroy!');
      return this.config_;
    };
    shaka.Player.prototype.resetConfiguration = function () {
      goog.asserts.assert(this.config_, 'Cannot be destroyed');
      for (var a in this.config_) delete this.config_[a];
      shaka.util.PlayerConfiguration.mergeConfigObjects(this.config_, this.defaultConfig_(), this.defaultConfig_());
      this.applyConfig_();
    };
    shaka.Player.prototype.getLoadMode = function () {
      return this.loadMode_;
    };
    shaka.Player.prototype.getMediaElement = function () {
      return this.video_;
    };
    shaka.Player.prototype.getNetworkingEngine = function () {
      return this.networkingEngine_;
    };
    shaka.Player.prototype.getAssetUri = function () {
      return this.assetUri_;
    };
    shaka.Player.prototype.getAdManager = function () {
      shaka.log.warnOnce(
        'getAdManager',
        "Shaka Player's ad features are currently in BETA and are NOT yet covered by semantic versioning compatibility guarantees.  The API may change at any time!",
      );
      return this.adManager_;
    };
    shaka.Player.prototype.isLive = function () {
      return this.manifest_
        ? this.manifest_.presentationTimeline.isLive()
        : this.video_ && this.video_.src
        ? Infinity == this.video_.duration
        : !1;
    };
    shaka.Player.prototype.isInProgress = function () {
      return this.manifest_ ? this.manifest_.presentationTimeline.isInProgress() : !1;
    };
    shaka.Player.prototype.isAudioOnly = function () {
      if (this.manifest_) {
        var a = this.manifest_.variants;
        return a.length ? !a[0].video : !1;
      }
      return this.video_ && this.video_.src
        ? this.video_.videoTracks
          ? 0 == this.video_.videoTracks.length
          : 0 == this.video_.videoHeight
        : !1;
    };
    shaka.Player.prototype.seekRange = function () {
      if (this.manifest_) {
        var a = this.manifest_.presentationTimeline;
        return { start: a.getSeekRangeStart(), end: a.getSeekRangeEnd() };
      }
      return this.video_ && this.video_.src && ((a = this.video_.seekable), a.length)
        ? { start: a.start(0), end: a.end(a.length - 1) }
        : { start: 0, end: 0 };
    };
    shaka.Player.prototype.keySystem = function () {
      return shaka.media.DrmEngine.keySystem(this.drmInfo());
    };
    shaka.Player.prototype.drmInfo = function () {
      return this.drmEngine_ ? this.drmEngine_.getDrmInfo() : null;
    };
    shaka.Player.prototype.getExpiration = function () {
      return this.drmEngine_ ? this.drmEngine_.getExpiration() : Infinity;
    };
    shaka.Player.prototype.isBuffering = function () {
      var a = shaka.media.BufferingObserver.State;
      return this.bufferObserver_ ? this.bufferObserver_.getState() == a.STARVING : !1;
    };
    shaka.Player.prototype.getPlaybackRate = function () {
      return this.video_ ? (this.playRateController_ ? this.playRateController_.getRealRate() : 1) : 0;
    };
    shaka.Player.prototype.trickPlay = function (a) {
      goog.asserts.assert(0 != a, 'Should never set a trick play rate of 0!');
      0 == a
        ? shaka.log.alwaysWarn('A trick play rate of 0 is unsupported!')
        : (this.video_.paused && this.video_.play(),
          this.playRateController_.set(a),
          this.loadMode_ == shaka.Player.LoadMode.MEDIA_SOURCE &&
            (this.abrManager_.playbackRateChanged(a), this.streamingEngine_.setTrickPlay(1 < Math.abs(a))));
    };
    shaka.Player.prototype.cancelTrickPlay = function () {
      this.loadMode_ == shaka.Player.LoadMode.SRC_EQUALS && this.playRateController_.set(1);
      this.loadMode_ == shaka.Player.LoadMode.MEDIA_SOURCE &&
        (this.playRateController_.set(1),
        this.abrManager_.playbackRateChanged(1),
        this.streamingEngine_.setTrickPlay(!1));
    };
    shaka.Player.prototype.getVariantTracks = function () {
      if (this.manifest_) {
        for (
          var a = this.streamingEngine_ ? this.streamingEngine_.getCurrentVariant() : null,
            b = [],
            c = $jscomp.makeIterator(this.manifest_.variants),
            d = c.next();
          !d.done;
          d = c.next()
        )
          if (((d = d.value), shaka.util.StreamUtils.isPlayable(d))) {
            var e = shaka.util.StreamUtils.variantToTrack(d);
            e.active = d == a;
            b.push(e);
          }
        return b;
      }
      return this.video_ && this.video_.audioTracks
        ? Array.from(this.video_.audioTracks).map(function (f) {
            return shaka.util.StreamUtils.html5AudioTrackToTrack(f);
          })
        : [];
    };
    shaka.Player.prototype.getTextTracks = function () {
      if (this.manifest_) {
        for (
          var a = this.streamingEngine_ ? this.streamingEngine_.getCurrentTextStream() : null,
            b = [],
            c = $jscomp.makeIterator(this.manifest_.textStreams),
            d = c.next();
          !d.done;
          d = c.next()
        ) {
          d = d.value;
          var e = shaka.util.StreamUtils.textStreamToTrack(d);
          e.active = d == a;
          b.push(e);
        }
        return b;
      }
      if (this.video_ && this.video_.src && this.video_.textTracks) {
        a = this.getFilteredTextTracks_();
        var f = shaka.util.StreamUtils;
        return a.map(function (g) {
          return f.html5TextTrackToTrack(g);
        });
      }
      return [];
    };
    shaka.Player.prototype.selectTextTrack = function (a) {
      if (this.manifest_ && this.streamingEngine_) {
        var b = this.manifest_.textStreams.find(function (d) {
          return d.id == a.id;
        });
        b
          ? b == this.streamingEngine_.getCurrentTextStream()
            ? shaka.log.debug('Text track already selected.')
            : (this.addTextStreamToSwitchHistory_(b, !1),
              this.streamingEngine_.switchTextStream(b),
              this.onTextChanged_(),
              (this.currentTextLanguage_ = b.language))
          : shaka.log.error('No stream with id', a.id);
      } else if (this.video_ && this.video_.src && this.video_.textTracks) {
        b = this.getFilteredTextTracks_();
        b = $jscomp.makeIterator(b);
        for (var c = b.next(); !c.done; c = b.next())
          (c = c.value),
            shaka.util.StreamUtils.html5TrackId(c) == a.id
              ? (c.mode = this.isTextVisible_ ? 'showing' : 'hidden')
              : (c.mode = 'disabled');
      }
    };
    shaka.Player.prototype.selectVariantTrack = function (a, b, c) {
      b = void 0 === b ? !1 : b;
      c = void 0 === c ? 0 : c;
      if (this.manifest_ && this.streamingEngine_) {
        this.config_.abr.enabled &&
          shaka.log.alwaysWarn(
            'Changing tracks while abr manager is enabled will likely result in the selected track being overriden. Consider disabling abr before calling selectVariantTrack().',
          );
        var d = this.manifest_.variants.find(function (e) {
          return e.id == a.id;
        });
        d
          ? shaka.util.StreamUtils.isPlayable(d)
            ? d == this.streamingEngine_.getCurrentVariant()
              ? shaka.log.debug('Variant already selected.')
              : (this.addVariantToSwitchHistory_(d, !1),
                this.streamingEngine_.switchVariant(d, b, c),
                this.onVariantChanged_(),
                (this.currentAdaptationSetCriteria_ = new shaka.media.ExampleBasedCriteria(d)),
                this.updateAbrManagerVariants_())
            : shaka.log.error('Unable to switch to restricted track', a.id)
          : shaka.log.error('No variant with id', a.id);
      } else if (this.video_ && this.video_.audioTracks) {
        b = Array.from(this.video_.audioTracks);
        b = $jscomp.makeIterator(b);
        for (c = b.next(); !c.done; c = b.next())
          (c = c.value), shaka.util.StreamUtils.html5TrackId(c) == a.id && (c.enabled = !0);
        this.onVariantChanged_();
      }
    };
    shaka.Player.prototype.getAudioLanguagesAndRoles = function () {
      return shaka.Player.getLanguageAndRolesFrom_(this.getVariantTracks());
    };
    shaka.Player.prototype.getTextLanguagesAndRoles = function () {
      return shaka.Player.getLanguageAndRolesFrom_(this.getTextTracks());
    };
    shaka.Player.prototype.getAudioLanguages = function () {
      return Array.from(shaka.Player.getLanguagesFrom_(this.getVariantTracks()));
    };
    shaka.Player.prototype.getTextLanguages = function () {
      return Array.from(shaka.Player.getLanguagesFrom_(this.getTextTracks()));
    };
    shaka.Player.prototype.selectAudioLanguage = function (a, b) {
      var c = shaka.util.LanguageUtils;
      if (this.manifest_ && this.playhead_)
        (this.currentAdaptationSetCriteria_ = new shaka.media.PreferenceBasedCriteria(a, b || '', 0, '')),
          this.chooseVariantAndSwitch_();
      else if (this.video_ && this.video_.audioTracks) {
        var d = Array.from(this.video_.audioTracks),
          e = c.normalize(a),
          f = null,
          g = null;
        d = $jscomp.makeIterator(d);
        for (var h = d.next(); !h.done; h = d.next()) {
          h = h.value;
          var k = shaka.util.StreamUtils.html5AudioTrackToTrack(h);
          c.normalize(k.language) == e &&
            ((f = h), b ? k.roles.includes(b) && (g = h) : 0 == k.roles.length && (g = h));
        }
        g ? ((g.enabled = !0), this.onVariantChanged_()) : f && ((f.enabled = !0), this.onVariantChanged_());
      }
    };
    shaka.Player.prototype.selectTextLanguage = function (a, b) {
      var c = shaka.util.LanguageUtils;
      if (this.manifest_ && this.playhead_) {
        this.currentTextLanguage_ = a;
        this.currentTextRole_ = b || '';
        var d = this.chooseTextStream_();
        d &&
          (d == this.streamingEngine_.getCurrentTextStream()
            ? shaka.log.debug('Text track already selected.')
            : (this.addTextStreamToSwitchHistory_(d, !1),
              this.shouldStreamText_() && (this.streamingEngine_.switchTextStream(d), this.onTextChanged_())));
      } else {
        var e = c.normalize(a);
        (d = this.getTextTracks().find(function (f) {
          return c.normalize(f.language) == e && (!b || f.roles.includes(b));
        })) && this.selectTextTrack(d);
      }
    };
    shaka.Player.prototype.selectVariantsByLabel = function (a) {
      if (this.manifest_ && this.playhead_) {
        for (var b = null, c = $jscomp.makeIterator(this.manifest_.variants), d = c.next(); !d.done; d = c.next())
          if (((d = d.value), d.audio.label == a)) {
            b = d;
            break;
          }
        null == b
          ? shaka.log.warning('No variants were found with label: ' + a + '. Ignoring the request to switch.')
          : ((this.currentAdaptationSetCriteria_ = new shaka.media.PreferenceBasedCriteria(b.language, '', 0, a)),
            this.chooseVariantAndSwitch_());
      }
    };
    shaka.Player.prototype.isTextTrackVisible = function () {
      var a = this.isTextVisible_;
      if (this.mediaSourceEngine_) {
        var b = this.mediaSourceEngine_.getTextDisplayer().isTextVisible();
        goog.asserts.assert(b == a, 'text visibility has fallen out of sync');
        return b;
      }
      return this.video_ && this.video_.src && this.video_.textTracks
        ? this.getFilteredTextTracks_().some(function (c) {
            return 'showing' == c.mode;
          })
        : a;
    };
    shaka.Player.prototype.getFilteredTextTracks_ = function () {
      goog.asserts.assert(this.video_.textTracks, 'TextTracks should be valid.');
      return Array.from(this.video_.textTracks).filter(function (a) {
        return 'metadata' != a.kind && 'chapters' != a.kind && a.label != shaka.Player.TextTrackLabel;
      });
    };
    shaka.Player.prototype.getMetadataTracks_ = function () {
      goog.asserts.assert(this.video_.textTracks, 'TextTracks should be valid.');
      return Array.from(this.video_.textTracks).filter(function (a) {
        return 'metadata' == a.kind;
      });
    };
    shaka.Player.prototype.setTextTrackVisibility = function (a) {
      a = !!a;
      if (this.isTextVisible_ != a) {
        this.isTextVisible_ = a;
        if (this.loadMode_ == shaka.Player.LoadMode.MEDIA_SOURCE)
          this.mediaSourceEngine_.getTextDisplayer().setTextVisibility(a),
            this.config_.streaming.alwaysStreamText ||
              (a
                ? this.streamingEngine_.getCurrentTextStream() ||
                  ((a = shaka.util.StreamUtils.filterStreamsByLanguageAndRole(
                    this.manifest_.textStreams,
                    this.currentTextLanguage_,
                    this.currentTextRole_,
                  )),
                  0 < a.length && (this.streamingEngine_.switchTextStream(a[0]), this.onTextChanged_()))
                : this.streamingEngine_.unloadTextStream());
        else if (this.video_ && this.video_.src && this.video_.textTracks) {
          var b = this.getFilteredTextTracks_();
          b = $jscomp.makeIterator(b);
          for (var c = b.next(); !c.done; c = b.next())
            (c = c.value), 'disabled' != c.mode && (c.mode = a ? 'showing' : 'hidden');
        }
        this.onTextTrackVisibility_();
      }
    };
    shaka.Player.prototype.getPlayheadTimeAsDate = function () {
      if (!this.isLive()) return shaka.log.warning('getPlayheadTimeAsDate is for live streams!'), null;
      var a = this.walker_.getCurrentPayload(),
        b = 0;
      if (this.playhead_) b = this.playhead_.getTime();
      else if (a) {
        if (null == a.startTime) return new Date();
        b = a.startTime;
      }
      if (this.manifest_)
        return (a = this.manifest_.presentationTimeline.getPresentationStartTime()), new Date(1e3 * (a + b));
      if (this.video_ && this.video_.getStartDate)
        return (
          (a = this.video_.getStartDate()),
          isNaN(a.getTime())
            ? (shaka.log.warning('EXT-X-PROGRAM-DATETIME required to get playhead time as Date!'), null)
            : new Date(a.getTime() + 1e3 * b)
        );
      shaka.log.warning('No way to get playhead time as Date!');
      return null;
    };
    shaka.Player.prototype.getPresentationStartTimeAsDate = function () {
      if (!this.isLive()) return shaka.log.warning('getPresentationStartTimeAsDate is for live streams!'), null;
      if (this.manifest_) {
        var a = this.manifest_.presentationTimeline.getPresentationStartTime();
        goog.asserts.assert(null != a, 'Presentation start time should not be null!');
        return new Date(1e3 * a);
      }
      if (this.video_ && this.video_.getStartDate)
        return (
          (a = this.video_.getStartDate()),
          isNaN(a.getTime())
            ? (shaka.log.warning('EXT-X-PROGRAM-DATETIME required to get presentation start time as Date!'), null)
            : a
        );
      shaka.log.warning('No way to get presentation start time as Date!');
      return null;
    };
    shaka.Player.prototype.getBufferedInfo = function () {
      if (this.loadMode_ == shaka.Player.LoadMode.MEDIA_SOURCE) return this.mediaSourceEngine_.getBufferedInfo();
      var a = { total: [], audio: [], video: [], text: [] };
      this.loadMode_ == shaka.Player.LoadMode.SRC_EQUALS &&
        (a.total = shaka.media.TimeRangesUtils.getBufferedInfo(this.video_.buffered));
      return a;
    };
    shaka.Player.prototype.getStats = function () {
      if (this.loadMode_ != shaka.Player.LoadMode.MEDIA_SOURCE && this.loadMode_ != shaka.Player.LoadMode.SRC_EQUALS)
        return shaka.util.Stats.getEmptyBlob();
      this.updateStateHistory_();
      goog.asserts.assert(this.video_, 'If we have stats, we should have video_');
      var a = this.video_;
      a.getVideoPlaybackQuality &&
        ((a = a.getVideoPlaybackQuality()),
        this.stats_.setDroppedFrames(Number(a.droppedVideoFrames), Number(a.totalVideoFrames)),
        this.stats_.setCorruptedFrames(Number(a.corruptedVideoFrames)));
      a = this.drmEngine_ ? this.drmEngine_.getLicenseTime() : NaN;
      this.stats_.setLicenseTime(a);
      if (this.loadMode_ == shaka.Player.LoadMode.MEDIA_SOURCE) {
        if ((a = this.streamingEngine_.getCurrentVariant())) {
          var b = (this.playRateController_ ? this.playRateController_.getRealRate() : 1) * a.bandwidth;
          this.stats_.setCurrentStreamBandwidth(b);
        }
        a && a.video && this.stats_.setResolution(a.video.width || NaN, a.video.height || NaN);
        this.isLive() &&
          ((a = this.getPresentationStartTimeAsDate().valueOf() + 1e3 * this.seekRange().end),
          (a = (Date.now() - a) / 1e3),
          this.stats_.setLiveLatency(a));
        this.manifest_ &&
          this.manifest_.presentationTimeline &&
          ((a = this.manifest_.presentationTimeline.getMaxSegmentDuration()), this.stats_.setMaxSegmentDuration(a));
        a = this.abrManager_.getBandwidthEstimate();
        this.stats_.setBandwidthEstimate(a);
      }
      return this.stats_.getBlob();
    };
    shaka.Player.prototype.addTextTrack = function (a, b, c, d, e, f) {
      if (this.loadMode_ == shaka.Player.LoadMode.SRC_EQUALS)
        throw (shaka.log.error('Cannot add text when loaded with src='), Error('State error!'));
      if (this.loadMode_ != shaka.Player.LoadMode.MEDIA_SOURCE)
        throw (
          (shaka.log.error('Must call load() and wait for it to resolve before adding text tracks.'),
          Error('State error!'))
        );
      var g = shaka.util.ManifestParserUtils.ContentType,
        h = this.getMediaElement().duration;
      if (Infinity == h)
        throw new shaka.util.Error(
          shaka.util.Error.Severity.RECOVERABLE,
          shaka.util.Error.Category.MANIFEST,
          shaka.util.Error.Code.CANNOT_ADD_EXTERNAL_TEXT_TO_LIVE_STREAM,
        );
      a = {
        id: this.nextExternalStreamId_++,
        originalId: null,
        createSegmentIndex: function () {
          return Promise.resolve();
        },
        segmentIndex: shaka.media.SegmentIndex.forSingleSegment(0, h, [a]),
        mimeType: d,
        codecs: e || '',
        kind: c,
        encrypted: !1,
        drmInfos: [],
        keyIds: new Set(),
        language: b,
        label: f || null,
        type: g.TEXT,
        primary: !1,
        trickModeVideo: null,
        emsgSchemeIdUris: null,
        roles: [],
        channelsCount: null,
        audioSamplingRate: null,
        closedCaptions: null,
      };
      this.manifest_.textStreams.push(a);
      this.onTracksChanged_();
      return shaka.util.StreamUtils.textStreamToTrack(a);
    };
    shaka.Player.prototype.setMaxHardwareResolution = function (a, b) {
      this.maxHwRes_.width = a;
      this.maxHwRes_.height = b;
    };
    shaka.Player.prototype.retryStreaming = function () {
      return this.loadMode_ == shaka.Player.LoadMode.MEDIA_SOURCE ? this.streamingEngine_.retry() : !1;
    };
    shaka.Player.prototype.getManifest = function () {
      shaka.log.alwaysWarn(
        "Shaka Player's internal Manifest structure is NOT covered by semantic versioning compatibility guarantees.  It may change at any time!  Please consider filing a feature request for whatever you use getManifest() for.",
      );
      return this.manifest_;
    };
    shaka.Player.prototype.getManifestParserFactory = function () {
      return this.parserFactory_;
    };
    shaka.Player.prototype.addVariantToSwitchHistory_ = function (a, b) {
      this.stats_.getSwitchHistory().updateCurrentVariant(a, b);
    };
    shaka.Player.prototype.addTextStreamToSwitchHistory_ = function (a, b) {
      this.stats_.getSwitchHistory().updateCurrentText(a, b);
    };
    shaka.Player.prototype.defaultConfig_ = function () {
      var a = this,
        b = shaka.util.PlayerConfiguration.createDefault();
      b.streaming.failureCallback = function (c) {
        a.defaultStreamingFailureCallback_(c);
      };
      b.textDisplayFactory = function () {
        return a.videoContainer_
          ? new shaka.text.UITextDisplayer(a.video_, a.videoContainer_)
          : new shaka.text.SimpleTextDisplayer(a.video_);
      };
      return b;
    };
    shaka.Player.prototype.setVideoContainer = function (a) {
      this.videoContainer_ = a;
    };
    shaka.Player.prototype.defaultStreamingFailureCallback_ = function (a) {
      var b = [shaka.util.Error.Code.BAD_HTTP_STATUS, shaka.util.Error.Code.HTTP_ERROR, shaka.util.Error.Code.TIMEOUT];
      this.isLive() &&
        b.includes(a.code) &&
        ((a.severity = shaka.util.Error.Severity.RECOVERABLE),
        shaka.log.warning('Live streaming error.  Retrying automatically...'),
        this.retryStreaming());
    };
    shaka.Player.prototype.makeTextStreamsForClosedCaptions_ = function (a) {
      for (
        var b = shaka.util.ManifestParserUtils.ContentType,
          c = shaka.util.MimeUtils,
          d = shaka.util.ManifestParserUtils.TextStreamKind,
          e = new Set(),
          f = $jscomp.makeIterator(a.textStreams),
          g = f.next();
        !g.done;
        g = f.next()
      )
        (g = g.value), g.mimeType == c.CLOSED_CAPTION_MIMETYPE && e.add(g.originalId);
      f = $jscomp.makeIterator(a.variants);
      for (g = f.next(); !g.done; g = f.next())
        if ((g = g.value.video) && g.closedCaptions)
          for (var h = $jscomp.makeIterator(g.closedCaptions.keys()), k = h.next(); !k.done; k = h.next())
            if (((k = k.value), !e.has(k))) {
              var l = new shaka.media.MetaSegmentIndex();
              l = {
                id: this.nextExternalStreamId_++,
                originalId: k,
                createSegmentIndex: function () {
                  return Promise.resolve();
                },
                segmentIndex: l,
                mimeType: c.CLOSED_CAPTION_MIMETYPE,
                codecs: '',
                kind: d.CLOSED_CAPTION,
                encrypted: !1,
                drmInfos: [],
                keyIds: new Set(),
                language: g.closedCaptions.get(k),
                label: null,
                type: b.TEXT,
                primary: !1,
                trickModeVideo: null,
                emsgSchemeIdUris: null,
                roles: g.roles,
                channelsCount: null,
                audioSamplingRate: null,
                closedCaptions: null,
              };
              a.textStreams.push(l);
              e.add(k);
            }
    };
    shaka.Player.prototype.filterManifest_ = function (a) {
      goog.asserts.assert(a, 'Manifest should exist!');
      goog.asserts.assert(this.video_, 'Must not be destroyed');
      var b = shaka.util.StreamUtils,
        c = this.streamingEngine_ ? this.streamingEngine_.getCurrentVariant() : null;
      b.filterManifest(this.drmEngine_, c, a);
      if (!a.variants.some(b.isPlayable))
        throw new shaka.util.Error(
          shaka.util.Error.Severity.CRITICAL,
          shaka.util.Error.Category.MANIFEST,
          shaka.util.Error.Code.CONTENT_UNSUPPORTED_BY_BROWSER,
        );
      if (
        shaka.util.StreamUtils.applyRestrictions(a.variants, this.config_.restrictions, this.maxHwRes_) &&
        this.streamingEngine_
      )
        this.onTracksChanged_();
      if ((b = this.drmEngine_ ? this.drmEngine_.getDrmInfo() : null)) {
        c = $jscomp.makeIterator(a.variants);
        for (var d = c.next(); !d.done; d = c.next()) {
          d = d.value;
          d = (d.video ? d.video.drmInfos : []).concat(d.audio ? d.audio.drmInfos : []);
          d = $jscomp.makeIterator(d);
          for (var e = d.next(); !e.done; e = d.next())
            if (((e = e.value), e.keySystem == b.keySystem)) {
              e = $jscomp.makeIterator(e.initData || []);
              for (var f = e.next(); !f.done; f = e.next())
                (f = f.value), this.drmEngine_.newInitData(f.initDataType, f.initData);
            }
        }
      }
      this.checkRestrictedVariants_(a);
    };
    shaka.Player.prototype.adjustStartTime_ = function (a, b) {
      var c, d, e, f, g;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (h) {
        if (1 == h.nextAddress)
          return (
            (c = a.audio),
            (d = a.video),
            (e = function (k, l) {
              var m, n;
              return $jscomp.asyncExecutePromiseGeneratorProgram(function (p) {
                if (1 == p.nextAddress) return k ? p.yield(k.createSegmentIndex(), 2) : p['return'](null);
                m = k.segmentIndex[Symbol.iterator]().seek(l);
                if (!m) return p['return'](null);
                n = m.startTime;
                goog.asserts.assert(n <= l, 'Segment should start before target time!');
                return p['return'](n);
              });
            }),
            h.yield(e(c, b), 2)
          );
        if (3 != h.nextAddress) return (f = h.yieldResult), h.yield(e(d, b), 3);
        g = h.yieldResult;
        return null != g && null != f
          ? h['return'](Math.max(g, f))
          : null != g
          ? h['return'](g)
          : null != f
          ? h['return'](f)
          : h['return'](b);
      });
    };
    shaka.Player.prototype.updateBufferState_ = function () {
      var a = this.isBuffering();
      shaka.log.v2('Player changing buffering state to', a);
      this.stats_ &&
        this.bufferObserver_ &&
        this.playhead_ &&
        (this.playRateController_.setBuffering(a), this.updateStateHistory_());
      this.dispatchEvent(this.makeEvent_(shaka.Player.EventName.Buffering, { buffering: a }));
    };
    shaka.Player.prototype.onRateChange_ = function () {
      var a = this.video_.playbackRate;
      0 != a &&
        (this.playRateController_ && this.playRateController_.set(a),
        (a = this.makeEvent_(shaka.Player.EventName.RateChange)),
        this.dispatchEvent(a));
    };
    shaka.Player.prototype.updateStateHistory_ = function () {
      if (this.stats_ && this.bufferObserver_) {
        var a = shaka.media.BufferingObserver.State,
          b = this.stats_.getStateHistory();
        this.bufferObserver_.getState() == a.STARVING
          ? b.update('buffering')
          : this.video_.paused
          ? b.update('paused')
          : this.video_.ended
          ? b.update('ended')
          : b.update('playing');
      }
    };
    shaka.Player.prototype.onSeek_ = function () {
      this.playheadObservers_ && this.playheadObservers_.notifyOfSeek();
      this.streamingEngine_ && this.streamingEngine_.seeked();
      this.bufferObserver_ && this.pollBufferState_();
    };
    shaka.Player.prototype.updateAbrManagerVariants_ = function () {
      try {
        goog.asserts.assert(this.manifest_, 'Manifest should exist by now!'),
          this.checkRestrictedVariants_(this.manifest_);
      } catch (b) {
        return this.onError_(b), !1;
      }
      var a = this.manifest_.variants.filter(function (b) {
        return shaka.util.StreamUtils.isPlayable(b);
      });
      a = this.currentAdaptationSetCriteria_.create(a);
      this.abrManager_.setVariants(Array.from(a.values()));
      return !0;
    };
    shaka.Player.prototype.chooseVariant_ = function () {
      return this.updateAbrManagerVariants_() ? this.abrManager_.chooseVariant() : null;
    };
    shaka.Player.prototype.chooseTextStream_ = function () {
      return (
        shaka.util.StreamUtils.filterStreamsByLanguageAndRole(
          this.manifest_.textStreams,
          this.currentTextLanguage_,
          this.currentTextRole_,
        )[0] || null
      );
    };
    shaka.Player.prototype.chooseVariantAndSwitch_ = function () {
      goog.asserts.assert(this.config_, 'Must not be destroyed');
      var a = this.chooseVariant_();
      if (a) {
        if (a == this.streamingEngine_.getCurrentVariant()) {
          shaka.log.debug('Variant already selected.');
          return;
        }
        this.addVariantToSwitchHistory_(a, !0);
        this.streamingEngine_.switchVariant(a, !0, 0);
        this.onVariantChanged_();
      }
      this.onAdaptation_();
    };
    shaka.Player.prototype.setInitialTextState_ = function (a, b) {
      b
        ? (a.audio && this.shouldInitiallyShowText_(a.audio, b) && (this.isTextVisible_ = !0),
          this.isTextVisible_ &&
            (this.mediaSourceEngine_.getTextDisplayer().setTextVisibility(!0),
            goog.asserts.assert(this.shouldStreamText_(), 'Should be streaming text')),
          this.onTextTrackVisibility_())
        : (this.isTextVisible_ = !1);
    };
    shaka.Player.prototype.shouldInitiallyShowText_ = function (a, b) {
      var c = shaka.util.LanguageUtils,
        d = c.normalize(this.config_.preferredTextLanguage),
        e = c.normalize(a.language),
        f = c.normalize(b.language);
      return c.areLanguageCompatible(f, d) && !c.areLanguageCompatible(e, f);
    };
    shaka.Player.prototype.onManifestUpdate_ = function () {
      this.parser_ && this.parser_.update && this.parser_.update();
    };
    shaka.Player.prototype.onSegmentAppended_ = function () {
      this.playhead_ && this.playhead_.notifyOfBufferingChange();
      this.pollBufferState_();
    };
    shaka.Player.prototype.switch_ = function (a, b, c) {
      b = void 0 === b ? !1 : b;
      c = void 0 === c ? 0 : c;
      shaka.log.debug('switch_');
      goog.asserts.assert(this.config_.abr.enabled, 'AbrManager should not call switch while disabled!');
      goog.asserts.assert(this.manifest_, 'We need a manifest to switch variants.');
      this.streamingEngine_ &&
        a != this.streamingEngine_.getCurrentVariant() &&
        (this.addVariantToSwitchHistory_(a, !0), this.streamingEngine_.switchVariant(a, b, c), this.onAdaptation_());
    };
    shaka.Player.prototype.onAdaptation_ = function () {
      var a = this.makeEvent_(shaka.Player.EventName.Adaptation);
      this.delayDispatchEvent_(a);
    };
    shaka.Player.prototype.onTracksChanged_ = function () {
      var a = this.makeEvent_(shaka.Player.EventName.TracksChanged);
      this.delayDispatchEvent_(a);
    };
    shaka.Player.prototype.onVariantChanged_ = function () {
      var a = this.makeEvent_(shaka.Player.EventName.VariantChanged);
      this.delayDispatchEvent_(a);
    };
    shaka.Player.prototype.onTextChanged_ = function () {
      var a = this.makeEvent_(shaka.Player.EventName.TextChanged);
      this.delayDispatchEvent_(a);
    };
    shaka.Player.prototype.onTextTrackVisibility_ = function () {
      var a = this.makeEvent_(shaka.Player.EventName.TextTrackVisibility);
      this.delayDispatchEvent_(a);
    };
    shaka.Player.prototype.onAbrStatusChanged_ = function () {
      var a = this.makeEvent_(shaka.Player.EventName.AbrStatusChanged, { newStatus: this.config_.abr.enabled });
      this.delayDispatchEvent_(a);
    };
    shaka.Player.prototype.onError_ = function (a) {
      goog.asserts.assert(a instanceof shaka.util.Error, 'Wrong error type!');
      if (this.loadMode_ != shaka.Player.LoadMode.DESTROYED) {
        var b = this.makeEvent_(shaka.Player.EventName.Error, { detail: a });
        this.dispatchEvent(b);
        b.defaultPrevented && (a.handled = !0);
      }
    };
    shaka.Player.prototype.onRegionEvent_ = function (a, b) {
      this.dispatchEvent(
        this.makeEvent_(a, {
          detail: {
            schemeIdUri: b.schemeIdUri,
            value: b.value,
            startTime: b.startTime,
            endTime: b.endTime,
            id: b.id,
            eventElement: b.eventElement,
          },
        }),
      );
    };
    shaka.Player.prototype.videoErrorToShakaError_ = function () {
      goog.asserts.assert(this.video_.error, 'Video error expected, but missing!');
      if (!this.video_.error) return null;
      var a = this.video_.error.code;
      if (1 == a) return null;
      var b = this.video_.error.msExtendedCode;
      b && (0 > b && (b += Math.pow(2, 32)), (b = b.toString(16)));
      return new shaka.util.Error(
        shaka.util.Error.Severity.CRITICAL,
        shaka.util.Error.Category.MEDIA,
        shaka.util.Error.Code.VIDEO_ERROR,
        a,
        b,
        this.video_.error.message,
      );
    };
    shaka.Player.prototype.onVideoError_ = function (a) {
      if ((a = this.videoErrorToShakaError_())) this.onError_(a);
    };
    shaka.Player.prototype.onKeyStatus_ = function (a) {
      if (this.streamingEngine_) {
        var b = Object.keys(a);
        0 == b.length &&
          shaka.log.warning(
            "Got a key status event without any key statuses, so we don't know the real key statuses. If we don't have all the keys, you'll need to set restrictions so we don't select those tracks.",
          );
        var c = 1 == b.length && '00' == b[0];
        c &&
          shaka.log.warning(
            "Got a synthetic key status event, so we don't know the real key statuses. If we don't have all the keys, you'll need to set restrictions so we don't select those tracks.",
          );
        var d = shaka.Player.restrictedStatuses_,
          e = !1;
        if (b.length) {
          b = $jscomp.makeIterator(this.manifest_.variants);
          for (var f = b.next(); !f.done; f = b.next()) {
            f = f.value;
            var g = shaka.util.StreamUtils.getVariantStreams(f);
            g = $jscomp.makeIterator(g);
            for (var h = g.next(); !h.done; h = g.next()) {
              var k = h.value;
              h = f.allowedByKeySystem;
              if (k.keyIds.size) {
                f.allowedByKeySystem = !0;
                k = $jscomp.makeIterator(k.keyIds);
                for (var l = k.next(); !l.done; l = k.next())
                  (l = l.value),
                    (l = a[c ? '00' : l]),
                    (f.allowedByKeySystem = f.allowedByKeySystem && !!l && !d.includes(l));
              }
              h != f.allowedByKeySystem && (e = !0);
            }
          }
        }
        e && this.updateAbrManagerVariants_();
        (a = this.streamingEngine_.getCurrentVariant()) &&
          !a.allowedByKeySystem &&
          (shaka.log.debug('Choosing new streams after key status changed'), this.chooseVariantAndSwitch_());
        if (e) this.onTracksChanged_();
      }
    };
    shaka.Player.prototype.onExpirationUpdated_ = function (a, b) {
      if (this.parser_ && this.parser_.onExpirationUpdated) this.parser_.onExpirationUpdated(a, b);
      var c = this.makeEvent_(shaka.Player.EventName.ExpirationUpdated);
      this.dispatchEvent(c);
    };
    shaka.Player.prototype.shouldStreamText_ = function () {
      return this.config_.streaming.alwaysStreamText || this.isTextTrackVisible();
    };
    shaka.Player.applyPlayRange_ = function (a, b, c) {
      0 < b &&
        (a.isLive()
          ? shaka.log.warning('|playRangeStart| has been configured for live content. Ignoring the setting.')
          : a.setUserSeekStart(b));
      b = a.getDuration();
      c < b &&
        (a.isLive()
          ? shaka.log.warning('|playRangeEnd| has been configured for live content. Ignoring the setting.')
          : a.setDuration(c));
    };
    shaka.Player.prototype.checkRestrictedVariants_ = function (a) {
      var b = shaka.Player.restrictedStatuses_,
        c = this.drmEngine_ ? this.drmEngine_.getKeyStatuses() : {},
        d = Object.keys(c);
      d = d.length && '00' == d[0];
      var e = !1,
        f = !1,
        g = new Set(),
        h = new Set();
      a = $jscomp.makeIterator(a.variants);
      for (var k = a.next(); !k.done; k = a.next()) {
        k = k.value;
        var l = [];
        k.audio && l.push(k.audio);
        k.video && l.push(k.video);
        l = $jscomp.makeIterator(l);
        for (var m = l.next(); !m.done; m = l.next())
          if (((m = m.value), m.keyIds.size)) {
            m = $jscomp.makeIterator(m.keyIds);
            for (var n = m.next(); !n.done; n = m.next()) {
              n = n.value;
              var p = c[d ? '00' : n];
              p ? b.includes(p) && h.add(p) : g.add(n);
            }
          }
        k.allowedByApplication ? k.allowedByKeySystem && (e = !0) : (f = !0);
      }
      if (!e)
        throw (
          ((b = { hasAppRestrictions: f, missingKeys: Array.from(g), restrictedKeyStatuses: Array.from(h) }),
          new shaka.util.Error(
            shaka.util.Error.Severity.CRITICAL,
            shaka.util.Error.Category.MANIFEST,
            shaka.util.Error.Code.RESTRICTIONS_CANNOT_BE_MET,
            b,
          ))
        );
    };
    shaka.Player.prototype.delayDispatchEvent_ = function (a) {
      var b = this;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (c) {
        if (1 == c.nextAddress) return c.yield(Promise.resolve(), 2);
        b.loadMode_ != shaka.Player.LoadMode.DESTROYED && b.dispatchEvent(a);
        c.jumpToEnd();
      });
    };
    shaka.Player.getLanguagesFrom_ = function (a) {
      var b = new Set();
      a = $jscomp.makeIterator(a);
      for (var c = a.next(); !c.done; c = a.next())
        (c = c.value), c.language ? b.add(shaka.util.LanguageUtils.normalize(c.language)) : b.add('und');
      return b;
    };
    shaka.Player.getLanguageAndRolesFrom_ = function (a) {
      var b = new Map();
      a = $jscomp.makeIterator(a);
      for (var c = a.next(); !c.done; c = a.next()) {
        var d = c.value;
        c = 'und';
        var e = [];
        d.language && (c = shaka.util.LanguageUtils.normalize(d.language));
        ((e = 'variant' == d.type ? d.audioRoles : d.roles) && e.length) || (e = ['']);
        b.has(c) || b.set(c, new Set());
        d = $jscomp.makeIterator(e);
        for (e = d.next(); !e.done; e = d.next()) (e = e.value), b.get(c).add(e);
      }
      var f = [];
      b.forEach(function (g, h) {
        for (var k = $jscomp.makeIterator(g), l = k.next(); !l.done; l = k.next())
          f.push({ language: h, role: l.value });
      });
      return f;
    };
    shaka.Player.prototype.isBufferedToEndMS_ = function () {
      goog.asserts.assert(this.video_, 'We need a video element to get buffering information');
      goog.asserts.assert(this.mediaSourceEngine_, 'We need a media source engine to get buffering information');
      goog.asserts.assert(this.manifest_, 'We need a manifest to get buffering information');
      if (this.video_.ended || this.mediaSourceEngine_.ended()) return !0;
      if (this.manifest_.presentationTimeline.isLive()) {
        var a = this.manifest_.presentationTimeline.getSegmentAvailabilityEnd(),
          b = shaka.media.TimeRangesUtils.bufferEnd(this.video_.buffered);
        if (null != b && b >= a) return !0;
      }
      return !1;
    };
    shaka.Player.prototype.isBufferedToEndSrc_ = function () {
      goog.asserts.assert(this.video_, 'We need a video element to get buffering information');
      if (this.video_.ended) return !0;
      var a = shaka.media.TimeRangesUtils.bufferEnd(this.video_.buffered);
      return null != a && a >= this.video_.duration - 1;
    };
    shaka.Player.prototype.createAbortLoadError_ = function () {
      return new shaka.util.Error(
        shaka.util.Error.Severity.CRITICAL,
        shaka.util.Error.Category.PLAYER,
        shaka.util.Error.Code.LOAD_INTERRUPTED,
      );
    };
    shaka.Player.prototype.getNextStep_ = function (a, b, c, d) {
      var e = null;
      a == this.detachNode_ && (e = c == this.detachNode_ ? this.detachNode_ : this.attachNode_);
      a == this.attachNode_ && (e = this.getNextAfterAttach_(c, b, d));
      a == this.mediaSourceNode_ && (e = this.getNextAfterMediaSource_(c, b, d));
      a == this.parserNode_ &&
        (e = this.getNextMatchingAllDependencies_(this.loadNode_, this.manifestNode_, this.unloadNode_, c, b, d));
      a == this.manifestNode_ &&
        (e = this.getNextMatchingAllDependencies_(this.loadNode_, this.drmNode_, this.unloadNode_, c, b, d));
      a == this.drmNode_ &&
        (e = this.getNextMatchingAllDependencies_(this.loadNode_, this.loadNode_, this.unloadNode_, c, b, d));
      a == this.srcEqualsDrmNode_ &&
        (e = c == this.srcEqualsNode_ && b.mediaElement == d.mediaElement ? this.srcEqualsNode_ : this.unloadNode_);
      if (a == this.loadNode_ || a == this.srcEqualsNode_) e = this.unloadNode_;
      a == this.unloadNode_ && (e = this.getNextAfterUnload_(c, b, d));
      goog.asserts.assert(e, 'Missing next step!');
      return e;
    };
    shaka.Player.prototype.getNextAfterAttach_ = function (a, b, c) {
      return a == this.detachNode_ || b.mediaElement != c.mediaElement
        ? this.detachNode_
        : a == this.attachNode_
        ? this.attachNode_
        : a == this.mediaSourceNode_ || a == this.loadNode_
        ? this.mediaSourceNode_
        : a == this.srcEqualsNode_
        ? this.srcEqualsDrmNode_
        : null;
    };
    shaka.Player.prototype.getNextAfterMediaSource_ = function (a, b, c) {
      return a == this.loadNode_ && b.mediaElement == c.mediaElement ? this.parserNode_ : this.unloadNode_;
    };
    shaka.Player.prototype.getNextAfterUnload_ = function (a, b, c) {
      return c.mediaElement && b.mediaElement == c.mediaElement ? this.attachNode_ : this.detachNode_;
    };
    shaka.Player.prototype.getNextMatchingAllDependencies_ = function (a, b, c, d, e, f) {
      return d == a && e.mediaElement == f.mediaElement && e.uri == f.uri && e.mimeType == f.mimeType ? b : c;
    };
    shaka.Player.createEmptyPayload_ = function () {
      return { mediaElement: null, mimeType: null, startTime: null, startTimeOfLoad: NaN, uri: null };
    };
    shaka.Player.prototype.wrapWalkerListenersWithPromise_ = function (a) {
      var b = this;
      return new Promise(function (c, d) {
        a.onCancel = function () {
          return d(b.createAbortLoadError_());
        };
        a.onEnd = function () {
          return c();
        };
        a.onError = function (e) {
          return d(e);
        };
        a.onSkip = function () {
          return d(b.createAbortLoadError_());
        };
      });
    };
    goog.exportSymbol('shaka.Player', shaka.Player);
    goog.exportProperty(shaka.Player.prototype, 'setVideoContainer', shaka.Player.prototype.setVideoContainer);
    goog.exportProperty(
      shaka.Player.prototype,
      'getManifestParserFactory',
      shaka.Player.prototype.getManifestParserFactory,
    );
    goog.exportProperty(shaka.Player.prototype, 'getManifest', shaka.Player.prototype.getManifest);
    goog.exportProperty(shaka.Player.prototype, 'retryStreaming', shaka.Player.prototype.retryStreaming);
    goog.exportProperty(
      shaka.Player.prototype,
      'setMaxHardwareResolution',
      shaka.Player.prototype.setMaxHardwareResolution,
    );
    goog.exportProperty(shaka.Player.prototype, 'addTextTrack', shaka.Player.prototype.addTextTrack);
    goog.exportProperty(shaka.Player.prototype, 'getStats', shaka.Player.prototype.getStats);
    goog.exportProperty(shaka.Player.prototype, 'getBufferedInfo', shaka.Player.prototype.getBufferedInfo);
    goog.exportProperty(
      shaka.Player.prototype,
      'getPresentationStartTimeAsDate',
      shaka.Player.prototype.getPresentationStartTimeAsDate,
    );
    goog.exportProperty(shaka.Player.prototype, 'getPlayheadTimeAsDate', shaka.Player.prototype.getPlayheadTimeAsDate);
    goog.exportProperty(
      shaka.Player.prototype,
      'setTextTrackVisibility',
      shaka.Player.prototype.setTextTrackVisibility,
    );
    goog.exportProperty(shaka.Player.prototype, 'isTextTrackVisible', shaka.Player.prototype.isTextTrackVisible);
    goog.exportProperty(shaka.Player.prototype, 'selectVariantsByLabel', shaka.Player.prototype.selectVariantsByLabel);
    goog.exportProperty(shaka.Player.prototype, 'selectTextLanguage', shaka.Player.prototype.selectTextLanguage);
    goog.exportProperty(shaka.Player.prototype, 'selectAudioLanguage', shaka.Player.prototype.selectAudioLanguage);
    goog.exportProperty(shaka.Player.prototype, 'getTextLanguages', shaka.Player.prototype.getTextLanguages);
    goog.exportProperty(shaka.Player.prototype, 'getAudioLanguages', shaka.Player.prototype.getAudioLanguages);
    goog.exportProperty(
      shaka.Player.prototype,
      'getTextLanguagesAndRoles',
      shaka.Player.prototype.getTextLanguagesAndRoles,
    );
    goog.exportProperty(
      shaka.Player.prototype,
      'getAudioLanguagesAndRoles',
      shaka.Player.prototype.getAudioLanguagesAndRoles,
    );
    goog.exportProperty(shaka.Player.prototype, 'selectVariantTrack', shaka.Player.prototype.selectVariantTrack);
    goog.exportProperty(shaka.Player.prototype, 'selectTextTrack', shaka.Player.prototype.selectTextTrack);
    goog.exportProperty(shaka.Player.prototype, 'getTextTracks', shaka.Player.prototype.getTextTracks);
    goog.exportProperty(shaka.Player.prototype, 'getVariantTracks', shaka.Player.prototype.getVariantTracks);
    goog.exportProperty(shaka.Player.prototype, 'cancelTrickPlay', shaka.Player.prototype.cancelTrickPlay);
    goog.exportProperty(shaka.Player.prototype, 'trickPlay', shaka.Player.prototype.trickPlay);
    goog.exportProperty(shaka.Player.prototype, 'getPlaybackRate', shaka.Player.prototype.getPlaybackRate);
    goog.exportProperty(shaka.Player.prototype, 'isBuffering', shaka.Player.prototype.isBuffering);
    goog.exportProperty(shaka.Player.prototype, 'getExpiration', shaka.Player.prototype.getExpiration);
    goog.exportProperty(shaka.Player.prototype, 'drmInfo', shaka.Player.prototype.drmInfo);
    goog.exportProperty(shaka.Player.prototype, 'keySystem', shaka.Player.prototype.keySystem);
    goog.exportProperty(shaka.Player.prototype, 'seekRange', shaka.Player.prototype.seekRange);
    goog.exportProperty(shaka.Player.prototype, 'isAudioOnly', shaka.Player.prototype.isAudioOnly);
    goog.exportProperty(shaka.Player.prototype, 'isInProgress', shaka.Player.prototype.isInProgress);
    goog.exportProperty(shaka.Player.prototype, 'isLive', shaka.Player.prototype.isLive);
    goog.exportProperty(shaka.Player.prototype, 'getAdManager', shaka.Player.prototype.getAdManager);
    goog.exportProperty(shaka.Player.prototype, 'getAssetUri', shaka.Player.prototype.getAssetUri);
    goog.exportProperty(shaka.Player.prototype, 'getNetworkingEngine', shaka.Player.prototype.getNetworkingEngine);
    goog.exportProperty(shaka.Player.prototype, 'getMediaElement', shaka.Player.prototype.getMediaElement);
    goog.exportProperty(shaka.Player.prototype, 'getLoadMode', shaka.Player.prototype.getLoadMode);
    goog.exportProperty(shaka.Player.prototype, 'resetConfiguration', shaka.Player.prototype.resetConfiguration);
    goog.exportProperty(shaka.Player.prototype, 'getConfiguration', shaka.Player.prototype.getConfiguration);
    goog.exportProperty(shaka.Player.prototype, 'configure', shaka.Player.prototype.configure);
    goog.exportProperty(shaka.Player.prototype, 'load', shaka.Player.prototype.load);
    goog.exportProperty(shaka.Player.prototype, 'unload', shaka.Player.prototype.unload);
    goog.exportProperty(shaka.Player.prototype, 'detach', shaka.Player.prototype.detach);
    goog.exportProperty(shaka.Player.prototype, 'attach', shaka.Player.prototype.attach);
    goog.exportProperty(shaka.Player, 'probeSupport', shaka.Player.probeSupport);
    goog.exportProperty(shaka.Player, 'isBrowserSupported', shaka.Player.isBrowserSupported);
    goog.exportProperty(shaka.Player, 'setAdManagerFactory', shaka.Player.setAdManagerFactory);
    goog.exportProperty(shaka.Player, 'registerSupportPlugin', shaka.Player.registerSupportPlugin);
    goog.exportProperty(shaka.Player.prototype, 'destroy', shaka.Player.prototype.destroy);
    shaka.Player.EventName = {
      AbrStatusChanged: 'abrstatuschanged',
      Adaptation: 'adaptation',
      Buffering: 'buffering',
      DrmSessionUpdate: 'drmsessionupdate',
      Emsg: 'emsg',
      Error: 'error',
      ExpirationUpdated: 'expirationupdated',
      LargeGap: 'largegap',
      Loaded: 'loaded',
      Loading: 'loading',
      ManifestParsed: 'manifestparsed',
      Metadata: 'metadata',
      OnStateChange: 'onstatechange',
      OnStateIdle: 'onstateidle',
      RateChange: 'ratechange',
      Streaming: 'streaming',
      TextChanged: 'textchanged',
      TextTrackVisibility: 'texttrackvisibility',
      TimelineRegionAdded: 'timelineregionadded',
      TimelineRegionEnter: 'timelineregionenter',
      TimelineRegionExit: 'timelineregionexit',
      TracksChanged: 'trackschanged',
      Unloading: 'unloading',
      VariantChanged: 'variantchanged',
    };
    shaka.Player.LoadMode = { DESTROYED: 0, NOT_LOADED: 1, MEDIA_SOURCE: 2, SRC_EQUALS: 3 };
    goog.exportProperty(shaka.Player, 'LoadMode', shaka.Player.LoadMode);
    shaka.Player.TYPICAL_BUFFERING_THRESHOLD_ = 0.5;
    shaka.Player.version = 'v3.0.6-debug';
    goog.exportProperty(shaka.Player, 'version', shaka.Player.version);
    shaka.Deprecate.init(shaka.Player.version);
    shaka.Player.restrictedStatuses_ = ['output-restricted', 'internal-error'];
    shaka.Player.supportPlugins_ = {};
    shaka.Player.adManagerFactory_ = null;
    shaka.Player.TextTrackLabel = 'Shaka Player TextTrack';
    shaka.ads = {};
    shaka.ads.AdsStats = function () {
      this.loadTimes_ = [];
      this.skipped_ = this.playedCompletely_ = this.started_ = 0;
    };
    shaka.ads.AdsStats.prototype.addLoadTime = function (a) {
      this.loadTimes_.push(a);
    };
    shaka.ads.AdsStats.prototype.incrementStarted = function () {
      this.started_++;
    };
    shaka.ads.AdsStats.prototype.incrementPlayedCompletely = function () {
      this.playedCompletely_++;
    };
    shaka.ads.AdsStats.prototype.incrementSkipped = function () {
      this.skipped_++;
    };
    shaka.ads.AdsStats.prototype.getBlob = function () {
      return {
        loadTimes: this.loadTimes_,
        started: this.started_,
        playedCompletely: this.playedCompletely_,
        skipped: this.skipped_,
      };
    };
    shaka.ads.ClientSideAd = function (a, b) {
      var c = this;
      this.ad_ = a;
      this.manager_ = b;
      this.isPaused_ = !1;
      this.volume_ = this.manager_.getVolume();
      this.eventManager_ = new shaka.util.EventManager();
      this.eventManager_.listen(this.manager_, google.ima.AdEvent.Type.PAUSED, function () {
        c.isPaused_ = !0;
      });
      this.eventManager_.listen(this.manager_, google.ima.AdEvent.Type.RESUMED, function () {
        c.isPaused_ = !1;
      });
    };
    shaka.ads.ClientSideAd.prototype.getDuration = function () {
      return this.ad_.getDuration();
    };
    shaka.ads.ClientSideAd.prototype.getRemainingTime = function () {
      return this.manager_.getRemainingTime();
    };
    shaka.ads.ClientSideAd.prototype.isPaused = function () {
      return this.isPaused_;
    };
    shaka.ads.ClientSideAd.prototype.isSkippable = function () {
      return 0 <= this.ad_.getSkipTimeOffset();
    };
    shaka.ads.ClientSideAd.prototype.getTimeUntilSkippable = function () {
      var a = this.ad_.getSkipTimeOffset();
      a = this.getRemainingTime() - a;
      return Math.max(a, 0);
    };
    shaka.ads.ClientSideAd.prototype.canSkipNow = function () {
      return this.manager_.getAdSkippableState();
    };
    shaka.ads.ClientSideAd.prototype.skip = function () {
      return this.manager_.skip();
    };
    shaka.ads.ClientSideAd.prototype.setPaused = function (a) {
      this.isPaused_ = a;
    };
    shaka.ads.ClientSideAd.prototype.pause = function () {
      return this.manager_.pause();
    };
    shaka.ads.ClientSideAd.prototype.play = function () {
      return this.manager_.resume();
    };
    shaka.ads.ClientSideAd.prototype.getVolume = function () {
      return this.manager_.getVolume();
    };
    shaka.ads.ClientSideAd.prototype.setVolume = function (a) {
      return this.manager_.setVolume(a);
    };
    shaka.ads.ClientSideAd.prototype.isMuted = function () {
      return 0 == this.manager_.getVolume();
    };
    shaka.ads.ClientSideAd.prototype.resize = function (a, b) {
      this.manager_.resize(
        a,
        b,
        document.fullscreenElement ? google.ima.ViewMode.FULLSCREEN : google.ima.ViewMode.NORMAL,
      );
    };
    shaka.ads.ClientSideAd.prototype.setMuted = function (a) {
      a ? ((this.volume_ = this.getVolume()), this.setVolume(0)) : this.setVolume(this.volume_);
    };
    shaka.ads.ClientSideAd.prototype.getSequenceLength = function () {
      var a = this.ad_.getAdPodInfo();
      return null == a ? 1 : a.getTotalAds();
    };
    shaka.ads.ClientSideAd.prototype.getPositionInSequence = function () {
      var a = this.ad_.getAdPodInfo();
      return null == a ? 1 : a.getAdPosition();
    };
    shaka.ads.ClientSideAd.prototype.release = function () {
      this.manager_ = this.ad_ = null;
    };
    goog.exportSymbol('shaka.ads.ClientSideAd', shaka.ads.ClientSideAd);
    goog.exportProperty(shaka.ads.ClientSideAd.prototype, 'release', shaka.ads.ClientSideAd.prototype.release);
    goog.exportProperty(
      shaka.ads.ClientSideAd.prototype,
      'getPositionInSequence',
      shaka.ads.ClientSideAd.prototype.getPositionInSequence,
    );
    goog.exportProperty(
      shaka.ads.ClientSideAd.prototype,
      'getSequenceLength',
      shaka.ads.ClientSideAd.prototype.getSequenceLength,
    );
    goog.exportProperty(shaka.ads.ClientSideAd.prototype, 'setMuted', shaka.ads.ClientSideAd.prototype.setMuted);
    goog.exportProperty(shaka.ads.ClientSideAd.prototype, 'resize', shaka.ads.ClientSideAd.prototype.resize);
    goog.exportProperty(shaka.ads.ClientSideAd.prototype, 'isMuted', shaka.ads.ClientSideAd.prototype.isMuted);
    goog.exportProperty(shaka.ads.ClientSideAd.prototype, 'setVolume', shaka.ads.ClientSideAd.prototype.setVolume);
    goog.exportProperty(shaka.ads.ClientSideAd.prototype, 'getVolume', shaka.ads.ClientSideAd.prototype.getVolume);
    goog.exportProperty(shaka.ads.ClientSideAd.prototype, 'play', shaka.ads.ClientSideAd.prototype.play);
    goog.exportProperty(shaka.ads.ClientSideAd.prototype, 'pause', shaka.ads.ClientSideAd.prototype.pause);
    goog.exportProperty(shaka.ads.ClientSideAd.prototype, 'skip', shaka.ads.ClientSideAd.prototype.skip);
    goog.exportProperty(shaka.ads.ClientSideAd.prototype, 'canSkipNow', shaka.ads.ClientSideAd.prototype.canSkipNow);
    goog.exportProperty(
      shaka.ads.ClientSideAd.prototype,
      'getTimeUntilSkippable',
      shaka.ads.ClientSideAd.prototype.getTimeUntilSkippable,
    );
    goog.exportProperty(shaka.ads.ClientSideAd.prototype, 'isSkippable', shaka.ads.ClientSideAd.prototype.isSkippable);
    goog.exportProperty(shaka.ads.ClientSideAd.prototype, 'isPaused', shaka.ads.ClientSideAd.prototype.isPaused);
    goog.exportProperty(
      shaka.ads.ClientSideAd.prototype,
      'getRemainingTime',
      shaka.ads.ClientSideAd.prototype.getRemainingTime,
    );
    goog.exportProperty(shaka.ads.ClientSideAd.prototype, 'getDuration', shaka.ads.ClientSideAd.prototype.getDuration);
    shaka.ads.ClientSideAdManager = function (a, b, c, d) {
      var e = this;
      this.adContainer_ = a;
      this.video_ = b;
      this.requestAdsStartTime_ = NaN;
      this.onEvent_ = d;
      this.ad_ = null;
      this.eventManager_ = new shaka.util.EventManager();
      google.ima.settings.setLocale(c);
      a = new google.ima.AdDisplayContainer(this.adContainer_, this.video_);
      a.initialize();
      this.adsLoader_ = new google.ima.AdsLoader(a);
      this.adsLoader_.getSettings().setPlayerType('shaka-player');
      this.adsLoader_.getSettings().setPlayerVersion(shaka.Player.version);
      this.imaAdsManager_ = null;
      this.eventManager_.listenOnce(
        this.adsLoader_,
        google.ima.AdsManagerLoadedEvent.Type.ADS_MANAGER_LOADED,
        function (f) {
          e.onAdsManagerLoaded_(f);
        },
      );
      this.eventManager_.listen(this.adsLoader_, google.ima.AdEvent.Type.AD_ERROR, function (f) {
        e.onAdError_(f);
      });
      this.video_.onended = function () {
        e.adsLoader_.contentComplete();
      };
    };
    shaka.ads.ClientSideAdManager.prototype.requestAds = function (a) {
      goog.asserts.assert(
        a.adTagUrl || a.adsResponse,
        'The ad tag needs to be set up before requesting ads, or adsResponse must be filled.',
      );
      this.requestAdsStartTime_ = Date.now() / 1e3;
      this.adsLoader_.requestAds(a);
    };
    shaka.ads.ClientSideAdManager.prototype.stop = function () {
      this.imaAdsManager_.stop();
    };
    shaka.ads.ClientSideAdManager.prototype.onAdError_ = function (a) {
      shaka.log.warning('There was an ad error from the IMA SDK: ' + a.getError());
      shaka.log.warning('Resuming playback.');
      this.onAdComplete_(null);
      this.onEvent_(new shaka.util.FakeEvent(shaka.ads.AdManager.CUEPOINTS_CHANGED, { cuepoints: [] }));
    };
    shaka.ads.ClientSideAdManager.prototype.onAdsManagerLoaded_ = function (a) {
      var b = this;
      goog.asserts.assert(null != this.video_, 'Video should not be null!');
      var c = Date.now() / 1e3 - this.requestAdsStartTime_;
      this.onEvent_(new shaka.util.FakeEvent(shaka.ads.AdManager.ADS_LOADED, { loadTime: c }));
      this.imaAdsManager_ = a.getAdsManager(this.video_);
      this.onEvent_(
        new shaka.util.FakeEvent(shaka.ads.AdManager.IMA_AD_MANAGER_LOADED, { imaAdsManager: this.imaAdsManager_ }),
      );
      c = this.imaAdsManager_.getCuePoints();
      if (c.length) {
        a = [];
        c = $jscomp.makeIterator(c);
        for (var d = c.next(); !d.done; d = c.next()) (d = new shaka.ads.CuePoint(d.value)), a.push(d);
        this.onEvent_(new shaka.util.FakeEvent(shaka.ads.AdManager.CUEPOINTS_CHANGED, { cuepoints: a }));
      }
      this.addImaEventListeners_();
      try {
        this.imaAdsManager_.init(
          this.video_.offsetWidth,
          this.video_.offsetHeight,
          document.fullscreenElement ? google.ima.ViewMode.FULLSCREEN : google.ima.ViewMode.NORMAL,
        ),
          this.eventManager_.listen(this.video_, 'loadeddata', function () {
            b.imaAdsManager_.resize(
              b.video_.offsetWidth,
              b.video_.offsetHeight,
              document.fullscreenElement ? google.ima.ViewMode.FULLSCREEN : google.ima.ViewMode.NORMAL,
            );
          }),
          this.imaAdsManager_.start();
      } catch (e) {
        this.onAdComplete_(null);
      }
    };
    shaka.ads.ClientSideAdManager.prototype.addImaEventListeners_ = function () {
      var a = this;
      this.eventManager_.listen(this.imaAdsManager_, google.ima.AdErrorEvent.Type.AD_ERROR, function (b) {
        a.onAdError_(b);
      });
      this.eventManager_.listen(this.imaAdsManager_, google.ima.AdEvent.Type.CONTENT_PAUSE_REQUESTED, function (b) {
        a.onAdStart_(b);
      });
      this.eventManager_.listen(this.imaAdsManager_, google.ima.AdEvent.Type.STARTED, function (b) {
        a.onAdStart_(b);
      });
      this.eventManager_.listen(this.imaAdsManager_, google.ima.AdEvent.Type.FIRST_QUARTILE, function (b) {
        a.onEvent_(new shaka.util.FakeEvent(shaka.ads.AdManager.AD_FIRST_QUARTILE, { originalEvent: b }));
      });
      this.eventManager_.listen(this.imaAdsManager_, google.ima.AdEvent.Type.MIDPOINT, function (b) {
        a.onEvent_(new shaka.util.FakeEvent(shaka.ads.AdManager.AD_MIDPOINT, { originalEvent: b }));
      });
      this.eventManager_.listen(this.imaAdsManager_, google.ima.AdEvent.Type.THIRD_QUARTILE, function (b) {
        a.onEvent_(new shaka.util.FakeEvent(shaka.ads.AdManager.AD_THIRD_QUARTILE, { originalEvent: b }));
      });
      this.eventManager_.listen(this.imaAdsManager_, google.ima.AdEvent.Type.COMPLETE, function (b) {
        a.onEvent_(new shaka.util.FakeEvent(shaka.ads.AdManager.AD_COMPLETE, { originalEvent: b }));
      });
      this.eventManager_.listen(this.imaAdsManager_, google.ima.AdEvent.Type.CONTENT_RESUME_REQUESTED, function (b) {
        a.onAdComplete_(b);
      });
      this.eventManager_.listen(this.imaAdsManager_, google.ima.AdEvent.Type.ALL_ADS_COMPLETED, function (b) {
        a.onAdComplete_(b);
      });
      this.eventManager_.listen(this.imaAdsManager_, google.ima.AdEvent.Type.SKIPPED, function (b) {
        a.onEvent_(new shaka.util.FakeEvent(shaka.ads.AdManager.AD_SKIPPED, { originalEvent: b }));
      });
      this.eventManager_.listen(this.imaAdsManager_, google.ima.AdEvent.Type.VOLUME_CHANGED, function (b) {
        a.onEvent_(new shaka.util.FakeEvent(shaka.ads.AdManager.AD_VOLUME_CHANGED, { originalEvent: b }));
      });
      this.eventManager_.listen(this.imaAdsManager_, google.ima.AdEvent.Type.VOLUME_MUTED, function (b) {
        a.onEvent_(new shaka.util.FakeEvent(shaka.ads.AdManager.AD_MUTED, { originalEvent: b }));
      });
      this.eventManager_.listen(this.imaAdsManager_, google.ima.AdEvent.Type.PAUSED, function (b) {
        goog.asserts.assert(null != a.ad_, 'Ad should not be null!');
        a.ad_.setPaused(!0);
        a.onEvent_(new shaka.util.FakeEvent(shaka.ads.AdManager.AD_PAUSED, { originalEvent: b }));
      });
      this.eventManager_.listen(this.imaAdsManager_, google.ima.AdEvent.Type.RESUMED, function (b) {
        goog.asserts.assert(null != a.ad_, 'Ad should not be null!');
        a.ad_.setPaused(!1);
        a.onEvent_(new shaka.util.FakeEvent(shaka.ads.AdManager.AD_RESUMED, { originalEvent: b }));
      });
      this.eventManager_.listen(this.imaAdsManager_, google.ima.AdEvent.Type.SKIPPABLE_STATE_CHANGED, function (b) {
        goog.asserts.assert(null != a.ad_, 'Ad should not be null!');
        a.onEvent_(new shaka.util.FakeEvent(shaka.ads.AdManager.AD_SKIP_STATE_CHANGED, { originalEvent: b }));
      });
      this.eventManager_.listen(this.imaAdsManager_, google.ima.AdEvent.Type.CLICK, function (b) {
        a.onEvent_(new shaka.util.FakeEvent(shaka.ads.AdManager.AD_CLICKED));
      });
      this.eventManager_.listen(this.imaAdsManager_, google.ima.AdEvent.Type.AD_PROGRESS, function (b) {
        a.onEvent_(new shaka.util.FakeEvent(shaka.ads.AdManager.AD_PROGRESS, { originalEvent: b }));
      });
      this.eventManager_.listen(this.imaAdsManager_, google.ima.AdEvent.Type.AD_BUFFERING, function (b) {
        a.onEvent_(new shaka.util.FakeEvent(shaka.ads.AdManager.AD_BUFFERING, { originalEvent: b }));
      });
      this.eventManager_.listen(this.imaAdsManager_, google.ima.AdEvent.Type.IMPRESSION, function (b) {
        a.onEvent_(new shaka.util.FakeEvent(shaka.ads.AdManager.AD_IMPRESSION, { originalEvent: b }));
      });
      this.eventManager_.listen(this.imaAdsManager_, google.ima.AdEvent.Type.DURATION_CHANGE, function (b) {
        a.onEvent_(new shaka.util.FakeEvent(shaka.ads.AdManager.AD_DURATION_CHANGED, { originalEvent: b }));
      });
      this.eventManager_.listen(this.imaAdsManager_, google.ima.AdEvent.Type.USER_CLOSE, function (b) {
        a.onEvent_(new shaka.util.FakeEvent(shaka.ads.AdManager.AD_CLOSED, { originalEvent: b }));
      });
      this.eventManager_.listen(this.imaAdsManager_, google.ima.AdEvent.Type.LOADED, function (b) {
        a.onEvent_(new shaka.util.FakeEvent(shaka.ads.AdManager.AD_LOADED, { originalEvent: b }));
      });
      this.eventManager_.listen(this.imaAdsManager_, google.ima.AdEvent.Type.ALL_ADS_COMPLETED, function (b) {
        a.onEvent_(new shaka.util.FakeEvent(shaka.ads.AdManager.ALL_ADS_COMPLETED, { originalEvent: b }));
      });
      this.eventManager_.listen(this.imaAdsManager_, google.ima.AdEvent.Type.LINEAR_CHANGED, function (b) {
        a.onEvent_(new shaka.util.FakeEvent(shaka.ads.AdManager.AD_LINEAR_CHANGED, { originalEvent: b }));
      });
      this.eventManager_.listen(this.imaAdsManager_, google.ima.AdEvent.Type.AD_METADATA, function (b) {
        a.onEvent_(new shaka.util.FakeEvent(shaka.ads.AdManager.AD_METADATA, { originalEvent: b }));
      });
      this.eventManager_.listen(this.imaAdsManager_, google.ima.AdEvent.Type.LOG, function (b) {
        a.onEvent_(new shaka.util.FakeEvent(shaka.ads.AdManager.AD_RECOVERABLE_ERROR, { originalEvent: b }));
      });
      this.eventManager_.listen(this.imaAdsManager_, google.ima.AdEvent.Type.AD_BREAK_READY, function (b) {
        a.onEvent_(new shaka.util.FakeEvent(shaka.ads.AdManager.AD_BREAK_READY, { originalEvent: b }));
      });
      this.eventManager_.listen(this.imaAdsManager_, google.ima.AdEvent.Type.INTERACTION, function (b) {
        a.onEvent_(new shaka.util.FakeEvent(shaka.ads.AdManager.AD_INTERACTION, { originalEvent: b }));
      });
    };
    shaka.ads.ClientSideAdManager.prototype.onAdStart_ = function (a) {
      goog.asserts.assert(this.imaAdsManager_, 'Should have an ads manager at this point!');
      var b = a.getAd();
      this.ad_ = new shaka.ads.ClientSideAd(b, this.imaAdsManager_);
      this.onEvent_(
        new shaka.util.FakeEvent(shaka.ads.AdManager.AD_STARTED, { ad: this.ad_, sdkAdObject: b, originalEvent: a }),
      );
      this.adContainer_.setAttribute('ad-active', 'true');
      this.video_.pause();
    };
    shaka.ads.ClientSideAdManager.prototype.onAdComplete_ = function (a) {
      this.onEvent_(new shaka.util.FakeEvent(shaka.ads.AdManager.AD_STOPPED, { originalEvent: a }));
      this.adContainer_.removeAttribute('ad-active');
      this.video_.play();
    };
    shaka.ads.ServerSideAd = function (a, b) {
      this.ad_ = a;
      this.adProgressData_ = null;
      this.video_ = b;
    };
    shaka.ads.ServerSideAd.prototype.setProgressData = function (a) {
      this.adProgressData_ = a;
    };
    shaka.ads.ServerSideAd.prototype.getDuration = function () {
      return this.adProgressData_ ? this.adProgressData_.duration : -1;
    };
    shaka.ads.ServerSideAd.prototype.getRemainingTime = function () {
      return this.adProgressData_ ? this.adProgressData_.duration - this.adProgressData_.currentTime : -1;
    };
    shaka.ads.ServerSideAd.prototype.isPaused = function () {
      return this.video_.paused;
    };
    shaka.ads.ServerSideAd.prototype.isSkippable = function () {
      return this.ad_.isSkippable();
    };
    shaka.ads.ServerSideAd.prototype.getTimeUntilSkippable = function () {
      var a = this.ad_.getSkipTimeOffset();
      a = this.getRemainingTime() - a;
      return Math.max(a, 0);
    };
    shaka.ads.ServerSideAd.prototype.canSkipNow = function () {
      return 0 == this.getTimeUntilSkippable();
    };
    shaka.ads.ServerSideAd.prototype.skip = function () {
      this.video_.currentTime += this.getRemainingTime();
    };
    shaka.ads.ServerSideAd.prototype.pause = function () {
      return this.video_.pause();
    };
    shaka.ads.ServerSideAd.prototype.play = function () {
      return this.video_.play();
    };
    shaka.ads.ServerSideAd.prototype.getVolume = function () {
      return this.video_.volume;
    };
    shaka.ads.ServerSideAd.prototype.setVolume = function (a) {
      this.video_.volume = a;
    };
    shaka.ads.ServerSideAd.prototype.isMuted = function () {
      return this.video_.muted;
    };
    shaka.ads.ServerSideAd.prototype.resize = function (a, b) {};
    shaka.ads.ServerSideAd.prototype.setMuted = function (a) {
      this.video_.muted = a;
    };
    shaka.ads.ServerSideAd.prototype.getSequenceLength = function () {
      var a = this.ad_.getAdPodInfo();
      return null == a ? 1 : a.getTotalAds();
    };
    shaka.ads.ServerSideAd.prototype.getPositionInSequence = function () {
      var a = this.ad_.getAdPodInfo();
      return null == a ? 1 : a.getAdPosition();
    };
    shaka.ads.ServerSideAd.prototype.release = function () {
      this.video_ = this.adProgressData_ = this.ad_ = null;
    };
    goog.exportSymbol('shaka.ads.ServerSideAd', shaka.ads.ServerSideAd);
    goog.exportProperty(shaka.ads.ServerSideAd.prototype, 'release', shaka.ads.ServerSideAd.prototype.release);
    goog.exportProperty(
      shaka.ads.ServerSideAd.prototype,
      'getPositionInSequence',
      shaka.ads.ServerSideAd.prototype.getPositionInSequence,
    );
    goog.exportProperty(
      shaka.ads.ServerSideAd.prototype,
      'getSequenceLength',
      shaka.ads.ServerSideAd.prototype.getSequenceLength,
    );
    goog.exportProperty(shaka.ads.ServerSideAd.prototype, 'setMuted', shaka.ads.ServerSideAd.prototype.setMuted);
    goog.exportProperty(shaka.ads.ServerSideAd.prototype, 'resize', shaka.ads.ServerSideAd.prototype.resize);
    goog.exportProperty(shaka.ads.ServerSideAd.prototype, 'isMuted', shaka.ads.ServerSideAd.prototype.isMuted);
    goog.exportProperty(shaka.ads.ServerSideAd.prototype, 'setVolume', shaka.ads.ServerSideAd.prototype.setVolume);
    goog.exportProperty(shaka.ads.ServerSideAd.prototype, 'getVolume', shaka.ads.ServerSideAd.prototype.getVolume);
    goog.exportProperty(shaka.ads.ServerSideAd.prototype, 'play', shaka.ads.ServerSideAd.prototype.play);
    goog.exportProperty(shaka.ads.ServerSideAd.prototype, 'pause', shaka.ads.ServerSideAd.prototype.pause);
    goog.exportProperty(shaka.ads.ServerSideAd.prototype, 'skip', shaka.ads.ServerSideAd.prototype.skip);
    goog.exportProperty(shaka.ads.ServerSideAd.prototype, 'canSkipNow', shaka.ads.ServerSideAd.prototype.canSkipNow);
    goog.exportProperty(
      shaka.ads.ServerSideAd.prototype,
      'getTimeUntilSkippable',
      shaka.ads.ServerSideAd.prototype.getTimeUntilSkippable,
    );
    goog.exportProperty(shaka.ads.ServerSideAd.prototype, 'isSkippable', shaka.ads.ServerSideAd.prototype.isSkippable);
    goog.exportProperty(shaka.ads.ServerSideAd.prototype, 'isPaused', shaka.ads.ServerSideAd.prototype.isPaused);
    goog.exportProperty(
      shaka.ads.ServerSideAd.prototype,
      'getRemainingTime',
      shaka.ads.ServerSideAd.prototype.getRemainingTime,
    );
    goog.exportProperty(shaka.ads.ServerSideAd.prototype, 'getDuration', shaka.ads.ServerSideAd.prototype.getDuration);
    shaka.ads.ServerSideAdManager = function (a, b, c, d) {
      var e = this;
      this.adContainer_ = a;
      this.video_ = b;
      this.streamPromise_ = null;
      this.streamRequestStartTime_ = NaN;
      this.onEvent_ = d;
      this.isLiveContent_ = !1;
      this.adProgressData_ = this.ad_ = this.snapForwardTime_ = null;
      this.backupUrl_ = '';
      this.eventManager_ = new shaka.util.EventManager();
      a = new google.ima.dai.api.UiSettings();
      a.setLocale(c);
      this.streamManager_ = new google.ima.dai.api.StreamManager(this.video_, this.adContainer_, a);
      this.eventManager_.listen(this.streamManager_, google.ima.dai.api.StreamEvent.Type.LOADED, function (f) {
        shaka.log.info('Ad SS Loaded');
        e.onLoaded_(f);
      });
      this.eventManager_.listen(this.streamManager_, google.ima.dai.api.StreamEvent.Type.ERROR, function () {
        shaka.log.info('Ad SS Error');
        e.onError_();
      });
      this.eventManager_.listen(this.streamManager_, google.ima.dai.api.StreamEvent.Type.AD_BREAK_STARTED, function () {
        shaka.log.info('Ad Break Started');
      });
      this.eventManager_.listen(this.streamManager_, google.ima.dai.api.StreamEvent.Type.STARTED, function (f) {
        shaka.log.info('Ad Started');
        e.onAdStart_(f);
      });
      this.eventManager_.listen(this.streamManager_, google.ima.dai.api.StreamEvent.Type.AD_BREAK_ENDED, function () {
        shaka.log.info('Ad Break Ended');
        e.onAdBreakEnded_();
      });
      this.eventManager_.listen(this.streamManager_, google.ima.dai.api.StreamEvent.Type.AD_PROGRESS, function (f) {
        e.onAdProgress_(f);
      });
      this.eventManager_.listen(this.streamManager_, google.ima.dai.api.StreamEvent.Type.FIRST_QUARTILE, function () {
        shaka.log.info('Ad event: First Quartile');
        e.onEvent_(new shaka.util.FakeEvent(shaka.ads.AdManager.AD_FIRST_QUARTILE));
      });
      this.eventManager_.listen(this.streamManager_, google.ima.dai.api.StreamEvent.Type.MIDPOINT, function () {
        shaka.log.info('Ad event: Midpoint');
        e.onEvent_(new shaka.util.FakeEvent(shaka.ads.AdManager.AD_MIDPOINT));
      });
      this.eventManager_.listen(this.streamManager_, google.ima.dai.api.StreamEvent.Type.THIRD_QUARTILE, function () {
        shaka.log.info('Ad event: Third Quartile');
        e.onEvent_(new shaka.util.FakeEvent(shaka.ads.AdManager.AD_THIRD_QUARTILE));
      });
      this.eventManager_.listen(this.streamManager_, google.ima.dai.api.StreamEvent.Type.COMPLETE, function () {
        shaka.log.info('Ad event: Complete');
        e.onEvent_(new shaka.util.FakeEvent(shaka.ads.AdManager.AD_COMPLETE));
        e.onEvent_(new shaka.util.FakeEvent(shaka.ads.AdManager.AD_STOPPED));
        e.adContainer_.removeAttribute('ad-active');
        e.ad_ = null;
      });
      this.eventManager_.listen(this.streamManager_, google.ima.dai.api.StreamEvent.Type.SKIPPED, function () {
        shaka.log.info('Ad event: Skipped');
        e.onEvent_(new shaka.util.FakeEvent(shaka.ads.AdManager.AD_SKIPPED));
        e.onEvent_(new shaka.util.FakeEvent(shaka.ads.AdManager.AD_STOPPED));
      });
      this.eventManager_.listen(
        this.streamManager_,
        google.ima.dai.api.StreamEvent.Type.CUEPOINTS_CHANGED,
        function (f) {
          shaka.log.info('Ad event: Cue points changed');
          e.onCuePointsChanged_(f);
        },
      );
    };
    shaka.ads.ServerSideAdManager.prototype.streamRequest = function (a, b) {
      if (this.streamPromise_)
        return Promise.reject(
          new shaka.util.Error(
            shaka.util.Error.Severity.RECOVERABLE,
            shaka.util.Error.Category.ADS,
            shaka.util.Error.Code.CURRENT_DAI_REQUEST_NOT_FINISHED,
          ),
        );
      a instanceof google.ima.dai.api.LiveStreamRequest && (this.isLiveContent_ = !0);
      this.streamPromise_ = new shaka.util.PublicPromise();
      this.streamManager_.requestStream(a);
      this.backupUrl_ = b || '';
      this.streamRequestStartTime_ = Date.now() / 1e3;
      return this.streamPromise_;
    };
    shaka.ads.ServerSideAdManager.prototype.replaceAdTagParameters = function (a) {
      this.streamManager_.replaceAdTagParameters(a);
    };
    shaka.ads.ServerSideAdManager.prototype.stop = function () {
      this.streamManager_.reset();
      this.backupUrl_ = '';
      this.snapForwardTime_ = null;
    };
    shaka.ads.ServerSideAdManager.prototype.onTimedMetadata = function (a, b, c) {
      this.streamManager_.processMetadata(a, b, c);
    };
    shaka.ads.ServerSideAdManager.prototype.onCueMetadataChange = function (a) {
      if (a.key && a.data) {
        var b = {};
        b[a.key] = a.data;
        this.streamManager_.onTimedMetadata(b);
      }
    };
    shaka.ads.ServerSideAdManager.prototype.checkForSnapback_ = function () {
      var a = this.video_.currentTime;
      if (0 != a) {
        this.streamManager_.streamTimeForContentTime(a);
        var b = this.streamManager_.previousCuePointForStreamTime(a);
        b &&
          !b.played &&
          (shaka.log.info('Seeking back to the start of the ad break at ' + b.start + ' and will return to ' + a),
          (this.snapForwardTime_ = a),
          (this.video_.currentTime = b.start));
      }
    };
    shaka.ads.ServerSideAdManager.prototype.onAdStart_ = function (a) {
      goog.asserts.assert(this.streamManager_, 'Should have a stream manager at this point!');
      a = a.getAd();
      this.ad_ = new shaka.ads.ServerSideAd(a, this.video_);
      this.adProgressData_ && this.ad_.setProgressData(this.adProgressData_);
      this.onEvent_(new shaka.util.FakeEvent(shaka.ads.AdManager.AD_STARTED, { ad: this.ad_ }));
      this.adContainer_.setAttribute('ad-active', 'true');
    };
    shaka.ads.ServerSideAdManager.prototype.onAdBreakEnded_ = function () {
      this.adContainer_.removeAttribute('ad-active');
      var a = this.video_.currentTime;
      this.snapForwardTime_ &&
        this.snapForwardTime_ > a &&
        ((this.video_.currentTime = this.snapForwardTime_), (this.snapForwardTime_ = null));
    };
    shaka.ads.ServerSideAdManager.prototype.onLoaded_ = function (a) {
      var b = this,
        c = Date.now() / 1e3 - this.streamRequestStartTime_;
      this.onEvent_(new shaka.util.FakeEvent(shaka.ads.AdManager.ADS_LOADED, { loadTime: c }));
      a = a.getStreamData().url;
      this.streamPromise_.resolve(a);
      this.streamPromise_ = null;
      this.isLiveContent_ ||
        this.eventManager_.listen(this.video_, 'seeked', function () {
          b.checkForSnapback_();
        });
    };
    shaka.ads.ServerSideAdManager.prototype.onError_ = function () {
      this.backupUrl_.length
        ? (shaka.log.warning('IMA stream request returned an error. Falling back to the backup asset uri.'),
          this.streamPromise_.resolve(this.backupUrl_))
        : this.streamPromise_.reject(
            'IMA Stream request returned an error and there was no backup asset uri provided.',
          );
      this.streamPromise_ = null;
    };
    shaka.ads.ServerSideAdManager.prototype.onAdProgress_ = function (a) {
      this.adProgressData_ = a.getStreamData().adProgressData;
      this.ad_ && this.ad_.setProgressData(this.adProgressData_);
    };
    shaka.ads.ServerSideAdManager.prototype.onCuePointsChanged_ = function (a) {
      var b = a.getStreamData();
      a = [];
      b = $jscomp.makeIterator(b.cuepoints);
      for (var c = b.next(); !c.done; c = b.next())
        (c = c.value), (c = new shaka.ads.CuePoint(c.start, c.end)), a.push(c);
      this.onEvent_(new shaka.util.FakeEvent(shaka.ads.AdManager.CUEPOINTS_CHANGED, { cuepoints: a }));
    };
    shaka.ads.AdManager = function () {
      shaka.util.FakeEventTarget.call(this);
      this.ssAdManager_ = this.csAdManager_ = null;
      this.stats_ = new shaka.ads.AdsStats();
      this.locale_ = navigator.language;
    };
    $jscomp.inherits(shaka.ads.AdManager, shaka.util.FakeEventTarget);
    shaka.ads.AdManager.prototype.setLocale = function (a) {
      this.locale_ = a;
    };
    shaka.ads.AdManager.prototype.initClientSide = function (a, b) {
      var c = this;
      if (!window.google || !google.ima || !google.ima.AdsLoader)
        throw new shaka.util.Error(
          shaka.util.Error.Severity.CRITICAL,
          shaka.util.Error.Category.ADS,
          shaka.util.Error.Code.CS_IMA_SDK_MISSING,
        );
      this.csAdManager_ = new shaka.ads.ClientSideAdManager(a, b, this.locale_, function (d) {
        if (d && d.type)
          switch (d.type) {
            case shaka.ads.AdManager.ADS_LOADED:
              c.stats_.addLoadTime(d.loadTime);
              break;
            case shaka.ads.AdManager.AD_STARTED:
              c.stats_.incrementStarted();
              break;
            case shaka.ads.AdManager.AD_COMPLETE:
              c.stats_.incrementPlayedCompletely();
              break;
            case shaka.ads.AdManager.AD_SKIPPED:
              c.stats_.incrementSkipped();
          }
        c.dispatchEvent(d);
      });
    };
    shaka.ads.AdManager.prototype.onAssetUnload = function () {
      this.csAdManager_ && this.csAdManager_.stop();
      this.dispatchEvent(new shaka.util.FakeEvent(shaka.ads.AdManager.AD_STOPPED));
      this.stats_ = new shaka.ads.AdsStats();
    };
    shaka.ads.AdManager.prototype.requestClientSideAds = function (a) {
      if (!this.csAdManager_)
        throw new shaka.util.Error(
          shaka.util.Error.Severity.RECOVERABLE,
          shaka.util.Error.Category.ADS,
          shaka.util.Error.Code.CS_AD_MANAGER_NOT_INITIALIZED,
        );
      this.csAdManager_.requestAds(a);
    };
    shaka.ads.AdManager.prototype.initServerSide = function (a, b) {
      var c = this;
      if (!window.google || !google.ima || !google.ima.dai)
        throw new shaka.util.Error(
          shaka.util.Error.Severity.CRITICAL,
          shaka.util.Error.Category.ADS,
          shaka.util.Error.Code.SS_IMA_SDK_MISSING,
        );
      this.ssAdManager_ = new shaka.ads.ServerSideAdManager(a, b, this.locale_, function (d) {
        if (d && d.type)
          switch (d.type) {
            case shaka.ads.AdManager.ADS_LOADED:
              c.stats_.addLoadTime(d.loadTime);
              break;
            case shaka.ads.AdManager.AD_STARTED:
              c.stats_.incrementStarted();
              break;
            case shaka.ads.AdManager.AD_COMPLETE:
              c.stats_.incrementPlayedCompletely();
              break;
            case shaka.ads.AdManager.AD_SKIPPED:
              c.stats_.incrementSkipped();
          }
        c.dispatchEvent(d);
      });
    };
    shaka.ads.AdManager.prototype.requestServerSideStream = function (a, b) {
      b = void 0 === b ? '' : b;
      if (!this.ssAdManager_)
        throw new shaka.util.Error(
          shaka.util.Error.Severity.RECOVERABLE,
          shaka.util.Error.Category.ADS,
          shaka.util.Error.Code.SS_AD_MANAGER_NOT_INITIALIZED,
        );
      a.adTagParameters || (a.adTagParameters = {});
      var c = a.adTagParameters;
      (c.mpt || c.mpv) &&
        shaka.log.alwaysWarn(
          'You have attempted to set "mpt" and/or "mpv" parameters of the ad tag. Please note that those parameters are used for Shaka adoption tracking and will be overriden.',
        );
      a.adTagParameters.mpt = 'Shaka Player';
      a.adTagParameters.mpv = shaka.Player.version;
      return this.ssAdManager_.streamRequest(a, b);
    };
    shaka.ads.AdManager.prototype.replaceServerSideAdTagParameters = function (a) {
      if (!this.ssAdManager_)
        throw new shaka.util.Error(
          shaka.util.Error.Severity.RECOVERABLE,
          shaka.util.Error.Category.ADS,
          shaka.util.Error.Code.SS_AD_MANAGER_NOT_INITIALIZED,
        );
      (a.mpt || a.mpv) &&
        shaka.log.alwaysWarn(
          'You have attempted to set "mpt" and/or "mpv" parameters of the ad tag. Please note that those parameters are used for Shaka adoption tracking and will be overriden.',
        );
      a.mpt = 'Shaka Player';
      a.mpv = shaka.Player.version;
      this.ssAdManager_.replaceAdTagParameters(a);
    };
    shaka.ads.AdManager.prototype.getStats = function () {
      return this.stats_.getBlob();
    };
    shaka.ads.AdManager.prototype.onDashTimedMetadata = function (a) {
      if (this.ssAdManager_ && 'urn:google:dai:2018' == a.schemeIdUri) {
        var b = a.schemeIdUri,
          c = a.eventElement ? a.eventElement.getAttribute('messageData') : null;
        this.ssAdManager_.onTimedMetadata(b, c, a.startTime);
      }
    };
    shaka.ads.AdManager.prototype.onHlsTimedMetadata = function (a, b) {
      if (this.ssAdManager_) this.ssAdManager_.onTimedMetadata('ID3', a.data, b);
      else
        shaka.log.warning(
          'ID3 metadata processing was called without initializing server side ad logic. Ad-related metadata will not take effect',
        );
    };
    shaka.ads.AdManager.prototype.onCueMetadataChange = function (a) {
      if (this.ssAdManager_) this.ssAdManager_.onCueMetadataChange(a);
      else
        shaka.log.warning(
          'ID3 metadata processing was called without initializing server side ad logic. Ad-related metadata will not take effect',
        );
    };
    goog.exportSymbol('shaka.ads.AdManager', shaka.ads.AdManager);
    goog.exportProperty(
      shaka.ads.AdManager.prototype,
      'onCueMetadataChange',
      shaka.ads.AdManager.prototype.onCueMetadataChange,
    );
    goog.exportProperty(
      shaka.ads.AdManager.prototype,
      'onHlsTimedMetadata',
      shaka.ads.AdManager.prototype.onHlsTimedMetadata,
    );
    goog.exportProperty(
      shaka.ads.AdManager.prototype,
      'onDashTimedMetadata',
      shaka.ads.AdManager.prototype.onDashTimedMetadata,
    );
    goog.exportProperty(shaka.ads.AdManager.prototype, 'getStats', shaka.ads.AdManager.prototype.getStats);
    goog.exportProperty(
      shaka.ads.AdManager.prototype,
      'replaceServerSideAdTagParameters',
      shaka.ads.AdManager.prototype.replaceServerSideAdTagParameters,
    );
    goog.exportProperty(
      shaka.ads.AdManager.prototype,
      'requestServerSideStream',
      shaka.ads.AdManager.prototype.requestServerSideStream,
    );
    goog.exportProperty(shaka.ads.AdManager.prototype, 'initServerSide', shaka.ads.AdManager.prototype.initServerSide);
    goog.exportProperty(
      shaka.ads.AdManager.prototype,
      'requestClientSideAds',
      shaka.ads.AdManager.prototype.requestClientSideAds,
    );
    goog.exportProperty(shaka.ads.AdManager.prototype, 'onAssetUnload', shaka.ads.AdManager.prototype.onAssetUnload);
    goog.exportProperty(shaka.ads.AdManager.prototype, 'initClientSide', shaka.ads.AdManager.prototype.initClientSide);
    goog.exportProperty(shaka.ads.AdManager.prototype, 'setLocale', shaka.ads.AdManager.prototype.setLocale);
    shaka.ads.CuePoint = function (a, b) {
      this.start = a;
      this.end = void 0 === b ? null : b;
    };
    shaka.ads.AdManager.ADS_LOADED = 'ads-loaded';
    goog.exportProperty(shaka.ads.AdManager, 'ADS_LOADED', shaka.ads.AdManager.ADS_LOADED);
    shaka.ads.AdManager.AD_STARTED = 'ad-started';
    goog.exportProperty(shaka.ads.AdManager, 'AD_STARTED', shaka.ads.AdManager.AD_STARTED);
    shaka.ads.AdManager.AD_FIRST_QUARTILE = 'ad-first-quartile';
    goog.exportProperty(shaka.ads.AdManager, 'AD_FIRST_QUARTILE', shaka.ads.AdManager.AD_FIRST_QUARTILE);
    shaka.ads.AdManager.AD_MIDPOINT = 'ad-midpoint';
    goog.exportProperty(shaka.ads.AdManager, 'AD_MIDPOINT', shaka.ads.AdManager.AD_MIDPOINT);
    shaka.ads.AdManager.AD_THIRD_QUARTILE = 'ad-third-quartile';
    goog.exportProperty(shaka.ads.AdManager, 'AD_THIRD_QUARTILE', shaka.ads.AdManager.AD_THIRD_QUARTILE);
    shaka.ads.AdManager.AD_COMPLETE = 'ad-complete';
    goog.exportProperty(shaka.ads.AdManager, 'AD_COMPLETE', shaka.ads.AdManager.AD_COMPLETE);
    shaka.ads.AdManager.AD_STOPPED = 'ad-stopped';
    goog.exportProperty(shaka.ads.AdManager, 'AD_STOPPED', shaka.ads.AdManager.AD_STOPPED);
    shaka.ads.AdManager.AD_SKIPPED = 'ad-skipped';
    goog.exportProperty(shaka.ads.AdManager, 'AD_SKIPPED', shaka.ads.AdManager.AD_SKIPPED);
    shaka.ads.AdManager.AD_VOLUME_CHANGED = 'ad-volume-changed';
    goog.exportProperty(shaka.ads.AdManager, 'AD_VOLUME_CHANGED', shaka.ads.AdManager.AD_VOLUME_CHANGED);
    shaka.ads.AdManager.AD_MUTED = 'ad-muted';
    goog.exportProperty(shaka.ads.AdManager, 'AD_MUTED', shaka.ads.AdManager.AD_MUTED);
    shaka.ads.AdManager.AD_PAUSED = 'ad-paused';
    goog.exportProperty(shaka.ads.AdManager, 'AD_PAUSED', shaka.ads.AdManager.AD_PAUSED);
    shaka.ads.AdManager.AD_RESUMED = 'ad-resumed';
    goog.exportProperty(shaka.ads.AdManager, 'AD_RESUMED', shaka.ads.AdManager.AD_RESUMED);
    shaka.ads.AdManager.AD_SKIP_STATE_CHANGED = 'ad-skip-state-changed';
    goog.exportProperty(shaka.ads.AdManager, 'AD_SKIP_STATE_CHANGED', shaka.ads.AdManager.AD_SKIP_STATE_CHANGED);
    shaka.ads.AdManager.CUEPOINTS_CHANGED = 'ad-cue-points-changed';
    goog.exportProperty(shaka.ads.AdManager, 'CUEPOINTS_CHANGED', shaka.ads.AdManager.CUEPOINTS_CHANGED);
    shaka.ads.AdManager.IMA_AD_MANAGER_LOADED = 'ima-ad-manager-loaded';
    goog.exportProperty(shaka.ads.AdManager, 'IMA_AD_MANAGER_LOADED', shaka.ads.AdManager.IMA_AD_MANAGER_LOADED);
    shaka.ads.AdManager.AD_CLICKED = 'ad-clicked';
    goog.exportProperty(shaka.ads.AdManager, 'AD_CLICKED', shaka.ads.AdManager.AD_CLICKED);
    shaka.ads.AdManager.AD_PROGRESS = 'ad-progress';
    goog.exportProperty(shaka.ads.AdManager, 'AD_PROGRESS', shaka.ads.AdManager.AD_PROGRESS);
    shaka.ads.AdManager.AD_BUFFERING = 'ad-buffering';
    goog.exportProperty(shaka.ads.AdManager, 'AD_BUFFERING', shaka.ads.AdManager.AD_BUFFERING);
    shaka.ads.AdManager.AD_IMPRESSION = 'ad-impression';
    goog.exportProperty(shaka.ads.AdManager, 'AD_IMPRESSION', shaka.ads.AdManager.AD_IMPRESSION);
    shaka.ads.AdManager.AD_DURATION_CHANGED = 'ad-duration-changed';
    goog.exportProperty(shaka.ads.AdManager, 'AD_DURATION_CHANGED', shaka.ads.AdManager.AD_DURATION_CHANGED);
    shaka.ads.AdManager.AD_CLOSED = 'ad-closed';
    goog.exportProperty(shaka.ads.AdManager, 'AD_CLOSED', shaka.ads.AdManager.AD_CLOSED);
    shaka.ads.AdManager.AD_LOADED = 'ad-loaded';
    goog.exportProperty(shaka.ads.AdManager, 'AD_LOADED', shaka.ads.AdManager.AD_LOADED);
    shaka.ads.AdManager.ALL_ADS_COMPLETED = 'all-ads-completed';
    goog.exportProperty(shaka.ads.AdManager, 'ALL_ADS_COMPLETED', shaka.ads.AdManager.ALL_ADS_COMPLETED);
    shaka.ads.AdManager.AD_LINEAR_CHANGED = 'ad-linear-changed';
    goog.exportProperty(shaka.ads.AdManager, 'AD_LINEAR_CHANGED', shaka.ads.AdManager.AD_LINEAR_CHANGED);
    shaka.ads.AdManager.AD_METADATA = 'ad-metadata';
    goog.exportProperty(shaka.ads.AdManager, 'AD_METADATA', shaka.ads.AdManager.AD_METADATA);
    shaka.ads.AdManager.AD_RECOVERABLE_ERROR = 'ad-recoverable-error';
    goog.exportProperty(shaka.ads.AdManager, 'AD_RECOVERABLE_ERROR', shaka.ads.AdManager.AD_RECOVERABLE_ERROR);
    shaka.ads.AdManager.AD_BREAK_READY = 'ad-break-ready';
    goog.exportProperty(shaka.ads.AdManager, 'AD_BREAK_READY', shaka.ads.AdManager.AD_BREAK_READY);
    shaka.ads.AdManager.AD_INTERACTION = 'ad-interaction';
    goog.exportProperty(shaka.ads.AdManager, 'AD_INTERACTION', shaka.ads.AdManager.AD_INTERACTION);
    shaka.Player.setAdManagerFactory(function () {
      return new shaka.ads.AdManager();
    });
    shaka.cast = {};
    shaka.cast.CastUtils = function () {};
    shaka.cast.CastUtils.serialize = function (a) {
      return JSON.stringify(a, function (b, c) {
        if ('function' != typeof c) {
          if (c instanceof Event || c instanceof shaka.util.FakeEvent) {
            var d = {},
              e;
            for (e in c) {
              var f = c[e];
              f && 'object' == typeof f ? 'detail' == e && (d[e] = f) : e in Event || (d[e] = f);
            }
            return d;
          }
          return c instanceof Error
            ? shaka.cast.CastUtils.unpackError_(c)
            : c instanceof TimeRanges
            ? shaka.cast.CastUtils.unpackTimeRanges_(c)
            : c instanceof Uint8Array
            ? shaka.cast.CastUtils.unpackUint8Array_(c)
            : 'number' == typeof c
            ? isNaN(c)
              ? 'NaN'
              : isFinite(c)
              ? c
              : 0 > c
              ? '-Infinity'
              : 'Infinity'
            : c;
        }
      });
    };
    shaka.cast.CastUtils.deserialize = function (a) {
      return JSON.parse(a, function (b, c) {
        return 'NaN' == c
          ? NaN
          : '-Infinity' == c
          ? -Infinity
          : 'Infinity' == c
          ? Infinity
          : c && 'object' == typeof c && 'TimeRanges' == c.__type__
          ? shaka.cast.CastUtils.simulateTimeRanges_(c)
          : c && 'object' == typeof c && 'Uint8Array' == c.__type__
          ? shaka.cast.CastUtils.makeUint8Array_(c)
          : c && 'object' == typeof c && 'Error' == c.__type__
          ? shaka.cast.CastUtils.makeError_(c)
          : c;
      });
    };
    shaka.cast.CastUtils.unpackTimeRanges_ = function (a) {
      var b = { __type__: 'TimeRanges', length: a.length, start: [], end: [] };
      a = $jscomp.makeIterator(shaka.media.TimeRangesUtils.getBufferedInfo(a));
      for (var c = a.next(); !c.done; c = a.next()) {
        c = c.value;
        var d = c.end;
        b.start.push(c.start);
        b.end.push(d);
      }
      return b;
    };
    shaka.cast.CastUtils.simulateTimeRanges_ = function (a) {
      return {
        length: a.length,
        start: function (b) {
          return a.start[b];
        },
        end: function (b) {
          return a.end[b];
        },
      };
    };
    shaka.cast.CastUtils.unpackUint8Array_ = function (a) {
      return { __type__: 'Uint8Array', entries: Array.from(a) };
    };
    shaka.cast.CastUtils.makeUint8Array_ = function (a) {
      return new Uint8Array(a.entries);
    };
    shaka.cast.CastUtils.unpackError_ = function (a) {
      var b = new Set(['name', 'message', 'stack']),
        c;
      for (c in a) b.add(c);
      var d = $jscomp.makeIterator(Object.getOwnPropertyNames(a));
      for (c = d.next(); !c.done; c = d.next()) b.add(c.value);
      d = {};
      b = $jscomp.makeIterator(b);
      for (c = b.next(); !c.done; c = b.next()) (c = c.value), (d[c] = a[c]);
      return { __type__: 'Error', contents: d };
    };
    shaka.cast.CastUtils.makeError_ = function (a) {
      a = a.contents;
      var b = Error(a.message),
        c;
      for (c in a) b[c] = a[c];
      return b;
    };
    shaka.cast.CastUtils.VideoEvents = 'ended play playing pause pausing ratechange seeked seeking timeupdate volumechange'.split(
      ' ',
    );
    shaka.cast.CastUtils.VideoAttributes = 'buffered currentTime duration ended loop muted paused playbackRate seeking videoHeight videoWidth volume'.split(
      ' ',
    );
    shaka.cast.CastUtils.VideoInitStateAttributes = ['loop', 'playbackRate'];
    shaka.cast.CastUtils.VideoVoidMethods = ['pause', 'play'];
    shaka.cast.CastUtils.PlayerGetterMethods = {
      getAssetUri: 2,
      getAudioLanguages: 2,
      getAudioLanguagesAndRoles: 2,
      getBufferedInfo: 2,
      getConfiguration: 2,
      getExpiration: 2,
      getPlaybackRate: 2,
      getTextLanguages: 2,
      getTextLanguagesAndRoles: 2,
      getTextTracks: 2,
      getStats: 5,
      getVariantTracks: 2,
      isAudioOnly: 10,
      isBuffering: 1,
      isInProgress: 1,
      isLive: 10,
      isTextTrackVisible: 1,
      keySystem: 10,
      seekRange: 1,
      getLoadMode: 10,
    };
    shaka.cast.CastUtils.PlayerGetterMethodsThatRequireLive = {
      getPlayheadTimeAsDate: 1,
      getPresentationStartTimeAsDate: 20,
    };
    shaka.cast.CastUtils.PlayerInitState = [['getConfiguration', 'configure']];
    shaka.cast.CastUtils.PlayerInitAfterLoadState = [['isTextTrackVisible', 'setTextTrackVisibility']];
    shaka.cast.CastUtils.PlayerVoidMethods = 'addTextTrack cancelTrickPlay configure resetConfiguration retryStreaming selectAudioLanguage selectTextLanguage selectTextTrack selectVariantTrack selectVariantsByLabel setTextTrackVisibility trickPlay'.split(
      ' ',
    );
    shaka.cast.CastUtils.PlayerPromiseMethods = ['attach', 'detach', 'load', 'unload'];
    shaka.cast.CastUtils.SHAKA_MESSAGE_NAMESPACE = 'urn:x-cast:com.google.shaka.v2';
    shaka.cast.CastUtils.GENERIC_MESSAGE_NAMESPACE = 'urn:x-cast:com.google.cast.media';
    shaka.cast.CastSender = function (a, b, c, d, e, f) {
      var g = this;
      this.receiverAppId_ = a;
      this.statusChangeTimer_ = new shaka.util.Timer(b);
      this.onFirstCastStateUpdate_ = c;
      this.hasJoinedExistingSession_ = !1;
      this.onRemoteEvent_ = d;
      this.onResumeLocal_ = e;
      this.onInitStateRequired_ = f;
      this.isCasting_ = this.apiReady_ = !1;
      this.receiverName_ = '';
      this.appData_ = null;
      this.onConnectionStatusChangedBound_ = function () {
        return g.onConnectionStatusChanged_();
      };
      this.onMessageReceivedBound_ = function (h, k) {
        return g.onMessageReceived_(h, k);
      };
      this.cachedProperties_ = { video: {}, player: {} };
      this.nextAsyncCallId_ = 0;
      this.asyncCallPromises_ = {};
      this.castPromise_ = null;
      shaka.cast.CastSender.instances_.add(this);
    };
    shaka.cast.CastSender.prototype.destroy = function () {
      shaka.cast.CastSender.instances_['delete'](this);
      this.rejectAllPromises_();
      shaka.cast.CastSender.session_ && this.removeListeners_();
      this.statusChangeTimer_ && (this.statusChangeTimer_.stop(), (this.statusChangeTimer_ = null));
      this.onResumeLocal_ = this.onRemoteEvent_ = null;
      this.isCasting_ = this.apiReady_ = !1;
      this.onMessageReceivedBound_ = this.onConnectionStatusChangedBound_ = this.castPromise_ = this.asyncCallPromises_ = this.cachedProperties_ = this.appData_ = null;
      return Promise.resolve();
    };
    shaka.cast.CastSender.prototype.apiReady = function () {
      return this.apiReady_;
    };
    shaka.cast.CastSender.prototype.hasReceivers = function () {
      return shaka.cast.CastSender.hasReceivers_;
    };
    shaka.cast.CastSender.prototype.isCasting = function () {
      return this.isCasting_;
    };
    shaka.cast.CastSender.prototype.receiverName = function () {
      return this.receiverName_;
    };
    shaka.cast.CastSender.prototype.hasRemoteProperties = function () {
      return 0 != Object.keys(this.cachedProperties_.video).length;
    };
    shaka.cast.CastSender.prototype.init = function () {
      var a = shaka.cast.CastSender;
      if (window.chrome && chrome.cast && chrome.cast.isAvailable && this.receiverAppId_.length) {
        this.apiReady_ = !0;
        this.statusChangeTimer_.tickNow();
        var b = new chrome.cast.SessionRequest(this.receiverAppId_);
        b = new chrome.cast.ApiConfig(
          b,
          function (c) {
            return a.onExistingSessionJoined_(c);
          },
          function (c) {
            return a.onReceiverStatusChanged_(c);
          },
          'origin_scoped',
        );
        chrome.cast.initialize(
          b,
          function () {
            shaka.log.debug('CastSender: init');
          },
          function (c) {
            shaka.log.error('CastSender: init error', c);
          },
        );
        shaka.cast.CastSender.hasReceivers_ && this.statusChangeTimer_.tickAfter(shaka.cast.CastSender.STATUS_DELAY);
        (b = shaka.cast.CastSender.session_) && b.status != chrome.cast.SessionStatus.STOPPED
          ? (shaka.log.debug('CastSender: re-using existing connection'), this.onExistingSessionJoined_(b))
          : (shaka.cast.CastSender.session_ = null);
      }
    };
    shaka.cast.CastSender.prototype.setAppData = function (a) {
      this.appData_ = a;
      this.isCasting_ && this.sendMessage_({ type: 'appData', appData: this.appData_ });
    };
    shaka.cast.CastSender.prototype.cast = function (a) {
      var b = this;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (c) {
        if (!b.apiReady_)
          throw new shaka.util.Error(
            shaka.util.Error.Severity.RECOVERABLE,
            shaka.util.Error.Category.CAST,
            shaka.util.Error.Code.CAST_API_UNAVAILABLE,
          );
        if (!shaka.cast.CastSender.hasReceivers_)
          throw new shaka.util.Error(
            shaka.util.Error.Severity.RECOVERABLE,
            shaka.util.Error.Category.CAST,
            shaka.util.Error.Code.NO_CAST_RECEIVERS,
          );
        if (b.isCasting_)
          throw new shaka.util.Error(
            shaka.util.Error.Severity.RECOVERABLE,
            shaka.util.Error.Category.CAST,
            shaka.util.Error.Code.ALREADY_CASTING,
          );
        b.castPromise_ = new shaka.util.PublicPromise();
        chrome.cast.requestSession(
          function (d) {
            return b.onSessionInitiated_(a, d);
          },
          function (d) {
            return b.onConnectionError_(d);
          },
        );
        return c.yield(b.castPromise_, 0);
      });
    };
    shaka.cast.CastSender.prototype.showDisconnectDialog = function () {
      var a = this;
      if (this.isCasting_) {
        var b = this.onInitStateRequired_();
        chrome.cast.requestSession(
          function (c) {
            return a.onSessionInitiated_(b, c);
          },
          function (c) {
            return a.onConnectionError_(c);
          },
        );
      }
    };
    shaka.cast.CastSender.prototype.forceDisconnect = function () {
      if (this.isCasting_) {
        this.rejectAllPromises_();
        if (shaka.cast.CastSender.session_) {
          this.removeListeners_();
          try {
            shaka.cast.CastSender.session_.stop(
              function () {},
              function () {},
            );
          } catch (a) {}
          shaka.cast.CastSender.session_ = null;
        }
        this.onConnectionStatusChanged_();
      }
    };
    shaka.cast.CastSender.prototype.get = function (a, b) {
      var c = this;
      goog.asserts.assert('video' == a || 'player' == a, 'Unexpected target name');
      var d = shaka.cast.CastUtils;
      if ('video' == a) {
        if (d.VideoVoidMethods.includes(b))
          return function (f) {
            for (var g = [], h = 0; h < arguments.length; ++h) g[h - 0] = arguments[h];
            return c.remoteCall_.apply(c, [a, b].concat($jscomp.arrayFromIterable(g)));
          };
      } else if ('player' == a) {
        if (d.PlayerGetterMethodsThatRequireLive[b]) {
          var e = this.get('player', 'isLive')();
          goog.asserts.assert(e, b + ' should be called on a live stream!');
          if (!e) return function () {};
        }
        if (d.PlayerVoidMethods.includes(b))
          return function (f) {
            for (var g = [], h = 0; h < arguments.length; ++h) g[h - 0] = arguments[h];
            return c.remoteCall_.apply(c, [a, b].concat($jscomp.arrayFromIterable(g)));
          };
        if (d.PlayerPromiseMethods.includes(b))
          return function (f) {
            for (var g = [], h = 0; h < arguments.length; ++h) g[h - 0] = arguments[h];
            return c.remoteAsyncCall_.apply(c, [a, b].concat($jscomp.arrayFromIterable(g)));
          };
        if (d.PlayerGetterMethods[b])
          return function () {
            return c.propertyGetter_(a, b);
          };
      }
      return this.propertyGetter_(a, b);
    };
    shaka.cast.CastSender.prototype.set = function (a, b, c) {
      goog.asserts.assert('video' == a || 'player' == a, 'Unexpected target name');
      this.cachedProperties_[a][b] = c;
      this.sendMessage_({ type: 'set', targetName: a, property: b, value: c });
    };
    shaka.cast.CastSender.prototype.onSessionInitiated_ = function (a, b) {
      shaka.log.debug('CastSender: onSessionInitiated');
      this.onSessionCreated_(b);
      // a.textTracks = window._s; // TODO fetching subtitles from Video.tsx, handing over to the player
      a.activeSubsIndex = window._p.getTextTracks().findIndex((t) => t.active === true);
      var me = this;
      window.requestDRMCustomData().then(function (data) {
        a.customDRMData = data;
        me.sendMessage_({ type: 'init', initState: a, appData: me.appData_ });
        me.castPromise_.resolve();
      });
    };
    shaka.cast.CastSender.prototype.onConnectionError_ = function (a) {
      var b = shaka.util.Error.Code.UNEXPECTED_CAST_ERROR;
      switch (a.code) {
        case 'cancel':
          b = shaka.util.Error.Code.CAST_CANCELED_BY_USER;
          break;
        case 'timeout':
          b = shaka.util.Error.Code.CAST_CONNECTION_TIMED_OUT;
          break;
        case 'receiver_unavailable':
          b = shaka.util.Error.Code.CAST_RECEIVER_APP_UNAVAILABLE;
      }
      this.castPromise_.reject(
        new shaka.util.Error(shaka.util.Error.Severity.CRITICAL, shaka.util.Error.Category.CAST, b, a),
      );
    };
    shaka.cast.CastSender.prototype.propertyGetter_ = function (a, b) {
      goog.asserts.assert('video' == a || 'player' == a, 'Unexpected target name');
      return this.cachedProperties_[a][b];
    };
    shaka.cast.CastSender.prototype.remoteCall_ = function (a, b, c) {
      for (var d = [], e = 2; e < arguments.length; ++e) d[e - 2] = arguments[e];
      goog.asserts.assert('video' == a || 'player' == a, 'Unexpected target name');
      this.sendMessage_({ type: 'call', targetName: a, methodName: b, args: d });
    };
    shaka.cast.CastSender.prototype.remoteAsyncCall_ = function (a, b, c) {
      for (var d = [], e = 2; e < arguments.length; ++e) d[e - 2] = arguments[e];
      goog.asserts.assert('video' == a || 'player' == a, 'Unexpected target name');
      e = new shaka.util.PublicPromise();
      var f = this.nextAsyncCallId_.toString();
      this.nextAsyncCallId_++;
      this.asyncCallPromises_[f] = e;
      try {
        this.sendMessage_({ type: 'asyncCall', targetName: a, methodName: b, args: d, id: f });
      } catch (g) {
        e.reject(g);
      }
      return e;
    };
    shaka.cast.CastSender.onExistingSessionJoined_ = function (a) {
      for (var b = $jscomp.makeIterator(shaka.cast.CastSender.instances_), c = b.next(); !c.done; c = b.next())
        c.value.onExistingSessionJoined_(a);
    };
    shaka.cast.CastSender.prototype.onExistingSessionJoined_ = function (a) {
      shaka.log.debug('CastSender: onExistingSessionJoined');
      var b = this.onInitStateRequired_();
      this.castPromise_ = new shaka.util.PublicPromise();
      this.hasJoinedExistingSession_ = !0;
      this.onSessionInitiated_(b, a);
    };
    shaka.cast.CastSender.onReceiverStatusChanged_ = function (a) {
      for (var b = $jscomp.makeIterator(shaka.cast.CastSender.instances_), c = b.next(); !c.done; c = b.next())
        c.value.onReceiverStatusChanged_(a);
    };
    shaka.cast.CastSender.prototype.onReceiverStatusChanged_ = function (a) {
      shaka.log.debug('CastSender: receiver status', a);
      shaka.cast.CastSender.hasReceivers_ = 'available' == a;
      this.statusChangeTimer_.tickNow();
    };
    shaka.cast.CastSender.prototype.onSessionCreated_ = function (a) {
      shaka.cast.CastSender.session_ = a;
      a.addUpdateListener(this.onConnectionStatusChangedBound_);
      a.addMessageListener(shaka.cast.CastUtils.SHAKA_MESSAGE_NAMESPACE, this.onMessageReceivedBound_);
      this.onConnectionStatusChanged_();
    };
    shaka.cast.CastSender.prototype.removeListeners_ = function () {
      var a = shaka.cast.CastSender.session_;
      a.removeUpdateListener(this.onConnectionStatusChangedBound_);
      a.removeMessageListener(shaka.cast.CastUtils.SHAKA_MESSAGE_NAMESPACE, this.onMessageReceivedBound_);
    };
    shaka.cast.CastSender.prototype.onConnectionStatusChanged_ = function () {
      var a = shaka.cast.CastSender.session_ ? 'connected' == shaka.cast.CastSender.session_.status : !1;
      shaka.log.debug('CastSender: connection status', a);
      if (this.isCasting_ && !a) {
        this.onResumeLocal_();
        for (var b in this.cachedProperties_) this.cachedProperties_[b] = {};
        this.rejectAllPromises_();
      }
      this.receiverName_ = (this.isCasting_ = a) ? shaka.cast.CastSender.session_.receiver.friendlyName : '';
      this.statusChangeTimer_.tickNow();
    };
    shaka.cast.CastSender.prototype.rejectAllPromises_ = function () {
      for (var a in this.asyncCallPromises_) {
        var b = this.asyncCallPromises_[a];
        delete this.asyncCallPromises_[a];
        b.reject(
          new shaka.util.Error(
            shaka.util.Error.Severity.RECOVERABLE,
            shaka.util.Error.Category.PLAYER,
            shaka.util.Error.Code.LOAD_INTERRUPTED,
          ),
        );
      }
    };
    shaka.cast.CastSender.prototype.onMessageReceived_ = function (a, b) {
      // console.log(JSON.parse(b));
      var c = shaka.cast.CastUtils.deserialize(b);
      shaka.log.v2('CastSender: message', c);
      switch (c.type) {
        case 'event':
          var d = c.targetName;
          c = c.event;
          c = new shaka.util.FakeEvent(c.type, c);
          this.onRemoteEvent_(d, c);
          break;
        case 'update':
          d = c.update;
          for (var e in d) {
            c = this.cachedProperties_[e] || {};
            for (var f in d[e]) {
              c[f] = d[e][f];
            }
          }

          // TODO change track visibility when changed received from the player
          // var ui = _p.video_.ui;
          // var uiConfig = ui.getConfiguration();
          // ui.configure(uiConfig);

          // if (
          //   (d.player.isTextTrackVisible && !_p.isTextTrackVisible) ||
          //   (!d.player.isTextTrackVisible && _p.isTextTrackVisible)
          // ) {
          //   var ui = _p.video_.ui;
          //   var uiConfig = ui.getConfiguration();
          //   ui.configure(uiConfig);
          // }

          // if (
          //   (d.player.isTextTrackVisible && !_p.isTextTrackVisible) ||
          //   (!d.player.isTextTrackVisible && _p.isTextTrackVisible)
          // ) {
          // var ui = _p.video_.ui;
          // var uiConfig = ui.getConfiguration();
          // ui.configure(uiConfig);
          // }
          this.hasJoinedExistingSession_ && (this.onFirstCastStateUpdate_(), (this.hasJoinedExistingSession_ = !1));
          break;
        case 'asyncComplete':
          if (
            ((e = c.id),
            (c = c.error),
            (f = this.asyncCallPromises_[e]),
            delete this.asyncCallPromises_[e],
            goog.asserts.assert(f, 'Unexpected async id'),
            f)
          )
            if (c) {
              e = new shaka.util.Error(c.severity, c.category, c.code);
              for (d in c) e[d] = c[d];
              f.reject(e);
            } else f.resolve();
      }
    };
    shaka.cast.CastSender.prototype.sendMessage_ = function (a) {
      a = shaka.cast.CastUtils.serialize(a);
      var b = shaka.cast.CastSender.session_;
      try {
        b.sendMessage(shaka.cast.CastUtils.SHAKA_MESSAGE_NAMESPACE, a, function () {}, shaka.log.error);
      } catch (c) {
        throw (
          (shaka.log.error('Cast session sendMessage threw', c),
          (a = new shaka.util.Error(
            shaka.util.Error.Severity.CRITICAL,
            shaka.util.Error.Category.CAST,
            shaka.util.Error.Code.CAST_CONNECTION_TIMED_OUT,
            c,
          )),
          (b = new shaka.util.FakeEvent('error', { detail: a })),
          this.onRemoteEvent_('player', b),
          this.forceDisconnect(),
          a)
        );
      }
    };
    shaka.cast.CastSender.STATUS_DELAY = 0.02;
    shaka.cast.CastSender.hasReceivers_ = !1;
    shaka.cast.CastSender.session_ = null;
    shaka.cast.CastSender.instances_ = new Set();
    shaka.cast.CastSender.onSdkLoaded_ = function (a) {
      if (a) {
        a = $jscomp.makeIterator(shaka.cast.CastSender.instances_);
        for (var b = a.next(); !b.done; b = a.next()) b.value.init();
      }
    };
    window.__onGCastApiAvailable = shaka.cast.CastSender.onSdkLoaded_;
    shaka.cast.CastProxy = function (a, b, c) {
      shaka.util.FakeEventTarget.call(this);
      var d = this;
      this.localVideo_ = a;
      this.localPlayer_ = b;
      this.eventManager_ = this.playerEventTarget_ = this.videoEventTarget_ = this.playerProxy_ = this.videoProxy_ = null;
      this.receiverAppId_ = c;
      this.compiledToExternNames_ = new Map();
      this.sender_ = new shaka.cast.CastSender(
        c,
        function () {
          return d.onCastStatusChanged_();
        },
        function () {
          return d.onFirstCastStateUpdate_();
        },
        function (e, f) {
          return d.onRemoteEvent_(e, f);
        },
        function () {
          return d.onResumeLocal_();
        },
        function () {
          return d.getInitState_();
        },
      );
      this.init_();
    };
    $jscomp.inherits(shaka.cast.CastProxy, shaka.util.FakeEventTarget);
    shaka.cast.CastProxy.prototype.destroy = function (a) {
      a && this.sender_.forceDisconnect();
      this.eventManager_ && (this.eventManager_.release(), (this.eventManager_ = null));
      a = [];
      this.localPlayer_ && (a.push(this.localPlayer_.destroy()), (this.localPlayer_ = null));
      this.sender_ && (a.push(this.sender_.destroy()), (this.sender_ = null));
      this.playerProxy_ = this.videoProxy_ = this.localVideo_ = null;
      return Promise.all(a);
    };
    shaka.cast.CastProxy.prototype.getVideo = function () {
      return this.videoProxy_;
    };
    shaka.cast.CastProxy.prototype.getPlayer = function () {
      return this.playerProxy_;
    };
    shaka.cast.CastProxy.prototype.canCast = function () {
      return this.sender_.apiReady() && this.sender_.hasReceivers();
    };
    shaka.cast.CastProxy.prototype.isCasting = function () {
      return this.sender_.isCasting();
    };
    shaka.cast.CastProxy.prototype.receiverName = function () {
      return this.sender_.receiverName();
    };
    shaka.cast.CastProxy.prototype.cast = function () {
      var a = this,
        b;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (c) {
        return 1 == c.nextAddress
          ? ((b = a.getInitState_()), c.yield(a.sender_.cast(b), 2))
          : a.localPlayer_
          ? c.yield(a.localPlayer_.unload(), 0)
          : c['return']();
      });
    };
    shaka.cast.CastProxy.prototype.setAppData = function (a) {
      this.sender_.setAppData(a);
    };
    shaka.cast.CastProxy.prototype.suggestDisconnect = function () {
      this.sender_.showDisconnectDialog();
    };
    shaka.cast.CastProxy.prototype.forceDisconnect = function () {
      this.sender_.forceDisconnect();
    };
    shaka.cast.CastProxy.prototype.changeReceiverId = function (a) {
      var b = this;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (c) {
        if (1 == c.nextAddress) {
          if (a == b.receiverAppId_) return c['return']();
          b.receiverAppId_ = a;
          b.sender_.forceDisconnect();
          return c.yield(b.sender_.destroy(), 2);
        }
        b.sender_ = null;
        b.sender_ = new shaka.cast.CastSender(
          a,
          function () {
            return b.onCastStatusChanged_();
          },
          function () {
            return b.onFirstCastStateUpdate_();
          },
          function (d, e) {
            return b.onRemoteEvent_(d, e);
          },
          function () {
            return b.onResumeLocal_();
          },
          function () {
            return b.getInitState_();
          },
        );
        b.sender_.init();
        c.jumpToEnd();
      });
    };
    shaka.cast.CastProxy.prototype.init_ = function () {
      var a = this;
      this.sender_.init();
      this.eventManager_ = new shaka.util.EventManager();
      for (var b = $jscomp.makeIterator(shaka.cast.CastUtils.VideoEvents), c = b.next(); !c.done; c = b.next())
        this.eventManager_.listen(this.localVideo_, c.value, function (f) {
          return a.videoProxyLocalEvent_(f);
        });
      for (var d in shaka.Player.EventName)
        this.eventManager_.listen(this.localPlayer_, shaka.Player.EventName[d], function (f) {
          return a.playerProxyLocalEvent_(f);
        });
      this.videoProxy_ = {};
      b = {};
      for (var e in this.localVideo_)
        (b.$jscomp$loop$prop$k$535 = e),
          Object.defineProperty(this.videoProxy_, b.$jscomp$loop$prop$k$535, {
            configurable: !1,
            enumerable: !0,
            get: (function (f) {
              return function () {
                return a.videoProxyGet_(f.$jscomp$loop$prop$k$535);
              };
            })(b),
            set: (function (f) {
              return function (g) {
                return a.videoProxySet_(f.$jscomp$loop$prop$k$535, g);
              };
            })(b),
          }),
          (b = { $jscomp$loop$prop$k$535: b.$jscomp$loop$prop$k$535 });
      this.playerProxy_ = {};
      this.iterateOverPlayerMethods_(function (f, g) {
        goog.asserts.assert(a.playerProxy_, 'Must have player proxy!');
        Object.defineProperty(a.playerProxy_, f, {
          configurable: !1,
          enumerable: !0,
          get: function () {
            return a.playerProxyGet_(f);
          },
        });
      });
      COMPILED && this.mapCompiledToUncompiledPlayerMethodNames_();
      this.videoEventTarget_ = new shaka.util.FakeEventTarget();
      this.videoEventTarget_.dispatchTarget = this.videoProxy_;
      this.playerEventTarget_ = new shaka.util.FakeEventTarget();
      this.playerEventTarget_.dispatchTarget = this.playerProxy_;
    };
    shaka.cast.CastProxy.prototype.mapCompiledToUncompiledPlayerMethodNames_ = function () {
      var a = this,
        b = new Map();
      this.iterateOverPlayerMethods_(function (c, d) {
        if (b.has(d)) {
          var e = b.get(d);
          c.length < e.length ? a.compiledToExternNames_.set(c, e) : a.compiledToExternNames_.set(e, c);
        } else b.set(d, c);
      });
    };
    shaka.cast.CastProxy.prototype.iterateOverPlayerMethods_ = function (a) {
      function b(k) {
        return 'constructor' == k || 'function' != typeof c[k] ? !1 : !d.has(k);
      }
      goog.asserts.assert(this.localPlayer_, 'Must have player!');
      var c = this.localPlayer_,
        d = new Set();
      for (e in c) b(e) && (d.add(e), a(e, c[e]));
      var e = Object.getPrototypeOf(c);
      for (var f = Object.getPrototypeOf({}); e && e != f; ) {
        for (var g = $jscomp.makeIterator(Object.getOwnPropertyNames(e)), h = g.next(); !h.done; h = g.next())
          (h = h.value), b(h) && (d.add(h), a(h, c[h]));
        e = Object.getPrototypeOf(e);
      }
    };
    shaka.cast.CastProxy.prototype.getInitState_ = function () {
      var a = {
        video: {},
        player: {},
        playerAfterLoad: {}, // ABC
        manifest: this.localPlayer_.getAssetUri(),
        startTime: null,
      };
      this.localVideo_.pause();
      for (
        var b = $jscomp.makeIterator(shaka.cast.CastUtils.VideoInitStateAttributes), c = b.next();
        !c.done;
        c = b.next()
      )
        (c = c.value), (a.video[c] = this.localVideo_[c]);
      this.localVideo_.ended || (a.startTime = this.localVideo_.currentTime);
      b = $jscomp.makeIterator(shaka.cast.CastUtils.PlayerInitState);
      for (c = b.next(); !c.done; c = b.next()) {
        var d = c.value;
        c = d[1];
        d = this.localPlayer_[d[0]]();
        a.player[c] = d;
      }
      b = $jscomp.makeIterator(shaka.cast.CastUtils.PlayerInitAfterLoadState);
      for (c = b.next(); !c.done; c = b.next())
        (d = c.value), (c = d[1]), (d = this.localPlayer_[d[0]]()), (a.playerAfterLoad[c] = d);
      return a;
    };
    shaka.cast.CastProxy.prototype.onCastStatusChanged_ = function () {
      var a = new shaka.util.FakeEvent('caststatuschanged');
      this.dispatchEvent(a);
    };
    shaka.cast.CastProxy.prototype.onFirstCastStateUpdate_ = function () {
      var a = new shaka.util.FakeEvent(this.videoProxy_.paused ? 'pause' : 'play');
      this.videoEventTarget_.dispatchEvent(a);
    };
    shaka.cast.CastProxy.prototype.onResumeLocal_ = function () {
      for (
        var a = this, b = $jscomp.makeIterator(shaka.cast.CastUtils.PlayerInitState), c = b.next();
        !c.done;
        c = b.next()
      ) {
        var d = c.value;
        c = d[1];
        d = this.sender_.get('player', d[0])();
        this.localPlayer_[c](d);
      }
      var e = this.sender_.get('player', 'getAssetUri')();
      c = this.sender_.get('video', 'ended');
      b = Promise.resolve();
      var f = this.localVideo_.autoplay;
      d = null;
      c || (d = this.sender_.get('video', 'currentTime'));
      e && ((this.localVideo_.autoplay = !1), (b = this.localPlayer_.load(e, d)));
      var g = {};
      c = $jscomp.makeIterator(shaka.cast.CastUtils.VideoInitStateAttributes);
      for (d = c.next(); !d.done; d = c.next()) (d = d.value), (g[d] = this.sender_.get('video', d));
      b.then(
        function () {
          if (a.localVideo_) {
            // _s.forEach((s) => {
            //   // TODO re-add subtitles after Chromecast ends
            //   _p.addTextTrack(s.url, s.langCode, 'subtitle', 'text/vtt', '', s.title);
            // });
            for (
              var h = $jscomp.makeIterator(shaka.cast.CastUtils.VideoInitStateAttributes), k = h.next();
              !k.done;
              k = h.next()
            )
              (k = k.value), (a.localVideo_[k] = g[k]);
            h = $jscomp.makeIterator(shaka.cast.CastUtils.PlayerInitAfterLoadState);
            for (k = h.next(); !k.done; k = h.next()) {
              var l = k.value;
              k = l[1];
              l = a.sender_.get('player', l[0])();
              a.localPlayer_[k](l);
            }
            a.localVideo_.autoplay = f;
            e && a.localVideo_.play();
          }
        },
        function (h) {
          goog.asserts.assert(h instanceof shaka.util.Error, 'Wrong error type!');
          h = new shaka.util.FakeEvent(shaka.Player.EventName.Error, { detail: h });
          a.localPlayer_.dispatchEvent(h);
        },
      );
    };
    shaka.cast.CastProxy.prototype.videoProxyGet_ = function (a) {
      var b = this;
      if ('addEventListener' == a)
        return function (d, e, f) {
          return b.videoEventTarget_.addEventListener(d, e, f);
        };
      if ('removeEventListener' == a)
        return function (d, e, f) {
          return b.videoEventTarget_.removeEventListener(d, e, f);
        };
      if (this.sender_.isCasting() && !this.sender_.hasRemoteProperties()) {
        var c = this.localVideo_[a];
        if ('function' != typeof c) return c;
      }
      return this.sender_.isCasting()
        ? this.sender_.get('video', a)
        : ((a = this.localVideo_[a]), 'function' == typeof a && (a = a.bind(this.localVideo_)), a);
    };
    shaka.cast.CastProxy.prototype.videoProxySet_ = function (a, b) {
      this.sender_.isCasting() ? this.sender_.set('video', a, b) : (this.localVideo_[a] = b);
    };
    shaka.cast.CastProxy.prototype.videoProxyLocalEvent_ = function (a) {
      this.sender_.isCasting() || ((a = new shaka.util.FakeEvent(a.type, a)), this.videoEventTarget_.dispatchEvent(a));
    };
    shaka.cast.CastProxy.prototype.playerProxyGet_ = function (a) {
      var b = this;
      this.compiledToExternNames_.has(a) && (a = this.compiledToExternNames_.get(a));
      if ('addEventListener' == a)
        return function (d, e, f) {
          return b.playerEventTarget_.addEventListener(d, e, f);
        };
      if ('removeEventListener' == a)
        return function (d, e, f) {
          return b.playerEventTarget_.removeEventListener(d, e, f);
        };
      if ('getMediaElement' == a)
        return function () {
          return b.videoProxy_;
        };
      if ('getSharedConfiguration' == a)
        return (
          shaka.log.warning("Can't share configuration across a network. Returning copy."),
          this.sender_.get('player', 'getConfiguration')
        );
      if ('getNetworkingEngine' == a)
        return (
          this.sender_.isCasting() && shaka.log.warning('NOTE: getNetworkingEngine() is always local!'),
          function () {
            return b.localPlayer_.getNetworkingEngine();
          }
        );
      if ('getAdManager' == a)
        return (
          this.sender_.isCasting() && shaka.log.warning('NOTE: getAdManager() is always local!'),
          function () {
            return b.localPlayer_.getAdManager();
          }
        );
      if ('setVideoContainer' == a)
        return (
          this.sender_.isCasting() && shaka.log.warning('NOTE: setVideoContainer() is always local!'),
          function (d) {
            return b.localPlayer_.setVideoContainer(d);
          }
        );
      if (this.sender_.isCasting()) {
        if ('getManifest' == a || 'drmInfo' == a)
          return function () {
            shaka.log.alwaysWarn(a + '() does not work while casting!');
            return null;
          };
        if ('attach' == a || 'detach' == a)
          return function () {
            shaka.log.alwaysWarn(a + '() does not work while casting!');
            return Promise.resolve();
          };
      }
      if (
        this.sender_.isCasting() &&
        !this.sender_.hasRemoteProperties() &&
        shaka.cast.CastUtils.PlayerGetterMethods[a]
      ) {
        var c = this.localPlayer_[a];
        goog.asserts.assert('function' == typeof c, 'only methods on Player');
        return c.bind(this.localPlayer_);
      }
      return this.sender_.isCasting()
        ? this.sender_.get('player', a)
        : ((c = this.localPlayer_[a]),
          goog.asserts.assert('function' == typeof c, 'only methods on Player'),
          c.bind(this.localPlayer_));
    };
    shaka.cast.CastProxy.prototype.playerProxyLocalEvent_ = function (a) {
      this.sender_.isCasting() || this.playerEventTarget_.dispatchEvent(a);
    };
    shaka.cast.CastProxy.prototype.onRemoteEvent_ = function (a, b) {
      goog.asserts.assert(this.sender_.isCasting(), 'Should only receive remote events while casting');
      this.sender_.isCasting() &&
        ('video' == a
          ? this.videoEventTarget_.dispatchEvent(b)
          : 'player' == a && this.playerEventTarget_.dispatchEvent(b));
    };
    goog.exportSymbol('shaka.cast.CastProxy', shaka.cast.CastProxy);
    goog.exportProperty(
      shaka.cast.CastProxy.prototype,
      'changeReceiverId',
      shaka.cast.CastProxy.prototype.changeReceiverId,
    );
    goog.exportProperty(
      shaka.cast.CastProxy.prototype,
      'forceDisconnect',
      shaka.cast.CastProxy.prototype.forceDisconnect,
    );
    goog.exportProperty(
      shaka.cast.CastProxy.prototype,
      'suggestDisconnect',
      shaka.cast.CastProxy.prototype.suggestDisconnect,
    );
    goog.exportProperty(shaka.cast.CastProxy.prototype, 'setAppData', shaka.cast.CastProxy.prototype.setAppData);
    goog.exportProperty(shaka.cast.CastProxy.prototype, 'cast', shaka.cast.CastProxy.prototype.cast);
    goog.exportProperty(shaka.cast.CastProxy.prototype, 'receiverName', shaka.cast.CastProxy.prototype.receiverName);
    goog.exportProperty(shaka.cast.CastProxy.prototype, 'isCasting', shaka.cast.CastProxy.prototype.isCasting);
    goog.exportProperty(shaka.cast.CastProxy.prototype, 'canCast', shaka.cast.CastProxy.prototype.canCast);
    goog.exportProperty(shaka.cast.CastProxy.prototype, 'getPlayer', shaka.cast.CastProxy.prototype.getPlayer);
    goog.exportProperty(shaka.cast.CastProxy.prototype, 'getVideo', shaka.cast.CastProxy.prototype.getVideo);
    goog.exportProperty(shaka.cast.CastProxy.prototype, 'destroy', shaka.cast.CastProxy.prototype.destroy);
    shaka.cast.CastReceiver = function (a, b, c, d) {
      shaka.util.FakeEventTarget.call(this);
      var e = this;
      this.video_ = a;
      this.player_ = b;
      this.eventManager_ = new shaka.util.EventManager();
      this.targets_ = { video: a, player: b };
      this.appDataCallback_ = c || function () {};
      this.contentIdCallback_ =
        d ||
        function (f) {
          return f;
        };
      this.metadata_ = null;
      this.isConnected_ = !1;
      this.isIdle_ = !0;
      this.updateNumber_ = 0;
      this.startUpdatingUpdateNumber_ = !1;
      this.initialStatusUpdatePending_ = !0;
      this.genericBus_ = this.shakaBus_ = null;
      this.pollTimer_ = new shaka.util.Timer(function () {
        e.pollAttributes_();
      });
      this.init_();
    };
    $jscomp.inherits(shaka.cast.CastReceiver, shaka.util.FakeEventTarget);
    shaka.cast.CastReceiver.prototype.isConnected = function () {
      return this.isConnected_;
    };
    shaka.cast.CastReceiver.prototype.isIdle = function () {
      return this.isIdle_;
    };
    shaka.cast.CastReceiver.prototype.setContentMetadata = function (a) {
      this.metadata_ = a;
    };
    shaka.cast.CastReceiver.prototype.clearContentMetadata = function () {
      this.metadata_ = null;
    };
    shaka.cast.CastReceiver.prototype.setContentTitle = function (a) {
      this.metadata_ || (this.metadata_ = { metadataType: cast.receiver.media.MetadataType.GENERIC });
      this.metadata_.title = a;
    };
    shaka.cast.CastReceiver.prototype.setContentImage = function (a) {
      this.metadata_ || (this.metadata_ = { metadataType: cast.receiver.media.MetadataType.GENERIC });
      this.metadata_.images = [{ url: a }];
    };
    shaka.cast.CastReceiver.prototype.setContentArtist = function (a) {
      this.metadata_ || (this.metadata_ = {});
      this.metadata_.artist = a;
      this.metadata_.metadataType = cast.receiver.media.MetadataType.MUSIC_TRACK;
    };
    shaka.cast.CastReceiver.prototype.destroy = function () {
      var a = this,
        b,
        c;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (d) {
        if (1 == d.nextAddress)
          return (
            a.eventManager_ && (a.eventManager_.release(), (a.eventManager_ = null)),
            (b = []),
            a.player_ && (b.push(a.player_.destroy()), (a.player_ = null)),
            a.pollTimer_ && (a.pollTimer_.stop(), (a.pollTimer_ = null)),
            (a.video_ = null),
            (a.targets_ = null),
            (a.appDataCallback_ = null),
            (a.isConnected_ = !1),
            (a.isIdle_ = !0),
            (a.shakaBus_ = null),
            (a.genericBus_ = null),
            d.yield(Promise.all(b), 2)
          );
        c = cast.receiver.CastReceiverManager.getInstance();
        c.stop();
        d.jumpToEnd();
      });
    };
    shaka.cast.CastReceiver.prototype.init_ = function () {
      var a = this,
        b = cast.receiver.CastReceiverManager.getInstance();
      b.onSenderConnected = function () {
        return a.onSendersChanged_();
      };
      b.onSenderDisconnected = function () {
        return a.onSendersChanged_();
      };
      b.onSystemVolumeChanged = function () {
        return a.fakeVolumeChangeEvent_();
      };
      this.genericBus_ = b.getCastMessageBus(shaka.cast.CastUtils.GENERIC_MESSAGE_NAMESPACE);
      this.genericBus_.onMessage = function (e) {
        return a.onGenericMessage_(e);
      };
      this.shakaBus_ = b.getCastMessageBus(shaka.cast.CastUtils.SHAKA_MESSAGE_NAMESPACE);
      this.shakaBus_.onMessage = function (e) {
        return a.onShakaMessage_(e);
      };
      goog.DEBUG ? shaka.util.Platform.isChromecast() && b.start() : b.start();
      b = $jscomp.makeIterator(shaka.cast.CastUtils.VideoEvents);
      for (var c = b.next(); !c.done; c = b.next())
        this.eventManager_.listen(this.video_, c.value, function (e) {
          return a.proxyEvent_('video', e);
        });
      for (var d in shaka.Player.EventName)
        this.eventManager_.listen(this.player_, shaka.Player.EventName[d], function (e) {
          return a.proxyEvent_('player', e);
        });
      cast.__platform__ && cast.__platform__.canDisplayType('video/mp4; codecs="avc1.640028"; width=3840; height=2160')
        ? this.player_.setMaxHardwareResolution(3840, 2160)
        : this.player_.setMaxHardwareResolution(1920, 1080);
      this.eventManager_.listen(this.video_, 'loadeddata', function () {
        a.startUpdatingUpdateNumber_ = !0;
      });
      this.eventManager_.listen(this.player_, 'loading', function () {
        a.isIdle_ = !1;
        a.onCastStatusChanged_();
      });
      this.eventManager_.listen(this.video_, 'playing', function () {
        a.isIdle_ = !1;
        a.onCastStatusChanged_();
      });
      this.eventManager_.listen(this.video_, 'pause', function () {
        a.onCastStatusChanged_();
      });
      this.eventManager_.listen(this.player_, 'unloading', function () {
        a.isIdle_ = !0;
        a.onCastStatusChanged_();
      });
      this.eventManager_.listen(this.video_, 'ended', function () {
        new shaka.util.Timer(function () {
          a.video_ && a.video_.ended && ((a.isIdle_ = !0), a.onCastStatusChanged_());
        }).tickAfter(shaka.cast.CastReceiver.IDLE_INTERVAL);
      });
    };
    shaka.cast.CastReceiver.prototype.onSendersChanged_ = function () {
      this.updateNumber_ = 0;
      this.initialStatusUpdatePending_ = !0;
      this.isConnected_ = 0 != cast.receiver.CastReceiverManager.getInstance().getSenders().length;
      this.onCastStatusChanged_();
    };
    shaka.cast.CastReceiver.prototype.onCastStatusChanged_ = function () {
      var a = this,
        b;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (c) {
        if (1 == c.nextAddress) return c.yield(Promise.resolve(), 2);
        if (!a.player_) return c['return']();
        b = new shaka.util.FakeEvent('caststatuschanged');
        a.dispatchEvent(b);
        a.maybeSendMediaInfoMessage_() || a.sendMediaStatus_();
        c.jumpToEnd();
      });
    };
    shaka.cast.CastReceiver.prototype.initState_ = function (a, b) {
      var c = this,
        d,
        e,
        f,
        g,
        h,
        k,
        l,
        m,
        n,
        p;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (q) {
        switch (q.nextAddress) {
          case 1:
            for (d in a.player) (e = a.player[d]), c.player_[d](e);
            c.appDataCallback_(b);
            f = c.video_.autoplay;
            return a.manifest
              ? ((c.video_.autoplay = !1),
                q.setCatchFinallyBlocks(5),
                q.yield(c.player_.load(a.manifest, a.startTime), 7))
              : q.yield(Promise.resolve(), 3);
          case 7:
            q.leaveTryBlock(3);
            break;
          case 5:
            return (
              (g = q.enterCatchBlock()),
              goog.asserts.assert(g instanceof shaka.util.Error, 'Wrong error type!'),
              (h = shaka.Player.EventName.Error),
              (k = new shaka.util.FakeEvent(h, { detail: g })),
              c.player_.dispatchEvent(k),
              q['return']()
            );
          case 3:
            if (!c.player_) return q['return']();
            for (l in a.video) (m = a.video[l]), (c.video_[l] = m);
            for (n in a.playerAfterLoad) (p = a.playerAfterLoad[n]), c.player_[n](p);
            c.video_.autoplay = f;
            a.manifest && (c.video_.play(), c.sendMediaStatus_());
            q.jumpToEnd();
        }
      });
    };
    shaka.cast.CastReceiver.prototype.proxyEvent_ = function (a, b) {
      this.player_ &&
        (this.pollAttributes_(), this.sendMessage_({ type: 'event', targetName: a, event: b }, this.shakaBus_));
    };
    shaka.cast.CastReceiver.prototype.pollAttributes_ = function () {
      this.pollTimer_.tickAfter(shaka.cast.CastReceiver.POLL_INTERVAL);
      for (
        var a = { video: {}, player: {} }, b = $jscomp.makeIterator(shaka.cast.CastUtils.VideoAttributes), c = b.next();
        !c.done;
        c = b.next()
      )
        (c = c.value), (a.video[c] = this.video_[c]);
      if (this.player_.isLive()) {
        b = shaka.cast.CastUtils.PlayerGetterMethodsThatRequireLive;
        for (var d in b) 0 == this.updateNumber_ % b[d] && (a.player[d] = this.player_[d]());
      }
      for (var e in shaka.cast.CastUtils.PlayerGetterMethods)
        0 == this.updateNumber_ % shaka.cast.CastUtils.PlayerGetterMethods[e] && (a.player[e] = this.player_[e]());
      if ((d = cast.receiver.CastReceiverManager.getInstance().getSystemVolume()))
        (a.video.volume = d.level), (a.video.muted = d.muted);
      this.startUpdatingUpdateNumber_ && (this.updateNumber_ += 1);
      this.sendMessage_({ type: 'update', update: a }, this.shakaBus_);
      this.maybeSendMediaInfoMessage_();
    };
    shaka.cast.CastReceiver.prototype.maybeSendMediaInfoMessage_ = function () {
      return this.initialStatusUpdatePending_ && (this.video_.duration || this.player_.isLive())
        ? (this.sendMediaInfoMessage_(), (this.initialStatusUpdatePending_ = !1), !0)
        : !1;
    };
    shaka.cast.CastReceiver.prototype.sendMediaInfoMessage_ = function (a) {
      a = void 0 === a ? 0 : a;
      var b = {
        contentId: this.player_.getAssetUri(),
        streamType: this.player_.isLive() ? 'LIVE' : 'BUFFERED',
        contentType: '',
      };
      this.player_.isLive() || (b.duration = this.video_.duration);
      this.metadata_ && (b.metadata = this.metadata_);
      this.sendMediaStatus_(a, b);
    };
    shaka.cast.CastReceiver.prototype.fakeVolumeChangeEvent_ = function () {
      var a = cast.receiver.CastReceiverManager.getInstance().getSystemVolume();
      goog.asserts.assert(a, 'System volume should not be null!');
      a &&
        this.sendMessage_({ type: 'update', update: { video: { volume: a.level, muted: a.muted } } }, this.shakaBus_);
      this.sendMessage_({ type: 'event', targetName: 'video', event: { type: 'volumechange' } }, this.shakaBus_);
    };
    shaka.cast.CastReceiver.prototype.onShakaMessage_ = function (a) {
      var b = this,
        c = shaka.cast.CastUtils.deserialize(a.data);
      shaka.log.debug('CastReceiver: message', c);
      switch (c.type) {
        case 'init':
          this.updateNumber_ = 0;
          this.startUpdatingUpdateNumber_ = !1;
          this.initialStatusUpdatePending_ = !0;
          this.initState_(c.initState, c.appData);
          this.pollAttributes_();
          break;
        case 'appData':
          this.appDataCallback_(c.appData);
          break;
        case 'set':
          var d = c.targetName,
            e = c.property;
          c = c.value;
          if ('video' == d)
            if (((a = cast.receiver.CastReceiverManager.getInstance()), 'volume' == e)) {
              a.setSystemVolumeLevel(c);
              break;
            } else if ('muted' == e) {
              a.setSystemVolumeMuted(c);
              break;
            }
          this.targets_[d][e] = c;
          break;
        case 'call':
          d = this.targets_[c.targetName];
          d[c.methodName].apply(d, c.args);
          break;
        case 'asyncCall':
          d = c.targetName;
          e = c.methodName;
          'player' == d && 'load' == e && ((this.updateNumber_ = 0), (this.startUpdatingUpdateNumber_ = !1));
          var f = c.id,
            g = a.senderId;
          a = this.targets_[d];
          c = a[e].apply(a, c.args);
          'player' == d &&
            'load' == e &&
            (c = c.then(function () {
              b.initialStatusUpdatePending_ = !0;
            }));
          c.then(
            function () {
              return b.sendAsyncComplete_(g, f, null);
            },
            function (h) {
              return b.sendAsyncComplete_(g, f, h);
            },
          );
      }
    };
    shaka.cast.CastReceiver.prototype.onGenericMessage_ = function (a) {
      var b = this,
        c = shaka.cast.CastUtils.deserialize(a.data);
      shaka.log.debug('CastReceiver: message', c);
      switch (c.type) {
        case 'PLAY':
          this.video_.play();
          this.sendMediaStatus_();
          break;
        case 'PAUSE':
          this.video_.pause();
          this.sendMediaStatus_();
          break;
        case 'SEEK':
          a = c.currentTime;
          var d = c.resumeState;
          null != a && (this.video_.currentTime = Number(a));
          d && 'PLAYBACK_START' == d
            ? (this.video_.play(), this.sendMediaStatus_())
            : d && 'PLAYBACK_PAUSE' == d && (this.video_.pause(), this.sendMediaStatus_());
          break;
        case 'STOP':
          this.player_.unload().then(function () {
            b.player_ && b.sendMediaStatus_();
          });
          break;
        case 'GET_STATUS':
          this.sendMediaInfoMessage_(Number(c.requestId));
          break;
        case 'VOLUME':
          d = c.volume;
          a = d.level;
          d = d.muted;
          var e = this.video_.volume,
            f = this.video_.muted;
          null != a && (this.video_.volume = Number(a));
          null != d && (this.video_.muted = d);
          (e == this.video_.volume && f == this.video_.muted) || this.sendMediaStatus_();
          break;
        case 'LOAD':
          this.updateNumber_ = 0;
          this.initialStatusUpdatePending_ = this.startUpdatingUpdateNumber_ = !1;
          a = c.media;
          d = c.currentTime;
          e = this.contentIdCallback_(a.contentId);
          f = c.autoplay || !0;
          this.appDataCallback_(a.customData);
          f && (this.video_.autoplay = !0);
          this.player_
            .load(e, d)
            .then(function () {
              b.player_ && b.sendMediaInfoMessage_();
            })
            ['catch'](function (g) {
              goog.asserts.assert(g instanceof shaka.util.Error, 'Wrong error type!');
              var h = 'LOAD_FAILED';
              g.category == shaka.util.Error.Category.PLAYER &&
                g.code == shaka.util.Error.Code.LOAD_INTERRUPTED &&
                (h = 'LOAD_CANCELLED');
              b.sendMessage_({ requestId: Number(c.requestId), type: h }, b.genericBus_);
            });
          break;
        default:
          shaka.log.warning('Unrecognized message type from the generic Chromecast controller!', c.type),
            this.sendMessage_(
              { requestId: Number(c.requestId), type: 'INVALID_REQUEST', reason: 'INVALID_COMMAND' },
              this.genericBus_,
            );
      }
    };
    shaka.cast.CastReceiver.prototype.sendAsyncComplete_ = function (a, b, c) {
      this.player_ && this.sendMessage_({ type: 'asyncComplete', id: b, error: c }, this.shakaBus_, a);
    };
    shaka.cast.CastReceiver.prototype.sendMessage_ = function (a, b, c) {
      this.isConnected_ && ((a = shaka.cast.CastUtils.serialize(a)), c ? b.getCastChannel(c).send(a) : b.broadcast(a));
    };
    shaka.cast.CastReceiver.prototype.getPlayState_ = function () {
      var a = shaka.cast.CastReceiver.PLAY_STATE;
      return this.isIdle_
        ? a.IDLE
        : this.player_.isBuffering()
        ? a.BUFFERING
        : this.video_.paused
        ? a.PAUSED
        : a.PLAYING;
    };
    shaka.cast.CastReceiver.prototype.sendMediaStatus_ = function (a, b) {
      a = void 0 === a ? 0 : a;
      b = void 0 === b ? null : b;
      var c = {
        mediaSessionId: 0,
        playbackRate: this.video_.playbackRate,
        playerState: this.getPlayState_(),
        currentTime: this.video_.currentTime,
        supportedMediaCommands: 63,
        volume: { level: this.video_.volume, muted: this.video_.muted },
      };
      b && (c.media = b);
      this.sendMessage_({ requestId: a, type: 'MEDIA_STATUS', status: [c] }, this.genericBus_);
    };
    goog.exportSymbol('shaka.cast.CastReceiver', shaka.cast.CastReceiver);
    goog.exportProperty(shaka.cast.CastReceiver.prototype, 'destroy', shaka.cast.CastReceiver.prototype.destroy);
    goog.exportProperty(
      shaka.cast.CastReceiver.prototype,
      'setContentArtist',
      shaka.cast.CastReceiver.prototype.setContentArtist,
    );
    goog.exportProperty(
      shaka.cast.CastReceiver.prototype,
      'setContentImage',
      shaka.cast.CastReceiver.prototype.setContentImage,
    );
    goog.exportProperty(
      shaka.cast.CastReceiver.prototype,
      'setContentTitle',
      shaka.cast.CastReceiver.prototype.setContentTitle,
    );
    goog.exportProperty(
      shaka.cast.CastReceiver.prototype,
      'clearContentMetadata',
      shaka.cast.CastReceiver.prototype.clearContentMetadata,
    );
    goog.exportProperty(
      shaka.cast.CastReceiver.prototype,
      'setContentMetadata',
      shaka.cast.CastReceiver.prototype.setContentMetadata,
    );
    goog.exportProperty(shaka.cast.CastReceiver.prototype, 'isIdle', shaka.cast.CastReceiver.prototype.isIdle);
    goog.exportProperty(
      shaka.cast.CastReceiver.prototype,
      'isConnected',
      shaka.cast.CastReceiver.prototype.isConnected,
    );
    shaka.cast.CastReceiver.POLL_INTERVAL = 0.5;
    shaka.cast.CastReceiver.IDLE_INTERVAL = 5;
    shaka.cast.CastReceiver.PLAY_STATE = { IDLE: 'IDLE', PLAYING: 'PLAYING', BUFFERING: 'BUFFERING', PAUSED: 'PAUSED' };
    shaka.util.Pssh = function (a) {
      var b = this;
      this.systemIds = [];
      this.cencKeyIds = [];
      this.data = [];
      new shaka.util.Mp4Parser()
        .box('moov', shaka.util.Mp4Parser.children)
        .fullBox('pssh', function (c) {
          return b.parsePsshBox_(c);
        })
        .parse(a);
      0 == this.data.length && shaka.log.warning('No pssh box found!');
    };
    shaka.util.Pssh.prototype.parsePsshBox_ = function (a) {
      goog.asserts.assert(null != a.version, 'PSSH boxes are full boxes and must have a valid version');
      goog.asserts.assert(null != a.flags, 'PSSH boxes are full boxes and must have a valid flag');
      if (1 < a.version) shaka.log.warning('Unrecognized PSSH version found!');
      else {
        var b = a.reader.getDataView();
        goog.asserts.assert(12 <= b.byteOffset, 'DataView at incorrect position');
        b = shaka.util.BufferUtils.toUint8(b, -12, a.size);
        this.data.push(b);
        this.systemIds.push(shaka.util.Uint8ArrayUtils.toHex(a.reader.readBytes(16)));
        if (0 < a.version) {
          b = a.reader.readUint32();
          b = $jscomp.makeIterator(shaka.util.Iterables.range(b));
          for (var c = b.next(); !c.done; c = b.next())
            shaka.util.Functional.ignored(c.value),
              (c = shaka.util.Uint8ArrayUtils.toHex(a.reader.readBytes(16))),
              this.cencKeyIds.push(c);
        }
      }
    };
    shaka.util.Pssh.createPssh = function (a, b) {
      goog.asserts.assert(16 == b.byteLength, 'Invalid system ID length');
      var c = a.length,
        d = 12 + b.length + 4 + c,
        e = new Uint8Array(d),
        f = shaka.util.BufferUtils.toDataView(e),
        g = 0;
      f.setUint32(g, d);
      g += 4;
      f.setUint32(g, 1886614376);
      g += 4;
      f.setUint32(g, 0);
      g += 4;
      e.set(b, g);
      g += b.length;
      f.setUint32(g, c);
      g += 4;
      e.set(a, g);
      goog.asserts.assert(g + c === d, 'PSSH invalid length.');
      return e;
    };
    shaka.util.Pssh.normaliseInitData = function (a) {
      if (!a) return a;
      var b = new shaka.util.Pssh(a);
      if (1 >= b.data.length) return a;
      a = [];
      var c = {};
      b = $jscomp.makeIterator(b.data);
      for (
        var d = b.next();
        !d.done;
        c = { $jscomp$loop$prop$initData$455$537: c.$jscomp$loop$prop$initData$455$537 }, d = b.next()
      )
        (c.$jscomp$loop$prop$initData$455$537 = d.value),
          a.some(
            (function (e) {
              return function (f) {
                return shaka.util.BufferUtils.equal(f, e.$jscomp$loop$prop$initData$455$537);
              };
            })(c),
          ) || a.push(c.$jscomp$loop$prop$initData$455$537);
      return shaka.util.Uint8ArrayUtils.concat.apply(shaka.util.Uint8ArrayUtils, $jscomp.arrayFromIterable(a));
    };
    shaka.util.XmlUtils = function () {};
    shaka.util.XmlUtils.findChild = function (a, b) {
      var c = shaka.util.XmlUtils.findChildren(a, b);
      return 1 != c.length ? null : c[0];
    };
    shaka.util.XmlUtils.findChildNS = function (a, b, c) {
      a = shaka.util.XmlUtils.findChildrenNS(a, b, c);
      return 1 != a.length ? null : a[0];
    };
    shaka.util.XmlUtils.findChildren = function (a, b) {
      return Array.from(a.childNodes).filter(function (c) {
        return c instanceof Element && c.tagName == b;
      });
    };
    shaka.util.XmlUtils.findChildrenNS = function (a, b, c) {
      return Array.from(a.childNodes).filter(function (d) {
        return d instanceof Element && d.localName == c && d.namespaceURI == b;
      });
    };
    shaka.util.XmlUtils.getAttributeNS = function (a, b, c) {
      return a.hasAttributeNS(b, c) ? a.getAttributeNS(b, c) : null;
    };
    shaka.util.XmlUtils.getContents = function (a) {
      return Array.from(a.childNodes).every(function (b) {
        return b.nodeType == Node.TEXT_NODE || b.nodeType == Node.CDATA_SECTION_NODE;
      })
        ? a.textContent.trim()
        : null;
    };
    shaka.util.XmlUtils.parseAttr = function (a, b, c, d) {
      d = void 0 === d ? null : d;
      var e = null;
      a = a.getAttribute(b);
      null != a && (e = c(a));
      return null == e ? d : e;
    };
    shaka.util.XmlUtils.parseDate = function (a) {
      if (!a) return null;
      /^\d+-\d+-\d+T\d+:\d+:\d+(\.\d+)?$/.test(a) && (a += 'Z');
      a = Date.parse(a);
      return isNaN(a) ? null : Math.floor(a / 1e3);
    };
    shaka.util.XmlUtils.parseDuration = function (a) {
      if (!a) return null;
      var b = /^P(?:([0-9]*)Y)?(?:([0-9]*)M)?(?:([0-9]*)D)?(?:T(?:([0-9]*)H)?(?:([0-9]*)M)?(?:([0-9.]*)S)?)?$/.exec(a);
      if (!b) return shaka.log.warning('Invalid duration string:', a), null;
      a =
        31536e3 * Number(b[1] || null) +
        2592e3 * Number(b[2] || null) +
        86400 * Number(b[3] || null) +
        3600 * Number(b[4] || null) +
        60 * Number(b[5] || null) +
        Number(b[6] || null);
      return isFinite(a) ? a : null;
    };
    shaka.util.XmlUtils.parseRange = function (a) {
      var b = /([0-9]+)-([0-9]+)/.exec(a);
      if (!b) return null;
      a = Number(b[1]);
      if (!isFinite(a)) return null;
      b = Number(b[2]);
      return isFinite(b) ? { start: a, end: b } : null;
    };
    shaka.util.XmlUtils.parseInt = function (a) {
      a = Number(a);
      return 0 === a % 1 ? a : null;
    };
    shaka.util.XmlUtils.parsePositiveInt = function (a) {
      a = Number(a);
      return 0 === a % 1 && 0 < a ? a : null;
    };
    shaka.util.XmlUtils.parseNonNegativeInt = function (a) {
      a = Number(a);
      return 0 === a % 1 && 0 <= a ? a : null;
    };
    shaka.util.XmlUtils.parseFloat = function (a) {
      a = Number(a);
      return isNaN(a) ? null : a;
    };
    shaka.util.XmlUtils.evalDivision = function (a) {
      var b;
      a = (b = a.match(/^(\d+)\/(\d+)$/)) ? Number(b[1]) / Number(b[2]) : Number(a);
      return isNaN(a) ? null : a;
    };
    shaka.util.XmlUtils.parseXmlString = function (a, b) {
      var c = new DOMParser(),
        d = null,
        e = null;
      try {
        e = c.parseFromString(a, 'text/xml');
      } catch (f) {}
      e && e.documentElement.tagName == b && (d = e.documentElement);
      return d && 0 < d.getElementsByTagName('parsererror').length ? null : d;
    };
    shaka.util.XmlUtils.parseXml = function (a, b) {
      try {
        var c = shaka.util.StringUtils.fromUTF8(a);
        return shaka.util.XmlUtils.parseXmlString(c, b);
      } catch (d) {
        return null;
      }
    };
    shaka.dash = {};
    shaka.dash.ContentProtection = function () {};
    shaka.dash.ContentProtection.parseFromAdaptationSet = function (a, b) {
      var c = shaka.dash.ContentProtection,
        d = shaka.util.ManifestParserUtils,
        e = c.parseElements_(a),
        f = null,
        g = [],
        h = [],
        k = new Set(
          e.map(function (l) {
            return l.keyId;
          }),
        );
      k['delete'](null);
      if (1 < k.size)
        throw new shaka.util.Error(
          shaka.util.Error.Severity.CRITICAL,
          shaka.util.Error.Category.MANIFEST,
          shaka.util.Error.Code.DASH_CONFLICTING_KEY_IDS,
        );
      b ||
        ((h = e.filter(function (l) {
          return l.schemeUri == c.MP4Protection_
            ? (goog.asserts.assert(!l.init || l.init.length, 'Init data must be null or non-empty.'),
              (f = l.init || f),
              !1)
            : !0;
        })),
        h.length && ((g = c.convertElements_(f, h)), 0 == g.length && (g = [d.createDrmInfo('', f)])));
      if (e.length && (b || !h.length))
        for (g = [], e = $jscomp.makeIterator(c.defaultKeySystems_.values()), h = e.next(); !h.done; h = e.next())
          (h = h.value), 'org.w3.clearkey' != h && ((h = d.createDrmInfo(h, f)), g.push(h));
      if ((d = Array.from(k)[0] || null))
        for (k = $jscomp.makeIterator(g), e = k.next(); !e.done; e = k.next())
          for (e = $jscomp.makeIterator(e.value.initData), h = e.next(); !h.done; h = e.next()) h.value.keyId = d;
      return { defaultKeyId: d, defaultInit: f, drmInfos: g, firstRepresentation: !0 };
    };
    shaka.dash.ContentProtection.parseFromRepresentation = function (a, b, c) {
      var d = shaka.dash.ContentProtection.parseFromAdaptationSet(a, c);
      if (b.firstRepresentation) {
        a = 1 == b.drmInfos.length && !b.drmInfos[0].keySystem;
        c = 0 == d.drmInfos.length;
        if (0 == b.drmInfos.length || (a && !c)) b.drmInfos = d.drmInfos;
        b.firstRepresentation = !1;
      } else if (
        0 < d.drmInfos.length &&
        ((b.drmInfos = b.drmInfos.filter(function (e) {
          return d.drmInfos.some(function (f) {
            return f.keySystem == e.keySystem;
          });
        })),
        0 == b.drmInfos.length)
      )
        throw new shaka.util.Error(
          shaka.util.Error.Severity.CRITICAL,
          shaka.util.Error.Category.MANIFEST,
          shaka.util.Error.Code.DASH_NO_COMMON_KEY_SYSTEM,
        );
      return d.defaultKeyId || b.defaultKeyId;
    };
    shaka.dash.ContentProtection.getWidevineLicenseUrl = function (a) {
      return (a = shaka.util.XmlUtils.findChildNS(a.node, 'urn:microsoft', 'laurl'))
        ? a.getAttribute('licenseUrl') || ''
        : '';
    };
    shaka.dash.ContentProtection.parseMsProRecords_ = function (a, b) {
      for (var c = []; b < a.byteLength - 1; ) {
        var d = a.getUint16(b, !0);
        b += 2;
        var e = a.getUint16(b, !0);
        b += 2;
        if (0 != (e & 1) || e + b > a.byteLength) return shaka.log.warning('Malformed MS PRO object'), [];
        var f = shaka.util.BufferUtils.toUint8(a, b, e);
        c.push({ type: d, value: f });
        b += e;
      }
      return c;
    };
    shaka.dash.ContentProtection.parseMsPro_ = function (a) {
      var b = 0,
        c = shaka.util.BufferUtils.toDataView(a),
        d = c.getUint32(b, !0);
      b += 4;
      return d != a.byteLength
        ? (shaka.log.warning('PlayReady Object with invalid length encountered.'), [])
        : shaka.dash.ContentProtection.parseMsProRecords_(c, b + 2);
    };
    shaka.dash.ContentProtection.getLaurl_ = function (a) {
      a = $jscomp.makeIterator(a.getElementsByTagName('DATA'));
      for (var b = a.next(); !b.done; b = a.next()) {
        b = $jscomp.makeIterator(b.value.childNodes);
        for (var c = b.next(); !c.done; c = b.next())
          if (((c = c.value), c instanceof Element && 'LA_URL' == c.tagName)) return c.textContent;
      }
      return '';
    };
    shaka.dash.ContentProtection.getPlayReadyLicenseUrl = function (a) {
      var b = shaka.util.XmlUtils.findChildNS(a.node, 'urn:microsoft:playready', 'pro');
      if (!b) return '';
      a = shaka.dash.ContentProtection;
      var c = a.PLAYREADY_RECORD_TYPES;
      b = shaka.util.Uint8ArrayUtils.fromBase64(b.textContent);
      b = a.parseMsPro_(b).filter(function (d) {
        return d.type === c.RIGHTS_MANAGEMENT;
      })[0];
      if (!b) return '';
      b = shaka.util.StringUtils.fromUTF16(b.value, !0);
      return (b = shaka.util.XmlUtils.parseXmlString(b, 'WRMHEADER')) ? a.getLaurl_(b) : '';
    };
    shaka.dash.ContentProtection.getInitDataFromPro_ = function (a) {
      var b = shaka.util.XmlUtils.findChildNS(a.node, 'urn:microsoft:playready', 'pro');
      if (!b) return null;
      b = shaka.util.Uint8ArrayUtils.fromBase64(b.textContent);
      var c = new Uint8Array([154, 4, 240, 121, 152, 64, 66, 134, 171, 146, 230, 91, 224, 136, 95, 149]);
      return [{ initData: shaka.util.Pssh.createPssh(b, c), initDataType: 'cenc', keyId: a.keyId }];
    };
    shaka.dash.ContentProtection.convertElements_ = function (a, b) {
      for (
        var c = shaka.dash.ContentProtection,
          d = shaka.util.ManifestParserUtils,
          e = c.defaultKeySystems_,
          f = c.licenseUrlParsers_,
          g = [],
          h = $jscomp.makeIterator(b),
          k = h.next();
        !k.done;
        k = h.next()
      ) {
        k = k.value;
        var l = e.get(k.schemeUri);
        if (l) {
          goog.asserts.assert(!k.init || k.init.length, 'Init data must be null or non-empty.');
          var m = c.getInitDataFromPro_(k);
          m = d.createDrmInfo(l, k.init || a || m);
          if ((l = f.get(l))) m.licenseServerUri = l(k);
          g.push(m);
        }
      }
      return g;
    };
    shaka.dash.ContentProtection.parseElements_ = function (a) {
      var b = [];
      a = $jscomp.makeIterator(a);
      for (var c = a.next(); !c.done; c = a.next())
        (c = shaka.dash.ContentProtection.parseElement_(c.value)) && b.push(c);
      return b;
    };
    shaka.dash.ContentProtection.parseElement_ = function (a) {
      var b = shaka.dash.ContentProtection.CencNamespaceUri_,
        c = a.getAttribute('schemeIdUri'),
        d = shaka.util.XmlUtils.getAttributeNS(a, b, 'default_KID');
      b = shaka.util.XmlUtils.findChildrenNS(a, b, 'pssh').map(shaka.util.XmlUtils.getContents);
      if (!c) return shaka.log.error('Missing required schemeIdUri attribute on', 'ContentProtection element', a), null;
      c = c.toLowerCase();
      if (d && ((d = d.replace(/-/g, '').toLowerCase()), d.includes(' ')))
        throw new shaka.util.Error(
          shaka.util.Error.Severity.CRITICAL,
          shaka.util.Error.Category.MANIFEST,
          shaka.util.Error.Code.DASH_MULTIPLE_KEY_IDS_NOT_SUPPORTED,
        );
      var e = [];
      try {
        e = b.map(function (f) {
          return { initDataType: 'cenc', initData: shaka.util.Uint8ArrayUtils.fromBase64(f), keyId: null };
        });
      } catch (f) {
        throw new shaka.util.Error(
          shaka.util.Error.Severity.CRITICAL,
          shaka.util.Error.Category.MANIFEST,
          shaka.util.Error.Code.DASH_PSSH_BAD_ENCODING,
        );
      }
      return { node: a, schemeUri: c, keyId: d, init: 0 < e.length ? e : null };
    };
    shaka.dash.ContentProtection.PLAYREADY_RECORD_TYPES = { RIGHTS_MANAGEMENT: 1, RESERVED: 2, EMBEDDED_LICENSE: 3 };
    shaka.dash.ContentProtection.defaultKeySystems_ = new Map()
      .set('urn:uuid:1077efec-c0b2-4d02-ace3-3c1e52e2fb4b', 'org.w3.clearkey')
      .set('urn:uuid:edef8ba9-79d6-4ace-a3c8-27dcd51d21ed', 'com.widevine.alpha')
      .set('urn:uuid:9a04f079-9840-4286-ab92-e65be0885f95', 'com.microsoft.playready')
      .set('urn:uuid:79f0049a-4098-8642-ab92-e65be0885f95', 'com.microsoft.playready')
      .set('urn:uuid:f239e769-efa3-4850-9c16-a903c6932efb', 'com.adobe.primetime');
    shaka.dash.ContentProtection.licenseUrlParsers_ = new Map()
      .set('com.widevine.alpha', shaka.dash.ContentProtection.getWidevineLicenseUrl)
      .set('com.microsoft.playready', shaka.dash.ContentProtection.getPlayReadyLicenseUrl);
    shaka.dash.ContentProtection.MP4Protection_ = 'urn:mpeg:dash:mp4protection:2011';
    shaka.dash.ContentProtection.CencNamespaceUri_ = 'urn:mpeg:cenc:2013';
    shaka.dash.MpdUtils = function () {};
    shaka.dash.MpdUtils.fillUriTemplate = function (a, b, c, d, e) {
      var f = { RepresentationID: b, Number: c, Bandwidth: d, Time: e };
      return a.replace(
        /\$(RepresentationID|Number|Bandwidth|Time)?(?:%0([0-9]+)([diouxX]))?\$/g,
        function (g, h, k, l) {
          if ('$$' == g) return '$';
          var m = f[h];
          goog.asserts.assert(void 0 !== m, 'Unrecognized identifier');
          if (null == m)
            return (
              shaka.log.warning(
                'URL template does not have an available substitution for ',
                'identifier "' + h + '":',
                a,
              ),
              g
            );
          'RepresentationID' == h &&
            k &&
            (shaka.log.warning(
              'URL template should not contain a width specifier for identifier',
              '"RepresentationID":',
              a,
            ),
            (k = void 0));
          'Time' == h &&
            (goog.asserts.assert('number' == typeof m, 'Time value should be a number!'),
            goog.asserts.assert(
              0.2 > Math.abs(m - Math.round(m)),
              'Calculated $Time$ values must be close to integers',
            ),
            (m = Math.round(m)));
          switch (l) {
            case void 0:
            case 'd':
            case 'i':
            case 'u':
              g = m.toString();
              break;
            case 'o':
              g = m.toString(8);
              break;
            case 'x':
              g = m.toString(16);
              break;
            case 'X':
              g = m.toString(16).toUpperCase();
              break;
            default:
              goog.asserts.assert(!1, 'Unhandled format specifier'), (g = m.toString());
          }
          k = window.parseInt(k, 10) || 1;
          return Array(Math.max(0, k - g.length) + 1).join('0') + g;
        },
      );
    };
    shaka.dash.MpdUtils.createTimeline = function (a, b, c, d) {
      goog.asserts.assert(0 < b && Infinity > b, 'timescale must be a positive, finite integer');
      goog.asserts.assert(0 < d, 'period duration must be a positive integer');
      var e = shaka.util.XmlUtils,
        f = e.findChildren(a, 'S');
      a = [];
      var g = -c;
      f = $jscomp.makeIterator(shaka.util.Iterables.enumerate(f));
      for (var h = f.next(); !h.done; h = f.next()) {
        h = h.value;
        var k = h.item,
          l = h.next,
          m = e.parseAttr(k, 't', e.parseNonNegativeInt);
        h = e.parseAttr(k, 'd', e.parseNonNegativeInt);
        var n = e.parseAttr(k, 'r', e.parseInt);
        null != m && (m -= c);
        if (!h) {
          shaka.log.warning('"S" element must have a duration:', 'ignoring the remaining "S" elements.', k);
          break;
        }
        m = null != m ? m : g;
        n = n || 0;
        if (0 > n)
          if (l) {
            l = e.parseAttr(l, 't', e.parseNonNegativeInt);
            if (null == l) {
              shaka.log.warning(
                'An "S" element cannot have a negative repeat',
                'if the next "S" element does not have a valid start time:',
                'ignoring the remaining "S" elements.',
                k,
              );
              break;
            } else if (m >= l) {
              shaka.log.warning(
                'An "S" element cannot have a negative repeatif its start ',
                'time exceeds the next "S" element\'s start time:',
                'ignoring the remaining "S" elements.',
                k,
              );
              break;
            }
            n = Math.ceil((l - m) / h) - 1;
          } else {
            if (Infinity == d) {
              shaka.log.warning(
                'The last "S" element cannot have a negative repeat',
                'if the Period has an infinite duration:',
                'ignoring the last "S" element.',
                k,
              );
              break;
            } else if (m / b >= d) {
              shaka.log.warning(
                'The last "S" element cannot have a negative repeat',
                "if its start time exceeds the Period's duration:",
                'igoring the last "S" element.',
                k,
              );
              break;
            }
            n = Math.ceil((d * b - m) / h) - 1;
          }
        0 < a.length &&
          m != g &&
          (Math.abs((m - g) / b) >= shaka.util.ManifestParserUtils.GAP_OVERLAP_TOLERANCE_SECONDS &&
            shaka.log.warning('SegmentTimeline contains a large gap/overlap:', 'the content may have errors in it.', k),
          (a[a.length - 1].end = m / b));
        k = $jscomp.makeIterator(shaka.util.Iterables.range(n + 1));
        for (l = k.next(); !l.done; l = k.next())
          shaka.util.Functional.ignored(l.value),
            (g = m + h),
            a.push({ start: m / b, end: g / b, unscaledStart: m }),
            (m = g);
      }
      return a;
    };
    shaka.dash.MpdUtils.parseSegmentInfo = function (a, b) {
      goog.asserts.assert(b(a.representation), 'There must be at least one element of the given type.');
      var c = shaka.dash.MpdUtils,
        d = shaka.util.XmlUtils,
        e = c.inheritAttribute(a, b, 'timescale'),
        f = 1;
      e && (f = d.parsePositiveInt(e) || 1);
      e = c.inheritAttribute(a, b, 'duration');
      (e = d.parsePositiveInt(e || '')) && (e /= f);
      var g = c.inheritAttribute(a, b, 'startNumber'),
        h = Number(c.inheritAttribute(a, b, 'presentationTimeOffset')) || 0;
      d = d.parseNonNegativeInt(g || '');
      if (null == g || null == d) d = 1;
      g = c.inheritChild(a, b, 'SegmentTimeline');
      var k = null;
      g && (k = c.createTimeline(g, f, h, a.periodInfo.duration || Infinity));
      return {
        timescale: f,
        segmentDuration: e,
        startNumber: d,
        scaledPresentationTimeOffset: h / f || 0,
        unscaledPresentationTimeOffset: h,
        timeline: k,
      };
    };
    shaka.dash.MpdUtils.inheritAttribute = function (a, b, c) {
      var d = shaka.util.Functional;
      goog.asserts.assert(b(a.representation), 'There must be at least one element of the given type');
      return [b(a.representation), b(a.adaptationSet), b(a.period)]
        .filter(d.isNotNull)
        .map(function (e) {
          return e.getAttribute(c);
        })
        .reduce(function (e, f) {
          return e || f;
        });
    };
    shaka.dash.MpdUtils.inheritChild = function (a, b, c) {
      var d = shaka.util.Functional;
      goog.asserts.assert(b(a.representation), 'There must be at least one element of the given type');
      a = [b(a.representation), b(a.adaptationSet), b(a.period)].filter(d.isNotNull);
      var e = shaka.util.XmlUtils;
      return a
        .map(function (f) {
          return e.findChild(f, c);
        })
        .reduce(function (f, g) {
          return f || g;
        });
    };
    shaka.dash.MpdUtils.handleXlinkInElement_ = function (a, b, c, d, e, f) {
      var g = shaka.util.XmlUtils,
        h = shaka.util.Error,
        k = shaka.util.ManifestParserUtils,
        l = shaka.dash.MpdUtils.XlinkNamespaceUri_,
        m = g.getAttributeNS(a, l, 'href');
      g = g.getAttributeNS(a, l, 'actuate') || 'onRequest';
      for (var n = $jscomp.makeIterator(Array.from(a.attributes)), p = n.next(); !p.done; p = n.next())
        (p = p.value), p.namespaceURI == l && a.removeAttributeNS(p.namespaceURI, p.localName);
      if (5 <= f)
        return shaka.util.AbortableOperation.failed(
          new h(h.Severity.CRITICAL, h.Category.MANIFEST, h.Code.DASH_XLINK_DEPTH_LIMIT),
        );
      if ('onLoad' != g)
        return shaka.util.AbortableOperation.failed(
          new h(h.Severity.CRITICAL, h.Category.MANIFEST, h.Code.DASH_UNSUPPORTED_XLINK_ACTUATE),
        );
      var q = k.resolveUris([d], [m]);
      d = shaka.net.NetworkingEngine.RequestType.MANIFEST;
      k = shaka.net.NetworkingEngine.makeRequest(q, b);
      d = e.request(d, k);
      goog.asserts.assert(
        d instanceof shaka.util.AbortableOperation,
        'Unexpected implementation of IAbortableOperation!',
      );
      return d.chain(function (r) {
        r = shaka.util.XmlUtils.parseXml(r.data, a.tagName);
        if (!r)
          return shaka.util.AbortableOperation.failed(
            new h(h.Severity.CRITICAL, h.Category.MANIFEST, h.Code.DASH_INVALID_XML, m),
          );
        for (; a.childNodes.length; ) a.removeChild(a.childNodes[0]);
        for (; r.childNodes.length; ) {
          var t = r.childNodes[0];
          r.removeChild(t);
          a.appendChild(t);
        }
        r = $jscomp.makeIterator(Array.from(r.attributes));
        for (t = r.next(); !t.done; t = r.next()) a.setAttributeNode(t.value.cloneNode(!1));
        return shaka.dash.MpdUtils.processXlinks(a, b, c, q[0], e, f + 1);
      });
    };
    shaka.dash.MpdUtils.processXlinks = function (a, b, c, d, e, f) {
      f = void 0 === f ? 0 : f;
      var g = shaka.dash.MpdUtils,
        h = shaka.util.XmlUtils,
        k = g.XlinkNamespaceUri_;
      if (h.getAttributeNS(a, k, 'href'))
        return (
          (h = g.handleXlinkInElement_(a, b, c, d, e, f)),
          c &&
            (h = h.chain(void 0, function (p) {
              return g.processXlinks(a, b, c, d, e, f);
            })),
          h
        );
      for (var l = [], m = $jscomp.makeIterator(Array.from(a.childNodes)), n = m.next(); !n.done; n = m.next())
        (n = n.value),
          n instanceof Element &&
            ('urn:mpeg:dash:resolve-to-zero:2013' == h.getAttributeNS(n, k, 'href')
              ? a.removeChild(n)
              : 'SegmentTimeline' != n.tagName && l.push(shaka.dash.MpdUtils.processXlinks(n, b, c, d, e, f)));
      return shaka.util.AbortableOperation.all(l).chain(function () {
        return a;
      });
    };
    shaka.dash.MpdUtils.XlinkNamespaceUri_ = 'http://www.w3.org/1999/xlink';
    shaka.media.Mp4SegmentIndexParser = function () {};
    shaka.media.Mp4SegmentIndexParser.parse = function (a, b, c, d, e, f, g) {
      var h = shaka.media.Mp4SegmentIndexParser,
        k,
        l = new shaka.util.Mp4Parser().fullBox('sidx', function (m) {
          k = h.parseSIDX_(b, d, e, f, g, c, m);
        });
      a && l.parse(a);
      if (k) return k;
      shaka.log.error('Invalid box type, expected "sidx".');
      throw new shaka.util.Error(
        shaka.util.Error.Severity.CRITICAL,
        shaka.util.Error.Category.MEDIA,
        shaka.util.Error.Code.MP4_SIDX_WRONG_BOX_TYPE,
      );
    };
    shaka.media.Mp4SegmentIndexParser.parseSIDX_ = function (a, b, c, d, e, f, g) {
      goog.asserts.assert(null != g.version, 'SIDX is a full box and should have a valid version.');
      var h = [];
      g.reader.skip(4);
      var k = g.reader.readUint32();
      if (0 == k)
        throw (
          (shaka.log.error('Invalid timescale.'),
          new shaka.util.Error(
            shaka.util.Error.Severity.CRITICAL,
            shaka.util.Error.Category.MEDIA,
            shaka.util.Error.Code.MP4_SIDX_INVALID_TIMESCALE,
          ))
        );
      if (0 == g.version) {
        var l = g.reader.readUint32();
        var m = g.reader.readUint32();
      } else (l = g.reader.readUint64()), (m = g.reader.readUint64());
      g.reader.skip(2);
      var n = g.reader.readUint16();
      a = a + g.size + m;
      n = $jscomp.makeIterator(shaka.util.Iterables.range(n));
      for (m = n.next(); !m.done; m = n.next()) {
        shaka.util.Functional.ignored(m.value);
        var p = g.reader.readUint32();
        m = (p & 2147483648) >>> 31;
        p &= 2147483647;
        var q = g.reader.readUint32();
        g.reader.skip(4);
        if (1 == m)
          throw (
            (shaka.log.error('Heirarchical SIDXs are not supported.'),
            new shaka.util.Error(
              shaka.util.Error.Severity.CRITICAL,
              shaka.util.Error.Category.MEDIA,
              shaka.util.Error.Code.MP4_SIDX_TYPE_NOT_SUPPORTED,
            ))
          );
        h.push(
          new shaka.media.SegmentReference(
            l / k + c,
            (l + q) / k + c,
            function () {
              return f;
            },
            a,
            a + p - 1,
            b,
            c,
            d,
            e,
          ),
        );
        l += q;
        a += p;
      }
      g.parser.stop();
      return h;
    };
    shaka.util.EbmlParser = function (a) {
      this.dataView_ = shaka.util.BufferUtils.toDataView(a);
      this.reader_ = new shaka.util.DataViewReader(this.dataView_, shaka.util.DataViewReader.Endianness.BIG_ENDIAN);
    };
    shaka.util.EbmlParser.prototype.hasMoreData = function () {
      return this.reader_.hasMoreData();
    };
    shaka.util.EbmlParser.prototype.parseElement = function () {
      var a = this.parseId_(),
        b = this.parseVint_();
      b = shaka.util.EbmlParser.isDynamicSizeValue_(b)
        ? this.dataView_.byteLength - this.reader_.getPosition()
        : shaka.util.EbmlParser.getVintValue_(b);
      b =
        this.reader_.getPosition() + b <= this.dataView_.byteLength
          ? b
          : this.dataView_.byteLength - this.reader_.getPosition();
      var c = shaka.util.BufferUtils.toDataView(this.dataView_, this.reader_.getPosition(), b);
      this.reader_.skip(b);
      return new shaka.util.EbmlElement(a, c);
    };
    shaka.util.EbmlParser.prototype.parseId_ = function () {
      var a = this.parseVint_();
      if (7 < a.length)
        throw new shaka.util.Error(
          shaka.util.Error.Severity.CRITICAL,
          shaka.util.Error.Category.MEDIA,
          shaka.util.Error.Code.EBML_OVERFLOW,
        );
      var b = 0;
      a = $jscomp.makeIterator(a);
      for (var c = a.next(); !c.done; c = a.next()) b = 256 * b + c.value;
      return b;
    };
    shaka.util.EbmlParser.prototype.parseVint_ = function () {
      var a = this.reader_.getPosition(),
        b = this.reader_.readUint8();
      if (0 == b)
        throw new shaka.util.Error(
          shaka.util.Error.Severity.CRITICAL,
          shaka.util.Error.Category.MEDIA,
          shaka.util.Error.Code.EBML_OVERFLOW,
        );
      b = 8 - Math.floor(Math.log2(b));
      goog.asserts.assert(8 >= b && 1 <= b, 'Incorrect log2 value');
      this.reader_.skip(b - 1);
      return shaka.util.BufferUtils.toUint8(this.dataView_, a, b);
    };
    shaka.util.EbmlParser.getVintValue_ = function (a) {
      if (8 == a.length && a[1] & 224)
        throw new shaka.util.Error(
          shaka.util.Error.Severity.CRITICAL,
          shaka.util.Error.Category.MEDIA,
          shaka.util.Error.Code.JS_INTEGER_OVERFLOW,
        );
      for (
        var b = 0, c = $jscomp.makeIterator(shaka.util.Iterables.enumerate(a)), d = c.next();
        !d.done;
        d = c.next()
      ) {
        d = d.value;
        var e = d.item;
        b = 0 == d.i ? e & ((1 << (8 - a.length)) - 1) : 256 * b + e;
      }
      return b;
    };
    shaka.util.EbmlParser.isDynamicSizeValue_ = function (a) {
      for (
        var b = shaka.util.BufferUtils, c = $jscomp.makeIterator(shaka.util.EbmlParser.DYNAMIC_SIZES), d = c.next();
        !d.done;
        d = c.next()
      )
        if (b.equal(a, new Uint8Array(d.value))) return !0;
      return !1;
    };
    shaka.util.EbmlParser.DYNAMIC_SIZES = [
      [255],
      [127, 255],
      [63, 255, 255],
      [31, 255, 255, 255],
      [15, 255, 255, 255, 255],
      [7, 255, 255, 255, 255, 255],
      [3, 255, 255, 255, 255, 255, 255],
      [1, 255, 255, 255, 255, 255, 255, 255],
    ];
    shaka.util.EbmlElement = function (a, b) {
      this.id = a;
      this.dataView_ = b;
    };
    shaka.util.EbmlElement.prototype.getOffset = function () {
      return this.dataView_.byteOffset;
    };
    shaka.util.EbmlElement.prototype.createParser = function () {
      return new shaka.util.EbmlParser(this.dataView_);
    };
    shaka.util.EbmlElement.prototype.getUint = function () {
      if (8 < this.dataView_.byteLength)
        throw new shaka.util.Error(
          shaka.util.Error.Severity.CRITICAL,
          shaka.util.Error.Category.MEDIA,
          shaka.util.Error.Code.EBML_OVERFLOW,
        );
      if (8 == this.dataView_.byteLength && this.dataView_.getUint8(0) & 224)
        throw new shaka.util.Error(
          shaka.util.Error.Severity.CRITICAL,
          shaka.util.Error.Category.MEDIA,
          shaka.util.Error.Code.JS_INTEGER_OVERFLOW,
        );
      for (
        var a = 0, b = $jscomp.makeIterator(shaka.util.Iterables.range(this.dataView_.byteLength)), c = b.next();
        !c.done;
        c = b.next()
      )
        (c = this.dataView_.getUint8(c.value)), (a = 256 * a + c);
      return a;
    };
    shaka.util.EbmlElement.prototype.getFloat = function () {
      if (4 == this.dataView_.byteLength) return this.dataView_.getFloat32(0);
      if (8 == this.dataView_.byteLength) return this.dataView_.getFloat64(0);
      throw new shaka.util.Error(
        shaka.util.Error.Severity.CRITICAL,
        shaka.util.Error.Category.MEDIA,
        shaka.util.Error.Code.EBML_BAD_FLOATING_POINT_SIZE,
      );
    };
    shaka.media.WebmSegmentIndexParser = function () {};
    shaka.media.WebmSegmentIndexParser.parse = function (a, b, c, d, e, f, g) {
      b = shaka.media.WebmSegmentIndexParser.parseWebmContainer_(b);
      a = new shaka.util.EbmlParser(a).parseElement();
      if (a.id != shaka.media.WebmSegmentIndexParser.CUES_ID)
        throw (
          (shaka.log.error('Not a Cues element.'),
          new shaka.util.Error(
            shaka.util.Error.Severity.CRITICAL,
            shaka.util.Error.Category.MEDIA,
            shaka.util.Error.Code.WEBM_CUES_ELEMENT_MISSING,
          ))
        );
      return shaka.media.WebmSegmentIndexParser.parseCues_(
        a,
        b.segmentOffset,
        b.timecodeScale,
        b.duration,
        c,
        d,
        e,
        f,
        g,
      );
    };
    shaka.media.WebmSegmentIndexParser.parseWebmContainer_ = function (a) {
      a = new shaka.util.EbmlParser(a);
      if (a.parseElement().id != shaka.media.WebmSegmentIndexParser.EBML_ID)
        throw (
          (shaka.log.error('Not an EBML element.'),
          new shaka.util.Error(
            shaka.util.Error.Severity.CRITICAL,
            shaka.util.Error.Category.MEDIA,
            shaka.util.Error.Code.WEBM_EBML_HEADER_ELEMENT_MISSING,
          ))
        );
      var b = a.parseElement();
      if (b.id != shaka.media.WebmSegmentIndexParser.SEGMENT_ID)
        throw (
          (shaka.log.error('Not a Segment element.'),
          new shaka.util.Error(
            shaka.util.Error.Severity.CRITICAL,
            shaka.util.Error.Category.MEDIA,
            shaka.util.Error.Code.WEBM_SEGMENT_ELEMENT_MISSING,
          ))
        );
      a = b.getOffset();
      b = shaka.media.WebmSegmentIndexParser.parseSegment_(b);
      return { segmentOffset: a, timecodeScale: b.timecodeScale, duration: b.duration };
    };
    shaka.media.WebmSegmentIndexParser.parseSegment_ = function (a) {
      a = a.createParser();
      for (var b = null; a.hasMoreData(); ) {
        var c = a.parseElement();
        if (c.id == shaka.media.WebmSegmentIndexParser.INFO_ID) {
          b = c;
          break;
        }
      }
      if (!b)
        throw (
          (shaka.log.error('Not an Info element.'),
          new shaka.util.Error(
            shaka.util.Error.Severity.CRITICAL,
            shaka.util.Error.Category.MEDIA,
            shaka.util.Error.Code.WEBM_INFO_ELEMENT_MISSING,
          ))
        );
      return shaka.media.WebmSegmentIndexParser.parseInfo_(b);
    };
    shaka.media.WebmSegmentIndexParser.parseInfo_ = function (a) {
      var b = a.createParser(),
        c = 1e6;
      for (a = null; b.hasMoreData(); ) {
        var d = b.parseElement();
        d.id == shaka.media.WebmSegmentIndexParser.TIMECODE_SCALE_ID
          ? (c = d.getUint())
          : d.id == shaka.media.WebmSegmentIndexParser.DURATION_ID && (a = d.getFloat());
      }
      if (null == a)
        throw new shaka.util.Error(
          shaka.util.Error.Severity.CRITICAL,
          shaka.util.Error.Category.MEDIA,
          shaka.util.Error.Code.WEBM_DURATION_ELEMENT_MISSING,
        );
      b = c / 1e9;
      return { timecodeScale: b, duration: a * b };
    };
    shaka.media.WebmSegmentIndexParser.parseCues_ = function (a, b, c, d, e, f, g, h, k) {
      var l = [],
        m = function () {
          return e;
        };
      a = a.createParser();
      for (var n = null, p = null; a.hasMoreData(); ) {
        var q = a.parseElement();
        if (q.id == shaka.media.WebmSegmentIndexParser.CUE_POINT_ID) {
          var r = shaka.media.WebmSegmentIndexParser.parseCuePoint_(q);
          r &&
            ((q = c * r.unscaledTime),
            (r = b + r.relativeOffset),
            null != n &&
              (goog.asserts.assert(null != p, 'last offset cannot be null'),
              l.push(new shaka.media.SegmentReference(n + g, q + g, m, p, r - 1, f, g, h, k))),
            (n = q),
            (p = r));
        }
      }
      null != n &&
        (goog.asserts.assert(null != p, 'last offset cannot be null'),
        l.push(new shaka.media.SegmentReference(n + g, d + g, m, p, null, f, g, h, k)));
      return l;
    };
    shaka.media.WebmSegmentIndexParser.parseCuePoint_ = function (a) {
      var b = a.createParser();
      a = b.parseElement();
      if (a.id != shaka.media.WebmSegmentIndexParser.CUE_TIME_ID)
        throw (
          (shaka.log.warning('Not a CueTime element.'),
          new shaka.util.Error(
            shaka.util.Error.Severity.CRITICAL,
            shaka.util.Error.Category.MEDIA,
            shaka.util.Error.Code.WEBM_CUE_TIME_ELEMENT_MISSING,
          ))
        );
      a = a.getUint();
      b = b.parseElement();
      if (b.id != shaka.media.WebmSegmentIndexParser.CUE_TRACK_POSITIONS_ID)
        throw (
          (shaka.log.warning('Not a CueTrackPositions element.'),
          new shaka.util.Error(
            shaka.util.Error.Severity.CRITICAL,
            shaka.util.Error.Category.MEDIA,
            shaka.util.Error.Code.WEBM_CUE_TRACK_POSITIONS_ELEMENT_MISSING,
          ))
        );
      b = b.createParser();
      for (var c = 0; b.hasMoreData(); ) {
        var d = b.parseElement();
        if (d.id == shaka.media.WebmSegmentIndexParser.CUE_CLUSTER_POSITION) {
          c = d.getUint();
          break;
        }
      }
      return { unscaledTime: a, relativeOffset: c };
    };
    shaka.media.WebmSegmentIndexParser.EBML_ID = 440786851;
    shaka.media.WebmSegmentIndexParser.SEGMENT_ID = 408125543;
    shaka.media.WebmSegmentIndexParser.INFO_ID = 357149030;
    shaka.media.WebmSegmentIndexParser.TIMECODE_SCALE_ID = 2807729;
    shaka.media.WebmSegmentIndexParser.DURATION_ID = 17545;
    shaka.media.WebmSegmentIndexParser.CUES_ID = 475249515;
    shaka.media.WebmSegmentIndexParser.CUE_POINT_ID = 187;
    shaka.media.WebmSegmentIndexParser.CUE_TIME_ID = 179;
    shaka.media.WebmSegmentIndexParser.CUE_TRACK_POSITIONS_ID = 183;
    shaka.media.WebmSegmentIndexParser.CUE_CLUSTER_POSITION = 241;
    shaka.dash.SegmentBase = function () {};
    shaka.dash.SegmentBase.createInitSegment = function (a, b) {
      var c = shaka.util.XmlUtils,
        d = shaka.util.ManifestParserUtils,
        e = shaka.dash.MpdUtils.inheritChild(a, b, 'Initialization');
      if (!e) return null;
      var f = a.representation.baseUris,
        g = e.getAttribute('sourceURL');
      g && (f = d.resolveUris(a.representation.baseUris, [g]));
      d = 0;
      g = null;
      if ((c = c.parseAttr(e, 'range', c.parseRange))) (d = c.start), (g = c.end);
      return new shaka.media.InitSegmentReference(
        function () {
          return f;
        },
        d,
        g,
      );
    };
    shaka.dash.SegmentBase.createStreamInfo = function (a, b) {
      goog.asserts.assert(a.representation.segmentBase, 'Should only be called with SegmentBase');
      var c = shaka.dash.MpdUtils,
        d = shaka.dash.SegmentBase,
        e = shaka.util.XmlUtils,
        f = Number(c.inheritAttribute(a, d.fromInheritance_, 'presentationTimeOffset')) || 0;
      c = c.inheritAttribute(a, d.fromInheritance_, 'timescale');
      var g = 1;
      c && (g = e.parsePositiveInt(c) || 1);
      var h = f / g || 0,
        k = d.createInitSegment(a, d.fromInheritance_);
      d.checkSegmentIndexRangeSupport_(a, k);
      var l = shaka.util.ObjectUtils.shallowCloneObject(a);
      return {
        generateSegmentIndex: function () {
          return d.generateSegmentIndex_(l, b, k, h);
        },
      };
    };
    shaka.dash.SegmentBase.generateSegmentIndexFromUris = function (a, b, c, d, e, f, g) {
      var h, k, l, m, n, p, q, r, t, w, u, v, x, B, z;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (A) {
        if (1 == A.nextAddress)
          return (
            (h = a.presentationTimeline),
            (k = !a.dynamic || !a.periodInfo.isLastPeriod),
            (l = a.periodInfo.start),
            (m = a.periodInfo.duration),
            (n = a.representation.mimeType.split('/')[1]),
            (p = b),
            (q = null),
            (r = [p(d, e, f), 'webm' == n ? p(c.getUris(), c.startByte, c.endByte) : null]),
            (p = null),
            A.yield(Promise.all(r), 2)
          );
        t = A.yieldResult;
        w = t[0];
        u = t[1] || null;
        v = null;
        x = l - g;
        B = l;
        z = m ? l + m : Infinity;
        'mp4' == n
          ? (v = shaka.media.Mp4SegmentIndexParser.parse(w, e, d, c, x, B, z))
          : (goog.asserts.assert(u, 'WebM requires init data'),
            (v = shaka.media.WebmSegmentIndexParser.parse(w, u, d, c, x, B, z)));
        h.notifySegments(v);
        goog.asserts.assert(!q, 'Should not call generateSegmentIndex twice');
        q = new shaka.media.SegmentIndex(v);
        k && q.fit(B, z);
        return A['return'](q);
      });
    };
    shaka.dash.SegmentBase.fromInheritance_ = function (a) {
      return a.segmentBase;
    };
    shaka.dash.SegmentBase.computeIndexRange_ = function (a) {
      var b = shaka.dash.MpdUtils,
        c = shaka.dash.SegmentBase,
        d = shaka.util.XmlUtils,
        e = b.inheritChild(a, c.fromInheritance_, 'RepresentationIndex');
      a = b.inheritAttribute(a, c.fromInheritance_, 'indexRange');
      a = d.parseRange(a || '');
      e && (a = d.parseAttr(e, 'range', d.parseRange, a));
      return a;
    };
    shaka.dash.SegmentBase.computeIndexUris_ = function (a) {
      var b = shaka.util.ManifestParserUtils,
        c = shaka.dash.MpdUtils.inheritChild(a, shaka.dash.SegmentBase.fromInheritance_, 'RepresentationIndex'),
        d = a.representation.baseUris;
      c && (c = c.getAttribute('sourceURL')) && (d = b.resolveUris(a.representation.baseUris, [c]));
      return d;
    };
    shaka.dash.SegmentBase.checkSegmentIndexRangeSupport_ = function (a, b) {
      var c = shaka.dash.SegmentBase;
      c.checkSegmentIndexSupport(a, b);
      if (!c.computeIndexRange_(a))
        throw (
          (shaka.log.error(
            'SegmentBase does not contain sufficient segment information:',
            'the SegmentBase does not contain @indexRange',
            'or a RepresentationIndex element.',
            a.representation,
          ),
          new shaka.util.Error(
            shaka.util.Error.Severity.CRITICAL,
            shaka.util.Error.Category.MANIFEST,
            shaka.util.Error.Code.DASH_NO_SEGMENT_INFO,
          ))
        );
    };
    shaka.dash.SegmentBase.checkSegmentIndexSupport = function (a, b) {
      var c = shaka.util.ManifestParserUtils.ContentType,
        d = a.representation.contentType,
        e = a.representation.mimeType.split('/')[1];
      if (d != c.TEXT && 'mp4' != e && 'webm' != e)
        throw (
          (shaka.log.error('SegmentBase specifies an unsupported container type.', a.representation),
          new shaka.util.Error(
            shaka.util.Error.Severity.CRITICAL,
            shaka.util.Error.Category.MANIFEST,
            shaka.util.Error.Code.DASH_UNSUPPORTED_CONTAINER,
          ))
        );
      if ('webm' == e && !b)
        throw (
          (shaka.log.error(
            'SegmentBase does not contain sufficient segment information:',
            'the SegmentBase uses a WebM container,',
            'but does not contain an Initialization element.',
            a.representation,
          ),
          new shaka.util.Error(
            shaka.util.Error.Severity.CRITICAL,
            shaka.util.Error.Category.MANIFEST,
            shaka.util.Error.Code.DASH_WEBM_MISSING_INIT,
          ))
        );
    };
    shaka.dash.SegmentBase.generateSegmentIndex_ = function (a, b, c, d) {
      var e = shaka.dash.SegmentBase,
        f = e.computeIndexUris_(a);
      e = e.computeIndexRange_(a);
      goog.asserts.assert(e, 'Index range should not be null!');
      return shaka.dash.SegmentBase.generateSegmentIndexFromUris(a, b, c, f, e.start, e.end, d);
    };
    shaka.dash.SegmentList = function () {};
    shaka.dash.SegmentList.createStreamInfo = function (a, b) {
      goog.asserts.assert(a.representation.segmentList, 'Should only be called with SegmentList');
      var c = shaka.dash.SegmentList,
        d = shaka.dash.SegmentBase.createInitSegment(a, c.fromInheritance_),
        e = c.parseSegmentListInfo_(a);
      c.checkSegmentListInfo_(a, e);
      var f = null,
        g = null;
      a.period.id && a.representation.id && ((g = a.period.id + ',' + a.representation.id), (f = b[g]));
      c = c.createSegmentReferences_(
        a.periodInfo.start,
        a.periodInfo.duration,
        e.startNumber,
        a.representation.baseUris,
        e,
        d,
      );
      f
        ? (f.merge(c), (g = a.presentationTimeline.getSegmentAvailabilityStart()), f.evict(g))
        : (a.presentationTimeline.notifySegments(c),
          (f = new shaka.media.SegmentIndex(c)),
          g && a.dynamic && (b[g] = f));
      (a.dynamic && a.periodInfo.isLastPeriod) ||
        f.fit(a.periodInfo.start, a.periodInfo.duration ? a.periodInfo.start + a.periodInfo.duration : Infinity);
      return {
        generateSegmentIndex: function () {
          return Promise.resolve(f);
        },
      };
    };
    shaka.dash.SegmentList.fromInheritance_ = function (a) {
      return a.segmentList;
    };
    shaka.dash.SegmentList.parseSegmentListInfo_ = function (a) {
      var b = shaka.dash.SegmentList,
        c = shaka.dash.MpdUtils,
        d = b.parseMediaSegments_(a);
      a = c.parseSegmentInfo(a, b.fromInheritance_);
      b = a.startNumber;
      0 == b && (shaka.log.warning('SegmentList@startNumber must be > 0'), (b = 1));
      c = 0;
      a.segmentDuration
        ? (c = a.segmentDuration * (b - 1))
        : a.timeline && 0 < a.timeline.length && (c = a.timeline[0].start);
      return {
        segmentDuration: a.segmentDuration,
        startTime: c,
        startNumber: b,
        scaledPresentationTimeOffset: a.scaledPresentationTimeOffset,
        timeline: a.timeline,
        mediaSegments: d,
      };
    };
    shaka.dash.SegmentList.checkSegmentListInfo_ = function (a, b) {
      if (!b.segmentDuration && !b.timeline && 1 < b.mediaSegments.length)
        throw (
          (shaka.log.warning(
            'SegmentList does not contain sufficient segment information:',
            'the SegmentList specifies multiple segments,',
            'but does not specify a segment duration or timeline.',
            a.representation,
          ),
          new shaka.util.Error(
            shaka.util.Error.Severity.CRITICAL,
            shaka.util.Error.Category.MANIFEST,
            shaka.util.Error.Code.DASH_NO_SEGMENT_INFO,
          ))
        );
      if (!b.segmentDuration && !a.periodInfo.duration && !b.timeline && 1 == b.mediaSegments.length)
        throw (
          (shaka.log.warning(
            'SegmentList does not contain sufficient segment information:',
            'the SegmentList specifies one segment,',
            'but does not specify a segment duration, period duration,',
            'or timeline.',
            a.representation,
          ),
          new shaka.util.Error(
            shaka.util.Error.Severity.CRITICAL,
            shaka.util.Error.Category.MANIFEST,
            shaka.util.Error.Code.DASH_NO_SEGMENT_INFO,
          ))
        );
      if (b.timeline && 0 == b.timeline.length)
        throw (
          (shaka.log.warning(
            'SegmentList does not contain sufficient segment information:',
            'the SegmentList has an empty timeline.',
            a.representation,
          ),
          new shaka.util.Error(
            shaka.util.Error.Severity.CRITICAL,
            shaka.util.Error.Category.MANIFEST,
            shaka.util.Error.Code.DASH_NO_SEGMENT_INFO,
          ))
        );
    };
    shaka.dash.SegmentList.createSegmentReferences_ = function (a, b, c, d, e, f) {
      c = shaka.util.ManifestParserUtils;
      var g = e.mediaSegments.length;
      e.timeline &&
        e.timeline.length != e.mediaSegments.length &&
        ((g = Math.min(e.timeline.length, e.mediaSegments.length)),
        shaka.log.warning(
          'The number of items in the segment timeline and the number of ',
          'segment URLs do not match, truncating',
          e.mediaSegments.length,
          'to',
          g,
        ));
      var h = a - e.scaledPresentationTimeOffset,
        k = b ? a + b : Infinity,
        l = [],
        m = e.startTime,
        n = {};
      g = $jscomp.makeIterator(shaka.util.Iterables.range(g));
      for (
        var p = g.next();
        !p.done;
        n = { $jscomp$loop$prop$mediaUri$539: n.$jscomp$loop$prop$mediaUri$539 }, p = g.next()
      ) {
        var q = p.value;
        p = e.mediaSegments[q];
        n.$jscomp$loop$prop$mediaUri$539 = c.resolveUris(d, [p.mediaUri]);
        var r = void 0;
        null != e.segmentDuration
          ? (r = m + e.segmentDuration)
          : e.timeline
          ? (r = e.timeline[q].end)
          : (goog.asserts.assert(
              1 == e.mediaSegments.length && b,
              'There should be exactly one segment with a Period duration.',
            ),
            (r = m + b));
        q = (function (t) {
          return function () {
            return t.$jscomp$loop$prop$mediaUri$539;
          };
        })(n);
        l.push(new shaka.media.SegmentReference(a + m, a + r, q, p.start, p.end, f, h, a, k));
        m = r;
      }
      return l;
    };
    shaka.dash.SegmentList.parseMediaSegments_ = function (a) {
      var b = [a.representation.segmentList, a.adaptationSet.segmentList, a.period.segmentList].filter(
          shaka.util.Functional.isNotNull,
        ),
        c = shaka.util.XmlUtils;
      return b
        .map(function (d) {
          return c.findChildren(d, 'SegmentURL');
        })
        .reduce(function (d, e) {
          return 0 < d.length ? d : e;
        })
        .map(function (d) {
          d.getAttribute('indexRange') &&
            !a.indexRangeWarningGiven &&
            ((a.indexRangeWarningGiven = !0),
            shaka.log.warning(
              'We do not support the SegmentURL@indexRange attribute on SegmentList.  We only use the SegmentList@duration attribute or SegmentTimeline, which must be accurate.',
            ));
          var e = d.getAttribute('media');
          d = c.parseAttr(d, 'mediaRange', c.parseRange, { start: 0, end: null });
          return { mediaUri: e, start: d.start, end: d.end };
        });
    };
    shaka.dash.SegmentTemplate = function () {};
    shaka.dash.SegmentTemplate.createStreamInfo = function (a, b, c, d, e) {
      goog.asserts.assert(a.representation.segmentTemplate, 'Should only be called with SegmentTemplate');
      var f = shaka.dash.SegmentTemplate,
        g = f.createInitSegment_(a),
        h = f.parseSegmentTemplateInfo_(a);
      f.checkSegmentTemplateInfo_(a, h);
      var k = shaka.util.ObjectUtils.shallowCloneObject(a);
      if (h.indexTemplate)
        return (
          shaka.dash.SegmentBase.checkSegmentIndexSupport(a, g),
          {
            generateSegmentIndex: function () {
              return f.generateSegmentIndexFromIndexTemplate_(k, b, g, h);
            },
          }
        );
      if (h.segmentDuration)
        return (
          d ||
            (a.presentationTimeline.notifyMaxSegmentDuration(h.segmentDuration),
            a.presentationTimeline.notifyMinSegmentStartTime(a.periodInfo.start)),
          {
            generateSegmentIndex: function () {
              return f.generateSegmentIndexFromDuration_(k, h, e, g);
            },
          }
        );
      var l = null;
      d = null;
      a.period.id && a.representation.id && ((d = a.period.id + ',' + a.representation.id), (l = c[d]));
      var m = f.createFromTimeline_(k, h, g),
        n = a.periodInfo.start,
        p = a.periodInfo.duration ? a.periodInfo.start + a.periodInfo.duration : Infinity,
        q = Infinity != p;
      l
        ? (q && new shaka.media.SegmentIndex(m).fit(n, p),
          l.merge(m),
          l.evict(a.presentationTimeline.getSegmentAvailabilityStart()))
        : (a.presentationTimeline.notifySegments(m),
          (l = new shaka.media.SegmentIndex(m)),
          d && a.dynamic && (c[d] = l));
      q && l.fit(n, p);
      return {
        generateSegmentIndex: function () {
          return Promise.resolve(l);
        },
      };
    };
    shaka.dash.SegmentTemplate.fromInheritance_ = function (a) {
      return a.segmentTemplate;
    };
    shaka.dash.SegmentTemplate.parseSegmentTemplateInfo_ = function (a) {
      var b = shaka.dash.SegmentTemplate,
        c = shaka.dash.MpdUtils,
        d = c.parseSegmentInfo(a, b.fromInheritance_),
        e = c.inheritAttribute(a, b.fromInheritance_, 'media');
      a = c.inheritAttribute(a, b.fromInheritance_, 'index');
      return {
        segmentDuration: d.segmentDuration,
        timescale: d.timescale,
        startNumber: d.startNumber,
        scaledPresentationTimeOffset: d.scaledPresentationTimeOffset,
        unscaledPresentationTimeOffset: d.unscaledPresentationTimeOffset,
        timeline: d.timeline,
        mediaTemplate: e,
        indexTemplate: a,
      };
    };
    shaka.dash.SegmentTemplate.checkSegmentTemplateInfo_ = function (a, b) {
      var c = b.indexTemplate ? 1 : 0;
      c += b.timeline ? 1 : 0;
      c += b.segmentDuration ? 1 : 0;
      if (0 == c)
        throw (
          (shaka.log.error(
            'SegmentTemplate does not contain any segment information:',
            'the SegmentTemplate must contain either an index URL template',
            'a SegmentTimeline, or a segment duration.',
            a.representation,
          ),
          new shaka.util.Error(
            shaka.util.Error.Severity.CRITICAL,
            shaka.util.Error.Category.MANIFEST,
            shaka.util.Error.Code.DASH_NO_SEGMENT_INFO,
          ))
        );
      1 != c &&
        (shaka.log.warning(
          'SegmentTemplate containes multiple segment information sources:',
          'the SegmentTemplate should only contain an index URL template,',
          'a SegmentTimeline or a segment duration.',
          a.representation,
        ),
        b.indexTemplate
          ? (shaka.log.info('Using the index URL template by default.'), (b.timeline = null))
          : (goog.asserts.assert(b.timeline, 'There should be a timeline'),
            shaka.log.info('Using the SegmentTimeline by default.')),
        (b.segmentDuration = null));
      if (!b.indexTemplate && !b.mediaTemplate)
        throw (
          (shaka.log.error(
            'SegmentTemplate does not contain sufficient segment information:',
            "the SegmentTemplate's media URL template is missing.",
            a.representation,
          ),
          new shaka.util.Error(
            shaka.util.Error.Severity.CRITICAL,
            shaka.util.Error.Category.MANIFEST,
            shaka.util.Error.Code.DASH_NO_SEGMENT_INFO,
          ))
        );
    };
    shaka.dash.SegmentTemplate.generateSegmentIndexFromIndexTemplate_ = function (a, b, c, d) {
      var e = shaka.dash.MpdUtils,
        f = shaka.util.ManifestParserUtils;
      goog.asserts.assert(d.indexTemplate, 'must be using index template');
      e = e.fillUriTemplate(d.indexTemplate, a.representation.id, null, a.bandwidth || null, null);
      f = f.resolveUris(a.representation.baseUris, [e]);
      return shaka.dash.SegmentBase.generateSegmentIndexFromUris(a, b, c, f, 0, null, d.scaledPresentationTimeOffset);
    };
    shaka.dash.SegmentTemplate.generateSegmentIndexFromDuration_ = function (a, b, c, d) {
      goog.asserts.assert(b.mediaTemplate, 'There should be a media template with duration');
      var e = shaka.dash.MpdUtils,
        f = shaka.util.ManifestParserUtils,
        g = a.presentationTimeline,
        h = a.periodInfo.start,
        k = a.periodInfo.duration,
        l = k ? h + k : Infinity,
        m = b.segmentDuration;
      goog.asserts.assert(null != m, 'Segment duration must not be null!');
      var n = b.startNumber,
        p = b.timescale,
        q = b.mediaTemplate,
        r = a.bandwidth || null,
        t = a.representation.id,
        w = a.representation.baseUris,
        u = h - b.scaledPresentationTimeOffset,
        v = function () {
          var y = [Math.max(g.getSegmentAvailabilityStart(), h), Math.min(g.getSegmentAvailabilityEnd(), l)];
          goog.asserts.assert(y.every(isFinite), 'Available presentation times must be finite!');
          goog.asserts.assert(
            y.every(function (C) {
              return 0 <= C;
            }),
            'Available presentation times must be positive!',
          );
          goog.asserts.assert(null != m, 'Segment duration must not be null!');
          y = y.map(function (C) {
            return C - h;
          });
          return [Math.ceil(y[0] / m), Math.ceil(y[1] / m) - 1].map(function (C) {
            return C + n;
          });
        },
        x = v();
      k = x[1];
      var B = [],
        z = function (y) {
          goog.asserts.assert(null != m, 'Segment duration must not be null!');
          var C = (y - n) * m,
            H = C + b.scaledPresentationTimeOffset;
          C += h;
          var F = Math.min(C + m, l);
          goog.asserts.assert(C < F, 'Generated a segment outside of the period!');
          return new shaka.media.SegmentReference(
            C,
            F,
            function () {
              var E = e.fillUriTemplate(q, t, y, r, H * p);
              return f.resolveUris(w, [E]);
            },
            0,
            null,
            d,
            u,
            h,
            l,
          );
        };
      for (a = a.dynamic ? Math.max(x[0], x[1] - c + 1) : x[0]; a <= k; ++a) (c = z(a)), B.push(c);
      var A = new shaka.media.SegmentIndex(B);
      if (g.getSegmentAvailabilityEnd() < l) {
        var D = k + 1;
        A.updateEvery(m, function () {
          A.evict(g.getSegmentAvailabilityStart());
          var y = $jscomp.makeIterator(v());
          y.next();
          y = y.next().value;
          for (var C = []; D <= y; ) {
            var H = z(D);
            C.push(H);
            D++;
          }
          return C;
        });
      }
      return Promise.resolve(A);
    };
    shaka.dash.SegmentTemplate.createFromTimeline_ = function (a, b, c) {
      var d = shaka.dash.MpdUtils,
        e = shaka.util.ManifestParserUtils,
        f = a.periodInfo.start,
        g = a.periodInfo.duration,
        h = f - b.scaledPresentationTimeOffset;
      g = g ? f + g : Infinity;
      for (
        var k = [], l = {}, m = $jscomp.makeIterator(shaka.util.Iterables.enumerate(b.timeline)), n = m.next();
        !n.done;
        l = {
          $jscomp$loop$prop$repId$541: l.$jscomp$loop$prop$repId$541,
          $jscomp$loop$prop$segmentReplacement$542: l.$jscomp$loop$prop$segmentReplacement$542,
          $jscomp$loop$prop$bandwidth$543: l.$jscomp$loop$prop$bandwidth$543,
          $jscomp$loop$prop$timeReplacement$544: l.$jscomp$loop$prop$timeReplacement$544,
        },
          n = m.next()
      ) {
        var p = n.value,
          q = p.item;
        n = q.start;
        var r = q.unscaledStart;
        q = q.end;
        l.$jscomp$loop$prop$segmentReplacement$542 = p.i + b.startNumber;
        l.$jscomp$loop$prop$timeReplacement$544 = r + b.unscaledPresentationTimeOffset;
        l.$jscomp$loop$prop$repId$541 = a.representation.id;
        l.$jscomp$loop$prop$bandwidth$543 = a.bandwidth || null;
        p = (function (t) {
          return function () {
            goog.asserts.assert(b.mediaTemplate, 'There should be a media template with a timeline');
            var w = d.fillUriTemplate(
              b.mediaTemplate,
              t.$jscomp$loop$prop$repId$541,
              t.$jscomp$loop$prop$segmentReplacement$542,
              t.$jscomp$loop$prop$bandwidth$543 || null,
              t.$jscomp$loop$prop$timeReplacement$544,
            );
            return e.resolveUris(a.representation.baseUris, [w]).map(function (u) {
              return u.toString();
            });
          };
        })(l);
        k.push(new shaka.media.SegmentReference(f + n, f + q, p, 0, null, c, h, f, g));
      }
      return k;
    };
    shaka.dash.SegmentTemplate.createInitSegment_ = function (a) {
      var b = shaka.dash.MpdUtils,
        c = shaka.util.ManifestParserUtils,
        d = b.inheritAttribute(a, shaka.dash.SegmentTemplate.fromInheritance_, 'initialization');
      if (!d) return null;
      var e = a.representation.id,
        f = a.bandwidth || null,
        g = a.representation.baseUris;
      return new shaka.media.InitSegmentReference(
        function () {
          goog.asserts.assert(d, 'Should have returned earler');
          var h = b.fillUriTemplate(d, e, null, f, null);
          return c.resolveUris(g, [h]);
        },
        0,
        null,
      );
    };
    shaka.util.PeriodCombiner = function () {
      this.variants_ = [];
      this.audioStreams_ = [];
      this.videoStreams_ = [];
      this.textStreams_ = [];
      this.usedPeriodIds_ = new Set();
    };
    shaka.util.PeriodCombiner.prototype.release = function () {
      var a = this.audioStreams_.concat(this.videoStreams_, this.textStreams_);
      a = $jscomp.makeIterator(a);
      for (var b = a.next(); !b.done; b = a.next()) (b = b.value), b.segmentIndex && b.segmentIndex.release();
      this.audioStreams_ = [];
      this.videoStreams_ = [];
      this.textStreams_ = [];
      this.variants_ = [];
    };
    shaka.util.PeriodCombiner.prototype.getVariants = function () {
      return this.variants_;
    };
    shaka.util.PeriodCombiner.prototype.getTextStreams = function () {
      return this.textStreams_;
    };
    shaka.util.PeriodCombiner.prototype.combinePeriods = function (a, b) {
      var c = this,
        d,
        e,
        f,
        g,
        h,
        k,
        l,
        m,
        n,
        p,
        q,
        r,
        t,
        w,
        u,
        v,
        x,
        B,
        z,
        A,
        D,
        y,
        C,
        H,
        F,
        E,
        G,
        I,
        K,
        N,
        O;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (L) {
        switch (L.nextAddress) {
          case 1:
            d = shaka.util.ManifestParserUtils.ContentType;
            e = shaka.util.Iterables;
            shaka.util.PeriodCombiner.filterOutAudioStreamDuplicates_(a);
            shaka.util.PeriodCombiner.filterOutVideoStreamDuplicates_(a);
            shaka.util.PeriodCombiner.filterOutTextStreamDuplicates_(a);
            if (!b && 1 == a.length) {
              f = a[0];
              c.audioStreams_ = f.audioStreams;
              c.videoStreams_ = f.videoStreams;
              c.textStreams_ = f.textStreams;
              L.jumpTo(2);
              break;
            }
            g = -1;
            h = $jscomp.makeIterator(e.enumerate(a));
            for (k = h.next(); !k.done; k = h.next())
              (m = l = k.value),
                (n = m.i),
                (p = m.item),
                c.usedPeriodIds_.has(p.id) || (c.usedPeriodIds_.add(p.id), -1 == g && (g = n));
            if (-1 == g) return L['return']();
            q = a.map(function (M) {
              return M.audioStreams;
            });
            r = a.map(function (M) {
              return M.videoStreams;
            });
            t = a.map(function (M) {
              return M.textStreams;
            });
            w = $jscomp.makeIterator(t);
            for (u = w.next(); !u.done; u = w.next())
              (v = u.value), v.push(shaka.util.PeriodCombiner.dummyTextStream_());
            return L.yield(
              shaka.util.PeriodCombiner.combine_(
                c.audioStreams_,
                q,
                g,
                shaka.util.PeriodCombiner.cloneStream_,
                shaka.util.PeriodCombiner.concatenateStreams_,
              ),
              3,
            );
          case 3:
            return L.yield(
              shaka.util.PeriodCombiner.combine_(
                c.videoStreams_,
                r,
                g,
                shaka.util.PeriodCombiner.cloneStream_,
                shaka.util.PeriodCombiner.concatenateStreams_,
              ),
              4,
            );
          case 4:
            return L.yield(
              shaka.util.PeriodCombiner.combine_(
                c.textStreams_,
                t,
                g,
                shaka.util.PeriodCombiner.cloneStream_,
                shaka.util.PeriodCombiner.concatenateStreams_,
              ),
              2,
            );
          case 2:
            x = 0;
            B = [];
            if (c.videoStreams_.length && c.audioStreams_.length)
              for (H = $jscomp.makeIterator(c.audioStreams_), F = H.next(); !F.done; F = H.next())
                for (E = F.value, G = $jscomp.makeIterator(c.videoStreams_), I = G.next(); !I.done; I = G.next())
                  (K = I.value),
                    (N = shaka.media.DrmEngine.getCommonDrmInfos(E.drmInfos, K.drmInfos)),
                    E.drmInfos.length && K.drmInfos.length && !N.length
                      ? shaka.log.warning('Incompatible DRM in audio & video, skipping variant creation.', E, K)
                      : ((O = x++),
                        B.push({
                          id: O,
                          language: E.language,
                          primary: E.primary,
                          audio: E,
                          video: K,
                          bandwidth: (E.bandwidth || 0) + (K.bandwidth || 0),
                          drmInfos: N,
                          allowedByApplication: !0,
                          allowedByKeySystem: !0,
                        }));
            else
              for (
                z = c.videoStreams_.concat(c.audioStreams_), A = $jscomp.makeIterator(z), D = A.next();
                !D.done;
                D = A.next()
              )
                (y = D.value),
                  (C = x++),
                  B.push({
                    id: C,
                    language: y.language,
                    primary: y.primary,
                    audio: y.type == d.AUDIO ? y : null,
                    video: y.type == d.VIDEO ? y : null,
                    bandwidth: y.bandwidth || 0,
                    drmInfos: y.drmInfos,
                    allowedByApplication: !0,
                    allowedByKeySystem: !0,
                  });
            c.variants_ = B;
            L.jumpToEnd();
        }
      });
    };
    shaka.util.PeriodCombiner.filterOutAudioStreamDuplicates_ = function (a) {
      var b = shaka.util.ArrayUtils;
      a = $jscomp.makeIterator(a);
      for (var c = a.next(); !c.done; c = a.next()) {
        c = c.value;
        for (var d = [], e = $jscomp.makeIterator(c.audioStreams), f = e.next(); !f.done; f = e.next()) {
          f = f.value;
          for (var g = !1, h = $jscomp.makeIterator(d), k = h.next(); !k.done; k = h.next())
            (k = k.value),
              f.id != k.id &&
                f.channelsCount == k.channelsCount &&
                f.language == k.language &&
                f.bandwidth == k.bandwidth &&
                b.hasSameElements(f.roles, k.roles) &&
                f.audioSamplingRate == k.audioSamplingRate &&
                f.primary == k.primary &&
                (g = !0);
          g || d.push(f);
        }
        c.audioStreams = d;
      }
    };
    shaka.util.PeriodCombiner.filterOutTextStreamDuplicates_ = function (a) {
      var b = shaka.util.ArrayUtils;
      a = $jscomp.makeIterator(a);
      for (var c = a.next(); !c.done; c = a.next()) {
        c = c.value;
        for (var d = [], e = $jscomp.makeIterator(c.textStreams), f = e.next(); !f.done; f = e.next()) {
          f = f.value;
          for (var g = !1, h = $jscomp.makeIterator(d), k = h.next(); !k.done; k = h.next())
            (k = k.value), f.id != k.id && f.language == k.language && b.hasSameElements(f.roles, k.roles) && (g = !0);
          g || d.push(f);
        }
        c.textStreams = d;
      }
    };
    shaka.util.PeriodCombiner.filterOutVideoStreamDuplicates_ = function (a) {
      var b = shaka.util.ArrayUtils,
        c = shaka.util.MapUtils;
      a = $jscomp.makeIterator(a);
      for (var d = a.next(); !d.done; d = a.next()) {
        d = d.value;
        for (var e = [], f = $jscomp.makeIterator(d.videoStreams), g = f.next(); !g.done; g = f.next()) {
          g = g.value;
          for (var h = !1, k = $jscomp.makeIterator(e), l = k.next(); !l.done; l = k.next())
            (l = l.value),
              g.id != l.id &&
                g.width == l.width &&
                g.frameRate == l.frameRate &&
                b.hasSameElements(g.roles, l.roles) &&
                c.hasSameElements(g.closedCaptions, l.closedCaptions) &&
                g.bandwidth == l.bandwidth &&
                (h = !0);
          h || e.push(g);
        }
        d.videoStreams = e;
      }
    };
    shaka.util.PeriodCombiner.combineDbStreams = function (a) {
      var b, c, d, e, f, g, h, k, l, m, n, p, q, r, t, w, u, v, x, B, z, A;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (D) {
        switch (D.nextAddress) {
          case 1:
            b = shaka.util.ManifestParserUtils.ContentType;
            if (1 == a.length) return D['return'](a[0]);
            c = a.map(function (y) {
              return y.filter(function (C) {
                return C.type == b.AUDIO;
              });
            });
            d = a.map(function (y) {
              return y.filter(function (C) {
                return C.type == b.VIDEO;
              });
            });
            e = a.map(function (y) {
              return y.filter(function (C) {
                return C.type == b.TEXT;
              });
            });
            f = $jscomp.makeIterator(e);
            for (g = f.next(); !g.done; g = f.next())
              (h = g.value), h.push(shaka.util.PeriodCombiner.dummyTextStreamDB_());
            return D.yield(
              shaka.util.PeriodCombiner.combine_(
                [],
                c,
                0,
                shaka.util.PeriodCombiner.cloneStreamDB_,
                shaka.util.PeriodCombiner.concatenateStreamDBs_,
              ),
              2,
            );
          case 2:
            return (
              (k = D.yieldResult),
              D.yield(
                shaka.util.PeriodCombiner.combine_(
                  [],
                  d,
                  0,
                  shaka.util.PeriodCombiner.cloneStreamDB_,
                  shaka.util.PeriodCombiner.concatenateStreamDBs_,
                ),
                3,
              )
            );
          case 3:
            return (
              (l = D.yieldResult),
              D.yield(
                shaka.util.PeriodCombiner.combine_(
                  [],
                  e,
                  0,
                  shaka.util.PeriodCombiner.cloneStreamDB_,
                  shaka.util.PeriodCombiner.concatenateStreamDBs_,
                ),
                4,
              )
            );
          case 4:
            m = D.yieldResult;
            n = 0;
            if (l.length && k.length)
              for (w = $jscomp.makeIterator(k), u = w.next(); !u.done; u = w.next())
                for (v = u.value, x = $jscomp.makeIterator(l), B = x.next(); !B.done; B = x.next())
                  (z = B.value), (A = n++), z.variantIds.push(A), v.variantIds.push(A);
            else
              for (p = l.concat(k), q = $jscomp.makeIterator(p), r = q.next(); !r.done; r = q.next())
                (t = r.value), (t.variantIds = [n++]);
            return D['return'](l.concat(k).concat(m));
        }
      });
    };
    shaka.util.PeriodCombiner.combine_ = function (a, b, c, d, e) {
      var f, g, h, k, l, m, n, p, q, r, t, w, u, v, x, B, z, A, D, y, C, H, F, E, G;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (I) {
        switch (I.nextAddress) {
          case 1:
            f = shaka.util.ManifestParserUtils.ContentType;
            g = shaka.util.Iterables;
            h = [];
            k = $jscomp.makeIterator(g.enumerate(b));
            for (l = k.next(); !l.done; l = k.next())
              (n = m = l.value), (p = n.i), (q = n.item), p >= c ? h.push(new Set(q)) : h.push(new Set());
            r = $jscomp.makeIterator(a);
            t = r.next();
          case 2:
            if (t.done) {
              I.jumpTo(4);
              break;
            }
            w = t.value;
            return I.yield(shaka.util.PeriodCombiner.extendExistingOutputStream_(w, b, c, e, h), 5);
          case 5:
            u = I.yieldResult;
            if (!u)
              throw new shaka.util.Error(
                shaka.util.Error.Severity.CRITICAL,
                shaka.util.Error.Category.MANIFEST,
                shaka.util.Error.Code.PERIOD_FLATTENING_FAILED,
              );
            t = r.next();
            I.jumpTo(2);
            break;
          case 4:
            (v = $jscomp.makeIterator(h)), (x = v.next());
          case 6:
            if (x.done) {
              I.jumpTo(8);
              break;
            }
            B = x.value;
            z = $jscomp.makeIterator(B);
            A = z.next();
          case 9:
            if (A.done) {
              x = v.next();
              I.jumpTo(6);
              break;
            }
            D = A.value;
            return I.yield(shaka.util.PeriodCombiner.createNewOutputStream_(D, b, d, e, h), 12);
          case 12:
            (y = I.yieldResult) && a.push(y);
            A = z.next();
            I.jumpTo(9);
            break;
          case 8:
            C = $jscomp.makeIterator(h);
            for (x = C.next(); !x.done; x = C.next())
              for (
                H = x.value, F = {}, E = $jscomp.makeIterator(H), A = E.next();
                !A.done;
                F = { $jscomp$loop$prop$stream$462$546: F.$jscomp$loop$prop$stream$462$546 }, A = E.next()
              )
                if (
                  ((F.$jscomp$loop$prop$stream$462$546 = A.value),
                  F.$jscomp$loop$prop$stream$462$546.type != f.TEXT || F.$jscomp$loop$prop$stream$462$546.language)
                )
                  if (
                    (G = a.some(
                      (function (K) {
                        return function (N) {
                          return (
                            N.mimeType == K.$jscomp$loop$prop$stream$462$546.mimeType &&
                            shaka.util.MimeUtils.getCodecBase(N.codecs) ==
                              shaka.util.MimeUtils.getCodecBase(K.$jscomp$loop$prop$stream$462$546.codecs)
                          );
                        };
                      })(F),
                    ))
                  )
                    throw new shaka.util.Error(
                      shaka.util.Error.Severity.CRITICAL,
                      shaka.util.Error.Category.MANIFEST,
                      shaka.util.Error.Code.PERIOD_FLATTENING_FAILED,
                    );
            return I['return'](a);
        }
      });
    };
    shaka.util.PeriodCombiner.extendExistingOutputStream_ = function (a, b, c, d, e) {
      var f;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (g) {
        if (1 == g.nextAddress) {
          f = shaka.util.PeriodCombiner.findMatchesInAllPeriods_(b, a);
          if (!f) return g['return'](!1);
          goog.asserts.assert(a.createSegmentIndex, 'outputStream should be a Stream type!');
          return g.yield(
            Promise.all(
              f.map(function (h) {
                return h.createSegmentIndex();
              }),
            ),
            2,
          );
        }
        goog.asserts.assert(f, 'Matches should be non-null');
        shaka.util.PeriodCombiner.extendOutputStream_(a, f, c, d, e);
        return g['return'](!0);
      });
    };
    shaka.util.PeriodCombiner.createNewOutputStream_ = function (a, b, c, d, e) {
      var f, g;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (h) {
        if (1 == h.nextAddress)
          return (
            (f = c(a)),
            (g = shaka.util.PeriodCombiner.findMatchesInAllPeriods_(b, f))
              ? f.createSegmentIndex
                ? h.yield(
                    Promise.all(
                      g.map(function (k) {
                        return k.createSegmentIndex();
                      }),
                    ),
                    2,
                  )
                : h.jumpTo(2)
              : h['return'](null)
          );
        goog.asserts.assert(g, 'Matches should be non-null');
        shaka.util.PeriodCombiner.extendOutputStream_(f, g, 0, d, e);
        return h['return'](f);
      });
    };
    shaka.util.PeriodCombiner.extendOutputStream_ = function (a, b, c, d, e) {
      var f = shaka.util.ManifestParserUtils.ContentType,
        g = shaka.util.LanguageUtils;
      b = $jscomp.makeIterator(shaka.util.Iterables.enumerate(b));
      for (var h = b.next(); !h.done; h = b.next()) {
        var k = h.value;
        h = k.i;
        k = k.item;
        if (h >= c) {
          d(a, k);
          var l = !0;
          a.type == f.AUDIO && 0 == g.relatedness(a.language, k.language) && (l = !1);
          l && e[h]['delete'](k);
        }
      }
    };
    shaka.util.PeriodCombiner.cloneStream_ = function (a) {
      a = Object.assign({}, a);
      a.originalId = null;
      a.createSegmentIndex = function () {
        return Promise.resolve();
      };
      a.segmentIndex = new shaka.media.MetaSegmentIndex();
      a.emsgSchemeIdUris = [];
      a.keyIds = new Set();
      a.closedCaptions = null;
      a.trickModeVideo = null;
      return a;
    };
    shaka.util.PeriodCombiner.cloneStreamDB_ = function (a) {
      a = Object.assign({}, a);
      a.keyIds = new Set();
      a.segments = [];
      a.variantIds = [];
      a.closedCaptions = null;
      return a;
    };
    shaka.util.PeriodCombiner.concatenateStreams_ = function (a, b) {
      a.roles = Array.from(new Set(a.roles.concat(b.roles)));
      b.emsgSchemeIdUris && (a.emsgSchemeIdUris = Array.from(new Set(a.emsgSchemeIdUris.concat(b.emsgSchemeIdUris))));
      var c = b.keyIds;
      c = new Set([].concat($jscomp.arrayFromIterable(a.keyIds), $jscomp.arrayFromIterable(c)));
      a.keyIds = c;
      a.originalId = null == a.originalId ? b.originalId : a.originalId + (',' + (b.originalId || ''));
      c = shaka.media.DrmEngine.getCommonDrmInfos(a.drmInfos, b.drmInfos);
      if (b.drmInfos.length && a.drmInfos.length && !c.length)
        throw new shaka.util.Error(
          shaka.util.Error.Severity.CRITICAL,
          shaka.util.Error.Category.MANIFEST,
          shaka.util.Error.Code.INCONSISTENT_DRM_ACROSS_PERIODS,
        );
      a.drmInfos = c;
      a.encrypted = a.encrypted || b.encrypted;
      if (b.closedCaptions) {
        a.closedCaptions || (a.closedCaptions = new Map());
        c = $jscomp.makeIterator(b.closedCaptions);
        for (var d = c.next(); !d.done; d = c.next()) {
          var e = $jscomp.makeIterator(d.value);
          d = e.next().value;
          e = e.next().value;
          a.closedCaptions.set(d, e);
        }
      }
      goog.asserts.assert(
        a.segmentIndex instanceof shaka.media.MetaSegmentIndex,
        'Output streams should have a MetaSegmentIndex!',
      );
      goog.asserts.assert(b.segmentIndex, 'Input segment index should have been created by now!');
      a.segmentIndex.appendSegmentIndex(b.segmentIndex);
      b.trickModeVideo
        ? (a.trickModeVideo ||
            ((a.trickModeVideo = shaka.util.PeriodCombiner.cloneStream_(b.trickModeVideo)),
            (a.trickModeVideo.segmentIndex = a.segmentIndex.clone())),
          shaka.util.PeriodCombiner.concatenateStreams_(a.trickModeVideo, b.trickModeVideo))
        : a.trickModeVideo && shaka.util.PeriodCombiner.concatenateStreams_(a.trickModeVideo, b);
    };
    shaka.util.PeriodCombiner.concatenateStreamDBs_ = function (a, b) {
      a.roles = Array.from(new Set(a.roles.concat(b.roles)));
      var c = b.keyIds;
      c = new Set([].concat($jscomp.arrayFromIterable(a.keyIds), $jscomp.arrayFromIterable(c)));
      a.keyIds = c;
      a.encrypted = a.encrypted && b.encrypted;
      a.segments.push.apply(a.segments, $jscomp.arrayFromIterable(b.segments));
      if (b.closedCaptions) {
        a.closedCaptions || (a.closedCaptions = new Map());
        c = $jscomp.makeIterator(b.closedCaptions);
        for (var d = c.next(); !d.done; d = c.next()) {
          var e = $jscomp.makeIterator(d.value);
          d = e.next().value;
          e = e.next().value;
          a.closedCaptions.set(d, e);
        }
      }
    };
    shaka.util.PeriodCombiner.findMatchesInAllPeriods_ = function (a, b) {
      for (var c = [], d = $jscomp.makeIterator(a), e = d.next(); !e.done; e = d.next()) {
        e = shaka.util.PeriodCombiner.findBestMatchInPeriod_(e.value, b);
        if (!e) return null;
        c.push(e);
      }
      return c;
    };
    shaka.util.PeriodCombiner.findBestMatchInPeriod_ = function (a, b) {
      for (
        var c = {
            audio: shaka.util.PeriodCombiner.areAVStreamsCompatible_,
            video: shaka.util.PeriodCombiner.areAVStreamsCompatible_,
            text: shaka.util.PeriodCombiner.areTextStreamsCompatible_,
          }[b.type],
          d = {
            audio: shaka.util.PeriodCombiner.isAudioStreamBetterMatch_,
            video: shaka.util.PeriodCombiner.isVideoStreamBetterMatch_,
            text: shaka.util.PeriodCombiner.isTextStreamBetterMatch_,
          }[b.type],
          e = null,
          f = $jscomp.makeIterator(a),
          g = f.next();
        !g.done;
        g = f.next()
      )
        (g = g.value), !c(b, g) || (e && !d(b, e, g)) || (e = g);
      return e;
    };
    shaka.util.PeriodCombiner.areAVStreamsCompatible_ = function (a, b) {
      return b.mimeType != a.mimeType ||
        shaka.util.MimeUtils.getCodecBase(b.codecs) != shaka.util.MimeUtils.getCodecBase(a.codecs) ||
        (a.drmInfos && !shaka.media.DrmEngine.areDrmCompatible(a.drmInfos, b.drmInfos))
        ? !1
        : !0;
    };
    shaka.util.PeriodCombiner.areTextStreamsCompatible_ = function (a, b) {
      return a.language
        ? b.language
          ? 0 == shaka.util.LanguageUtils.relatedness(a.language, b.language) || b.kind != a.kind
            ? !1
            : !0
          : !0
        : !1;
    };
    shaka.util.PeriodCombiner.isAudioStreamBetterMatch_ = function (a, b, c) {
      var d = shaka.util.LanguageUtils,
        e = shaka.util.PeriodCombiner.BetterOrWorse,
        f = e.BETTER;
      e = e.WORSE;
      if (a.id == c.id) return !0;
      var g = d.relatedness(a.language, b.language);
      d = d.relatedness(a.language, c.language);
      if (d > g) return !0;
      if (d < g) return !1;
      if (!b.primary && c.primary) return !0;
      if (b.primary && !c.primary) return !1;
      if (a.roles.length)
        return (
          (f = b.roles.filter(function (h) {
            return a.roles.includes(h);
          })),
          (e = c.roles.filter(function (h) {
            return a.roles.includes(h);
          })),
          e.length > f.length ? !0 : e.length < f.length ? !1 : c.roles.length < b.roles.length
        );
      d = shaka.util.PeriodCombiner.compareClosestPreferLower(a.channelsCount, b.channelsCount, c.channelsCount);
      if (d == f) return !0;
      if (d == e) return !1;
      d = shaka.util.PeriodCombiner.compareClosestPreferLower(
        a.audioSamplingRate,
        b.audioSamplingRate,
        c.audioSamplingRate,
      );
      return d == f
        ? !0
        : d == e
        ? !1
        : a.bandwidth &&
          shaka.util.PeriodCombiner.compareClosestPreferMinimalAbsDiff_(a.bandwidth, b.bandwidth, c.bandwidth) == f
        ? !0
        : !1;
    };
    shaka.util.PeriodCombiner.isVideoStreamBetterMatch_ = function (a, b, c) {
      var d = shaka.util.PeriodCombiner.BetterOrWorse,
        e = d.BETTER;
      d = d.WORSE;
      if (a.id == c.id) return !0;
      var f = shaka.util.PeriodCombiner.compareClosestPreferLower(
        a.width * a.height,
        b.width * b.height,
        c.width * c.height,
      );
      if (f == e) return !0;
      if (f == d) return !1;
      if (a.frameRate) {
        f = shaka.util.PeriodCombiner.compareClosestPreferLower(a.frameRate, b.frameRate, c.frameRate);
        if (f == e) return !0;
        if (f == d) return !1;
      }
      return a.bandwidth &&
        shaka.util.PeriodCombiner.compareClosestPreferMinimalAbsDiff_(a.bandwidth, b.bandwidth, c.bandwidth) == e
        ? !0
        : !1;
    };
    shaka.util.PeriodCombiner.isTextStreamBetterMatch_ = function (a, b, c) {
      var d = shaka.util.LanguageUtils;
      if (a.id == c.id) return !0;
      var e = d.relatedness(a.language, b.language);
      d = d.relatedness(a.language, c.language);
      if (d > e) return !0;
      if (d < e) return !1;
      if (!b.primary && c.primary) return !0;
      if (b.primary && !c.primary) return !1;
      if (a.roles.length) {
        e = b.roles.filter(function (f) {
          return a.roles.includes(f);
        });
        d = c.roles.filter(function (f) {
          return a.roles.includes(f);
        });
        if (d.length > e.length) return !0;
        if (d.length < e.length) return !1;
      }
      return c.mimeType != a.mimeType || c.codecs != a.codecs || (b.mimeType == a.mimeType && b.codecs == a.codecs)
        ? !1
        : !0;
    };
    shaka.util.PeriodCombiner.dummyTextStreamDB_ = function () {
      return {
        id: 0,
        originalId: '',
        primary: !1,
        type: shaka.util.ManifestParserUtils.ContentType.TEXT,
        mimeType: '',
        codecs: '',
        language: '',
        label: null,
        width: null,
        height: null,
        encrypted: !1,
        keyIds: new Set(),
        segments: [],
        variantIds: [],
        roles: [],
        channelsCount: null,
        audioSamplingRate: null,
        closedCaptions: null,
      };
    };
    shaka.util.PeriodCombiner.dummyTextStream_ = function () {
      var a = shaka.util.ManifestParserUtils.ContentType;
      return {
        id: 0,
        originalId: '',
        createSegmentIndex: function () {
          return Promise.resolve();
        },
        segmentIndex: new shaka.media.SegmentIndex([]),
        mimeType: '',
        codecs: '',
        encrypted: !1,
        drmInfos: [],
        keyIds: new Set(),
        language: '',
        label: null,
        type: a.TEXT,
        primary: !1,
        trickModeVideo: null,
        emsgSchemeIdUris: null,
        roles: [],
        channelsCount: null,
        audioSamplingRate: null,
        closedCaptions: null,
      };
    };
    shaka.util.PeriodCombiner.compareClosestPreferLower = function (a, b, c) {
      var d = shaka.util.PeriodCombiner.BetterOrWorse,
        e = d.BETTER,
        f = d.WORSE;
      if (b == a && a != c) return f;
      if (c == a && a != b) return e;
      if (b > a) {
        if (c <= a || c - a < b - a) return e;
        if (c - a > b - a) return f;
      } else {
        if (c > a) return f;
        if (a - c < a - b) return e;
        if (a - c > a - b) return f;
      }
      return d.EQUAL;
    };
    shaka.util.PeriodCombiner.compareClosestPreferMinimalAbsDiff_ = function (a, b, c) {
      var d = shaka.util.PeriodCombiner.BetterOrWorse,
        e = d.BETTER,
        f = d.WORSE;
      b = Math.abs(a - b);
      a = Math.abs(a - c);
      return a < b ? e : b < a ? f : d.EQUAL;
    };
    shaka.util.PeriodCombiner.BetterOrWorse = { BETTER: 1, EQUAL: 0, WORSE: -1 };
    shaka.dash.DashParser = function () {
      var a = this;
      this.playerInterface_ = this.config_ = null;
      this.manifestUris_ = [];
      this.manifest_ = null;
      this.globalId_ = 1;
      this.segmentIndexMap_ = {};
      this.periodCombiner_ = new shaka.util.PeriodCombiner();
      this.updatePeriod_ = 0;
      this.averageUpdateDuration_ = new shaka.abr.Ewma(5);
      this.updateTimer_ = new shaka.util.Timer(function () {
        a.onUpdate_();
      });
      this.operationManager_ = new shaka.util.OperationManager();
    };
    shaka.dash.DashParser.prototype.configure = function (a) {
      goog.asserts.assert(null != a.dash, 'DashManifestConfiguration should not be null!');
      this.config_ = a;
    };
    shaka.dash.DashParser.prototype.start = function (a, b) {
      var c = this,
        d;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (e) {
        if (1 == e.nextAddress)
          return (
            goog.asserts.assert(c.config_, 'Must call configure() before start()!'),
            (c.manifestUris_ = [a]),
            (c.playerInterface_ = b),
            e.yield(c.requestManifest_(), 2)
          );
        d = e.yieldResult;
        c.playerInterface_ && c.setUpdateTimer_(d);
        if (!c.playerInterface_)
          throw new shaka.util.Error(
            shaka.util.Error.Severity.CRITICAL,
            shaka.util.Error.Category.PLAYER,
            shaka.util.Error.Code.OPERATION_ABORTED,
          );
        goog.asserts.assert(c.manifest_, 'Manifest should be non-null!');
        return e['return'](c.manifest_);
      });
    };
    shaka.dash.DashParser.prototype.stop = function () {
      for (var a = $jscomp.makeIterator(Object.values(this.segmentIndexMap_)), b = a.next(); !b.done; b = a.next())
        b.value.release();
      this.periodCombiner_ && this.periodCombiner_.release();
      this.config_ = this.playerInterface_ = null;
      this.manifestUris_ = [];
      this.manifest_ = null;
      this.segmentIndexMap_ = {};
      this.periodCombiner_ = null;
      null != this.updateTimer_ && (this.updateTimer_.stop(), (this.updateTimer_ = null));
      return this.operationManager_.destroy();
    };
    shaka.dash.DashParser.prototype.update = function () {
      var a = this,
        b;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (c) {
        if (1 == c.nextAddress) return c.setCatchFinallyBlocks(2), c.yield(a.requestManifest_(), 4);
        if (2 != c.nextAddress) return c.leaveTryBlock(0);
        b = c.enterCatchBlock();
        if (!a.playerInterface_ || !b) return c['return']();
        goog.asserts.assert(b instanceof shaka.util.Error, 'Bad error type');
        a.playerInterface_.onError(b);
        c.jumpToEnd();
      });
    };
    shaka.dash.DashParser.prototype.onExpirationUpdated = function (a, b) {};
    shaka.dash.DashParser.prototype.requestManifest_ = function () {
      var a = this,
        b,
        c,
        d,
        e,
        f,
        g,
        h,
        k;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (l) {
        if (1 == l.nextAddress)
          return (
            (b = shaka.net.NetworkingEngine.RequestType.MANIFEST),
            (c = shaka.net.NetworkingEngine.makeRequest(a.manifestUris_, a.config_.retryParameters)),
            (d = a.playerInterface_.networkingEngine),
            (e = Date.now()),
            (f = d.request(b, c)),
            a.operationManager_.manage(f),
            l.yield(f.promise, 2)
          );
        if (3 != l.nextAddress) {
          g = l.yieldResult;
          if (!a.playerInterface_) return l['return'](0);
          g.uri && !a.manifestUris_.includes(g.uri) && a.manifestUris_.unshift(g.uri);
          return l.yield(a.parseManifest_(g.data, g.uri), 3);
        }
        h = Date.now();
        k = (h - e) / 1e3;
        a.averageUpdateDuration_.sample(1, k);
        return l['return'](k);
      });
    };
    shaka.dash.DashParser.prototype.parseManifest_ = function (a, b) {
      var c = this,
        d,
        e,
        f,
        g,
        h,
        k;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (l) {
        if (1 == l.nextAddress) {
          d = shaka.util.Error;
          e = shaka.dash.MpdUtils;
          f = shaka.util.XmlUtils.parseXml(a, 'MPD');
          if (!f) throw new d(d.Severity.CRITICAL, d.Category.MANIFEST, d.Code.DASH_INVALID_XML, b);
          g = c.config_.dash.xlinkFailGracefully;
          h = e.processXlinks(f, c.config_.retryParameters, g, b, c.playerInterface_.networkingEngine);
          c.operationManager_.manage(h);
          return l.yield(h.promise, 2);
        }
        k = l.yieldResult;
        return l['return'](c.processManifest_(k, b));
      });
    };
    shaka.dash.DashParser.prototype.processManifest_ = function (a, b) {
      var c = this,
        d,
        e,
        f,
        g,
        h,
        k,
        l,
        m,
        n,
        p,
        q,
        r,
        t,
        w,
        u,
        v,
        x,
        B,
        z,
        A,
        D,
        y,
        C,
        H,
        F,
        E;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (G) {
        switch (G.nextAddress) {
          case 1:
            return (
              (d = shaka.util.Functional),
              (e = shaka.util.XmlUtils),
              (f = [b]),
              (g = e.findChildren(a, 'Location').map(e.getContents).filter(d.isNotNull)),
              0 < g.length && ((h = shaka.util.ManifestParserUtils.resolveUris(f, g)), (f = c.manifestUris_ = h)),
              (k = e.findChildren(a, 'BaseURL').map(e.getContents)),
              (l = shaka.util.ManifestParserUtils.resolveUris(f, k)),
              (m = c.config_.dash.ignoreMinBufferTime),
              (n = 0),
              m || (n = e.parseAttr(a, 'minBufferTime', e.parseDuration) || 0),
              (c.updatePeriod_ = e.parseAttr(a, 'minimumUpdatePeriod', e.parseDuration, -1)),
              (p = e.parseAttr(a, 'availabilityStartTime', e.parseDate)),
              (q = e.parseAttr(a, 'timeShiftBufferDepth', e.parseDuration)),
              (r = c.config_.dash.ignoreSuggestedPresentationDelay),
              (t = null),
              r || (t = e.parseAttr(a, 'suggestedPresentationDelay', e.parseDuration)),
              (w = e.parseAttr(a, 'maxSegmentDuration', e.parseDuration)),
              (u = a.getAttribute('type') || 'static'),
              c.manifest_
                ? (v = c.manifest_.presentationTimeline)
                : ((x = c.config_.defaultPresentationDelay || 1.5 * n),
                  (B = null != t ? t : x),
                  (v = new shaka.media.PresentationTimeline(p, B, c.config_.dash.autoCorrectDrift))),
              (z = {
                dynamic: 'static' != u,
                presentationTimeline: v,
                period: null,
                periodInfo: null,
                adaptationSet: null,
                representation: null,
                bandwidth: 0,
                indexRangeWarningGiven: !1,
              }),
              (A = c.parsePeriods_(z, l, a)),
              (D = A.duration),
              (y = A.periods),
              v.setStatic('static' == u),
              ('static' != u && A.durationDerivedFromPeriods) || v.setDuration(D || Infinity),
              (C = v.isLive()) &&
                !isNaN(c.config_.availabilityWindowOverride) &&
                (q = c.config_.availabilityWindowOverride),
              null == q && (q = Infinity),
              v.setSegmentAvailabilityDuration(q),
              v.notifyMaxSegmentDuration(w || 1),
              goog.DEBUG && v.assertIsValid(),
              G.yield(c.periodCombiner_.combinePeriods(y, z.dynamic), 2)
            );
          case 2:
            if (c.manifest_) {
              c.manifest_.variants = c.periodCombiner_.getVariants();
              c.manifest_.textStreams = c.periodCombiner_.getTextStreams();
              G.jumpTo(3);
              break;
            }
            c.manifest_ = {
              presentationTimeline: v,
              variants: c.periodCombiner_.getVariants(),
              textStreams: c.periodCombiner_.getTextStreams(),
              offlineSessionIds: [],
              minBufferTime: n || 0,
            };
            if (!v.usingPresentationStartTime()) {
              G.jumpTo(3);
              break;
            }
            H = shaka.util.XmlUtils;
            F = H.findChildren(a, 'UTCTiming');
            return G.yield(c.parseUtcTiming_(l, F), 5);
          case 5:
            E = G.yieldResult;
            if (!c.playerInterface_) return G['return']();
            v.setClockOffset(E);
          case 3:
            return (
              c.playerInterface_.makeTextStreamsForClosedCaptions(c.manifest_),
              goog.asserts.assert(c.manifest_, 'Manifest should exist by now!'),
              G.yield(c.playerInterface_.filter(c.manifest_), 0)
            );
        }
      });
    };
    shaka.dash.DashParser.prototype.parsePeriods_ = function (a, b, c) {
      var d = shaka.util.XmlUtils,
        e = d.parseAttr(c, 'mediaPresentationDuration', d.parseDuration),
        f = [],
        g = 0;
      c = d.findChildren(c, 'Period');
      c = $jscomp.makeIterator(shaka.util.Iterables.enumerate(c));
      for (var h = c.next(); !h.done; h = c.next()) {
        var k = h.value;
        h = k.i;
        var l = k.item;
        k = k.next;
        g = d.parseAttr(l, 'start', d.parseDuration, g);
        var m = d.parseAttr(l, 'duration', d.parseDuration),
          n = null;
        if (k) {
          var p = d.parseAttr(k, 'start', d.parseDuration);
          null != p && (n = p - g);
        } else null != e && (n = e - g);
        p = shaka.util.ManifestParserUtils.GAP_OVERLAP_TOLERANCE_SECONDS;
        n && m && Math.abs(n - m) > p && shaka.log.warning('There is a gap/overlap between Periods', l);
        null == n && (n = m);
        l = this.parsePeriod_(a, b, { start: g, duration: n, node: l, isLastPeriod: null == n || !k });
        f.push(l);
        if (null == n) {
          k &&
            shaka.log.warning(
              'Skipping Period',
              h + 1,
              'and any subsequent Periods:',
              'Period',
              h + 1,
              'does not have a valid start time.',
              k,
            );
          g = null;
          break;
        }
        g += n;
      }
      return null != e
        ? (g != e &&
            shaka.log.warning('@mediaPresentationDuration does not match the total duration of ', 'all Periods.'),
          { periods: f, duration: e, durationDerivedFromPeriods: !1 })
        : { periods: f, duration: g, durationDerivedFromPeriods: !0 };
    };
    shaka.dash.DashParser.prototype.parsePeriod_ = function (a, b, c) {
      var d = this,
        e = shaka.util.Functional,
        f = shaka.util.XmlUtils,
        g = shaka.util.ManifestParserUtils.ContentType;
      a.period = this.createFrame_(c.node, null, b);
      a.periodInfo = c;
      a.period.id ||
        (shaka.log.info('No Period ID given for Period with start time ' + c.start + ',  Assigning a default'),
        (a.period.id = '__shaka_period_' + c.start));
      b = f.findChildren(c.node, 'EventStream');
      b = $jscomp.makeIterator(b);
      for (var h = b.next(); !h.done; h = b.next()) this.parseEventStream_(c.start, c.duration, h.value);
      e = f
        .findChildren(c.node, 'AdaptationSet')
        .map(function (m) {
          return d.parseAdaptationSet_(a, m);
        })
        .filter(e.isNotNull);
      if (a.dynamic) {
        c = [];
        f = $jscomp.makeIterator(e);
        for (b = f.next(); !b.done; b = f.next())
          for (b = $jscomp.makeIterator(b.value.representationIds), h = b.next(); !h.done; h = b.next())
            c.push(h.value);
        f = new Set(c);
        if (c.length != f.size)
          throw new shaka.util.Error(
            shaka.util.Error.Severity.CRITICAL,
            shaka.util.Error.Category.MANIFEST,
            shaka.util.Error.Code.DASH_DUPLICATE_REPRESENTATION_ID,
          );
      }
      c = e.filter(function (m) {
        return !m.trickModeFor;
      });
      e = e.filter(function (m) {
        return m.trickModeFor;
      });
      e = $jscomp.makeIterator(e);
      for (f = e.next(); !f.done; f = e.next()) {
        b = f.value;
        f = b.streams[0];
        b = b.trickModeFor;
        h = $jscomp.makeIterator(c);
        for (var k = h.next(); !k.done; k = h.next())
          if (((k = k.value), k.id == b)) {
            k = $jscomp.makeIterator(k.streams);
            for (var l = k.next(); !l.done; l = k.next()) l.value.trickModeVideo = f;
          }
      }
      f = this.config_.disableAudio ? [] : this.getSetsOfType_(c, g.AUDIO);
      e = this.config_.disableVideo ? [] : this.getSetsOfType_(c, g.VIDEO);
      c = this.config_.disableText ? [] : this.getSetsOfType_(c, g.TEXT);
      if (!e.length && !f.length)
        throw new shaka.util.Error(
          shaka.util.Error.Severity.CRITICAL,
          shaka.util.Error.Category.MANIFEST,
          shaka.util.Error.Code.DASH_EMPTY_PERIOD,
        );
      g = [];
      f = $jscomp.makeIterator(f);
      for (b = f.next(); !b.done; b = f.next()) g.push.apply(g, $jscomp.arrayFromIterable(b.value.streams));
      f = [];
      e = $jscomp.makeIterator(e);
      for (b = e.next(); !b.done; b = e.next()) f.push.apply(f, $jscomp.arrayFromIterable(b.value.streams));
      e = [];
      c = $jscomp.makeIterator(c);
      for (b = c.next(); !b.done; b = c.next()) e.push.apply(e, $jscomp.arrayFromIterable(b.value.streams));
      return { id: a.period.id, audioStreams: g, videoStreams: f, textStreams: e };
    };
    shaka.dash.DashParser.prototype.getSetsOfType_ = function (a, b) {
      return a.filter(function (c) {
        return c.contentType == b;
      });
    };
    shaka.dash.DashParser.prototype.parseAdaptationSet_ = function (a, b) {
      var c = this,
        d = shaka.util.XmlUtils,
        e = shaka.util.Functional,
        f = shaka.util.ManifestParserUtils,
        g = f.ContentType,
        h = shaka.dash.ContentProtection;
      a.adaptationSet = this.createFrame_(b, a.period, null);
      if (a.adaptationSet.contentType == g.IMAGE)
        return shaka.log.warning('Skipping Image AdaptationSet', a.adaptationSet), null;
      var k = !1,
        l = d.findChildren(b, 'Role'),
        m = l
          .map(function (y) {
            return y.getAttribute('value');
          })
          .filter(e.isNotNull),
        n = void 0;
      if ((e = a.adaptationSet.contentType == g.TEXT)) n = f.TextStreamKind.SUBTITLE;
      l = $jscomp.makeIterator(l);
      for (var p = l.next(); !p.done; p = l.next()) {
        p = p.value;
        var q = p.getAttribute('schemeIdUri');
        if (null == q || 'urn:mpeg:dash:role:2011' == q)
          switch (((p = p.getAttribute('value')), p)) {
            case 'main':
              k = !0;
              break;
            case 'caption':
            case 'subtitle':
              n = p;
          }
      }
      q = d.findChildren(b, 'EssentialProperty');
      l = null;
      p = !1;
      q = $jscomp.makeIterator(q);
      for (var r = q.next(); !r.done; r = q.next()) {
        var t = r.value;
        'http://dashif.org/guidelines/trickmode' == t.getAttribute('schemeIdUri')
          ? (l = t.getAttribute('value'))
          : (p = !0);
      }
      t = d.findChildren(b, 'Accessibility');
      q = shaka.util.LanguageUtils;
      var w = new Map();
      t = $jscomp.makeIterator(t);
      for (r = t.next(); !r.done; r = t.next()) {
        var u = r.value;
        r = u.getAttribute('schemeIdUri');
        u = u.getAttribute('value');
        if ('urn:scte:dash:cc:cea-608:2015' == r || 'urn:scte:dash:cc:cea-708:2015' == r)
          if (((r = 1), null != u)) {
            u = $jscomp.makeIterator(u.split(';'));
            for (var v = u.next(); !v.done; v = u.next()) {
              var x = v.value,
                B = (v = void 0);
              x.includes('=')
                ? ((x = x.split('=')),
                  (v = x[0].startsWith('CC') ? x[0] : 'CC' + x[0]),
                  (B = x[1].split(',')[0].split(':').pop()))
                : ((v = 'CC' + r), (r += 2), (B = x));
              w.set(v, q.normalize(B));
            }
          } else w.set('CC1', 'und');
        else
          'urn:mpeg:dash:role:2011' == r &&
            null != u &&
            (m.push(u), 'captions' == u && (n = f.TextStreamKind.CLOSED_CAPTION));
      }
      if (p) return null;
      f = d.findChildren(b, 'ContentProtection');
      var z = h.parseFromAdaptationSet(f, this.config_.dash.ignoreDrmInfo),
        A = shaka.util.LanguageUtils.normalize(b.getAttribute('lang') || 'und'),
        D = b.getAttribute('label');
      (h = d.findChildren(b, 'Label')) && h.length && ((h = h[0]), h.textContent && (D = h.textContent));
      h = d.findChildren(b, 'Representation');
      d = h
        .map(function (y) {
          return c.parseRepresentation_(a, z, n, A, D, k, m, w, y);
        })
        .filter(function (y) {
          return !!y;
        });
      if (0 == d.length) {
        if (this.config_.dash.ignoreEmptyAdaptationSet || e) return null;
        throw new shaka.util.Error(
          shaka.util.Error.Severity.CRITICAL,
          shaka.util.Error.Category.MANIFEST,
          shaka.util.Error.Code.DASH_EMPTY_ADAPTATION_SET,
        );
      }
      if (!a.adaptationSet.contentType || a.adaptationSet.contentType == g.APPLICATION)
        for (
          a.adaptationSet.contentType = shaka.dash.DashParser.guessContentType_(d[0].mimeType, d[0].codecs),
            g = $jscomp.makeIterator(d),
            e = g.next();
          !e.done;
          e = g.next()
        )
          e.value.type = a.adaptationSet.contentType;
      g = $jscomp.makeIterator(d);
      for (e = g.next(); !e.done; e = g.next())
        for (e = e.value, f = $jscomp.makeIterator(z.drmInfos), p = f.next(); !p.done; p = f.next())
          (p = p.value),
            (p.keyIds =
              p.keyIds && e.keyIds
                ? new Set([].concat($jscomp.arrayFromIterable(p.keyIds), $jscomp.arrayFromIterable(e.keyIds)))
                : p.keyIds || e.keyIds);
      g = h
        .map(function (y) {
          return y.getAttribute('id');
        })
        .filter(shaka.util.Functional.isNotNull);
      return {
        id: a.adaptationSet.id || '__fake__' + this.globalId_++,
        contentType: a.adaptationSet.contentType,
        language: A,
        main: k,
        streams: d,
        drmInfos: z.drmInfos,
        trickModeFor: l,
        representationIds: g,
      };
    };
    shaka.dash.DashParser.prototype.parseRepresentation_ = function (a, b, c, d, e, f, g, h, k) {
      var l = this,
        m = shaka.util.XmlUtils,
        n = shaka.util.ManifestParserUtils.ContentType;
      a.representation = this.createFrame_(k, a.adaptationSet, null);
      if (!this.verifyRepresentation_(a.representation))
        return shaka.log.warning('Skipping Representation', a.representation), null;
      var p = a.periodInfo.start;
      a.bandwidth = m.parseAttr(k, 'bandwidth', m.parsePositiveInt) || 0;
      var q = a.representation.contentType;
      n = q == n.TEXT || q == n.APPLICATION;
      try {
        if (
          ((q = function (v, x, B) {
            return l.requestInitSegment_(v, x, B);
          }),
          a.representation.segmentBase)
        )
          var r = shaka.dash.SegmentBase.createStreamInfo(a, q);
        else if (a.representation.segmentList) r = shaka.dash.SegmentList.createStreamInfo(a, this.segmentIndexMap_);
        else if (a.representation.segmentTemplate)
          r = shaka.dash.SegmentTemplate.createStreamInfo(
            a,
            q,
            this.segmentIndexMap_,
            !!this.manifest_,
            this.config_.dash.initialSegmentLimit,
          );
        else {
          goog.asserts.assert(n, 'Must have Segment* with non-text streams.');
          var t = a.representation.baseUris,
            w = a.periodInfo.duration || 0;
          r = {
            generateSegmentIndex: function () {
              return Promise.resolve(shaka.media.SegmentIndex.forSingleSegment(p, w, t));
            },
          };
        }
      } catch (v) {
        if (n && v.code == shaka.util.Error.Code.DASH_NO_SEGMENT_INFO) return null;
        throw v;
      }
      n = m.findChildren(k, 'ContentProtection');
      n = shaka.dash.ContentProtection.parseFromRepresentation(n, b, this.config_.dash.ignoreDrmInfo);
      n = new Set(n ? [n] : []);
      m.findChildren(k, 'SupplementalProperty').some(function (v) {
        return (
          'tag:dolby.com,2018:dash:EC3_ExtensionType:2018' == v.getAttribute('schemeIdUri') &&
          'JOC' == v.getAttribute('value')
        );
      }) && (a.representation.mimeType = 'audio/eac3-joc');
      var u = {
        id: this.globalId_++,
        originalId: a.representation.id,
        createSegmentIndex: function () {
          var v;
          return $jscomp.asyncExecutePromiseGeneratorProgram(function (x) {
            if (1 == x.nextAddress) {
              if (u.segmentIndex) return x.jumpTo(0);
              v = u;
              return x.yield(r.generateSegmentIndex(), 3);
            }
            v.segmentIndex = x.yieldResult;
            x.jumpToEnd();
          });
        },
        segmentIndex: null,
        mimeType: a.representation.mimeType,
        codecs: a.representation.codecs,
        frameRate: a.representation.frameRate,
        pixelAspectRatio: a.representation.pixelAspectRatio,
        bandwidth: a.bandwidth,
        width: a.representation.width,
        height: a.representation.height,
        kind: c,
        encrypted: 0 < b.drmInfos.length,
        drmInfos: b.drmInfos,
        keyIds: n,
        language: d,
        label: e,
        type: a.adaptationSet.contentType,
        primary: f,
        trickModeVideo: null,
        emsgSchemeIdUris: a.representation.emsgSchemeIdUris,
        roles: g,
        channelsCount: a.representation.numChannels,
        audioSamplingRate: a.representation.audioSamplingRate,
        closedCaptions: h,
      };
      return u;
    };
    shaka.dash.DashParser.prototype.onUpdate_ = function () {
      var a = this,
        b,
        c;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (d) {
        switch (d.nextAddress) {
          case 1:
            return (
              goog.asserts.assert(0 <= a.updatePeriod_, 'There should be an update period'),
              shaka.log.info('Updating manifest...'),
              (b = 0),
              d.setCatchFinallyBlocks(2),
              d.yield(a.requestManifest_(), 4)
            );
          case 4:
            b = d.yieldResult;
            d.leaveTryBlock(3);
            break;
          case 2:
            (c = d.enterCatchBlock()),
              goog.asserts.assert(c instanceof shaka.util.Error, 'Should only receive a Shaka error'),
              a.playerInterface_ &&
                ((c.severity = shaka.util.Error.Severity.RECOVERABLE), a.playerInterface_.onError(c));
          case 3:
            if (!a.playerInterface_) return d['return']();
            a.setUpdateTimer_(b);
            d.jumpToEnd();
        }
      });
    };
    shaka.dash.DashParser.prototype.setUpdateTimer_ = function (a) {
      0 > this.updatePeriod_ ||
        ((a = Math.max(
          shaka.dash.DashParser.MIN_UPDATE_PERIOD_,
          this.updatePeriod_ - a,
          this.averageUpdateDuration_.getEstimate(),
        )),
        this.updateTimer_.tickAfter(a));
    };
    shaka.dash.DashParser.prototype.createFrame_ = function (a, b, c) {
      goog.asserts.assert(b || c, 'Must provide either parent or baseUris');
      var d = shaka.util.ManifestParserUtils,
        e = shaka.util.XmlUtils;
      b = b || {
        contentType: '',
        mimeType: '',
        codecs: '',
        emsgSchemeIdUris: [],
        frameRate: void 0,
        pixelAspectRatio: void 0,
        numChannels: null,
        audioSamplingRate: null,
      };
      c = c || b.baseUris;
      var f = e.parseNonNegativeInt,
        g = e.evalDivision,
        h = e.findChildren(a, 'BaseURL').map(e.getContents),
        k = a.getAttribute('contentType') || b.contentType,
        l = a.getAttribute('mimeType') || b.mimeType,
        m = a.getAttribute('codecs') || b.codecs;
      g = e.parseAttr(a, 'frameRate', g) || b.frameRate;
      var n = a.getAttribute('sar') || b.pixelAspectRatio,
        p = this.emsgSchemeIdUris_(e.findChildren(a, 'InbandEventStream'), b.emsgSchemeIdUris),
        q = e.findChildren(a, 'AudioChannelConfiguration');
      q = this.parseAudioChannels_(q) || b.numChannels;
      var r = e.parseAttr(a, 'audioSamplingRate', f) || b.audioSamplingRate;
      k || (k = shaka.dash.DashParser.guessContentType_(l, m));
      return {
        baseUris: d.resolveUris(c, h),
        segmentBase: e.findChild(a, 'SegmentBase') || b.segmentBase,
        segmentList: e.findChild(a, 'SegmentList') || b.segmentList,
        segmentTemplate: e.findChild(a, 'SegmentTemplate') || b.segmentTemplate,
        width: e.parseAttr(a, 'width', f) || b.width,
        height: e.parseAttr(a, 'height', f) || b.height,
        contentType: k,
        mimeType: l,
        codecs: m,
        frameRate: g,
        pixelAspectRatio: n,
        emsgSchemeIdUris: p,
        id: a.getAttribute('id'),
        numChannels: q,
        audioSamplingRate: r,
      };
    };
    shaka.dash.DashParser.prototype.emsgSchemeIdUris_ = function (a, b) {
      for (var c = b.slice(), d = $jscomp.makeIterator(a), e = d.next(); !e.done; e = d.next())
        (e = e.value.getAttribute('schemeIdUri')), c.includes(e) || c.push(e);
      return c;
    };
    shaka.dash.DashParser.prototype.parseAudioChannels_ = function (a) {
      a = $jscomp.makeIterator(a);
      for (var b = a.next(); !b.done; b = a.next()) {
        var c = b.value;
        if ((b = c.getAttribute('schemeIdUri')))
          if ((c = c.getAttribute('value')))
            switch (b) {
              case 'urn:mpeg:dash:outputChannelPositionList:2012':
                return c.trim().split(/ +/).length;
              case 'urn:mpeg:dash:23003:3:audio_channel_configuration:2011':
              case 'urn:dts:dash:audio_channel_configuration:2012':
                var d = parseInt(c, 10);
                if (!d) {
                  shaka.log.warning('Channel parsing failure! Ignoring scheme and value', b, c);
                  continue;
                }
                return d;
              case 'tag:dolby.com,2014:dash:audio_channel_configuration:2011':
              case 'urn:dolby:dash:audio_channel_configuration:2011':
                d = parseInt(c, 16);
                if (!d) {
                  shaka.log.warning('Channel parsing failure! Ignoring scheme and value', b, c);
                  continue;
                }
                for (a = 0; d; ) d & 1 && ++a, (d >>= 1);
                return a;
              default:
                shaka.log.warning('Unrecognized audio channel scheme:', b, c);
            }
      }
      return null;
    };
    shaka.dash.DashParser.prototype.verifyRepresentation_ = function (a) {
      var b = shaka.util.ManifestParserUtils.ContentType;
      var c = a.segmentBase ? 1 : 0;
      c += a.segmentList ? 1 : 0;
      c += a.segmentTemplate ? 1 : 0;
      if (0 == c) {
        if (a.contentType == b.TEXT || a.contentType == b.APPLICATION) return !0;
        shaka.log.warning(
          'Representation does not contain a segment information source:',
          'the Representation must contain one of SegmentBase, SegmentList,',
          'SegmentTemplate, or explicitly indicate that it is "text".',
          a,
        );
        return !1;
      }
      1 != c &&
        (shaka.log.warning(
          'Representation contains multiple segment information sources:',
          'the Representation should only contain one of SegmentBase,',
          'SegmentList, or SegmentTemplate.',
          a,
        ),
        a.segmentBase
          ? (shaka.log.info('Using SegmentBase by default.'), (a.segmentList = null))
          : (goog.asserts.assert(a.segmentList, 'There should be a SegmentList'),
            shaka.log.info('Using SegmentList by default.')),
        (a.segmentTemplate = null));
      return !0;
    };
    shaka.dash.DashParser.prototype.requestForTiming_ = function (a, b, c) {
      var d = this,
        e,
        f,
        g,
        h,
        k,
        l,
        m;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (n) {
        if (1 == n.nextAddress)
          return (
            (e = shaka.util.ManifestParserUtils.resolveUris(a, [b])),
            (f = shaka.net.NetworkingEngine.makeRequest(e, d.config_.retryParameters)),
            (f.method = c),
            (g = shaka.net.NetworkingEngine.RequestType.TIMING),
            (h = d.playerInterface_.networkingEngine.request(g, f)),
            d.operationManager_.manage(h),
            n.yield(h.promise, 2)
          );
        k = n.yieldResult;
        if ('HEAD' == c) {
          if (!k.headers || !k.headers.date)
            return shaka.log.warning('UTC timing response is missing', 'expected date header'), n['return'](0);
          l = k.headers.date;
        } else l = shaka.util.StringUtils.fromUTF8(k.data);
        m = Date.parse(l);
        return isNaN(m)
          ? (shaka.log.warning('Unable to parse date from UTC timing response'), n['return'](0))
          : n['return'](m - Date.now());
      });
    };
    shaka.dash.DashParser.prototype.parseUtcTiming_ = function (a, b) {
      var c = this,
        d,
        e,
        f,
        g,
        h,
        k,
        l,
        m,
        n;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (p) {
        switch (p.nextAddress) {
          case 1:
            (d = b.map(function (q) {
              return { scheme: q.getAttribute('schemeIdUri'), value: q.getAttribute('value') };
            })),
              (e = c.config_.dash.clockSyncUri),
              !d.length && e && d.push({ scheme: 'urn:mpeg:dash:utc:http-head:2014', value: e }),
              (f = $jscomp.makeIterator(d)),
              (g = f.next());
          case 2:
            if (g.done) {
              p.jumpTo(4);
              break;
            }
            h = g.value;
            p.setCatchFinallyBlocks(5);
            k = h.scheme;
            l = h.value;
            switch (k) {
              case 'urn:mpeg:dash:utc:http-head:2014':
              case 'urn:mpeg:dash:utc:http-head:2012':
                return p.jumpTo(7);
              case 'urn:mpeg:dash:utc:http-xsdate:2014':
              case 'urn:mpeg:dash:utc:http-iso:2014':
              case 'urn:mpeg:dash:utc:http-xsdate:2012':
              case 'urn:mpeg:dash:utc:http-iso:2012':
                return p.jumpTo(8);
              case 'urn:mpeg:dash:utc:direct:2014':
              case 'urn:mpeg:dash:utc:direct:2012':
                return (m = Date.parse(l)), p['return'](isNaN(m) ? 0 : m - Date.now());
              case 'urn:mpeg:dash:utc:http-ntp:2014':
              case 'urn:mpeg:dash:utc:ntp:2014':
              case 'urn:mpeg:dash:utc:sntp:2014':
                shaka.log.alwaysWarn('NTP UTCTiming scheme is not supported');
                break;
              default:
                shaka.log.alwaysWarn('Unrecognized scheme in UTCTiming element', k);
            }
            p.jumpTo(9);
            break;
          case 7:
            return p.yield(c.requestForTiming_(a, l, 'HEAD'), 10);
          case 10:
            return p['return'](p.yieldResult);
          case 8:
            return p.yield(c.requestForTiming_(a, l, 'GET'), 11);
          case 11:
            return p['return'](p.yieldResult);
          case 9:
            p.leaveTryBlock(3);
            break;
          case 5:
            (n = p.enterCatchBlock()), shaka.log.warning('Error fetching time from UTCTiming elem', n.message);
          case 3:
            g = f.next();
            p.jumpTo(2);
            break;
          case 4:
            return (
              shaka.log.alwaysWarn(
                'A UTCTiming element should always be given in live manifests! This content may not play on clients with bad clocks!',
              ),
              p['return'](0)
            );
        }
      });
    };
    shaka.dash.DashParser.prototype.parseEventStream_ = function (a, b, c) {
      var d = shaka.util.XmlUtils,
        e = d.parseNonNegativeInt,
        f = c.getAttribute('schemeIdUri') || '',
        g = c.getAttribute('value') || '',
        h = d.parseAttr(c, 'timescale', e) || 1;
      c = $jscomp.makeIterator(d.findChildren(c, 'Event'));
      for (var k = c.next(); !k.done; k = c.next()) {
        k = k.value;
        var l = d.parseAttr(k, 'presentationTime', e) || 0,
          m = d.parseAttr(k, 'duration', e) || 0;
        l = l / h + a;
        m = l + m / h;
        null != b && ((l = Math.min(l, a + b)), (m = Math.min(m, a + b)));
        k = { schemeIdUri: f, value: g, startTime: l, endTime: m, id: k.getAttribute('id') || '', eventElement: k };
        this.playerInterface_.onTimelineRegionAdded(k);
      }
    };
    shaka.dash.DashParser.prototype.requestInitSegment_ = function (a, b, c) {
      var d = this,
        e,
        f,
        g,
        h,
        k;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (l) {
        if (1 == l.nextAddress)
          return (
            (e = shaka.net.NetworkingEngine.RequestType.SEGMENT),
            (f = shaka.util.Networking.createSegmentRequest(a, b, c, d.config_.retryParameters)),
            (g = d.playerInterface_.networkingEngine),
            (h = g.request(e, f)),
            d.operationManager_.manage(h),
            l.yield(h.promise, 2)
          );
        k = l.yieldResult;
        return l['return'](k.data);
      });
    };
    shaka.dash.DashParser.guessContentType_ = function (a, b) {
      var c = shaka.util.MimeUtils.getFullType(a, b);
      return shaka.text.TextEngine.isTypeSupported(c)
        ? shaka.util.ManifestParserUtils.ContentType.TEXT
        : a.split('/')[0];
    };
    goog.exportSymbol('shaka.dash.DashParser', shaka.dash.DashParser);
    shaka.dash.DashParser.MIN_UPDATE_PERIOD_ = 3;
    shaka.media.ManifestParser.registerParserByExtension('mpd', function () {
      return new shaka.dash.DashParser();
    });
    shaka.media.ManifestParser.registerParserByMime('application/dash+xml', function () {
      return new shaka.dash.DashParser();
    });
    shaka.media.ManifestParser.registerParserByMime('video/vnd.mpeg.dash.mpd', function () {
      return new shaka.dash.DashParser();
    });
    shaka.hls = {};
    shaka.hls.Playlist = function (a, b, c, d) {
      this.absoluteUri = a;
      this.type = b;
      this.tags = c;
      this.segments = d || null;
    };
    shaka.hls.PlaylistType = { MASTER: 0, MEDIA: 1 };
    shaka.hls.Tag = function (a, b, c, d) {
      this.id = a;
      this.name = b;
      this.attributes = c;
      this.value = void 0 === d ? null : d;
    };
    shaka.hls.Tag.prototype.toString = function () {
      var a = function (c) {
          var d = isNaN(Number(c.value)) ? '"' + c.value + '"' : c.value;
          return c.name + '=' + d;
        },
        b = '#' + this.name;
      a = this.attributes ? this.attributes.map(a) : [];
      this.value && a.unshift(this.value);
      0 < a.length && (b += ':' + a.join(','));
      return b;
    };
    shaka.hls.Tag.prototype.addAttribute = function (a) {
      this.attributes.push(a);
    };
    shaka.hls.Tag.prototype.getAttribute = function (a) {
      var b = this.attributes.filter(function (c) {
        return c.name == a;
      });
      goog.asserts.assert(2 > b.length, 'A tag should not have multiple attributes with the same name!');
      return b.length ? b[0] : null;
    };
    shaka.hls.Tag.prototype.getAttributeValue = function (a, b) {
      var c = this.getAttribute(a);
      return c ? c.value : b || null;
    };
    shaka.hls.Tag.prototype.getRequiredAttrValue = function (a) {
      var b = this.getAttribute(a);
      if (!b)
        throw new shaka.util.Error(
          shaka.util.Error.Severity.CRITICAL,
          shaka.util.Error.Category.MANIFEST,
          shaka.util.Error.Code.HLS_REQUIRED_ATTRIBUTE_MISSING,
          a,
        );
      return b.value;
    };
    shaka.hls.Segment = function (a, b) {
      this.tags = b;
      this.absoluteUri = a;
    };
    shaka.hls.Attribute = function (a, b) {
      this.name = a;
      this.value = b;
    };
    shaka.hls.Utils = function () {};
    shaka.hls.Utils.filterTagsByName = function (a, b) {
      return a.filter(function (c) {
        return c.name == b;
      });
    };
    shaka.hls.Utils.filterTagsByType = function (a, b) {
      return a.filter(function (c) {
        return c.getRequiredAttrValue('TYPE') == b;
      });
    };
    shaka.hls.Utils.getFirstTagWithName = function (a, b) {
      var c = shaka.hls.Utils.filterTagsByName(a, b);
      return c.length ? c[0] : null;
    };
    shaka.hls.Utils.getFirstTagWithNameAsNumber = function (a, b, c) {
      c = void 0 === c ? 0 : c;
      return (a = shaka.hls.Utils.getFirstTagWithName(a, b)) ? Number(a.value) : c;
    };
    shaka.hls.Utils.constructAbsoluteUri = function (a, b) {
      return shaka.util.ManifestParserUtils.resolveUris([a], [b])[0];
    };
    shaka.hls.Utils.isComment = function (a) {
      return /^#(?!EXT)/m.test(a);
    };
    shaka.util.TextParser = function (a) {
      this.data_ = a;
      this.position_ = 0;
    };
    shaka.util.TextParser.prototype.atEnd = function () {
      return this.position_ == this.data_.length;
    };
    shaka.util.TextParser.prototype.readLine = function () {
      return this.readRegexReturnCapture_(/(.*?)(\n|$)/gm, 1);
    };
    shaka.util.TextParser.prototype.readWord = function () {
      return this.readRegexReturnCapture_(/[^ \t\n]*/gm, 0);
    };
    shaka.util.TextParser.prototype.skipWhitespace = function () {
      this.readRegex(/[ \t]+/gm);
    };
    shaka.util.TextParser.prototype.readRegex = function (a) {
      a = this.indexOf_(a);
      if (this.atEnd() || null == a || a.position != this.position_) return null;
      this.position_ += a.length;
      return a.results;
    };
    shaka.util.TextParser.prototype.readRegexReturnCapture_ = function (a, b) {
      if (this.atEnd()) return null;
      var c = this.readRegex(a);
      return c ? c[b] : null;
    };
    shaka.util.TextParser.prototype.indexOf_ = function (a) {
      goog.asserts.assert(a.global, 'global flag should be set');
      a.lastIndex = this.position_;
      a = a.exec(this.data_);
      return null == a ? null : { position: a.index, length: a[0].length, results: a };
    };
    shaka.hls.ManifestTextParser = function () {
      this.globalId_ = 0;
    };
    shaka.hls.ManifestTextParser.prototype.parsePlaylist = function (a, b) {
      var c = shaka.hls.ManifestTextParser.MEDIA_PLAYLIST_TAGS,
        d = shaka.hls.ManifestTextParser.SEGMENT_TAGS,
        e = shaka.util.StringUtils.fromUTF8(a);
      e = e.replace(/\r\n|\r(?=[^\n]|$)/gm, '\n').trim();
      var f = e.split(/\n+/m);
      if (!/^#EXTM3U($|[ \t\n])/m.test(f[0]))
        throw new shaka.util.Error(
          shaka.util.Error.Severity.CRITICAL,
          shaka.util.Error.Category.MANIFEST,
          shaka.util.Error.Code.HLS_PLAYLIST_HEADER_MISSING,
        );
      e = shaka.hls.PlaylistType.MASTER;
      for (var g = !0, h = $jscomp.makeIterator(f), k = h.next(); !k.done; k = h.next())
        if (((k = k.value), shaka.hls.Utils.isComment(k) || g)) g = !1;
        else if (((k = this.parseTag_(k)), --this.globalId_, c.includes(k.name))) {
          e = shaka.hls.PlaylistType.MEDIA;
          break;
        } else 'EXT-X-STREAM-INF' == k.name && (g = !0);
      c = [];
      g = !0;
      h = $jscomp.makeIterator(shaka.util.Iterables.enumerate(f));
      for (k = h.next(); !k.done; k = h.next()) {
        var l = k.value;
        k = l.i;
        var m = l.item;
        l = l.next;
        if (shaka.hls.Utils.isComment(m) || g) g = !1;
        else {
          m = this.parseTag_(m);
          if (d.includes(m.name)) {
            if (e != shaka.hls.PlaylistType.MEDIA)
              throw new shaka.util.Error(
                shaka.util.Error.Severity.CRITICAL,
                shaka.util.Error.Category.MANIFEST,
                shaka.util.Error.Code.HLS_INVALID_PLAYLIST_HIERARCHY,
              );
            d = f.splice(k, f.length - k);
            d = this.parseSegments_(b, d, c);
            return new shaka.hls.Playlist(b, e, c, d);
          }
          c.push(m);
          'EXT-X-STREAM-INF' == m.name && ((g = new shaka.hls.Attribute('URI', l)), m.addAttribute(g), (g = !0));
        }
      }
      return new shaka.hls.Playlist(b, e, c);
    };
    shaka.hls.ManifestTextParser.prototype.parseSegments_ = function (a, b, c) {
      var d = [],
        e = [],
        f = null;
      b = $jscomp.makeIterator(b);
      for (var g = b.next(); !g.done; g = b.next())
        (g = g.value),
          /^(#EXT)/.test(g)
            ? ((g = this.parseTag_(g)),
              shaka.hls.ManifestTextParser.MEDIA_PLAYLIST_TAGS.includes(g.name)
                ? c.push(g)
                : 'EXT-X-MAP' == g.name
                ? (f = g)
                : e.push(g))
            : shaka.hls.Utils.isComment(g) ||
              ((g = g.trim()),
              (g = shaka.hls.Utils.constructAbsoluteUri(a, g)),
              f && e.push(f),
              (e = new shaka.hls.Segment(g, e)),
              d.push(e),
              (e = []));
      return d;
    };
    shaka.hls.ManifestTextParser.prototype.parseTag_ = function (a) {
      return shaka.hls.ManifestTextParser.parseTag(this.globalId_++, a);
    };
    shaka.hls.ManifestTextParser.parseTag = function (a, b) {
      var c = b.match(/^#(EXT[^:]*)(?::(.*))?$/);
      if (!c)
        throw new shaka.util.Error(
          shaka.util.Error.Severity.CRITICAL,
          shaka.util.Error.Category.MANIFEST,
          shaka.util.Error.Code.INVALID_HLS_TAG,
          b,
        );
      var d = c[1],
        e = c[2];
      c = [];
      var f;
      if (e) {
        e = new shaka.util.TextParser(e);
        var g,
          h = e.readRegex(/^([^,=]+)(?:,|$)/g);
        h && (f = h[1]);
        for (h = /([^=]+)=(?:"([^"]*)"|([^",]*))(?:,|$)/g; (g = e.readRegex(h)); )
          (g = new shaka.hls.Attribute(g[1], g[2] || g[3])), c.push(g);
      }
      return new shaka.hls.Tag(a, d, c, f);
    };
    shaka.hls.ManifestTextParser.MEDIA_PLAYLIST_TAGS = 'EXT-X-TARGETDURATION EXT-X-MEDIA-SEQUENCE EXT-X-DISCONTINUITY-SEQUENCE EXT-X-PLAYLIST-TYPE EXT-X-I-FRAMES-ONLY EXT-X-ENDLIST'.split(
      ' ',
    );
    shaka.hls.ManifestTextParser.SEGMENT_TAGS = 'EXTINF EXT-X-BYTERANGE EXT-X-DISCONTINUITY EXT-X-PROGRAM-DATE-TIME EXT-X-KEY EXT-X-DATERANGE EXT-X-MAP'.split(
      ' ',
    );
    shaka.net.DataUriPlugin = function () {};
    shaka.net.DataUriPlugin.parse = function (a, b, c, d) {
      try {
        var e = shaka.net.DataUriPlugin.parseRaw(a);
        return shaka.util.AbortableOperation.completed({
          uri: a,
          originalUri: a,
          data: e.data,
          headers: { 'content-type': e.contentType },
        });
      } catch (f) {
        return shaka.util.AbortableOperation.failed(f);
      }
    };
    shaka.net.DataUriPlugin.parseRaw = function (a) {
      var b = a.split(':');
      if (2 > b.length || 'data' != b[0])
        throw (
          (shaka.log.error('Bad data URI, failed to parse scheme'),
          new shaka.util.Error(
            shaka.util.Error.Severity.CRITICAL,
            shaka.util.Error.Category.NETWORK,
            shaka.util.Error.Code.MALFORMED_DATA_URI,
            a,
          ))
        );
      b = b.slice(1).join(':').split(',');
      if (2 > b.length)
        throw (
          (shaka.log.error('Bad data URI, failed to extract encoding and MIME type'),
          new shaka.util.Error(
            shaka.util.Error.Severity.CRITICAL,
            shaka.util.Error.Category.NETWORK,
            shaka.util.Error.Code.MALFORMED_DATA_URI,
            a,
          ))
        );
      var c = b[0];
      a = window.decodeURIComponent(b.slice(1).join(','));
      b = c.split(';');
      c = b[0];
      var d = !1;
      1 < b.length && 'base64' == b[b.length - 1] && ((d = !0), b.pop());
      return { data: d ? shaka.util.Uint8ArrayUtils.fromBase64(a) : shaka.util.StringUtils.toUTF8(a), contentType: c };
    };
    goog.exportSymbol('shaka.net.DataUriPlugin', shaka.net.DataUriPlugin);
    goog.exportProperty(shaka.net.DataUriPlugin, 'parse', shaka.net.DataUriPlugin.parse);
    shaka.net.NetworkingEngine.registerScheme('data', shaka.net.DataUriPlugin.parse);
    shaka.hls.HlsParser = function () {
      var a = this;
      this.config_ = this.playerInterface_ = null;
      this.globalId_ = 1;
      this.globalVariables_ = new Map();
      this.groupIdToStreamInfosMap_ = new Map();
      this.variantUriSet_ = new Set();
      this.uriToStreamInfosMap_ = new Map();
      this.presentationTimeline_ = null;
      this.masterPlaylistUri_ = '';
      this.manifestTextParser_ = new shaka.hls.ManifestTextParser();
      this.updatePlaylistDelay_ = 0;
      this.updatePlaylistTimer_ = new shaka.util.Timer(function () {
        a.onUpdate_();
      });
      this.presentationType_ = shaka.hls.HlsParser.PresentationType_.VOD;
      this.manifest_ = null;
      this.maxTargetDuration_ = 0;
      this.minTargetDuration_ = Infinity;
      this.operationManager_ = new shaka.util.OperationManager();
      this.segmentsToNotifyByStream_ = [];
      this.groupIdToClosedCaptionsMap_ = new Map();
      this.aesEncrypted_ = !1;
      this.groupIdToCodecsMap_ = new Map();
      this.playlistStartTime_ = null;
      this.mapTagToInitSegmentRefMap_ = new Map();
      this.discontinuityToTso_ = new Map();
    };
    shaka.hls.HlsParser.prototype.configure = function (a) {
      this.config_ = a;
    };
    shaka.hls.HlsParser.prototype.start = function (a, b) {
      var c = this,
        d,
        e;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (f) {
        if (1 == f.nextAddress)
          return (
            goog.asserts.assert(c.config_, 'Must call configure() before start()!'),
            (c.playerInterface_ = b),
            f.yield(c.requestManifest_(a), 2)
          );
        if (3 != f.nextAddress)
          return (
            (d = f.yieldResult),
            (c.masterPlaylistUri_ = d.uri),
            goog.asserts.assert(d.data, 'Response data should be non-null!'),
            f.yield(c.parseManifest_(d.data), 3)
          );
        e = c.updatePlaylistDelay_;
        0 < e && c.updatePlaylistTimer_.tickAfter(e);
        goog.asserts.assert(c.manifest_, 'Manifest should be non-null');
        return f['return'](c.manifest_);
      });
    };
    shaka.hls.HlsParser.prototype.stop = function () {
      this.updatePlaylistTimer_ && (this.updatePlaylistTimer_.stop(), (this.updatePlaylistTimer_ = null));
      var a = [];
      this.operationManager_ && (a.push(this.operationManager_.destroy()), (this.operationManager_ = null));
      this.config_ = this.playerInterface_ = null;
      this.variantUriSet_.clear();
      this.manifest_ = null;
      this.uriToStreamInfosMap_.clear();
      this.groupIdToStreamInfosMap_.clear();
      this.groupIdToCodecsMap_.clear();
      this.globalVariables_.clear();
      return Promise.all(a);
    };
    shaka.hls.HlsParser.prototype.update = function () {
      var a = this,
        b,
        c,
        d;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (e) {
        if (1 == e.nextAddress) {
          if (!a.isLive_()) return e['return']();
          b = [];
          a.playlistStartTime_ = null;
          c = Array.from(a.uriToStreamInfosMap_.values());
          return c.length ? e.yield(a.updateStream_(c[0]), 2) : e.jumpTo(2);
        }
        for (d = 1; d < c.length; d++) b.push(a.updateStream_(c[d]));
        return e.yield(Promise.all(b), 0);
      });
    };
    shaka.hls.HlsParser.prototype.updateStream_ = function (a) {
      var b = this,
        c,
        d,
        e,
        f,
        g,
        h,
        k,
        l,
        m,
        n;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (p) {
        if (1 == p.nextAddress)
          return (
            (c = shaka.hls.HlsParser.PresentationType_),
            (d = a.absoluteMediaPlaylistUri),
            p.yield(b.requestManifest_(d), 2)
          );
        if (3 != p.nextAddress) {
          e = p.yieldResult;
          f = b.manifestTextParser_.parsePlaylist(e.data, e.uri);
          if (f.type != shaka.hls.PlaylistType.MEDIA)
            throw new shaka.util.Error(
              shaka.util.Error.Severity.CRITICAL,
              shaka.util.Error.Category.MANIFEST,
              shaka.util.Error.Code.HLS_INVALID_PLAYLIST_HIERARCHY,
            );
          g = shaka.hls.Utils.filterTagsByName(f.tags, 'EXT-X-DEFINE');
          h = b.parseMediaVariables_(g);
          k = a.stream;
          return p.yield(
            b.createSegments_(a.verbatimMediaPlaylistUri, f, k.type, k.mimeType, a.mediaSequenceToStartTime, h),
            3,
          );
        }
        l = p.yieldResult;
        k.segmentIndex.merge(l);
        l.length && k.segmentIndex.evict(l[0].startTime);
        m = l[l.length - 1];
        goog.asserts.assert(m, 'Should have segments!');
        if ((n = shaka.hls.Utils.getFirstTagWithName(f.tags, 'EXT-X-ENDLIST')))
          b.setPresentationType_(c.VOD), b.presentationTimeline_.setDuration(m.endTime);
        p.jumpToEnd();
      });
    };
    shaka.hls.HlsParser.prototype.onExpirationUpdated = function (a, b) {};
    shaka.hls.HlsParser.prototype.parseManifest_ = function (a) {
      var b = this,
        c,
        d,
        e,
        f,
        g,
        h,
        k,
        l,
        m,
        n,
        p,
        q,
        r,
        t,
        w,
        u;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (v) {
        switch (v.nextAddress) {
          case 1:
            c = shaka.hls.Utils;
            goog.asserts.assert(b.masterPlaylistUri_, 'Master playlist URI must be set before calling parseManifest_!');
            d = b.manifestTextParser_.parsePlaylist(a, b.masterPlaylistUri_);
            if (d.type != shaka.hls.PlaylistType.MASTER)
              throw new shaka.util.Error(
                shaka.util.Error.Severity.CRITICAL,
                shaka.util.Error.Category.MANIFEST,
                shaka.util.Error.Code.HLS_MASTER_PLAYLIST_NOT_PROVIDED,
              );
            e = c.filterTagsByName(d.tags, 'EXT-X-DEFINE');
            b.parseMasterVariables_(e);
            f = c.filterTagsByName(d.tags, 'EXT-X-MEDIA');
            g = c.filterTagsByName(d.tags, 'EXT-X-STREAM-INF');
            b.parseCodecs_(g);
            return v.yield(b.createStreamInfosFromMediaTags_(f), 2);
          case 2:
            return b.parseClosedCaptions_(f), v.yield(b.createVariantsForTags_(g), 3);
          case 3:
            return (h = v.yieldResult), v.yield(b.parseTexts_(f), 4);
          case 4:
            k = v.yieldResult;
            if (!b.playerInterface_)
              throw new shaka.util.Error(
                shaka.util.Error.Severity.CRITICAL,
                shaka.util.Error.Category.PLAYER,
                shaka.util.Error.Code.OPERATION_ABORTED,
              );
            if (b.aesEncrypted_ && 0 == h.length)
              throw (
                (shaka.log.info("No stream is created, because we don't support AES-128", 'encryption yet'),
                new shaka.util.Error(
                  shaka.util.Error.Severity.CRITICAL,
                  shaka.util.Error.Category.MANIFEST,
                  shaka.util.Error.Code.HLS_AES_128_ENCRYPTION_NOT_SUPPORTED,
                ))
              );
            m = l = Infinity;
            n = $jscomp.makeIterator(b.uriToStreamInfosMap_.values());
            for (p = n.next(); !p.done; p = n.next())
              (q = p.value),
                (l = Math.min(l, q.minTimestamp)),
                'text' != q.stream.type && (m = Math.min(m, q.maxTimestamp - q.minTimestamp));
            goog.asserts.assert(null == b.presentationTimeline_, 'Presentation timeline created early!');
            b.createPresentationTimeline_();
            goog.asserts.assert(b.presentationTimeline_, 'Presentation timeline not created!');
            if (b.isLive_())
              (b.updatePlaylistDelay_ = b.minTargetDuration_),
                (r = shaka.hls.HlsParser.PresentationType_),
                b.presentationType_ == r.LIVE &&
                  ((t = b.presentationTimeline_.getDelay()),
                  isNaN(b.config_.availabilityWindowOverride) || (t = b.config_.availabilityWindowOverride),
                  b.presentationTimeline_.setSegmentAvailabilityDuration(t));
            else
              for (
                b.presentationTimeline_.setDuration(m),
                  b.presentationTimeline_.offset(-l),
                  w = $jscomp.makeIterator(b.uriToStreamInfosMap_.values()),
                  p = w.next();
                !p.done;
                p = w.next()
              )
                (u = p.value), u.stream.segmentIndex.offset(-l), u.stream.segmentIndex.fit(0, m);
            b.manifest_ = {
              presentationTimeline: b.presentationTimeline_,
              variants: h,
              textStreams: k,
              offlineSessionIds: [],
              minBufferTime: 0,
            };
            b.playerInterface_.makeTextStreamsForClosedCaptions(b.manifest_);
            return v.yield(b.playerInterface_.filter(b.manifest_), 0);
        }
      });
    };
    shaka.hls.HlsParser.prototype.parseMasterVariables_ = function (a) {
      a = $jscomp.makeIterator(a);
      for (var b = a.next(); !b.done; b = a.next()) {
        var c = b.value;
        b = c.getAttributeValue('NAME');
        c = c.getAttributeValue('VALUE');
        b && c && (this.globalVariables_.has(b) || this.globalVariables_.set(b, c));
      }
    };
    shaka.hls.HlsParser.prototype.parseMediaVariables_ = function (a) {
      var b = new Map();
      a = $jscomp.makeIterator(a);
      for (var c = a.next(); !c.done; c = a.next()) {
        var d = c.value;
        c = d.getAttributeValue('NAME');
        var e = d.getAttributeValue('VALUE');
        d = d.getAttributeValue('IMPORT');
        c && e && b.set(c, e);
        d && (c = this.globalVariables_.get(d)) && b.set(d, c);
      }
      return b;
    };
    shaka.hls.HlsParser.prototype.parseCodecs_ = function (a) {
      var b = shaka.util.ManifestParserUtils.ContentType;
      a = $jscomp.makeIterator(a);
      for (var c = a.next(); !c.done; c = a.next()) {
        var d = c.value,
          e = d.getAttributeValue('AUDIO');
        c = d.getAttributeValue('VIDEO');
        var f = d.getAttributeValue('SUBTITLES');
        d = this.getCodecsForVariantTag_(d);
        if (f) {
          var g = this.guessCodecsSafe_(b.TEXT, d);
          goog.asserts.assert(null != g, 'Text codecs should be valid.');
          this.groupIdToCodecsMap_.set(f, g);
          shaka.util.ArrayUtils.remove(d, g);
        }
        e && ((f = this.guessCodecs_(b.AUDIO, d)), this.groupIdToCodecsMap_.set(e, f));
        c && ((e = this.guessCodecs_(b.VIDEO, d)), this.groupIdToCodecsMap_.set(c, e));
      }
    };
    shaka.hls.HlsParser.prototype.parseTexts_ = function (a) {
      var b = this,
        c,
        d,
        e,
        f,
        g,
        h,
        k,
        l,
        m,
        n,
        p,
        q;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (r) {
        if (1 == r.nextAddress)
          return (
            (c = shaka.hls.Utils.filterTagsByType(a, 'SUBTITLES')),
            (d = c.map(function (t) {
              var w, u, v;
              return $jscomp.asyncExecutePromiseGeneratorProgram(function (x) {
                if (1 == x.nextAddress) {
                  if ((w = b.config_.disableText)) return x['return'](null);
                  x.setCatchFinallyBlocks(2);
                  return x.yield(b.createStreamInfoFromMediaTag_(t), 4);
                }
                if (2 != x.nextAddress)
                  return (
                    (u = x.yieldResult),
                    goog.asserts.assert(u, 'Should always have a streamInfo for text'),
                    x['return'](u.stream)
                  );
                v = x.enterCatchBlock();
                if (b.config_.hls.ignoreTextStreamFailures) return x['return'](null);
                throw v;
              });
            })),
            r.yield(Promise.all(d), 2)
          );
        e = r.yieldResult;
        f = $jscomp.makeIterator(c);
        for (g = f.next(); !g.done; g = f.next())
          if (((h = g.value), (k = h.getRequiredAttrValue('GROUP-ID')), (l = b.groupIdToCodecsMap_.get(k))))
            if ((m = b.groupIdToStreamInfosMap_.get(k)))
              for (n = $jscomp.makeIterator(m), p = n.next(); !p.done; p = n.next())
                (q = p.value), (q.stream.codecs = l);
        return r['return'](
          e.filter(function (t) {
            return t;
          }),
        );
      });
    };
    shaka.hls.HlsParser.prototype.createStreamInfosFromMediaTags_ = function (a) {
      var b = this,
        c;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (d) {
        if (1 == d.nextAddress)
          return (
            (a = a.filter(function (e) {
              var f = e.getAttributeValue('URI') || '';
              return 'SUBTITLES' != e.getAttributeValue('TYPE') && '' != f;
            })),
            a.length ? d.yield(b.createStreamInfoFromMediaTag_(a[0]), 2) : d.jumpTo(2)
          );
        c = a.slice(1).map(function (e) {
          return b.createStreamInfoFromMediaTag_(e);
        });
        return d.yield(Promise.all(c), 0);
      });
    };
    shaka.hls.HlsParser.prototype.createVariantsForTags_ = function (a) {
      var b = this,
        c,
        d,
        e;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (f) {
        if (1 == f.nextAddress)
          return (
            (c = a.map(function (g) {
              var h, k, l, m, n, p, q;
              return $jscomp.asyncExecutePromiseGeneratorProgram(function (r) {
                return 1 == r.nextAddress
                  ? ((h = g.getAttributeValue('FRAME-RATE')),
                    (k = Number(g.getRequiredAttrValue('BANDWIDTH'))),
                    (l = g.getAttributeValue('RESOLUTION')),
                    (m = $jscomp.makeIterator(l ? l.split('x') : [null, null])),
                    (n = m.next().value),
                    (p = m.next().value),
                    r.yield(b.createStreamInfosForVariantTag_(g, l, h), 2))
                  : (q = r.yieldResult)
                  ? (goog.asserts.assert(q.audio.length || q.video.length, 'We should have created a stream!'),
                    r['return'](b.createVariants_(q.audio, q.video, k, n, p, h)))
                  : r['return']([]);
              });
            })),
            f.yield(Promise.all(c), 2)
          );
        d = f.yieldResult;
        e = d.reduce(shaka.util.Functional.collapseArrays, []);
        e = e.filter(function (g) {
          return null != g;
        });
        return f['return'](e);
      });
    };
    shaka.hls.HlsParser.prototype.createStreamInfosForVariantTag_ = function (a, b, c) {
      var d = this,
        e,
        f,
        g,
        h,
        k,
        l,
        m,
        n,
        p,
        q,
        r,
        t,
        w,
        u;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (v) {
        if (1 == v.nextAddress)
          return (
            (e = shaka.util.ManifestParserUtils.ContentType),
            (f = d.getCodecsForVariantTag_(a)),
            (g = a.getAttributeValue('AUDIO')),
            (h = a.getAttributeValue('VIDEO')),
            goog.asserts.assert(null == g || null == h, 'Unexpected: both video and audio described by media tags!'),
            (l = (k = g || h) && d.groupIdToStreamInfosMap_.has(k) ? d.groupIdToStreamInfosMap_.get(k) : []),
            (m = { audio: g ? l : [], video: h ? l : [] }),
            shaka.log.debug('Guessing stream type for', a.toString()),
            (p = !1),
            (q = a.getRequiredAttrValue('URI')),
            (r = m.audio.find(function (x) {
              return x && x.verbatimMediaPlaylistUri == q;
            })),
            (t = d.guessCodecsSafe_(e.VIDEO, f)),
            (w = b || c || t),
            1 != f.length || w
              ? !l.length && 1 < f.length
                ? (shaka.log.debug('Guessing multiplexed audio+video.'), (n = e.VIDEO), (f = [f.join(',')]))
                : m.audio.length && r
                ? (shaka.log.debug('Guessing audio-only.'), (n = e.AUDIO), (p = !0))
                : m.video.length
                ? (shaka.log.debug('Guessing audio-only.'), (n = e.AUDIO))
                : (shaka.log.debug('Guessing video-only.'), (n = e.VIDEO))
              : ((n = e.AUDIO), shaka.log.debug('Guessing audio-only.')),
            p ? v.jumpTo(2) : v.yield(d.createStreamInfoFromVariantTag_(a, f, n), 3)
          );
        2 != v.nextAddress && (u = v.yieldResult);
        if (u) m[u.stream.type] = [u];
        else if (null === u) return shaka.log.debug('streamInfo is null'), v['return'](null);
        d.filterLegacyCodecs_(m);
        return v['return'](m);
      });
    };
    shaka.hls.HlsParser.prototype.getCodecsForVariantTag_ = function (a) {
      var b = [];
      this.config_.disableVideo || b.push('avc1.42E01E');
      this.config_.disableAudio || b.push('mp4a.40.2');
      b = b.join(',');
      var c = a.getAttributeValue('CODECS', b).split(/\s*,\s*/);
      a = new Set();
      b = [];
      c = $jscomp.makeIterator(c);
      for (var d = c.next(); !d.done; d = c.next()) {
        d = d.value;
        var e = shaka.util.MimeUtils.getCodecBase(d);
        a.has(e) ? shaka.log.debug('Ignoring duplicate codec') : (b.push(d), a.add(e));
      }
      return b;
    };
    shaka.hls.HlsParser.prototype.getChannelsCount_ = function (a) {
      a = a.getAttributeValue('CHANNELS');
      if (!a) return null;
      a = a.split('/')[0];
      return parseInt(a, 10);
    };
    shaka.hls.HlsParser.prototype.getClosedCaptions_ = function (a, b) {
      var c = shaka.util.ManifestParserUtils.ContentType,
        d = a.getAttributeValue('CLOSED-CAPTIONS');
      return b == c.VIDEO && d && 'NONE' != d ? this.groupIdToClosedCaptionsMap_.get(d) : null;
    };
    shaka.hls.HlsParser.prototype.getLanguage_ = function (a) {
      var b = shaka.util.LanguageUtils;
      a = a.getAttributeValue('LANGUAGE') || 'und';
      return b.normalize(a);
    };
    shaka.hls.HlsParser.prototype.getType_ = function (a) {
      a = a.getRequiredAttrValue('TYPE').toLowerCase();
      'subtitles' == a && (a = shaka.util.ManifestParserUtils.ContentType.TEXT);
      return a;
    };
    shaka.hls.HlsParser.prototype.filterLegacyCodecs_ = function (a) {
      a = $jscomp.makeIterator(a.audio.concat(a.video));
      for (var b = a.next(); !b.done; b = a.next())
        if ((b = b.value)) {
          var c = b.stream.codecs.split(',');
          c = c.filter(function (d) {
            return 'mp4a.40.34' != d;
          });
          b.stream.codecs = c.join(',');
        }
    };
    shaka.hls.HlsParser.prototype.createVariants_ = function (a, b, c, d, e, f) {
      for (
        var g = shaka.util.ManifestParserUtils.ContentType,
          h = shaka.media.DrmEngine,
          k = $jscomp.makeIterator(b),
          l = k.next();
        !l.done;
        l = k.next()
      )
        this.addVideoAttributes_(l.value.stream, d, e, f);
      d = this.config_.disableAudio;
      if (!a.length || d) a = [null];
      d = this.config_.disableVideo;
      if (!b.length || d) b = [null];
      d = [];
      a = $jscomp.makeIterator(a);
      for (e = a.next(); !e.done; e = a.next())
        for (e = e.value, f = $jscomp.makeIterator(b), k = f.next(); !k.done; k = f.next()) {
          var m = k.value;
          k = e ? e.stream : null;
          l = m ? m.stream : null;
          var n = e ? e.stream.drmInfos : null,
            p = m ? m.stream.drmInfos : null;
          m = (m ? m.verbatimMediaPlaylistUri : '') + ' - ' + (e ? e.verbatimMediaPlaylistUri : '');
          k && l && !h.areDrmCompatible(n, p)
            ? shaka.log.warning('Incompatible DRM info in HLS variant.  Skipping.')
            : this.variantUriSet_.has(m)
            ? shaka.log.debug('Skipping variant which only differs in text streams.')
            : (goog.asserts.assert(!k || k.type == g.AUDIO, 'Audio parameter mismatch!'),
              goog.asserts.assert(!l || l.type == g.VIDEO, 'Video parameter mismatch!'),
              (k = {
                id: this.globalId_++,
                language: k ? k.language : 'und',
                primary: (!!k && k.primary) || (!!l && l.primary),
                audio: k,
                video: l,
                bandwidth: c,
                allowedByApplication: !0,
                allowedByKeySystem: !0,
              }),
              d.push(k),
              this.variantUriSet_.add(m));
        }
      return d;
    };
    shaka.hls.HlsParser.prototype.parseClosedCaptions_ = function (a) {
      a = shaka.hls.Utils.filterTagsByType(a, 'CLOSED-CAPTIONS');
      a = $jscomp.makeIterator(a);
      for (var b = a.next(); !b.done; b = a.next()) {
        var c = b.value;
        goog.asserts.assert('EXT-X-MEDIA' == c.name, 'Should only be called on media tags!');
        b = this.getLanguage_(c);
        var d = c.getRequiredAttrValue('GROUP-ID');
        c = c.getRequiredAttrValue('INSTREAM-ID');
        this.groupIdToClosedCaptionsMap_.get(d) || this.groupIdToClosedCaptionsMap_.set(d, new Map());
        this.groupIdToClosedCaptionsMap_.get(d).set(c, b);
      }
    };
    shaka.hls.HlsParser.prototype.createStreamInfoFromMediaTag_ = function (a) {
      var b = this,
        c,
        d,
        e,
        f,
        g,
        h,
        k,
        l,
        m,
        n,
        p;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (q) {
        if (1 == q.nextAddress) {
          goog.asserts.assert('EXT-X-MEDIA' == a.name, 'Should only be called on media tags!');
          c = a.getRequiredAttrValue('GROUP-ID');
          d = '';
          e = b.getType_(a);
          e != shaka.util.ManifestParserUtils.ContentType.TEXT &&
            c &&
            b.groupIdToCodecsMap_.has(c) &&
            (d = b.groupIdToCodecsMap_.get(c));
          f = b.variableSubstitution_(a.getRequiredAttrValue('URI'), b.globalVariables_);
          if (b.uriToStreamInfosMap_.has(f)) return q['return'](b.uriToStreamInfosMap_.get(f));
          g = b.getLanguage_(a);
          h = a.getAttributeValue('NAME');
          k = a.getAttribute('DEFAULT');
          l = 'YES' == k;
          m = 'audio' == e ? b.getChannelsCount_(a) : null;
          n = a.getAttributeValue('CHARACTERISTICS');
          return q.yield(b.createStreamInfo_(f, d, e, g, l, h, m, null, n), 2);
        }
        p = q.yieldResult;
        b.groupIdToStreamInfosMap_.has(c)
          ? b.groupIdToStreamInfosMap_.get(c).push(p)
          : b.groupIdToStreamInfosMap_.set(c, [p]);
        if (null == p) return q['return'](null);
        if (b.uriToStreamInfosMap_.has(f)) return q['return'](b.uriToStreamInfosMap_.get(f));
        b.uriToStreamInfosMap_.set(f, p);
        return q['return'](p);
      });
    };
    shaka.hls.HlsParser.prototype.createStreamInfoFromVariantTag_ = function (a, b, c) {
      var d = this,
        e,
        f,
        g,
        h;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (k) {
        if (1 == k.nextAddress) {
          goog.asserts.assert('EXT-X-STREAM-INF' == a.name, 'Should only be called on variant tags!');
          e = d.variableSubstitution_(a.getRequiredAttrValue('URI'), d.globalVariables_);
          if (d.uriToStreamInfosMap_.has(e)) return k['return'](d.uriToStreamInfosMap_.get(e));
          f = d.getClosedCaptions_(a, c);
          g = d.guessCodecs_(c, b);
          return k.yield(d.createStreamInfo_(e, g, c, 'und', !1, null, null, f, null), 2);
        }
        h = k.yieldResult;
        if (null == h) return k['return'](null);
        if (d.uriToStreamInfosMap_.has(e)) return k['return'](d.uriToStreamInfosMap_.get(e));
        d.uriToStreamInfosMap_.set(e, h);
        return k['return'](h);
      });
    };
    shaka.hls.HlsParser.prototype.createStreamInfo_ = function (a, b, c, d, e, f, g, h, k) {
      var l = this,
        m,
        n,
        p,
        q,
        r,
        t,
        w,
        u,
        v,
        x,
        B,
        z,
        A,
        D,
        y,
        C,
        H,
        F,
        E,
        G,
        I,
        K,
        N,
        O,
        L,
        M,
        Q,
        T,
        U,
        V,
        W,
        R,
        S,
        P,
        X,
        Y;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (J) {
        switch (J.nextAddress) {
          case 1:
            return (
              (m = shaka.hls.Utils.constructAbsoluteUri(l.masterPlaylistUri_, a)), J.yield(l.requestManifest_(m), 2)
            );
          case 2:
            n = J.yieldResult;
            m = n.uri;
            p = l.manifestTextParser_.parsePlaylist(n.data, m);
            if (p.type != shaka.hls.PlaylistType.MEDIA)
              throw new shaka.util.Error(
                shaka.util.Error.Severity.CRITICAL,
                shaka.util.Error.Category.MANIFEST,
                shaka.util.Error.Code.HLS_INVALID_PLAYLIST_HIERARCHY,
              );
            q = [];
            if (p.segments)
              for (r = $jscomp.makeIterator(p.segments), t = r.next(); !t.done; t = r.next())
                (w = t.value),
                  (u = shaka.hls.Utils.filterTagsByName(w.tags, 'EXT-X-KEY')),
                  q.push.apply(q, $jscomp.arrayFromIterable(u));
            v = !1;
            x = [];
            B = new Set();
            z = $jscomp.makeIterator(q);
            for (A = z.next(); !A.done; A = z.next())
              if (((D = A.value), (y = D.getRequiredAttrValue('METHOD')), 'NONE' != y)) {
                v = !0;
                if ('AES-128' == y)
                  return shaka.log.warning('Unsupported HLS Encryption', y), (l.aesEncrypted_ = !0), J['return'](null);
                C = D.getRequiredAttrValue('KEYFORMAT');
                if ((F = (H = shaka.hls.HlsParser.KEYFORMATS_TO_DRM_PARSERS_[C]) ? H(D) : null)) {
                  if (F.keyIds)
                    for (E = $jscomp.makeIterator(F.keyIds), G = E.next(); !G.done; G = E.next())
                      (I = G.value), B.add(I);
                  x.push(F);
                } else shaka.log.warning('Unsupported HLS KEYFORMAT', C);
              }
            if (v && !x.length)
              throw new shaka.util.Error(
                shaka.util.Error.Severity.CRITICAL,
                shaka.util.Error.Category.MANIFEST,
                shaka.util.Error.Code.HLS_KEYFORMATS_NOT_SUPPORTED,
              );
            K = shaka.hls.Utils.filterTagsByName(p.tags, 'EXT-X-DEFINE');
            N = l.parseMediaVariables_(K);
            goog.asserts.assert(null != p.segments, 'Media playlist should have segments!');
            l.determinePresentationType_(p);
            return J.yield(l.guessMimeType_(c, b, p, N), 3);
          case 3:
            return (
              (O = J.yieldResult),
              shaka.hls.HlsParser.RAW_FORMATS_.includes(O) && (b = ''),
              (L = new Map()),
              J.setCatchFinallyBlocks(4),
              J.yield(l.createSegments_(a, p, c, O, L, N), 6)
            );
          case 6:
            M = J.yieldResult;
            J.leaveTryBlock(5);
            break;
          case 4:
            Q = J.enterCatchBlock();
            if (Q.code == shaka.util.Error.Code.HLS_INTERNAL_SKIP_STREAM)
              return shaka.log.alwaysWarn('Skipping unsupported HLS stream', O, a), J['return'](null);
            throw Q;
          case 5:
            T = M[0].startTime;
            U = M[M.length - 1].endTime;
            V = new shaka.media.SegmentIndex(M);
            W =
              c == shaka.util.ManifestParserUtils.ContentType.TEXT
                ? shaka.util.ManifestParserUtils.TextStreamKind.SUBTITLE
                : void 0;
            R = [];
            if (k)
              for (S = $jscomp.makeIterator(k.split(',')), P = S.next(); !P.done; P = S.next())
                (X = P.value), R.push(X);
            Y = {
              id: l.globalId_++,
              originalId: f,
              createSegmentIndex: function () {
                return Promise.resolve();
              },
              segmentIndex: V,
              mimeType: O,
              codecs: b,
              kind: W,
              encrypted: v,
              drmInfos: x,
              keyIds: B,
              language: d,
              label: f,
              type: c,
              primary: e,
              trickModeVideo: null,
              emsgSchemeIdUris: null,
              frameRate: void 0,
              pixelAspectRatio: void 0,
              width: void 0,
              height: void 0,
              bandwidth: void 0,
              roles: R,
              channelsCount: g,
              audioSamplingRate: null,
              closedCaptions: h,
            };
            return J['return']({
              stream: Y,
              verbatimMediaPlaylistUri: a,
              absoluteMediaPlaylistUri: m,
              minTimestamp: T,
              maxTimestamp: U,
              mediaSequenceToStartTime: L,
            });
        }
      });
    };
    shaka.hls.HlsParser.prototype.determinePresentationType_ = function (a) {
      var b = shaka.hls.HlsParser.PresentationType_,
        c = shaka.hls.Utils.getFirstTagWithName(a.tags, 'EXT-X-PLAYLIST-TYPE'),
        d = shaka.hls.Utils.getFirstTagWithName(a.tags, 'EXT-X-ENDLIST');
      d = (c && 'VOD' == c.value) || d;
      c = c && 'EVENT' == c.value && !d;
      c = !d && !c;
      d
        ? this.setPresentationType_(b.VOD)
        : (c ? this.setPresentationType_(b.LIVE) : this.setPresentationType_(b.EVENT),
          (a = this.getRequiredTag_(a.tags, 'EXT-X-TARGETDURATION')),
          (a = Number(a.value)),
          (this.maxTargetDuration_ = Math.max(a, this.maxTargetDuration_)),
          (this.minTargetDuration_ = Math.min(a, this.minTargetDuration_)));
    };
    shaka.hls.HlsParser.prototype.createPresentationTimeline_ = function () {
      this.isLive_()
        ? ((this.presentationTimeline_ = new shaka.media.PresentationTimeline(
            0,
            this.config_.defaultPresentationDelay || 3 * this.maxTargetDuration_,
          )),
          this.presentationTimeline_.setStatic(!1))
        : ((this.presentationTimeline_ = new shaka.media.PresentationTimeline(null, 0)),
          this.presentationTimeline_.setStatic(!0));
      this.notifySegments_();
      goog.asserts.assert(
        !this.presentationTimeline_.usingPresentationStartTime(),
        'We should not be using the presentation start time in HLS!',
      );
    };
    shaka.hls.HlsParser.prototype.getInitSegmentReference_ = function (a, b, c) {
      b = shaka.hls.Utils.getFirstTagWithName(b, 'EXT-X-MAP');
      if (!b) return null;
      var d = b.getRequiredAttrValue('URI');
      c = this.variableSubstitution_(shaka.hls.Utils.constructAbsoluteUri(a, d), c);
      a = [c, b.getAttributeValue('BYTERANGE', '')].join('-');
      this.mapTagToInitSegmentRefMap_.has(a) ||
        ((b = this.createInitSegmentReference_(c, b)), this.mapTagToInitSegmentRefMap_.set(a, b));
      return this.mapTagToInitSegmentRefMap_.get(a);
    };
    shaka.hls.HlsParser.prototype.createInitSegmentReference_ = function (a, b) {
      var c = 0,
        d = null,
        e = b.getAttributeValue('BYTERANGE');
      e && ((c = e.split('@')), (d = Number(c[0])), (c = Number(c[1])), (d = c + d - 1));
      return new shaka.media.InitSegmentReference(
        function () {
          return [a];
        },
        c,
        d,
      );
    };
    shaka.hls.HlsParser.prototype.createSegmentReference_ = function (a, b, c, d, e, f) {
      var g = c.tags,
        h = this.variableSubstitution_(c.absoluteUri, f);
      c = this.getRequiredTag_(g, 'EXTINF').value.split(',');
      c = d + Number(c[0]);
      f = 0;
      var k = null;
      if ((g = shaka.hls.Utils.getFirstTagWithName(g, 'EXT-X-BYTERANGE')))
        (f = g.value.split('@')),
          (g = Number(f[0])),
          f[1]
            ? (f = Number(f[1]))
            : (goog.asserts.assert(b, 'Cannot refer back to previous HLS segment!'), (f = b.endByte + 1)),
          (k = f + g - 1);
      return new shaka.media.SegmentReference(
        d,
        c,
        function () {
          return [h];
        },
        f,
        k,
        a,
        e,
        0,
        Infinity,
      );
    };
    shaka.hls.HlsParser.prototype.notifySegments_ = function () {
      if (this.presentationTimeline_) {
        for (var a = $jscomp.makeIterator(this.segmentsToNotifyByStream_), b = a.next(); !b.done; b = a.next())
          this.presentationTimeline_.notifySegments(b.value);
        this.segmentsToNotifyByStream_ = [];
      }
    };
    shaka.hls.HlsParser.prototype.createSegments_ = function (a, b, c, d, e, f) {
      var g = this,
        h,
        k,
        l,
        m,
        n,
        p,
        q,
        r,
        t,
        w,
        u,
        v,
        x,
        B,
        z,
        A,
        D,
        y,
        C,
        H,
        F;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (E) {
        switch (E.nextAddress) {
          case 1:
            h = b.segments;
            goog.asserts.assert(h.length, 'Playlist should have segments!');
            l = shaka.hls.Utils.getFirstTagWithNameAsNumber(b.tags, 'EXT-X-MEDIA-SEQUENCE', 0);
            if (g.isLive_() && e.has(l)) {
              m = e.get(l);
              E.jumpTo(2);
              break;
            }
            if (null != g.playlistStartTime_) {
              E.jumpTo(3);
              break;
            }
            k = g.getInitSegmentReference_(b.absoluteUri, h[0].tags, f);
            goog.asserts.assert(
              c != shaka.util.ManifestParserUtils.ContentType.TEXT,
              'Should only get start time from audio or video streams',
            );
            n = g;
            return E.yield(g.getStartTime_(a, k, d, l, !1, h[0], f), 4);
          case 4:
            n.playlistStartTime_ = E.yieldResult;
          case 3:
            m = g.playlistStartTime_;
          case 2:
            (p = h[0].absoluteUri),
              shaka.log.debug('First segment', p.split('/').pop(), 'starts at', m),
              (q = shaka.hls.Utils.getFirstTagWithNameAsNumber(b.tags, 'EXT-X-DISCONTINUITY-SEQUENCE')),
              (r = g.discontinuityToTso_.get(q) || 0),
              (t = []),
              (w = function (G) {
                return shaka.util.Iterables.enumerate(G);
              }),
              (u = $jscomp.makeIterator(w(h))),
              (v = u.next());
          case 5:
            if (v.done) {
              E.jumpTo(7);
              break;
            }
            B = x = v.value;
            z = B.i;
            A = B.item;
            D = t[t.length - 1];
            y = 0 == z ? m : D.endTime;
            C = l + z;
            e.set(C, y);
            k = g.getInitSegmentReference_(b.absoluteUri, A.tags, f);
            H = shaka.hls.Utils.getFirstTagWithName(A.tags, 'EXT-X-DISCONTINUITY');
            if (!H) {
              E.jumpTo(8);
              break;
            }
            q++;
            return E.yield(g.getTimestampOffset_(q, a, k, d, C, A, f, y), 9);
          case 9:
            r = E.yieldResult;
          case 8:
            F = g.createSegmentReference_(k, D, A, y, r, f);
            t.push(F);
            v = u.next();
            E.jumpTo(5);
            break;
          case 7:
            return g.segmentsToNotifyByStream_.push(t), g.notifySegments_(), E['return'](t);
        }
      });
    };
    shaka.hls.HlsParser.prototype.getTimestampOffset_ = function (a, b, c, d, e, f, g, h) {
      var k = this,
        l,
        m;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (n) {
        if (1 == n.nextAddress)
          return (
            (l = 0),
            k.discontinuityToTso_.has(a)
              ? ((l = k.discontinuityToTso_.get(a)), n.jumpTo(2))
              : n.yield(k.getStartTime_(b, c, d, e, !0, f, g), 3)
          );
        2 != n.nextAddress &&
          ((m = n.yieldResult),
          (l = h - m),
          shaka.log.v1('Segment timestampOffset =', l),
          k.discontinuityToTso_.set(a, l));
        return n['return'](l);
      });
    };
    shaka.hls.HlsParser.prototype.fetchStartOfSegment_ = function (a) {
      var b = this,
        c,
        d,
        e,
        f,
        g,
        h;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (k) {
        switch (k.nextAddress) {
          case 1:
            c = shaka.net.NetworkingEngine.RequestType.SEGMENT;
            d = shaka.util.Networking.createSegmentRequest(
              a.getUris(),
              a.startByte,
              a.endByte,
              b.config_.retryParameters,
            );
            if (b.config_.hls.useFullSegmentsForStartTime) return k['return'](b.makeNetworkRequest_(d, c));
            e = shaka.util.Networking.createSegmentRequest(
              a.getUris(),
              a.startByte,
              a.startByte + shaka.hls.HlsParser.START_OF_SEGMENT_SIZE_ - 1,
              b.config_.retryParameters,
            );
            k.setCatchFinallyBlocks(2);
            return k.yield(b.makeNetworkRequest_(e, c), 4);
          case 4:
            return (f = k.yieldResult), k['return'](f);
          case 2:
            g = k.enterCatchBlock();
            if (g.code == shaka.util.Error.Code.OPERATION_ABORTED) throw g;
            shaka.log.alwaysWarn(
              'Unable to fetch a partial HLS segment! Falling back to a full segment request, which is expensive!  Your server should support Range requests and CORS preflights.',
              e.uris[0],
            );
            return k.yield(b.makeNetworkRequest_(d, c), 5);
          case 5:
            return (h = k.yieldResult), k['return'](h);
        }
      });
    };
    shaka.hls.HlsParser.prototype.getStartTime_ = function (a, b, c, d, e, f, g) {
      var h = this,
        k,
        l,
        m,
        n,
        p,
        q,
        r,
        t;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (w) {
        switch (w.nextAddress) {
          case 1:
            k = h.createSegmentReference_(b, null, f, 0, 0, g);
            if (h.manifest_ && !e) {
              l = h.uriToStreamInfosMap_.get(a);
              m = l.mediaSequenceToStartTime.get(d);
              if (void 0 != m) return shaka.log.v1('Found segment start time in previous manifest', m), w['return'](m);
              shaka.log.debug('Unable to find segment start time in previous manifest!');
            }
            shaka.log.v1('Fetching segment to find start time');
            c = c.toLowerCase();
            if (shaka.hls.HlsParser.RAW_FORMATS_.includes(c))
              throw (
                (shaka.log.alwaysWarn('Raw formats are not yet supported.  Skipping ' + c),
                new shaka.util.Error(
                  shaka.util.Error.Severity.RECOVERABLE,
                  shaka.util.Error.Category.MANIFEST,
                  shaka.util.Error.Code.HLS_INTERNAL_SKIP_STREAM,
                ))
              );
            if ('video/webm' == c)
              throw (
                (shaka.log.alwaysWarn('WebM in HLS is not yet supported.  Skipping.'),
                new shaka.util.Error(
                  shaka.util.Error.Severity.RECOVERABLE,
                  shaka.util.Error.Category.MANIFEST,
                  shaka.util.Error.Code.HLS_INTERNAL_SKIP_STREAM,
                ))
              );
            if ('video/mp4' != c && 'audio/mp4' != c) {
              w.jumpTo(2);
              break;
            }
            n = [h.fetchStartOfSegment_(k)];
            b && n.push(h.fetchStartOfSegment_(b));
            return w.yield(Promise.all(n), 3);
          case 3:
            return (
              (p = w.yieldResult),
              (q = p[0]),
              (r = p[1] || p[0]),
              w['return'](h.getStartTimeFromMp4Segment_(a, q.uri, q.data, r.data))
            );
          case 2:
            if ('video/mp2t' != c) {
              w.jumpTo(4);
              break;
            }
            return w.yield(h.fetchStartOfSegment_(k), 5);
          case 5:
            return (
              (t = w.yieldResult),
              goog.asserts.assert(t.data, 'Should have a response body!'),
              w['return'](h.getStartTimeFromTsSegment_(a, t.uri, t.data))
            );
          case 4:
            throw new shaka.util.Error(
              shaka.util.Error.Severity.CRITICAL,
              shaka.util.Error.Category.MANIFEST,
              shaka.util.Error.Code.HLS_COULD_NOT_PARSE_SEGMENT_START_TIME,
              a,
            );
        }
      });
    };
    shaka.hls.HlsParser.prototype.getStartTimeFromMp4Segment_ = function (a, b, c, d) {
      var e = shaka.util.Mp4Parser,
        f = 0;
      new e()
        .box('moov', e.children)
        .box('trak', e.children)
        .box('mdia', e.children)
        .fullBox('mdhd', function (k) {
          goog.asserts.assert(0 == k.version || 1 == k.version, 'MDHD version can only be 0 or 1');
          k.reader.skip(0 == k.version ? 8 : 16);
          f = k.reader.readUint32();
          k.parser.stop();
        })
        .parse(d, !0);
      if (!f)
        throw (
          (shaka.log.error('Unable to find timescale in init segment!'),
          new shaka.util.Error(
            shaka.util.Error.Severity.CRITICAL,
            shaka.util.Error.Category.MANIFEST,
            shaka.util.Error.Code.HLS_COULD_NOT_PARSE_SEGMENT_START_TIME,
            a,
            b,
          ))
        );
      var g = 0,
        h = !1;
      new e()
        .box('moof', e.children)
        .box('traf', e.children)
        .fullBox('tfdt', function (k) {
          goog.asserts.assert(0 == k.version || 1 == k.version, 'TFDT version can only be 0 or 1');
          g = (0 == k.version ? k.reader.readUint32() : k.reader.readUint64()) / f;
          h = !0;
          k.parser.stop();
        })
        .parse(c, !0);
      if (!h)
        throw new shaka.util.Error(
          shaka.util.Error.Severity.CRITICAL,
          shaka.util.Error.Category.MANIFEST,
          shaka.util.Error.Code.HLS_COULD_NOT_PARSE_SEGMENT_START_TIME,
          a,
          b,
        );
      return g;
    };
    shaka.hls.HlsParser.prototype.getStartTimeFromTsSegment_ = function (a, b, c) {
      var d = new shaka.util.DataViewReader(c, shaka.util.DataViewReader.Endianness.BIG_ENDIAN),
        e = function () {
          throw new shaka.util.Error(
            shaka.util.Error.Severity.CRITICAL,
            shaka.util.Error.Category.MANIFEST,
            shaka.util.Error.Code.HLS_COULD_NOT_PARSE_SEGMENT_START_TIME,
            a,
            b,
          );
        },
        f = 0,
        g = 0;
      for (
        c = function () {
          d.seek(f + 188);
          g = d.readUint8();
          71 != g && (d.seek(f + 192), (g = d.readUint8()));
          71 != g && (d.seek(f + 204), (g = d.readUint8()));
          71 != g && e();
          d.rewind(1);
        };
        ;

      ) {
        f = d.getPosition();
        g = d.readUint8();
        71 != g && e();
        var h = d.readUint16();
        if (8191 == (h & 8191)) c();
        else if (h & 16384)
          if (
            ((h = (d.readUint8() & 48) >> 4),
            (0 != h && 2 != h) || e(),
            3 == h && ((h = d.readUint8()), d.skip(h)),
            1 != d.readUint32() >> 8)
          )
            c();
          else {
            d.skip(3);
            c = d.readUint8() >> 6;
            (0 != c && 1 != c) || e();
            h = d.readUint8();
            0 == h && e();
            2 == c
              ? goog.asserts.assert(5 == h, 'Bad PES header?')
              : 3 == c && goog.asserts.assert(10 == h, 'Bad PES header?');
            c = d.readUint8();
            h = d.readUint16();
            var k = d.readUint16();
            return (
              (1073741824 * ((c & 14) >> 1) + (((h & 65534) << 14) | ((k & 65534) >> 1))) /
              shaka.hls.HlsParser.TS_TIMESCALE_
            );
          }
        else c();
      }
    };
    shaka.hls.HlsParser.prototype.guessCodecs_ = function (a, b) {
      if (1 == b.length) return b[0];
      var c = this.guessCodecsSafe_(a, b);
      if (null != c) return c;
      throw new shaka.util.Error(
        shaka.util.Error.Severity.CRITICAL,
        shaka.util.Error.Category.MANIFEST,
        shaka.util.Error.Code.HLS_COULD_NOT_GUESS_CODECS,
        b,
      );
    };
    shaka.hls.HlsParser.prototype.guessCodecsSafe_ = function (a, b) {
      for (
        var c = $jscomp.makeIterator(shaka.hls.HlsParser.CODEC_REGEXPS_BY_CONTENT_TYPE_[a]), d = c.next();
        !d.done;
        d = c.next()
      ) {
        d = d.value;
        for (var e = $jscomp.makeIterator(b), f = e.next(); !f.done; f = e.next())
          if (((f = f.value), d.test(f.trim()))) return f.trim();
      }
      return a == shaka.util.ManifestParserUtils.ContentType.TEXT ? '' : null;
    };
    shaka.hls.HlsParser.prototype.variableSubstitution_ = function (a, b) {
      var c = String(a).replace(/%7B/g, '{').replace(/%7D/g, '}'),
        d = c.match(/{\$\w*}/g);
      if (d) {
        d = $jscomp.makeIterator(d);
        for (var e = d.next(); !e.done; e = d.next()) {
          e = e.value;
          var f = e.slice(2, e.length - 1),
            g = b.get(f);
          if (g) c = c.replace(e, g);
          else
            throw (
              (shaka.log.error('A variable has been found that is not declared', f),
              new shaka.util.Error(
                shaka.util.Error.Severity.CRITICAL,
                shaka.util.Error.Category.MANIFEST,
                shaka.util.Error.Code.HLS_VARIABLE_NOT_FOUND,
                f,
              ))
            );
        }
      }
      return c;
    };
    shaka.hls.HlsParser.prototype.guessMimeType_ = function (a, b, c, d) {
      var e = this,
        f,
        g,
        h,
        k,
        l,
        m,
        n,
        p,
        q,
        r,
        t;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (w) {
        if (1 == w.nextAddress) {
          f = shaka.hls.HlsParser;
          g = shaka.util.ManifestParserUtils.ContentType;
          h = shaka.net.NetworkingEngine.RequestType.SEGMENT;
          goog.asserts.assert(c.segments.length, 'Playlist should have segments!');
          k = e.variableSubstitution_(c.segments[0].absoluteUri, d);
          l = new goog.Uri(k);
          m = l.getPath().split('.').pop();
          n = f.EXTENSION_MAP_BY_CONTENT_TYPE_[a];
          if ((p = n[m])) return w['return'](p);
          if (a == g.TEXT)
            return b && 'vtt' != b && 'wvtt' != b ? w['return']('application/mp4') : w['return']('text/vtt');
          q = shaka.net.NetworkingEngine.makeRequest([k], e.config_.retryParameters);
          q.method = 'HEAD';
          return w.yield(e.makeNetworkRequest_(q, h), 2);
        }
        r = w.yieldResult;
        t = r.headers['content-type'];
        if (!t)
          throw new shaka.util.Error(
            shaka.util.Error.Severity.CRITICAL,
            shaka.util.Error.Category.MANIFEST,
            shaka.util.Error.Code.HLS_COULD_NOT_GUESS_MIME_TYPE,
            m,
          );
        return w['return'](t.split(';')[0]);
      });
    };
    shaka.hls.HlsParser.prototype.getRequiredTag_ = function (a, b) {
      var c = shaka.hls.Utils.getFirstTagWithName(a, b);
      if (!c)
        throw new shaka.util.Error(
          shaka.util.Error.Severity.CRITICAL,
          shaka.util.Error.Category.MANIFEST,
          shaka.util.Error.Code.HLS_REQUIRED_TAG_MISSING,
          b,
        );
      return c;
    };
    shaka.hls.HlsParser.prototype.addVideoAttributes_ = function (a, b, c, d) {
      a && ((a.width = Number(b) || void 0), (a.height = Number(c) || void 0), (a.frameRate = Number(d) || void 0));
    };
    shaka.hls.HlsParser.prototype.requestManifest_ = function (a) {
      var b = shaka.net.NetworkingEngine.RequestType.MANIFEST;
      a = shaka.net.NetworkingEngine.makeRequest([a], this.config_.retryParameters);
      return this.makeNetworkRequest_(a, b);
    };
    shaka.hls.HlsParser.prototype.onUpdate_ = function () {
      var a = this,
        b,
        c;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (d) {
        if (1 == d.nextAddress) {
          shaka.log.info('Updating manifest...');
          goog.asserts.assert(
            0 < a.updatePlaylistDelay_,
            'We should only call |onUpdate_| when we are suppose to be updating.',
          );
          if (!a.playerInterface_) return d['return']();
          d.setCatchFinallyBlocks(2);
          return d.yield(a.update(), 4);
        }
        if (2 != d.nextAddress)
          return (b = a.updatePlaylistDelay_), a.updatePlaylistTimer_.tickAfter(b), d.leaveTryBlock(0);
        c = d.enterCatchBlock();
        if (!a.playerInterface_) return d['return']();
        goog.asserts.assert(c instanceof shaka.util.Error, 'Should only receive a Shaka error');
        c.severity = shaka.util.Error.Severity.RECOVERABLE;
        a.playerInterface_.onError(c);
        a.updatePlaylistTimer_.tickAfter(0.1);
        d.jumpToEnd();
      });
    };
    shaka.hls.HlsParser.prototype.isLive_ = function () {
      return this.presentationType_ != shaka.hls.HlsParser.PresentationType_.VOD;
    };
    shaka.hls.HlsParser.prototype.setPresentationType_ = function (a) {
      this.presentationType_ = a;
      this.presentationTimeline_ && this.presentationTimeline_.setStatic(!this.isLive_());
      this.isLive_() || this.updatePlaylistTimer_.stop();
    };
    shaka.hls.HlsParser.prototype.makeNetworkRequest_ = function (a, b) {
      if (!this.operationManager_)
        throw new shaka.util.Error(
          shaka.util.Error.Severity.CRITICAL,
          shaka.util.Error.Category.PLAYER,
          shaka.util.Error.Code.OPERATION_ABORTED,
        );
      var c = this.playerInterface_.networkingEngine.request(b, a);
      this.operationManager_.manage(c);
      return c.promise;
    };
    shaka.hls.HlsParser.widevineDrmParser_ = function (a) {
      var b = a.getRequiredAttrValue('METHOD'),
        c = ['SAMPLE-AES', 'SAMPLE-AES-CTR'];
      if (!c.includes(b))
        return shaka.log.error('Widevine in HLS is only supported with [', c.join(', '), '], not', b), null;
      b = a.getRequiredAttrValue('URI');
      b = shaka.net.DataUriPlugin.parseRaw(b);
      b = shaka.util.BufferUtils.toUint8(b.data);
      b = shaka.util.ManifestParserUtils.createDrmInfo('com.widevine.alpha', [{ initDataType: 'cenc', initData: b }]);
      if ((a = a.getAttributeValue('KEYID')))
        (a = a.toLowerCase()),
          goog.asserts.assert(a.startsWith('0x'), 'Incorrect KEYID format!'),
          (b.keyIds = new Set([a.substr(2)]));
      return b;
    };
    goog.exportSymbol('shaka.hls.HlsParser', shaka.hls.HlsParser);
    shaka.hls.HlsParser.VIDEO_CODEC_REGEXPS_ = [/^avc/, /^hev/, /^hvc/, /^vp0?[89]/, /^av1$/];
    shaka.hls.HlsParser.AUDIO_CODEC_REGEXPS_ = [/^vorbis$/, /^opus$/, /^flac$/, /^mp4a/, /^[ae]c-3$/];
    shaka.hls.HlsParser.TEXT_CODEC_REGEXPS_ = [/^vtt$/, /^wvtt/, /^stpp/];
    shaka.hls.HlsParser.CODEC_REGEXPS_BY_CONTENT_TYPE_ = {
      audio: shaka.hls.HlsParser.AUDIO_CODEC_REGEXPS_,
      video: shaka.hls.HlsParser.VIDEO_CODEC_REGEXPS_,
      text: shaka.hls.HlsParser.TEXT_CODEC_REGEXPS_,
    };
    shaka.hls.HlsParser.AUDIO_EXTENSIONS_TO_MIME_TYPES_ = {
      mp4: 'audio/mp4',
      mp4a: 'audio/mp4',
      m4s: 'audio/mp4',
      m4i: 'audio/mp4',
      m4a: 'audio/mp4',
      cmfa: 'audio/mp4',
      ts: 'video/mp2t',
      aac: 'audio/aac',
      ac3: 'audio/ac3',
      ec3: 'audio/ec3',
      mp3: 'audio/mpeg',
    };
    shaka.hls.HlsParser.RAW_FORMATS_ = ['audio/aac', 'audio/ac3', 'audio/ec3', 'audio/mpeg'];
    shaka.hls.HlsParser.VIDEO_EXTENSIONS_TO_MIME_TYPES_ = {
      mp4: 'video/mp4',
      mp4v: 'video/mp4',
      m4s: 'video/mp4',
      m4i: 'video/mp4',
      m4v: 'video/mp4',
      cmfv: 'video/mp4',
      ts: 'video/mp2t',
    };
    shaka.hls.HlsParser.TEXT_EXTENSIONS_TO_MIME_TYPES_ = {
      mp4: 'application/mp4',
      m4s: 'application/mp4',
      m4i: 'application/mp4',
      cmft: 'application/mp4',
      vtt: 'text/vtt',
      ttml: 'application/ttml+xml',
    };
    shaka.hls.HlsParser.EXTENSION_MAP_BY_CONTENT_TYPE_ = {
      audio: shaka.hls.HlsParser.AUDIO_EXTENSIONS_TO_MIME_TYPES_,
      video: shaka.hls.HlsParser.VIDEO_EXTENSIONS_TO_MIME_TYPES_,
      text: shaka.hls.HlsParser.TEXT_EXTENSIONS_TO_MIME_TYPES_,
    };
    shaka.hls.HlsParser.KEYFORMATS_TO_DRM_PARSERS_ = {
      'urn:uuid:edef8ba9-79d6-4ace-a3c8-27dcd51d21ed': shaka.hls.HlsParser.widevineDrmParser_,
    };
    shaka.hls.HlsParser.PresentationType_ = { VOD: 'VOD', EVENT: 'EVENT', LIVE: 'LIVE' };
    shaka.hls.HlsParser.TS_TIMESCALE_ = 9e4;
    shaka.hls.HlsParser.START_OF_SEGMENT_SIZE_ = 2048;
    shaka.media.ManifestParser.registerParserByExtension('m3u8', function () {
      return new shaka.hls.HlsParser();
    });
    shaka.media.ManifestParser.registerParserByMime('application/x-mpegurl', function () {
      return new shaka.hls.HlsParser();
    });
    shaka.media.ManifestParser.registerParserByMime('application/vnd.apple.mpegurl', function () {
      return new shaka.hls.HlsParser();
    });
    shaka.net.HttpPluginUtils = function () {};
    shaka.net.HttpPluginUtils.makeResponse = function (a, b, c, d, e, f) {
      if (200 <= c && 299 >= c && 202 != c)
        return { uri: e || d, originalUri: d, data: b, headers: a, fromCache: !!a['x-shaka-from-cache'] };
      e = null;
      try {
        e = shaka.util.StringUtils.fromBytesAutoDetect(b);
      } catch (g) {}
      shaka.log.debug('HTTP error text:', e);
      throw new shaka.util.Error(
        401 == c || 403 == c ? shaka.util.Error.Severity.CRITICAL : shaka.util.Error.Severity.RECOVERABLE,
        shaka.util.Error.Category.NETWORK,
        shaka.util.Error.Code.BAD_HTTP_STATUS,
        d,
        c,
        e,
        a,
        f,
      );
    };
    shaka.net.HttpFetchPlugin = function () {};
    shaka.net.HttpFetchPlugin.parse = function (a, b, c, d) {
      var e = new shaka.net.HttpFetchPlugin.Headers_();
      shaka.util.MapUtils.asMap(b.headers).forEach(function (k, l) {
        e.append(l, k);
      });
      var f = new shaka.net.HttpFetchPlugin.AbortController_(),
        g = { canceled: !1, timedOut: !1 };
      a = shaka.net.HttpFetchPlugin.request_(
        a,
        c,
        {
          body: b.body || void 0,
          headers: e,
          method: b.method,
          signal: f.signal,
          credentials: b.allowCrossSiteCredentials ? 'include' : void 0,
        },
        g,
        d,
      );
      a = new shaka.util.AbortableOperation(a, function () {
        g.canceled = !0;
        f.abort();
        return Promise.resolve();
      });
      if ((b = b.retryParameters.timeout)) {
        var h = new shaka.util.Timer(function () {
          g.timedOut = !0;
          f.abort();
        });
        h.tickAfter(b / 1e3);
        a['finally'](function () {
          h.stop();
        });
      }
      return a;
    };
    shaka.net.HttpFetchPlugin.request_ = function (a, b, c, d, e) {
      var f, g, h, k, l, m, n, p, q, r, t, w, u, v;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (x) {
        switch (x.nextAddress) {
          case 1:
            return (
              (f = shaka.net.HttpFetchPlugin.fetch_),
              (g = shaka.net.HttpFetchPlugin.ReadableStream_),
              (m = l = 0),
              (n = Date.now()),
              x.setCatchFinallyBlocks(2),
              x.yield(f(a, c), 4)
            );
          case 4:
            return (
              (h = x.yieldResult),
              (p = h.clone().body.getReader()),
              (r = (q = h.headers.get('Content-Length')) ? parseInt(q, 10) : 0),
              (t = function (B) {
                var z = function () {
                  var A, D, y;
                  return $jscomp.asyncExecutePromiseGeneratorProgram(function (C) {
                    switch (C.nextAddress) {
                      case 1:
                        return C.setCatchFinallyBlocks(2), C.yield(p.read(), 4);
                      case 4:
                        A = C.yieldResult;
                        C.leaveTryBlock(3);
                        break;
                      case 2:
                        return (
                          (D = C.enterCatchBlock()), shaka.log.v1('error reading from stream', D.message), C['return']()
                        );
                      case 3:
                        A.done || (l += A.value.byteLength);
                        y = Date.now();
                        if (100 < y - n || A.done) e(y - n, l - m, r - l), (m = l), (n = y);
                        A.done
                          ? (goog.asserts.assert(!A.value, 'readObj should be unset when "done" is true.'), B.close())
                          : (B.enqueue(A.value), z());
                        C.jumpToEnd();
                    }
                  });
                };
                z();
              }),
              new g({ start: t }),
              x.yield(h.arrayBuffer(), 5)
            );
          case 5:
            k = x.yieldResult;
            x.leaveTryBlock(3);
            break;
          case 2:
            w = x.enterCatchBlock();
            if (d.canceled)
              throw new shaka.util.Error(
                shaka.util.Error.Severity.RECOVERABLE,
                shaka.util.Error.Category.NETWORK,
                shaka.util.Error.Code.OPERATION_ABORTED,
                a,
                b,
              );
            if (d.timedOut)
              throw new shaka.util.Error(
                shaka.util.Error.Severity.RECOVERABLE,
                shaka.util.Error.Category.NETWORK,
                shaka.util.Error.Code.TIMEOUT,
                a,
                b,
              );
            throw new shaka.util.Error(
              shaka.util.Error.Severity.RECOVERABLE,
              shaka.util.Error.Category.NETWORK,
              shaka.util.Error.Code.HTTP_ERROR,
              a,
              w,
              b,
            );
          case 3:
            return (
              (u = {}),
              (v = h.headers),
              v.forEach(function (B, z) {
                u[z.trim()] = B;
              }),
              x['return'](shaka.net.HttpPluginUtils.makeResponse(u, k, h.status, a, h.url, b))
            );
        }
      });
    };
    shaka.net.HttpFetchPlugin.isSupported = function () {
      if (window.ReadableStream)
        try {
          new ReadableStream({});
        } catch (a) {
          return !1;
        }
      else return !1;
      return !(!window.fetch || !window.AbortController);
    };
    goog.exportSymbol('shaka.net.HttpFetchPlugin', shaka.net.HttpFetchPlugin);
    goog.exportProperty(shaka.net.HttpFetchPlugin, 'isSupported', shaka.net.HttpFetchPlugin.isSupported);
    goog.exportProperty(shaka.net.HttpFetchPlugin, 'parse', shaka.net.HttpFetchPlugin.parse);
    shaka.net.HttpFetchPlugin.fetch_ = window.fetch;
    shaka.net.HttpFetchPlugin.AbortController_ = window.AbortController;
    shaka.net.HttpFetchPlugin.ReadableStream_ = window.ReadableStream;
    shaka.net.HttpFetchPlugin.Headers_ = window.Headers;
    shaka.net.HttpFetchPlugin.isSupported() &&
      (shaka.net.NetworkingEngine.registerScheme(
        'http',
        shaka.net.HttpFetchPlugin.parse,
        shaka.net.NetworkingEngine.PluginPriority.PREFERRED,
      ),
      shaka.net.NetworkingEngine.registerScheme(
        'https',
        shaka.net.HttpFetchPlugin.parse,
        shaka.net.NetworkingEngine.PluginPriority.PREFERRED,
      ));
    shaka.net.HttpXHRPlugin = function () {};
    shaka.net.HttpXHRPlugin.parse = function (a, b, c, d) {
      var e = new shaka.net.HttpXHRPlugin.Xhr_(),
        f = Date.now(),
        g = 0,
        h = new Promise(function (k, l) {
          e.open(b.method, a, !0);
          e.responseType = 'arraybuffer';
          e.timeout = b.retryParameters.timeout;
          e.withCredentials = b.allowCrossSiteCredentials;
          e.onabort = function () {
            l(
              new shaka.util.Error(
                shaka.util.Error.Severity.RECOVERABLE,
                shaka.util.Error.Category.NETWORK,
                shaka.util.Error.Code.OPERATION_ABORTED,
                a,
                c,
              ),
            );
          };
          e.onload = function (p) {
            p = p.target;
            goog.asserts.assert(p, 'XHR onload has no target!');
            var q = p.getAllResponseHeaders().trim().split('\r\n'),
              r = {};
            q = $jscomp.makeIterator(q);
            for (var t = q.next(); !t.done; t = q.next())
              (t = t.value.split(': ')), (r[t[0].toLowerCase()] = t.slice(1).join(': '));
            try {
              var w = shaka.net.HttpPluginUtils.makeResponse(r, p.response, p.status, a, p.responseURL, c);
              k(w);
            } catch (u) {
              goog.asserts.assert(u instanceof shaka.util.Error, 'Wrong error type!'), l(u);
            }
          };
          e.onerror = function (p) {
            l(
              new shaka.util.Error(
                shaka.util.Error.Severity.RECOVERABLE,
                shaka.util.Error.Category.NETWORK,
                shaka.util.Error.Code.HTTP_ERROR,
                a,
                p,
                c,
              ),
            );
          };
          e.ontimeout = function (p) {
            l(
              new shaka.util.Error(
                shaka.util.Error.Severity.RECOVERABLE,
                shaka.util.Error.Category.NETWORK,
                shaka.util.Error.Code.TIMEOUT,
                a,
                c,
              ),
            );
          };
          e.onprogress = function (p) {
            var q = Date.now();
            if (100 < q - f || (p.lengthComputable && p.loaded == p.total))
              d(q - f, p.loaded - g, p.total - p.loaded), (g = p.loaded), (f = q);
          };
          for (var m in b.headers) {
            var n = m.toLowerCase();
            e.setRequestHeader(n, b.headers[m]);
          }
          e.send(b.body);
        });
      return new shaka.util.AbortableOperation(h, function () {
        e.abort();
        return Promise.resolve();
      });
    };
    goog.exportSymbol('shaka.net.HttpXHRPlugin', shaka.net.HttpXHRPlugin);
    goog.exportProperty(shaka.net.HttpXHRPlugin, 'parse', shaka.net.HttpXHRPlugin.parse);
    shaka.net.HttpXHRPlugin.Xhr_ = window.XMLHttpRequest;
    shaka.net.NetworkingEngine.registerScheme(
      'http',
      shaka.net.HttpXHRPlugin.parse,
      shaka.net.NetworkingEngine.PluginPriority.FALLBACK,
    );
    shaka.net.NetworkingEngine.registerScheme(
      'https',
      shaka.net.HttpXHRPlugin.parse,
      shaka.net.NetworkingEngine.PluginPriority.FALLBACK,
    );
    shaka.offline = {};
    shaka.offline.DownloadProgressEstimator = function () {
      this.actualDownloaded_ = this.estimatedDownloaded_ = this.estimatedTotal_ = 0;
      this.pending_ = new Map();
      this.nextId_ = 0;
    };
    shaka.offline.DownloadProgressEstimator.prototype.open = function (a) {
      this.estimatedTotal_ += a;
      var b = this.nextId_;
      this.nextId_++;
      this.pending_.set(b, a);
      return b;
    };
    shaka.offline.DownloadProgressEstimator.prototype.close = function (a, b) {
      if (this.pending_.has(a)) {
        var c = this.pending_.get(a);
        this.pending_['delete'](a);
        this.estimatedDownloaded_ += c;
        this.actualDownloaded_ += b;
      }
    };
    shaka.offline.DownloadProgressEstimator.prototype.getEstimatedProgress = function () {
      return 0 == this.estimatedTotal_ ? 0 : this.estimatedDownloaded_ / this.estimatedTotal_;
    };
    shaka.offline.DownloadProgressEstimator.prototype.getTotalDownloaded = function () {
      return this.actualDownloaded_;
    };
    shaka.offline.DownloadManager = function (a) {
      var b = this;
      this.networkingEngine_ = a;
      this.groups_ = new Map();
      this.destroyer_ = new shaka.util.Destroyer(function () {
        var c = Array.from(b.groups_.values());
        return Promise.all(
          c.map(function (d) {
            return d['catch'](function () {});
          }),
        );
      });
      this.abortCallbacks_ = [];
      this.onProgress_ = function (c, d) {};
      this.onInitData_ = function (c, d) {};
      this.estimator_ = new shaka.offline.DownloadProgressEstimator();
    };
    shaka.offline.DownloadManager.prototype.destroy = function () {
      return this.destroyer_.destroy();
    };
    shaka.offline.DownloadManager.prototype.setCallbacks = function (a, b) {
      this.onProgress_ = a;
      this.onInitData_ = b;
    };
    shaka.offline.DownloadManager.prototype.abortAll = function () {
      var a = this.abortCallbacks_.map(function (b) {
        return b();
      });
      this.abortCallbacks_ = [];
      return Promise.all(a);
    };
    shaka.offline.DownloadManager.prototype.queue = function (a, b, c, d, e) {
      var f = this;
      this.destroyer_.ensureNotDestroyed();
      var g = this.estimator_.open(c);
      c = (this.groups_.get(a) || Promise.resolve()).then(function () {
        var h, k, l, m, n, p, q;
        return $jscomp.asyncExecutePromiseGeneratorProgram(function (r) {
          if (1 == r.nextAddress) return r.yield(f.fetchSegment_(b), 2);
          h = r.yieldResult;
          if (f.destroyer_.destroyed())
            throw new shaka.util.Error(
              shaka.util.Error.Severity.CRITICAL,
              shaka.util.Error.Category.STORAGE,
              shaka.util.Error.Code.OPERATION_ABORTED,
            );
          if (d)
            for (m in ((k = shaka.util.BufferUtils.toUint8(h)), (l = new shaka.util.Pssh(k)), l.data))
              (n = Number(m)), (p = l.data[n]), (q = l.systemIds[n]), f.onInitData_(p, q);
          f.estimator_.close(g, h.byteLength);
          f.onProgress_(f.estimator_.getEstimatedProgress(), f.estimator_.getTotalDownloaded());
          return r['return'](e(h));
        });
      });
      this.groups_.set(a, c);
      return c;
    };
    shaka.offline.DownloadManager.prototype.queueWork = function (a, b) {
      this.destroyer_.ensureNotDestroyed();
      var c = (this.groups_.get(a) || Promise.resolve()).then(function () {
        return $jscomp.asyncExecutePromiseGeneratorProgram(function (d) {
          return d.yield(b(), 0);
        });
      });
      this.groups_.set(a, c);
      return c;
    };
    shaka.offline.DownloadManager.prototype.waitToFinish = function () {
      var a = this;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (b) {
        return 1 == b.nextAddress
          ? b.yield(Promise.all(a.groups_.values()), 2)
          : b['return'](a.estimator_.getTotalDownloaded());
      });
    };
    shaka.offline.DownloadManager.prototype.fetchSegment_ = function (a) {
      var b = this,
        c,
        d,
        e,
        f;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (g) {
        if (1 == g.nextAddress)
          return (
            (c = shaka.net.NetworkingEngine.RequestType.SEGMENT),
            (d = b.networkingEngine_.request(c, a)),
            (e = function () {
              return d.abort();
            }),
            b.abortCallbacks_.push(e),
            g.yield(d.promise, 2)
          );
        f = g.yieldResult;
        shaka.util.ArrayUtils.remove(b.abortCallbacks_, e);
        return g['return'](f.data);
      });
    };
    shaka.offline.indexeddb = {};
    shaka.offline.indexeddb.DBOperation = function (a, b) {
      var c = this;
      this.transaction_ = a;
      this.store_ = a.objectStore(b);
      this.promise_ = new shaka.util.PublicPromise();
      a.onabort = function (d) {
        d.preventDefault();
        c.promise_.reject();
      };
      a.onerror = function (d) {
        d.preventDefault();
        c.promise_.reject();
      };
      a.oncomplete = function (d) {
        c.promise_.resolve();
      };
    };
    shaka.offline.indexeddb.DBOperation.prototype.abort = function () {
      var a = this;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (b) {
        if (1 == b.nextAddress) {
          try {
            a.transaction_.abort();
          } catch (c) {}
          b.setCatchFinallyBlocks(2);
          return b.yield(a.promise_, 4);
        }
        if (2 != b.nextAddress) return b.leaveTryBlock(0);
        b.enterCatchBlock();
        b.jumpToEnd();
      });
    };
    shaka.offline.indexeddb.DBOperation.prototype.forEachEntry = function (a) {
      var b = this;
      return new Promise(function (c, d) {
        var e = b.store_.openCursor();
        e.onerror = d;
        e.onsuccess = function (f) {
          var g;
          return $jscomp.asyncExecutePromiseGeneratorProgram(function (h) {
            if (1 == h.nextAddress) {
              if (null == e.result) return c(), h['return']();
              g = e.result;
              return h.yield(a(g.key, g.value, g), 2);
            }
            g['continue']();
            h.jumpToEnd();
          });
        };
      });
    };
    shaka.offline.indexeddb.DBOperation.prototype.store = function () {
      return this.store_;
    };
    shaka.offline.indexeddb.DBOperation.prototype.promise = function () {
      return this.promise_;
    };
    shaka.offline.indexeddb.DBConnection = function (a) {
      this.connection_ = a;
      this.pending_ = [];
    };
    shaka.offline.indexeddb.DBConnection.prototype.destroy = function () {
      return Promise.all(
        this.pending_.map(function (a) {
          return a.abort();
        }),
      );
    };
    shaka.offline.indexeddb.DBConnection.prototype.startReadOnlyOperation = function (a) {
      return this.startOperation_(a, 'readonly');
    };
    shaka.offline.indexeddb.DBConnection.prototype.startReadWriteOperation = function (a) {
      return this.startOperation_(a, 'readwrite');
    };
    shaka.offline.indexeddb.DBConnection.prototype.startOperation_ = function (a, b) {
      var c = this,
        d = this.connection_.transaction([a], b),
        e = new shaka.offline.indexeddb.DBOperation(d, a);
      this.pending_.push(e);
      e.promise().then(
        function () {
          return c.stopTracking_(e);
        },
        function () {
          return c.stopTracking_(e);
        },
      );
      return e;
    };
    shaka.offline.indexeddb.DBConnection.prototype.stopTracking_ = function (a) {
      shaka.util.ArrayUtils.remove(this.pending_, a);
    };
    shaka.offline.indexeddb.BaseStorageCell = function (a, b, c) {
      this.connection_ = new shaka.offline.indexeddb.DBConnection(a);
      this.segmentStore_ = b;
      this.manifestStore_ = c;
    };
    shaka.offline.indexeddb.BaseStorageCell.prototype.destroy = function () {
      return this.connection_.destroy();
    };
    shaka.offline.indexeddb.BaseStorageCell.prototype.hasFixedKeySpace = function () {
      return !0;
    };
    shaka.offline.indexeddb.BaseStorageCell.prototype.addSegments = function (a) {
      return this.rejectAdd(this.segmentStore_);
    };
    shaka.offline.indexeddb.BaseStorageCell.prototype.removeSegments = function (a, b) {
      return this.remove_(this.segmentStore_, a, b);
    };
    shaka.offline.indexeddb.BaseStorageCell.prototype.getSegments = function (a) {
      var b = this,
        c;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (d) {
        if (1 == d.nextAddress) return d.yield(b.get_(b.segmentStore_, a), 2);
        c = d.yieldResult;
        return d['return'](
          c.map(function (e) {
            return b.convertSegmentData(e);
          }),
        );
      });
    };
    shaka.offline.indexeddb.BaseStorageCell.prototype.addManifests = function (a) {
      return this.rejectAdd(this.manifestStore_);
    };
    shaka.offline.indexeddb.BaseStorageCell.prototype.updateManifestExpiration = function (a, b) {
      var c = this.connection_.startReadWriteOperation(this.manifestStore_),
        d = c.store();
      d.get(a).onsuccess = function (e) {
        if ((e = e.target.result)) (e.expiration = b), d.put(e, a);
      };
      return c.promise();
    };
    shaka.offline.indexeddb.BaseStorageCell.prototype.removeManifests = function (a, b) {
      return this.remove_(this.manifestStore_, a, b);
    };
    shaka.offline.indexeddb.BaseStorageCell.prototype.getManifests = function (a) {
      var b = this,
        c;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (d) {
        if (1 == d.nextAddress) return d.yield(b.get_(b.manifestStore_, a), 2);
        c = d.yieldResult;
        return d['return'](
          Promise.all(
            c.map(function (e) {
              return b.convertManifest(e);
            }),
          ),
        );
      });
    };
    shaka.offline.indexeddb.BaseStorageCell.prototype.getAllManifests = function () {
      var a = this,
        b,
        c;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (d) {
        return 1 == d.nextAddress
          ? ((b = a.connection_.startReadOnlyOperation(a.manifestStore_)),
            (c = new Map()),
            d.yield(
              b.forEachEntry(function (e, f) {
                var g;
                return $jscomp.asyncExecutePromiseGeneratorProgram(function (h) {
                  if (1 == h.nextAddress) return h.yield(a.convertManifest(f), 2);
                  g = h.yieldResult;
                  c.set(e, g);
                  h.jumpToEnd();
                });
              }),
              2,
            ))
          : 3 != d.nextAddress
          ? d.yield(b.promise(), 3)
          : d['return'](c);
      });
    };
    shaka.offline.indexeddb.BaseStorageCell.prototype.convertSegmentData = function (a) {
      return a;
    };
    shaka.offline.indexeddb.BaseStorageCell.prototype.convertManifest = function (a) {
      return Promise.resolve(a);
    };
    shaka.offline.indexeddb.BaseStorageCell.prototype.rejectAdd = function (a) {
      return Promise.reject(
        new shaka.util.Error(
          shaka.util.Error.Severity.CRITICAL,
          shaka.util.Error.Category.STORAGE,
          shaka.util.Error.Code.NEW_KEY_OPERATION_NOT_SUPPORTED,
          'Cannot add new value to ' + a,
        ),
      );
    };
    shaka.offline.indexeddb.BaseStorageCell.prototype.add = function (a, b) {
      var c = this,
        d,
        e,
        f,
        g,
        h,
        k,
        l;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (m) {
        if (1 == m.nextAddress) {
          d = c.connection_.startReadWriteOperation(a);
          e = d.store();
          f = [];
          g = {};
          h = $jscomp.makeIterator(b);
          for (
            k = h.next();
            !k.done;
            g = { $jscomp$loop$prop$request$548: g.$jscomp$loop$prop$request$548 }, k = h.next()
          )
            (l = k.value),
              (g.$jscomp$loop$prop$request$548 = e.add(l)),
              (g.$jscomp$loop$prop$request$548.onsuccess = (function (n) {
                return function (p) {
                  f.push(n.$jscomp$loop$prop$request$548.result);
                };
              })(g));
          return m.yield(d.promise(), 2);
        }
        return m['return'](f);
      });
    };
    shaka.offline.indexeddb.BaseStorageCell.prototype.remove_ = function (a, b, c) {
      a = this.connection_.startReadWriteOperation(a);
      var d = a.store(),
        e = {};
      b = $jscomp.makeIterator(b);
      for (var f = b.next(); !f.done; e = { $jscomp$loop$prop$key$550: e.$jscomp$loop$prop$key$550 }, f = b.next())
        (e.$jscomp$loop$prop$key$550 = f.value),
          (d['delete'](e.$jscomp$loop$prop$key$550).onsuccess = (function (g) {
            return function () {
              return c(g.$jscomp$loop$prop$key$550);
            };
          })(e));
      return a.promise();
    };
    shaka.offline.indexeddb.BaseStorageCell.prototype.get_ = function (a, b) {
      var c = this,
        d,
        e,
        f,
        g,
        h,
        k,
        l;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (m) {
        if (1 == m.nextAddress) {
          d = c.connection_.startReadOnlyOperation(a);
          e = d.store();
          f = {};
          g = [];
          h = {};
          k = $jscomp.makeIterator(b);
          for (
            l = k.next();
            !l.done;
            h = {
              $jscomp$loop$prop$request$552: h.$jscomp$loop$prop$request$552,
              $jscomp$loop$prop$key$553: h.$jscomp$loop$prop$key$553,
            },
              l = k.next()
          )
            (h.$jscomp$loop$prop$key$553 = l.value),
              (h.$jscomp$loop$prop$request$552 = e.get(h.$jscomp$loop$prop$key$553)),
              (h.$jscomp$loop$prop$request$552.onsuccess = (function (n) {
                return function () {
                  void 0 == n.$jscomp$loop$prop$request$552.result && g.push(n.$jscomp$loop$prop$key$553);
                  f[n.$jscomp$loop$prop$key$553] = n.$jscomp$loop$prop$request$552.result;
                };
              })(h));
          return m.yield(d.promise(), 2);
        }
        if (g.length)
          throw new shaka.util.Error(
            shaka.util.Error.Severity.CRITICAL,
            shaka.util.Error.Category.STORAGE,
            shaka.util.Error.Code.KEY_NOT_FOUND,
            'Could not find values for ' + g,
          );
        return m['return'](
          b.map(function (n) {
            return f[n];
          }),
        );
      });
    };
    shaka.offline.indexeddb.EmeSessionStorageCell = function (a, b) {
      this.connection_ = new shaka.offline.indexeddb.DBConnection(a);
      this.store_ = b;
    };
    shaka.offline.indexeddb.EmeSessionStorageCell.prototype.destroy = function () {
      return this.connection_.destroy();
    };
    shaka.offline.indexeddb.EmeSessionStorageCell.prototype.getAll = function () {
      var a = this,
        b,
        c;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (d) {
        return 1 == d.nextAddress
          ? ((b = a.connection_.startReadOnlyOperation(a.store_)),
            (c = []),
            d.yield(
              b.forEachEntry(function (e, f) {
                c.push(f);
              }),
              2,
            ))
          : 3 != d.nextAddress
          ? d.yield(b.promise(), 3)
          : d['return'](c);
      });
    };
    shaka.offline.indexeddb.EmeSessionStorageCell.prototype.add = function (a) {
      var b = this.connection_.startReadWriteOperation(this.store_),
        c = b.store();
      a = $jscomp.makeIterator(a);
      for (var d = a.next(); !d.done; d = a.next()) c.add(d.value);
      return b.promise();
    };
    shaka.offline.indexeddb.EmeSessionStorageCell.prototype.remove = function (a) {
      var b = this,
        c;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (d) {
        return 1 == d.nextAddress
          ? ((c = b.connection_.startReadWriteOperation(b.store_)),
            d.yield(
              c.forEachEntry(function (e, f, g) {
                a.includes(f.sessionId) && g['delete']();
              }),
              2,
            ))
          : d.yield(c.promise(), 0);
      });
    };
    shaka.offline.StorageMuxer = function () {
      this.mechanisms_ = new Map();
    };
    shaka.offline.StorageMuxer.prototype.destroy = function () {
      for (var a = [], b = $jscomp.makeIterator(this.mechanisms_.values()), c = b.next(); !c.done; c = b.next())
        a.push(c.value.destroy());
      this.mechanisms_.clear();
      return Promise.all(a);
    };
    shaka.offline.StorageMuxer.prototype.init = function () {
      var a = this;
      shaka.offline.StorageMuxer.getRegistry_().forEach(function (e, f) {
        var g = e();
        g ? a.mechanisms_.set(f, g) : shaka.log.info('Skipping ' + f + ' as it is not supported on this platform');
      });
      for (var b = [], c = $jscomp.makeIterator(this.mechanisms_.values()), d = c.next(); !d.done; d = c.next())
        b.push(d.value.init());
      return Promise.all(b);
    };
    shaka.offline.StorageMuxer.prototype.getActive = function () {
      var a = null;
      this.mechanisms_.forEach(function (b, c) {
        b.getCells().forEach(function (d, e) {
          d.hasFixedKeySpace() || a || (a = { path: { mechanism: c, cell: e }, cell: d });
        });
      });
      if (a) return a;
      throw new shaka.util.Error(
        shaka.util.Error.Severity.CRITICAL,
        shaka.util.Error.Category.STORAGE,
        shaka.util.Error.Code.MISSING_STORAGE_CELL,
        'Could not find a cell that supports add-operations',
      );
    };
    shaka.offline.StorageMuxer.prototype.forEachCell = function (a) {
      this.mechanisms_.forEach(function (b, c) {
        b.getCells().forEach(function (d, e) {
          a({ mechanism: c, cell: e }, d);
        });
      });
    };
    shaka.offline.StorageMuxer.prototype.getCell = function (a, b) {
      var c = this.mechanisms_.get(a);
      if (!c)
        throw new shaka.util.Error(
          shaka.util.Error.Severity.CRITICAL,
          shaka.util.Error.Category.STORAGE,
          shaka.util.Error.Code.MISSING_STORAGE_CELL,
          'Could not find mechanism with name ' + a,
        );
      c = c.getCells().get(b);
      if (!c)
        throw new shaka.util.Error(
          shaka.util.Error.Severity.CRITICAL,
          shaka.util.Error.Category.STORAGE,
          shaka.util.Error.Code.MISSING_STORAGE_CELL,
          'Could not find cell with name ' + b,
        );
      return c;
    };
    shaka.offline.StorageMuxer.prototype.forEachEmeSessionCell = function (a) {
      this.mechanisms_.forEach(function (b, c) {
        a(b.getEmeSessionCell());
      });
    };
    shaka.offline.StorageMuxer.prototype.getEmeSessionCell = function () {
      var a = Array.from(this.mechanisms_.keys());
      if (!a.length)
        throw new shaka.util.Error(
          shaka.util.Error.Severity.CRITICAL,
          shaka.util.Error.Category.STORAGE,
          shaka.util.Error.Code.STORAGE_NOT_SUPPORTED,
          'No supported storage mechanisms found',
        );
      return this.mechanisms_.get(a[0]).getEmeSessionCell();
    };
    shaka.offline.StorageMuxer.prototype.resolvePath = function (a) {
      var b = this.mechanisms_.get(a.mechanism);
      return b ? b.getCells().get(a.cell) : null;
    };
    shaka.offline.StorageMuxer.prototype.erase = function () {
      var a = this,
        b,
        c,
        d;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (e) {
        return 1 == e.nextAddress
          ? ((b = Array.from(a.mechanisms_.values())),
            (c = 0 < b.length),
            c ||
              ((d = shaka.offline.StorageMuxer.getRegistry_()),
              d.forEach(function (f, g) {
                var h = f();
                h && b.push(h);
              })),
            e.yield(
              Promise.all(
                b.map(function (f) {
                  return f.erase();
                }),
              ),
              2,
            ))
          : c
          ? e.jumpTo(0)
          : e.yield(
              Promise.all(
                b.map(function (f) {
                  return f.destroy();
                }),
              ),
              0,
            );
      });
    };
    shaka.offline.StorageMuxer.register = function (a, b) {
      shaka.offline.StorageMuxer.registry_.set(a, b);
    };
    shaka.offline.StorageMuxer.unregister = function (a) {
      shaka.offline.StorageMuxer.registry_['delete'](a);
    };
    shaka.offline.StorageMuxer.support = function () {
      var a = shaka.offline.StorageMuxer.getRegistry_();
      a = $jscomp.makeIterator(a.values());
      for (var b = a.next(); !b.done; b = a.next()) if (((b = b.value), (b = b()))) return b.destroy(), !0;
      return !1;
    };
    shaka.offline.StorageMuxer.overrideSupport = function (a) {
      shaka.offline.StorageMuxer.override_ = a;
    };
    shaka.offline.StorageMuxer.clearOverride = function () {
      shaka.offline.StorageMuxer.override_ = null;
    };
    shaka.offline.StorageMuxer.getRegistry_ = function () {
      var a = shaka.offline.StorageMuxer.override_,
        b = shaka.offline.StorageMuxer.registry_;
      return COMPILED ? b : a || b;
    };
    goog.exportSymbol('shaka.offline.StorageMuxer', shaka.offline.StorageMuxer);
    goog.exportProperty(shaka.offline.StorageMuxer, 'unregister', shaka.offline.StorageMuxer.unregister);
    goog.exportProperty(shaka.offline.StorageMuxer, 'register', shaka.offline.StorageMuxer.register);
    goog.exportProperty(shaka.offline.StorageMuxer.prototype, 'destroy', shaka.offline.StorageMuxer.prototype.destroy);
    shaka.offline.StorageMuxer.override_ = null;
    shaka.offline.StorageMuxer.registry_ = new Map();
    shaka.offline.indexeddb.V1StorageCell = function () {
      shaka.offline.indexeddb.BaseStorageCell.apply(this, arguments);
    };
    $jscomp.inherits(shaka.offline.indexeddb.V1StorageCell, shaka.offline.indexeddb.BaseStorageCell);
    shaka.offline.indexeddb.V1StorageCell.prototype.updateManifestExpiration = function (a, b) {
      var c = this,
        d,
        e,
        f;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (g) {
        d = c.connection_.startReadWriteOperation(c.manifestStore_);
        e = d.store();
        f = new shaka.util.PublicPromise();
        e.get(a).onsuccess = function (h) {
          (h = h.target.result)
            ? (goog.asserts.assert(h.key == a, 'With in-line keys, the keys should match'),
              (h.expiration = b),
              e.put(h),
              f.resolve())
            : f.reject(
                new shaka.util.Error(
                  shaka.util.Error.Severity.CRITICAL,
                  shaka.util.Error.Category.STORAGE,
                  shaka.util.Error.Code.KEY_NOT_FOUND,
                  'Could not find values for ' + a,
                ),
              );
        };
        return g.yield(Promise.all([d.promise(), f]), 0);
      });
    };
    shaka.offline.indexeddb.V1StorageCell.prototype.convertManifest = function (a) {
      var b, c, d, e, f, g, h;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (k) {
        if (1 == k.nextAddress) {
          b = shaka.offline.indexeddb.V1StorageCell;
          c = [];
          for (d = 0; d < a.periods.length; ++d)
            (e = d == a.periods.length - 1 ? a.duration : a.periods[d + 1].startTime),
              (f = e - a.periods[d].startTime),
              (g = b.convertPeriod_(a.periods[d], f)),
              c.push(g);
          return k.yield(shaka.util.PeriodCombiner.combineDbStreams(c), 2);
        }
        h = k.yieldResult;
        return k['return']({
          creationTime: 0,
          originalManifestUri: a.originalManifestUri,
          duration: a.duration,
          size: a.size,
          expiration: null == a.expiration ? Infinity : a.expiration,
          streams: h,
          sessionIds: a.sessionIds,
          drmInfo: a.drmInfo,
          appMetadata: a.appMetadata,
        });
      });
    };
    shaka.offline.indexeddb.V1StorageCell.convertPeriod_ = function (a, b) {
      var c = shaka.offline.indexeddb.V1StorageCell;
      c.fillMissingVariants_(a);
      for (var d = $jscomp.makeIterator(a.streams), e = d.next(); !e.done; e = d.next())
        goog.asserts.assert(
          e.value.variantIds,
          'After filling in missing variants, each stream should have variant ids',
        );
      return a.streams.map(function (f) {
        return c.convertStream_(f, a.startTime, b);
      });
    };
    shaka.offline.indexeddb.V1StorageCell.convertStream_ = function (a, b, c) {
      var d = shaka.offline.indexeddb.V1StorageCell,
        e = a.initSegmentUri ? d.getKeyFromSegmentUri_(a.initSegmentUri) : null,
        f = b + a.presentationTimeOffset,
        g = b + c;
      return {
        id: a.id,
        originalId: null,
        primary: a.primary,
        type: a.contentType,
        mimeType: a.mimeType,
        codecs: a.codecs,
        frameRate: a.frameRate,
        pixelAspectRatio: void 0,
        kind: a.kind,
        language: a.language,
        label: a.label,
        width: a.width,
        height: a.height,
        initSegmentKey: e,
        encrypted: a.encrypted,
        keyIds: new Set([a.keyId]),
        segments: a.segments.map(function (h) {
          return d.convertSegment_(h, e, b, g, f);
        }),
        variantIds: a.variantIds,
        roles: [],
        audioSamplingRate: null,
        channelsCount: null,
        closedCaptions: null,
      };
    };
    shaka.offline.indexeddb.V1StorageCell.convertSegment_ = function (a, b, c, d, e) {
      var f = shaka.offline.indexeddb.V1StorageCell.getKeyFromSegmentUri_(a.uri);
      return {
        startTime: c + a.startTime,
        endTime: c + a.endTime,
        dataKey: f,
        initSegmentKey: b,
        appendWindowStart: c,
        appendWindowEnd: d,
        timestampOffset: e,
      };
    };
    shaka.offline.indexeddb.V1StorageCell.prototype.convertSegmentData = function (a) {
      return { data: a.data };
    };
    shaka.offline.indexeddb.V1StorageCell.getKeyFromSegmentUri_ = function (a) {
      var b;
      if ((b = /^offline:[0-9]+\/[0-9]+\/([0-9]+)$/.exec(a)) || (b = /^offline:segment\/([0-9]+)$/.exec(a)))
        return Number(b[1]);
      throw new shaka.util.Error(
        shaka.util.Error.Severity.CRITICAL,
        shaka.util.Error.Category.STORAGE,
        shaka.util.Error.Code.MALFORMED_OFFLINE_URI,
        'Could not parse uri ' + a,
      );
    };
    shaka.offline.indexeddb.V1StorageCell.fillMissingVariants_ = function (a) {
      var b = shaka.util.ManifestParserUtils.ContentType.AUDIO,
        c = shaka.util.ManifestParserUtils.ContentType.VIDEO,
        d = a.streams.filter(function (l) {
          return l.contentType == b;
        });
      a = a.streams.filter(function (l) {
        return l.contentType == c;
      });
      if (
        !d.every(function (l) {
          return l.variantIds;
        }) ||
        !a.every(function (l) {
          return l.variantIds;
        })
      ) {
        goog.asserts.assert(
          d.every(function (l) {
            return !l.variantIds;
          }),
          'Some audio streams have variant ids and some do not.',
        );
        goog.asserts.assert(
          a.every(function (l) {
            return !l.variantIds;
          }),
          'Some video streams have variant ids and some do not.',
        );
        for (var e = $jscomp.makeIterator(d), f = e.next(); !f.done; f = e.next()) f.value.variantIds = [];
        e = $jscomp.makeIterator(a);
        for (f = e.next(); !f.done; f = e.next()) f.value.variantIds = [];
        e = 0;
        if (a.length && !d.length) {
          shaka.log.debug('Found video-only content. Creating variants for video.');
          var g = e++,
            h = $jscomp.makeIterator(a);
          for (f = h.next(); !f.done; f = h.next()) f.value.variantIds.push(g);
        }
        if (!a.length && d.length)
          for (
            shaka.log.debug('Found audio-only content. Creating variants for audio.'),
              g = e++,
              h = $jscomp.makeIterator(d),
              f = h.next();
            !f.done;
            f = h.next()
          )
            f.value.variantIds.push(g);
        if (a.length && d.length)
          for (
            shaka.log.debug('Found audio-video content. Creating variants.'), d = $jscomp.makeIterator(d), f = d.next();
            !f.done;
            f = d.next()
          )
            for (f = f.value, g = $jscomp.makeIterator(a), h = g.next(); !h.done; h = g.next()) {
              h = h.value;
              var k = e++;
              f.variantIds.push(k);
              h.variantIds.push(k);
            }
      }
    };
    shaka.offline.indexeddb.V2StorageCell = function () {
      shaka.offline.indexeddb.BaseStorageCell.apply(this, arguments);
    };
    $jscomp.inherits(shaka.offline.indexeddb.V2StorageCell, shaka.offline.indexeddb.BaseStorageCell);
    shaka.offline.indexeddb.V2StorageCell.prototype.convertManifest = function (a) {
      var b = this,
        c,
        d,
        e,
        f,
        g,
        h;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (k) {
        if (1 == k.nextAddress) {
          c = [];
          for (d = 0; d < a.periods.length; ++d)
            (e = d == a.periods.length - 1 ? a.duration : a.periods[d + 1].startTime),
              (f = e - a.periods[d].startTime),
              (g = b.convertPeriod_(a.periods[d], f)),
              c.push(g);
          return k.yield(shaka.util.PeriodCombiner.combineDbStreams(c), 2);
        }
        h = k.yieldResult;
        return k['return']({
          appMetadata: a.appMetadata,
          creationTime: 0,
          drmInfo: a.drmInfo,
          duration: a.duration,
          expiration: null == a.expiration ? Infinity : a.expiration,
          originalManifestUri: a.originalManifestUri,
          sessionIds: a.sessionIds,
          size: a.size,
          streams: h,
        });
      });
    };
    shaka.offline.indexeddb.V2StorageCell.prototype.convertPeriod_ = function (a, b) {
      for (var c = [], d = $jscomp.makeIterator(a.streams), e = d.next(); !e.done; e = d.next())
        (e = e.value), 0 != e.variantIds.length && c.push(this.convertStream_(e, a.startTime, a.startTime + b));
      return c;
    };
    shaka.offline.indexeddb.V2StorageCell.prototype.convertStream_ = function (a, b, c) {
      var d = this;
      return {
        id: a.id,
        originalId: a.originalId,
        primary: a.primary,
        type: a.contentType,
        mimeType: a.mimeType,
        codecs: a.codecs,
        frameRate: a.frameRate,
        pixelAspectRatio: a.pixelAspectRatio,
        kind: a.kind,
        language: a.language,
        label: a.label,
        width: a.width,
        height: a.height,
        encrypted: a.encrypted,
        keyIds: new Set([a.keyId]),
        segments: a.segments.map(function (e) {
          return d.convertSegment_(e, a.initSegmentKey, b, c, a.presentationTimeOffset);
        }),
        variantIds: a.variantIds,
        roles: [],
        audioSamplingRate: null,
        channelsCount: null,
        closedCaptions: null,
      };
    };
    shaka.offline.indexeddb.V2StorageCell.prototype.convertSegment_ = function (a, b, c, d, e) {
      return {
        startTime: c + a.startTime,
        endTime: c + a.endTime,
        initSegmentKey: b,
        appendWindowStart: c,
        appendWindowEnd: d,
        timestampOffset: c - e,
        dataKey: a.dataKey,
      };
    };
    shaka.offline.indexeddb.V5StorageCell = function () {
      shaka.offline.indexeddb.BaseStorageCell.apply(this, arguments);
    };
    $jscomp.inherits(shaka.offline.indexeddb.V5StorageCell, shaka.offline.indexeddb.BaseStorageCell);
    shaka.offline.indexeddb.V5StorageCell.prototype.hasFixedKeySpace = function () {
      return !1;
    };
    shaka.offline.indexeddb.V5StorageCell.prototype.addSegments = function (a) {
      return this.add(this.segmentStore_, a);
    };
    shaka.offline.indexeddb.V5StorageCell.prototype.addManifests = function (a) {
      return this.add(this.manifestStore_, a);
    };
    shaka.offline.indexeddb.V5StorageCell.prototype.convertManifest = function (a) {
      null == a.expiration && (a.expiration = Infinity);
      return Promise.resolve(a);
    };
    shaka.offline.indexeddb.StorageMechanism = function () {
      this.sessions_ = this.v5_ = this.v3_ = this.v2_ = this.v1_ = this.db_ = null;
    };
    shaka.offline.indexeddb.StorageMechanism.prototype.init = function () {
      var a = this,
        b = shaka.offline.indexeddb.StorageMechanism.DB_NAME,
        c = shaka.offline.indexeddb.StorageMechanism.VERSION,
        d = new shaka.util.PublicPromise(),
        e = window.indexedDB.open(b, c);
      e.onsuccess = function (f) {
        f = e.result;
        a.db_ = f;
        a.v1_ = shaka.offline.indexeddb.StorageMechanism.createV1_(f);
        a.v2_ = shaka.offline.indexeddb.StorageMechanism.createV2_(f);
        a.v3_ = shaka.offline.indexeddb.StorageMechanism.createV3_(f);
        a.v5_ = shaka.offline.indexeddb.StorageMechanism.createV5_(f);
        a.sessions_ = shaka.offline.indexeddb.StorageMechanism.createEmeSessionCell_(f);
        d.resolve();
      };
      e.onupgradeneeded = function (f) {
        a.createStores_(e.result);
      };
      e.onerror = function (f) {
        d.reject(
          new shaka.util.Error(
            shaka.util.Error.Severity.CRITICAL,
            shaka.util.Error.Category.STORAGE,
            shaka.util.Error.Code.INDEXED_DB_ERROR,
            e.error,
          ),
        );
        f.preventDefault();
      };
      return d;
    };
    shaka.offline.indexeddb.StorageMechanism.prototype.destroy = function () {
      var a = this;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (b) {
        switch (b.nextAddress) {
          case 1:
            if (!a.v1_) {
              b.jumpTo(2);
              break;
            }
            return b.yield(a.v1_.destroy(), 2);
          case 2:
            if (!a.v2_) {
              b.jumpTo(4);
              break;
            }
            return b.yield(a.v2_.destroy(), 4);
          case 4:
            if (!a.v3_) {
              b.jumpTo(6);
              break;
            }
            return b.yield(a.v3_.destroy(), 6);
          case 6:
            if (!a.v5_) {
              b.jumpTo(8);
              break;
            }
            return b.yield(a.v5_.destroy(), 8);
          case 8:
            if (!a.sessions_) {
              b.jumpTo(10);
              break;
            }
            return b.yield(a.sessions_.destroy(), 10);
          case 10:
            a.db_ && a.db_.close(), b.jumpToEnd();
        }
      });
    };
    shaka.offline.indexeddb.StorageMechanism.prototype.getCells = function () {
      var a = new Map();
      this.v1_ && a.set('v1', this.v1_);
      this.v2_ && a.set('v2', this.v2_);
      this.v3_ && a.set('v3', this.v3_);
      this.v5_ && a.set('v5', this.v5_);
      return a;
    };
    shaka.offline.indexeddb.StorageMechanism.prototype.getEmeSessionCell = function () {
      goog.asserts.assert(this.sessions_, 'Cannot be destroyed.');
      return this.sessions_;
    };
    shaka.offline.indexeddb.StorageMechanism.prototype.erase = function () {
      var a = this;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (b) {
        switch (b.nextAddress) {
          case 1:
            if (!a.v1_) {
              b.jumpTo(2);
              break;
            }
            return b.yield(a.v1_.destroy(), 2);
          case 2:
            if (!a.v2_) {
              b.jumpTo(4);
              break;
            }
            return b.yield(a.v2_.destroy(), 4);
          case 4:
            if (!a.v3_) {
              b.jumpTo(6);
              break;
            }
            return b.yield(a.v3_.destroy(), 6);
          case 6:
            if (!a.v5_) {
              b.jumpTo(8);
              break;
            }
            return b.yield(a.v5_.destroy(), 8);
          case 8:
            return a.db_ && a.db_.close(), b.yield(shaka.offline.indexeddb.StorageMechanism.deleteAll_(), 10);
          case 10:
            return (a.db_ = null), (a.v1_ = null), (a.v2_ = null), (a.v3_ = null), (a.v5_ = null), b.yield(a.init(), 0);
        }
      });
    };
    shaka.offline.indexeddb.StorageMechanism.createV1_ = function (a) {
      var b = shaka.offline.indexeddb.StorageMechanism,
        c = b.V1_SEGMENT_STORE;
      b = b.V1_MANIFEST_STORE;
      var d = a.objectStoreNames;
      return d.contains(b) && d.contains(c)
        ? (shaka.log.debug('Mounting v1 idb storage cell'), new shaka.offline.indexeddb.V1StorageCell(a, c, b))
        : null;
    };
    shaka.offline.indexeddb.StorageMechanism.createV2_ = function (a) {
      var b = shaka.offline.indexeddb.StorageMechanism,
        c = b.V2_SEGMENT_STORE;
      b = b.V2_MANIFEST_STORE;
      var d = a.objectStoreNames;
      return d.contains(b) && d.contains(c)
        ? (shaka.log.debug('Mounting v2 idb storage cell'), new shaka.offline.indexeddb.V2StorageCell(a, c, b))
        : null;
    };
    shaka.offline.indexeddb.StorageMechanism.createV3_ = function (a) {
      var b = shaka.offline.indexeddb.StorageMechanism,
        c = b.V3_SEGMENT_STORE;
      b = b.V3_MANIFEST_STORE;
      var d = a.objectStoreNames;
      return d.contains(b) && d.contains(c)
        ? (shaka.log.debug('Mounting v3 idb storage cell'), new shaka.offline.indexeddb.V2StorageCell(a, c, b))
        : null;
    };
    shaka.offline.indexeddb.StorageMechanism.createV5_ = function (a) {
      var b = shaka.offline.indexeddb.StorageMechanism,
        c = b.V5_SEGMENT_STORE;
      b = b.V5_MANIFEST_STORE;
      var d = a.objectStoreNames;
      return d.contains(b) && d.contains(c)
        ? (shaka.log.debug('Mounting v5 idb storage cell'), new shaka.offline.indexeddb.V5StorageCell(a, c, b))
        : null;
    };
    shaka.offline.indexeddb.StorageMechanism.createEmeSessionCell_ = function (a) {
      var b = shaka.offline.indexeddb.StorageMechanism.SESSION_ID_STORE;
      return a.objectStoreNames.contains(b)
        ? (shaka.log.debug('Mounting session ID idb storage cell'),
          new shaka.offline.indexeddb.EmeSessionStorageCell(a, b))
        : null;
    };
    shaka.offline.indexeddb.StorageMechanism.prototype.createStores_ = function (a) {
      for (
        var b = $jscomp.makeIterator([
            shaka.offline.indexeddb.StorageMechanism.V5_SEGMENT_STORE,
            shaka.offline.indexeddb.StorageMechanism.V5_MANIFEST_STORE,
            shaka.offline.indexeddb.StorageMechanism.SESSION_ID_STORE,
          ]),
          c = b.next();
        !c.done;
        c = b.next()
      )
        (c = c.value), a.objectStoreNames.contains(c) || a.createObjectStore(c, { autoIncrement: !0 });
    };
    shaka.offline.indexeddb.StorageMechanism.deleteAll_ = function () {
      var a = shaka.offline.indexeddb.StorageMechanism.DB_NAME,
        b = new shaka.util.PublicPromise(),
        c = window.indexedDB.deleteDatabase(a);
      c.onblocked = function (d) {
        shaka.log.warning('Deleting', a, 'is being blocked');
      };
      c.onsuccess = function (d) {
        b.resolve();
      };
      c.onerror = function (d) {
        b.reject(
          new shaka.util.Error(
            shaka.util.Error.Severity.CRITICAL,
            shaka.util.Error.Category.STORAGE,
            shaka.util.Error.Code.INDEXED_DB_ERROR,
            c.error,
          ),
        );
        d.preventDefault();
      };
      return b;
    };
    shaka.offline.indexeddb.StorageMechanism.DB_NAME = 'shaka_offline_db';
    shaka.offline.indexeddb.StorageMechanism.VERSION = 5;
    shaka.offline.indexeddb.StorageMechanism.V1_SEGMENT_STORE = 'segment';
    shaka.offline.indexeddb.StorageMechanism.V2_SEGMENT_STORE = 'segment-v2';
    shaka.offline.indexeddb.StorageMechanism.V3_SEGMENT_STORE = 'segment-v3';
    shaka.offline.indexeddb.StorageMechanism.V5_SEGMENT_STORE = 'segment-v5';
    shaka.offline.indexeddb.StorageMechanism.V1_MANIFEST_STORE = 'manifest';
    shaka.offline.indexeddb.StorageMechanism.V2_MANIFEST_STORE = 'manifest-v2';
    shaka.offline.indexeddb.StorageMechanism.V3_MANIFEST_STORE = 'manifest-v3';
    shaka.offline.indexeddb.StorageMechanism.V5_MANIFEST_STORE = 'manifest-v5';
    shaka.offline.indexeddb.StorageMechanism.SESSION_ID_STORE = 'session-ids';
    shaka.offline.StorageMuxer.register('idb', function () {
      return shaka.util.Platform.isChromecast() || !window.indexedDB
        ? null
        : new shaka.offline.indexeddb.StorageMechanism();
    });
    shaka.offline.OfflineUri = function (a, b, c, d) {
      this.type_ = a;
      this.mechanism_ = b;
      this.cell_ = c;
      this.key_ = d;
      this.asString_ = ['offline:', a, '/', b, '/', c, '/', d].join('');
    };
    shaka.offline.OfflineUri.prototype.isManifest = function () {
      return 'manifest' == this.type_;
    };
    shaka.offline.OfflineUri.prototype.isSegment = function () {
      return 'segment' == this.type_;
    };
    shaka.offline.OfflineUri.prototype.mechanism = function () {
      return this.mechanism_;
    };
    shaka.offline.OfflineUri.prototype.cell = function () {
      return this.cell_;
    };
    shaka.offline.OfflineUri.prototype.key = function () {
      return this.key_;
    };
    shaka.offline.OfflineUri.prototype.toString = function () {
      return this.asString_;
    };
    shaka.offline.OfflineUri.parse = function (a) {
      a = /^offline:([a-z]+)\/([^/]+)\/([^/]+)\/([0-9]+)$/.exec(a);
      if (null == a) return null;
      var b = a[1];
      if ('manifest' != b && 'segment' != b) return null;
      var c = a[2];
      if (!c) return null;
      var d = a[3];
      return d && null != b ? new shaka.offline.OfflineUri(b, c, d, Number(a[4])) : null;
    };
    shaka.offline.OfflineUri.manifest = function (a, b, c) {
      return new shaka.offline.OfflineUri('manifest', a, b, c);
    };
    shaka.offline.OfflineUri.segment = function (a, b, c) {
      return new shaka.offline.OfflineUri('segment', a, b, c);
    };
    shaka.offline.ManifestConverter = function (a, b) {
      this.mechanism_ = a;
      this.cell_ = b;
    };
    shaka.offline.ManifestConverter.prototype.fromManifestDB = function (a) {
      var b = this,
        c = new shaka.media.PresentationTimeline(null, 0);
      c.setDuration(a.duration);
      var d = a.streams.filter(function (k) {
          return b.isAudio_(k);
        }),
        e = a.streams.filter(function (k) {
          return b.isVideo_(k);
        });
      d = this.createVariants(d, e, c);
      e = a.streams
        .filter(function (k) {
          return b.isText_(k);
        })
        .map(function (k) {
          return b.fromStreamDB_(k, c);
        });
      var f = a.drmInfo ? [a.drmInfo] : [];
      if (a.drmInfo)
        for (var g = $jscomp.makeIterator(d.values()), h = g.next(); !h.done; h = g.next())
          (h = h.value),
            h.audio && h.audio.encrypted && (h.audio.drmInfos = f),
            h.video && h.video.encrypted && (h.video.drmInfos = f);
      return {
        presentationTimeline: c,
        minBufferTime: 2,
        offlineSessionIds: a.sessionIds,
        variants: Array.from(d.values()),
        textStreams: e,
      };
    };
    shaka.offline.ManifestConverter.prototype.createVariants = function (a, b, c) {
      for (var d = new Set(), e = $jscomp.makeIterator(a), f = e.next(); !f.done; f = e.next()) {
        var g = $jscomp.makeIterator(f.value.variantIds);
        for (f = g.next(); !f.done; f = g.next()) d.add(f.value);
      }
      e = $jscomp.makeIterator(b);
      for (f = e.next(); !f.done; f = e.next())
        for (g = $jscomp.makeIterator(f.value.variantIds), f = g.next(); !f.done; f = g.next()) d.add(f.value);
      e = new Map();
      d = $jscomp.makeIterator(d);
      for (f = d.next(); !f.done; f = d.next()) (f = f.value), e.set(f, this.createEmptyVariant_(f));
      a = $jscomp.makeIterator(a);
      for (d = a.next(); !d.done; d = a.next())
        for (
          d = d.value, f = this.fromStreamDB_(d, c), g = $jscomp.makeIterator(d.variantIds), d = g.next();
          !d.done;
          d = g.next()
        )
          (d = e.get(d.value)),
            goog.asserts.assert(!d.audio, 'A variant should only have one audio stream'),
            (d.language = f.language),
            (d.primary = d.primary || f.primary),
            (d.audio = f);
      b = $jscomp.makeIterator(b);
      for (a = b.next(); !a.done; a = b.next())
        for (
          d = a.value, a = this.fromStreamDB_(d, c), f = $jscomp.makeIterator(d.variantIds), d = f.next();
          !d.done;
          d = f.next()
        )
          (d = e.get(d.value)),
            goog.asserts.assert(!d.video, 'A variant should only have one video stream'),
            (d.primary = d.primary || a.primary),
            (d.video = a);
      return e;
    };
    shaka.offline.ManifestConverter.prototype.fromStreamDB_ = function (a, b) {
      var c = this,
        d = a.segments.map(function (e, f) {
          return c.fromSegmentDB_(f, e);
        });
      b.notifySegments(d);
      d = new shaka.media.SegmentIndex(d);
      return {
        id: a.id,
        originalId: a.originalId,
        createSegmentIndex: function () {
          return Promise.resolve();
        },
        segmentIndex: d,
        mimeType: a.mimeType,
        codecs: a.codecs,
        width: a.width || void 0,
        height: a.height || void 0,
        frameRate: a.frameRate,
        pixelAspectRatio: a.pixelAspectRatio,
        kind: a.kind,
        encrypted: a.encrypted,
        drmInfos: [],
        keyIds: a.keyIds,
        language: a.language,
        label: a.label,
        type: a.type,
        primary: a.primary,
        trickModeVideo: null,
        emsgSchemeIdUris: null,
        roles: a.roles,
        channelsCount: a.channelsCount,
        audioSamplingRate: a.audioSamplingRate,
        closedCaptions: a.closedCaptions,
      };
    };
    shaka.offline.ManifestConverter.prototype.fromSegmentDB_ = function (a, b) {
      var c = shaka.offline.OfflineUri.segment(this.mechanism_, this.cell_, b.dataKey),
        d = null != b.initSegmentKey ? this.fromInitSegmentDB_(b.initSegmentKey) : null;
      return new shaka.media.SegmentReference(
        b.startTime,
        b.endTime,
        function () {
          return [c.toString()];
        },
        0,
        null,
        d,
        b.timestampOffset,
        b.appendWindowStart,
        b.appendWindowEnd,
      );
    };
    shaka.offline.ManifestConverter.prototype.fromInitSegmentDB_ = function (a) {
      var b = shaka.offline.OfflineUri.segment(this.mechanism_, this.cell_, a);
      return new shaka.media.InitSegmentReference(
        function () {
          return [b.toString()];
        },
        0,
        null,
      );
    };
    shaka.offline.ManifestConverter.prototype.isAudio_ = function (a) {
      return a.type == shaka.util.ManifestParserUtils.ContentType.AUDIO;
    };
    shaka.offline.ManifestConverter.prototype.isVideo_ = function (a) {
      return a.type == shaka.util.ManifestParserUtils.ContentType.VIDEO;
    };
    shaka.offline.ManifestConverter.prototype.isText_ = function (a) {
      return a.type == shaka.util.ManifestParserUtils.ContentType.TEXT;
    };
    shaka.offline.ManifestConverter.prototype.createEmptyVariant_ = function (a) {
      return {
        id: a,
        language: '',
        primary: !1,
        audio: null,
        video: null,
        bandwidth: 0,
        allowedByApplication: !0,
        allowedByKeySystem: !0,
      };
    };
    shaka.offline.OfflineManifestParser = function () {
      this.uri_ = null;
    };
    shaka.offline.OfflineManifestParser.prototype.configure = function (a) {};
    shaka.offline.OfflineManifestParser.prototype.start = function (a, b) {
      var c = this,
        d,
        e,
        f,
        g,
        h,
        k,
        l;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (m) {
        switch (m.nextAddress) {
          case 1:
            d = shaka.offline.OfflineUri.parse(a);
            c.uri_ = d;
            if (null == d || !d.isManifest())
              throw new shaka.util.Error(
                shaka.util.Error.Severity.CRITICAL,
                shaka.util.Error.Category.NETWORK,
                shaka.util.Error.Code.MALFORMED_OFFLINE_URI,
                a,
              );
            e = new shaka.offline.StorageMuxer();
            m.setFinallyBlock(2);
            return m.yield(e.init(), 4);
          case 4:
            return m.yield(e.getCell(d.mechanism(), d.cell()), 5);
          case 5:
            return (f = m.yieldResult), m.yield(f.getManifests([d.key()]), 6);
          case 6:
            return (
              (g = m.yieldResult),
              (h = g[0]),
              (k = new shaka.offline.ManifestConverter(d.mechanism(), d.cell())),
              (l = k.fromManifestDB(h)),
              b.makeTextStreamsForClosedCaptions(l),
              m['return'](l)
            );
          case 2:
            return m.enterFinallyBlock(), m.yield(e.destroy(), 7);
          case 7:
            m.leaveFinallyBlock(0);
        }
      });
    };
    shaka.offline.OfflineManifestParser.prototype.stop = function () {
      return Promise.resolve();
    };
    shaka.offline.OfflineManifestParser.prototype.update = function () {};
    shaka.offline.OfflineManifestParser.prototype.onExpirationUpdated = function (a, b) {
      var c = this,
        d,
        e,
        f,
        g,
        h,
        k,
        l,
        m;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (n) {
        switch (n.nextAddress) {
          case 1:
            return (
              goog.asserts.assert(c.uri_, 'Should not get update event before start has been called'),
              (d = c.uri_),
              (e = new shaka.offline.StorageMuxer()),
              n.setCatchFinallyBlocks(2, 3),
              n.yield(e.init(), 5)
            );
          case 5:
            return n.yield(e.getCell(d.mechanism(), d.cell()), 6);
          case 6:
            return (f = n.yieldResult), n.yield(f.getManifests([d.key()]), 7);
          case 7:
            g = n.yieldResult;
            h = g[0];
            k = h.sessionIds.includes(a);
            l = void 0 == h.expiration || h.expiration > b;
            if (!k || !l) {
              n.jumpTo(3);
              break;
            }
            shaka.log.debug('Updating expiration for stored content');
            return n.yield(f.updateManifestExpiration(d.key(), b), 3);
          case 3:
            return n.enterFinallyBlock(), n.yield(e.destroy(), 10);
          case 10:
            n.leaveFinallyBlock(0);
            break;
          case 2:
            (m = n.enterCatchBlock()), shaka.log.error('There was an error updating', d, m), n.jumpTo(3);
        }
      });
    };
    shaka.media.ManifestParser.registerParserByMime('application/x-offline-manifest', function () {
      return new shaka.offline.OfflineManifestParser();
    });
    shaka.offline.OfflineScheme = function () {};
    shaka.offline.OfflineScheme.plugin = function (a, b, c, d) {
      return (b = shaka.offline.OfflineUri.parse(a)) && b.isManifest()
        ? shaka.offline.OfflineScheme.getManifest_(a)
        : b && b.isSegment()
        ? shaka.offline.OfflineScheme.getSegment_(b.key(), b)
        : shaka.util.AbortableOperation.failed(
            new shaka.util.Error(
              shaka.util.Error.Severity.CRITICAL,
              shaka.util.Error.Category.NETWORK,
              shaka.util.Error.Code.MALFORMED_OFFLINE_URI,
              a,
            ),
          );
    };
    shaka.offline.OfflineScheme.getManifest_ = function (a) {
      a = {
        uri: a,
        originalUri: a,
        data: new ArrayBuffer(0),
        headers: { 'content-type': 'application/x-offline-manifest' },
      };
      return shaka.util.AbortableOperation.completed(a);
    };
    shaka.offline.OfflineScheme.getSegment_ = function (a, b) {
      goog.asserts.assert(b.isSegment(), "Only segment uri's should be given to getSegment");
      var c = new shaka.offline.StorageMuxer();
      return shaka.util.AbortableOperation.completed(void 0)
        .chain(function () {
          return c.init();
        })
        .chain(function () {
          return c.getCell(b.mechanism(), b.cell());
        })
        .chain(function (d) {
          return d.getSegments([b.key()]);
        })
        .chain(function (d) {
          return { uri: b, data: d[0].data, headers: {} };
        })
        ['finally'](function () {
          return c.destroy();
        });
    };
    goog.exportSymbol('shaka.offline.OfflineScheme', shaka.offline.OfflineScheme);
    goog.exportProperty(shaka.offline.OfflineScheme, 'plugin', shaka.offline.OfflineScheme.plugin);
    shaka.net.NetworkingEngine.registerScheme('offline', shaka.offline.OfflineScheme.plugin);
    shaka.offline.SessionDeleter = function () {};
    shaka.offline.SessionDeleter.prototype['delete'] = function (a, b, c) {
      var d = this,
        e,
        f,
        g,
        h,
        k,
        l,
        m;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (n) {
        switch (n.nextAddress) {
          case 1:
            (e = shaka.offline.SessionDeleter),
              (f = []),
              (g = $jscomp.makeIterator(e.createBuckets_(c))),
              (h = g.next());
          case 2:
            if (h.done) {
              n.jumpTo(4);
              break;
            }
            k = h.value;
            l = d.doDelete_(a, b, k);
            return n.yield(l, 5);
          case 5:
            m = n.yieldResult;
            f = f.concat(m);
            h = g.next();
            n.jumpTo(2);
            break;
          case 4:
            return n['return'](f);
        }
      });
    };
    shaka.offline.SessionDeleter.prototype.doDelete_ = function (a, b, c) {
      var d, e, f, g;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (h) {
        switch (h.nextAddress) {
          case 1:
            return (
              (d = new shaka.media.DrmEngine({
                netEngine: b,
                onError: function () {},
                onKeyStatus: function () {},
                onExpirationUpdated: function () {},
                onEvent: function () {},
              })),
              h.setCatchFinallyBlocks(2),
              d.configure(a),
              h.yield(
                d.initForRemoval(
                  c.info.keySystem,
                  c.info.licenseUri,
                  c.info.serverCertificate,
                  c.info.audioCapabilities,
                  c.info.videoCapabilities,
                ),
                4,
              )
            );
          case 4:
            h.leaveTryBlock(3);
            break;
          case 2:
            return (e = h.enterCatchBlock()), shaka.log.warning('Error initializing EME', e), h.yield(d.destroy(), 5);
          case 5:
            return h['return']([]);
          case 3:
            return h.setCatchFinallyBlocks(6), h.yield(d.setServerCertificate(), 8);
          case 8:
            h.leaveTryBlock(7);
            break;
          case 6:
            return (
              (f = h.enterCatchBlock()),
              shaka.log.warning('Error setting server certificate', f),
              h.yield(d.destroy(), 9)
            );
          case 9:
            return h['return']([]);
          case 7:
            return (
              (g = []),
              h.yield(
                Promise.all(
                  c.sessionIds.map(function (k) {
                    var l;
                    return $jscomp.asyncExecutePromiseGeneratorProgram(function (m) {
                      if (1 == m.nextAddress) return m.setCatchFinallyBlocks(2), m.yield(d.removeSession(k), 4);
                      if (2 != m.nextAddress) return g.push(k), m.leaveTryBlock(0);
                      l = m.enterCatchBlock();
                      shaka.log.warning('Error deleting offline session', l);
                      m.jumpToEnd();
                    });
                  }),
                ),
                10,
              )
            );
          case 10:
            return h.yield(d.destroy(), 11);
          case 11:
            return h['return'](g);
        }
      });
    };
    shaka.offline.SessionDeleter.createBuckets_ = function (a) {
      var b = shaka.offline.SessionDeleter,
        c = [];
      a = $jscomp.makeIterator(a);
      for (var d = a.next(); !d.done; d = a.next()) {
        d = d.value;
        for (var e = !1, f = $jscomp.makeIterator(c), g = f.next(); !g.done; g = f.next())
          if (((g = g.value), b.isCompatible_(g.info, d))) {
            g.sessionIds.push(d.sessionId);
            e = !0;
            break;
          }
        e || c.push({ info: d, sessionIds: [d.sessionId] });
      }
      return c;
    };
    shaka.offline.SessionDeleter.isCompatible_ = function (a, b) {
      var c = shaka.util.ArrayUtils,
        d = function (e, f) {
          return e.robustness == f.robustness && e.contentType == f.contentType;
        };
      return (
        a.keySystem == b.keySystem &&
        a.licenseUri == b.licenseUri &&
        c.hasSameElements(a.audioCapabilities, b.audioCapabilities, d) &&
        c.hasSameElements(a.videoCapabilities, b.videoCapabilities, d)
      );
    };
    shaka.offline.StoredContentUtils = function () {};
    shaka.offline.StoredContentUtils.fromManifest = function (a, b, c, d) {
      goog.asserts.assert(b.variants.length, 'Cannot create stored content from manifest with no variants.');
      var e = b.presentationTimeline.getDuration();
      b = shaka.offline.StoredContentUtils.getTracks_(b);
      return {
        offlineUri: null,
        originalManifestUri: a,
        duration: e,
        size: c,
        expiration: Infinity,
        tracks: b,
        appMetadata: d,
      };
    };
    shaka.offline.StoredContentUtils.fromManifestDB = function (a, b) {
      goog.asserts.assert(b.streams.length, 'Cannot create stored content from manifestDB with no streams.');
      var c = new shaka.offline.ManifestConverter(a.mechanism(), a.cell()).fromManifestDB(b),
        d = b.appMetadata || {};
      c = shaka.offline.StoredContentUtils.getTracks_(c);
      goog.asserts.assert(null != b.expiration, 'Manifest expiration must be set by now!');
      return {
        offlineUri: a.toString(),
        originalManifestUri: b.originalManifestUri,
        duration: b.duration,
        size: b.size,
        expiration: b.expiration,
        tracks: c,
        appMetadata: d,
      };
    };
    shaka.offline.StoredContentUtils.getTracks_ = function (a) {
      var b = shaka.util.StreamUtils,
        c = [],
        d = b.getPlayableVariants(a.variants);
      d = $jscomp.makeIterator(d);
      for (var e = d.next(); !e.done; e = d.next()) c.push(b.variantToTrack(e.value));
      a = $jscomp.makeIterator(a.textStreams);
      for (d = a.next(); !d.done; d = a.next()) c.push(b.textStreamToTrack(d.value));
      return c;
    };
    shaka.offline.StreamBandwidthEstimator = function () {
      this.estimateByStreamId_ = {};
    };
    shaka.offline.StreamBandwidthEstimator.prototype.addVariant = function (a) {
      var b = a.audio,
        c = a.video;
      b && !c && this.setBitrate_(b.id, b.bandwidth || a.bandwidth);
      !b && c && this.setBitrate_(c.id, c.bandwidth || a.bandwidth);
      if (b && c) {
        var d = b.bandwidth || shaka.offline.StreamBandwidthEstimator.DEFAULT_AUDIO_BITRATE_,
          e = c.bandwidth || a.bandwidth - d;
        0 >= e &&
          (shaka.log.warning(
            "Audio bit rate consumes variants bandwidth. Setting video bandwidth to match variant's bandwidth.",
          ),
          (e = a.bandwidth));
        this.setBitrate_(b.id, d);
        this.setBitrate_(c.id, e);
      }
    };
    shaka.offline.StreamBandwidthEstimator.prototype.setBitrate_ = function (a, b) {
      this.estimateByStreamId_[a] = b;
    };
    shaka.offline.StreamBandwidthEstimator.prototype.addText = function (a) {
      this.estimateByStreamId_[a.id] = shaka.offline.StreamBandwidthEstimator.DEFAULT_TEXT_BITRATE_;
    };
    shaka.offline.StreamBandwidthEstimator.prototype.getSegmentEstimate = function (a, b) {
      var c = b.endTime - b.startTime;
      return this.getEstimate_(a) * c;
    };
    shaka.offline.StreamBandwidthEstimator.prototype.getInitSegmentEstimate = function (a) {
      return 0.5 * this.getEstimate_(a);
    };
    shaka.offline.StreamBandwidthEstimator.prototype.getEstimate_ = function (a) {
      a = this.estimateByStreamId_[a];
      null == a && ((a = 0), shaka.log.error('Asking for bitrate of stream not given to the estimator'));
      0 == a && shaka.log.warning("Using bitrate of 0, this stream won't affect progress");
      return a;
    };
    shaka.offline.StreamBandwidthEstimator.DEFAULT_AUDIO_BITRATE_ = 393216;
    shaka.offline.StreamBandwidthEstimator.DEFAULT_TEXT_BITRATE_ = 52;
    shaka.util.ManifestFilter = function () {};
    shaka.util.ManifestFilter.filterByRestrictions = function (a, b, c) {
      a.variants = a.variants.filter(function (d) {
        return shaka.util.StreamUtils.meetsRestrictions(d, b, c);
      });
    };
    shaka.util.ManifestFilter.filterByMediaSourceSupport = function (a) {
      var b = shaka.media.MediaSourceEngine;
      a.variants = a.variants.filter(function (c) {
        var d = !0;
        c.audio && (d = d && b.isStreamSupported(c.audio));
        c.video && (d = d && b.isStreamSupported(c.video));
        return d;
      });
    };
    shaka.util.ManifestFilter.filterByDrmSupport = function (a, b) {
      a.variants = a.variants.filter(function (c) {
        return b.supportsVariant(c);
      });
    };
    shaka.offline.Storage = function (a) {
      var b = this;
      if (a && a.constructor != shaka.Player)
        throw new shaka.util.Error(
          shaka.util.Error.Severity.CRITICAL,
          shaka.util.Error.Category.STORAGE,
          shaka.util.Error.Code.LOCAL_PLAYER_INSTANCE_REQUIRED,
        );
      this.networkingEngine_ = this.config_ = null;
      a
        ? ((this.config_ = a.getSharedConfiguration()),
          (this.networkingEngine_ = a.getNetworkingEngine()),
          goog.asserts.assert(
            this.networkingEngine_,
            'Storage should not be initialized with a player that had |destroy| called on it.',
          ))
        : ((this.config_ = shaka.util.PlayerConfiguration.createDefault()),
          (this.networkingEngine_ = new shaka.net.NetworkingEngine()));
      this.segmentsFromStore_ = [];
      this.openOperations_ = [];
      this.openDownloadManagers_ = [];
      this.initSegmentDbKeyCache_ = new Map();
      this.initSegmentDbKeyCache_.set(null, Promise.resolve(null));
      this.segmentDbKeyCache_ = new Map();
      var c = !a;
      this.destroyer_ = new shaka.util.Destroyer(function () {
        var d, e, f, g, h;
        return $jscomp.asyncExecutePromiseGeneratorProgram(function (k) {
          switch (k.nextAddress) {
            case 1:
              return k.yield(
                Promise.all(
                  b.openDownloadManagers_.map(function (l) {
                    return l.abortAll();
                  }),
                ),
                2,
              );
            case 2:
              d = function () {};
              e = [];
              f = $jscomp.makeIterator(b.openOperations_);
              for (g = f.next(); !g.done; g = f.next()) (h = g.value), e.push(h.then(d, d));
              return k.yield(Promise.all(e), 3);
            case 3:
              if (!c) {
                k.jumpTo(4);
                break;
              }
              return k.yield(b.networkingEngine_.destroy(), 4);
            case 4:
              (b.config_ = null), (b.networkingEngine_ = null), k.jumpToEnd();
          }
        });
      });
    };
    shaka.offline.Storage.support = function () {
      return shaka.util.Platform.supportsMediaSource() ? shaka.offline.StorageMuxer.support() : !1;
    };
    shaka.offline.Storage.prototype.destroy = function () {
      return this.destroyer_.destroy();
    };
    shaka.offline.Storage.prototype.configure = function (a, b) {
      goog.asserts.assert('object' == typeof a || 2 == arguments.length, 'String configs should have values!');
      2 == arguments.length && 'string' == typeof a && (a = shaka.util.ConfigUtils.convertToConfigObject(a, b));
      goog.asserts.assert('object' == typeof a, 'Should be an object!');
      a.manifest &&
        a.manifest.dash &&
        'defaultPresentationDelay' in a.manifest.dash &&
        (shaka.Deprecate.deprecateFeature(
          4,
          'manifest.dash.defaultPresentationDelay configuration',
          'Please Use manifest.defaultPresentationDelay instead.',
        ),
        (a.manifest.defaultPresentationDelay = a.manifest.dash.defaultPresentationDelay),
        delete a.manifest.dash.defaultPresentationDelay);
      goog.asserts.assert(this.config_, 'Cannot reconfigure stroage after calling destroy.');
      return shaka.util.PlayerConfiguration.mergeConfigObjects(this.config_, a);
    };
    shaka.offline.Storage.prototype.getConfiguration = function () {
      goog.asserts.assert(this.config_, 'Config must not be null!');
      var a = shaka.util.PlayerConfiguration.createDefault();
      shaka.util.PlayerConfiguration.mergeConfigObjects(
        a,
        this.config_,
        shaka.util.PlayerConfiguration.createDefault(),
      );
      return a;
    };
    shaka.offline.Storage.prototype.getNetworkingEngine = function () {
      return this.networkingEngine_;
    };
    shaka.offline.Storage.prototype.store = function (a, b, c) {
      var d = this;
      goog.asserts.assert(this.networkingEngine_, 'Cannot call |downloadManifest_| after calling |destroy|.');
      var e = this.getConfiguration(),
        f = new shaka.offline.DownloadManager(this.networkingEngine_);
      this.openDownloadManagers_.push(f);
      b = this.store_(
        a,
        b || {},
        function () {
          var h;
          return $jscomp.asyncExecutePromiseGeneratorProgram(function (k) {
            if (1 == k.nextAddress)
              return (
                goog.asserts.assert(d.networkingEngine_, 'Should not call |store| after |destroy|'),
                k.yield(
                  shaka.media.ManifestParser.getFactory(a, d.networkingEngine_, e.manifest.retryParameters, c || null),
                  2,
                )
              );
            h = k.yieldResult;
            return k['return'](shaka.util.Functional.callFactory(h));
          });
        },
        e,
        f,
      );
      var g = new shaka.util.AbortableOperation(b, function () {
        return f.abortAll();
      });
      g['finally'](function () {
        shaka.util.ArrayUtils.remove(d.openDownloadManagers_, f);
      });
      g.then = function (h) {
        shaka.Deprecate.deprecateFeature(
          4,
          'shaka.offline.Storage.store.then',
          'Storage operations now return a shaka.util.AbortableOperation, rather than a promise.  Please update to conform to this new API; you can use the |chain| method instead.',
        );
        return g.promise.then(h);
      };
      return this.startAbortableOperation_(g);
    };
    shaka.offline.Storage.prototype.getStoreInProgress = function () {
      shaka.Deprecate.deprecateFeature(
        4,
        'shaka.offline.Storage.getStoreInProgress',
        'Multiple concurrent downloads are now supported.',
      );
      return !1;
    };
    shaka.offline.Storage.prototype.store_ = function (a, b, c, d, e) {
      var f = this,
        g,
        h,
        k,
        l,
        m,
        n,
        p,
        q,
        r,
        t,
        w;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (u) {
        switch (u.nextAddress) {
          case 1:
            return (
              f.requireSupport_(),
              (h = g = null),
              (k = new shaka.offline.StorageMuxer()),
              (m = l = null),
              u.setCatchFinallyBlocks(2, 3),
              u.yield(c(), 5)
            );
          case 5:
            return (g = u.yieldResult), u.yield(f.parseManifest(a, g, d), 6);
          case 6:
            n = u.yieldResult;
            f.ensureNotDestroyed_();
            p = !n.presentationTimeline.isLive() && !n.presentationTimeline.isInProgress();
            if (!p)
              throw new shaka.util.Error(
                shaka.util.Error.Severity.CRITICAL,
                shaka.util.Error.Category.STORAGE,
                shaka.util.Error.Code.CANNOT_STORE_LIVE_OFFLINE,
                a,
              );
            return u.yield(
              f.createDrmEngine(
                n,
                function (v) {
                  m = m || v;
                },
                d,
              ),
              7,
            );
          case 7:
            h = u.yieldResult;
            f.ensureNotDestroyed_();
            if (m) throw m;
            return u.yield(f.filterManifest_(n, h, d), 8);
          case 8:
            return u.yield(k.init(), 9);
          case 9:
            return f.ensureNotDestroyed_(), u.yield(k.getActive(), 10);
          case 10:
            return (
              (l = u.yieldResult),
              f.ensureNotDestroyed_(),
              goog.asserts.assert(h, 'drmEngine should be non-null here.'),
              u.yield(f.downloadManifest_(l.cell, h, n, a, b, d, e), 11)
            );
          case 11:
            q = u.yieldResult;
            f.ensureNotDestroyed_();
            if (m) throw m;
            return u.yield(l.cell.addManifests([q]), 12);
          case 12:
            return (
              (r = u.yieldResult),
              f.ensureNotDestroyed_(),
              (t = shaka.offline.OfflineUri.manifest(l.path.mechanism, l.path.cell, r[0])),
              u['return'](shaka.offline.StoredContentUtils.fromManifestDB(t, q))
            );
          case 3:
            return u.enterFinallyBlock(), (f.segmentsFromStore_ = []), u.yield(k.destroy(), 13);
          case 13:
            if (!g) {
              u.jumpTo(14);
              break;
            }
            return u.yield(g.stop(), 14);
          case 14:
            if (!h) {
              u.jumpTo(16);
              break;
            }
            return u.yield(h.destroy(), 16);
          case 16:
            u.leaveFinallyBlock(0);
            break;
          case 2:
            w = u.enterCatchBlock();
            if (!l) {
              u.jumpTo(18);
              break;
            }
            return u.yield(
              l.cell.removeSegments(f.segmentsFromStore_, function () {}),
              18,
            );
          case 18:
            throw m || w;
        }
      });
    };
    shaka.offline.Storage.prototype.filterManifest_ = function (a, b, c) {
      var d, e, f, g, h, k, l, m, n, p, q, r, t, w, u, v;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (x) {
        if (1 == x.nextAddress) {
          d = shaka.util.StreamUtils;
          e = { width: Infinity, height: Infinity };
          shaka.util.ManifestFilter.filterByRestrictions(a, c.restrictions, e);
          shaka.util.ManifestFilter.filterByMediaSourceSupport(a);
          shaka.util.ManifestFilter.filterByDrmSupport(a, b);
          f = [];
          g = c.preferredAudioChannelCount;
          shaka.util.StreamUtils.chooseCodecsAndFilterManifest(a, g);
          h = $jscomp.makeIterator(a.variants);
          for (k = h.next(); !k.done; k = h.next())
            (l = k.value),
              goog.asserts.assert(d.isPlayable(l), 'We should have already filtered by "is playable"'),
              f.push(d.variantToTrack(l));
          m = $jscomp.makeIterator(a.textStreams);
          for (n = m.next(); !n.done; n = m.next()) (p = n.value), f.push(d.textStreamToTrack(p));
          return x.yield(c.offline.trackSelectionCallback(f), 2);
        }
        q = x.yieldResult;
        r = new Set();
        t = new Set();
        w = $jscomp.makeIterator(q);
        for (u = w.next(); !u.done; u = w.next())
          (v = u.value), 'variant' == v.type && r.add(v.id), 'text' == v.type && t.add(v.id);
        a.variants = a.variants.filter(function (B) {
          return r.has(B.id);
        });
        a.textStreams = a.textStreams.filter(function (B) {
          return t.has(B.id);
        });
        shaka.offline.Storage.validateManifest_(a);
        x.jumpToEnd();
      });
    };
    shaka.offline.Storage.prototype.downloadManifest_ = function (a, b, c, d, e, f, g) {
      var h = this,
        k,
        l,
        m,
        n,
        p,
        q,
        r,
        t,
        w,
        u,
        v,
        x;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (B) {
        switch (B.nextAddress) {
          case 1:
            return (
              (k = shaka.offline.StoredContentUtils.fromManifest(d, c, 0, e)),
              (l = f.offline.progressCallback),
              (m = function (z, A) {
                k.size = A;
                l(k, z);
              }),
              (n = function (z, A) {
                r && f.offline.usePersistentLicense && t == A && b.newInitData('cenc', z);
              }),
              g.setCallbacks(m, n),
              (p = c.variants.some(function (z) {
                var A = z.audio && z.audio.encrypted;
                return (z.video && z.video.encrypted) || A;
              })),
              (q = c.variants.some(function (z) {
                return (z.video ? z.video.drmInfos : []).concat(z.audio ? z.audio.drmInfos : []).some(function (A) {
                  return A.initData && A.initData.length;
                });
              })),
              (r = p && !q),
              (t = null),
              r && ((w = b.getDrmInfo()), (t = shaka.offline.Storage.defaultSystemIds_.get(w.keySystem))),
              B.setFinallyBlock(2),
              (v = u = h.createOfflineManifest_(g, a, b, c, d, e, f)),
              B.yield(g.waitToFinish(), 4)
            );
          case 4:
            v.size = B.yieldResult;
            u.expiration = b.getExpiration();
            x = b.getSessionIds();
            u.sessionIds = f.offline.usePersistentLicense ? x : [];
            if (p && f.offline.usePersistentLicense && !x.length)
              throw new shaka.util.Error(
                shaka.util.Error.Severity.CRITICAL,
                shaka.util.Error.Category.STORAGE,
                shaka.util.Error.Code.NO_INIT_DATA_FOR_OFFLINE,
              );
            return B['return'](u);
          case 2:
            return B.enterFinallyBlock(), B.yield(g.destroy(), 5);
          case 5:
            B.leaveFinallyBlock(0);
        }
      });
    };
    shaka.offline.Storage.prototype.remove = function (a) {
      return this.startOperation_(this.remove_(a));
    };
    shaka.offline.Storage.prototype.remove_ = function (a) {
      var b = this,
        c,
        d,
        e,
        f,
        g,
        h;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (k) {
        switch (k.nextAddress) {
          case 1:
            b.requireSupport_();
            c = shaka.offline.OfflineUri.parse(a);
            if (null == c || !c.isManifest())
              throw new shaka.util.Error(
                shaka.util.Error.Severity.CRITICAL,
                shaka.util.Error.Category.STORAGE,
                shaka.util.Error.Code.MALFORMED_OFFLINE_URI,
                a,
              );
            d = c;
            e = new shaka.offline.StorageMuxer();
            k.setFinallyBlock(2);
            return k.yield(e.init(), 4);
          case 4:
            return k.yield(e.getCell(d.mechanism(), d.cell()), 5);
          case 5:
            return (f = k.yieldResult), k.yield(f.getManifests([d.key()]), 6);
          case 6:
            return (
              (g = k.yieldResult),
              (h = g[0]),
              k.yield(Promise.all([b.removeFromDRM_(d, h, e), b.removeFromStorage_(f, d, h)]), 2)
            );
          case 2:
            return k.enterFinallyBlock(), k.yield(e.destroy(), 8);
          case 8:
            k.leaveFinallyBlock(0);
        }
      });
    };
    shaka.offline.Storage.getCapabilities_ = function (a, b) {
      for (
        var c = shaka.util.MimeUtils, d = [], e = $jscomp.makeIterator(a.streams), f = e.next();
        !f.done;
        f = e.next()
      )
        (f = f.value),
          b && 'video' == f.type
            ? d.push({ contentType: c.getFullType(f.mimeType, f.codecs), robustness: a.drmInfo.videoRobustness })
            : b ||
              'audio' != f.type ||
              d.push({ contentType: c.getFullType(f.mimeType, f.codecs), robustness: a.drmInfo.audioRobustness });
      return d;
    };
    shaka.offline.Storage.prototype.removeFromDRM_ = function (a, b, c) {
      var d = this;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (e) {
        goog.asserts.assert(d.networkingEngine_, 'Cannot be destroyed');
        return e.yield(shaka.offline.Storage.deleteLicenseFor_(d.networkingEngine_, d.config_.drm, c, b), 0);
      });
    };
    shaka.offline.Storage.prototype.removeFromStorage_ = function (a, b, c) {
      var d = this,
        e = shaka.offline.Storage.getAllSegmentIds_(c),
        f = e.length + 1,
        g = 0,
        h = shaka.offline.StoredContentUtils.fromManifestDB(b, c);
      c = function (k) {
        g += 1;
        d.config_.offline.progressCallback(h, g / f);
      };
      return Promise.all([a.removeSegments(e, c), a.removeManifests([b.key()], c)]);
    };
    shaka.offline.Storage.prototype.removeEmeSessions = function () {
      return this.startOperation_(this.removeEmeSessions_());
    };
    shaka.offline.Storage.prototype.removeEmeSessions_ = function () {
      var a = this,
        b,
        c,
        d,
        e,
        f,
        g,
        h,
        k,
        l,
        m,
        n;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (p) {
        switch (p.nextAddress) {
          case 1:
            return (
              a.requireSupport_(),
              goog.asserts.assert(a.networkingEngine_, 'Cannot be destroyed'),
              (b = a.networkingEngine_),
              (c = a.config_.drm),
              (d = new shaka.offline.StorageMuxer()),
              (e = new shaka.offline.SessionDeleter()),
              (f = !1),
              p.setFinallyBlock(2),
              p.yield(d.init(), 4)
            );
          case 4:
            (g = []),
              d.forEachEmeSessionCell(function (q) {
                return g.push(q);
              }),
              (h = $jscomp.makeIterator(g)),
              (k = h.next());
          case 5:
            if (k.done) {
              p.jumpTo(2);
              break;
            }
            l = k.value;
            return p.yield(l.getAll(), 8);
          case 8:
            return (m = p.yieldResult), p.yield(e['delete'](c, b, m), 9);
          case 9:
            return (n = p.yieldResult), p.yield(l.remove(n), 10);
          case 10:
            n.length != m.length && (f = !0);
            k = h.next();
            p.jumpTo(5);
            break;
          case 2:
            return p.enterFinallyBlock(), p.yield(d.destroy(), 11);
          case 11:
            p.leaveFinallyBlock(3);
            break;
          case 3:
            return p['return'](!f);
        }
      });
    };
    shaka.offline.Storage.prototype.list = function () {
      return this.startOperation_(this.list_());
    };
    shaka.offline.Storage.prototype.list_ = function () {
      var a = this,
        b,
        c,
        d;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (e) {
        switch (e.nextAddress) {
          case 1:
            return (
              a.requireSupport_(),
              (b = []),
              (c = new shaka.offline.StorageMuxer()),
              e.setFinallyBlock(2),
              e.yield(c.init(), 4)
            );
          case 4:
            return (
              (d = Promise.resolve()),
              c.forEachCell(function (f, g) {
                d = d.then(function () {
                  var h;
                  return $jscomp.asyncExecutePromiseGeneratorProgram(function (k) {
                    if (1 == k.nextAddress) return k.yield(g.getAllManifests(), 2);
                    h = k.yieldResult;
                    h.forEach(function (l, m) {
                      var n = shaka.offline.OfflineUri.manifest(f.mechanism, f.cell, m);
                      n = shaka.offline.StoredContentUtils.fromManifestDB(n, l);
                      b.push(n);
                    });
                    k.jumpToEnd();
                  });
                });
              }),
              e.yield(d, 2)
            );
          case 2:
            return e.enterFinallyBlock(), e.yield(c.destroy(), 6);
          case 6:
            e.leaveFinallyBlock(3);
            break;
          case 3:
            return e['return'](b);
        }
      });
    };
    shaka.offline.Storage.prototype.parseManifest = function (a, b, c) {
      var d = this,
        e,
        f,
        g,
        h,
        k;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (l) {
        if (1 == l.nextAddress)
          return (
            (e = null),
            (f = d.networkingEngine_),
            goog.asserts.assert(f, 'Should be initialized!'),
            (g = {
              networkingEngine: f,
              filter: function () {
                return Promise.resolve();
              },
              makeTextStreamsForClosedCaptions: function (m) {},
              onTimelineRegionAdded: function () {},
              onEvent: function () {},
              onError: function (m) {
                e = m;
              },
            }),
            b.configure(c.manifest),
            d.ensureNotDestroyed_(),
            l.yield(b.start(a, g), 2)
          );
        if (3 != l.nextAddress)
          return (
            (h = l.yieldResult),
            d.ensureNotDestroyed_(),
            (k = shaka.offline.Storage.getAllStreamsFromManifest_(h)),
            l.yield(
              Promise.all(
                shaka.util.Iterables.map(k, function (m) {
                  return m.createSegmentIndex();
                }),
              ),
              3,
            )
          );
        d.ensureNotDestroyed_();
        if (e) throw e;
        return l['return'](h);
      });
    };
    shaka.offline.Storage.prototype.createDrmEngine = function (a, b, c) {
      var d = this,
        e;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (f) {
        switch (f.nextAddress) {
          case 1:
            return (
              goog.asserts.assert(d.networkingEngine_, 'Cannot call |createDrmEngine| after |destroy|'),
              (e = new shaka.media.DrmEngine({
                netEngine: d.networkingEngine_,
                onError: b,
                onKeyStatus: function () {},
                onExpirationUpdated: function () {},
                onEvent: function () {},
              })),
              e.configure(c.drm),
              f.yield(e.initForStorage(a.variants, c.offline.usePersistentLicense), 2)
            );
          case 2:
            return f.yield(e.setServerCertificate(), 3);
          case 3:
            return f.yield(e.createOrLoad(), 4);
          case 4:
            return f['return'](e);
        }
      });
    };
    shaka.offline.Storage.prototype.createOfflineManifest_ = function (a, b, c, d, e, f, g) {
      var h = new shaka.offline.StreamBandwidthEstimator();
      a = this.createStreams_(a, b, h, c, d, g);
      g = g.offline.usePersistentLicense;
      (b = c.getDrmInfo()) && g && (b.initData = []);
      return {
        creationTime: Date.now(),
        originalManifestUri: e,
        duration: d.presentationTimeline.getDuration(),
        size: 0,
        expiration: c.getExpiration(),
        streams: a,
        sessionIds: g ? c.getSessionIds() : [],
        drmInfo: b,
        appMetadata: f,
      };
    };
    shaka.offline.Storage.prototype.createStreams_ = function (a, b, c, d, e, f) {
      d = $jscomp.makeIterator(e.variants);
      for (var g = d.next(); !g.done; g = d.next()) c.addVariant(g.value);
      d = $jscomp.makeIterator(e.textStreams);
      for (g = d.next(); !g.done; g = d.next()) c.addText(g.value);
      g = shaka.offline.Storage.getAllStreamsFromManifest_(e);
      d = new Map();
      g = $jscomp.makeIterator(g);
      for (var h = g.next(); !h.done; h = g.next()) {
        h = h.value;
        var k = this.createStream_(a, b, c, e, h, f);
        d.set(h.id, k);
      }
      a = $jscomp.makeIterator(e.variants);
      for (g = a.next(); !g.done; g = a.next())
        (b = g.value),
          b.audio && d.get(b.audio.id).variantIds.push(b.id),
          b.video && d.get(b.video.id).variantIds.push(b.id);
      return Array.from(d.values());
    };
    shaka.offline.Storage.prototype.createStream_ = function (a, b, c, d, e, f) {
      var g = this,
        h = {
          id: e.id,
          originalId: e.originalId,
          primary: e.primary,
          type: e.type,
          mimeType: e.mimeType,
          codecs: e.codecs,
          frameRate: e.frameRate,
          pixelAspectRatio: e.pixelAspectRatio,
          kind: e.kind,
          language: e.language,
          label: e.label,
          width: e.width || null,
          height: e.height || null,
          encrypted: e.encrypted,
          keyIds: e.keyIds,
          segments: [],
          variantIds: [],
          roles: e.roles,
          channelsCount: e.channelsCount,
          audioSamplingRate: e.audioSamplingRate,
          closedCaptions: e.closedCaptions,
        },
        k = e.id;
      d = d.presentationTimeline.getSegmentAvailabilityStart();
      shaka.offline.Storage.forEachSegment_(e, d, function (l) {
        var m = g.getInitSegmentDbKey_(a, k, e.id, b, c, l.initSegmentReference, f),
          n = g.getSegmentDbKey_(a, k, e.id, b, c, l, f);
        a.queueWork(k, function () {
          var p, q;
          return $jscomp.asyncExecutePromiseGeneratorProgram(function (r) {
            if (1 == r.nextAddress) return r.yield(m, 2);
            if (3 != r.nextAddress) return (p = r.yieldResult), r.yield(n, 3);
            q = r.yieldResult;
            h.segments.push({
              initSegmentKey: p,
              startTime: l.startTime,
              endTime: l.endTime,
              appendWindowStart: l.appendWindowStart,
              appendWindowEnd: l.appendWindowEnd,
              timestampOffset: l.timestampOffset,
              dataKey: q,
            });
            r.jumpToEnd();
          });
        });
      });
      return h;
    };
    shaka.offline.Storage.prototype.getInitSegmentDbKey_ = function (a, b, c, d, e, f, g) {
      var h = this;
      if (this.initSegmentDbKeyCache_.has(f)) return this.initSegmentDbKeyCache_.get(f);
      g = shaka.util.Networking.createSegmentRequest(f.getUris(), f.startByte, f.endByte, g.streaming.retryParameters);
      a = a.queue(b, g, e.getInitSegmentEstimate(c), !0, function (k) {
        var l;
        return $jscomp.asyncExecutePromiseGeneratorProgram(function (m) {
          if (1 == m.nextAddress) return m.yield(d.addSegments([{ data: k }]), 2);
          l = m.yieldResult;
          h.segmentsFromStore_.push(l[0]);
          return m['return'](l[0]);
        });
      });
      this.initSegmentDbKeyCache_.set(f, a);
      return a;
    };
    shaka.offline.Storage.prototype.getSegmentDbKey_ = function (a, b, c, d, e, f, g) {
      var h = this,
        k = [f.getUris()[0], f.startByte, f.endByte].join('-');
      if (this.segmentDbKeyCache_.has(k)) return this.segmentDbKeyCache_.get(k);
      g = shaka.util.Networking.createSegmentRequest(f.getUris(), f.startByte, f.endByte, g.streaming.retryParameters);
      a = a.queue(b, g, e.getSegmentEstimate(c, f), !1, function (l) {
        var m;
        return $jscomp.asyncExecutePromiseGeneratorProgram(function (n) {
          if (1 == n.nextAddress) return n.yield(d.addSegments([{ data: l }]), 2);
          m = n.yieldResult;
          h.segmentsFromStore_.push(m[0]);
          return n['return'](m[0]);
        });
      });
      this.segmentDbKeyCache_.set(k, a);
      return a;
    };
    shaka.offline.Storage.forEachSegment_ = function (a, b, c) {
      b = a.segmentIndex.find(b);
      if (null != b) for (var d = a.segmentIndex.get(b); d; ) c(d), (d = a.segmentIndex.get(++b));
    };
    shaka.offline.Storage.prototype.ensureNotDestroyed_ = function () {
      if (this.destroyer_.destroyed())
        throw new shaka.util.Error(
          shaka.util.Error.Severity.CRITICAL,
          shaka.util.Error.Category.STORAGE,
          shaka.util.Error.Code.OPERATION_ABORTED,
        );
    };
    shaka.offline.Storage.prototype.requireSupport_ = function () {
      if (!shaka.offline.Storage.support())
        throw new shaka.util.Error(
          shaka.util.Error.Severity.CRITICAL,
          shaka.util.Error.Category.STORAGE,
          shaka.util.Error.Code.STORAGE_NOT_SUPPORTED,
        );
    };
    shaka.offline.Storage.prototype.startOperation_ = function (a) {
      var b = this;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (c) {
        if (1 == c.nextAddress) return b.openOperations_.push(a), c.setFinallyBlock(2), c.yield(a, 4);
        if (2 != c.nextAddress) return c['return'](c.yieldResult);
        c.enterFinallyBlock();
        shaka.util.ArrayUtils.remove(b.openOperations_, a);
        return c.leaveFinallyBlock(0);
      });
    };
    shaka.offline.Storage.prototype.startAbortableOperation_ = function (a) {
      var b = this,
        c = a.promise;
      this.openOperations_.push(c);
      return a['finally'](function () {
        shaka.util.ArrayUtils.remove(b.openOperations_, c);
      });
    };
    shaka.offline.Storage.getAllSegmentIds_ = function (a) {
      var b = [];
      a = $jscomp.makeIterator(a.streams);
      for (var c = a.next(); !c.done; c = a.next()) {
        c = $jscomp.makeIterator(c.value.segments);
        for (var d = c.next(); !d.done; d = c.next())
          (d = d.value), null != d.initSegmentKey && b.push(d.initSegmentKey), b.push(d.dataKey);
      }
      return b;
    };
    shaka.offline.Storage.deleteAll = function () {
      var a;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (b) {
        return 1 == b.nextAddress
          ? ((a = new shaka.offline.StorageMuxer()), b.setFinallyBlock(2), b.yield(a.erase(), 2))
          : 5 != b.nextAddress
          ? (b.enterFinallyBlock(), b.yield(a.destroy(), 5))
          : b.leaveFinallyBlock(0);
      });
    };
    shaka.offline.Storage.deleteLicenseFor_ = function (a, b, c, d) {
      var e, f, g, h;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (k) {
        if (1 == k.nextAddress) {
          if (!d.drmInfo) return k['return']();
          e = c.getEmeSessionCell();
          f = d.sessionIds.map(function (l) {
            return {
              sessionId: l,
              keySystem: d.drmInfo.keySystem,
              licenseUri: d.drmInfo.licenseServerUri,
              serverCertificate: d.drmInfo.serverCertificate,
              audioCapabilities: shaka.offline.Storage.getCapabilities_(d, !1),
              videoCapabilities: shaka.offline.Storage.getCapabilities_(d, !0),
            };
          });
          g = new shaka.offline.SessionDeleter();
          return k.yield(g['delete'](b, a, f), 2);
        }
        return 3 != k.nextAddress
          ? ((h = k.yieldResult), k.yield(e.remove(h), 3))
          : k.yield(
              e.add(
                f.filter(function (l) {
                  return !h.includes(l.sessionId);
                }),
              ),
              0,
            );
      });
    };
    shaka.offline.Storage.getAllStreamsFromManifest_ = function (a) {
      for (var b = new Set(), c = $jscomp.makeIterator(a.textStreams), d = c.next(); !d.done; d = c.next())
        b.add(d.value);
      a = $jscomp.makeIterator(a.variants);
      for (c = a.next(); !c.done; c = a.next()) (c = c.value), c.audio && b.add(c.audio), c.video && b.add(c.video);
      return b;
    };
    shaka.offline.Storage.validateManifest_ = function (a) {
      var b = new Set(
          a.variants.map(function (g) {
            return g.video;
          }),
        ),
        c = new Set(
          a.variants.map(function (g) {
            return g.audio;
          }),
        );
      a = a.textStreams;
      1 < b.size && shaka.log.warning('Multiple video tracks selected to be stored');
      b = $jscomp.makeIterator(c);
      for (var d = b.next(); !d.done; d = b.next()) {
        d = d.value;
        for (var e = $jscomp.makeIterator(c), f = e.next(); !f.done; f = e.next())
          (f = f.value),
            d != f &&
              d.language == f.language &&
              shaka.log.warning('Similar audio tracks were selected to be stored', d.id, f.id);
      }
      c = $jscomp.makeIterator(a);
      for (b = c.next(); !b.done; b = c.next())
        for (b = b.value, d = $jscomp.makeIterator(a), e = d.next(); !e.done; e = d.next())
          (e = e.value),
            b != e &&
              b.language == e.language &&
              shaka.log.warning('Similar text tracks were selected to be stored', b.id, e.id);
    };
    goog.exportSymbol('shaka.offline.Storage', shaka.offline.Storage);
    goog.exportProperty(shaka.offline.Storage, 'deleteAll', shaka.offline.Storage.deleteAll);
    goog.exportProperty(shaka.offline.Storage.prototype, 'list', shaka.offline.Storage.prototype.list);
    goog.exportProperty(
      shaka.offline.Storage.prototype,
      'removeEmeSessions',
      shaka.offline.Storage.prototype.removeEmeSessions,
    );
    goog.exportProperty(shaka.offline.Storage.prototype, 'remove', shaka.offline.Storage.prototype.remove);
    goog.exportProperty(
      shaka.offline.Storage.prototype,
      'getStoreInProgress',
      shaka.offline.Storage.prototype.getStoreInProgress,
    );
    goog.exportProperty(shaka.offline.Storage.prototype, 'store', shaka.offline.Storage.prototype.store);
    goog.exportProperty(
      shaka.offline.Storage.prototype,
      'getNetworkingEngine',
      shaka.offline.Storage.prototype.getNetworkingEngine,
    );
    goog.exportProperty(
      shaka.offline.Storage.prototype,
      'getConfiguration',
      shaka.offline.Storage.prototype.getConfiguration,
    );
    goog.exportProperty(shaka.offline.Storage.prototype, 'configure', shaka.offline.Storage.prototype.configure);
    goog.exportProperty(shaka.offline.Storage.prototype, 'destroy', shaka.offline.Storage.prototype.destroy);
    goog.exportProperty(shaka.offline.Storage, 'support', shaka.offline.Storage.support);
    shaka.offline.Storage.defaultSystemIds_ = new Map()
      .set('org.w3.clearkey', '1077efecc0b24d02ace33c1e52e2fb4b')
      .set('com.widevine.alpha', 'edef8ba979d64acea3c827dcd51d21ed')
      .set('com.microsoft.playready', '9a04f07998404286ab92e65be0885f95')
      .set('com.adobe.primetime', 'f239e769efa348509c16a903c6932efb');
    shaka.Player.registerSupportPlugin('offline', shaka.offline.Storage.support);
    shaka.polyfill = function () {};
    shaka.polyfill.installAll = function () {
      for (var a = $jscomp.makeIterator(shaka.polyfill.polyfills_), b = a.next(); !b.done; b = a.next()) {
        b = b.value;
        try {
          b.callback();
        } catch (c) {
          shaka.log.alwaysWarn('Error installing polyfill!', c);
        }
      }
    };
    shaka.polyfill.register = function (a, b) {
      for (
        var c = { priority: b || 0, callback: a },
          d = $jscomp.makeIterator(shaka.util.Iterables.enumerate(shaka.polyfill.polyfills_)),
          e = d.next();
        !e.done;
        e = d.next()
      ) {
        e = e.value;
        var f = e.i;
        if (e.item.priority < c.priority) {
          shaka.polyfill.polyfills_.splice(f, 0, c);
          return;
        }
      }
      shaka.polyfill.polyfills_.push(c);
    };
    goog.exportSymbol('shaka.polyfill', shaka.polyfill);
    goog.exportProperty(shaka.polyfill, 'register', shaka.polyfill.register);
    goog.exportProperty(shaka.polyfill, 'installAll', shaka.polyfill.installAll);
    shaka.polyfill.polyfills_ = [];
    shaka.polyfill.EncryptionScheme = function () {};
    shaka.polyfill.EncryptionScheme.install = function () {
      EncryptionSchemePolyfills.install();
    };
    shaka.polyfill.register(shaka.polyfill.EncryptionScheme.install, -1);
    shaka.polyfill.Fullscreen = function () {};
    shaka.polyfill.Fullscreen.install = function () {
      if (window.Document) {
        var a = Element.prototype;
        a.requestFullscreen =
          a.requestFullscreen || a.mozRequestFullScreen || a.msRequestFullscreen || a.webkitRequestFullscreen;
        a = Document.prototype;
        a.exitFullscreen = a.exitFullscreen || a.mozCancelFullScreen || a.msExitFullscreen || a.webkitCancelFullScreen;
        'fullscreenElement' in document ||
          (Object.defineProperty(document, 'fullscreenElement', {
            get: function () {
              return (
                document.mozFullScreenElement ||
                document.msFullscreenElement ||
                document.webkitCurrentFullScreenElement ||
                document.webkitFullscreenElement
              );
            },
          }),
          Object.defineProperty(document, 'fullscreenEnabled', {
            get: function () {
              return document.mozFullScreenEnabled || document.msFullscreenEnabled || document.webkitFullscreenEnabled;
            },
          }));
        a = shaka.polyfill.Fullscreen.proxyEvent_;
        document.addEventListener('webkitfullscreenchange', a);
        document.addEventListener('webkitfullscreenerror', a);
        document.addEventListener('mozfullscreenchange', a);
        document.addEventListener('mozfullscreenerror', a);
        document.addEventListener('MSFullscreenChange', a);
        document.addEventListener('MSFullscreenError', a);
      }
    };
    shaka.polyfill.Fullscreen.proxyEvent_ = function (a) {
      var b = a.type.replace(/^(webkit|moz|MS)/, '').toLowerCase();
      if ('function' === typeof Event) var c = new Event(b, a);
      else (c = document.createEvent('Event')), c.initEvent(b, a.bubbles, a.cancelable);
      a.target.dispatchEvent(c);
    };
    shaka.polyfill.register(shaka.polyfill.Fullscreen.install);
    shaka.polyfill.InputEvent = function () {};
    shaka.polyfill.InputEvent.install = function () {
      shaka.log.debug('InputEvent.install');
      shaka.util.Platform.isIE() &&
        !HTMLInputElement.prototype.originalAddEventListener &&
        (shaka.log.info('Patching input event support on IE.'),
        (HTMLInputElement.prototype.originalAddEventListener = HTMLInputElement.prototype.addEventListener),
        (HTMLInputElement.prototype.addEventListener = shaka.polyfill.InputEvent.addEventListener_));
    };
    shaka.polyfill.InputEvent.addEventListener_ = function (a, b, c) {
      if ('input' == a)
        switch (this.type) {
          case 'range':
            a = 'change';
        }
      HTMLInputElement.prototype.originalAddEventListener.call(this, a, b, c);
    };
    shaka.polyfill.register(shaka.polyfill.InputEvent.install);
    shaka.polyfill.Languages = function () {};
    shaka.polyfill.Languages.install = function () {
      navigator.languages ||
        Object.defineProperty(navigator, 'languages', {
          get: function () {
            return navigator.language ? [navigator.language] : ['en'];
          },
        });
    };
    shaka.polyfill.register(shaka.polyfill.Languages.install);
    shaka.polyfill.MathRound = function () {};
    shaka.polyfill.MathRound.install = function () {
      shaka.log.debug('mathRound.install');
      var a = shaka.polyfill.MathRound.MAX_ACCURATE_INPUT_ + 1;
      if (Math.round(a) != a) {
        shaka.log.debug('polyfill Math.round');
        var b = Math.round;
        Math.round = function (c) {
          var d = c;
          c <= shaka.polyfill.MathRound.MAX_ACCURATE_INPUT_ && (d = b(c));
          return d;
        };
      }
    };
    shaka.polyfill.MathRound.MAX_ACCURATE_INPUT_ = 4503599627370496;
    shaka.polyfill.register(shaka.polyfill.MathRound.install);
    shaka.polyfill.MediaSource = function () {};
    shaka.polyfill.MediaSource.install = function () {
      shaka.log.debug('MediaSource.install');
      var a = shaka.util.Platform.safariVersion();
      window.MediaSource
        ? window.cast && cast.__platform__ && cast.__platform__.canDisplayType
          ? (shaka.log.info('Patching Chromecast MSE bugs.'), shaka.polyfill.MediaSource.patchCastIsTypeSupported_())
          : a
          ? (shaka.polyfill.MediaSource.rejectTsContent_(),
            12 >= a
              ? (shaka.log.info('Patching Safari 11 & 12 MSE bugs.'),
                shaka.polyfill.MediaSource.stubAbort_(),
                shaka.polyfill.MediaSource.patchRemovalRange_())
              : (shaka.log.info('Patching Safari 13 MSE bugs.'), shaka.polyfill.MediaSource.stubAbort_()))
          : shaka.util.Platform.isTizen2() || shaka.util.Platform.isTizen3() || shaka.util.Platform.isTizen4()
          ? shaka.polyfill.MediaSource.rejectCodec_('opus')
          : shaka.log.info('Using native MSE as-is.')
        : shaka.log.info('No MSE implementation available.');
    };
    shaka.polyfill.MediaSource.stubAbort_ = function () {
      var a = MediaSource.prototype.addSourceBuffer;
      MediaSource.prototype.addSourceBuffer = function (b) {
        for (var c = [], d = 0; d < arguments.length; ++d) c[d - 0] = arguments[d];
        c = a.apply(this, c);
        c.abort = function () {};
        return c;
      };
    };
    shaka.polyfill.MediaSource.patchRemovalRange_ = function () {
      var a = SourceBuffer.prototype.remove;
      SourceBuffer.prototype.remove = function (b, c) {
        return a.call(this, b, c - 0.001);
      };
    };
    shaka.polyfill.MediaSource.rejectTsContent_ = function () {
      var a = MediaSource.isTypeSupported;
      MediaSource.isTypeSupported = function (b) {
        return 'mp2t' == b.split(/ *; */)[0].split('/')[1].toLowerCase() ? !1 : a(b);
      };
    };
    shaka.polyfill.MediaSource.rejectCodec_ = function (a) {
      var b = MediaSource.isTypeSupported;
      MediaSource.isTypeSupported = function (c) {
        return shaka.util.MimeUtils.getCodecBase(c) != a && b(c);
      };
    };
    shaka.polyfill.MediaSource.patchCastIsTypeSupported_ = function () {
      var a = MediaSource.isTypeSupported;
      MediaSource.isTypeSupported = function (b) {
        var c = b.split(/ *; */);
        c.shift();
        return c.some(function (d) {
          return d.startsWith('codecs=');
        })
          ? cast.__platform__.canDisplayType(b)
          : a(b);
      };
    };
    shaka.polyfill.register(shaka.polyfill.MediaSource.install);
    shaka.polyfill.PatchedMediaKeysApple = function () {};
    shaka.polyfill.PatchedMediaKeysApple.install = function () {
      if (window.HTMLVideoElement && window.WebKitMediaKeys) {
        shaka.log.info('Using Apple-prefixed EME');
        var a = shaka.polyfill.PatchedMediaKeysApple;
        delete HTMLMediaElement.prototype.mediaKeys;
        HTMLMediaElement.prototype.mediaKeys = null;
        HTMLMediaElement.prototype.setMediaKeys = a.setMediaKeys;
        window.MediaKeys = a.MediaKeys;
        window.MediaKeySystemAccess = a.MediaKeySystemAccess;
        navigator.requestMediaKeySystemAccess = a.requestMediaKeySystemAccess;
      }
    };
    shaka.polyfill.PatchedMediaKeysApple.requestMediaKeySystemAccess = function (a, b) {
      shaka.log.debug('PatchedMediaKeysApple.requestMediaKeySystemAccess');
      goog.asserts.assert(this == navigator, 'bad "this" for requestMediaKeySystemAccess');
      var c = shaka.polyfill.PatchedMediaKeysApple;
      try {
        var d = new c.MediaKeySystemAccess(a, b);
        return Promise.resolve(d);
      } catch (e) {
        return Promise.reject(e);
      }
    };
    shaka.polyfill.PatchedMediaKeysApple.setMediaKeys = function (a) {
      shaka.log.debug('PatchedMediaKeysApple.setMediaKeys');
      goog.asserts.assert(this instanceof HTMLMediaElement, 'bad "this" for setMediaKeys');
      var b = shaka.polyfill.PatchedMediaKeysApple,
        c = this.mediaKeys;
      c &&
        c != a &&
        (goog.asserts.assert(c instanceof b.MediaKeys, 'non-polyfill instance of oldMediaKeys'), c.setMedia(null));
      delete this.mediaKeys;
      return (this.mediaKeys = a)
        ? (goog.asserts.assert(a instanceof b.MediaKeys, 'non-polyfill instance of newMediaKeys'), a.setMedia(this))
        : Promise.resolve();
    };
    shaka.polyfill.PatchedMediaKeysApple.onWebkitNeedKey_ = function (a) {
      shaka.log.debug('PatchedMediaKeysApple.onWebkitNeedKey_', a);
      goog.asserts.assert(
        this.mediaKeys instanceof shaka.polyfill.PatchedMediaKeysApple.MediaKeys,
        'non-polyfill instance of newMediaKeys',
      );
      goog.asserts.assert(null != a.initData, 'missing init data!');
      a = shaka.util.BufferUtils.toUint8(a.initData);
      if (shaka.util.BufferUtils.toDataView(a).getUint32(0, !0) + 4 != a.byteLength)
        throw new RangeError('Malformed FairPlay init data');
      a = shaka.util.StringUtils.fromUTF16(a.subarray(4), !0);
      a = shaka.util.StringUtils.toUTF8(a);
      var b = new Event('encrypted');
      b.initDataType = 'skd';
      b.initData = shaka.util.BufferUtils.toArrayBuffer(a);
      this.dispatchEvent(b);
    };
    shaka.polyfill.PatchedMediaKeysApple.MediaKeySystemAccess = function (a, b) {
      shaka.log.debug('PatchedMediaKeysApple.MediaKeySystemAccess');
      this.keySystem = a;
      if (a.startsWith('com.apple.fps'))
        for (var c = $jscomp.makeIterator(b), d = c.next(); !d.done; d = c.next())
          if ((d = this.checkConfig_(d.value))) {
            this.configuration_ = d;
            return;
          }
      c = Error('Unsupported keySystem');
      c.name = 'NotSupportedError';
      c.code = DOMException.NOT_SUPPORTED_ERR;
      throw c;
    };
    shaka.polyfill.PatchedMediaKeysApple.MediaKeySystemAccess.prototype.checkConfig_ = function (a) {
      if ('required' == a.persistentState) return null;
      var b = {
          audioCapabilities: [],
          videoCapabilities: [],
          persistentState: 'optional',
          distinctiveIdentifier: 'optional',
          initDataTypes: a.initDataTypes,
          sessionTypes: ['temporary'],
          label: a.label,
        },
        c = !1,
        d = !1;
      if (a.audioCapabilities)
        for (var e = $jscomp.makeIterator(a.audioCapabilities), f = e.next(); !f.done; f = e.next())
          if (((f = f.value), f.contentType)) {
            c = !0;
            var g = f.contentType.split(';')[0];
            WebKitMediaKeys.isTypeSupported(this.keySystem, g) && (b.audioCapabilities.push(f), (d = !0));
          }
      if (a.videoCapabilities)
        for (a = $jscomp.makeIterator(a.videoCapabilities), f = a.next(); !f.done; f = a.next())
          (e = f.value),
            e.contentType &&
              ((c = !0),
              (f = e.contentType.split(';')[0]),
              WebKitMediaKeys.isTypeSupported(this.keySystem, f) && (b.videoCapabilities.push(e), (d = !0)));
      c || (d = WebKitMediaKeys.isTypeSupported(this.keySystem, 'video/mp4'));
      return d ? b : null;
    };
    shaka.polyfill.PatchedMediaKeysApple.MediaKeySystemAccess.prototype.createMediaKeys = function () {
      shaka.log.debug('PatchedMediaKeysApple.MediaKeySystemAccess.createMediaKeys');
      var a = new shaka.polyfill.PatchedMediaKeysApple.MediaKeys(this.keySystem);
      return Promise.resolve(a);
    };
    shaka.polyfill.PatchedMediaKeysApple.MediaKeySystemAccess.prototype.getConfiguration = function () {
      shaka.log.debug('PatchedMediaKeysApple.MediaKeySystemAccess.getConfiguration');
      return this.configuration_;
    };
    shaka.polyfill.PatchedMediaKeysApple.MediaKeys = function (a) {
      shaka.log.debug('PatchedMediaKeysApple.MediaKeys');
      this.nativeMediaKeys_ = new WebKitMediaKeys(a);
      this.eventManager_ = new shaka.util.EventManager();
    };
    shaka.polyfill.PatchedMediaKeysApple.MediaKeys.prototype.createSession = function (a) {
      shaka.log.debug('PatchedMediaKeysApple.MediaKeys.createSession');
      a = a || 'temporary';
      if ('temporary' != a) throw new TypeError('Session type ' + a + ' is unsupported on this platform.');
      return new shaka.polyfill.PatchedMediaKeysApple.MediaKeySession(this.nativeMediaKeys_, a);
    };
    shaka.polyfill.PatchedMediaKeysApple.MediaKeys.prototype.setServerCertificate = function (a) {
      shaka.log.debug('PatchedMediaKeysApple.MediaKeys.setServerCertificate');
      return Promise.resolve(!1);
    };
    shaka.polyfill.PatchedMediaKeysApple.MediaKeys.prototype.setMedia = function (a) {
      var b = this,
        c = shaka.polyfill.PatchedMediaKeysApple;
      this.eventManager_.removeAll();
      if (!a) return Promise.resolve();
      this.eventManager_.listen(a, 'webkitneedkey', c.onWebkitNeedKey_);
      try {
        return (
          shaka.util.MediaReadyState.waitForReadyState(
            a,
            HTMLMediaElement.HAVE_METADATA,
            this.eventManager_,
            function () {
              a.webkitSetMediaKeys(b.nativeMediaKeys_);
            },
          ),
          Promise.resolve()
        );
      } catch (d) {
        return Promise.reject(d);
      }
    };
    shaka.polyfill.PatchedMediaKeysApple.MediaKeySession = function (a, b) {
      shaka.log.debug('PatchedMediaKeysApple.MediaKeySession');
      shaka.util.FakeEventTarget.call(this);
      this.nativeMediaKeySession_ = null;
      this.nativeMediaKeys_ = a;
      this.updatePromise_ = this.generateRequestPromise_ = null;
      this.eventManager_ = new shaka.util.EventManager();
      this.sessionId = '';
      this.expiration = NaN;
      this.closed = new shaka.util.PublicPromise();
      this.keyStatuses = new shaka.polyfill.PatchedMediaKeysApple.MediaKeyStatusMap();
    };
    $jscomp.inherits(shaka.polyfill.PatchedMediaKeysApple.MediaKeySession, shaka.util.FakeEventTarget);
    shaka.polyfill.PatchedMediaKeysApple.MediaKeySession.prototype.generateRequest = function (a, b) {
      var c = this;
      shaka.log.debug('PatchedMediaKeysApple.MediaKeySession.generateRequest');
      this.generateRequestPromise_ = new shaka.util.PublicPromise();
      try {
        var d = this.nativeMediaKeys_.createSession('video/mp4', shaka.util.BufferUtils.toUint8(b));
        this.nativeMediaKeySession_ = d;
        this.sessionId = d.sessionId || '';
        this.eventManager_.listen(this.nativeMediaKeySession_, 'webkitkeymessage', function (e) {
          return c.onWebkitKeyMessage_(e);
        });
        this.eventManager_.listen(d, 'webkitkeyadded', function (e) {
          return c.onWebkitKeyAdded_(e);
        });
        this.eventManager_.listen(d, 'webkitkeyerror', function (e) {
          return c.onWebkitKeyError_(e);
        });
        this.updateKeyStatus_('status-pending');
      } catch (e) {
        this.generateRequestPromise_.reject(e);
      }
      return this.generateRequestPromise_;
    };
    shaka.polyfill.PatchedMediaKeysApple.MediaKeySession.prototype.load = function () {
      shaka.log.debug('PatchedMediaKeysApple.MediaKeySession.load');
      return Promise.reject(Error('MediaKeySession.load not yet supported'));
    };
    shaka.polyfill.PatchedMediaKeysApple.MediaKeySession.prototype.update = function (a) {
      shaka.log.debug('PatchedMediaKeysApple.MediaKeySession.update');
      this.updatePromise_ = new shaka.util.PublicPromise();
      try {
        this.nativeMediaKeySession_.update(shaka.util.BufferUtils.toUint8(a));
      } catch (b) {
        this.updatePromise_.reject(b);
      }
      return this.updatePromise_;
    };
    shaka.polyfill.PatchedMediaKeysApple.MediaKeySession.prototype.close = function () {
      shaka.log.debug('PatchedMediaKeysApple.MediaKeySession.close');
      try {
        this.nativeMediaKeySession_.close(), this.closed.resolve(), this.eventManager_.removeAll();
      } catch (a) {
        this.closed.reject(a);
      }
      return this.closed;
    };
    shaka.polyfill.PatchedMediaKeysApple.MediaKeySession.prototype.remove = function () {
      shaka.log.debug('PatchedMediaKeysApple.MediaKeySession.remove');
      return Promise.reject(
        Error(
          'MediaKeySession.remove is only applicable for persistent licenses, which are not supported on this platform',
        ),
      );
    };
    shaka.polyfill.PatchedMediaKeysApple.MediaKeySession.prototype.onWebkitKeyMessage_ = function (a) {
      shaka.log.debug('PatchedMediaKeysApple.onWebkitKeyMessage_', a);
      goog.asserts.assert(this.generateRequestPromise_, 'generateRequestPromise_ should be set before now!');
      this.generateRequestPromise_ && (this.generateRequestPromise_.resolve(), (this.generateRequestPromise_ = null));
      var b = void 0 == this.keyStatuses.getStatus();
      a = new shaka.util.FakeEvent('message', {
        messageType: b ? 'license-request' : 'license-renewal',
        message: shaka.util.BufferUtils.toArrayBuffer(a.message),
      });
      this.dispatchEvent(a);
    };
    shaka.polyfill.PatchedMediaKeysApple.MediaKeySession.prototype.onWebkitKeyAdded_ = function (a) {
      shaka.log.debug('PatchedMediaKeysApple.onWebkitKeyAdded_', a);
      goog.asserts.assert(!this.generateRequestPromise_, 'Key added during generate!');
      goog.asserts.assert(this.updatePromise_, 'updatePromise_ should be set before now!');
      this.updatePromise_ &&
        (this.updateKeyStatus_('usable'), this.updatePromise_.resolve(), (this.updatePromise_ = null));
    };
    shaka.polyfill.PatchedMediaKeysApple.MediaKeySession.prototype.onWebkitKeyError_ = function (a) {
      shaka.log.debug('PatchedMediaKeysApple.onWebkitKeyError_', a);
      a = Error('EME PatchedMediaKeysApple key error');
      a.errorCode = this.nativeMediaKeySession_.error;
      if (null != this.generateRequestPromise_)
        this.generateRequestPromise_.reject(a), (this.generateRequestPromise_ = null);
      else if (null != this.updatePromise_) this.updatePromise_.reject(a), (this.updatePromise_ = null);
      else
        switch (this.nativeMediaKeySession_.error.code) {
          case WebKitMediaKeyError.MEDIA_KEYERR_OUTPUT:
          case WebKitMediaKeyError.MEDIA_KEYERR_HARDWARECHANGE:
            this.updateKeyStatus_('output-not-allowed');
            break;
          default:
            this.updateKeyStatus_('internal-error');
        }
    };
    shaka.polyfill.PatchedMediaKeysApple.MediaKeySession.prototype.updateKeyStatus_ = function (a) {
      this.keyStatuses.setStatus(a);
      a = new shaka.util.FakeEvent('keystatuseschange');
      this.dispatchEvent(a);
    };
    shaka.polyfill.PatchedMediaKeysApple.MediaKeyStatusMap = function () {
      this.size = 0;
      this.status_ = void 0;
    };
    shaka.polyfill.PatchedMediaKeysApple.MediaKeyStatusMap.prototype.setStatus = function (a) {
      this.size = void 0 == a ? 0 : 1;
      this.status_ = a;
    };
    shaka.polyfill.PatchedMediaKeysApple.MediaKeyStatusMap.prototype.getStatus = function () {
      return this.status_;
    };
    shaka.polyfill.PatchedMediaKeysApple.MediaKeyStatusMap.prototype.forEach = function (a) {
      this.status_ && a(this.status_, shaka.media.DrmEngine.DUMMY_KEY_ID.value());
    };
    shaka.polyfill.PatchedMediaKeysApple.MediaKeyStatusMap.prototype.get = function (a) {
      if (this.has(a)) return this.status_;
    };
    shaka.polyfill.PatchedMediaKeysApple.MediaKeyStatusMap.prototype.has = function (a) {
      var b = shaka.media.DrmEngine.DUMMY_KEY_ID.value();
      return this.status_ && shaka.util.BufferUtils.equal(a, b) ? !0 : !1;
    };
    shaka.polyfill.PatchedMediaKeysApple.MediaKeyStatusMap.prototype.entries = function () {
      goog.asserts.assert(!1, 'Not used!  Provided only for the compiler.');
    };
    shaka.polyfill.PatchedMediaKeysApple.MediaKeyStatusMap.prototype.keys = function () {
      goog.asserts.assert(!1, 'Not used!  Provided only for the compiler.');
    };
    shaka.polyfill.PatchedMediaKeysApple.MediaKeyStatusMap.prototype.values = function () {
      goog.asserts.assert(!1, 'Not used!  Provided only for the compiler.');
    };
    shaka.polyfill.register(shaka.polyfill.PatchedMediaKeysApple.install);
    shaka.polyfill.PatchedMediaKeysMs = function () {};
    shaka.polyfill.PatchedMediaKeysMs.install = function () {
      if (
        window.HTMLVideoElement &&
        window.MSMediaKeys &&
        (!navigator.requestMediaKeySystemAccess || !MediaKeySystemAccess.prototype.getConfiguration)
      ) {
        shaka.log.info('Using ms-prefixed EME v20140218');
        var a = shaka.polyfill.PatchedMediaKeysMs;
        delete HTMLMediaElement.prototype.mediaKeys;
        HTMLMediaElement.prototype.mediaKeys = null;
        window.MediaKeys = a.MediaKeys;
        window.MediaKeySystemAccess = a.MediaKeySystemAccess;
        navigator.requestMediaKeySystemAccess = a.requestMediaKeySystemAccess;
        HTMLMediaElement.prototype.setMediaKeys = a.MediaKeySystemAccess.setMediaKeys;
      }
    };
    shaka.polyfill.PatchedMediaKeysMs.requestMediaKeySystemAccess = function (a, b) {
      shaka.log.debug('PatchedMediaKeysMs.requestMediaKeySystemAccess');
      goog.asserts.assert(this == navigator, 'bad "this" for requestMediaKeySystemAccess');
      var c = shaka.polyfill.PatchedMediaKeysMs;
      try {
        var d = new c.MediaKeySystemAccess(a, b);
        return Promise.resolve(d);
      } catch (e) {
        return Promise.reject(e);
      }
    };
    shaka.polyfill.PatchedMediaKeysMs.onMsNeedKey_ = function (a) {
      shaka.log.debug('PatchedMediaKeysMs.onMsNeedKey_', a);
      if (a.initData) {
        var b = document.createEvent('CustomEvent');
        b.initCustomEvent('encrypted', !1, !1, null);
        b.initDataType = 'cenc';
        b.initData = shaka.util.BufferUtils.toArrayBuffer(shaka.util.Pssh.normaliseInitData(a.initData));
        this.dispatchEvent(b);
      }
    };
    shaka.polyfill.PatchedMediaKeysMs.MediaKeySystemAccess = function (a, b) {
      shaka.log.debug('PatchedMediaKeysMs.MediaKeySystemAccess');
      this.keySystem = a;
      for (var c = !1, d = $jscomp.makeIterator(b), e = d.next(); !e.done; e = d.next()) {
        e = e.value;
        var f = {
            audioCapabilities: [],
            videoCapabilities: [],
            persistentState: 'optional',
            distinctiveIdentifier: 'optional',
            initDataTypes: e.initDataTypes,
            sessionTypes: ['temporary'],
            label: e.label,
          },
          g = !1;
        if (e.audioCapabilities)
          for (var h = $jscomp.makeIterator(e.audioCapabilities), k = h.next(); !k.done; k = h.next())
            if (((k = k.value), k.contentType)) {
              g = !0;
              var l = k.contentType.split(';')[0];
              MSMediaKeys.isTypeSupported(this.keySystem, l) && (f.audioCapabilities.push(k), (c = !0));
            }
        if (e.videoCapabilities)
          for (h = $jscomp.makeIterator(e.videoCapabilities), k = h.next(); !k.done; k = h.next())
            (k = k.value),
              k.contentType &&
                ((g = !0),
                (l = k.contentType.split(';')[0]),
                MSMediaKeys.isTypeSupported(this.keySystem, l) && (f.videoCapabilities.push(k), (c = !0)));
        g || (c = MSMediaKeys.isTypeSupported(this.keySystem, 'video/mp4'));
        'required' == e.persistentState && (c = !1);
        if (c) {
          this.configuration_ = f;
          return;
        }
      }
      c = Error('Unsupported keySystem');
      c.name = 'NotSupportedError';
      c.code = DOMException.NOT_SUPPORTED_ERR;
      throw c;
    };
    shaka.polyfill.PatchedMediaKeysMs.MediaKeySystemAccess.prototype.createMediaKeys = function () {
      shaka.log.debug('PatchedMediaKeysMs.MediaKeySystemAccess.createMediaKeys');
      var a = new shaka.polyfill.PatchedMediaKeysMs.MediaKeys(this.keySystem);
      return Promise.resolve(a);
    };
    shaka.polyfill.PatchedMediaKeysMs.MediaKeySystemAccess.prototype.getConfiguration = function () {
      shaka.log.debug('PatchedMediaKeysMs.MediaKeySystemAccess.getConfiguration');
      return this.configuration_;
    };
    shaka.polyfill.PatchedMediaKeysMs.MediaKeySystemAccess.setMediaKeys = function (a) {
      shaka.log.debug('PatchedMediaKeysMs.setMediaKeys');
      goog.asserts.assert(this instanceof HTMLMediaElement, 'bad "this" for setMediaKeys');
      var b = shaka.polyfill.PatchedMediaKeysMs,
        c = this.mediaKeys;
      c &&
        c != a &&
        (goog.asserts.assert(c instanceof b.MediaKeys, 'non-polyfill instance of oldMediaKeys'), c.setMedia(null));
      delete this.mediaKeys;
      return (this.mediaKeys = a)
        ? (goog.asserts.assert(a instanceof b.MediaKeys, 'non-polyfill instance of newMediaKeys'), a.setMedia(this))
        : Promise.resolve();
    };
    shaka.polyfill.PatchedMediaKeysMs.MediaKeys = function (a) {
      shaka.log.debug('PatchedMediaKeysMs.MediaKeys');
      this.nativeMediaKeys_ = new MSMediaKeys(a);
      this.eventManager_ = new shaka.util.EventManager();
    };
    shaka.polyfill.PatchedMediaKeysMs.MediaKeys.prototype.createSession = function (a) {
      shaka.log.debug('PatchedMediaKeysMs.MediaKeys.createSession');
      a = a || 'temporary';
      if ('temporary' != a) throw new TypeError('Session type ' + a + ' is unsupported on this platform.');
      return new shaka.polyfill.PatchedMediaKeysMs.MediaKeySession(this.nativeMediaKeys_, a);
    };
    shaka.polyfill.PatchedMediaKeysMs.MediaKeys.prototype.setServerCertificate = function (a) {
      shaka.log.debug('PatchedMediaKeysMs.MediaKeys.setServerCertificate');
      return Promise.resolve(!1);
    };
    shaka.polyfill.PatchedMediaKeysMs.MediaKeys.prototype.setMedia = function (a) {
      var b = this,
        c = shaka.polyfill.PatchedMediaKeysMs;
      this.eventManager_.removeAll();
      if (!a) return Promise.resolve();
      this.eventManager_.listen(a, 'msneedkey', c.onMsNeedKey_);
      try {
        return (
          shaka.util.MediaReadyState.waitForReadyState(
            a,
            HTMLMediaElement.HAVE_METADATA,
            this.eventManager_,
            function () {
              a.msSetMediaKeys(b.nativeMediaKeys_);
            },
          ),
          Promise.resolve()
        );
      } catch (d) {
        return Promise.reject(d);
      }
    };
    shaka.polyfill.PatchedMediaKeysMs.MediaKeySession = function (a, b) {
      shaka.log.debug('PatchedMediaKeysMs.MediaKeySession');
      shaka.util.FakeEventTarget.call(this);
      this.nativeMediaKeySession_ = null;
      this.nativeMediaKeys_ = a;
      this.updatePromise_ = this.generateRequestPromise_ = null;
      this.eventManager_ = new shaka.util.EventManager();
      this.sessionId = '';
      this.expiration = NaN;
      this.closed = new shaka.util.PublicPromise();
      this.keyStatuses = new shaka.polyfill.PatchedMediaKeysMs.MediaKeyStatusMap();
    };
    $jscomp.inherits(shaka.polyfill.PatchedMediaKeysMs.MediaKeySession, shaka.util.FakeEventTarget);
    shaka.polyfill.PatchedMediaKeysMs.MediaKeySession.prototype.generateRequest = function (a, b) {
      var c = this;
      shaka.log.debug('PatchedMediaKeysMs.MediaKeySession.generateRequest');
      this.generateRequestPromise_ = new shaka.util.PublicPromise();
      try {
        (this.nativeMediaKeySession_ = this.nativeMediaKeys_.createSession(
          'video/mp4',
          shaka.util.BufferUtils.toUint8(b),
          null,
        )),
          this.eventManager_.listen(this.nativeMediaKeySession_, 'mskeymessage', function (d) {
            return c.onMsKeyMessage_(d);
          }),
          this.eventManager_.listen(this.nativeMediaKeySession_, 'mskeyadded', function (d) {
            return c.onMsKeyAdded_(d);
          }),
          this.eventManager_.listen(this.nativeMediaKeySession_, 'mskeyerror', function (d) {
            return c.onMsKeyError_(d);
          }),
          this.updateKeyStatus_('status-pending');
      } catch (d) {
        this.generateRequestPromise_.reject(d);
      }
      return this.generateRequestPromise_;
    };
    shaka.polyfill.PatchedMediaKeysMs.MediaKeySession.prototype.load = function () {
      shaka.log.debug('PatchedMediaKeysMs.MediaKeySession.load');
      return Promise.reject(Error('MediaKeySession.load not yet supported'));
    };
    shaka.polyfill.PatchedMediaKeysMs.MediaKeySession.prototype.update = function (a) {
      shaka.log.debug('PatchedMediaKeysMs.MediaKeySession.update');
      this.updatePromise_ = new shaka.util.PublicPromise();
      try {
        this.nativeMediaKeySession_.update(shaka.util.BufferUtils.toUint8(a));
      } catch (b) {
        this.updatePromise_.reject(b);
      }
      return this.updatePromise_;
    };
    shaka.polyfill.PatchedMediaKeysMs.MediaKeySession.prototype.close = function () {
      shaka.log.debug('PatchedMediaKeysMs.MediaKeySession.close');
      try {
        this.nativeMediaKeySession_.close(), this.closed.resolve(), this.eventManager_.removeAll();
      } catch (a) {
        this.closed.reject(a);
      }
      return this.closed;
    };
    shaka.polyfill.PatchedMediaKeysMs.MediaKeySession.prototype.remove = function () {
      shaka.log.debug('PatchedMediaKeysMs.MediaKeySession.remove');
      return Promise.reject(
        Error(
          'MediaKeySession.remove is only applicable for persistent licenses, which are not supported on this platform',
        ),
      );
    };
    shaka.polyfill.PatchedMediaKeysMs.MediaKeySession.prototype.onMsKeyMessage_ = function (a) {
      shaka.log.debug('PatchedMediaKeysMs.onMsKeyMessage_', a);
      goog.asserts.assert(this.generateRequestPromise_, 'generateRequestPromise_ not set in onMsKeyMessage_');
      this.generateRequestPromise_ && (this.generateRequestPromise_.resolve(), (this.generateRequestPromise_ = null));
      var b = void 0 == this.keyStatuses.getStatus();
      a = new shaka.util.FakeEvent('message', {
        messageType: b ? 'license-request' : 'license-renewal',
        message: shaka.util.BufferUtils.toArrayBuffer(a.message),
      });
      this.dispatchEvent(a);
    };
    shaka.polyfill.PatchedMediaKeysMs.MediaKeySession.prototype.onMsKeyAdded_ = function (a) {
      shaka.log.debug('PatchedMediaKeysMs.onMsKeyAdded_', a);
      this.generateRequestPromise_
        ? (shaka.log.debug('Simulating completion for a PR persistent license.'),
          goog.asserts.assert(!this.updatePromise_, 'updatePromise_ and generateRequestPromise_ set in onMsKeyAdded_'),
          this.updateKeyStatus_('usable'),
          this.generateRequestPromise_.resolve(),
          (this.generateRequestPromise_ = null))
        : (goog.asserts.assert(this.updatePromise_, 'updatePromise_ not set in onMsKeyAdded_'),
          this.updatePromise_ &&
            (this.updateKeyStatus_('usable'), this.updatePromise_.resolve(), (this.updatePromise_ = null)));
    };
    shaka.polyfill.PatchedMediaKeysMs.MediaKeySession.prototype.onMsKeyError_ = function (a) {
      shaka.log.debug('PatchedMediaKeysMs.onMsKeyError_', a);
      a = Error('EME PatchedMediaKeysMs key error');
      a.errorCode = this.nativeMediaKeySession_.error;
      if (null != this.generateRequestPromise_)
        this.generateRequestPromise_.reject(a), (this.generateRequestPromise_ = null);
      else if (null != this.updatePromise_) this.updatePromise_.reject(a), (this.updatePromise_ = null);
      else
        switch (this.nativeMediaKeySession_.error.code) {
          case MSMediaKeyError.MS_MEDIA_KEYERR_OUTPUT:
          case MSMediaKeyError.MS_MEDIA_KEYERR_HARDWARECHANGE:
            this.updateKeyStatus_('output-not-allowed');
            break;
          default:
            this.updateKeyStatus_('internal-error');
        }
    };
    shaka.polyfill.PatchedMediaKeysMs.MediaKeySession.prototype.updateKeyStatus_ = function (a) {
      this.keyStatuses.setStatus(a);
      a = new shaka.util.FakeEvent('keystatuseschange');
      this.dispatchEvent(a);
    };
    shaka.polyfill.PatchedMediaKeysMs.MediaKeyStatusMap = function () {
      this.size = 0;
      this.status_ = void 0;
    };
    shaka.polyfill.PatchedMediaKeysMs.MediaKeyStatusMap.prototype.setStatus = function (a) {
      this.size = void 0 == a ? 0 : 1;
      this.status_ = a;
    };
    shaka.polyfill.PatchedMediaKeysMs.MediaKeyStatusMap.prototype.getStatus = function () {
      return this.status_;
    };
    shaka.polyfill.PatchedMediaKeysMs.MediaKeyStatusMap.prototype.forEach = function (a) {
      this.status_ && a(this.status_, shaka.media.DrmEngine.DUMMY_KEY_ID.value());
    };
    shaka.polyfill.PatchedMediaKeysMs.MediaKeyStatusMap.prototype.get = function (a) {
      if (this.has(a)) return this.status_;
    };
    shaka.polyfill.PatchedMediaKeysMs.MediaKeyStatusMap.prototype.has = function (a) {
      var b = shaka.media.DrmEngine.DUMMY_KEY_ID.value();
      return this.status_ && shaka.util.BufferUtils.equal(a, b) ? !0 : !1;
    };
    shaka.polyfill.PatchedMediaKeysMs.MediaKeyStatusMap.prototype.entries = function () {
      goog.asserts.assert(!1, 'Not used!  Provided only for the compiler.');
    };
    shaka.polyfill.PatchedMediaKeysMs.MediaKeyStatusMap.prototype.keys = function () {
      goog.asserts.assert(!1, 'Not used!  Provided only for the compiler.');
    };
    shaka.polyfill.PatchedMediaKeysMs.MediaKeyStatusMap.prototype.values = function () {
      goog.asserts.assert(!1, 'Not used!  Provided only for the compiler.');
    };
    shaka.polyfill.register(shaka.polyfill.PatchedMediaKeysMs.install);
    shaka.polyfill.PatchedMediaKeysNop = function () {};
    shaka.polyfill.PatchedMediaKeysNop.install = function () {
      if (
        !(
          !window.HTMLVideoElement ||
          (navigator.requestMediaKeySystemAccess && MediaKeySystemAccess.prototype.getConfiguration)
        )
      ) {
        shaka.log.info('EME not available.');
        var a = shaka.polyfill.PatchedMediaKeysNop;
        navigator.requestMediaKeySystemAccess = a.requestMediaKeySystemAccess;
        delete HTMLMediaElement.prototype.mediaKeys;
        HTMLMediaElement.prototype.mediaKeys = null;
        HTMLMediaElement.prototype.setMediaKeys = a.setMediaKeys;
        window.MediaKeys = a.MediaKeys;
        window.MediaKeySystemAccess = a.MediaKeySystemAccess;
      }
    };
    shaka.polyfill.PatchedMediaKeysNop.requestMediaKeySystemAccess = function (a, b) {
      shaka.log.debug('PatchedMediaKeysNop.requestMediaKeySystemAccess');
      goog.asserts.assert(this == navigator, 'bad "this" for requestMediaKeySystemAccess');
      return Promise.reject(Error('The key system specified is not supported.'));
    };
    shaka.polyfill.PatchedMediaKeysNop.setMediaKeys = function (a) {
      shaka.log.debug('PatchedMediaKeysNop.setMediaKeys');
      goog.asserts.assert(this instanceof HTMLMediaElement, 'bad "this" for setMediaKeys');
      return null == a ? Promise.resolve() : Promise.reject(Error('MediaKeys not supported.'));
    };
    shaka.polyfill.PatchedMediaKeysNop.MediaKeys = function () {
      throw new TypeError('Illegal constructor.');
    };
    shaka.polyfill.PatchedMediaKeysNop.MediaKeys.prototype.createSession = function () {};
    shaka.polyfill.PatchedMediaKeysNop.MediaKeys.prototype.setServerCertificate = function () {};
    shaka.polyfill.PatchedMediaKeysNop.MediaKeySystemAccess = function () {
      this.keySystem = '';
      throw new TypeError('Illegal constructor.');
    };
    shaka.polyfill.PatchedMediaKeysNop.MediaKeySystemAccess.prototype.getConfiguration = function () {};
    shaka.polyfill.PatchedMediaKeysNop.MediaKeySystemAccess.prototype.createMediaKeys = function () {};
    shaka.polyfill.register(shaka.polyfill.PatchedMediaKeysNop.install, -10);
    shaka.polyfill.PatchedMediaKeysWebkit = function () {};
    shaka.polyfill.PatchedMediaKeysWebkit.install = function () {
      var a = shaka.polyfill.PatchedMediaKeysWebkit;
      if (
        !(
          !window.HTMLVideoElement ||
          (navigator.requestMediaKeySystemAccess && MediaKeySystemAccess.prototype.getConfiguration)
        )
      ) {
        if (HTMLMediaElement.prototype.webkitGenerateKeyRequest)
          shaka.log.info('Using webkit-prefixed EME v0.1b'), (a.prefix_ = 'webkit');
        else if (HTMLMediaElement.prototype.generateKeyRequest) shaka.log.info('Using nonprefixed EME v0.1b');
        else return;
        goog.asserts.assert(
          HTMLMediaElement.prototype[a.prefixApi_('generateKeyRequest')],
          'PatchedMediaKeysWebkit APIs not available!',
        );
        navigator.requestMediaKeySystemAccess = a.requestMediaKeySystemAccess;
        delete HTMLMediaElement.prototype.mediaKeys;
        HTMLMediaElement.prototype.mediaKeys = null;
        HTMLMediaElement.prototype.setMediaKeys = a.setMediaKeys;
        window.MediaKeys = a.MediaKeys;
        window.MediaKeySystemAccess = a.MediaKeySystemAccess;
      }
    };
    shaka.polyfill.PatchedMediaKeysWebkit.prefixApi_ = function (a) {
      var b = shaka.polyfill.PatchedMediaKeysWebkit.prefix_;
      return b ? b + a.charAt(0).toUpperCase() + a.slice(1) : a;
    };
    shaka.polyfill.PatchedMediaKeysWebkit.requestMediaKeySystemAccess = function (a, b) {
      shaka.log.debug('PatchedMediaKeysWebkit.requestMediaKeySystemAccess');
      goog.asserts.assert(this == navigator, 'bad "this" for requestMediaKeySystemAccess');
      var c = shaka.polyfill.PatchedMediaKeysWebkit;
      try {
        var d = new c.MediaKeySystemAccess(a, b);
        return Promise.resolve(d);
      } catch (e) {
        return Promise.reject(e);
      }
    };
    shaka.polyfill.PatchedMediaKeysWebkit.setMediaKeys = function (a) {
      shaka.log.debug('PatchedMediaKeysWebkit.setMediaKeys');
      goog.asserts.assert(this instanceof HTMLMediaElement, 'bad "this" for setMediaKeys');
      var b = shaka.polyfill.PatchedMediaKeysWebkit,
        c = this.mediaKeys;
      c &&
        c != a &&
        (goog.asserts.assert(c instanceof b.MediaKeys, 'non-polyfill instance of oldMediaKeys'), c.setMedia(null));
      delete this.mediaKeys;
      if ((this.mediaKeys = a))
        goog.asserts.assert(a instanceof b.MediaKeys, 'non-polyfill instance of newMediaKeys'), a.setMedia(this);
      return Promise.resolve();
    };
    shaka.polyfill.PatchedMediaKeysWebkit.getVideoElement_ = function () {
      var a = document.getElementsByTagName('video');
      return a.length ? a[0] : document.createElement('video');
    };
    shaka.polyfill.PatchedMediaKeysWebkit.MediaKeySystemAccess = function (a, b) {
      shaka.log.debug('PatchedMediaKeysWebkit.MediaKeySystemAccess');
      this.internalKeySystem_ = this.keySystem = a;
      var c = !1;
      'org.w3.clearkey' == a && ((this.internalKeySystem_ = 'webkit-org.w3.clearkey'), (c = !1));
      for (
        var d = !1,
          e = shaka.polyfill.PatchedMediaKeysWebkit.getVideoElement_(),
          f = $jscomp.makeIterator(b),
          g = f.next();
        !g.done;
        g = f.next()
      ) {
        g = g.value;
        var h = {
            audioCapabilities: [],
            videoCapabilities: [],
            persistentState: 'optional',
            distinctiveIdentifier: 'optional',
            initDataTypes: g.initDataTypes,
            sessionTypes: ['temporary'],
            label: g.label,
          },
          k = !1;
        if (g.audioCapabilities)
          for (var l = $jscomp.makeIterator(g.audioCapabilities), m = l.next(); !m.done; m = l.next())
            if (((m = m.value), m.contentType)) {
              k = !0;
              var n = m.contentType.split(';')[0];
              e.canPlayType(n, this.internalKeySystem_) && (h.audioCapabilities.push(m), (d = !0));
            }
        if (g.videoCapabilities)
          for (l = $jscomp.makeIterator(g.videoCapabilities), m = l.next(); !m.done; m = l.next())
            (m = m.value),
              m.contentType &&
                ((k = !0),
                e.canPlayType(m.contentType, this.internalKeySystem_) && (h.videoCapabilities.push(m), (d = !0)));
        k ||
          (d =
            e.canPlayType('video/mp4', this.internalKeySystem_) ||
            e.canPlayType('video/webm', this.internalKeySystem_));
        'required' == g.persistentState &&
          (c ? ((h.persistentState = 'required'), (h.sessionTypes = ['persistent-license'])) : (d = !1));
        if (d) {
          this.configuration_ = h;
          return;
        }
      }
      c = 'Unsupported keySystem';
      if ('org.w3.clearkey' == a || 'com.widevine.alpha' == a)
        c = 'None of the requested configurations were supported.';
      c = Error(c);
      c.name = 'NotSupportedError';
      c.code = DOMException.NOT_SUPPORTED_ERR;
      throw c;
    };
    shaka.polyfill.PatchedMediaKeysWebkit.MediaKeySystemAccess.prototype.createMediaKeys = function () {
      shaka.log.debug('PatchedMediaKeysWebkit.MediaKeySystemAccess.createMediaKeys');
      var a = new shaka.polyfill.PatchedMediaKeysWebkit.MediaKeys(this.internalKeySystem_);
      return Promise.resolve(a);
    };
    shaka.polyfill.PatchedMediaKeysWebkit.MediaKeySystemAccess.prototype.getConfiguration = function () {
      shaka.log.debug('PatchedMediaKeysWebkit.MediaKeySystemAccess.getConfiguration');
      return this.configuration_;
    };
    shaka.polyfill.PatchedMediaKeysWebkit.MediaKeys = function (a) {
      shaka.log.debug('PatchedMediaKeysWebkit.MediaKeys');
      this.keySystem_ = a;
      this.media_ = null;
      this.eventManager_ = new shaka.util.EventManager();
      this.newSessions_ = [];
      this.sessionMap_ = new Map();
    };
    shaka.polyfill.PatchedMediaKeysWebkit.MediaKeys.prototype.setMedia = function (a) {
      var b = this;
      this.media_ = a;
      this.eventManager_.removeAll();
      var c = shaka.polyfill.PatchedMediaKeysWebkit.prefix_;
      a &&
        (this.eventManager_.listen(a, c + 'needkey', function (d) {
          return b.onWebkitNeedKey_(d);
        }),
        this.eventManager_.listen(a, c + 'keymessage', function (d) {
          return b.onWebkitKeyMessage_(d);
        }),
        this.eventManager_.listen(a, c + 'keyadded', function (d) {
          return b.onWebkitKeyAdded_(d);
        }),
        this.eventManager_.listen(a, c + 'keyerror', function (d) {
          return b.onWebkitKeyError_(d);
        }));
    };
    shaka.polyfill.PatchedMediaKeysWebkit.MediaKeys.prototype.createSession = function (a) {
      shaka.log.debug('PatchedMediaKeysWebkit.MediaKeys.createSession');
      a = a || 'temporary';
      if ('temporary' != a && 'persistent-license' != a)
        throw new TypeError('Session type ' + a + ' is unsupported on this platform.');
      var b = shaka.polyfill.PatchedMediaKeysWebkit,
        c = this.media_ || document.createElement('video');
      c.src || (c.src = 'about:blank');
      a = new b.MediaKeySession(c, this.keySystem_, a);
      this.newSessions_.push(a);
      return a;
    };
    shaka.polyfill.PatchedMediaKeysWebkit.MediaKeys.prototype.setServerCertificate = function (a) {
      shaka.log.debug('PatchedMediaKeysWebkit.MediaKeys.setServerCertificate');
      return Promise.resolve(!1);
    };
    shaka.polyfill.PatchedMediaKeysWebkit.MediaKeys.prototype.onWebkitNeedKey_ = function (a) {
      shaka.log.debug('PatchedMediaKeysWebkit.onWebkitNeedKey_', a);
      goog.asserts.assert(this.media_, 'media_ not set in onWebkitNeedKey_');
      var b = document.createEvent('CustomEvent');
      b.initCustomEvent('encrypted', !1, !1, null);
      b.initDataType = 'cenc';
      b.initData = shaka.util.BufferUtils.toArrayBuffer(a.initData);
      this.media_.dispatchEvent(b);
    };
    shaka.polyfill.PatchedMediaKeysWebkit.MediaKeys.prototype.onWebkitKeyMessage_ = function (a) {
      shaka.log.debug('PatchedMediaKeysWebkit.onWebkitKeyMessage_', a);
      var b = this.findSession_(a.sessionId);
      if (b) {
        var c = void 0 == b.keyStatuses.getStatus();
        a = new shaka.util.FakeEvent('message', {
          messageType: c ? 'licenserequest' : 'licenserenewal',
          message: a.message,
        });
        b.generated();
        b.dispatchEvent(a);
      } else shaka.log.error('Session not found', a.sessionId);
    };
    shaka.polyfill.PatchedMediaKeysWebkit.MediaKeys.prototype.onWebkitKeyAdded_ = function (a) {
      shaka.log.debug('PatchedMediaKeysWebkit.onWebkitKeyAdded_', a);
      a = this.findSession_(a.sessionId);
      goog.asserts.assert(a, 'unable to find session in onWebkitKeyAdded_');
      a && a.ready();
    };
    shaka.polyfill.PatchedMediaKeysWebkit.MediaKeys.prototype.onWebkitKeyError_ = function (a) {
      shaka.log.debug('PatchedMediaKeysWebkit.onWebkitKeyError_', a);
      var b = this.findSession_(a.sessionId);
      goog.asserts.assert(b, 'unable to find session in onWebkitKeyError_');
      b && b.handleError(a);
    };
    shaka.polyfill.PatchedMediaKeysWebkit.MediaKeys.prototype.findSession_ = function (a) {
      var b = this.sessionMap_.get(a);
      return b
        ? (shaka.log.debug('PatchedMediaKeysWebkit.MediaKeys.findSession_', b), b)
        : (b = this.newSessions_.shift())
        ? ((b.sessionId = a),
          this.sessionMap_.set(a, b),
          shaka.log.debug('PatchedMediaKeysWebkit.MediaKeys.findSession_', b),
          b)
        : null;
    };
    shaka.polyfill.PatchedMediaKeysWebkit.MediaKeySession = function (a, b, c) {
      shaka.log.debug('PatchedMediaKeysWebkit.MediaKeySession');
      shaka.util.FakeEventTarget.call(this);
      this.media_ = a;
      this.initialized_ = !1;
      this.updatePromise_ = this.generatePromise_ = null;
      this.keySystem_ = b;
      this.type_ = c;
      this.sessionId = '';
      this.expiration = NaN;
      this.closed = new shaka.util.PublicPromise();
      this.keyStatuses = new shaka.polyfill.PatchedMediaKeysWebkit.MediaKeyStatusMap();
    };
    $jscomp.inherits(shaka.polyfill.PatchedMediaKeysWebkit.MediaKeySession, shaka.util.FakeEventTarget);
    shaka.polyfill.PatchedMediaKeysWebkit.MediaKeySession.prototype.generated = function () {
      shaka.log.debug('PatchedMediaKeysWebkit.MediaKeySession.generated');
      this.generatePromise_ && (this.generatePromise_.resolve(), (this.generatePromise_ = null));
    };
    shaka.polyfill.PatchedMediaKeysWebkit.MediaKeySession.prototype.ready = function () {
      shaka.log.debug('PatchedMediaKeysWebkit.MediaKeySession.ready');
      this.updateKeyStatus_('usable');
      this.updatePromise_ && this.updatePromise_.resolve();
      this.updatePromise_ = null;
    };
    shaka.polyfill.PatchedMediaKeysWebkit.MediaKeySession.prototype.handleError = function (a) {
      shaka.log.debug('PatchedMediaKeysWebkit.MediaKeySession.handleError', a);
      var b = Error('EME v0.1b key error'),
        c = a.errorCode;
      c.systemCode = a.systemCode;
      b.errorCode = c;
      !a.sessionId && this.generatePromise_
        ? (45 == a.systemCode && (b.message = 'Unsupported session type.'),
          this.generatePromise_.reject(b),
          (this.generatePromise_ = null))
        : a.sessionId && this.updatePromise_
        ? (this.updatePromise_.reject(b), (this.updatePromise_ = null))
        : ((b = a.systemCode),
          a.errorCode.code == MediaKeyError.MEDIA_KEYERR_OUTPUT
            ? this.updateKeyStatus_('output-restricted')
            : 1 == b
            ? this.updateKeyStatus_('expired')
            : this.updateKeyStatus_('internal-error'));
    };
    shaka.polyfill.PatchedMediaKeysWebkit.MediaKeySession.prototype.generate_ = function (a, b) {
      var c = this,
        d = shaka.polyfill.PatchedMediaKeysWebkit;
      if (this.initialized_) return Promise.reject(Error('The session is already initialized.'));
      this.initialized_ = !0;
      try {
        if ('persistent-license' == this.type_) {
          var e = shaka.util.StringUtils;
          if (b) var f = shaka.util.BufferUtils.toUint8(e.toUTF8('LOAD_SESSION|' + b));
          else {
            goog.asserts.assert(a, 'expecting init data');
            var g = e.toUTF8('PERSISTENT|');
            f = shaka.util.Uint8ArrayUtils.concat(g, a);
          }
        } else
          goog.asserts.assert('temporary' == this.type_, 'expected temporary session'),
            goog.asserts.assert(!b, 'unexpected offline session ID'),
            goog.asserts.assert(a, 'expecting init data'),
            (f = shaka.util.BufferUtils.toUint8(a));
        goog.asserts.assert(f, 'init data not set!');
      } catch (k) {
        return Promise.reject(k);
      }
      goog.asserts.assert(null == this.generatePromise_, 'generatePromise_ should be null');
      this.generatePromise_ = new shaka.util.PublicPromise();
      var h = d.prefixApi_('generateKeyRequest');
      try {
        this.media_[h](this.keySystem_, f);
      } catch (k) {
        if ('InvalidStateError' != k.name) return (this.generatePromise_ = null), Promise.reject(k);
        new shaka.util.Timer(function () {
          try {
            c.media_[h](c.keySystem_, f);
          } catch (l) {
            c.generatePromise_.reject(l), (c.generatePromise_ = null);
          }
        }).tickAfter(0.01);
      }
      return this.generatePromise_;
    };
    shaka.polyfill.PatchedMediaKeysWebkit.MediaKeySession.prototype.update_ = function (a, b) {
      var c = this,
        d = shaka.polyfill.PatchedMediaKeysWebkit;
      if (this.updatePromise_)
        this.updatePromise_
          .then(function () {
            return c.update_(a, b);
          })
          ['catch'](function () {
            return c.update_(a, b);
          });
      else {
        this.updatePromise_ = a;
        if ('webkit-org.w3.clearkey' == this.keySystem_) {
          var e = shaka.util.Uint8ArrayUtils;
          var f = shaka.util.StringUtils.fromUTF8(b);
          var g = JSON.parse(f);
          'oct' != g.keys[0].kty &&
            (this.updatePromise_.reject(Error('Response is not a valid JSON Web Key Set.')),
            (this.updatePromise_ = null));
          f = e.fromBase64(g.keys[0].k);
          e = e.fromBase64(g.keys[0].kid);
        } else (f = shaka.util.BufferUtils.toUint8(b)), (e = null);
        d = d.prefixApi_('addKey');
        try {
          this.media_[d](this.keySystem_, f, e, this.sessionId);
        } catch (h) {
          this.updatePromise_.reject(h), (this.updatePromise_ = null);
        }
      }
    };
    shaka.polyfill.PatchedMediaKeysWebkit.MediaKeySession.prototype.updateKeyStatus_ = function (a) {
      this.keyStatuses.setStatus(a);
      a = new shaka.util.FakeEvent('keystatuseschange');
      this.dispatchEvent(a);
    };
    shaka.polyfill.PatchedMediaKeysWebkit.MediaKeySession.prototype.generateRequest = function (a, b) {
      shaka.log.debug('PatchedMediaKeysWebkit.MediaKeySession.generateRequest');
      return this.generate_(b, null);
    };
    shaka.polyfill.PatchedMediaKeysWebkit.MediaKeySession.prototype.load = function (a) {
      shaka.log.debug('PatchedMediaKeysWebkit.MediaKeySession.load');
      return 'persistent-license' == this.type_
        ? this.generate_(null, a)
        : Promise.reject(Error('Not a persistent session.'));
    };
    shaka.polyfill.PatchedMediaKeysWebkit.MediaKeySession.prototype.update = function (a) {
      shaka.log.debug('PatchedMediaKeysWebkit.MediaKeySession.update', a);
      goog.asserts.assert(this.sessionId, 'update without session ID');
      var b = new shaka.util.PublicPromise();
      this.update_(b, a);
      return b;
    };
    shaka.polyfill.PatchedMediaKeysWebkit.MediaKeySession.prototype.close = function () {
      var a = shaka.polyfill.PatchedMediaKeysWebkit;
      shaka.log.debug('PatchedMediaKeysWebkit.MediaKeySession.close');
      if ('persistent-license' != this.type_) {
        if (!this.sessionId) return this.closed.reject(Error('The session is not callable.')), this.closed;
        a = a.prefixApi_('cancelKeyRequest');
        try {
          this.media_[a](this.keySystem_, this.sessionId);
        } catch (b) {}
      }
      this.closed.resolve();
      return this.closed;
    };
    shaka.polyfill.PatchedMediaKeysWebkit.MediaKeySession.prototype.remove = function () {
      shaka.log.debug('PatchedMediaKeysWebkit.MediaKeySession.remove');
      return 'persistent-license' != this.type_ ? Promise.reject(Error('Not a persistent session.')) : this.close();
    };
    shaka.polyfill.PatchedMediaKeysWebkit.MediaKeyStatusMap = function () {
      this.size = 0;
      this.status_ = void 0;
    };
    shaka.polyfill.PatchedMediaKeysWebkit.MediaKeyStatusMap.prototype.setStatus = function (a) {
      this.size = void 0 == a ? 0 : 1;
      this.status_ = a;
    };
    shaka.polyfill.PatchedMediaKeysWebkit.MediaKeyStatusMap.prototype.getStatus = function () {
      return this.status_;
    };
    shaka.polyfill.PatchedMediaKeysWebkit.MediaKeyStatusMap.prototype.forEach = function (a) {
      this.status_ && a(this.status_, shaka.media.DrmEngine.DUMMY_KEY_ID.value());
    };
    shaka.polyfill.PatchedMediaKeysWebkit.MediaKeyStatusMap.prototype.get = function (a) {
      if (this.has(a)) return this.status_;
    };
    shaka.polyfill.PatchedMediaKeysWebkit.MediaKeyStatusMap.prototype.has = function (a) {
      var b = shaka.media.DrmEngine.DUMMY_KEY_ID.value();
      return this.status_ && shaka.util.BufferUtils.equal(a, b) ? !0 : !1;
    };
    shaka.polyfill.PatchedMediaKeysWebkit.MediaKeyStatusMap.prototype.entries = function () {
      goog.asserts.assert(!1, 'Not used!  Provided only for compiler.');
    };
    shaka.polyfill.PatchedMediaKeysWebkit.MediaKeyStatusMap.prototype.keys = function () {
      goog.asserts.assert(!1, 'Not used!  Provided only for compiler.');
    };
    shaka.polyfill.PatchedMediaKeysWebkit.MediaKeyStatusMap.prototype.values = function () {
      goog.asserts.assert(!1, 'Not used!  Provided only for compiler.');
    };
    shaka.polyfill.PatchedMediaKeysWebkit.prefix_ = '';
    shaka.polyfill.register(shaka.polyfill.PatchedMediaKeysWebkit.install);
    shaka.polyfill.PiPWebkit = function () {};
    shaka.polyfill.PiPWebkit.install = function () {
      if (window.HTMLVideoElement) {
        var a = HTMLVideoElement.prototype;
        if ((!a.requestPictureInPicture || !document.exitPictureInPicture) && a.webkitSupportsPresentationMode) {
          var b = shaka.polyfill.PiPWebkit;
          shaka.log.debug('PiPWebkit.install');
          document.pictureInPictureEnabled = !0;
          document.pictureInPictureElement = null;
          a.requestPictureInPicture = b.requestPictureInPicture_;
          Object.defineProperty(a, 'disablePictureInPicture', {
            get: b.getDisablePictureInPicture_,
            set: b.setDisablePictureInPicture_,
            enumerable: !0,
            configurable: !0,
          });
          document.exitPictureInPicture = b.exitPictureInPicture_;
          document.addEventListener('webkitpresentationmodechanged', b.proxyEvent_, !0);
        }
      }
    };
    shaka.polyfill.PiPWebkit.proxyEvent_ = function (a) {
      a = a.target;
      if (a.webkitPresentationMode == shaka.polyfill.PiPWebkit.PIP_MODE_) {
        document.pictureInPictureElement = a;
        var b = new Event('enterpictureinpicture');
        a.dispatchEvent(b);
      } else
        document.pictureInPictureElement == a && (document.pictureInPictureElement = null),
          (b = new Event('leavepictureinpicture')),
          a.dispatchEvent(b);
    };
    shaka.polyfill.PiPWebkit.requestPictureInPicture_ = function () {
      var a = shaka.polyfill.PiPWebkit;
      return this.webkitSupportsPresentationMode(a.PIP_MODE_)
        ? (this.webkitSetPresentationMode(a.PIP_MODE_), (document.pictureInPictureElement = this), Promise.resolve())
        : Promise.reject(Error('PiP not allowed by video element'));
    };
    shaka.polyfill.PiPWebkit.exitPictureInPicture_ = function () {
      var a = shaka.polyfill.PiPWebkit,
        b = document.pictureInPictureElement;
      return b
        ? (b.webkitSetPresentationMode(a.INLINE_MODE_), (document.pictureInPictureElement = null), Promise.resolve())
        : Promise.reject(Error('No picture in picture element found'));
    };
    shaka.polyfill.PiPWebkit.getDisablePictureInPicture_ = function () {
      return this.hasAttribute('disablePictureInPicture')
        ? !0
        : !this.webkitSupportsPresentationMode(shaka.polyfill.PiPWebkit.PIP_MODE_);
    };
    shaka.polyfill.PiPWebkit.setDisablePictureInPicture_ = function (a) {
      a ? this.setAttribute('disablePictureInPicture', '') : this.removeAttribute('disablePictureInPicture');
    };
    shaka.polyfill.PiPWebkit.PIP_MODE_ = 'picture-in-picture';
    shaka.polyfill.PiPWebkit.INLINE_MODE_ = 'inline';
    shaka.polyfill.register(shaka.polyfill.PiPWebkit.install);
    shaka.polyfill.VideoPlayPromise = function () {};
    shaka.polyfill.VideoPlayPromise.install = function () {
      shaka.log.debug('VideoPlayPromise.install');
      if (window.HTMLMediaElement) {
        var a = HTMLMediaElement.prototype.play;
        HTMLMediaElement.prototype.play = function () {
          var b = a.apply(this);
          b && b['catch'](function () {});
          return b;
        };
      }
    };
    shaka.polyfill.register(shaka.polyfill.VideoPlayPromise.install);
    shaka.polyfill.VideoPlaybackQuality = function () {};
    shaka.polyfill.VideoPlaybackQuality.install = function () {
      if (window.HTMLVideoElement) {
        var a = HTMLVideoElement.prototype;
        !a.getVideoPlaybackQuality &&
          'webkitDroppedFrameCount' in a &&
          (a.getVideoPlaybackQuality = shaka.polyfill.VideoPlaybackQuality.webkit_);
      }
    };
    shaka.polyfill.VideoPlaybackQuality.webkit_ = function () {
      return {
        droppedVideoFrames: this.webkitDroppedFrameCount,
        totalVideoFrames: this.webkitDecodedFrameCount,
        corruptedVideoFrames: 0,
        creationTime: NaN,
        totalFrameDelay: 0,
      };
    };
    shaka.polyfill.register(shaka.polyfill.VideoPlaybackQuality.install);
    shaka.polyfill.VTTCue = function () {};
    shaka.polyfill.VTTCue.install = function () {
      if (window.VTTCue) shaka.log.info('Using native VTTCue.');
      else if (window.TextTrackCue) {
        var a = null,
          b = TextTrackCue.length;
        3 == b
          ? (shaka.log.info('Using VTTCue polyfill from 3 argument TextTrackCue.'),
            (a = shaka.polyfill.VTTCue.from3ArgsTextTrackCue_))
          : 6 == b
          ? (shaka.log.info('Using VTTCue polyfill from 6 argument TextTrackCue.'),
            (a = shaka.polyfill.VTTCue.from6ArgsTextTrackCue_))
          : shaka.polyfill.VTTCue.canUse3ArgsTextTrackCue_() &&
            (shaka.log.info('Using VTTCue polyfill from 3 argument TextTrackCue.'),
            (a = shaka.polyfill.VTTCue.from3ArgsTextTrackCue_));
        a
          ? (window.VTTCue = function (c, d, e) {
              return a(c, d, e);
            })
          : shaka.log.error('No recognized signature for TextTrackCue found!');
      } else shaka.log.error('VTTCue not available.');
    };
    shaka.polyfill.VTTCue.from3ArgsTextTrackCue_ = function (a, b, c) {
      return new window.TextTrackCue(a, b, c);
    };
    shaka.polyfill.VTTCue.from6ArgsTextTrackCue_ = function (a, b, c) {
      return new window.TextTrackCue(a + '-' + b + '-' + c, a, b, c);
    };
    shaka.polyfill.VTTCue.canUse3ArgsTextTrackCue_ = function () {
      try {
        return !!shaka.polyfill.VTTCue.from3ArgsTextTrackCue_(1, 2, '');
      } catch (a) {
        return !1;
      }
    };
    shaka.polyfill.register(shaka.polyfill.VTTCue.install);
    shaka.text.TtmlTextParser = function () {};
    shaka.text.TtmlTextParser.prototype.parseInit = function (a) {
      goog.asserts.assert(!1, 'TTML does not have init segments');
    };
    shaka.text.TtmlTextParser.prototype.parseMedia = function (a, b) {
      var c = shaka.text.TtmlTextParser,
        d = shaka.util.XmlUtils,
        e = c.parameterNs_,
        f = c.styleNs_,
        g = shaka.util.StringUtils.fromUTF8(a),
        h = [],
        k = new DOMParser(),
        l = null;
      if ('' == g) return h;
      try {
        l = k.parseFromString(g, 'text/xml');
      } catch (t) {
        throw new shaka.util.Error(
          shaka.util.Error.Severity.CRITICAL,
          shaka.util.Error.Category.TEXT,
          shaka.util.Error.Code.INVALID_XML,
          'Failed to parse TTML.',
        );
      }
      if (l) {
        if ((g = l.getElementsByTagName('parsererror')[0]))
          throw new shaka.util.Error(
            shaka.util.Error.Severity.CRITICAL,
            shaka.util.Error.Category.TEXT,
            shaka.util.Error.Code.INVALID_XML,
            g.textContent,
          );
        if ((l = l.getElementsByTagName('tt')[0])) {
          g = d.getAttributeNS(l, e, 'frameRate');
          k = d.getAttributeNS(l, e, 'subFrameRate');
          var m = d.getAttributeNS(l, e, 'frameRateMultiplier');
          var n = d.getAttributeNS(l, e, 'tickRate');
          var p = d.getAttributeNS(l, e, 'cellResolution');
          e = l.getAttribute('xml:space') || 'default';
          f = d.getAttributeNS(l, f, 'extent');
        } else
          throw new shaka.util.Error(
            shaka.util.Error.Severity.CRITICAL,
            shaka.util.Error.Category.TEXT,
            shaka.util.Error.Code.INVALID_XML,
            'TTML does not contain <tt> tag.',
          );
        if ('default' != e && 'preserve' != e)
          throw new shaka.util.Error(
            shaka.util.Error.Severity.CRITICAL,
            shaka.util.Error.Category.TEXT,
            shaka.util.Error.Code.INVALID_XML,
            'Invalid xml:space value: ' + e,
          );
        d = 'default' == e;
        e = new c.RateInfo_(g, k, m, n);
        g = c.getCellResolution_(p);
        k = c.getLeafNodes_(l.getElementsByTagName('metadata')[0]);
        m = c.getLeafNodes_(l.getElementsByTagName('styling')[0]);
        n = c.getLeafNodes_(l.getElementsByTagName('layout')[0]);
        p = [];
        for (var q = $jscomp.makeIterator(n), r = q.next(); !r.done; r = q.next())
          (r = c.parseCueRegion_(r.value, m, f)) && p.push(r);
        l = c.getLeafCues_(l.getElementsByTagName('body')[0]);
        l = $jscomp.makeIterator(l);
        for (f = l.next(); !f.done; f = l.next())
          (f = c.parseCue_(f.value, b.periodStart, e, k, m, n, p, d, !1, g)) && h.push(f);
      }
      return h;
    };
    shaka.text.TtmlTextParser.getLeafNodes_ = function (a) {
      var b = [];
      if (!a) return b;
      for (var c = $jscomp.makeIterator(a.childNodes), d = c.next(); !d.done; d = c.next())
        (d = d.value),
          d.nodeType == Node.ELEMENT_NODE &&
            'br' !== d.nodeName &&
            (goog.asserts.assert(d instanceof Element, 'Node should be Element!'),
            (d = shaka.text.TtmlTextParser.getLeafNodes_(d)),
            goog.asserts.assert(0 < d.length, 'Only a null Element should return no leaves!'),
            (b = b.concat(d)));
      b.length || b.push(a);
      return b;
    };
    shaka.text.TtmlTextParser.getLeafCues_ = function (a) {
      if (!a) return [];
      var b = [];
      a = $jscomp.makeIterator(a.childNodes);
      for (var c = a.next(); !c.done; c = a.next())
        (c = c.value),
          c instanceof Element &&
            (c.hasAttribute('begin') ? b.push(c) : (b = b.concat(shaka.text.TtmlTextParser.getLeafCues_(c))));
      return b;
    };
    shaka.text.TtmlTextParser.sanitizeTextContent_ = function (a, b) {
      for (var c = '', d = $jscomp.makeIterator(a.childNodes), e = d.next(); !e.done; e = d.next())
        (e = e.value),
          'br' == e.nodeName && a.childNodes[0] !== e
            ? (c += '\n')
            : e.childNodes && 0 < e.childNodes.length
            ? (c += shaka.text.TtmlTextParser.sanitizeTextContent_(e, b))
            : b
            ? ((e = e.textContent.trim()), (e = e.replace(/\s+/g, ' ')), (c += e))
            : (c += e.textContent);
      return c;
    };
    shaka.text.TtmlTextParser.parseCue_ = function (a, b, c, d, e, f, g, h, k, l) {
      if (k && 'br' == a.nodeName) return (a = new shaka.text.Cue(0, 0, '')), (a.spacer = !0), a;
      var m = /^[\s\n]*$/.test(a.textContent),
        n = a.nodeType == Node.ELEMENT_NODE && !a.hasAttribute('begin') && !a.hasAttribute('end');
      if (a.nodeType != Node.ELEMENT_NODE || (n && m) || (n && !k)) return null;
      m = shaka.text.TtmlTextParser.parseTime_(a.getAttribute('begin'), c);
      n = shaka.text.TtmlTextParser.parseTime_(a.getAttribute('end'), c);
      var p = shaka.text.TtmlTextParser.parseTime_(a.getAttribute('dur'), c);
      null == n && null != p && (n = m + p);
      if (!k && (null == m || null == n))
        throw new shaka.util.Error(
          shaka.util.Error.Severity.CRITICAL,
          shaka.util.Error.Category.TEXT,
          shaka.util.Error.Code.INVALID_TEXT_CUE,
        );
      m = k && null == m ? 0 : m + b;
      n = k && null == n ? 0 : n + b;
      p = '';
      k = [];
      if (
        Array.from(a.childNodes).some(function (w) {
          return w.nodeType == Node.TEXT_NODE && /\S+/.test(w.textContent);
        })
      )
        p = shaka.text.TtmlTextParser.sanitizeTextContent_(a, h);
      else
        for (var q = $jscomp.makeIterator(a.childNodes), r = q.next(); !r.done; r = q.next())
          if ((r = shaka.text.TtmlTextParser.parseCue_(r.value, b, c, d, e, f, g, h, !0, l)))
            (r.startTime = r.startTime || m), (r.endTime = r.endTime || n), k.push(r);
      b = new shaka.text.Cue(m, n, p);
      b.nestedCues = k;
      l && (b.cellResolution = l);
      if (
        (f = shaka.text.TtmlTextParser.getElementsFromCollection_(a, 'region', f, '')[0]) &&
        f.getAttribute('xml:id')
      ) {
        var t = f.getAttribute('xml:id');
        b.region = g.filter(function (w) {
          return w.id == t;
        })[0];
      }
      d = shaka.text.TtmlTextParser.getElementsFromCollection_(
        a,
        'backgroundImage',
        d,
        '#',
        shaka.text.TtmlTextParser.smpteNs_,
      )[0];
      shaka.text.TtmlTextParser.addStyle_(b, a, f, d, e);
      return b;
    };
    shaka.text.TtmlTextParser.parseCueRegion_ = function (a, b, c) {
      var d = shaka.text.TtmlTextParser,
        e = new shaka.text.CueRegion(),
        f = a.getAttribute('xml:id');
      if (!f)
        return (
          shaka.log.warning('TtmlTextParser parser encountered a region with no id. Region will be ignored.'), null
        );
      e.id = f;
      f = null;
      c && (f = d.percentValues_.exec(c) || d.pixelValues_.exec(c));
      c = f ? Number(f[1]) : null;
      f = f ? Number(f[2]) : null;
      var g, h;
      if ((g = d.getStyleAttributeFromRegion_(a, b, 'extent')))
        (g = (h = d.percentValues_.exec(g)) || d.pixelValues_.exec(g)),
          null != g &&
            ((e.width = null != c ? (100 * Number(g[1])) / c : Number(g[1])),
            (e.height = null != f ? (100 * Number(g[2])) / f : Number(g[2])),
            (e.widthUnits = h || null != c ? shaka.text.CueRegion.units.PERCENTAGE : shaka.text.CueRegion.units.PX),
            (e.heightUnits = h || null != f ? shaka.text.CueRegion.units.PERCENTAGE : shaka.text.CueRegion.units.PX));
      if ((a = d.getStyleAttributeFromRegion_(a, b, 'origin')))
        (g = (h = d.percentValues_.exec(a)) || d.pixelValues_.exec(a)),
          null != g &&
            ((e.viewportAnchorX = null != f ? (100 * Number(g[1])) / f : Number(g[1])),
            (e.viewportAnchorY = null != c ? (100 * Number(g[2])) / c : Number(g[2])),
            (e.viewportAnchorUnits =
              h || null != c ? shaka.text.CueRegion.units.PERCENTAGE : shaka.text.CueRegion.units.PX));
      return e;
    };
    shaka.text.TtmlTextParser.addStyle_ = function (a, b, c, d, e) {
      var f = shaka.text.TtmlTextParser,
        g = shaka.text.Cue;
      'rtl' == f.getStyleAttribute_(b, c, e, 'direction') && (a.direction = g.direction.HORIZONTAL_RIGHT_TO_LEFT);
      var h = f.getStyleAttribute_(b, c, e, 'writingMode');
      'tb' == h || 'tblr' == h
        ? (a.writingMode = g.writingMode.VERTICAL_LEFT_TO_RIGHT)
        : 'tbrl' == h
        ? (a.writingMode = g.writingMode.VERTICAL_RIGHT_TO_LEFT)
        : 'rltb' == h || 'rl' == h
        ? (a.direction = g.direction.HORIZONTAL_RIGHT_TO_LEFT)
        : h && (a.direction = g.direction.HORIZONTAL_LEFT_TO_RIGHT);
      (h = f.getStyleAttribute_(b, c, e, 'textAlign'))
        ? ((a.positionAlign = f.textAlignToPositionAlign_[h]),
          (a.lineAlign = f.textAlignToLineAlign_[h]),
          goog.asserts.assert(h.toUpperCase() in g.textAlign, h.toUpperCase() + ' Should be in Cue.textAlign values!'),
          (a.textAlign = g.textAlign[h.toUpperCase()]))
        : (a.textAlign = g.textAlign.START);
      if ((h = f.getStyleAttribute_(b, c, e, 'displayAlign')))
        goog.asserts.assert(
          h.toUpperCase() in g.displayAlign,
          h.toUpperCase() + ' Should be in Cue.displayAlign values!',
        ),
          (a.displayAlign = g.displayAlign[h.toUpperCase()]);
      if ((h = f.getStyleAttribute_(b, c, e, 'color'))) a.color = h;
      if ((h = f.getStyleAttribute_(b, c, e, 'backgroundColor'))) a.backgroundColor = h;
      if ((h = f.getStyleAttribute_(b, c, e, 'border'))) a.border = h;
      if ((h = f.getStyleAttribute_(b, c, e, 'fontFamily'))) a.fontFamily = h;
      (h = f.getStyleAttribute_(b, c, e, 'fontWeight')) && 'bold' == h && (a.fontWeight = g.fontWeight.BOLD);
      (h = f.getStyleAttribute_(b, c, e, 'wrapOption')) && 'noWrap' == h && (a.wrapLine = !1);
      (h = f.getStyleAttribute_(b, c, e, 'lineHeight')) && h.match(f.unitValues_) && (a.lineHeight = h);
      (h = f.getStyleAttribute_(b, c, e, 'fontSize')) &&
        (h.match(f.unitValues_) || h.match(f.percentValue_)) &&
        (a.fontSize = h);
      if ((h = f.getStyleAttribute_(b, c, e, 'fontStyle')))
        goog.asserts.assert(h.toUpperCase() in g.fontStyle, h.toUpperCase() + ' Should be in Cue.fontStyle values!'),
          (a.fontStyle = g.fontStyle[h.toUpperCase()]);
      d &&
        ((g = d.getAttribute('imagetype')),
        (h = d.getAttribute('encoding')),
        (d = d.textContent.trim()),
        'PNG' == g && 'Base64' == h && d && (a.backgroundImage = 'data:image/png;base64,' + d));
      (d = f.getStyleAttribute_(b, c, e, 'letterSpacing')) && d.match(f.unitValues_) && (a.letterSpacing = d);
      (d = f.getStyleAttribute_(b, c, e, 'linePadding')) && d.match(f.unitValues_) && (a.linePadding = d);
      if ((d = f.getStyleAttribute_(b, c, e, 'opacity'))) a.opacity = parseFloat(d);
      (c = f.getStyleAttributeFromRegion_(c, e, 'textDecoration')) && f.addTextDecoration_(a, c);
      (b = f.getStyleAttributeFromElement_(b, e, 'textDecoration')) && f.addTextDecoration_(a, b);
    };
    shaka.text.TtmlTextParser.addTextDecoration_ = function (a, b) {
      for (var c = shaka.text.Cue, d = $jscomp.makeIterator(b.split(' ')), e = d.next(); !e.done; e = d.next())
        switch (e.value) {
          case 'underline':
            a.textDecoration.includes(c.textDecoration.UNDERLINE) || a.textDecoration.push(c.textDecoration.UNDERLINE);
            break;
          case 'noUnderline':
            a.textDecoration.includes(c.textDecoration.UNDERLINE) &&
              shaka.util.ArrayUtils.remove(a.textDecoration, c.textDecoration.UNDERLINE);
            break;
          case 'lineThrough':
            a.textDecoration.includes(c.textDecoration.LINE_THROUGH) ||
              a.textDecoration.push(c.textDecoration.LINE_THROUGH);
            break;
          case 'noLineThrough':
            a.textDecoration.includes(c.textDecoration.LINE_THROUGH) &&
              shaka.util.ArrayUtils.remove(a.textDecoration, c.textDecoration.LINE_THROUGH);
            break;
          case 'overline':
            a.textDecoration.includes(c.textDecoration.OVERLINE) || a.textDecoration.push(c.textDecoration.OVERLINE);
            break;
          case 'noOverline':
            a.textDecoration.includes(c.textDecoration.OVERLINE) &&
              shaka.util.ArrayUtils.remove(a.textDecoration, c.textDecoration.OVERLINE);
        }
    };
    shaka.text.TtmlTextParser.getStyleAttribute_ = function (a, b, c, d) {
      var e = shaka.text.TtmlTextParser;
      return (a = e.getStyleAttributeFromElement_(a, c, d)) ? a : e.getStyleAttributeFromRegion_(b, c, d);
    };
    shaka.text.TtmlTextParser.getStyleAttributeFromRegion_ = function (a, b, c) {
      var d = shaka.util.XmlUtils,
        e = shaka.text.TtmlTextParser.styleNs_;
      if (!a) return null;
      var f = shaka.text.TtmlTextParser.getLeafNodes_(a);
      f = $jscomp.makeIterator(f);
      for (var g = f.next(); !g.done; g = f.next()) if ((g = d.getAttributeNS(g.value, e, c))) return g;
      return shaka.text.TtmlTextParser.getInheritedStyleAttribute_(a, b, c);
    };
    shaka.text.TtmlTextParser.getStyleAttributeFromElement_ = function (a, b, c) {
      var d = shaka.util.XmlUtils.getAttributeNS(a, shaka.text.TtmlTextParser.styleNs_, c);
      return d ? d : shaka.text.TtmlTextParser.getInheritedStyleAttribute_(a, b, c);
    };
    shaka.text.TtmlTextParser.getInheritedStyleAttribute_ = function (a, b, c) {
      var d = shaka.util.XmlUtils,
        e = shaka.text.TtmlTextParser.styleNs_,
        f = shaka.text.TtmlTextParser.styleEbuttsNs_;
      a = shaka.text.TtmlTextParser.getElementsFromCollection_(a, 'style', b, '');
      for (var g = null, h = 0; h < a.length; h++) {
        var k = d.getAttributeNS(a[h], f, c);
        k || (k = d.getAttributeNS(a[h], e, c));
        k || (k = shaka.text.TtmlTextParser.getStyleAttributeFromElement_(a[h], b, c));
        k && (g = k);
      }
      return g;
    };
    shaka.text.TtmlTextParser.getElementsFromCollection_ = function (a, b, c, d, e) {
      var f = [];
      if (!a || 1 > c.length) return f;
      if ((a = shaka.text.TtmlTextParser.getInheritedAttribute_(a, b, e)))
        for (a = a.split(' '), a = $jscomp.makeIterator(a), b = a.next(); !b.done; b = a.next()) {
          b = b.value;
          e = $jscomp.makeIterator(c);
          for (var g = e.next(); !g.done; g = e.next())
            if (((g = g.value), d + g.getAttribute('xml:id') == b)) {
              f.push(g);
              break;
            }
        }
      return f;
    };
    shaka.text.TtmlTextParser.getInheritedAttribute_ = function (a, b, c) {
      for (
        var d = null, e = shaka.util.XmlUtils;
        a && !(d = c ? e.getAttributeNS(a, c, b) : a.getAttribute(b)) && ((a = a.parentNode), a instanceof Element);

      );
      return d;
    };
    shaka.text.TtmlTextParser.parseTime_ = function (a, b) {
      var c = null,
        d = shaka.text.TtmlTextParser;
      d.timeColonFormatFrames_.test(a)
        ? (c = d.parseColonTimeWithFrames_(b, a))
        : d.timeColonFormat_.test(a)
        ? (c = d.parseTimeFromRegex_(d.timeColonFormat_, a))
        : d.timeColonFormatMilliseconds_.test(a)
        ? (c = d.parseTimeFromRegex_(d.timeColonFormatMilliseconds_, a))
        : d.timeFramesFormat_.test(a)
        ? (c = d.parseFramesTime_(b, a))
        : d.timeTickFormat_.test(a)
        ? (c = d.parseTickTime_(b, a))
        : d.timeHMSFormat_.test(a) && (c = d.parseTimeFromRegex_(d.timeHMSFormat_, a));
      return c;
    };
    shaka.text.TtmlTextParser.parseFramesTime_ = function (a, b) {
      var c = shaka.text.TtmlTextParser.timeFramesFormat_.exec(b);
      return Number(c[1]) / a.frameRate;
    };
    shaka.text.TtmlTextParser.parseTickTime_ = function (a, b) {
      var c = shaka.text.TtmlTextParser.timeTickFormat_.exec(b);
      return Number(c[1]) / a.tickRate;
    };
    shaka.text.TtmlTextParser.parseColonTimeWithFrames_ = function (a, b) {
      var c = shaka.text.TtmlTextParser.timeColonFormatFrames_.exec(b),
        d = Number(c[1]),
        e = Number(c[2]),
        f = Number(c[3]),
        g = Number(c[4]);
      g += (Number(c[5]) || 0) / a.subFrameRate;
      f += g / a.frameRate;
      return f + 60 * e + 3600 * d;
    };
    shaka.text.TtmlTextParser.parseTimeFromRegex_ = function (a, b) {
      var c = a.exec(b);
      return null == c || '' == c[0]
        ? null
        : (Number(c[4]) || 0) / 1e3 + (Number(c[3]) || 0) + 60 * (Number(c[2]) || 0) + 3600 * (Number(c[1]) || 0);
    };
    shaka.text.TtmlTextParser.getCellResolution_ = function (a) {
      if (!a) return null;
      var b = /^(\d+) (\d+)$/.exec(a);
      if (!b) return null;
      a = parseInt(b[1], 10);
      b = parseInt(b[2], 10);
      return { columns: a, rows: b };
    };
    goog.exportSymbol('shaka.text.TtmlTextParser', shaka.text.TtmlTextParser);
    goog.exportProperty(
      shaka.text.TtmlTextParser.prototype,
      'parseMedia',
      shaka.text.TtmlTextParser.prototype.parseMedia,
    );
    goog.exportProperty(
      shaka.text.TtmlTextParser.prototype,
      'parseInit',
      shaka.text.TtmlTextParser.prototype.parseInit,
    );
    shaka.text.TtmlTextParser.RateInfo_ = function (a, b, c, d) {
      this.frameRate = Number(a) || 30;
      this.subFrameRate = Number(b) || 1;
      this.tickRate = Number(d);
      0 == this.tickRate && (this.tickRate = a ? this.frameRate * this.subFrameRate : 1);
      c && (a = /^(\d+) (\d+)$/g.exec(c)) && (this.frameRate *= Number(a[1]) / Number(a[2]));
    };
    shaka.text.TtmlTextParser.percentValues_ = /^(\d{1,2}(?:\.\d+)?|100(?:\.0+)?)% (\d{1,2}(?:\.\d+)?|100(?:\.0+)?)%$/;
    shaka.text.TtmlTextParser.percentValue_ = /^(\d{1,2}(?:\.\d+)?|100)%$/;
    shaka.text.TtmlTextParser.unitValues_ = /^(\d+px|\d+em|\d*\.?\d+c)$/;
    shaka.text.TtmlTextParser.pixelValues_ = /^(\d+)px (\d+)px$/;
    shaka.text.TtmlTextParser.timeColonFormatFrames_ = /^(\d{2,}):(\d{2}):(\d{2}):(\d{2})\.?(\d+)?$/;
    shaka.text.TtmlTextParser.timeColonFormat_ = /^(?:(\d{2,}):)?(\d{2}):(\d{2})$/;
    shaka.text.TtmlTextParser.timeColonFormatMilliseconds_ = /^(?:(\d{2,}):)?(\d{2}):(\d{2}\.\d{2,})$/;
    shaka.text.TtmlTextParser.timeFramesFormat_ = /^(\d*(?:\.\d*)?)f$/;
    shaka.text.TtmlTextParser.timeTickFormat_ = /^(\d*(?:\.\d*)?)t$/;
    shaka.text.TtmlTextParser.timeHMSFormat_ = /^(?:(\d*(?:\.\d*)?)h)?(?:(\d*(?:\.\d*)?)m)?(?:(\d*(?:\.\d*)?)s)?(?:(\d*(?:\.\d*)?)ms)?$/;
    shaka.text.TtmlTextParser.textAlignToLineAlign_ = {
      left: shaka.text.Cue.lineAlign.START,
      center: shaka.text.Cue.lineAlign.CENTER,
      right: shaka.text.Cue.lineAlign.END,
      start: shaka.text.Cue.lineAlign.START,
      end: shaka.text.Cue.lineAlign.END,
    };
    shaka.text.TtmlTextParser.textAlignToPositionAlign_ = {
      left: shaka.text.Cue.positionAlign.LEFT,
      center: shaka.text.Cue.positionAlign.CENTER,
      right: shaka.text.Cue.positionAlign.RIGHT,
    };
    shaka.text.TtmlTextParser.parameterNs_ = 'http://www.w3.org/ns/ttml#parameter';
    shaka.text.TtmlTextParser.styleNs_ = 'http://www.w3.org/ns/ttml#styling';
    shaka.text.TtmlTextParser.styleEbuttsNs_ = 'urn:ebu:tt:style';
    shaka.text.TtmlTextParser.smpteNs_ = 'http://www.smpte-ra.org/schemas/2052-1/2010/smpte-tt';
    shaka.text.TextEngine.registerParser('application/ttml+xml', function () {
      return new shaka.text.TtmlTextParser();
    });
    shaka.text.Mp4TtmlParser = function () {
      this.parser_ = new shaka.text.TtmlTextParser();
    };
    shaka.text.Mp4TtmlParser.prototype.parseInit = function (a) {
      var b = shaka.util.Mp4Parser,
        c = !1;
      new b()
        .box('moov', b.children)
        .box('trak', b.children)
        .box('mdia', b.children)
        .box('minf', b.children)
        .box('stbl', b.children)
        .fullBox('stsd', b.sampleDescription)
        .box('stpp', function (d) {
          c = !0;
          d.parser.stop();
        })
        .parse(a);
      if (!c)
        throw new shaka.util.Error(
          shaka.util.Error.Severity.CRITICAL,
          shaka.util.Error.Category.TEXT,
          shaka.util.Error.Code.INVALID_MP4_TTML,
        );
    };
    shaka.text.Mp4TtmlParser.prototype.parseMedia = function (a, b) {
      var c = this,
        d = shaka.util.Mp4Parser,
        e = !1,
        f = [];
      new d()
        .box(
          'mdat',
          d.allData(function (g) {
            e = !0;
            f = f.concat(c.parser_.parseMedia(g, b));
          }),
        )
        .parse(a, !1);
      if (!e)
        throw new shaka.util.Error(
          shaka.util.Error.Severity.CRITICAL,
          shaka.util.Error.Category.TEXT,
          shaka.util.Error.Code.INVALID_MP4_TTML,
        );
      return f;
    };
    goog.exportSymbol('shaka.text.Mp4TtmlParser', shaka.text.Mp4TtmlParser);
    goog.exportProperty(
      shaka.text.Mp4TtmlParser.prototype,
      'parseMedia',
      shaka.text.Mp4TtmlParser.prototype.parseMedia,
    );
    goog.exportProperty(shaka.text.Mp4TtmlParser.prototype, 'parseInit', shaka.text.Mp4TtmlParser.prototype.parseInit);
    shaka.text.TextEngine.registerParser('application/mp4; codecs="stpp"', function () {
      return new shaka.text.Mp4TtmlParser();
    });
    shaka.text.TextEngine.registerParser('application/mp4; codecs="stpp.ttml.im1t"', function () {
      return new shaka.text.Mp4TtmlParser();
    });
    shaka.text.TextEngine.registerParser('application/mp4; codecs="stpp.TTML.im1t"', function () {
      return new shaka.text.Mp4TtmlParser();
    });
    shaka.text.VttTextParser = function () {};
    shaka.text.VttTextParser.prototype.parseInit = function (a) {
      goog.asserts.assert(!1, 'VTT does not have init segments');
    };
    shaka.text.VttTextParser.prototype.parseMedia = function (a, b) {
      var c = shaka.text.VttTextParser,
        d = shaka.util.StringUtils.fromUTF8(a);
      d = d.replace(/\r\n|\r(?=[^\n]|$)/gm, '\n');
      d = d.split(/\n{2,}/m);
      if (!/^WEBVTT($|[ \t\n])/m.test(d[0]))
        throw new shaka.util.Error(
          shaka.util.Error.Severity.CRITICAL,
          shaka.util.Error.Category.TEXT,
          shaka.util.Error.Code.INVALID_TEXT_HEADER,
        );
      var e = b.periodStart;
      if (d[0].includes('X-TIMESTAMP-MAP')) {
        var f = d[0].match(/LOCAL:((?:(\d{1,}):)?(\d{2}):(\d{2})\.(\d{3}))/m),
          g = d[0].match(/MPEGTS:(\d+)/m);
        if (f && g) {
          e = new shaka.util.TextParser(f[1]);
          e = shaka.text.VttTextParser.parseTime_(e);
          if (null == e)
            throw new shaka.util.Error(
              shaka.util.Error.Severity.CRITICAL,
              shaka.util.Error.Category.TEXT,
              shaka.util.Error.Code.INVALID_TEXT_HEADER,
            );
          g = Number(g[1]);
          f = shaka.text.VttTextParser.MPEG_TIMESCALE_;
          for (var h = shaka.text.VttTextParser.TS_ROLLOVER_ / f, k = b.segmentStart; k >= h; )
            (k -= h), (g += shaka.text.VttTextParser.TS_ROLLOVER_);
          e = b.periodStart + g / f - e;
        }
      }
      g = [];
      f = $jscomp.makeIterator(d[0].split('\n'));
      for (h = f.next(); !h.done; h = f.next())
        (h = h.value), /^Region:/.test(h) && ((h = c.parseRegion_(h)), g.push(h));
      f = [];
      d = $jscomp.makeIterator(d.slice(1));
      for (h = d.next(); !h.done; h = d.next()) (h = h.value.split('\n')), (h = c.parseCue_(h, e, g)) && f.push(h);
      return f;
    };
    shaka.text.VttTextParser.parseRegion_ = function (a) {
      var b = shaka.text.VttTextParser;
      a = new shaka.util.TextParser(a);
      var c = new shaka.text.CueRegion();
      a.readWord();
      a.skipWhitespace();
      for (var d = a.readWord(); d; )
        b.parseRegionSetting_(c, d) ||
          shaka.log.warning(
            'VTT parser encountered an invalid VTTRegion setting: ',
            d,
            ' The setting will be ignored.',
          ),
          a.skipWhitespace(),
          (d = a.readWord());
      return c;
    };
    shaka.text.VttTextParser.parseCue_ = function (a, b, c) {
      var d = shaka.text.VttTextParser;
      if ((1 == a.length && !a[0]) || /^NOTE($|[ \t])/.test(a[0]) || 'STYLE' == a[0]) return null;
      var e = null;
      a[0].includes('--\x3e') || ((e = a[0]), a.splice(0, 1));
      var f = new shaka.util.TextParser(a[0]),
        g = d.parseTime_(f),
        h = f.readRegex(/[ \t]+--\x3e[ \t]+/g),
        k = d.parseTime_(f);
      if (null == g || null == h || null == k)
        throw new shaka.util.Error(
          shaka.util.Error.Severity.CRITICAL,
          shaka.util.Error.Category.TEXT,
          shaka.util.Error.Code.INVALID_TEXT_CUE,
        );
      g += b;
      k += b;
      a = a.slice(1).join('\n').trim();
      g = new shaka.text.Cue(g, k, a);
      f.skipWhitespace();
      for (k = f.readWord(); k; )
        d.parseCueSetting(g, k, c) ||
          shaka.log.warning('VTT parser encountered an invalid VTT setting: ', k, ' The setting will be ignored.'),
          f.skipWhitespace(),
          (k = f.readWord());
      null != e && (g.id = e);
      return g;
    };
    shaka.text.VttTextParser.parseCueSetting = function (a, b, c) {
      var d = shaka.text.VttTextParser,
        e;
      if ((e = /^align:(start|middle|center|end|left|right)$/.exec(b))) d.setTextAlign_(a, e[1]);
      else if ((e = /^vertical:(lr|rl)$/.exec(b))) d.setVerticalWritingMode_(a, e[1]);
      else if ((e = /^size:([\d.]+)%$/.exec(b))) a.size = Number(e[1]);
      else if ((e = /^position:([\d.]+)%(?:,(line-left|line-right|center|start|end))?$/.exec(b)))
        (a.position = Number(e[1])), e[2] && d.setPositionAlign_(a, e[2]);
      else if ((e = /^region:(.*)$/.exec(b))) {
        if ((b = d.getRegionById_(c, e[1]))) a.region = b;
      } else return d.parsedLineValueAndInterpretation_(a, b);
      return !0;
    };
    shaka.text.VttTextParser.getRegionById_ = function (a, b) {
      var c = a.filter(function (d) {
        return d.id == b;
      });
      if (!c.length)
        return (
          shaka.log.warning('VTT parser could not find a region with id: ', b, ' The region will be ignored.'), null
        );
      goog.asserts.assert(1 == c.length, 'VTTRegion ids should be unique!');
      return c[0];
    };
    shaka.text.VttTextParser.parseRegionSetting_ = function (a, b) {
      var c;
      if ((c = /^id=(.*)$/.exec(b))) a.id = c[1];
      else if ((c = /^width=(\d{1,2}|100)%$/.exec(b))) a.width = Number(c[1]);
      else if ((c = /^lines=(\d+)$/.exec(b)))
        (a.height = Number(c[1])), (a.heightUnits = shaka.text.CueRegion.units.LINES);
      else if ((c = /^regionanchor=(\d{1,2}|100)%,(\d{1,2}|100)%$/.exec(b)))
        (a.regionAnchorX = Number(c[1])), (a.regionAnchorY = Number(c[2]));
      else if ((c = /^viewportanchor=(\d{1,2}|100)%,(\d{1,2}|100)%$/.exec(b)))
        (a.viewportAnchorX = Number(c[1])), (a.viewportAnchorY = Number(c[2]));
      else if (/^scroll=up$/.exec(b)) a.scroll = shaka.text.CueRegion.scrollMode.UP;
      else return !1;
      return !0;
    };
    shaka.text.VttTextParser.setTextAlign_ = function (a, b) {
      var c = shaka.text.Cue;
      'middle' == b
        ? (a.textAlign = c.textAlign.CENTER)
        : (goog.asserts.assert(b.toUpperCase() in c.textAlign, b.toUpperCase() + ' Should be in Cue.textAlign values!'),
          (a.textAlign = c.textAlign[b.toUpperCase()]));
    };
    shaka.text.VttTextParser.setPositionAlign_ = function (a, b) {
      var c = shaka.text.Cue;
      a.positionAlign =
        'line-left' == b || 'start' == b
          ? c.positionAlign.LEFT
          : 'line-right' == b || 'end' == b
          ? c.positionAlign.RIGHT
          : c.positionAlign.CENTER;
    };
    shaka.text.VttTextParser.setVerticalWritingMode_ = function (a, b) {
      var c = shaka.text.Cue;
      a.writingMode = 'lr' == b ? c.writingMode.VERTICAL_LEFT_TO_RIGHT : c.writingMode.VERTICAL_RIGHT_TO_LEFT;
    };
    shaka.text.VttTextParser.parsedLineValueAndInterpretation_ = function (a, b) {
      var c = shaka.text.Cue,
        d;
      if ((d = /^line:([\d.]+)%(?:,(start|end|center))?$/.exec(b)))
        (a.lineInterpretation = c.lineInterpretation.PERCENTAGE),
          (a.line = Number(d[1])),
          d[2] &&
            (goog.asserts.assert(
              d[2].toUpperCase() in c.lineAlign,
              d[2].toUpperCase() + ' Should be in Cue.lineAlign values!',
            ),
            (a.lineAlign = c.lineAlign[d[2].toUpperCase()]));
      else if ((d = /^line:(-?\d+)(?:,(start|end|center))?$/.exec(b)))
        (a.lineInterpretation = c.lineInterpretation.LINE_NUMBER),
          (a.line = Number(d[1])),
          d[2] &&
            (goog.asserts.assert(
              d[2].toUpperCase() in c.lineAlign,
              d[2].toUpperCase() + ' Should be in Cue.lineAlign values!',
            ),
            (a.lineAlign = c.lineAlign[d[2].toUpperCase()]));
      else return !1;
      return !0;
    };
    shaka.text.VttTextParser.parseTime_ = function (a) {
      a = a.readRegex(/(?:(\d{1,}):)?(\d{2}):(\d{2})\.(\d{2,3})/g);
      if (null == a) return null;
      var b = Number(a[2]),
        c = Number(a[3]);
      return 59 < b || 59 < c ? null : Number(a[4]) / 1e3 + c + 60 * b + 3600 * (Number(a[1]) || 0);
    };
    goog.exportSymbol('shaka.text.VttTextParser', shaka.text.VttTextParser);
    goog.exportProperty(
      shaka.text.VttTextParser.prototype,
      'parseMedia',
      shaka.text.VttTextParser.prototype.parseMedia,
    );
    goog.exportProperty(shaka.text.VttTextParser.prototype, 'parseInit', shaka.text.VttTextParser.prototype.parseInit);
    shaka.text.VttTextParser.MPEG_TIMESCALE_ = 9e4;
    shaka.text.VttTextParser.TS_ROLLOVER_ = 8589934592;
    shaka.text.TextEngine.registerParser('text/vtt', function () {
      return new shaka.text.VttTextParser();
    });
    shaka.text.TextEngine.registerParser('text/vtt; codecs="vtt"', function () {
      return new shaka.text.VttTextParser();
    });
    shaka.text.TextEngine.registerParser('text/vtt; codecs="wvtt"', function () {
      return new shaka.text.VttTextParser();
    });
    shaka.text.Mp4VttParser = function () {
      this.timescale_ = null;
    };
    shaka.text.Mp4VttParser.prototype.parseInit = function (a) {
      var b = this,
        c = shaka.util.Mp4Parser,
        d = !1;
      new c()
        .box('moov', c.children)
        .box('trak', c.children)
        .box('mdia', c.children)
        .fullBox('mdhd', function (e) {
          goog.asserts.assert(0 == e.version || 1 == e.version, 'MDHD version can only be 0 or 1');
          0 == e.version
            ? (e.reader.skip(4), e.reader.skip(4), (b.timescale_ = e.reader.readUint32()), e.reader.skip(4))
            : (e.reader.skip(8), e.reader.skip(8), (b.timescale_ = e.reader.readUint32()), e.reader.skip(8));
          e.reader.skip(4);
        })
        .box('minf', c.children)
        .box('stbl', c.children)
        .fullBox('stsd', c.sampleDescription)
        .box('wvtt', function (e) {
          d = !0;
        })
        .parse(a);
      if (!this.timescale_)
        throw new shaka.util.Error(
          shaka.util.Error.Severity.CRITICAL,
          shaka.util.Error.Category.TEXT,
          shaka.util.Error.Code.INVALID_MP4_VTT,
        );
      if (!d)
        throw new shaka.util.Error(
          shaka.util.Error.Severity.CRITICAL,
          shaka.util.Error.Category.TEXT,
          shaka.util.Error.Code.INVALID_MP4_VTT,
        );
    };
    shaka.text.Mp4VttParser.prototype.parseMedia = function (a, b) {
      if (!this.timescale_)
        throw (
          (shaka.log.error('No init segment for MP4+VTT!'),
          new shaka.util.Error(
            shaka.util.Error.Severity.CRITICAL,
            shaka.util.Error.Category.TEXT,
            shaka.util.Error.Code.INVALID_MP4_VTT,
          ))
        );
      var c = shaka.text.Mp4VttParser,
        d = shaka.util.Mp4Parser,
        e = 0,
        f = [],
        g,
        h = [],
        k = !1,
        l = !1,
        m = !1,
        n = null;
      new d()
        .box('moof', d.children)
        .box('traf', d.children)
        .fullBox('tfdt', function (z) {
          k = !0;
          goog.asserts.assert(0 == z.version || 1 == z.version, 'TFDT version can only be 0 or 1');
          e = 0 == z.version ? z.reader.readUint32() : z.reader.readUint64();
        })
        .fullBox('tfhd', function (z) {
          goog.asserts.assert(null != z.flags, 'A TFHD box should have a valid flags value');
          n = c.parseTFHD_(z.flags, z.reader);
        })
        .fullBox('trun', function (z) {
          l = !0;
          goog.asserts.assert(null != z.version, 'A TRUN box should have a valid version value');
          goog.asserts.assert(null != z.flags, 'A TRUN box should have a valid flags value');
          f = c.parseTRUN_(z.version, z.flags, z.reader);
        })
        .box(
          'mdat',
          d.allData(function (z) {
            goog.asserts.assert(!m, 'VTT cues in mp4 with multiple MDAT are not currently supported');
            m = !0;
            g = z;
          }),
        )
        .parse(a, !1);
      if (!m && !k && !l)
        throw new shaka.util.Error(
          shaka.util.Error.Severity.CRITICAL,
          shaka.util.Error.Category.TEXT,
          shaka.util.Error.Code.INVALID_MP4_VTT,
        );
      d = e;
      for (
        var p = new shaka.util.DataViewReader(g, shaka.util.DataViewReader.Endianness.BIG_ENDIAN),
          q = $jscomp.makeIterator(f),
          r = q.next();
        !r.done;
        r = q.next()
      ) {
        r = r.value;
        var t = r.duration || n,
          w = r.timeOffset ? e + r.timeOffset : d;
        d = w + (t || 0);
        var u = 0;
        do {
          var v = p.readUint32();
          u += v;
          var x = p.readUint32();
          x = shaka.util.Mp4Parser.typeToString(x);
          var B = null;
          'vttc' == x
            ? 8 < v && (B = p.readBytes(v - 8))
            : ('vtte' != x && shaka.log.error('Unknown box ' + x + '! Skipping!'), p.skip(v - 8));
          t
            ? B &&
              (goog.asserts.assert(null != this.timescale_, 'Timescale should not be null!'),
              (v = shaka.text.Mp4VttParser.parseVTTC_(
                B,
                b.periodStart + w / this.timescale_,
                b.periodStart + d / this.timescale_,
              )),
              h.push(v))
            : shaka.log.error('WVTT sample duration unknown, and no default found!');
          goog.asserts.assert(
            !r.sampleSize || u <= r.sampleSize,
            'The samples do not fit evenly into the sample sizes given in the TRUN box!',
          );
        } while (r.sampleSize && u < r.sampleSize);
      }
      goog.asserts.assert(
        !p.hasMoreData(),
        'MDAT which contain VTT cues and non-VTT data are not currently supported!',
      );
      return h.filter(shaka.util.Functional.isNotNull);
    };
    shaka.text.Mp4VttParser.parseTFHD_ = function (a, b) {
      b.skip(4);
      a & 1 && b.skip(8);
      a & 2 && b.skip(4);
      return a & 8 ? b.readUint32() : null;
    };
    shaka.text.Mp4VttParser.parseTRUN_ = function (a, b, c) {
      var d = c.readUint32();
      b & 1 && c.skip(4);
      b & 4 && c.skip(4);
      var e = [];
      d = $jscomp.makeIterator(shaka.util.Iterables.range(d));
      for (var f = d.next(); !f.done; f = d.next())
        shaka.util.Functional.ignored(f.value),
          (f = { duration: null, sampleSize: null, timeOffset: null }),
          b & 256 && (f.duration = c.readUint32()),
          b & 512 && (f.sampleSize = c.readUint32()),
          b & 1024 && c.skip(4),
          b & 2048 && (f.timeOffset = 0 == a ? c.readUint32() : c.readInt32()),
          e.push(f);
      return e;
    };
    shaka.text.Mp4VttParser.parseVTTC_ = function (a, b, c) {
      var d, e, f;
      new shaka.util.Mp4Parser()
        .box(
          'payl',
          shaka.util.Mp4Parser.allData(function (g) {
            d = shaka.util.StringUtils.fromUTF8(g);
          }),
        )
        .box(
          'iden',
          shaka.util.Mp4Parser.allData(function (g) {
            e = shaka.util.StringUtils.fromUTF8(g);
          }),
        )
        .box(
          'sttg',
          shaka.util.Mp4Parser.allData(function (g) {
            f = shaka.util.StringUtils.fromUTF8(g);
          }),
        )
        .parse(a);
      return d ? shaka.text.Mp4VttParser.assembleCue_(d, e, f, b, c) : null;
    };
    shaka.text.Mp4VttParser.assembleCue_ = function (a, b, c, d, e) {
      a = new shaka.text.Cue(d, e, a);
      b && (a.id = b);
      if (c)
        for (b = new shaka.util.TextParser(c), c = b.readWord(); c; )
          shaka.text.VttTextParser.parseCueSetting(a, c, []) ||
            shaka.log.warning('VTT parser encountered an invalid VTT setting: ', c, ' The setting will be ignored.'),
            b.skipWhitespace(),
            (c = b.readWord());
      return a;
    };
    goog.exportSymbol('shaka.text.Mp4VttParser', shaka.text.Mp4VttParser);
    goog.exportProperty(shaka.text.Mp4VttParser.prototype, 'parseMedia', shaka.text.Mp4VttParser.prototype.parseMedia);
    goog.exportProperty(shaka.text.Mp4VttParser.prototype, 'parseInit', shaka.text.Mp4VttParser.prototype.parseInit);
    shaka.text.TextEngine.registerParser('application/mp4; codecs="wvtt"', function () {
      return new shaka.text.Mp4VttParser();
    }); /*
 @license
 EME Encryption Scheme Polyfill
 Copyright 2019 Google LLC
 SPDX-License-Identifier: Apache-2.0
*/
    var EmeEncryptionSchemePolyfill = function () {};
    EmeEncryptionSchemePolyfill.install = function () {
      EmeEncryptionSchemePolyfill.originalRMKSA_
        ? console.debug('EmeEncryptionSchemePolyfill: Already installed.')
        : navigator.requestMediaKeySystemAccess && MediaKeySystemAccess.prototype.getConfiguration
        ? ((EmeEncryptionSchemePolyfill.originalRMKSA_ = navigator.requestMediaKeySystemAccess),
          console.debug('EmeEncryptionSchemePolyfill: Waiting to detect encryptionScheme support.'),
          (navigator.requestMediaKeySystemAccess = EmeEncryptionSchemePolyfill.probeRMKSA_))
        : console.debug('EmeEncryptionSchemePolyfill: EME not found');
    };
    EmeEncryptionSchemePolyfill.probeRMKSA_ = function (a, b) {
      var c = this,
        d;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (e) {
        if (1 == e.nextAddress)
          return (
            console.assert(c == navigator, 'bad "this" for requestMediaKeySystemAccess'),
            e.yield(EmeEncryptionSchemePolyfill.originalRMKSA_.call(c, a, b), 2)
          );
        d = e.yieldResult;
        if (hasEncryptionScheme(d))
          return (
            console.debug('EmeEncryptionSchemePolyfill: Native encryptionScheme support found.'),
            (navigator.requestMediaKeySystemAccess = EmeEncryptionSchemePolyfill.originalRMKSA_),
            e['return'](d)
          );
        console.debug(
          'EmeEncryptionSchemePolyfill: No native encryptionScheme support found. Patching encryptionScheme support.',
        );
        navigator.requestMediaKeySystemAccess = EmeEncryptionSchemePolyfill.polyfillRMKSA_;
        return e['return'](EmeEncryptionSchemePolyfill.polyfillRMKSA_.call(c, a, b));
      });
    };
    EmeEncryptionSchemePolyfill.polyfillRMKSA_ = function (a, b) {
      var c = this,
        d,
        e,
        f,
        g,
        h,
        k,
        l,
        m,
        n,
        p;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (q) {
        if (1 == q.nextAddress) {
          console.assert(c == navigator, 'bad "this" for requestMediaKeySystemAccess');
          d = guessSupportedScheme(a);
          e = [];
          f = $jscomp.makeIterator(b);
          for (g = f.next(); !g.done; g = f.next())
            (h = g.value),
              (k = EmeEncryptionSchemePolyfill.filterCapabilities_(h.videoCapabilities, d)),
              (l = EmeEncryptionSchemePolyfill.filterCapabilities_(h.audioCapabilities, d)),
              (h.videoCapabilities && h.videoCapabilities.length && !k.length) ||
                (h.audioCapabilities && h.audioCapabilities.length && !l.length) ||
                ((m = Object.assign({}, h)), (m.videoCapabilities = k), (m.audioCapabilities = l), e.push(m));
          if (!e.length)
            throw (
              ((n = Error('Unsupported keySystem or supportedConfigurations.')),
              (n.name = 'NotSupportedError'),
              (n.code = DOMException.NOT_SUPPORTED_ERR),
              n)
            );
          return q.yield(EmeEncryptionSchemePolyfill.originalRMKSA_.call(c, a, e), 2);
        }
        p = q.yieldResult;
        return q['return'](new EmeEncryptionSchemePolyfillMediaKeySystemAccess(p, d));
      });
    };
    EmeEncryptionSchemePolyfill.filterCapabilities_ = function (a, b) {
      return a
        ? a.filter(function (c) {
            return !c.encryptionScheme || c.encryptionScheme == b;
          })
        : a;
    };
    goog.exportSymbol('EmeEncryptionSchemePolyfill', EmeEncryptionSchemePolyfill);
    goog.exportProperty(EmeEncryptionSchemePolyfill, 'install', EmeEncryptionSchemePolyfill.install);
    var McEncryptionSchemePolyfill = function () {};
    McEncryptionSchemePolyfill.install = function () {
      navigator.mediaCapabilities
        ? ((McEncryptionSchemePolyfill.originalDecodingInfo_ = navigator.mediaCapabilities.decodingInfo),
          console.debug('McEncryptionSchemePolyfill: Waiting to detect encryptionScheme support.'),
          (navigator.mediaCapabilities.decodingInfo = McEncryptionSchemePolyfill.probeDecodingInfo_))
        : console.debug('McEncryptionSchemePolyfill: MediaCapabilities not found');
    };
    McEncryptionSchemePolyfill.probeDecodingInfo_ = function (a) {
      var b = this,
        c,
        d;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (e) {
        if (1 == e.nextAddress)
          return (
            console.assert(b == navigator.mediaCapabilities, 'bad "this" for decodingInfo'),
            e.yield(McEncryptionSchemePolyfill.originalDecodingInfo_.call(b, a), 2)
          );
        c = e.yieldResult;
        if (!a.keySystemConfiguration) return e['return'](c);
        d = c.keySystemAccess;
        if (hasEncryptionScheme(d))
          return (
            console.debug('McEncryptionSchemePolyfill: Native encryptionScheme support found.'),
            (navigator.mediaCapabilities.decodingInfo = McEncryptionSchemePolyfill.originalDecodingInfo_),
            e['return'](c)
          );
        console.debug(
          'McEncryptionSchemePolyfill: No native encryptionScheme support found. Patching encryptionScheme support.',
        );
        navigator.mediaCapabilities.decodingInfo = McEncryptionSchemePolyfill.polyfillDecodingInfo_;
        return e['return'](McEncryptionSchemePolyfill.polyfillDecodingInfo_.call(b, a));
      });
    };
    McEncryptionSchemePolyfill.polyfillDecodingInfo_ = function (a) {
      var b = this,
        c,
        d,
        e,
        f,
        g,
        h,
        k;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (l) {
        if (1 == l.nextAddress)
          return (
            console.assert(b == navigator.mediaCapabilities, 'bad "this" for decodingInfo'),
            (c = null),
            a.keySystemConfiguration &&
            ((d = a.keySystemConfiguration),
            (e = d.keySystem),
            (f = d.audio && d.audio.encryptionScheme),
            (g = d.video && d.video.encryptionScheme),
            (c = guessSupportedScheme(e)),
            (h = { powerEfficient: !1, smooth: !1, supported: !1, keySystemAccess: null, configuration: a }),
            (f && f != c) || (g && g != c))
              ? l['return'](h)
              : l.yield(McEncryptionSchemePolyfill.originalDecodingInfo_.call(b, a), 2)
          );
        k = l.yieldResult;
        k.keySystemAccess &&
          (k.keySystemAccess = new EmeEncryptionSchemePolyfillMediaKeySystemAccess(k.keySystemAccess, c));
        return l['return'](k);
      });
    };
    goog.exportSymbol('McEncryptionSchemePolyfill', McEncryptionSchemePolyfill);
    goog.exportProperty(McEncryptionSchemePolyfill, 'install', McEncryptionSchemePolyfill.install);
    var EmeEncryptionSchemePolyfillMediaKeySystemAccess = function (a, b) {
      this.mksa_ = a;
      this.scheme_ = b;
      this.keySystem = a.keySystem;
    };
    EmeEncryptionSchemePolyfillMediaKeySystemAccess.prototype.getConfiguration = function () {
      var a = this.mksa_.getConfiguration();
      if (a.videoCapabilities)
        for (var b = $jscomp.makeIterator(a.videoCapabilities), c = b.next(); !c.done; c = b.next())
          c.value.encryptionScheme = this.scheme_;
      if (a.audioCapabilities)
        for (b = $jscomp.makeIterator(a.audioCapabilities), c = b.next(); !c.done; c = b.next())
          c.value.encryptionScheme = this.scheme_;
      return a;
    };
    EmeEncryptionSchemePolyfillMediaKeySystemAccess.prototype.createMediaKeys = function () {
      return this.mksa_.createMediaKeys();
    };
    function guessSupportedScheme(a) {
      if (
        a.startsWith('com.widevine') ||
        a.startsWith('com.microsoft') ||
        a.startsWith('com.adobe') ||
        a.startsWith('org.w3')
      )
        return 'cenc';
      if (a.startsWith('com.apple')) return 'cbcs-1-9';
      console.warn('EmeEncryptionSchemePolyfill: Unknown key system:', a, 'Please contribute!');
      return null;
    }
    function hasEncryptionScheme(a) {
      a = a.getConfiguration();
      var b = a.audioCapabilities && a.audioCapabilities[0];
      return (a = (a.videoCapabilities && a.videoCapabilities[0]) || b) && void 0 !== a.encryptionScheme ? !0 : !1;
    }
    var EncryptionSchemePolyfills = function () {};
    EncryptionSchemePolyfills.install = function () {
      EmeEncryptionSchemePolyfill.install();
      McEncryptionSchemePolyfill.install();
    };
    goog.exportSymbol('EncryptionSchemePolyfills', EncryptionSchemePolyfills);
    goog.exportProperty(EncryptionSchemePolyfills, 'install', EncryptionSchemePolyfills.install);
    (function () {
      'undefined' !== typeof module && module.exports && (module.exports = EncryptionSchemePolyfills);
    })(); /*
 @license
 Copyright 2013 Ali Al Dallal

 Licensed under the MIT license.

 Permission is hereby granted, free of charge, to any person obtaining a copy
 of this software and associated documentation files (the "Software"), to deal
 in the Software without restriction, including without limitation the rights
 to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 copies of the Software, and to permit persons to whom the Software is
 furnished to do so, subject to the following conditions:

 The above copyright notice and this permission notice shall be included in
 all copies or substantial portions of the Software.

 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 SOFTWARE.
*/
    for (
      var mozilla = {
          LanguageMapping: {
            ach: { nativeName: 'Lwo', englishName: 'Acholi' },
            ady: { nativeName: '\u0410\u0434\u044b\u0433\u044d\u0431\u0437\u044d', englishName: 'Adyghe' },
            af: { nativeName: 'Afrikaans', englishName: 'Afrikaans' },
            'af-NA': { nativeName: 'Afrikaans (Namibia)', englishName: 'Afrikaans (Namibia)' },
            'af-ZA': { nativeName: 'Afrikaans (South Africa)', englishName: 'Afrikaans (South Africa)' },
            ak: { nativeName: 'T\u0255\u0265i', englishName: 'Akan' },
            ar: { nativeName: '\u0627\u0644\u0639\u0631\u0628\u064a\u0629', englishName: 'Arabic' },
            'ar-AR': { nativeName: '\u0627\u0644\u0639\u0631\u0628\u064a\u0629', englishName: 'Arabic' },
            'ar-MA': { nativeName: '\u0627\u0644\u0639\u0631\u0628\u064a\u0629', englishName: 'Arabic (Morocco)' },
            'ar-SA': {
              nativeName:
                '\u0627\u0644\u0639\u0631\u0628\u064a\u0629 (\u0627\u0644\u0633\u0639\u0648\u062f\u064a\u0629)',
              englishName: 'Arabic (Saudi Arabia)',
            },
            'ay-BO': { nativeName: 'Aymar aru', englishName: 'Aymara' },
            az: { nativeName: 'Az\u0259rbaycan dili', englishName: 'Azerbaijani' },
            'az-AZ': { nativeName: 'Az\u0259rbaycan dili', englishName: 'Azerbaijani' },
            'be-BY': {
              nativeName: '\u0411\u0435\u043b\u0430\u0440\u0443\u0441\u043a\u0430\u044f',
              englishName: 'Belarusian',
            },
            bg: { nativeName: '\u0411\u044a\u043b\u0433\u0430\u0440\u0441\u043a\u0438', englishName: 'Bulgarian' },
            'bg-BG': { nativeName: '\u0411\u044a\u043b\u0433\u0430\u0440\u0441\u043a\u0438', englishName: 'Bulgarian' },
            bn: { nativeName: '\u09ac\u09be\u0982\u09b2\u09be', englishName: 'Bengali' },
            'bn-IN': {
              nativeName: '\u09ac\u09be\u0982\u09b2\u09be (\u09ad\u09be\u09b0\u09a4)',
              englishName: 'Bengali (India)',
            },
            'bn-BD': {
              nativeName: '\u09ac\u09be\u0982\u09b2\u09be(\u09ac\u09be\u0982\u09b2\u09be\u09a6\u09c7\u09b6)',
              englishName: 'Bengali (Bangladesh)',
            },
            'bs-BA': { nativeName: 'Bosanski', englishName: 'Bosnian' },
            ca: { nativeName: 'Catal\u00e0', englishName: 'Catalan' },
            'ca-ES': { nativeName: 'Catal\u00e0', englishName: 'Catalan' },
            cak: { nativeName: 'Maya Kaqchikel', englishName: 'Kaqchikel' },
            'ck-US': { nativeName: '\u13e3\u13b3\u13a9 (tsalagi)', englishName: 'Cherokee' },
            cs: { nativeName: '\u010ce\u0161tina', englishName: 'Czech' },
            'cs-CZ': { nativeName: '\u010ce\u0161tina', englishName: 'Czech' },
            cy: { nativeName: 'Cymraeg', englishName: 'Welsh' },
            'cy-GB': { nativeName: 'Cymraeg', englishName: 'Welsh' },
            da: { nativeName: 'Dansk', englishName: 'Danish' },
            'da-DK': { nativeName: 'Dansk', englishName: 'Danish' },
            de: { nativeName: 'Deutsch', englishName: 'German' },
            'de-AT': { nativeName: 'Deutsch (\u00d6sterreich)', englishName: 'German (Austria)' },
            'de-DE': { nativeName: 'Deutsch (Deutschland)', englishName: 'German (Germany)' },
            'de-CH': { nativeName: 'Deutsch (Schweiz)', englishName: 'German (Switzerland)' },
            dsb: { nativeName: 'Dolnoserb\u0161\u0107ina', englishName: 'Lower Sorbian' },
            el: { nativeName: '\u0395\u03bb\u03bb\u03b7\u03bd\u03b9\u03ba\u03ac', englishName: 'Greek' },
            'el-GR': { nativeName: '\u0395\u03bb\u03bb\u03b7\u03bd\u03b9\u03ba\u03ac', englishName: 'Greek (Greece)' },
            en: { nativeName: 'English', englishName: 'English' },
            'en-GB': { nativeName: 'English (UK)', englishName: 'English (UK)' },
            'en-AU': { nativeName: 'English (Australia)', englishName: 'English (Australia)' },
            'en-CA': { nativeName: 'English (Canada)', englishName: 'English (Canada)' },
            'en-IE': { nativeName: 'English (Ireland)', englishName: 'English (Ireland)' },
            'en-IN': { nativeName: 'English (India)', englishName: 'English (India)' },
            'en-PI': { nativeName: 'English (Pirate)', englishName: 'English (Pirate)' },
            'en-UD': { nativeName: 'English (Upside Down)', englishName: 'English (Upside Down)' },
            'en-US': { nativeName: 'English (US)', englishName: 'English (US)' },
            'en-ZA': { nativeName: 'English (South Africa)', englishName: 'English (South Africa)' },
            'en@pirate': { nativeName: 'English (Pirate)', englishName: 'English (Pirate)' },
            eo: { nativeName: 'Esperanto', englishName: 'Esperanto' },
            'eo-EO': { nativeName: 'Esperanto', englishName: 'Esperanto' },
            es: { nativeName: 'Espa\u00f1ol', englishName: 'Spanish' },
            'es-AR': { nativeName: 'Espa\u00f1ol (Argentine)', englishName: 'Spanish (Argentina)' },
            'es-419': { nativeName: 'Espa\u00f1ol (Latinoam\u00e9rica)', englishName: 'Spanish (Latin America)' },
            'es-CL': { nativeName: 'Espa\u00f1ol (Chile)', englishName: 'Spanish (Chile)' },
            'es-CO': { nativeName: 'Espa\u00f1ol (Colombia)', englishName: 'Spanish (Colombia)' },
            'es-EC': { nativeName: 'Espa\u00f1ol (Ecuador)', englishName: 'Spanish (Ecuador)' },
            'es-ES': { nativeName: 'Espa\u00f1ol (Espa\u00f1a)', englishName: 'Spanish (Spain)' },
            'es-LA': { nativeName: 'Espa\u00f1ol (Latinoam\u00e9rica)', englishName: 'Spanish (Latin America)' },
            'es-NI': { nativeName: 'Espa\u00f1ol (Nicaragua)', englishName: 'Spanish (Nicaragua)' },
            'es-MX': { nativeName: 'Espa\u00f1ol (M\u00e9xico)', englishName: 'Spanish (Mexico)' },
            'es-US': { nativeName: 'Espa\u00f1ol (Estados Unidos)', englishName: 'Spanish (United States)' },
            'es-VE': { nativeName: 'Espa\u00f1ol (Venezuela)', englishName: 'Spanish (Venezuela)' },
            et: { nativeName: 'eesti keel', englishName: 'Estonian' },
            'et-EE': { nativeName: 'Eesti (Estonia)', englishName: 'Estonian (Estonia)' },
            eu: { nativeName: 'Euskara', englishName: 'Basque' },
            'eu-ES': { nativeName: 'Euskara', englishName: 'Basque' },
            fa: { nativeName: '\u0641\u0627\u0631\u0633\u06cc', englishName: 'Persian' },
            'fa-IR': { nativeName: '\u0641\u0627\u0631\u0633\u06cc', englishName: 'Persian' },
            'fb-LT': { nativeName: 'Leet Speak', englishName: 'Leet' },
            ff: { nativeName: 'Fulah', englishName: 'Fulah' },
            fi: { nativeName: 'Suomi', englishName: 'Finnish' },
            'fi-FI': { nativeName: 'Suomi', englishName: 'Finnish' },
            'fo-FO': { nativeName: 'F\u00f8royskt', englishName: 'Faroese' },
            fr: { nativeName: 'Fran\u00e7ais', englishName: 'French' },
            'fr-CA': { nativeName: 'Fran\u00e7ais (Canada)', englishName: 'French (Canada)' },
            'fr-FR': { nativeName: 'Fran\u00e7ais (France)', englishName: 'French (France)' },
            'fr-BE': { nativeName: 'Fran\u00e7ais (Belgique)', englishName: 'French (Belgium)' },
            'fr-CH': { nativeName: 'Fran\u00e7ais (Suisse)', englishName: 'French (Switzerland)' },
            'fy-NL': { nativeName: 'Frysk', englishName: 'Frisian (West)' },
            ga: { nativeName: 'Gaeilge', englishName: 'Irish' },
            'ga-IE': { nativeName: 'Gaeilge (Gaelic)', englishName: 'Irish (Gaelic)' },
            gl: { nativeName: 'Galego', englishName: 'Galician' },
            'gl-ES': { nativeName: 'Galego', englishName: 'Galician' },
            'gn-PY': { nativeName: "Ava\u00f1e'\u1ebd", englishName: 'Guarani' },
            'gu-IN': { nativeName: '\u0a97\u0ac1\u0a9c\u0ab0\u0abe\u0aa4\u0ac0', englishName: 'Gujarati' },
            'gx-GR': {
              nativeName: '\u1f19\u03bb\u03bb\u03b7\u03bd\u03b9\u03ba\u03ae \u1f00\u03c1\u03c7\u03b1\u03af\u03b1',
              englishName: 'Classical Greek',
            },
            he: { nativeName: '\u05e2\u05d1\u05e8\u05d9\u05ea\u200f', englishName: 'Hebrew' },
            'he-IL': { nativeName: '\u05e2\u05d1\u05e8\u05d9\u05ea\u200f', englishName: 'Hebrew' },
            hi: { nativeName: '\u0939\u093f\u0928\u094d\u0926\u0940', englishName: 'Hindi' },
            'hi-IN': { nativeName: '\u0939\u093f\u0928\u094d\u0926\u0940', englishName: 'Hindi' },
            hr: { nativeName: 'Hrvatski', englishName: 'Croatian' },
            'hr-HR': { nativeName: 'Hrvatski', englishName: 'Croatian' },
            hsb: { nativeName: 'Hornjoserb\u0161\u0107ina', englishName: 'Upper Sorbian' },
            ht: { nativeName: 'Krey\u00f2l', englishName: 'Haitian Creole' },
            hu: { nativeName: 'Magyar', englishName: 'Hungarian' },
            'hu-HU': { nativeName: 'Magyar', englishName: 'Hungarian' },
            'hy-AM': { nativeName: '\u0540\u0561\u0575\u0565\u0580\u0565\u0576', englishName: 'Armenian' },
            id: { nativeName: 'Bahasa Indonesia', englishName: 'Indonesian' },
            'id-ID': { nativeName: 'Bahasa Indonesia', englishName: 'Indonesian' },
            is: { nativeName: '\u00cdslenska', englishName: 'Icelandic' },
            'is-IS': { nativeName: '\u00cdslenska (Iceland)', englishName: 'Icelandic (Iceland)' },
            it: { nativeName: 'Italiano', englishName: 'Italian' },
            'it-IT': { nativeName: 'Italiano', englishName: 'Italian' },
            ja: { nativeName: '\u65e5\u672c\u8a9e', englishName: 'Japanese' },
            'ja-JP': { nativeName: '\u65e5\u672c\u8a9e', englishName: 'Japanese' },
            'jv-ID': { nativeName: 'Basa Jawa', englishName: 'Javanese' },
            'ka-GE': { nativeName: '\u10e5\u10d0\u10e0\u10d7\u10e3\u10da\u10d8', englishName: 'Georgian' },
            'kk-KZ': { nativeName: '\u049a\u0430\u0437\u0430\u049b\u0448\u0430', englishName: 'Kazakh' },
            km: { nativeName: '\u1797\u17b6\u179f\u17b6\u1781\u17d2\u1798\u17c2\u179a', englishName: 'Khmer' },
            'km-KH': { nativeName: '\u1797\u17b6\u179f\u17b6\u1781\u17d2\u1798\u17c2\u179a', englishName: 'Khmer' },
            kab: { nativeName: 'Taqbaylit', englishName: 'Kabyle' },
            kn: { nativeName: '\u0c95\u0ca8\u0ccd\u0ca8\u0ca1', englishName: 'Kannada' },
            'kn-IN': { nativeName: '\u0c95\u0ca8\u0ccd\u0ca8\u0ca1 (India)', englishName: 'Kannada (India)' },
            ko: { nativeName: '\ud55c\uad6d\uc5b4', englishName: 'Korean' },
            'ko-KR': { nativeName: '\ud55c\uad6d\uc5b4 (\u97e9\u56fd)', englishName: 'Korean (Korea)' },
            ku: { nativeName: 'Kurd\u00ee', englishName: 'Kurdish' },
            'ku-TR': { nativeName: 'Kurd\u00ee', englishName: 'Kurdish' },
            la: { nativeName: 'Latin', englishName: 'Latin' },
            'la-VA': { nativeName: 'Latin', englishName: 'Latin' },
            lb: { nativeName: 'L\u00ebtzebuergesch', englishName: 'Luxembourgish' },
            'li-NL': { nativeName: 'L\u00e8mb\u00f6rgs', englishName: 'Limburgish' },
            lt: { nativeName: 'Lietuvi\u0173', englishName: 'Lithuanian' },
            'lt-LT': { nativeName: 'Lietuvi\u0173', englishName: 'Lithuanian' },
            lv: { nativeName: 'Latvie\u0161u', englishName: 'Latvian' },
            'lv-LV': { nativeName: 'Latvie\u0161u', englishName: 'Latvian' },
            mai: {
              nativeName: '\u092e\u0948\u0925\u093f\u0932\u0940, \u09ae\u09c8\u09a5\u09bf\u09b2\u09c0',
              englishName: 'Maithili',
            },
            'mg-MG': { nativeName: 'Malagasy', englishName: 'Malagasy' },
            mk: {
              nativeName: '\u041c\u0430\u043a\u0435\u0434\u043e\u043d\u0441\u043a\u0438',
              englishName: 'Macedonian',
            },
            'mk-MK': {
              nativeName:
                '\u041c\u0430\u043a\u0435\u0434\u043e\u043d\u0441\u043a\u0438 (\u041c\u0430\u043a\u0435\u0434\u043e\u043d\u0441\u043a\u0438)',
              englishName: 'Macedonian (Macedonian)',
            },
            ml: { nativeName: '\u0d2e\u0d32\u0d2f\u0d3e\u0d33\u0d02', englishName: 'Malayalam' },
            'ml-IN': { nativeName: '\u0d2e\u0d32\u0d2f\u0d3e\u0d33\u0d02', englishName: 'Malayalam' },
            'mn-MN': { nativeName: '\u041c\u043e\u043d\u0433\u043e\u043b', englishName: 'Mongolian' },
            mr: { nativeName: '\u092e\u0930\u093e\u0920\u0940', englishName: 'Marathi' },
            'mr-IN': { nativeName: '\u092e\u0930\u093e\u0920\u0940', englishName: 'Marathi' },
            ms: { nativeName: 'Bahasa Melayu', englishName: 'Malay' },
            'ms-MY': { nativeName: 'Bahasa Melayu', englishName: 'Malay' },
            mt: { nativeName: 'Malti', englishName: 'Maltese' },
            'mt-MT': { nativeName: 'Malti', englishName: 'Maltese' },
            my: { nativeName: '\u1017\u1019\u102c\u1005\u1000\u102c', englishName: 'Burmese' },
            nb: { nativeName: 'Norsk (bokm\u00e5l)', englishName: 'Norwegian (bokmal)' },
            'nb-NO': { nativeName: 'Norsk (bokm\u00e5l)', englishName: 'Norwegian (bokmal)' },
            ne: { nativeName: '\u0928\u0947\u092a\u093e\u0932\u0940', englishName: 'Nepali' },
            'ne-NP': { nativeName: '\u0928\u0947\u092a\u093e\u0932\u0940', englishName: 'Nepali' },
            nl: { nativeName: 'Nederlands', englishName: 'Dutch' },
            'nl-BE': { nativeName: 'Nederlands (Belgi\u00eb)', englishName: 'Dutch (Belgium)' },
            'nl-NL': { nativeName: 'Nederlands (Nederland)', englishName: 'Dutch (Netherlands)' },
            'nn-NO': { nativeName: 'Norsk (nynorsk)', englishName: 'Norwegian (nynorsk)' },
            no: { nativeName: 'Norsk', englishName: 'Norwegian' },
            oc: { nativeName: 'Occitan', englishName: 'Occitan' },
            'or-IN': { nativeName: '\u0b13\u0b21\u0b3c\u0b3f\u0b06', englishName: 'Oriya' },
            pa: { nativeName: '\u0a2a\u0a70\u0a1c\u0a3e\u0a2c\u0a40', englishName: 'Punjabi' },
            'pa-IN': {
              nativeName: '\u0a2a\u0a70\u0a1c\u0a3e\u0a2c\u0a40 (\u0a2d\u0a3e\u0a30\u0a24 \u0a28\u0a42\u0a70)',
              englishName: 'Punjabi (India)',
            },
            pl: { nativeName: 'Polski', englishName: 'Polish' },
            'pl-PL': { nativeName: 'Polski', englishName: 'Polish' },
            'ps-AF': { nativeName: '\u067e\u069a\u062a\u0648', englishName: 'Pashto' },
            pt: { nativeName: 'Portugu\u00eas', englishName: 'Portuguese' },
            'pt-BR': { nativeName: 'Portugu\u00eas (Brasil)', englishName: 'Portuguese (Brazil)' },
            'pt-PT': { nativeName: 'Portugu\u00eas (Portugal)', englishName: 'Portuguese (Portugal)' },
            'qu-PE': { nativeName: 'Qhichwa', englishName: 'Quechua' },
            'rm-CH': { nativeName: 'Rumantsch', englishName: 'Romansh' },
            ro: { nativeName: 'Rom\u00e2n\u0103', englishName: 'Romanian' },
            'ro-RO': { nativeName: 'Rom\u00e2n\u0103', englishName: 'Romanian' },
            ru: { nativeName: '\u0420\u0443\u0441\u0441\u043a\u0438\u0439', englishName: 'Russian' },
            'ru-RU': { nativeName: '\u0420\u0443\u0441\u0441\u043a\u0438\u0439', englishName: 'Russian' },
            'sa-IN': { nativeName: '\u0938\u0902\u0938\u094d\u0915\u0943\u0924\u092e\u094d', englishName: 'Sanskrit' },
            'se-NO': { nativeName: 'Davvis\u00e1megiella', englishName: 'Northern S\u00e1mi' },
            'si-LK': { nativeName: '\u0db4\u0dc5\u0dcf\u0dad', englishName: 'Sinhala (Sri Lanka)' },
            sk: { nativeName: 'Sloven\u010dina', englishName: 'Slovak' },
            'sk-SK': { nativeName: 'Sloven\u010dina (Slovakia)', englishName: 'Slovak (Slovakia)' },
            sl: { nativeName: 'Sloven\u0161\u010dina', englishName: 'Slovenian' },
            'sl-SI': { nativeName: 'Sloven\u0161\u010dina', englishName: 'Slovenian' },
            'so-SO': { nativeName: 'Soomaaliga', englishName: 'Somali' },
            sq: { nativeName: 'Shqip', englishName: 'Albanian' },
            'sq-AL': { nativeName: 'Shqip', englishName: 'Albanian' },
            sr: { nativeName: '\u0421\u0440\u043f\u0441\u043a\u0438', englishName: 'Serbian' },
            'sr-RS': { nativeName: '\u0421\u0440\u043f\u0441\u043a\u0438 (Serbia)', englishName: 'Serbian (Serbia)' },
            su: { nativeName: 'Basa Sunda', englishName: 'Sundanese' },
            sv: { nativeName: 'Svenska', englishName: 'Swedish' },
            'sv-SE': { nativeName: 'Svenska', englishName: 'Swedish' },
            sw: { nativeName: 'Kiswahili', englishName: 'Swahili' },
            'sw-KE': { nativeName: 'Kiswahili', englishName: 'Swahili (Kenya)' },
            ta: { nativeName: '\u0ba4\u0bae\u0bbf\u0bb4\u0bcd', englishName: 'Tamil' },
            'ta-IN': { nativeName: '\u0ba4\u0bae\u0bbf\u0bb4\u0bcd', englishName: 'Tamil' },
            te: { nativeName: '\u0c24\u0c46\u0c32\u0c41\u0c17\u0c41', englishName: 'Telugu' },
            'te-IN': { nativeName: '\u0c24\u0c46\u0c32\u0c41\u0c17\u0c41', englishName: 'Telugu' },
            tg: {
              nativeName: '\u0437\u0430\u0431\u043e\u0301\u043d\u0438 \u0442\u043e\u04b7\u0438\u043a\u04e3\u0301',
              englishName: 'Tajik',
            },
            'tg-TJ': { nativeName: '\u0442\u043e\u04b7\u0438\u043a\u04e3', englishName: 'Tajik' },
            th: { nativeName: '\u0e20\u0e32\u0e29\u0e32\u0e44\u0e17\u0e22', englishName: 'Thai' },
            'th-TH': {
              nativeName:
                '\u0e20\u0e32\u0e29\u0e32\u0e44\u0e17\u0e22 (\u0e1b\u0e23\u0e30\u0e40\u0e17\u0e28\u0e44\u0e17\u0e22)',
              englishName: 'Thai (Thailand)',
            },
            tl: { nativeName: 'Filipino', englishName: 'Filipino' },
            'tl-PH': { nativeName: 'Filipino', englishName: 'Filipino' },
            tlh: { nativeName: 'tlhIngan-Hol', englishName: 'Klingon' },
            tr: { nativeName: 'T\u00fcrk\u00e7e', englishName: 'Turkish' },
            'tr-TR': { nativeName: 'T\u00fcrk\u00e7e', englishName: 'Turkish' },
            'tt-RU': { nativeName: '\u0442\u0430\u0442\u0430\u0440\u0447\u0430', englishName: 'Tatar' },
            uk: {
              nativeName: '\u0423\u043a\u0440\u0430\u0457\u043d\u0441\u044c\u043a\u0430',
              englishName: 'Ukrainian',
            },
            'uk-UA': {
              nativeName: '\u0423\u043a\u0440\u0430\u0457\u043d\u0441\u044c\u043a\u0430',
              englishName: 'Ukrainian',
            },
            ur: { nativeName: '\u0627\u0631\u062f\u0648', englishName: 'Urdu' },
            'ur-PK': { nativeName: '\u0627\u0631\u062f\u0648', englishName: 'Urdu' },
            uz: { nativeName: "O'zbek", englishName: 'Uzbek' },
            'uz-UZ': { nativeName: "O'zbek", englishName: 'Uzbek' },
            vi: { nativeName: 'Ti\u1ebfng Vi\u1ec7t', englishName: 'Vietnamese' },
            'vi-VN': { nativeName: 'Ti\u1ebfng Vi\u1ec7t', englishName: 'Vietnamese' },
            'xh-ZA': { nativeName: 'isiXhosa', englishName: 'Xhosa' },
            yi: { nativeName: '\u05d9\u05d9\u05b4\u05d3\u05d9\u05e9', englishName: 'Yiddish' },
            'yi-DE': { nativeName: '\u05d9\u05d9\u05b4\u05d3\u05d9\u05e9 (German)', englishName: 'Yiddish (German)' },
            zh: { nativeName: '\u4e2d\u6587', englishName: 'Chinese' },
            'zh-HANS': { nativeName: '\u4e2d\u6587\u7b80\u4f53', englishName: 'Chinese Simplified' },
            'zh-HANT': { nativeName: '\u4e2d\u6587\u7e41\u9ad4', englishName: 'Chinese Traditional' },
            'zh-CN': { nativeName: '\u4e2d\u6587\uff08\u4e2d\u56fd\uff09', englishName: 'Chinese Simplified (China)' },
            'zh-HK': {
              nativeName: '\u4e2d\u6587\uff08\u9999\u6e2f\uff09',
              englishName: 'Chinese Traditional (Hong Kong)',
            },
            'zh-SG': {
              nativeName: '\u4e2d\u6587\uff08\u65b0\u52a0\u5761\uff09',
              englishName: 'Chinese Simplified (Singapore)',
            },
            'zh-TW': {
              nativeName: '\u4e2d\u6587\uff08\u53f0\u7063\uff09',
              englishName: 'Chinese Traditional (Taiwan)',
            },
            'zu-ZA': { nativeName: 'isiZulu', englishName: 'Zulu' },
          },
        },
        $jscomp$iter$343 = $jscomp.makeIterator(Object.keys(mozilla.LanguageMapping)),
        $jscomp$key$key = $jscomp$iter$343.next();
      !$jscomp$key$key.done;
      $jscomp$key$key = $jscomp$iter$343.next()
    ) {
      var key = $jscomp$key$key.value;
      mozilla.LanguageMapping[key.toLowerCase()] = mozilla.LanguageMapping[key];
    }
    shaka.ui.Element = function (a, b) {
      var c = this;
      this.parent = a;
      this.controls = b;
      this.eventManager = new shaka.util.EventManager();
      this.localization = this.controls.getLocalization();
      this.player = this.controls.getPlayer();
      this.video = this.controls.getVideo();
      this.adManager = this.player.getAdManager();
      this.ad = null;
      this.eventManager.listen(this.adManager, shaka.ads.AdManager.AD_STARTED, function (d) {
        c.ad = d.ad;
      });
      this.eventManager.listen(this.adManager, shaka.ads.AdManager.AD_STOPPED, function () {
        c.ad = null;
      });
    };
    shaka.ui.Element.prototype.release = function () {
      this.eventManager.release();
      this.ad = this.adManager = this.video = this.player = this.localization = this.eventManager = this.controls = this.parent = null;
    };
    goog.exportSymbol('shaka.ui.Element', shaka.ui.Element);
    goog.exportProperty(shaka.ui.Element.prototype, 'release', shaka.ui.Element.prototype.release);
    shaka.ui.Enums = {};
    shaka.ui.Enums.MaterialDesignIcons = {
      FULLSCREEN: 'fullscreen',
      EXIT_FULLSCREEN: 'fullscreen_exit',
      CLOSED_CAPTIONS: 'closed_caption',
      CHECKMARK: 'done',
      LANGUAGE: 'language',
      PIP: 'picture_in_picture_alt',
      EXIT_PIP: 'branding_watermark',
      BACK: 'arrow_back',
      RESOLUTION: 'settings',
      MUTE: 'volume_up',
      UNMUTE: 'volume_off',
      CAST: 'cast',
      EXIT_CAST: 'cast_connected',
      OPEN_OVERFLOW: 'more_vert',
      REWIND: 'fast_rewind',
      FAST_FORWARD: 'fast_forward',
      PLAY: 'play_arrow',
      PLAYBACK_RATE: 'slow_motion_video',
      PAUSE: 'pause',
      LOOP: 'loop',
    };
    shaka.ui.Utils = function () {};
    shaka.ui.Utils.getFirstDescendantWithClassName = function (a, b) {
      var c = shaka.ui.Utils.getDescendantIfExists(a, b);
      goog.asserts.assert(null != c, 'Should not be null!');
      return c;
    };
    shaka.ui.Utils.getDescendantIfExists = function (a, b) {
      var c = a.getElementsByClassName(b);
      return c.length ? c[0] : null;
    };
    shaka.ui.Utils.focusOnTheChosenItem = function (a) {
      a && (a = shaka.ui.Utils.getDescendantIfExists(a, 'shaka-chosen-item')) && a.parentElement.focus();
    };
    shaka.ui.Utils.checkmarkIcon = function () {
      var a = shaka.util.Dom.createHTMLElement('i');
      a.classList.add('material-icons-round');
      a.classList.add('shaka-chosen-item');
      a.textContent = shaka.ui.Enums.MaterialDesignIcons.CHECKMARK;
      a.setAttribute('aria-hidden', 'true');
      return a;
    };
    shaka.ui.Utils.setDisplay = function (a, b) {
      a &&
        (goog.asserts.assert(!(a instanceof SVGElement), 'Do not use setDisplay with SVG elements!'),
        b ? a.classList.remove('shaka-hidden') : a.classList.add('shaka-hidden'));
    };
    shaka.ui.Utils.buildTimeString = function (a, b) {
      var c = Math.floor(a / 3600),
        d = Math.floor((a / 60) % 60),
        e = Math.floor(a % 60);
      10 > e && (e = '0' + e);
      e = d + ':' + e;
      b && (10 > d && (e = '0' + e), (e = c + ':' + e));
      return e;
    };
    shaka.ui.AdCounter = function (a, b) {
      shaka.ui.Element.call(this, a, b);
      var c = this;
      this.container_ = shaka.util.Dom.createHTMLElement('div');
      this.container_.classList.add('shaka-ad-counter');
      this.parent.appendChild(this.container_);
      this.span_ = shaka.util.Dom.createHTMLElement('span');
      this.span_.classList.add('shaka-ad-counter-span');
      this.container_.appendChild(this.span_);
      this.timer_ = new shaka.util.Timer(function () {
        c.onTimerTick_();
      });
      this.updateAriaLabel_();
      this.eventManager.listen(this.localization, shaka.ui.Localization.LOCALE_UPDATED, function () {
        c.updateAriaLabel_();
      });
      this.eventManager.listen(this.localization, shaka.ui.Localization.LOCALE_CHANGED, function () {
        c.updateAriaLabel_();
      });
      this.eventManager.listen(this.adManager, shaka.ads.AdManager.AD_STARTED, function () {
        c.onAdStarted_();
      });
      this.eventManager.listen(this.adManager, shaka.ads.AdManager.AD_STOPPED, function () {
        c.reset_();
      });
    };
    $jscomp.inherits(shaka.ui.AdCounter, shaka.ui.Element);
    shaka.ui.AdCounter.prototype.updateAriaLabel_ = function () {};
    shaka.ui.AdCounter.prototype.onAdStarted_ = function () {
      this.timer_.tickNow();
      this.timer_.tickEvery(0.5);
    };
    shaka.ui.AdCounter.prototype.onTimerTick_ = function () {
      goog.asserts.assert(null != this.ad, 'this.ad should exist at this point');
      var a = Math.round(this.ad.getRemainingTime()),
        b = this.ad.getDuration();
      -1 != a &&
        -1 != b &&
        (0 < a
          ? ((a = shaka.ui.Utils.buildTimeString(b - a, !1)),
            (b = shaka.ui.Utils.buildTimeString(b, !1)),
            (b = a + ' / ' + b),
            1 < this.ad.getSequenceLength()
              ? (this.span_.textContent = b)
              : ((a = this.localization.resolve(shaka.ui.Locales.Ids.AD_TIME)),
                (this.span_.textContent = a.replace('[AD_TIME]', b))))
          : this.reset_());
    };
    shaka.ui.AdCounter.prototype.reset_ = function () {
      this.timer_.stop();
      this.span_.textContent = '';
    };
    shaka.ui.AdCounter.prototype.release = function () {
      this.timer_.stop();
      this.timer_ = null;
      shaka.ui.Element.prototype.release.call(this);
    };
    goog.exportSymbol('shaka.ui.AdCounter', shaka.ui.AdCounter);
    shaka.ui.AdPosition = function (a, b) {
      shaka.ui.Element.call(this, a, b);
      var c = this;
      this.container_ = shaka.util.Dom.createHTMLElement('div');
      this.container_.classList.add('shaka-ad-position');
      shaka.ui.Utils.setDisplay(this.container_, !1);
      this.parent.appendChild(this.container_);
      this.span_ = shaka.util.Dom.createHTMLElement('span');
      this.span_.classList.add('shaka-ad-position-span');
      this.container_.appendChild(this.span_);
      this.updateAriaLabel_();
      this.eventManager.listen(this.localization, shaka.ui.Localization.LOCALE_UPDATED, function () {
        c.ad && (c.updateAriaLabel_(), c.setPosition_());
      });
      this.eventManager.listen(this.localization, shaka.ui.Localization.LOCALE_CHANGED, function () {
        c.ad && (c.updateAriaLabel_(), c.setPosition_());
      });
      this.eventManager.listen(this.adManager, shaka.ads.AdManager.AD_STARTED, function () {
        c.setPosition_();
      });
      this.eventManager.listen(this.adManager, shaka.ads.AdManager.AD_STOPPED, function () {
        c.span_.textContent = '';
        shaka.ui.Utils.setDisplay(c.container_, !1);
      });
    };
    $jscomp.inherits(shaka.ui.AdPosition, shaka.ui.Element);
    shaka.ui.AdPosition.prototype.updateAriaLabel_ = function () {};
    shaka.ui.AdPosition.prototype.setPosition_ = function () {
      var a = this.ad.getSequenceLength();
      if (1 < a) {
        var b = shaka.ui.Locales.Ids,
          c = this.ad.getPositionInSequence();
        this.span_.textContent = this.localization
          .resolve(b.AD_PROGRESS)
          .replace('[AD_ON]', String(c))
          .replace('[NUM_ADS]', String(a));
        shaka.ui.Utils.setDisplay(this.container_, !0);
      }
    };
    goog.exportSymbol('shaka.ui.AdPosition', shaka.ui.AdPosition);
    shaka.ui.Constants = {};
    shaka.ui.Constants.ARIA_LABEL = 'aria-label';
    shaka.ui.Constants.MIN_SEEK_WINDOW_TO_SHOW_SEEKBAR = 5;
    shaka.ui.LanguageUtils = function () {};
    shaka.ui.LanguageUtils.updateTracks = function (a, b, c, d, e, f, g) {
      var h = a.filter(function (u) {
          return 1 == u.active;
        })[0],
        k = shaka.ui.Utils.getFirstDescendantWithClassName(b, 'shaka-back-to-overflow-button');
      shaka.util.Dom.removeAllChildren(b);
      b.appendChild(k);
      k = function (u) {
        return 'variant' == u.type ? (u.audioRoles ? u.audioRoles.join(', ') : void 0) : u.roles.join(', ');
      };
      for (
        var l = function (u, v) {
            return u + ': ' + v;
          },
          m = new Map(),
          n = $jscomp.makeIterator(a),
          p = n.next();
        !p.done;
        p = n.next()
      )
        (p = p.value), m.has(p.language) || m.set(p.language, new Set()), m.get(p.language).add(k(p));
      m = new Set();
      h = h ? l(h.language, k(h)) : '';
      n = {};
      a = $jscomp.makeIterator(a);
      for (
        p = a.next();
        !p.done;
        n = { $jscomp$loop$prop$track$503$555: n.$jscomp$loop$prop$track$503$555 }, p = a.next()
      ) {
        n.$jscomp$loop$prop$track$503$555 = p.value;
        p = n.$jscomp$loop$prop$track$503$555.language;
        var q = k(n.$jscomp$loop$prop$track$503$555),
          r = l(p, q);
        if (!m.has(r)) {
          m.add(r);
          var t = shaka.util.Dom.createButton();
          t.addEventListener(
            'click',
            (function (u) {
              return function () {
                c(u.$jscomp$loop$prop$track$503$555);
              };
            })(n),
          );
          var w = shaka.util.Dom.createHTMLElement('span');
          t.appendChild(w);
          w.textContent = shaka.ui.LanguageUtils.getLanguageName(p, f);
          switch (g) {
            case shaka.ui.TrackLabelFormat.ROLE:
              q
                ? (w.textContent = q)
                : (shaka.log.alwaysWarn(
                    'Track #' +
                      n.$jscomp$loop$prop$track$503$555.id +
                      ' does not have a role, but the UI is configured to only show role.',
                  ),
                  (w.textContent = '?'));
              break;
            case shaka.ui.TrackLabelFormat.LANGUAGE_ROLE:
              q && (w.textContent += ': ' + q);
          }
          d &&
            r == h &&
            (t.appendChild(shaka.ui.Utils.checkmarkIcon()),
            w.classList.add('shaka-chosen-item'),
            t.setAttribute('aria-selected', 'true'),
            (e.textContent = w.textContent));
          b.appendChild(t);
        }
      }
    };
    shaka.ui.LanguageUtils.getLanguageName = function (a, b) {
      if (!a && !b) return '';
      switch (a) {
        case 'mul':
          return b.resolve(shaka.ui.Locales.Ids.MULTIPLE_LANGUAGES);
        case 'und':
          return b.resolve(shaka.ui.Locales.Ids.UNDETERMINED_LANGUAGE);
        case 'zxx':
          return b.resolve(shaka.ui.Locales.Ids.NOT_APPLICABLE);
      }
      var c = shaka.util.LanguageUtils.getBase(a);
      return a in mozilla.LanguageMapping
        ? mozilla.LanguageMapping[a].nativeName
        : c in mozilla.LanguageMapping
        ? mozilla.LanguageMapping[c].nativeName + ' (' + a + ')'
        : b.resolve(shaka.ui.Locales.Ids.UNRECOGNIZED_LANGUAGE) + ' (' + a + ')';
    };
    shaka.ui.PlayButton = function (a, b) {
      shaka.ui.Element.call(this, a, b);
      var c = this,
        d = shaka.ads.AdManager;
      this.button = shaka.util.Dom.createButton();
      this.parent.appendChild(this.button);
      this.eventManager.listen(this.localization, shaka.ui.Localization.LOCALE_UPDATED, function () {
        c.updateAriaLabel();
      });
      this.eventManager.listen(this.localization, shaka.ui.Localization.LOCALE_CHANGED, function () {
        c.updateAriaLabel();
      });
      this.eventManager.listen(this.video, 'play', function () {
        c.updateAriaLabel();
        c.updateIcon();
      });
      this.eventManager.listen(this.video, 'pause', function () {
        c.updateAriaLabel();
        c.updateIcon();
      });
      this.eventManager.listen(this.adManager, d.AD_PAUSED, function () {
        c.updateAriaLabel();
        c.updateIcon();
      });
      this.eventManager.listen(this.adManager, d.AD_RESUMED, function () {
        c.updateAriaLabel();
        c.updateIcon();
      });
      this.eventManager.listen(this.adManager, d.AD_STARTED, function () {
        c.updateAriaLabel();
        c.updateIcon();
      });
      this.eventManager.listen(this.button, 'click', function () {
        c.ad ? c.controls.playPauseAd() : c.controls.playPausePresentation();
      });
    };
    $jscomp.inherits(shaka.ui.PlayButton, shaka.ui.Element);
    shaka.ui.PlayButton.prototype.isPaused = function () {
      return this.ad ? this.ad.isPaused() : this.controls.presentationIsPaused();
    };
    shaka.ui.PlayButton.prototype.updateAriaLabel = function () {
      var a = shaka.ui.Locales.Ids;
      a = this.isPaused() ? a.PLAY : a.PAUSE;
      this.button.setAttribute(shaka.ui.Constants.ARIA_LABEL, this.localization.resolve(a));
    };
    shaka.ui.PlayButton.prototype.updateIcon = function () {};
    goog.exportSymbol('shaka.ui.PlayButton', shaka.ui.PlayButton);
    shaka.ui.BigPlayButton = function (a, b) {
      shaka.ui.PlayButton.call(this, a, b);
      this.button.classList.add('shaka-play-button');
      this.button.classList.add('shaka-no-propagation');
      this.updateIcon();
      this.updateAriaLabel();
    };
    $jscomp.inherits(shaka.ui.BigPlayButton, shaka.ui.PlayButton);
    shaka.ui.BigPlayButton.prototype.updateIcon = function () {
      this.isPaused() ? this.button.setAttribute('icon', 'play') : this.button.setAttribute('icon', 'pause');
    };
    goog.exportSymbol('shaka.ui.BigPlayButton', shaka.ui.BigPlayButton);
    shaka.ui.RangeElement = function (a, b, c, d) {
      shaka.ui.Element.call(this, a, b);
      var e = this;
      this.container = shaka.util.Dom.createHTMLElement('div');
      this.container.classList.add('shaka-range-container');
      this.container.classList.add.apply(this.container.classList, $jscomp.arrayFromIterable(c));
      this.isChanging_ = !1;
      this.bar = document.createElement('input');
      this.bar.classList.add('shaka-range-element');
      this.bar.classList.add.apply(this.bar.classList, $jscomp.arrayFromIterable(d));
      this.bar.type = 'range';
      this.bar.step = 'any';
      this.bar.min = '0';
      this.bar.max = '1';
      this.bar.value = '0';
      this.container.appendChild(this.bar);
      this.parent.appendChild(this.container);
      this.eventManager.listen(this.bar, 'mousedown', function () {
        e.controls.isOpaque() && ((e.isChanging_ = !0), e.onChangeStart());
      });
      this.eventManager.listen(this.bar, 'touchstart', function (f) {
        e.controls.isOpaque() && ((e.isChanging_ = !0), e.setBarValueForTouch_(f), e.onChangeStart());
      });
      this.eventManager.listen(this.bar, 'input', function () {
        e.onChange();
      });
      this.eventManager.listen(this.bar, 'touchmove', function (f) {
        e.isChanging_ && (e.setBarValueForTouch_(f), e.onChange());
      });
      this.eventManager.listen(this.bar, 'touchend', function (f) {
        e.isChanging_ && ((e.isChanging_ = !1), e.setBarValueForTouch_(f), e.onChangeEnd());
      });
      this.eventManager.listen(this.bar, 'mouseup', function () {
        e.isChanging_ && ((e.isChanging_ = !1), e.onChangeEnd());
      });
    };
    $jscomp.inherits(shaka.ui.RangeElement, shaka.ui.Element);
    shaka.ui.RangeElement.prototype.setRange = function (a, b) {
      this.bar.min = a;
      this.bar.max = b;
    };
    shaka.ui.RangeElement.prototype.onChangeStart = function () {};
    shaka.ui.RangeElement.prototype.onChange = function () {};
    shaka.ui.RangeElement.prototype.onChangeEnd = function () {};
    shaka.ui.RangeElement.prototype.getValue = function () {
      return parseFloat(this.bar.value);
    };
    shaka.ui.RangeElement.prototype.setValue = function (a) {
      this.isChanging_ || (this.bar.value = a);
    };
    shaka.ui.RangeElement.prototype.setBarValueForTouch_ = function (a) {
      a.preventDefault();
      var b = a.changedTouches[0],
        c = this.bar.getBoundingClientRect();
      a = parseFloat(this.bar.min);
      var d = parseFloat(this.bar.max);
      b = a + ((d - a) / c.width) * (b.clientX - c.left);
      b < a ? (b = a) : b > d && (b = d);
      this.bar.value = b;
    };
    goog.exportSymbol('shaka.ui.RangeElement', shaka.ui.RangeElement);
    goog.exportProperty(shaka.ui.RangeElement.prototype, 'setValue', shaka.ui.RangeElement.prototype.setValue);
    goog.exportProperty(shaka.ui.RangeElement.prototype, 'getValue', shaka.ui.RangeElement.prototype.getValue);
    goog.exportProperty(shaka.ui.RangeElement.prototype, 'onChangeEnd', shaka.ui.RangeElement.prototype.onChangeEnd);
    goog.exportProperty(shaka.ui.RangeElement.prototype, 'onChange', shaka.ui.RangeElement.prototype.onChange);
    goog.exportProperty(
      shaka.ui.RangeElement.prototype,
      'onChangeStart',
      shaka.ui.RangeElement.prototype.onChangeStart,
    );
    goog.exportProperty(shaka.ui.RangeElement.prototype, 'setRange', shaka.ui.RangeElement.prototype.setRange);
    shaka.ui.SeekBar = function (a, b) {
      shaka.ui.RangeElement.call(
        this,
        a,
        b,
        ['shaka-seek-bar-container'],
        ['shaka-seek-bar', 'shaka-no-propagation', 'shaka-show-controls-on-mouse-over'],
      );
      var c = this;
      this.adMarkerContainer_ = shaka.util.Dom.createHTMLElement('div');
      this.adMarkerContainer_.classList.add('shaka-ad-markers');
      this.container.insertBefore(this.adMarkerContainer_, this.container.childNodes[0]);

      // TODO add custom event to let other components know about fake progress on mouseover.
      // Only send every other event cos of the performance.
      let noOfEvents = 1;
      var onMouseMove = function (event) {
        if (noOfEvents % 2 === 1) {
          var rangeElement = event.currentTarget;
          var seekBarClientWidth = rangeElement.clientWidth; // half of the thumb;
          var position = event.offsetX || (event.touches ? event.touches[0].pageX - rangeElement.offsetLeft : 0);
          var progress = 0;

          if (event.buttons === 1) {
            // left button pressed
            progress = rangeElement.value / rangeElement.max;
          } else {
            /*
              We need to take range's thumb into account, relative to current timestamp position.
              Thumb has its "center":
                - on the left when:   |o------| -> subtract 10px
                - on the center when: |---o---| -> subtract 0px
                - on the right when:  |------o| -> add 10px
              Seamlessly float between those intervals and add/subtract width depending on current video's position.
              Width of the thumb = 20px.
            */
            var ratio = position / seekBarClientWidth;
            var thumbFactor = Math.abs(ratio - 0.5) * 20 * (ratio > 0.5 ? 1 : -1);
            position += thumbFactor;

            var progress = position / seekBarClientWidth;
            var progress = Math.min(Math.max(progress, 0), 1);
          }

          c.controls.dispatchEvent(
            new shaka.util.FakeEvent('seekBarMouseOver', {
              progress: progress,
              screenX: event.clientX || (event.touches ? event.touches[0].clientX : 0),
              seekBarHorizontalMargin: rangeElement.offsetLeft,
            }),
          );
        }
        noOfEvents++;
      };
      var onMouseOut = function () {
        c.controls.dispatchEvent(new shaka.util.FakeEvent('seekBarMouseOut'));
      };

      this.eventManager.listen(this.bar, 'mousemove', onMouseMove);
      this.eventManager.listen(this.bar, 'touchmove', onMouseMove);
      this.eventManager.listen(this.bar, 'mouseout', onMouseOut);
      this.eventManager.listen(this.bar, 'touchend', onMouseOut);

      this.config_ = this.controls.getConfig();
      this.seekTimer_ = new shaka.util.Timer(function () {
        c.video.currentTime = c.getValue();
      });
      this.adBreaksTimer_ = new shaka.util.Timer(function () {
        c.markAdBreaks_();
      });
      this.wasPlaying_ = !1;
      this.adCuePoints_ = [];
      this.eventManager.listen(this.localization, shaka.ui.Localization.LOCALE_UPDATED, function () {
        return c.updateAriaLabel_();
      });
      this.eventManager.listen(this.localization, shaka.ui.Localization.LOCALE_CHANGED, function () {
        return c.updateAriaLabel_();
      });
      this.eventManager.listen(this.adManager, shaka.ads.AdManager.AD_STARTED, function () {
        shaka.ui.Utils.setDisplay(c.container, !1);
      });
      this.eventManager.listen(this.adManager, shaka.ads.AdManager.AD_STOPPED, function () {
        c.shouldBeDisplayed_() && shaka.ui.Utils.setDisplay(c.container, !0);
      });
      this.eventManager.listen(this.adManager, shaka.ads.AdManager.CUEPOINTS_CHANGED, function (d) {
        c.adCuePoints_ = d.cuepoints;
        c.onAdCuePointsChanged_();
      });
      this.eventManager.listen(this.player, 'unloading', function () {
        c.adCuePoints_ = [];
        c.onAdCuePointsChanged_();
      });
      this.setValue(this.video.currentTime);
      this.update();
      this.updateAriaLabel_();
    };
    $jscomp.inherits(shaka.ui.SeekBar, shaka.ui.RangeElement);
    shaka.ui.SeekBar.prototype.release = function () {
      this.seekTimer_ &&
        (this.seekTimer_.stop(), (this.seekTimer_ = null), this.adBreaksTimer_.stop(), (this.adBreaksTimer_ = null));
      shaka.ui.RangeElement.prototype.release.call(this);
    };
    shaka.ui.SeekBar.prototype.onChangeStart = function () {
      this.wasPlaying_ = !this.video.paused;
      this.controls.setSeeking(!0);
      this.video.pause();
    };
    shaka.ui.SeekBar.prototype.onChange = function () {
      this.video.duration && (this.update(), this.seekTimer_.tickAfter(0.125));
    };
    shaka.ui.SeekBar.prototype.onChangeEnd = function () {
      this.seekTimer_.tickNow();
      this.controls.setSeeking(!1);
      this.wasPlaying_ && this.video.play();
    };
    shaka.ui.SeekBar.prototype.isShowing = function () {
      return !this.container.classList.contains('shaka-hidden');
    };
    shaka.ui.SeekBar.prototype.update = function () {
      var a = this.config_.seekBarColors,
        b = this.getValue(),
        c = this.video.buffered.length,
        d = c ? this.video.buffered.start(0) : 0,
        e = c ? this.video.buffered.end(c - 1) : 0,
        f = this.player.seekRange(),
        g = f.end - f.start;
      this.setRange(f.start, f.end);
      this.shouldBeDisplayed_()
        ? (shaka.ui.Utils.setDisplay(this.container, !0),
          // TODO remove seekbar's color updates on empty buffer to stop progress disappearing
          // 0 == c
          //   ? (this.container.style.background = a.base)
          //   :
          ((c = (Math.max(d, f.start) - f.start) / g || 0),
          (e = (Math.min(e, f.end) - f.start) / g || 0),
          (b = (Math.min(Math.max(b, f.start), f.end) - f.start) / g || 0),
          (a = [
            'to right',
            this.makeColor_(this.config_.showUnbufferedStart ? a.base : a.played, c),
            this.makeColor_(a.played, c),
            this.makeColor_(a.played, b),
            this.makeColor_(a.buffered, b),
            this.makeColor_(a.buffered, e),
            this.makeColor_(a.base, e),
          ]),
          (this.container.style.background = 'linear-gradient(' + a.join(',') + ')')))
        : shaka.ui.Utils.setDisplay(this.container, !1);
    };
    shaka.ui.SeekBar.prototype.markAdBreaks_ = function () {
      if (this.adCuePoints_.length) {
        for (
          var a = this.player.seekRange(),
            b = a.end - a.start,
            c = ['to right'],
            d = [],
            e = this.config_.seekBarColors.adBreaks,
            f = !1,
            g = $jscomp.makeIterator(this.adCuePoints_),
            h = g.next();
          !h.done;
          h = g.next()
        )
          if (
            ((h = h.value),
            -1 != h.start || h.end || (f = !0),
            h.start >= a.start && h.start < a.end && !(h.end && h.end > a.end))
          ) {
            var k = (h.start - a.start) / b || 0,
              l = k + 0.01;
            h.end && (l = (h.end - a.start) / b || 0);
            d.push({ start: k, end: l });
          }
        a = $jscomp.makeIterator(d);
        for (h = a.next(); !h.done; h = a.next())
          (b = h.value),
            c.push(this.makeColor_('transparent', b.start)),
            c.push(this.makeColor_(e, b.start)),
            c.push(this.makeColor_(e, b.end)),
            c.push(this.makeColor_('transparent', b.end));
        f && (c.push(this.makeColor_('transparent', 0.99)), c.push(this.makeColor_(e, 0.99)));
        this.adMarkerContainer_.style.background = 'linear-gradient(' + c.join(',') + ')';
      } else this.adMarkerContainer_.style.background = 'transparent';
    };
    shaka.ui.SeekBar.prototype.makeColor_ = function (a, b) {
      return a + ' ' + 100 * b + '%';
    };
    shaka.ui.SeekBar.prototype.onAdCuePointsChanged_ = function () {
      this.markAdBreaks_();
      var a = this.player.seekRange();
      a = a.end - a.start;
      var b = shaka.ui.Constants.MIN_SEEK_WINDOW_TO_SHOW_SEEKBAR;
      this.player.isLive() && a > b && this.adBreaksTimer_.tickEvery(1);
    };
    shaka.ui.SeekBar.prototype.shouldBeDisplayed_ = function () {
      var a = this.player.seekRange();
      a = a.end - a.start;
      return this.player.isLive() && a < shaka.ui.Constants.MIN_SEEK_WINDOW_TO_SHOW_SEEKBAR ? !1 : null == this.ad;
    };
    shaka.ui.SeekBar.prototype.updateAriaLabel_ = function () {
      this.bar.setAttribute(shaka.ui.Constants.ARIA_LABEL, this.localization.resolve(shaka.ui.Locales.Ids.SEEK));
    };
    goog.exportSymbol('shaka.ui.SeekBar', shaka.ui.SeekBar);
    shaka.ui.ControlsPanel = {};
    shaka.ui.Controls = function (a, b, c, d) {
      shaka.util.FakeEventTarget.call(this);
      var e = this;
      this.enabled_ = !0;
      this.config_ = d;
      this.castProxy_ = new shaka.cast.CastProxy(c, a, this.config_.castReceiverAppId);
      this.castAllowed_ = !0;
      this.video_ = this.castProxy_.getVideo();
      this.localVideo_ = c;
      this.player_ = this.castProxy_.getPlayer();
      this.localPlayer_ = a;
      this.videoContainer_ = b;
      this.adManager_ = this.player_.getAdManager();
      this.seekBar_ = this.ad_ = null;
      this.isSeeking_ = !1;
      this.menus_ = [];
      this.showOnHoverControls_ = [];
      this.recentMouseMovement_ = !1;
      this.mouseStillTimer_ = new shaka.util.Timer(function () {
        e.onMouseStill_();
      });
      this.fadeControlsTimer_ = new shaka.util.Timer(function () {
        e.controlsContainer_.removeAttribute('shown');
        e.hideSettingsMenusTimer_.tickAfter(2);
      });
      this.hideSettingsMenusTimer_ = new shaka.util.Timer(function () {
        for (var f = $jscomp.makeIterator(e.menus_), g = f.next(); !g.done; g = f.next())
          shaka.ui.Utils.setDisplay(g.value, !1);
      });
      this.timeAndSeekRangeTimer_ = new shaka.util.Timer(function () {
        e.isOpaque() && e.updateTimeAndSeekRange_();
      });
      this.lastTouchEventTime_ = null;
      this.elements_ = [];
      this.localization_ = shaka.ui.Controls.createLocalization_();
      this.eventManager_ = new shaka.util.EventManager();
      this.configure(this.config_);
      this.addEventListeners_();
      this.pressedKeys_ = new Set();
      this.onCastStatusChange_();
      this.timeAndSeekRangeTimer_.tickEvery(0.125);
      this.eventManager_.listen(this.localization_, shaka.ui.Localization.LOCALE_CHANGED, function (f) {
        e.adManager_.setLocale(f.locales[0]);
      });
    };
    $jscomp.inherits(shaka.ui.Controls, shaka.util.FakeEventTarget);
    shaka.ui.Controls.prototype.destroy = function () {
      var a = this;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (b) {
        switch (b.nextAddress) {
          case 1:
            a.eventManager_ && (a.eventManager_.release(), (a.eventManager_ = null));
            a.mouseStillTimer_ && (a.mouseStillTimer_.stop(), (a.mouseStillTimer_ = null));
            a.fadeControlsTimer_ && (a.fadeControlsTimer_.stop(), (a.fadeControlsTimer_ = null));
            a.hideSettingsMenusTimer_ && (a.hideSettingsMenusTimer_.stop(), (a.hideSettingsMenusTimer_ = null));
            a.timeAndSeekRangeTimer_ && (a.timeAndSeekRangeTimer_.stop(), (a.timeAndSeekRangeTimer_ = null));
            a.releaseChildElements_();
            a.controlsContainer_ &&
              (a.videoContainer_.removeChild(a.controlsContainer_), (a.controlsContainer_ = null));
            if (!a.castProxy_) {
              b.jumpTo(2);
              break;
            }
            return b.yield(a.castProxy_.destroy(), 3);
          case 3:
            a.castProxy_ = null;
          case 2:
            if (!a.localPlayer_) {
              b.jumpTo(4);
              break;
            }
            return b.yield(a.localPlayer_.destroy(), 5);
          case 5:
            a.localPlayer_ = null;
          case 4:
            (a.player_ = null),
              (a.localVideo_ = null),
              (a.video_ = null),
              (a.localization_ = null),
              a.pressedKeys_.clear(),
              b.jumpToEnd();
        }
      });
    };
    shaka.ui.Controls.prototype.releaseChildElements_ = function () {
      for (var a = $jscomp.makeIterator(this.elements_), b = a.next(); !b.done; b = a.next()) b.value.release();
      this.elements_ = [];
    };
    shaka.ui.Controls.registerElement = function (a, b) {
      shaka.ui.ControlsPanel.elementNamesToFactories_.set(a, b);
    };
    shaka.ui.Controls.prototype.allowCast = function (a) {
      this.castAllowed_ = a;
      this.onCastStatusChange_();
    };
    shaka.ui.Controls.prototype.loadComplete = function () {
      this.onPlayStateChange_();
    };
    shaka.ui.Controls.prototype.configure = function (a) {
      this.config_ = a;
      this.castProxy_.changeReceiverId(a.castReceiverAppId);
      this.seekBar_ && (this.seekBar_ = null);
      this.playButton_ && (this.playButton_ = null);
      this.controlsContainer_
        ? (shaka.util.Dom.removeAllChildren(this.controlsContainer_), this.releaseChildElements_())
        : this.addControlsContainer_();
      this.createDOM_();
      this.onPlayStateChange_();
      a = this.videoContainer_.getElementsByClassName('shaka-no-propagation');
      a = $jscomp.makeIterator(a);
      for (var b = a.next(); !b.done; b = a.next()) {
        b = b.value;
        var c = function (d) {
          return d.stopPropagation();
        };
        this.eventManager_.listen(b, 'click', c);
        this.eventManager_.listen(b, 'dblclick', c);
      }
    };
    shaka.ui.Controls.prototype.setEnabledShakaControls = function (a) {
      (this.enabled_ = a)
        ? (this.videoContainer_.setAttribute('shaka-controls', 'true'),
          (this.localVideo_.tabIndex = -1),
          (this.localVideo_.controls = !1))
        : this.videoContainer_.removeAttribute('shaka-controls');
      this.onPlayStateChange_();
    };
    shaka.ui.Controls.prototype.setEnabledNativeControls = function (a) {
      this.localVideo_.controls = a;
      this.localVideo_.tabIndex = a ? 0 : -1;
      a && this.setEnabledShakaControls(!1);
    };
    shaka.ui.Controls.prototype.getCastProxy = function () {
      return this.castProxy_;
    };
    shaka.ui.Controls.prototype.getLocalization = function () {
      return this.localization_;
    };
    shaka.ui.Controls.prototype.getVideoContainer = function () {
      return this.videoContainer_;
    };
    shaka.ui.Controls.prototype.getVideo = function () {
      return this.video_;
    };
    shaka.ui.Controls.prototype.getLocalVideo = function () {
      return this.localVideo_;
    };
    shaka.ui.Controls.prototype.getPlayer = function () {
      return this.player_;
    };
    shaka.ui.Controls.prototype.getLocalPlayer = function () {
      return this.localPlayer_;
    };
    shaka.ui.Controls.prototype.getControlsContainer = function () {
      goog.asserts.assert(this.controlsContainer_, 'No controls container after destruction!');
      return this.controlsContainer_;
    };
    shaka.ui.Controls.prototype.getServerSideAdContainer = function () {
      return this.daiAdContainer_;
    };
    shaka.ui.Controls.prototype.getConfig = function () {
      return this.config_;
    };
    shaka.ui.Controls.prototype.isSeeking = function () {
      return this.isSeeking_;
    };
    shaka.ui.Controls.prototype.setSeeking = function (a) {
      this.isSeeking_ = a;
    };
    shaka.ui.Controls.prototype.isCastAllowed = function () {
      return this.castAllowed_;
    };
    shaka.ui.Controls.prototype.getDisplayTime = function () {
      return this.seekBar_ ? this.seekBar_.getValue() : this.video_.currentTime;
    };
    shaka.ui.Controls.prototype.setLastTouchEventTime = function (a) {
      this.lastTouchEventTime_ = a;
    };
    shaka.ui.Controls.prototype.anySettingsMenusAreOpen = function () {
      return this.menus_.some(function (a) {
        return !a.classList.contains('shaka-hidden');
      });
    };
    shaka.ui.Controls.prototype.hideSettingsMenus = function () {
      this.hideSettingsMenusTimer_.tickNow();
    };
    shaka.ui.Controls.prototype.toggleFullScreen = function () {
      var a = this,
        b;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (c) {
        switch (c.nextAddress) {
          case 1:
            if (document.fullscreenElement) return c.yield(document.exitFullscreen(), 0);
            c.setCatchFinallyBlocks(4);
            if (!document.pictureInPictureElement) {
              c.jumpTo(6);
              break;
            }
            return c.yield(document.exitPictureInPicture(), 6);
          case 6:
            return c.yield(a.videoContainer_.requestFullscreen({ navigationUI: 'hide' }), 8);
          case 8:
            c.leaveTryBlock(0);
            break;
          case 4:
            (b = c.enterCatchBlock()), a.dispatchEvent(new shaka.util.FakeEvent('error', { detail: b })), c.jumpTo(0);
        }
      });
    };
    shaka.ui.Controls.prototype.showAdUI = function () {
      shaka.ui.Utils.setDisplay(this.adPanel_, !0);
    };
    shaka.ui.Controls.prototype.hideAdUI = function () {
      shaka.ui.Utils.setDisplay(this.adPanel_, !1);
    };
    shaka.ui.Controls.prototype.playPausePresentation = function () {
      this.enabled_ &&
        this.video_.duration &&
        (this.player_.cancelTrickPlay(), this.presentationIsPaused() ? this.video_.play() : this.video_.pause());
    };
    shaka.ui.Controls.prototype.playPauseAd = function () {
      this.ad_ && this.ad_.isPaused() ? this.ad_.play() : this.ad_ && this.ad_.pause();
    };
    shaka.ui.Controls.prototype.presentationIsPaused = function () {
      return this.video_.paused && !this.isSeeking();
    };
    shaka.ui.Controls.prototype.createDOM_ = function () {
      this.videoContainer_.classList.add('shaka-video-container');
      this.localVideo_.classList.add('shaka-video');
      this.addScrimContainer_();
      this.config_.addBigPlayButton && this.addPlayButton_();
      this.spinnerContainer_ || this.addBufferingSpinner_();
      this.addDaiAdContainer_();
      this.addControlsButtonPanel_();
      this.menus_ = Array.from(this.videoContainer_.getElementsByClassName('shaka-settings-menu'));
      this.menus_.push.apply(
        this.menus_,
        $jscomp.arrayFromIterable(Array.from(this.videoContainer_.getElementsByClassName('shaka-overflow-menu'))),
      );
      if (this.config_.addSeekBar)
        (this.seekBar_ = new shaka.ui.SeekBar(this.bottomControls_, this)), this.elements_.push(this.seekBar_);
      else
        for (var a = $jscomp.makeIterator(this.menus_), b = a.next(); !b.done; b = a.next())
          b.value.classList.add('shaka-low-position');
      this.showOnHoverControls_ = Array.from(
        this.videoContainer_.getElementsByClassName('shaka-show-controls-on-mouse-over'),
      );
    };
    shaka.ui.Controls.prototype.addControlsContainer_ = function () {
      var a = this;
      this.controlsContainer_ = shaka.util.Dom.createHTMLElement('div');
      this.controlsContainer_.classList.add('shaka-controls-container');
      this.videoContainer_.appendChild(this.controlsContainer_);
      this.videoContainer_.setAttribute('shaka-controls', 'true');
      this.eventManager_.listen(
        this.controlsContainer_,
        'touchstart',
        function (b) {
          a.onContainerTouch_(b);
        },
        { passive: !1 },
      );
      this.eventManager_.listen(this.controlsContainer_, 'click', function () {
        a.onContainerClick_();
      });
      this.eventManager_.listen(this.controlsContainer_, 'dblclick', function () {
        a.config_.doubleClickForFullscreen && a.toggleFullScreen();
      });
    };
    shaka.ui.Controls.prototype.addPlayButton_ = function () {
      var a = shaka.util.Dom.createHTMLElement('div');
      a.classList.add('shaka-play-button-container');
      this.controlsContainer_.appendChild(a);
      this.playButton_ = new shaka.ui.BigPlayButton(a, this);
      this.elements_.push(this.playButton_);
    };
    shaka.ui.Controls.prototype.addScrimContainer_ = function () {
      var a = shaka.util.Dom.createHTMLElement('div');
      a.classList.add('shaka-scrim-container');
      this.controlsContainer_.appendChild(a);
    };
    shaka.ui.Controls.prototype.addAdControls_ = function () {
      this.adPanel_ = shaka.util.Dom.createHTMLElement('div');
      this.adPanel_.classList.add('shaka-ad-controls');
      shaka.ui.Utils.setDisplay(this.adPanel_, !1);
      this.bottomControls_.appendChild(this.adPanel_);
      var a = new shaka.ui.AdPosition(this.adPanel_, this);
      this.elements_.push(a);
      a = new shaka.ui.AdCounter(this.adPanel_, this);
      this.elements_.push(a);
    };
    shaka.ui.Controls.prototype.addBufferingSpinner_ = function () {
      this.spinnerContainer_ = shaka.util.Dom.createHTMLElement('div');
      this.spinnerContainer_.classList.add('shaka-spinner-container');
      this.videoContainer_.appendChild(this.spinnerContainer_);
      var a = shaka.util.Dom.createHTMLElement('div');
      a.classList.add('shaka-spinner');
      this.spinnerContainer_.appendChild(a);
      var b = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      b.setAttribute('class', 'shaka-spinner-svg');
      b.setAttribute('viewBox', '0 0 30 30');
      a.appendChild(b);
      a = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
      a.setAttribute('class', 'shaka-spinner-path');
      a.setAttribute('cx', '15');
      a.setAttribute('cy', '15');
      a.setAttribute('r', '14.5');
      a.setAttribute('fill', 'none');
      a.setAttribute('stroke-width', '1');
      a.setAttribute('stroke-miterlimit', '10');
      b.appendChild(a);
    };
    shaka.ui.Controls.prototype.addControlsButtonPanel_ = function () {
      var a = this;
      this.bottomControls_ = shaka.util.Dom.createHTMLElement('div');
      this.bottomControls_.classList.add('shaka-bottom-controls');
      this.bottomControls_.classList.add('shaka-no-propagation');
      this.controlsContainer_.appendChild(this.bottomControls_);
      this.eventManager_.listen(this.bottomControls_, 'click', function () {
        a.hideSettingsMenus();
      });
      this.addAdControls_();
      this.controlsButtonPanel_ = shaka.util.Dom.createHTMLElement('div');
      this.controlsButtonPanel_.classList.add('shaka-controls-button-panel');
      this.controlsButtonPanel_.classList.add('shaka-show-controls-on-mouse-over');
      this.bottomControls_.appendChild(this.controlsButtonPanel_);
      for (
        var b = {}, c = $jscomp.makeIterator(this.config_.controlPanelElements), d = c.next();
        !d.done;
        b = { $jscomp$loop$prop$moddableElement$557: b.$jscomp$loop$prop$moddableElement$557 }, d = c.next()
      )
        (d = d.value),
          shaka.ui.ControlsPanel.elementNamesToFactories_.get(d)
            ? ((d = shaka.ui.ControlsPanel.elementNamesToFactories_.get(d).create(this.controlsButtonPanel_, this)),
              'function' != typeof d.release &&
                (shaka.Deprecate.deprecateFeature(
                  4,
                  'shaka.extern.IUIElement',
                  'Please update UI elements to have a release() method.',
                ),
                (b.$jscomp$loop$prop$moddableElement$557 = d),
                (b.$jscomp$loop$prop$moddableElement$557.release = (function (e) {
                  return function () {
                    e.$jscomp$loop$prop$moddableElement$557.destroy &&
                      e.$jscomp$loop$prop$moddableElement$557.destroy();
                  };
                })(b))),
              this.elements_.push(d))
            : shaka.log.alwaysWarn('Unrecognized control panel element requested:', d);
    };
    shaka.ui.Controls.prototype.addDaiAdContainer_ = function () {
      this.daiAdContainer_ = shaka.util.Dom.createHTMLElement('div');
      this.daiAdContainer_.classList.add('shaka-server-side-ad-container');
      this.controlsContainer_.appendChild(this.daiAdContainer_);
    };
    shaka.ui.Controls.prototype.addEventListeners_ = function () {
      var a = this;
      this.eventManager_.listen(this.player_, 'buffering', function () {
        a.onBufferingStateChange_();
      });
      this.onBufferingStateChange_();
      this.eventManager_.listen(window, 'keydown', function (b) {
        a.onKeyDown_(b);
      });
      this.eventManager_.listen(window, 'click', function () {
        return a.hideSettingsMenus();
      });
      this.eventManager_.listen(this.video_, 'play', function () {
        a.onPlayStateChange_();
      });
      this.eventManager_.listen(this.video_, 'pause', function () {
        a.onPlayStateChange_();
      });
      this.eventManager_.listen(this.video_, 'ended', function () {
        a.onPlayStateChange_();
      });
      this.eventManager_.listen(this.videoContainer_, 'mousemove', function (b) {
        a.onMouseMove_(b);
      });
      this.eventManager_.listen(
        this.videoContainer_,
        'touchmove',
        function (b) {
          a.onMouseMove_(b);
        },
        { passive: !0 },
      );
      this.eventManager_.listen(
        this.videoContainer_,
        'touchend',
        function (b) {
          a.onMouseMove_(b);
        },
        { passive: !0 },
      );
      this.eventManager_.listen(this.videoContainer_, 'mouseleave', function () {
        a.onMouseLeave_();
      });
      this.eventManager_.listen(this.castProxy_, 'caststatuschanged', function () {
        a.onCastStatusChange_();
      });
      this.eventManager_.listen(this.videoContainer_, 'keyup', function (b) {
        a.onKeyUp_(b);
      });
      this.eventManager_.listen(this.adManager_, shaka.ads.AdManager.AD_STARTED, function (b) {
        a.ad_ = b.ad;
        a.showAdUI();
      });
      this.eventManager_.listen(this.adManager_, shaka.ads.AdManager.AD_STOPPED, function () {
        a.ad_ = null;
        a.hideAdUI();
      });
      screen.orientation &&
        this.eventManager_.listen(screen.orientation, 'change', function () {
          return $jscomp.asyncExecutePromiseGeneratorProgram(function (b) {
            return b.yield(a.onScreenRotation_(), 0);
          });
        });
      this.eventManager_.listen(document, 'fullscreenchange', function () {
        a.ad_ && a.ad_.resize(a.localVideo_.offsetWidth, a.localVideo_.offsetHeight);
      });
    };
    shaka.ui.Controls.prototype.onScreenRotation_ = function () {
      var a = this;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (b) {
        return a.video_ && 0 != a.video_.readyState && !a.castProxy_.isCasting() && a.config_.enableFullscreenOnRotation
          ? screen.orientation.type.includes('landscape') && !document.fullscreenElement
            ? b.yield(a.videoContainer_.requestFullscreen({ navigationUI: 'hide' }), 0)
            : screen.orientation.type.includes('portrait') && document.fullscreenElement
            ? b.yield(document.exitFullscreen(), 0)
            : b.jumpTo(0)
          : b['return']();
      });
    };
    shaka.ui.Controls.prototype.onMouseMove_ = function (a) {
      'mousemove' == a.type &&
        (this.controlsContainer_.classList.remove('shaka-keyboard-navigation'), this.computeOpacity());
      'touchstart' == a.type ||
      'touchmove' == a.type ||
      'touchend' == a.type ||
      'keyup' == a.type ||
      'keydown' == a.type // added keydown
        ? (this.lastTouchEventTime_ = Date.now())
        : this.lastTouchEventTime_ + 1e3 < Date.now() && (this.lastTouchEventTime_ = null);
      (this.lastTouchEventTime_ && 'mousemove' == a.type) ||
        ((this.videoContainer_.style.cursor = ''),
        (this.recentMouseMovement_ = !0),
        this.hideSettingsMenusTimer_.stop(),
        this.isOpaque() || (this.updateTimeAndSeekRange_(), this.computeOpacity()),
        this.mouseStillTimer_.stop(),
        ('touchend' != a.type && 'keyup' != a.type && 'keydown' != a.type && this.lastTouchEventTime_) ||
          this.mouseStillTimer_.tickAfter(3)); // added keydown
    };
    shaka.ui.Controls.prototype.onMouseLeave_ = function () {
      this.lastTouchEventTime_ || this.mouseStillTimer_.tickNow();
    };
    shaka.ui.Controls.prototype.onMouseStill_ = function () {
      this.videoContainer_.style.cursor = 'none';
      this.recentMouseMovement_ = !1;
      this.computeOpacity();
    };
    shaka.ui.Controls.prototype.isHovered_ = function () {
      return window.matchMedia('hover: hover').matches
        ? this.showOnHoverControls_.some(function (a) {
            return a.matches(':hover');
          })
        : !1;
    };
    shaka.ui.Controls.prototype.computeOpacity = function () {
      var a = this.ad_ ? this.ad_.isPaused() : !1,
        b = this.video_.paused && !this.isSeeking_,
        c = this.controlsContainer_.classList.contains('shaka-keyboard-navigation');
      a || (!this.ad_ && b) || this.recentMouseMovement_ || c || this.isHovered_()
        ? (this.updateTimeAndSeekRange_(),
          this.controlsContainer_.setAttribute('shown', 'true'),
          this.fadeControlsTimer_.stop())
        : this.fadeControlsTimer_.tickAfter(this.config_.fadeDelay);
    };
    shaka.ui.Controls.prototype.onContainerTouch_ = function (a) {
      this.video_.duration &&
        (this.isOpaque() ? (this.lastTouchEventTime_ = Date.now()) : (this.onMouseMove_(a), a.preventDefault()));
    };
    shaka.ui.Controls.prototype.onContainerClick_ = function () {
      if (this.enabled_) if (this.anySettingsMenusAreOpen()) this.hideSettingsMenusTimer_.tickNow();
      // TODO omit this so we can implement custom play/pause overlay
      // else this.onPlayPauseClick_();
    };
    shaka.ui.Controls.prototype.onPlayPauseClick_ = function () {
      this.ad_ ? this.playPauseAd() : this.playPausePresentation();
    };
    shaka.ui.Controls.prototype.onCastStatusChange_ = function () {
      var a = this.castProxy_.isCasting();
      this.dispatchEvent(new shaka.util.FakeEvent('caststatuschanged', { newStatus: a }));
      a ? this.controlsContainer_.setAttribute('casting', 'true') : this.controlsContainer_.removeAttribute('casting');
    };
    shaka.ui.Controls.prototype.onPlayStateChange_ = function () {
      this.video_.ended && !this.video_.paused && this.video_.pause();
      this.computeOpacity();
    };
    shaka.ui.Controls.prototype.onKeyUp_ = function (a) {
      var b = document.activeElement,
        c = b && b.classList ? b.classList.contains('shaka-volume-bar') : !1,
        d = b && b.classList && b.classList.contains('shaka-seek-bar');
      if (this.controlsContainer_.contains(b)) this.onMouseMove_(a);
      this.pressedKeys_['delete'](a.key);
      if (this.config_.enableKeyboardPlaybackControls)
        switch (a.key) {
          case 'ArrowLeft':
            c || this.seek_(this.video_.currentTime - 5, a);
            break;
          case 'ArrowRight':
            c || this.seek_(this.video_.currentTime + 5, a);
            break;
          case 'Home':
            this.seek_(this.player_.seekRange().start, a);
            break;
          case 'End':
            this.seek_(this.player_.seekRange().end, a);
            break;
          case ' ':
            if (d) this.onPlayPauseClick_();
        }
    };
    shaka.ui.Controls.prototype.onBufferingStateChange_ = function () {
      this.enabled_ && shaka.ui.Utils.setDisplay(this.spinnerContainer_, this.player_.isBuffering());
    };
    shaka.ui.Controls.prototype.isOpaque = function () {
      return this.enabled_
        ? null != this.controlsContainer_.getAttribute('shown') ||
            null != this.controlsContainer_.getAttribute('casting')
        : !1;
    };
    shaka.ui.Controls.prototype.seek_ = function (a, b) {
      this.video_.currentTime = a;
      this.isOpaque() && this.updateTimeAndSeekRange_();
    };
    shaka.ui.Controls.prototype.updateTimeAndSeekRange_ = function () {
      if (this.seekBar_)
        if ((this.seekBar_.setValue(this.video_.currentTime), this.seekBar_.update(), this.seekBar_.isShowing()))
          for (var a = $jscomp.makeIterator(this.menus_), b = a.next(); !b.done; b = a.next())
            b.value.classList.remove('shaka-low-position');
        else
          for (a = $jscomp.makeIterator(this.menus_), b = a.next(); !b.done; b = a.next())
            b.value.classList.add('shaka-low-position');
      this.dispatchEvent(new shaka.util.FakeEvent('timeandseekrangeupdated'));
    };
    shaka.ui.Controls.prototype.onKeyDown_ = function (a) {
      var b = this;
      this.pressedKeys_.add(a.key);
      var c = this.anySettingsMenusAreOpen();
      'Tab' == a.key &&
        (this.controlsContainer_.classList.add('shaka-keyboard-navigation'),
        this.computeOpacity(),
        this.eventManager_.listen(window, 'mousedown', function () {
          return b.onMouseDown_();
        }));
      'Escape' == a.key && this.hideSettingsMenusTimer_.tickNow();
      c && this.pressedKeys_.has('Tab') && this.keepFocusInMenu_(a);
    };
    shaka.ui.Controls.prototype.keepFocusInMenu_ = function (a) {
      var b = this.menus_.filter(function (e) {
        return !e.classList.contains('shaka-hidden');
      })[0];
      if (b.childNodes.length) {
        for (var c = b.firstElementChild; c && c.classList.contains('shaka-hidden'); ) c = c.nextElementSibling;
        for (b = b.lastElementChild; b && b.classList.contains('shaka-hidden'); ) b = b.previousElementSibling;
        var d = document.activeElement;
        this.pressedKeys_.has('Shift')
          ? d == c && (a.preventDefault(), b.focus())
          : d == b && (a.preventDefault(), c.focus());
      }
    };
    shaka.ui.Controls.prototype.onMouseDown_ = function () {
      this.eventManager_.unlisten(window, 'mousedown');
    };
    shaka.ui.Controls.createLocalization_ = function () {
      var a = new shaka.ui.Localization('en');
      shaka.ui.Locales.addTo(a);
      a.changeLocale(navigator.languages || []);
      return a;
    };
    goog.exportSymbol('shaka.ui.Controls', shaka.ui.Controls);
    goog.exportProperty(shaka.ui.Controls.prototype, 'isOpaque', shaka.ui.Controls.prototype.isOpaque);
    goog.exportProperty(shaka.ui.Controls.prototype, 'hideAdUI', shaka.ui.Controls.prototype.hideAdUI);
    goog.exportProperty(shaka.ui.Controls.prototype, 'showAdUI', shaka.ui.Controls.prototype.showAdUI);
    goog.exportProperty(shaka.ui.Controls.prototype, 'toggleFullScreen', shaka.ui.Controls.prototype.toggleFullScreen);
    goog.exportProperty(
      shaka.ui.Controls.prototype,
      'hideSettingsMenus',
      shaka.ui.Controls.prototype.hideSettingsMenus,
    );
    goog.exportProperty(
      shaka.ui.Controls.prototype,
      'anySettingsMenusAreOpen',
      shaka.ui.Controls.prototype.anySettingsMenusAreOpen,
    );
    goog.exportProperty(
      shaka.ui.Controls.prototype,
      'setLastTouchEventTime',
      shaka.ui.Controls.prototype.setLastTouchEventTime,
    );
    goog.exportProperty(shaka.ui.Controls.prototype, 'getDisplayTime', shaka.ui.Controls.prototype.getDisplayTime);
    goog.exportProperty(shaka.ui.Controls.prototype, 'isCastAllowed', shaka.ui.Controls.prototype.isCastAllowed);
    goog.exportProperty(shaka.ui.Controls.prototype, 'setSeeking', shaka.ui.Controls.prototype.setSeeking);
    goog.exportProperty(shaka.ui.Controls.prototype, 'isSeeking', shaka.ui.Controls.prototype.isSeeking);
    goog.exportProperty(shaka.ui.Controls.prototype, 'getConfig', shaka.ui.Controls.prototype.getConfig);
    goog.exportProperty(
      shaka.ui.Controls.prototype,
      'getServerSideAdContainer',
      shaka.ui.Controls.prototype.getServerSideAdContainer,
    );
    goog.exportProperty(
      shaka.ui.Controls.prototype,
      'getControlsContainer',
      shaka.ui.Controls.prototype.getControlsContainer,
    );
    goog.exportProperty(shaka.ui.Controls.prototype, 'getLocalPlayer', shaka.ui.Controls.prototype.getLocalPlayer);
    goog.exportProperty(shaka.ui.Controls.prototype, 'getPlayer', shaka.ui.Controls.prototype.getPlayer);
    goog.exportProperty(shaka.ui.Controls.prototype, 'getLocalVideo', shaka.ui.Controls.prototype.getLocalVideo);
    goog.exportProperty(shaka.ui.Controls.prototype, 'getVideo', shaka.ui.Controls.prototype.getVideo);
    goog.exportProperty(
      shaka.ui.Controls.prototype,
      'getVideoContainer',
      shaka.ui.Controls.prototype.getVideoContainer,
    );
    goog.exportProperty(shaka.ui.Controls.prototype, 'getLocalization', shaka.ui.Controls.prototype.getLocalization);
    goog.exportProperty(shaka.ui.Controls.prototype, 'getCastProxy', shaka.ui.Controls.prototype.getCastProxy);
    goog.exportProperty(
      shaka.ui.Controls.prototype,
      'setEnabledNativeControls',
      shaka.ui.Controls.prototype.setEnabledNativeControls,
    );
    goog.exportProperty(
      shaka.ui.Controls.prototype,
      'setEnabledShakaControls',
      shaka.ui.Controls.prototype.setEnabledShakaControls,
    );
    goog.exportProperty(shaka.ui.Controls.prototype, 'configure', shaka.ui.Controls.prototype.configure);
    goog.exportProperty(shaka.ui.Controls.prototype, 'loadComplete', shaka.ui.Controls.prototype.loadComplete);
    goog.exportProperty(shaka.ui.Controls.prototype, 'allowCast', shaka.ui.Controls.prototype.allowCast);
    goog.exportProperty(shaka.ui.Controls, 'registerElement', shaka.ui.Controls.registerElement);
    goog.exportProperty(shaka.ui.Controls.prototype, 'destroy', shaka.ui.Controls.prototype.destroy);
    shaka.ui.ControlsPanel.elementNamesToFactories_ = new Map();
    shaka.ui.OverflowMenu = function (a, b) {
      shaka.ui.Element.call(this, a, b);
      var c = this;
      this.config_ = this.controls.getConfig();
      this.controlsContainer_ = this.controls.getControlsContainer();
      this.children_ = [];
      this.addOverflowMenuButton_();
      this.addOverflowMenu_();
      this.createChildren_();
      var d = this.controls.getVideoContainer().getElementsByClassName('shaka-back-to-overflow-button');
      d = $jscomp.makeIterator(d);
      for (var e = d.next(); !e.done; e = d.next())
        this.eventManager.listen(e.value, 'click', function () {
          c.controls.hideSettingsMenus();
          shaka.ui.Utils.setDisplay(c.overflowMenu_, !0);
          c.overflowMenu_.childNodes.length && c.overflowMenu_.childNodes[0].focus();
          c.controls.computeOpacity();
        });
      this.eventManager.listen(this.localization, shaka.ui.Localization.LOCALE_UPDATED, function () {
        c.updateAriaLabel_();
      });
      this.eventManager.listen(this.localization, shaka.ui.Localization.LOCALE_CHANGED, function () {
        c.updateAriaLabel_();
      });
      this.eventManager.listen(this.adManager, shaka.ads.AdManager.AD_STARTED, function () {
        shaka.ui.Utils.setDisplay(c.overflowMenuButton_, !1);
      });
      this.eventManager.listen(this.adManager, shaka.ads.AdManager.AD_STOPPED, function () {
        shaka.ui.Utils.setDisplay(c.overflowMenuButton_, !0);
      });
      this.eventManager.listen(this.controls, 'submenuopen', function () {
        shaka.ui.Utils.setDisplay(c.overflowMenu_, !1);
      });
      this.eventManager.listen(this.overflowMenu_, 'touchstart', function (f) {
        c.controls.setLastTouchEventTime(Date.now());
        f.stopPropagation();
      });
      this.eventManager.listen(this.overflowMenuButton_, 'click', function () {
        c.onOverflowMenuButtonClick_();
      });
      this.updateAriaLabel_();
    };
    $jscomp.inherits(shaka.ui.OverflowMenu, shaka.ui.Element);
    shaka.ui.OverflowMenu.prototype.release = function () {
      this.controlsContainer_ = null;
      for (var a = $jscomp.makeIterator(this.children_), b = a.next(); !b.done; b = a.next()) b.value.release();
      this.children_ = [];
      shaka.ui.Element.prototype.release.call(this);
    };
    shaka.ui.OverflowMenu.registerElement = function (a, b) {
      shaka.ui.OverflowMenu.elementNamesToFactories_.set(a, b);
    };
    shaka.ui.OverflowMenu.prototype.addOverflowMenu_ = function () {
      this.overflowMenu_ = shaka.util.Dom.createHTMLElement('div');
      this.overflowMenu_.classList.add('shaka-overflow-menu');
      this.overflowMenu_.classList.add('shaka-no-propagation');
      this.overflowMenu_.classList.add('shaka-show-controls-on-mouse-over');
      this.overflowMenu_.classList.add('shaka-hidden');
      this.controlsContainer_.appendChild(this.overflowMenu_);
    };
    shaka.ui.OverflowMenu.prototype.addOverflowMenuButton_ = function () {
      this.overflowMenuButton_ = shaka.util.Dom.createButton();
      this.overflowMenuButton_.classList.add('shaka-overflow-menu-button');
      this.overflowMenuButton_.classList.add('shaka-no-propagation');
      this.overflowMenuButton_.classList.add('material-icons-round');
      this.overflowMenuButton_.textContent = shaka.ui.Enums.MaterialDesignIcons.OPEN_OVERFLOW;
      this.parent.appendChild(this.overflowMenuButton_);
    };
    shaka.ui.OverflowMenu.prototype.createChildren_ = function () {
      for (var a = $jscomp.makeIterator(this.config_.overflowMenuButtons), b = a.next(); !b.done; b = a.next())
        (b = b.value),
          shaka.ui.OverflowMenu.elementNamesToFactories_.get(b)
            ? ((b = shaka.ui.OverflowMenu.elementNamesToFactories_.get(b)),
              goog.asserts.assert(this.controls, 'Controls should not be null!'),
              this.children_.push(b.create(this.overflowMenu_, this.controls)))
            : shaka.log.alwaysWarn('Unrecognized overflow menu element requested:', b);
    };
    shaka.ui.OverflowMenu.prototype.onOverflowMenuButtonClick_ = function () {
      if (this.controls.anySettingsMenusAreOpen()) this.controls.hideSettingsMenus();
      else {
        shaka.ui.Utils.setDisplay(this.overflowMenu_, !0);
        this.controls.computeOpacity();
        var a = function (c) {
            return 0 == c.classList.contains('shaka-hidden');
          },
          b = shaka.util.Iterables;
        b.some(this.overflowMenu_.childNodes, a) && b.filter(this.overflowMenu_.childNodes, a)[0].focus();
      }
    };
    shaka.ui.OverflowMenu.prototype.updateAriaLabel_ = function () {
      this.overflowMenuButton_.setAttribute(
        shaka.ui.Constants.ARIA_LABEL,
        this.localization.resolve(shaka.ui.Locales.Ids.MORE_SETTINGS),
      );
    };
    goog.exportSymbol('shaka.ui.OverflowMenu', shaka.ui.OverflowMenu);
    goog.exportProperty(shaka.ui.OverflowMenu, 'registerElement', shaka.ui.OverflowMenu.registerElement);
    shaka.ui.OverflowMenu.Factory = function () {};
    shaka.ui.OverflowMenu.Factory.prototype.create = function (a, b) {
      return new shaka.ui.OverflowMenu(a, b);
    };
    shaka.ui.Controls.registerElement('overflow_menu', new shaka.ui.OverflowMenu.Factory());
    shaka.ui.OverflowMenu.elementNamesToFactories_ = new Map();
    shaka.ui.SettingsMenu = function (a, b, c) {
      shaka.ui.Element.call(this, a, b);
      var d = this;
      this.addButton_(c);
      this.addMenu_();
      this.eventManager.listen(this.button, 'click', function () {
        d.onButtonClick_();
      });
    };
    $jscomp.inherits(shaka.ui.SettingsMenu, shaka.ui.Element);
    shaka.ui.SettingsMenu.prototype.addButton_ = function (a) {
      this.button = shaka.util.Dom.createButton();
      this.icon = shaka.util.Dom.createHTMLElement('i');
      this.icon.classList.add('material-icons-round');
      this.icon.textContent = a;
      this.button.appendChild(this.icon);
      a = shaka.util.Dom.createHTMLElement('label');
      a.classList.add('shaka-overflow-button-label');
      this.nameSpan = shaka.util.Dom.createHTMLElement('span');
      a.appendChild(this.nameSpan);
      this.currentSelection = shaka.util.Dom.createHTMLElement('span');
      this.currentSelection.classList.add('shaka-current-selection-span');
      a.appendChild(this.currentSelection);
      this.button.appendChild(a);
      this.parent.appendChild(this.button);
    };
    shaka.ui.SettingsMenu.prototype.addMenu_ = function () {
      this.menu = shaka.util.Dom.createHTMLElement('div');
      this.menu.classList.add('shaka-no-propagation');
      this.menu.classList.add('shaka-show-controls-on-mouse-over');
      this.menu.classList.add('shaka-settings-menu');
      this.menu.classList.add('shaka-hidden');
      this.backButton = shaka.util.Dom.createButton();
      this.backButton.classList.add('shaka-back-to-overflow-button');
      this.menu.appendChild(this.backButton);
      var a = shaka.util.Dom.createHTMLElement('i');
      a.classList.add('material-icons-round');
      a.textContent = shaka.ui.Enums.MaterialDesignIcons.BACK;
      this.backButton.appendChild(a);
      this.backSpan = shaka.util.Dom.createHTMLElement('span');
      this.backButton.appendChild(this.backSpan);
      this.controls.getControlsContainer().appendChild(this.menu);
    };
    shaka.ui.SettingsMenu.prototype.onButtonClick_ = function () {
      this.controls.dispatchEvent(new shaka.util.FakeEvent('submenuopen'));
      shaka.ui.Utils.setDisplay(this.menu, !0);
      shaka.ui.Utils.focusOnTheChosenItem(this.menu);
    };
    goog.exportSymbol('shaka.ui.SettingsMenu', shaka.ui.SettingsMenu);
    shaka.ui.AudioLanguageSelection = function (a, b) {
      shaka.ui.SettingsMenu.call(this, a, b, shaka.ui.Enums.MaterialDesignIcons.LANGUAGE);
      var c = this;
      this.button.classList.add('shaka-language-button');
      this.menu.classList.add('shaka-audio-languages');
      this.eventManager.listen(this.localization, shaka.ui.Localization.LOCALE_UPDATED, function () {
        c.updateLocalizedStrings_();
      });
      this.eventManager.listen(this.localization, shaka.ui.Localization.LOCALE_CHANGED, function () {
        c.updateLocalizedStrings_();
      });
      this.eventManager.listen(this.player, 'trackschanged', function () {
        c.onTracksChanged_();
      });
      this.eventManager.listen(this.player, 'variantchanged', function () {
        c.updateAudioLanguages_();
      });
      this.updateLocalizedStrings_();
      this.updateAudioLanguages_();
    };
    $jscomp.inherits(shaka.ui.AudioLanguageSelection, shaka.ui.SettingsMenu);
    shaka.ui.AudioLanguageSelection.prototype.updateAudioLanguages_ = function () {
      var a = this,
        b = this.player.getVariantTracks();
      shaka.ui.LanguageUtils.updateTracks(
        b,
        this.menu,
        function (c) {
          return a.onAudioTrackSelected_(c);
        },
        !0,
        this.currentSelection,
        this.localization,
        this.controls.getConfig().trackLabelFormat,
      );
      shaka.ui.Utils.focusOnTheChosenItem(this.menu);
      this.controls.dispatchEvent(new shaka.util.FakeEvent('languageselectionupdated'));
    };
    shaka.ui.AudioLanguageSelection.prototype.onTracksChanged_ = function () {
      var a = 0 < this.player.getVariantTracks().length;
      shaka.ui.Utils.setDisplay(this.button, a);
      this.updateAudioLanguages_();
    };
    shaka.ui.AudioLanguageSelection.prototype.onAudioTrackSelected_ = function (a) {
      this.player.selectAudioLanguage(a.language, a.roles[0]);
    };
    shaka.ui.AudioLanguageSelection.prototype.updateLocalizedStrings_ = function () {
      var a = shaka.ui.Locales.Ids;
      this.backButton.setAttribute(shaka.ui.Constants.ARIA_LABEL, this.localization.resolve(a.BACK));
      this.button.setAttribute(shaka.ui.Constants.ARIA_LABEL, this.localization.resolve(a.LANGUAGE));
      this.nameSpan.textContent = this.localization.resolve(a.LANGUAGE);
      this.backSpan.textContent = this.localization.resolve(a.LANGUAGE);
    };
    goog.exportSymbol('shaka.ui.AudioLanguageSelection', shaka.ui.AudioLanguageSelection);
    shaka.ui.AudioLanguageSelection.Factory = function () {};
    shaka.ui.AudioLanguageSelection.Factory.prototype.create = function (a, b) {
      return new shaka.ui.AudioLanguageSelection(a, b);
    };
    shaka.ui.OverflowMenu.registerElement('language', new shaka.ui.AudioLanguageSelection.Factory());
    shaka.ui.CastButton = function (a, b) {
      shaka.ui.Element.call(this, a, b);
      var c = this;
      this.castProxy_ = this.controls.getCastProxy();
      this.castButton_ = shaka.util.Dom.createButton();
      this.castButton_.classList.add('shaka-cast-button');
      this.castButton_.setAttribute('aria-pressed', 'false');
      this.castIcon_ = shaka.util.Dom.createHTMLElement('i');
      this.castIcon_.classList.add('material-icons-round');
      this.castIcon_.textContent = shaka.ui.Enums.MaterialDesignIcons.CAST;
      this.castButton_.appendChild(this.castIcon_);
      var d = shaka.util.Dom.createHTMLElement('label');
      d.classList.add('shaka-overflow-button-label');
      this.castNameSpan_ = shaka.util.Dom.createHTMLElement('span');
      d.appendChild(this.castNameSpan_);
      this.castCurrentSelectionSpan_ = shaka.util.Dom.createHTMLElement('span');
      this.castCurrentSelectionSpan_.classList.add('shaka-current-selection-span');
      d.appendChild(this.castCurrentSelectionSpan_);
      this.castButton_.appendChild(d);
      this.parent.appendChild(this.castButton_);
      this.updateLocalizedStrings_();
      this.onCastStatusChange_();
      this.eventManager.listen(this.localization, shaka.ui.Localization.LOCALE_UPDATED, function () {
        c.updateLocalizedStrings_();
      });
      this.eventManager.listen(this.localization, shaka.ui.Localization.LOCALE_CHANGED, function () {
        c.updateLocalizedStrings_();
      });
      this.eventManager.listen(this.castButton_, 'click', function () {
        c.onCastClick_();
      });
      this.eventManager.listen(this.controls, 'caststatuschanged', function () {
        c.onCastStatusChange_();
      });
    };
    $jscomp.inherits(shaka.ui.CastButton, shaka.ui.Element);
    shaka.ui.CastButton.prototype.onCastClick_ = function () {
      var a = this,
        b;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (c) {
        if (1 == c.nextAddress) {
          if (a.castProxy_.isCasting()) return a.castProxy_.suggestDisconnect(), c.jumpTo(0);
          c.setCatchFinallyBlocks(3);
          a.castButton_.disabled = !0;
          return c.yield(a.castProxy_.cast(), 5);
        }
        if (3 != c.nextAddress) return (a.castButton_.disabled = !1), c.leaveTryBlock(0);
        b = c.enterCatchBlock();
        a.castButton_.disabled = !1;
        b.code != shaka.util.Error.Code.CAST_CANCELED_BY_USER &&
          a.controls.dispatchEvent(new shaka.util.FakeEvent('error', { detail: b }));
        c.jumpToEnd();
      });
    };
    shaka.ui.CastButton.prototype.onCastStatusChange_ = function () {
      var a = this.castProxy_.canCast() && this.controls.isCastAllowed(),
        b = this.castProxy_.isCasting(),
        c = shaka.ui.Enums.MaterialDesignIcons;
      shaka.ui.Utils.setDisplay(this.castButton_, a);
      this.castIcon_.textContent = b ? c.EXIT_CAST : c.CAST;
      a &&
        (b
          ? this.castButton_.setAttribute('aria-pressed', 'true')
          : this.castButton_.setAttribute('aria-pressed', 'false'));
      this.setCurrentCastSelection_();
    };
    shaka.ui.CastButton.prototype.setCurrentCastSelection_ = function () {
      this.castProxy_.isCasting()
        ? (this.castCurrentSelectionSpan_.textContent = this.castProxy_.receiverName())
        : (this.castCurrentSelectionSpan_.textContent = this.localization.resolve(shaka.ui.Locales.Ids.OFF));
    };
    shaka.ui.CastButton.prototype.updateLocalizedStrings_ = function () {
      var a = shaka.ui.Locales.Ids;
      this.castButton_.setAttribute(shaka.ui.Constants.ARIA_LABEL, this.localization.resolve(a.CAST));
      this.castNameSpan_.textContent = this.localization.resolve(a.CAST);
      this.setCurrentCastSelection_();
    };
    goog.exportSymbol('shaka.ui.CastButton', shaka.ui.CastButton);
    shaka.ui.CastButton.Factory = function () {};
    shaka.ui.CastButton.Factory.prototype.create = function (a, b) {
      return new shaka.ui.CastButton(a, b);
    };
    shaka.ui.OverflowMenu.registerElement('cast', new shaka.ui.CastButton.Factory());
    shaka.ui.FastForwardButton = function (a, b) {
      shaka.ui.Element.call(this, a, b);
      var c = this;
      this.button_ = shaka.util.Dom.createButton();
      this.button_.classList.add('material-icons-round');
      this.button_.classList.add('shaka-fast-forward-button');
      this.button_.textContent = shaka.ui.Enums.MaterialDesignIcons.FAST_FORWARD;
      this.parent.appendChild(this.button_);
      this.updateAriaLabel_();
      this.eventManager.listen(this.localization, shaka.ui.Localization.LOCALE_UPDATED, function () {
        c.updateAriaLabel_();
      });
      this.eventManager.listen(this.localization, shaka.ui.Localization.LOCALE_CHANGED, function () {
        c.updateAriaLabel_();
      });
      this.eventManager.listen(this.button_, 'click', function () {
        c.fastForward_();
      });
    };
    $jscomp.inherits(shaka.ui.FastForwardButton, shaka.ui.Element);
    shaka.ui.FastForwardButton.prototype.updateAriaLabel_ = function () {
      this.button_.setAttribute(
        shaka.ui.Constants.ARIA_LABEL,
        this.localization.resolve(shaka.ui.Locales.Ids.FAST_FORWARD),
      );
    };
    shaka.ui.FastForwardButton.prototype.fastForward_ = function () {
      if (this.video.duration) {
        var a = this.player.getPlaybackRate();
        this.player.trickPlay(0 > a || 4 < a ? 1 : 2 * a);
      }
    };
    goog.exportSymbol('shaka.ui.FastForwardButton', shaka.ui.FastForwardButton);
    shaka.ui.FastForwardButton.Factory = function () {};
    shaka.ui.FastForwardButton.Factory.prototype.create = function (a, b) {
      return new shaka.ui.FastForwardButton(a, b);
    };
    shaka.ui.Controls.registerElement('fast_forward', new shaka.ui.FastForwardButton.Factory());
    shaka.ui.FullscreenButton = function (a, b) {
      shaka.ui.Element.call(this, a, b);
      var c = this;
      this.button_ = shaka.util.Dom.createButton();
      this.button_.classList.add('shaka-fullscreen-button');
      this.button_.classList.add('material-icons-round');
      document.fullscreenEnabled || this.button_.classList.add('shaka-hidden');
      this.button_.textContent = shaka.ui.Enums.MaterialDesignIcons.FULLSCREEN;
      this.parent.appendChild(this.button_);
      this.updateAriaLabel_();
      this.eventManager.listen(this.localization, shaka.ui.Localization.LOCALE_UPDATED, function () {
        c.updateAriaLabel_();
      });
      this.eventManager.listen(this.localization, shaka.ui.Localization.LOCALE_CHANGED, function () {
        c.updateAriaLabel_();
      });
      this.eventManager.listen(this.button_, 'click', function () {
        return $jscomp.asyncExecutePromiseGeneratorProgram(function (d) {
          return d.yield(c.controls.toggleFullScreen(), 0);
        });
      });
      this.eventManager.listen(document, 'fullscreenchange', function () {
        c.updateIcon_();
        c.updateAriaLabel_();
      });
    };
    $jscomp.inherits(shaka.ui.FullscreenButton, shaka.ui.Element);
    shaka.ui.FullscreenButton.prototype.updateAriaLabel_ = function () {
      var a = shaka.ui.Locales.Ids;
      this.button_.setAttribute(
        shaka.ui.Constants.ARIA_LABEL,
        this.localization.resolve(document.fullscreenElement ? a.EXIT_FULL_SCREEN : a.FULL_SCREEN),
      );
    };
    shaka.ui.FullscreenButton.prototype.updateIcon_ = function () {
      this.button_.textContent = document.fullscreenElement
        ? shaka.ui.Enums.MaterialDesignIcons.EXIT_FULLSCREEN
        : shaka.ui.Enums.MaterialDesignIcons.FULLSCREEN;
    };
    goog.exportSymbol('shaka.ui.FullscreenButton', shaka.ui.FullscreenButton);
    shaka.ui.FullscreenButton.Factory = function () {};
    shaka.ui.FullscreenButton.Factory.prototype.create = function (a, b) {
      return new shaka.ui.FullscreenButton(a, b);
    };
    shaka.ui.Controls.registerElement('fullscreen', new shaka.ui.FullscreenButton.Factory());
    shaka.ui.LoopButton = function (a, b) {
      shaka.ui.Element.call(this, a, b);
      var c = this,
        d = shaka.ui.Locales.Ids;
      this.button_ = shaka.util.Dom.createButton();
      this.button_.classList.add('shaka-loop-button');
      this.icon_ = shaka.util.Dom.createHTMLElement('i');
      this.icon_.classList.add('material-icons-round');
      this.icon_.textContent = shaka.ui.Enums.MaterialDesignIcons.LOOP;
      this.button_.appendChild(this.icon_);
      var e = shaka.util.Dom.createHTMLElement('label');
      e.classList.add('shaka-overflow-button-label');
      this.nameSpan_ = shaka.util.Dom.createHTMLElement('span');
      this.nameSpan_.textContent = this.localization.resolve(d.LOOP);
      e.appendChild(this.nameSpan_);
      this.currentState_ = shaka.util.Dom.createHTMLElement('span');
      this.currentState_.classList.add('shaka-current-selection-span');
      e.appendChild(this.currentState_);
      this.button_.appendChild(e);
      this.updateLocalizedStrings_();
      this.parent.appendChild(this.button_);
      this.eventManager.listen(this.localization, shaka.ui.Localization.LOCALE_UPDATED, function () {
        c.updateLocalizedStrings_();
      });
      this.eventManager.listen(this.localization, shaka.ui.Localization.LOCALE_CHANGED, function () {
        c.updateLocalizedStrings_();
      });
      this.eventManager.listen(this.button_, 'click', function () {
        c.onClick_();
      });
      this.loopEnabled_ = this.video.loop;
      this.timer_ = new shaka.util.Timer(function () {
        c.onTimerTick_();
      });
      this.timer_.tickEvery(1);
    };
    $jscomp.inherits(shaka.ui.LoopButton, shaka.ui.Element);
    shaka.ui.LoopButton.prototype.release = function () {
      this.timer_.stop();
      this.timer_ = null;
      shaka.ui.Element.prototype.release.call(this);
    };
    shaka.ui.LoopButton.prototype.onClick_ = function () {
      this.video.loop = !this.video.loop;
      this.timer_.tickNow();
      this.timer_.tickEvery(1);
    };
    shaka.ui.LoopButton.prototype.onTimerTick_ = function () {
      this.loopEnabled_ != this.video.loop && (this.updateLocalizedStrings_(), (this.loopEnabled_ = this.video.loop));
    };
    shaka.ui.LoopButton.prototype.updateLocalizedStrings_ = function () {
      var a = shaka.ui.Locales.Ids;
      this.nameSpan_.textContent = this.localization.resolve(a.LOOP);
      this.currentState_.textContent = this.localization.resolve(this.video.loop ? a.ON : a.OFF);
      this.button_.setAttribute(
        shaka.ui.Constants.ARIA_LABEL,
        this.localization.resolve(this.video.loop ? a.EXIT_LOOP_MODE : a.ENTER_LOOP_MODE),
      );
    };
    goog.exportSymbol('shaka.ui.LoopButton', shaka.ui.LoopButton);
    shaka.ui.LoopButton.Factory = function () {};
    shaka.ui.LoopButton.Factory.prototype.create = function (a, b) {
      return new shaka.ui.LoopButton(a, b);
    };
    shaka.ui.OverflowMenu.registerElement('loop', new shaka.ui.LoopButton.Factory());
    shaka.ui.MuteButton = function (a, b) {
      shaka.ui.Element.call(this, a, b);
      var c = this;
      this.button_ = shaka.util.Dom.createButton();
      this.button_.classList.add('shaka-mute-button');
      this.button_.classList.add('material-icons-round');
      this.button_.textContent = shaka.ui.Enums.MaterialDesignIcons.MUTE;
      this.parent.appendChild(this.button_);
      this.updateAriaLabel_();
      this.eventManager.listen(this.localization, shaka.ui.Localization.LOCALE_UPDATED, function () {
        c.updateAriaLabel_();
      });
      this.eventManager.listen(this.localization, shaka.ui.Localization.LOCALE_CHANGED, function () {
        c.updateAriaLabel_();
      });
      this.eventManager.listen(this.button_, 'click', function () {
        c.ad ? c.ad.setMuted(!c.ad.isMuted()) : (c.video.muted = !c.video.muted);
      });
      this.eventManager.listen(this.video, 'volumechange', function () {
        c.updateAriaLabel_();
        c.updateIcon_();
      });
      this.eventManager.listen(this.adManager, shaka.ads.AdManager.AD_VOLUME_CHANGED, function () {
        c.updateAriaLabel_();
        c.updateIcon_();
      });
      this.eventManager.listen(this.adManager, shaka.ads.AdManager.AD_MUTED, function () {
        c.updateAriaLabel_();
        c.updateIcon_();
      });
      this.eventManager.listen(this.adManager, shaka.ads.AdManager.AD_STOPPED, function () {
        c.ad = null;
        c.updateAriaLabel_();
        c.updateIcon_();
      });
    };
    $jscomp.inherits(shaka.ui.MuteButton, shaka.ui.Element);
    shaka.ui.MuteButton.prototype.updateAriaLabel_ = function () {
      var a = shaka.ui.Locales.Ids;
      a = this.ad ? (this.ad.isMuted() ? a.UNMUTE : a.MUTE) : this.video.muted ? a.UNMUTE : a.MUTE;
      this.button_.setAttribute(shaka.ui.Constants.ARIA_LABEL, this.localization.resolve(a));
    };
    shaka.ui.MuteButton.prototype.updateIcon_ = function () {
      var a = shaka.ui.Enums.MaterialDesignIcons;
      a = this.ad ? (this.ad.isMuted() ? a.UNMUTE : a.MUTE) : this.video.muted ? a.UNMUTE : a.MUTE;
      this.button_.textContent = a;
    };
    goog.exportSymbol('shaka.ui.MuteButton', shaka.ui.MuteButton);
    shaka.ui.MuteButton.Factory = function () {};
    shaka.ui.MuteButton.Factory.prototype.create = function (a, b) {
      return new shaka.ui.MuteButton(a, b);
    };
    shaka.ui.Controls.registerElement('mute', new shaka.ui.MuteButton.Factory());
    shaka.ui.PipButton = function (a, b) {
      shaka.ui.Element.call(this, a, b);
      var c = this;
      this.localVideo_ = this.controls.getLocalVideo();
      var d = shaka.ui.Locales.Ids;
      this.pipButton_ = shaka.util.Dom.createButton();
      this.pipButton_.classList.add('shaka-pip-button');
      this.pipIcon_ = shaka.util.Dom.createHTMLElement('i');
      this.pipIcon_.classList.add('material-icons-round');
      this.pipIcon_.textContent = shaka.ui.Enums.MaterialDesignIcons.PIP;
      this.pipButton_.appendChild(this.pipIcon_);
      var e = shaka.util.Dom.createHTMLElement('label');
      e.classList.add('shaka-overflow-button-label');
      this.pipNameSpan_ = shaka.util.Dom.createHTMLElement('span');
      this.pipNameSpan_.textContent = this.localization.resolve(d.PICTURE_IN_PICTURE);
      e.appendChild(this.pipNameSpan_);
      this.currentPipState_ = shaka.util.Dom.createHTMLElement('span');
      this.currentPipState_.classList.add('shaka-current-selection-span');
      e.appendChild(this.currentPipState_);
      this.pipButton_.appendChild(e);
      this.updateLocalizedStrings_();
      this.parent.appendChild(this.pipButton_);
      this.isPipAllowed_() || shaka.ui.Utils.setDisplay(this.pipButton_, !1);
      this.eventManager.listen(this.localization, shaka.ui.Localization.LOCALE_UPDATED, function () {
        c.updateLocalizedStrings_();
      });
      this.eventManager.listen(this.localization, shaka.ui.Localization.LOCALE_CHANGED, function () {
        c.updateLocalizedStrings_();
      });
      this.eventManager.listen(this.pipButton_, 'click', function () {
        c.onPipClick_();
      });
      this.eventManager.listen(this.localVideo_, 'enterpictureinpicture', function () {
        c.onEnterPictureInPicture_();
      });
      this.eventManager.listen(this.localVideo_, 'leavepictureinpicture', function () {
        c.onLeavePictureInPicture_();
      });
      this.eventManager.listen(this.controls, 'caststatuschanged', function (f) {
        c.onCastStatusChange_(f);
      });
      this.eventManager.listen(this.player, 'trackschanged', function () {
        c.onTracksChanged_();
      });
    };
    $jscomp.inherits(shaka.ui.PipButton, shaka.ui.Element);
    shaka.ui.PipButton.prototype.isPipAllowed_ = function () {
      return (
        document.pictureInPictureEnabled &&
        !this.video.disablePictureInPicture &&
        !this.controls.getCastProxy().isCasting() // TODO only show PiP when not casting
      );
    };
    shaka.ui.PipButton.prototype.onPipClick_ = function () {
      var a = this,
        b;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (c) {
        if (1 == c.nextAddress)
          return (
            c.setCatchFinallyBlocks(2),
            document.pictureInPictureElement
              ? c.yield(document.exitPictureInPicture(), 5)
              : (document.fullscreenElement && document.exitFullscreen(), c.yield(a.video.requestPictureInPicture(), 5))
          );
        if (2 != c.nextAddress) return c.leaveTryBlock(0);
        b = c.enterCatchBlock();
        a.controls.dispatchEvent(new shaka.util.FakeEvent('error', { detail: b }));
        c.jumpToEnd();
      });
    };
    shaka.ui.PipButton.prototype.onEnterPictureInPicture_ = function () {
      var a = shaka.ui.Locales.Ids;
      this.pipIcon_.textContent = shaka.ui.Enums.MaterialDesignIcons.EXIT_PIP;
      this.pipButton_.setAttribute(shaka.ui.Constants.ARIA_LABEL, this.localization.resolve(a.EXIT_PICTURE_IN_PICTURE));
      this.currentPipState_.textContent = this.localization.resolve(a.ON);
    };
    shaka.ui.PipButton.prototype.onLeavePictureInPicture_ = function () {
      var a = shaka.ui.Locales.Ids;
      this.pipIcon_.textContent = shaka.ui.Enums.MaterialDesignIcons.PIP;
      this.pipButton_.setAttribute(
        shaka.ui.Constants.ARIA_LABEL,
        this.localization.resolve(a.ENTER_PICTURE_IN_PICTURE),
      );
      this.currentPipState_.textContent = this.localization.resolve(a.OFF);
    };
    shaka.ui.PipButton.prototype.updateLocalizedStrings_ = function () {
      var a = shaka.ui.Locales.Ids;
      this.pipNameSpan_.textContent = this.localization.resolve(a.PICTURE_IN_PICTURE);
      this.pipButton_.setAttribute(
        shaka.ui.Constants.ARIA_LABEL,
        this.localization.resolve(
          document.pictureInPictureElement ? a.EXIT_PICTURE_IN_PICTURE : a.ENTER_PICTURE_IN_PICTURE,
        ),
      );
      this.currentPipState_.textContent = this.localization.resolve(document.pictureInPictureElement ? a.ON : a.OFF);
    };
    shaka.ui.PipButton.prototype.onCastStatusChange_ = function (a) {
      a.newStatus
        ? this.isPipAllowed_() && shaka.ui.Utils.setDisplay(this.pipButton_, !1)
        : this.isPipAllowed_() && shaka.ui.Utils.setDisplay(this.pipButton_, !0);
    };
    shaka.ui.PipButton.prototype.onTracksChanged_ = function () {
      var a = this;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (b) {
        if (!a.isPipAllowed_()) return shaka.ui.Utils.setDisplay(a.pipButton_, !1), b.jumpTo(0);
        if (!a.player || !a.player.isAudioOnly()) return shaka.ui.Utils.setDisplay(a.pipButton_, !0), b.jumpTo(0);
        shaka.ui.Utils.setDisplay(a.pipButton_, !1);
        return document.pictureInPictureElement ? b.yield(document.exitPictureInPicture(), 0) : b.jumpTo(0);
      });
    };
    goog.exportSymbol('shaka.ui.PipButton', shaka.ui.PipButton);
    shaka.ui.PipButton.Factory = function () {};
    shaka.ui.PipButton.Factory.prototype.create = function (a, b) {
      return new shaka.ui.PipButton(a, b);
    };
    shaka.ui.OverflowMenu.registerElement('picture_in_picture', new shaka.ui.PipButton.Factory());
    shaka.ui.PlaybackRateSelection = function (a, b) {
      shaka.ui.SettingsMenu.call(this, a, b, shaka.ui.Enums.MaterialDesignIcons.PLAYBACK_RATE);
      var c = this;
      this.button.classList.add('shaka-playbackrate-button');
      this.menu.classList.add('shaka-playback-rates');
      this.eventManager.listen(this.localization, shaka.ui.Localization.LOCALE_UPDATED, function () {
        c.updateLocalizedStrings_();
      });
      this.eventManager.listen(this.localization, shaka.ui.Localization.LOCALE_CHANGED, function () {
        c.updateLocalizedStrings_();
      });
      this.eventManager.listen(this.player, 'ratechange', function () {
        c.updatePlaybackRateSelection_(c.player.getPlaybackRate());
      });
      this.playbackRates_ = new Map([
        ['0.5x', 0.5],
        ['0.75x', 0.75],
        ['1x', 1],
        ['1.25x', 1.25],
        ['1.5x', 1.5],
        ['1.75x', 1.75],
        ['2x', 2],
      ]);
      this.updateLocalizedStrings_();
      this.addPlaybackRates_();
      this.updatePlaybackRateSelection_(this.player.getPlaybackRate());
    };
    $jscomp.inherits(shaka.ui.PlaybackRateSelection, shaka.ui.SettingsMenu);
    shaka.ui.PlaybackRateSelection.prototype.updateLocalizedStrings_ = function () {
      var a = shaka.ui.Locales.Ids;
      this.backButton.setAttribute(shaka.ui.Constants.ARIA_LABEL, this.localization.resolve(a.BACK));
      this.button.setAttribute(shaka.ui.Constants.ARIA_LABEL, this.localization.resolve(a.PLAYBACK_RATE));
      this.nameSpan.textContent = this.localization.resolve(a.PLAYBACK_RATE);
      this.backSpan.textContent = this.localization.resolve(a.PLAYBACK_RATE);
    };
    shaka.ui.PlaybackRateSelection.prototype.updatePlaybackRateSelection_ = function (a) {
      var b = this,
        c = shaka.ui.Utils.getDescendantIfExists(this.menu, 'material-icons-round shaka-chosen-item');
      if (c) {
        var d = c.parentElement;
        d.removeAttribute('aria-selected');
        d.getElementsByTagName('span')[0].classList.remove('shaka-chosen-item');
        d.removeChild(c);
      }
      if (
        (c = Array.from(this.menu.querySelectorAll('span')).find(function (e) {
          return b.playbackRates_.get(e.textContent) == a;
        }))
      )
        (d = c.parentElement),
          d.appendChild(shaka.ui.Utils.checkmarkIcon()),
          d.setAttribute('aria-selected', 'true'),
          c.classList.add('shaka-chosen-item');
      this.currentSelection.textContent = a + 'x';
    };
    shaka.ui.PlaybackRateSelection.prototype.addPlaybackRates_ = function () {
      for (
        var a = this, b = {}, c = $jscomp.makeIterator(this.playbackRates_.keys()), d = c.next();
        !d.done;
        b = { $jscomp$loop$prop$rateStr$559: b.$jscomp$loop$prop$rateStr$559 }, d = c.next()
      ) {
        b.$jscomp$loop$prop$rateStr$559 = d.value;
        d = shaka.util.Dom.createButton();
        var e = shaka.util.Dom.createHTMLElement('span');
        e.textContent = b.$jscomp$loop$prop$rateStr$559;
        d.appendChild(e);
        this.eventManager.listen(
          d,
          'click',
          (function (f) {
            return function () {
              a.video.playbackRate = a.playbackRates_.get(f.$jscomp$loop$prop$rateStr$559);
            };
          })(b),
        );
        this.menu.appendChild(d);
      }
      shaka.ui.Utils.focusOnTheChosenItem(this.menu);
    };
    goog.exportSymbol('shaka.ui.PlaybackRateSelection', shaka.ui.PlaybackRateSelection);
    shaka.ui.PlaybackRateSelection.Factory = function () {};
    shaka.ui.PlaybackRateSelection.Factory.prototype.create = function (a, b) {
      return new shaka.ui.PlaybackRateSelection(a, b);
    };
    shaka.ui.OverflowMenu.registerElement('playback_rate', new shaka.ui.PlaybackRateSelection.Factory());
    shaka.ui.PresentationTimeTracker = function (a, b) {
      shaka.ui.Element.call(this, a, b);
      var c = this;
      this.currentTime_ = shaka.util.Dom.createButton();
      this.currentTime_.classList.add('shaka-current-time');
      this.setValue_('0:00');
      this.parent.appendChild(this.currentTime_);
      this.eventManager.listen(this.currentTime_, 'click', function () {
        c.player.isLive() && (c.video.currentTime = c.player.seekRange().end);
      });
      this.eventManager.listen(this.controls, 'timeandseekrangeupdated', function () {
        c.updateTime_();
      });
      this.eventManager.listen(this.player, 'trackschanged', function () {
        c.onTracksChanged_();
      });
    };
    $jscomp.inherits(shaka.ui.PresentationTimeTracker, shaka.ui.Element);
    shaka.ui.PresentationTimeTracker.prototype.setValue_ = function (a) {
      a != this.currentTime_.textContent && (this.currentTime_.textContent = a);
    };
    shaka.ui.PresentationTimeTracker.prototype.updateTime_ = function () {
      var a = this.controls.isSeeking(),
        b = this.controls.getDisplayTime(),
        c = this.video.duration,
        d = this.player.seekRange(),
        e = d.end - d.start,
        f = shaka.ui.Utils;
      this.player.isLive()
        ? ((b = Math.max(0, Math.floor(d.end - b))),
          (c = 3600 <= e),
          1 <= b || a
            ? (this.setValue_('- ' + f.buildTimeString(b, c)), (this.currentTime_.disabled = !1))
            : (this.setValue_(this.localization.resolve(shaka.ui.Locales.Ids.LIVE)), (this.currentTime_.disabled = !0)))
        : ((a = 3600 <= c),
          (b = f.buildTimeString(b, a)),
          c && (b += ' / ' + f.buildTimeString(c, a)),
          this.setValue_(b),
          (this.currentTime_.disabled = !0));
    };
    shaka.ui.PresentationTimeTracker.prototype.onTracksChanged_ = function () {
      this.player.isLive() &&
        this.currentTime_.setAttribute(
          shaka.ui.Constants.ARIA_LABEL,
          this.localization.resolve(shaka.ui.Locales.Ids.SKIP_TO_LIVE),
        );
    };
    goog.exportSymbol('shaka.ui.PresentationTimeTracker', shaka.ui.PresentationTimeTracker);
    shaka.ui.PresentationTimeTracker.Factory = function () {};
    shaka.ui.PresentationTimeTracker.Factory.prototype.create = function (a, b) {
      return new shaka.ui.PresentationTimeTracker(a, b);
    };
    shaka.ui.Controls.registerElement('time_and_duration', new shaka.ui.PresentationTimeTracker.Factory());
    shaka.ui.ResolutionSelection = function (a, b) {
      shaka.ui.SettingsMenu.call(this, a, b, shaka.ui.Enums.MaterialDesignIcons.RESOLUTION);
      var c = this;
      this.button.classList.add('shaka-resolution-button');
      this.menu.classList.add('shaka-resolutions');
      this.eventManager.listen(this.localization, shaka.ui.Localization.LOCALE_UPDATED, function () {
        c.updateLocalizedStrings_();
      });
      this.eventManager.listen(this.localization, shaka.ui.Localization.LOCALE_CHANGED, function () {
        c.updateLocalizedStrings_();
      });
      this.eventManager.listen(this.player, 'variantchanged', function () {
        c.updateResolutionSelection_();
      });
      this.eventManager.listen(this.player, 'trackschanged', function () {
        c.updateResolutionSelection_();
      });
      this.eventManager.listen(this.player, 'abrstatuschanged', function () {
        c.updateResolutionSelection_();
      });
      this.updateResolutionSelection_();
      this.updateLocalizedStrings_();
    };
    $jscomp.inherits(shaka.ui.ResolutionSelection, shaka.ui.SettingsMenu);
    shaka.ui.ResolutionSelection.prototype.updateResolutionSelection_ = function () {
      var a = this,
        b = this.player.getVariantTracks();
      if (b.length && !b[0].height)
        shaka.ui.Utils.setDisplay(this.menu, !1), shaka.ui.Utils.setDisplay(this.button, !1);
      else {
        shaka.ui.Utils.setDisplay(this.button, !0);
        b.sort(function (k, l) {
          goog.asserts.assert(null != k.height, 'Null height');
          goog.asserts.assert(null != l.height, 'Null height');
          return l.height - k.height;
        });
        var c = b.find(function (k) {
          return k.active;
        });
        c &&
          (b = b.filter(function (k) {
            return k.language == c.language && k.channelsCount == c.channelsCount;
          }));
        b = b.filter(function (k, l) {
          return (
            b.findIndex(function (m) {
              return m.height == k.height;
            }) == l
          );
        });
        var d = shaka.ui.Utils.getFirstDescendantWithClassName(this.menu, 'shaka-back-to-overflow-button');
        shaka.util.Dom.removeAllChildren(this.menu);
        this.menu.appendChild(d);
        d = this.player.getConfiguration().abr.enabled;
        for (
          var e = {}, f = $jscomp.makeIterator(b), g = f.next();
          !g.done;
          e = { $jscomp$loop$prop$track$561: e.$jscomp$loop$prop$track$561 }, g = f.next()
        ) {
          e.$jscomp$loop$prop$track$561 = g.value;
          g = shaka.util.Dom.createButton();
          g.classList.add('explicit-resolution');
          this.eventManager.listen(
            g,
            'click',
            (function (k) {
              return function () {
                return a.onTrackSelected_(k.$jscomp$loop$prop$track$561);
              };
            })(e),
          );
          var h = shaka.util.Dom.createHTMLElement('span');
          h.textContent = e.$jscomp$loop$prop$track$561.height + 'p';
          g.appendChild(h);
          d ||
            e.$jscomp$loop$prop$track$561 != c ||
            (g.setAttribute('aria-selected', 'true'),
            g.appendChild(shaka.ui.Utils.checkmarkIcon()),
            h.classList.add('shaka-chosen-item'),
            (this.currentSelection.textContent = h.textContent));
          this.menu.appendChild(g);
        }
        e = shaka.util.Dom.createButton();
        e.classList.add('shaka-enable-abr-button');
        this.eventManager.listen(e, 'click', function () {
          a.player.configure({ abr: { enabled: !0 } });
          a.updateResolutionSelection_();
        });
        this.abrOnSpan_ = shaka.util.Dom.createHTMLElement('span');
        this.abrOnSpan_.classList.add('shaka-auto-span');
        this.abrOnSpan_.textContent = this.localization.resolve(shaka.ui.Locales.Ids.AUTO_QUALITY);
        e.appendChild(this.abrOnSpan_);
        d &&
          (e.setAttribute('aria-selected', 'true'),
          e.appendChild(shaka.ui.Utils.checkmarkIcon()),
          this.abrOnSpan_.classList.add('shaka-chosen-item'),
          (this.currentSelection.textContent = this.localization.resolve(shaka.ui.Locales.Ids.AUTO_QUALITY)));
        this.menu.appendChild(e);
        shaka.ui.Utils.focusOnTheChosenItem(this.menu);
        this.controls.dispatchEvent(new shaka.util.FakeEvent('resolutionselectionupdated'));
      }
    };
    shaka.ui.ResolutionSelection.prototype.onTrackSelected_ = function (a) {
      this.player.configure({ abr: { enabled: !1 } });
      var b = this.controls.getConfig().clearBufferOnQualityChange;
      this.player.selectVariantTrack(a, b);
    };
    shaka.ui.ResolutionSelection.prototype.updateLocalizedStrings_ = function () {
      var a = shaka.ui.Locales.Ids;
      this.button.setAttribute(shaka.ui.Constants.ARIA_LABEL, this.localization.resolve(a.RESOLUTION));
      this.backButton.setAttribute(shaka.ui.Constants.ARIA_LABEL, this.localization.resolve(a.RESOLUTION));
      this.backSpan.textContent = this.localization.resolve(a.RESOLUTION);
      this.nameSpan.textContent = this.localization.resolve(a.RESOLUTION);
      this.abrOnSpan_.textContent = this.localization.resolve(a.AUTO_QUALITY);
      this.player.getConfiguration().abr.enabled &&
        (this.currentSelection.textContent = this.localization.resolve(shaka.ui.Locales.Ids.AUTO_QUALITY));
    };
    goog.exportSymbol('shaka.ui.ResolutionSelection', shaka.ui.ResolutionSelection);
    shaka.ui.ResolutionSelection.Factory = function () {};
    shaka.ui.ResolutionSelection.Factory.prototype.create = function (a, b) {
      return new shaka.ui.ResolutionSelection(a, b);
    };
    shaka.ui.OverflowMenu.registerElement('quality', new shaka.ui.ResolutionSelection.Factory());
    shaka.ui.RewindButton = function (a, b) {
      shaka.ui.Element.call(this, a, b);
      var c = this;
      this.button_ = shaka.util.Dom.createButton();
      this.button_.classList.add('material-icons-round');
      this.button_.classList.add('shaka-rewind-button');
      this.button_.textContent = shaka.ui.Enums.MaterialDesignIcons.REWIND;
      this.parent.appendChild(this.button_);
      this.updateAriaLabel_();
      this.eventManager.listen(this.localization, shaka.ui.Localization.LOCALE_UPDATED, function () {
        c.updateAriaLabel_();
      });
      this.eventManager.listen(this.localization, shaka.ui.Localization.LOCALE_CHANGED, function () {
        c.updateAriaLabel_();
      });
      this.eventManager.listen(this.button_, 'click', function () {
        c.rewind_();
      });
    };
    $jscomp.inherits(shaka.ui.RewindButton, shaka.ui.Element);
    shaka.ui.RewindButton.prototype.updateAriaLabel_ = function () {
      this.button_.setAttribute(shaka.ui.Constants.ARIA_LABEL, this.localization.resolve(shaka.ui.Locales.Ids.REWIND));
    };
    shaka.ui.RewindButton.prototype.rewind_ = function () {
      if (this.video.duration) {
        var a = this.player.getPlaybackRate();
        this.player.trickPlay(0 < a || -4 > a ? -1 : 2 * a);
      }
    };
    goog.exportSymbol('shaka.ui.RewindButton', shaka.ui.RewindButton);
    shaka.ui.RewindButton.Factory = function () {};
    shaka.ui.RewindButton.Factory.prototype.create = function (a, b) {
      return new shaka.ui.RewindButton(a, b);
    };
    shaka.ui.Controls.registerElement('rewind', new shaka.ui.RewindButton.Factory());
    shaka.ui.SkipAdButton = function (a, b) {
      shaka.ui.Element.call(this, a, b);
      var c = this;
      this.container_ = shaka.util.Dom.createHTMLElement('div');
      this.container_.classList.add('shaka-skip-ad-container');
      this.parent.appendChild(this.container_);
      this.counter_ = shaka.util.Dom.createHTMLElement('div');
      this.counter_.classList.add('shaka-skip-ad-counter');
      shaka.ui.Utils.setDisplay(this.counter_, !1);
      this.container_.appendChild(this.counter_);
      this.button_ = shaka.util.Dom.createButton();
      this.button_.classList.add('shaka-skip-ad-button');
      this.button_.disabled = !0;
      shaka.ui.Utils.setDisplay(this.button_, !1);
      this.button_.classList.add('shaka-no-propagation');
      this.container_.appendChild(this.button_);
      this.updateAriaLabel_();
      this.updateLocalizedStrings_();
      this.timer_ = new shaka.util.Timer(function () {
        c.onTimerTick_();
      });
      this.eventManager.listen(this.localization, shaka.ui.Localization.LOCALE_UPDATED, function () {
        c.updateAriaLabel_();
        c.updateLocalizedStrings_();
      });
      this.eventManager.listen(this.localization, shaka.ui.Localization.LOCALE_CHANGED, function () {
        c.updateAriaLabel_();
        c.updateLocalizedStrings_();
      });
      this.eventManager.listen(this.adManager, shaka.ads.AdManager.AD_STARTED, function () {
        c.onAdStarted_();
      });
      this.eventManager.listen(this.adManager, shaka.ads.AdManager.AD_SKIP_STATE_CHANGED, function () {
        c.onSkipStateChanged_();
      });
      this.eventManager.listen(this.adManager, shaka.ads.AdManager.AD_STOPPED, function () {
        c.reset_();
      });
      this.eventManager.listen(this.button_, 'click', function () {
        c.ad.skip();
      });
    };
    $jscomp.inherits(shaka.ui.SkipAdButton, shaka.ui.Element);
    shaka.ui.SkipAdButton.prototype.release = function () {
      this.timer_.stop();
      this.timer_ = null;
      shaka.ui.Element.prototype.release.call(this);
    };
    shaka.ui.SkipAdButton.prototype.updateLocalizedStrings_ = function () {
      this.button_.textContent = this.localization.resolve(shaka.ui.Locales.Ids.SKIP_AD);
    };
    shaka.ui.SkipAdButton.prototype.updateAriaLabel_ = function () {};
    shaka.ui.SkipAdButton.prototype.onAdStarted_ = function () {
      this.ad.isSkippable() &&
        (shaka.ui.Utils.setDisplay(this.button_, !0),
        shaka.ui.Utils.setDisplay(this.counter_, !0),
        (this.counter_.textContent = ''),
        this.timer_.tickNow(),
        this.timer_.tickEvery(0.5));
    };
    shaka.ui.SkipAdButton.prototype.onTimerTick_ = function () {
      goog.asserts.assert(null != this.ad, 'this.ad should exist at this point');
      var a = Math.round(this.ad.getTimeUntilSkippable());
      0 < a ? (this.counter_.textContent = a) : (this.timer_.stop(), shaka.ui.Utils.setDisplay(this.counter_, !1));
    };
    shaka.ui.SkipAdButton.prototype.onSkipStateChanged_ = function () {
      this.ad.canSkipNow() &&
        ((this.button_.disabled = !1), this.timer_.stop(), shaka.ui.Utils.setDisplay(this.counter_, !1));
    };
    shaka.ui.SkipAdButton.prototype.reset_ = function () {
      this.timer_.stop();
      this.button_.disabled = !0;
      shaka.ui.Utils.setDisplay(this.button_, !1);
      shaka.ui.Utils.setDisplay(this.counter_, !1);
    };
    goog.exportSymbol('shaka.ui.SkipAdButton', shaka.ui.SkipAdButton);
    shaka.ui.SmallPlayButton = function (a, b) {
      shaka.ui.PlayButton.call(this, a, b);
      this.button.classList.add('shaka-small-play-button');
      this.button.classList.add('material-icons-round');
      this.updateIcon();
      this.updateAriaLabel();
    };
    $jscomp.inherits(shaka.ui.SmallPlayButton, shaka.ui.PlayButton);
    shaka.ui.SmallPlayButton.prototype.updateIcon = function () {
      var a = shaka.ui.Enums.MaterialDesignIcons;
      this.button.textContent = this.isPaused() ? a.PLAY : a.PAUSE;
    };
    goog.exportSymbol('shaka.ui.SmallPlayButton', shaka.ui.SmallPlayButton);
    shaka.ui.SmallPlayButton.Factory = function () {};
    shaka.ui.SmallPlayButton.Factory.prototype.create = function (a, b) {
      return new shaka.ui.SmallPlayButton(a, b);
    };
    shaka.ui.Controls.registerElement('play_pause', new shaka.ui.SmallPlayButton.Factory());
    shaka.ui.Spacer = function (a, b) {
      shaka.ui.Element.call(this, a, b);
      var c = shaka.util.Dom.createHTMLElement('div');
      c.classList.add('shaka-spacer');
      c.setAttribute('aria-hidden', !0);
      this.parent.appendChild(c);
    };
    $jscomp.inherits(shaka.ui.Spacer, shaka.ui.Element);
    goog.exportSymbol('shaka.ui.Spacer', shaka.ui.Spacer);
    shaka.ui.Spacer.Factory = function () {};
    shaka.ui.Spacer.Factory.prototype.create = function (a, b) {
      return new shaka.ui.Spacer(a, b);
    };
    shaka.ui.Controls.registerElement('spacer', new shaka.ui.Spacer.Factory());
    shaka.ui.TextSelection = function (a, b) {
      shaka.ui.SettingsMenu.call(this, a, b, shaka.ui.Enums.MaterialDesignIcons.CLOSED_CAPTIONS);
      var c = this;
      this.button.classList.add('shaka-caption-button');
      this.menu.classList.add('shaka-text-languages');
      this.player && this.player.isTextTrackVisible()
        ? this.button.setAttribute('aria-pressed', 'true')
        : this.button.setAttribute('aria-pressed', 'false');
      this.addOffOption_();
      this.eventManager.listen(this.localization, shaka.ui.Localization.LOCALE_UPDATED, function () {
        c.updateLocalizedStrings_();
        c.updateTextLanguages_();
      });
      this.eventManager.listen(this.localization, shaka.ui.Localization.LOCALE_CHANGED, function () {
        c.updateLocalizedStrings_();
        c.updateTextLanguages_();
      });
      this.eventManager.listen(this.player, 'texttrackvisibility', function () {
        c.onCaptionStateChange_();
      });
      this.eventManager.listen(this.player, 'textchanged', function () {
        c.updateTextLanguages_();
      });
      this.eventManager.listen(this.player, 'trackschanged', function () {
        c.onTracksChanged_();
      });
      this.onCaptionStateChange_();
      this.updateLocalizedStrings_();
      this.updateTextLanguages_();
      this.onTracksChanged_();
    };
    $jscomp.inherits(shaka.ui.TextSelection, shaka.ui.SettingsMenu);
    shaka.ui.TextSelection.prototype.addOffOption_ = function () {
      var a = shaka.util.Dom.createButton();
      a.setAttribute('aria-selected', 'true');
      this.menu.appendChild(a);
      a.appendChild(shaka.ui.Utils.checkmarkIcon());
      this.captionsOffSpan_ = shaka.util.Dom.createHTMLElement('span');
      this.captionsOffSpan_.classList.add('shaka-auto-span');
      a.appendChild(this.captionsOffSpan_);
    };
    shaka.ui.TextSelection.prototype.onCaptionStateChange_ = function () {
      this.player.isTextTrackVisible()
        ? (this.icon.classList.add('shaka-captions-on'),
          this.icon.classList.remove('shaka-captions-off'),
          this.button.setAttribute('aria-pressed', 'true'))
        : (this.icon.classList.add('shaka-captions-off'),
          this.icon.classList.remove('shaka-captions-on'),
          this.button.setAttribute('aria-pressed', 'false'));
      this.controls.dispatchEvent(new shaka.util.FakeEvent('captionselectionupdated'));
    };
    shaka.ui.TextSelection.prototype.updateTextLanguages_ = function () {
      var a = this,
        b = ((this.cachedProperties || {}).player || {}).getTextTracks || this.player.getTextTracks();
      shaka.ui.LanguageUtils.updateTracks(
        b,
        this.menu,
        function (c) {
          return a.onTextTrackSelected_(c);
        },
        this.player.isTextTrackVisible(),
        this.currentSelection,
        this.localization,
        this.controls.getConfig().trackLabelFormat,
      );
      b = shaka.util.Dom.createButton();
      b.classList.add('shaka-turn-captions-off-button');
      this.eventManager.listen(b, 'click', function () {
        a.player.setTextTrackVisibility(!1);
        a.updateTextLanguages_();
      });
      b.appendChild(this.captionsOffSpan_);
      this.menu.appendChild(b);
      this.player.isTextTrackVisible() ||
        (b.setAttribute('aria-selected', 'true'),
        b.appendChild(shaka.ui.Utils.checkmarkIcon()),
        this.captionsOffSpan_.classList.add('shaka-chosen-item'),
        (this.currentSelection.textContent = this.localization.resolve(shaka.ui.Locales.Ids.OFF)));
      shaka.ui.Utils.focusOnTheChosenItem(this.menu);
      this.controls.dispatchEvent(new shaka.util.FakeEvent('captionselectionupdated'));
    };
    shaka.ui.TextSelection.prototype.onTextTrackSelected_ = function (a) {
      // TODO dispatch event on captions change
      window.dispatchEvent(
        new CustomEvent('captionschanged', {
          detail: a.language,
        }),
      );
      var b = this;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (c) {
        b.player.selectTextLanguage(a.language, a.roles[0]);
        return c.yield(b.player.setTextTrackVisibility(!0), 0);
      });
    };
    shaka.ui.TextSelection.prototype.updateLocalizedStrings_ = function () {
      var a = shaka.ui.Locales.Ids;
      this.button.setAttribute(shaka.ui.Constants.ARIA_LABEL, this.localization.resolve(a.CAPTIONS));
      this.backButton.setAttribute(shaka.ui.Constants.ARIA_LABEL, this.localization.resolve(a.BACK));
      this.nameSpan.textContent = this.localization.resolve(a.CAPTIONS);
      this.backSpan.textContent = this.localization.resolve(a.CAPTIONS);
      this.captionsOffSpan_.textContent = this.localization.resolve(a.OFF);
    };
    shaka.ui.TextSelection.prototype.onTracksChanged_ = function () {
      var a = 0 < this.player.getTextTracks().length;
      shaka.ui.Utils.setDisplay(this.button, a);
      this.updateTextLanguages_();
    };
    goog.exportSymbol('shaka.ui.TextSelection', shaka.ui.TextSelection);
    shaka.ui.TextSelection.Factory = function () {};
    shaka.ui.TextSelection.Factory.prototype.create = function (a, b) {
      return new shaka.ui.TextSelection(a, b);
    };
    shaka.ui.OverflowMenu.registerElement('captions', new shaka.ui.TextSelection.Factory());
    shaka.ui.Overlay = function (a, b, c) {
      this.player_ = a;
      this.config_ = this.defaultConfig_();
      b.dataset.shakaPlayerContainer = '';
      b.ui = this;
      this.isMobile() && b.classList.add('shaka-mobile');
      this.controls_ = new shaka.ui.Controls(a, b, c, this.config_);
      this.configure({});
      c.controls || a.setVideoContainer(b);
      b.ui = this;
      c.ui = this;
    };
    shaka.ui.Overlay.prototype.destroy = function () {
      var a = this;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (b) {
        if (1 == b.nextAddress) return a.controls_ ? b.yield(a.controls_.destroy(), 2) : b.jumpTo(2);
        if (4 != b.nextAddress) return (a.controls_ = null), a.player_ ? b.yield(a.player_.destroy(), 4) : b.jumpTo(4);
        a.player_ = null;
        b.jumpToEnd();
      });
    };
    shaka.ui.Overlay.prototype.isMobile = function () {
      return shaka.util.Platform.isMobile();
    };
    shaka.ui.Overlay.prototype.getConfiguration = function () {
      var a = this.defaultConfig_();
      shaka.util.ConfigUtils.mergeConfigObjects(a, this.config_, this.defaultConfig_(), {}, '');
      return a;
    };
    shaka.ui.Overlay.prototype.configure = function (a, b) {
      goog.asserts.assert('object' == typeof a || 2 == arguments.length, 'String configs should have values!');
      2 == arguments.length && 'string' == typeof a && (a = shaka.util.ConfigUtils.convertToConfigObject(a, b));
      goog.asserts.assert('object' == typeof a, 'Should be an object!');
      shaka.util.ConfigUtils.mergeConfigObjects(this.config_, a, this.defaultConfig_(), {}, '');
      this.config_.castReceiverAppId &&
        !this.config_.overflowMenuButtons.includes('cast') &&
        this.config_.overflowMenuButtons.push('cast');
      goog.asserts.assert(null != this.player_, 'Should have a player!');
      this.controls_.configure(this.config_);
      this.controls_.dispatchEvent(new shaka.util.FakeEvent('uiupdated'));
    };
    shaka.ui.Overlay.prototype.getControls = function () {
      return this.controls_;
    };
    shaka.ui.Overlay.prototype.setEnabled = function (a) {
      this.controls_.setEnabledShakaControls(a);
    };
    shaka.ui.Overlay.prototype.defaultConfig_ = function () {
      var a = {
        controlPanelElements: 'play_pause time_and_duration spacer mute volume fullscreen overflow_menu'.split(' '),
        overflowMenuButtons: 'captions quality language picture_in_picture cast playback_rate'.split(' '),
        addSeekBar: !0,
        addBigPlayButton: !1,
        castReceiverAppId: '',
        clearBufferOnQualityChange: !0,
        showUnbufferedStart: !1,
        seekBarColors: {
          base: 'rgba(255, 255, 255, 0.3)',
          buffered: 'rgba(255, 255, 255, 0.54)',
          played: 'rgb(255, 255, 255)',
          adBreaks: 'rgb(255, 204, 0)',
        },
        volumeBarColors: { base: 'rgba(255, 255, 255, 0.54)', level: 'rgb(255, 255, 255)' },
        trackLabelFormat: shaka.ui.TrackLabelFormat.LANGUAGE,
        fadeDelay: 0,
        doubleClickForFullscreen: !0,
        enableKeyboardPlaybackControls: !0,
        enableFullscreenOnRotation: !0,
      };
      this.isMobile() &&
        ((a.addBigPlayButton = !0),
        (a.controlPanelElements = a.controlPanelElements.filter(function (b) {
          return 'play_pause' != b && 'volume' != b;
        })));
      return a;
    };
    shaka.ui.Overlay.scanPageForShakaElements_ = function () {
      var a, b, c, d, e, f, g, h, k, l, m, n, p, q;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (r) {
        switch (r.nextAddress) {
          case 1:
            shaka.polyfill.installAll();
            if (!shaka.Player.isBrowserSupported())
              return (
                shaka.log.error(
                  'Shaka Player does not support this browser. Please see https://tinyurl.com/y7s4j9tr for the list of supported browsers.',
                ),
                shaka.ui.Overlay.dispatchLoadedEvent_(
                  'shaka-ui-load-failed',
                  shaka.ui.FailReasonCode.NO_BROWSER_SUPPORT,
                ),
                r['return']()
              );
            a = document.querySelectorAll('[data-shaka-player-container]');
            b = document.querySelectorAll('[data-shaka-player]');
            if (!b.length && !a.length) {
              r.jumpTo(2);
              break;
            }
            if (b.length && !a.length) {
              c = $jscomp.makeIterator(b);
              for (d = c.next(); !d.done; d = c.next())
                (e = d.value),
                  e.ui ||
                    (goog.asserts.assert('video' == e.tagName.toLowerCase(), 'Should be a video element!'),
                    (f = document.createElement('div')),
                    (g = e.parentElement),
                    g.replaceChild(f, e),
                    f.appendChild(e),
                    shaka.ui.Overlay.setupUIandAutoLoad_(f, e));
              r.jumpTo(2);
              break;
            }
            h = $jscomp.makeIterator(a);
            k = h.next();
          case 4:
            if (k.done) {
              r.jumpTo(2);
              break;
            }
            l = k.value;
            if (l.ui) {
              r.jumpTo(5);
              break;
            }
            goog.asserts.assert('div' == l.tagName.toLowerCase(), 'Container should be a div!');
            m = null;
            n = $jscomp.makeIterator(b);
            for (d = n.next(); !d.done; d = n.next())
              if (
                ((p = d.value),
                goog.asserts.assert('video' == p.tagName.toLowerCase(), 'Should be a video element!'),
                p.parentElement == l)
              ) {
                m = p;
                break;
              }
            m || ((m = document.createElement('video')), m.setAttribute('playsinline', ''), l.appendChild(m));
            r.setCatchFinallyBlocks(7);
            return r.yield(shaka.ui.Overlay.setupUIandAutoLoad_(l, m), 9);
          case 9:
            r.leaveTryBlock(5);
            break;
          case 7:
            return (
              (q = r.enterCatchBlock()),
              shaka.log.error('Error setting up Shaka Player', q),
              shaka.ui.Overlay.dispatchLoadedEvent_(
                'shaka-ui-load-failed',
                shaka.ui.FailReasonCode.PLAYER_FAILED_TO_LOAD,
              ),
              r['return']()
            );
          case 5:
            k = h.next();
            r.jumpTo(4);
            break;
          case 2:
            shaka.ui.Overlay.dispatchLoadedEvent_('shaka-ui-loaded'), r.jumpToEnd();
        }
      });
    };
    shaka.ui.Overlay.dispatchLoadedEvent_ = function (a, b) {
      var c = document.createEvent('CustomEvent'),
        d = null;
      void 0 != b && (d = { reasonCode: b });
      c.initCustomEvent(a, !1, !1, d);
      document.dispatchEvent(c);
    };
    shaka.ui.Overlay.setupUIandAutoLoad_ = function (a, b) {
      var c, d, e, f, g, h, k, l, m;
      return $jscomp.asyncExecutePromiseGeneratorProgram(function (n) {
        switch (n.nextAddress) {
          case 1:
            c = new shaka.Player(shaka.util.Dom.asHTMLMediaElement(b));
            d = new shaka.ui.Overlay(c, shaka.util.Dom.asHTMLElement(a), shaka.util.Dom.asHTMLMediaElement(b));
            e = '';
            a.dataset && a.dataset.shakaPlayerCastReceiverId
              ? (e = a.dataset.shakaPlayerCastReceiverId)
              : b.dataset && b.dataset.shakaPlayerCastReceiverId && (e = b.dataset.shakaPlayerCastReceiverId);
            e.length && d.configure({ castReceiverAppId: e });
            shaka.util.Dom.asHTMLMediaElement(b).controls && d.getControls().setEnabledNativeControls(!0);
            if ((f = b.getAttribute('src')))
              (g = document.createElement('source')),
                g.setAttribute('src', f),
                b.appendChild(g),
                b.removeAttribute('src');
            h = $jscomp.makeIterator(b.querySelectorAll('source'));
            k = h.next();
          case 2:
            if (k.done) {
              n.jumpTo(0);
              break;
            }
            l = k.value;
            n.setCatchFinallyBlocks(5);
            return n.yield(d.getControls().getPlayer().load(l.getAttribute('src')), 7);
          case 7:
            n.jumpTo(0);
            break;
          case 5:
            (m = n.enterCatchBlock()), shaka.log.error('Error auto-loading asset', m);
          case 3:
            (k = h.next()), n.jumpTo(2);
        }
      });
    };
    goog.exportSymbol('shaka.ui.Overlay', shaka.ui.Overlay);
    goog.exportProperty(shaka.ui.Overlay.prototype, 'setEnabled', shaka.ui.Overlay.prototype.setEnabled);
    goog.exportProperty(shaka.ui.Overlay.prototype, 'getControls', shaka.ui.Overlay.prototype.getControls);
    goog.exportProperty(shaka.ui.Overlay.prototype, 'configure', shaka.ui.Overlay.prototype.configure);
    goog.exportProperty(shaka.ui.Overlay.prototype, 'getConfiguration', shaka.ui.Overlay.prototype.getConfiguration);
    goog.exportProperty(shaka.ui.Overlay.prototype, 'isMobile', shaka.ui.Overlay.prototype.isMobile);
    goog.exportProperty(shaka.ui.Overlay.prototype, 'destroy', shaka.ui.Overlay.prototype.destroy);
    shaka.ui.TrackLabelFormat = { LANGUAGE: 0, ROLE: 1, LANGUAGE_ROLE: 2 };
    goog.exportSymbol('shaka.ui.TrackLabelFormat', shaka.ui.TrackLabelFormat);
    shaka.ui.FailReasonCode = { NO_BROWSER_SUPPORT: 0, PLAYER_FAILED_TO_LOAD: 1 };
    goog.exportSymbol('shaka.ui.FailReasonCode', shaka.ui.FailReasonCode);
    'complete' == document.readyState
      ? (function () {
          return $jscomp.asyncExecutePromiseGeneratorProgram(function (a) {
            if (1 == a.nextAddress) return a.yield(Promise.resolve(), 2);
            shaka.ui.Overlay.scanPageForShakaElements_();
            a.jumpToEnd();
          });
        })()
      : window.addEventListener('load', shaka.ui.Overlay.scanPageForShakaElements_);
    shaka.ui.VolumeBar = function (a, b) {
      shaka.ui.RangeElement.call(this, a, b, ['shaka-volume-bar-container'], ['shaka-volume-bar']);
      var c = this;
      this.config_ = this.controls.getConfig();
      this.eventManager.listen(this.video, 'volumechange', function () {
        return c.onPresentationVolumeChange_();
      });
      this.eventManager.listen(this.adManager, shaka.ads.AdManager.AD_VOLUME_CHANGED, function () {
        return c.onAdVolumeChange_();
      });
      this.eventManager.listen(this.adManager, shaka.ads.AdManager.AD_MUTED, function () {
        return c.onAdVolumeChange_();
      });
      this.eventManager.listen(this.adManager, shaka.ads.AdManager.AD_STOPPED, function () {
        return c.onPresentationVolumeChange_();
      });
      this.eventManager.listen(this.localization, shaka.ui.Localization.LOCALE_UPDATED, function () {
        return c.updateAriaLabel_();
      });
      this.eventManager.listen(this.localization, shaka.ui.Localization.LOCALE_CHANGED, function () {
        return c.updateAriaLabel_();
      });
      this.onPresentationVolumeChange_();
      this.updateAriaLabel_();
    };
    $jscomp.inherits(shaka.ui.VolumeBar, shaka.ui.RangeElement);
    shaka.ui.VolumeBar.prototype.onChange = function () {
      this.ad
        ? this.ad.setVolume(this.getValue())
        : ((this.video.volume = this.getValue()), (this.video.muted = 0 == this.video.volume ? !0 : !1));
    };
    shaka.ui.VolumeBar.prototype.onPresentationVolumeChange_ = function () {
      this.video.muted ? this.setValue(0) : this.setValue(this.video.volume);
      this.updateColors_();
    };
    shaka.ui.VolumeBar.prototype.onAdVolumeChange_ = function () {
      goog.asserts.assert(null != this.ad, 'This.ad should exist at this point!');
      var a = this.ad.getVolume();
      this.setValue(a);
      this.updateColors_();
    };
    shaka.ui.VolumeBar.prototype.updateColors_ = function () {
      var a = this.config_.volumeBarColors,
        b = ['to right'];
      b.push(a.level + 100 * this.getValue() + '%');
      b.push(a.base + 100 * this.getValue() + '%');
      b.push(a.base + '100%');
      this.container.style.background = 'linear-gradient(' + b.join(',') + ')';
    };
    shaka.ui.VolumeBar.prototype.updateAriaLabel_ = function () {
      this.bar.setAttribute(shaka.ui.Constants.ARIA_LABEL, this.localization.resolve(shaka.ui.Locales.Ids.VOLUME));
    };
    goog.exportSymbol('shaka.ui.VolumeBar', shaka.ui.VolumeBar);
    shaka.ui.VolumeBar.Factory = function () {};
    shaka.ui.VolumeBar.Factory.prototype.create = function (a, b) {
      return new shaka.ui.VolumeBar(a, b);
    };
    shaka.ui.Controls.registerElement('volume', new shaka.ui.VolumeBar.Factory());
  }.call(exportTo, innerGlobal, innerGlobal, undefined));
  if (typeof exports != 'undefined') for (var k in exportTo.shaka) exports[k] = exportTo.shaka[k];
  else if (typeof define == 'function' && define.amd)
    define(function () {
      return exportTo.shaka;
    });
  else innerGlobal.shaka = exportTo.shaka;
})();
